import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JWT: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  NonNegativeInt: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  URL: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  /** Flex deferred customer IDs configured for each country on this account. */
  accountCountryFlexMappings: Array<AccountCountryFlexMapping>;
  /**
   * List of approved suppliers to a specific account.
   * This will determine how those suppliers are displayed in the marketplace when that account views it.
   */
  approvedSuppliers: Maybe<Array<ApprovedSupplier>>;
  /** When the account was archived (null when not archived) */
  archivedAt: Maybe<Scalars['DateTime']['output']>;
  /** The admin who archived the account */
  archivedBy: Maybe<Admin>;
  /** ID of the admin who archived the account */
  archivedByAdminId: Maybe<Scalars['Int']['output']>;
  /** Whether the accounts menus will publish automatically */
  autoSendMenu: Scalars['Boolean']['output'];
  /** Whether the account is permitted to use the autopilot feature */
  autopilotEnabled: Scalars['Boolean']['output'];
  ccMealVendors: Array<CcMealVendor>;
  ccOrders: CcAccountOrdersPaged;
  /** CC subsidies for the account */
  ccSubsidies: Maybe<Array<Maybe<CcSubsidy>>>;
  /** CC teams associated with the account */
  ccTeams: Maybe<Array<Maybe<CcTeam>>>;
  ccUserOrders: CcUserOrdersPaged;
  /** Account code */
  code: Maybe<Scalars['String']['output']>;
  /** Account currency */
  currency: Currency;
  /**
   * Customer orders report for this account.
   * The account id is taken from this Account; filters control the report scope.
   */
  customerOrdersReport: CustomerOrdersReport;
  /**
   * Fast summary of customer orders for this account, for charts and analytics.
   * The account id is taken from this Account; filters control the summary scope.
   */
  customerOrdersSummary: CustomerOrdersSummary;
  /**
   * The default customer id for instant invoicing since payinging by card doesn't select and invoice account
   * @deprecated Use accountCountryFlexMappings.flexDeferredCustomerId for the relevant country.
   */
  defaultFlexDeferredCustomerId: Maybe<Scalars['String']['output']>;
  /** List of domains associated to the account */
  domains: Array<Scalars['String']['output']>;
  /** External id linked to the account */
  externalId: Maybe<Scalars['String']['output']>;
  /** Finance settings for account */
  financeSettings: AccountFinanceSettings;
  /** All flex invoice accounts associated with this account */
  flexInvoiceAccounts: Array<FlexInvoiceAccount>;
  gmBaskets: GmBasketPaged;
  /** Is the account classified as high risk? i.e. are they a fussy client */
  highRisk: Scalars['Boolean']['output'];
  /** The unique identifier of the account */
  id: Scalars['ID']['output'];
  /** All invoice accounts associated with this account */
  invoiceAccounts: Array<InvoiceAccount>;
  /** Is the account invoice approved */
  invoiceApproved: Maybe<Scalars['Boolean']['output']>;
  /** Whether the account is active for Cloud Canteen */
  isCCActive: Scalars['Boolean']['output'];
  /** Whether the account is active for Catering */
  isGMActive: Scalars['Boolean']['output'];
  /**
   * All account locations associated with this account
   * @deprecated Use `locationsPaged`.
   */
  locations: Maybe<Array<Maybe<AccountLocation>>>;
  locationsPaged: AccountLocationsPaged;
  /** Account manager */
  manager: Maybe<Admin>;
  /** Account manager id */
  managerId: Maybe<Scalars['String']['output']>;
  /** The name of the Feedr team member who is account manager for this account */
  managerName: Maybe<Scalars['String']['output']>;
  /** The name of the account */
  name: Scalars['String']['output'];
  /** Something about napkins and cutlery? Perhaps we include it with deliveries */
  napkinsCutlery: Scalars['Boolean']['output'];
  /** Additional notes about this account */
  notes: Scalars['String']['output'];
  /** Onboarding link for account */
  onboardingLink: Scalars['String']['output'];
  /** CC onboarding status of an account */
  onboardingStatus: Maybe<Scalars['String']['output']>;
  /** Primary contacts for account */
  primaryContacts: UsersPaged;
  quoteCollections: QuoteCollectionPaged;
  /** Sign up code for the account */
  signUpCode: Maybe<Scalars['String']['output']>;
  /** The account's SSO settings */
  ssoConfig: Maybe<AccountSsoConfig>;
  /** Is the account SSO enabled */
  ssoEnabled: Scalars['Boolean']['output'];
  /** The id of the tenant the account belongs to ie. Feedr or Eat First */
  tenantId: Scalars['String']['output'];
  /** Whether or not the account is permitted to top-up their Cloud-Canteen credits */
  topUpEnabled: Scalars['Boolean']['output'];
  /** User interface settings */
  userInterfaceSettings: AccountUserInterfaceSettings;
  /** All users associated with this account */
  users: UsersPaged;
};


export type AccountCcMealVendorsArgs = {
  input: CcMealVendorsQueryInput;
};


export type AccountCcOrdersArgs = {
  input: CcAccountOrdersQueryInput;
};


export type AccountCcUserOrdersArgs = {
  input: CcAccountOrderQueryInput;
};


export type AccountCustomerOrdersReportArgs = {
  input: CustomerOrdersReportForAccountInput;
};


export type AccountCustomerOrdersSummaryArgs = {
  input: CustomerOrdersReportForAccountInput;
};


export type AccountGmBasketsArgs = {
  filters?: InputMaybe<GmBasketFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountLocationsArgs = {
  filters: InputMaybe<AccountLocationFilters>;
  ids: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountLocationsPagedArgs = {
  filters: InputMaybe<AccountLocationFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountPrimaryContactsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountQuoteCollectionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountUsersArgs = {
  input: InputMaybe<UserSearch>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountCountryFlexMapping = {
  __typename?: 'AccountCountryFlexMapping';
  accountId: Scalars['Int']['output'];
  country: Scalars['String']['output'];
  flexDeferredCustomerId: Scalars['String']['output'];
};

export type AccountFilters = {
  isCCActive?: InputMaybe<Scalars['Boolean']['input']>;
  isGMActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountFinanceSettings = {
  __typename?: 'AccountFinanceSettings';
  accountId: Scalars['Int']['output'];
  additionalBillingNotes: Maybe<Scalars['String']['output']>;
  allowMinTopUpCc: Scalars['Boolean']['output'];
  budgetCodeCc: Maybe<Scalars['String']['output']>;
  budgetCodeGm: Maybe<Scalars['String']['output']>;
  chargeCreditCardFee: Maybe<Scalars['Boolean']['output']>;
  contractDateFrom: Maybe<Scalars['DateTime']['output']>;
  contractDateTo: Maybe<Scalars['DateTime']['output']>;
  deliverySurchargeCc: Maybe<Scalars['Int']['output']>;
  deliverySurchargeCcExTax: Maybe<Scalars['Int']['output']>;
  enterpriseCostPlusPricing: Scalars['Boolean']['output'];
  feeAndDiscountNotesGm: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoicingFormatGm: GmInvoicingFormat;
  isBudgetCodeMandatory: Maybe<Scalars['Boolean']['output']>;
  minMonthlyCateringSpendExTax: Scalars['Int']['output'];
  minOrderValueCc: Maybe<Scalars['Int']['output']>;
  minOrderValueCcExTax: Maybe<Scalars['Int']['output']>;
  minPlatformFeeCc: Maybe<Scalars['Int']['output']>;
  minPlatformFeeCcExTax: Maybe<Scalars['Int']['output']>;
  minPlatformFeeCcMonthlyExTax: Scalars['Int']['output'];
  minPlatformFeeGm: Maybe<Scalars['Int']['output']>;
  orderValPercentEnterpriseDiscountGm: Maybe<Scalars['Float']['output']>;
  orderValPercentPlatformFeeCc: Maybe<Scalars['Float']['output']>;
  orderValPercentPlatformFeeGm: Maybe<Scalars['Float']['output']>;
  paymentDueDaysAfterInvoice: Maybe<Scalars['Int']['output']>;
};

export type AccountIdentityProviderAttributeMapping = {
  __typename?: 'AccountIdentityProviderAttributeMapping';
  samlAttribute: Scalars['String']['output'];
  userPoolAttribute: Scalars['String']['output'];
};

export type AccountIdentityProviderAttributeMappingInput = {
  samlAttribute: Scalars['String']['input'];
  userPoolAttribute: Scalars['String']['input'];
};

export type AccountLocation = {
  __typename?: 'AccountLocation';
  /** Account the location belongs to */
  account: Account;
  /** Reference fields */
  accountLocationReferenceFieldValues: Array<AccountLocationReferenceFieldValue>;
  /** The address details of the location */
  address: Address;
  /** When the account location was archived (null when not archived) */
  archivedAt: Maybe<Scalars['DateTime']['output']>;
  /** The admin who archived the account location */
  archivedBy: Maybe<Admin>;
  /** ID of the admin who archived the account location */
  archivedByAdminId: Maybe<Scalars['Int']['output']>;
  /** Account location assets e.g. ccLaunchPdf */
  assets: Maybe<Array<Maybe<AccountLocationAsset>>>;
  /** CC CutOff minutes for breakfast service */
  breakfastClose: Maybe<Scalars['Int']['output']>;
  /** The budget for the account location */
  budget: Scalars['Float']['output'];
  /** CC availabilites for the account location */
  ccAvailabilities: CcAvailabilitiesPaged;
  /** CC Cluster the account location belongs to */
  ccCluster: Maybe<CcCluster>;
  /** All configured delivery timeslots for the given meal and date, regardless of whether orders exist */
  ccMealTimeslots: Array<CcMealTimeslot>;
  /** CC menu for the account location */
  ccMenu: Maybe<CcMenuQueryResult>;
  ccOrderItems: CcOrderItemsPaged;
  /** Sent at timestamp for the cc service launch email */
  ccServiceLaunchSentAt: Maybe<Scalars['DateTime']['output']>;
  /** CC service settings */
  ccServiceSettings: AccountLocationCanteenServieSettings;
  /** CC subsidies for the account location */
  ccSubsidies: Maybe<Array<Maybe<CcSubsidy>>>;
  /** Cluster ID - to be deprecated in new logic */
  clusterId: Maybe<Scalars['Int']['output']>;
  /** Contact preferences */
  contactPreferences: AccountLocationContactPreferences;
  /** The date and time the account location was created in UTC time */
  createdAt: Scalars['String']['output'];
  /** The date and time the account location was deleted at in UTC time */
  deletedAt: Maybe<Scalars['String']['output']>;
  /** Delivery preferences */
  deliveryPreferences: AccountLocationDeliveryPreferences;
  /** CC CutOff minutes for dinner service */
  dinnerClose: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the account location */
  id: Scalars['ID']['output'];
  /** The delivery instructions for the account location */
  instructions: Maybe<Scalars['String']['output']>;
  /** Whether the account location is used as a billing address */
  isBillingAddress: Maybe<Scalars['Boolean']['output']>;
  /** Whether the account is active for Cloud Canteen */
  isCCActive: Scalars['Boolean']['output'];
  /** Whether the account location is active for Group Meals */
  isGmActive: Scalars['Boolean']['output'];
  /** The label for the account location */
  label: Maybe<Scalars['String']['output']>;
  /** The latitude of the location */
  lat: Maybe<Scalars['Float']['output']>;
  /** The longitude of the location */
  lng: Maybe<Scalars['Float']['output']>;
  /** CC CutOff minutes for lunch service */
  lunchClose: Maybe<Scalars['Int']['output']>;
  /** The menu coverage tolerance for the account location */
  menuCoverageTolerance: Scalars['Float']['output'];
  /** Whether menu automation is opted out for this location */
  optOutMenuAutomation: Scalars['Boolean']['output'];
  /** Phone number */
  phone: Maybe<Scalars['String']['output']>;
  /** Timezone for an account location */
  timezone: Scalars['String']['output'];
  /** The date and time the account location was last updated in UTC time */
  updatedAt: Scalars['String']['output'];
  /** Vendor preferences for the account location ie. blacklisted/preferred vendors */
  vendorPreferences: Array<VendorPreference>;
  /** What 3 words */
  what3words: Maybe<Scalars['String']['output']>;
};


export type AccountLocationAccountLocationReferenceFieldValuesArgs = {
  input: InputMaybe<AccountLocationReferenceFieldValueInput>;
};


export type AccountLocationCcAvailabilitiesArgs = {
  input: InputMaybe<CcAvailabilityQueryInput>;
};


export type AccountLocationCcMealTimeslotsArgs = {
  input: CcMealTimeslotsQueryInput;
};


export type AccountLocationCcMenuArgs = {
  input: CcMenuQueryInput;
};


export type AccountLocationCcOrderItemsArgs = {
  input: CcOrderItemQueryInput;
};

/** Address */
export type AccountLocationAddressInput = {
  /** City or town */
  city: Scalars['String']['input'];
  /** Country code */
  country: Scalars['String']['input'];
  /** Latitude */
  lat?: InputMaybe<Scalars['Float']['input']>;
  /** Address line 1 */
  line1: Scalars['String']['input'];
  /** Address line 2 */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** Longitude */
  lng?: InputMaybe<Scalars['Float']['input']>;
  /** Postal code */
  postcode: Scalars['String']['input'];
  /** What3Words address */
  what3words?: InputMaybe<Scalars['String']['input']>;
};

export type AccountLocationAsset = {
  __typename?: 'AccountLocationAsset';
  generatedAt: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AccountLocationCanteenServieSettings = {
  __typename?: 'AccountLocationCanteenServieSettings';
  breakfastSingleVendorOrder: Scalars['Boolean']['output'];
  dinnerSingleVendorOrder: Scalars['Boolean']['output'];
  lunchSingleVendorOrder: Scalars['Boolean']['output'];
};

export type AccountLocationContactPreferences = {
  __typename?: 'AccountLocationContactPreferences';
  /** Should new users added to this account location be opted into daily reminders by default */
  dailyReminderDefaultOptIn: Scalars['Boolean']['output'];
};

/** Contact preferences */
export type AccountLocationContactPreferencesInput = {
  /** Should new users added to this account location be opted into daily reminders by default */
  dailyReminderDefaultOptIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountLocationDeliveryPreferences = {
  __typename?: 'AccountLocationDeliveryPreferences';
  /** Delivery instructions for the courier */
  deliveryInstructions: Maybe<Scalars['String']['output']>;
  /** Packing instructions for the vendor */
  packingInstructions: Maybe<Scalars['String']['output']>;
  /** Preferred courier */
  preferredCourier: Maybe<Scalars['String']['output']>;
};

/** Delivery preferences */
export type AccountLocationDeliveryPreferencesInput = {
  /** Delivery instructions for the courier */
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Packing instructions for the vendor */
  packingInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Preferred courier */
  preferredCourier?: InputMaybe<Scalars['String']['input']>;
};

export type AccountLocationFilters = {
  /**
   * Include locations archived by an account-archive cascade, alongside live ones.
   * Locations deleted outside a cascade are never returned.
   */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isCCActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AccountLocationInput = {
  id: Scalars['Int']['input'];
};

export type AccountLocationReferenceFieldValue = {
  __typename?: 'AccountLocationReferenceFieldValue';
  accountLocationReferenceFieldId: Scalars['Int']['output'];
  description: Maybe<Scalars['String']['output']>;
  fieldType: ReferenceFieldType;
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Array<AccountLocationReferenceFieldValueOption>;
  orderReferenceFieldId: Scalars['Int']['output'];
  value: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type AccountLocationReferenceFieldValueFilterInput = {
  orderReferenceFieldId: Scalars['Int']['input'];
};

export type AccountLocationReferenceFieldValueInput = {
  filter?: InputMaybe<Array<AccountLocationReferenceFieldValueFilterInput>>;
};

export type AccountLocationReferenceFieldValueOption = {
  __typename?: 'AccountLocationReferenceFieldValueOption';
  accountLocationReferenceFieldId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  option: Scalars['String']['output'];
  orderPriority: Scalars['Int']['output'];
};

export type AccountLocationsPaged = {
  __typename?: 'AccountLocationsPaged';
  pageInfo: PageInfo;
  rows: Array<AccountLocation>;
};

export enum AccountOrderByProperties {
  Id = 'id',
  Name = 'name',
  OnboardingStatus = 'onboardingStatus',
  SignUpCode = 'signUpCode'
}

export enum AccountOrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type AccountPrimaryContactInput = {
  userId: Scalars['Int']['input'];
};

export type AccountPrivateSuppliers = {
  __typename?: 'AccountPrivateSuppliers';
  suppliers: Maybe<Array<PrivateSupplier>>;
};

export type AccountSearch = {
  /** Caterdesk Admin request override TenantId */
  adminOverrideTenantId?: InputMaybe<Scalars['String']['input']>;
  /** Accounts by country location */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Account ordering results by */
  filters?: InputMaybe<AccountFilters>;
  /** Amount of results to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the account to search for */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Amount of results to skip */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Account ordering results by */
  orderBy?: InputMaybe<AccountsOrderByInput>;
  /** Filter by account status. Defaults to active accounts only. */
  status?: InputMaybe<AccountStatusFilter>;
};

export type AccountSsoConfig = {
  __typename?: 'AccountSsoConfig';
  attributeMapping: Array<AccountIdentityProviderAttributeMapping>;
};

/** Filter accounts by lifecycle status */
export enum AccountStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Archived = 'ARCHIVED'
}

export type AccountUserInterfaceSettings = {
  __typename?: 'AccountUserInterfaceSettings';
  accountId: Scalars['Int']['output'];
  hideCCPrices: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type AccountsOrderByInput = {
  direction?: InputMaybe<AccountOrderDirection>;
  property?: InputMaybe<AccountOrderByProperties>;
};

export type AccountsPaged = {
  __typename?: 'AccountsPaged';
  pageInfo: PageInfo;
  rows: Array<Account>;
};

export type AddInvoicePaymentInput = {
  amount: Scalars['Float']['input'];
};

export type AddTenantContactRegionInput = {
  region: UpdateTenantContactRegionInput;
  tenantId: Scalars['ID']['input'];
};

export type Address = {
  __typename?: 'Address';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  flatOrBuilding: Maybe<Scalars['String']['output']>;
  floorOrBuildingName: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  postcode: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  timezoneId: Maybe<Scalars['String']['output']>;
};

export type AddressComponent = {
  __typename?: 'AddressComponent';
  long_name: Scalars['String']['output'];
  short_name: Scalars['String']['output'];
  types: Maybe<Array<Scalars['String']['output']>>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  flatOrBuilding?: InputMaybe<Scalars['String']['input']>;
  floorOrBuildingName?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  timezoneId?: InputMaybe<Scalars['String']['input']>;
};

export type AddressLocation = {
  __typename?: 'AddressLocation';
  address: Address;
  context: GeocodeContext;
  id: Scalars['ID']['output'];
  relevance: Scalars['Float']['output'];
};

export type Admin = {
  __typename?: 'Admin';
  /** The country flags the admin has access to */
  countryFlags: Array<Scalars['String']['output']>;
  /** The admins email address */
  email: Scalars['String']['output'];
  /** The legacy feedr user ID, used for linking to feedr-client pages */
  feedrUserId: Maybe<Scalars['Int']['output']>;
  /** The admins first name */
  firstName: Scalars['String']['output'];
  /** The admins full name */
  fullName: Scalars['String']['output'];
  /** The unique identifier of the admin */
  id: Scalars['ID']['output'];
  /** Admin language settings such as selected locale  */
  languageSettings: AdminLanguageSettings;
  /** The admins last name */
  lastName: Scalars['String']['output'];
  /** The admins phone number */
  phone: Maybe<Scalars['String']['output']>;
  /** The roles assigned to the admin */
  roles: Array<Scalars['String']['output']>;
  /** The tenant associated to the admin */
  tenant: Tenant;
};

export type AdminDecreaseUserCreditsInput = {
  /** Amount to remove (positive number) */
  amount: Scalars['Float']['input'];
  /** Optional description (auto-generated if not provided) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The user ID to remove credits from */
  userId: Scalars['ID']['input'];
};

export type AdminIncreaseUserCreditsInput = {
  /** Amount to add (positive number) */
  amount: Scalars['Float']['input'];
  /** Optional description (auto-generated if not provided) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The user ID to add credits to */
  userId: Scalars['ID']['input'];
};

export type AdminLanguageSettings = {
  __typename?: 'AdminLanguageSettings';
  locale: Scalars['String']['output'];
};

export type AdminSearch = {
  /** adminIds to filter by */
  adminIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Include deleted admins */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Admin searching by name or email */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdminsPaged = {
  __typename?: 'AdminsPaged';
  pageInfo: PageInfo;
  rows: Array<Admin>;
};

export type AggregateByPeriod = {
  __typename?: 'AggregateByPeriod';
  amount: Scalars['Float']['output'];
  date: Scalars['String']['output'];
};

export type Alert = {
  __typename?: 'Alert';
  destinations: AlertDestinations;
  eventName: Scalars['String']['output'];
  filters: Array<AlertFilter>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AlertDestinations = {
  __typename?: 'AlertDestinations';
  email: AlertEmailDestination;
  slack: AlertSlackDestination;
};

export type AlertDestinationsInput = {
  email: AlertEmailDestinationInput;
  slack: AlertSlackDestinationInput;
};

export type AlertEmailDestination = {
  __typename?: 'AlertEmailDestination';
  addresses: Array<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
};

export type AlertEmailDestinationInput = {
  addresses: Array<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
};

export type AlertFilter = AlertFilterBoolean | AlertFilterNumber | AlertFilterString;

export type AlertFilterBase = {
  field: Scalars['String']['output'];
};

export type AlertFilterBoolean = AlertFilterBase & {
  __typename?: 'AlertFilterBoolean';
  field: Scalars['String']['output'];
  type: AlertFilterFieldType;
  value: Scalars['Boolean']['output'];
};

export enum AlertFilterFieldType {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  String = 'STRING'
}

export type AlertFilterInput = {
  condition?: InputMaybe<AlertFilterNumberCondition>;
  field: Scalars['String']['input'];
  type: AlertFilterFieldType;
  value?: InputMaybe<Scalars['String']['input']>;
  valueInt?: InputMaybe<Scalars['Int']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AlertFilterNumber = AlertFilterBase & {
  __typename?: 'AlertFilterNumber';
  condition: AlertFilterNumberCondition;
  field: Scalars['String']['output'];
  type: AlertFilterFieldType;
  valueInt: Scalars['Int']['output'];
};

export enum AlertFilterNumberCondition {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN'
}

export type AlertFilterString = AlertFilterBase & {
  __typename?: 'AlertFilterString';
  field: Scalars['String']['output'];
  type: AlertFilterFieldType;
  values: Array<Scalars['String']['output']>;
};

export enum AlertSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  None = 'NONE',
  Warn = 'WARN'
}

export type AlertSlackDestination = {
  __typename?: 'AlertSlackDestination';
  channels: Array<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
};

export type AlertSlackDestinationInput = {
  channels: Array<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
};

export type AlertTenantConfig = {
  __typename?: 'AlertTenantConfig';
  slackEnabled: Scalars['Boolean']['output'];
};

export type AlertType = {
  __typename?: 'AlertType';
  description: Scalars['String']['output'];
  eventName: Scalars['ID']['output'];
  filters: Array<AlertTypeFilter>;
  name: Scalars['String']['output'];
};

export type AlertTypeFilter = AlertTypeFilterAccount | AlertTypeFilterBoolean | AlertTypeFilterCountry | AlertTypeFilterDropdown | AlertTypeFilterNumber | AlertTypeFilterString | AlertTypeFilterSupplier;

export type AlertTypeFilterAccount = AlertTypeFilterBase & {
  __typename?: 'AlertTypeFilterAccount';
  field: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: AlertTypeFilterFieldType;
};

export type AlertTypeFilterBase = {
  field: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AlertTypeFilterBoolean = AlertTypeFilterBase & {
  __typename?: 'AlertTypeFilterBoolean';
  field: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: AlertTypeFilterFieldType;
};

export type AlertTypeFilterCountry = AlertTypeFilterBase & {
  __typename?: 'AlertTypeFilterCountry';
  field: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: AlertTypeFilterFieldType;
};

export type AlertTypeFilterDropdown = AlertTypeFilterBase & {
  __typename?: 'AlertTypeFilterDropdown';
  field: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
  type: AlertTypeFilterFieldType;
};

export enum AlertTypeFilterFieldType {
  Account = 'ACCOUNT',
  Boolean = 'BOOLEAN',
  Country = 'COUNTRY',
  Dropdown = 'DROPDOWN',
  Number = 'NUMBER',
  String = 'STRING',
  Supplier = 'SUPPLIER'
}

export type AlertTypeFilterNumber = AlertTypeFilterBase & {
  __typename?: 'AlertTypeFilterNumber';
  condition: Array<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: AlertTypeFilterFieldType;
};

export type AlertTypeFilterString = AlertTypeFilterBase & {
  __typename?: 'AlertTypeFilterString';
  field: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: AlertTypeFilterFieldType;
};

export type AlertTypeFilterSupplier = AlertTypeFilterBase & {
  __typename?: 'AlertTypeFilterSupplier';
  field: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: AlertTypeFilterFieldType;
};

export type AlertsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertsPaged = {
  __typename?: 'AlertsPaged';
  pageInfo: PageInfo;
  rows: Array<Alert>;
};

export type AllOrdersOrderByInput = {
  contact?: InputMaybe<Sort>;
  deliveryAddress?: InputMaybe<Sort>;
  deliveryDate?: InputMaybe<Sort>;
  orderNumber?: InputMaybe<Sort>;
  subTotal?: InputMaybe<Sort>;
  supplierName?: InputMaybe<Sort>;
  total?: InputMaybe<Sort>;
};

export type AllOrdersWithPagingInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AllOrdersOrderByInput>;
};

export enum Allergen {
  Celery = 'celery',
  Cereals = 'cereals',
  Crustaceans = 'crustaceans',
  Eggs = 'eggs',
  Fish = 'fish',
  Lupin = 'lupin',
  Milk = 'milk',
  Molluscs = 'molluscs',
  Mustard = 'mustard',
  None = 'none',
  Nuts = 'nuts',
  Peanuts = 'peanuts',
  Sesame = 'sesame',
  Soybeans = 'soybeans',
  Sulphur = 'sulphur'
}

export type AllergenAudit = {
  __typename?: 'AllergenAudit';
  action: Scalars['String']['output'];
  actor: Scalars['String']['output'];
  actorName: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
};

export enum AllergenAuditKind {
  /** An admin published a vendor's unchanged allergen data. */
  Approval = 'APPROVAL',
  /** The actor attested to the allergen data as recorded on the event. */
  Attestation = 'ATTESTATION'
}

export enum AllergenAuditStatus {
  /** The attested allergen data is the item's draft, waiting for internal admin approval. */
  Draft = 'DRAFT',
  /** The attested allergen data is what is live now. */
  Published = 'PUBLISHED',
  /** The attested allergen data was changed again before it went live. */
  Superseded = 'SUPERSEDED'
}

/** Allergen acceptances for the item editor and vendor portal banners. */
export type AllergenAuditSummary = {
  __typename?: 'AllergenAuditSummary';
  /** @deprecated Use rows. */
  latestAdmin: Maybe<AllergenAuditSummaryRow>;
  /** @deprecated Use rows. */
  latestVendor: Maybe<AllergenAuditSummaryRow>;
  /** Acceptances that describe the live and draft allergen data, oldest first. */
  rows: Array<AllergenAuditSummaryRow>;
};

export type AllergenAuditSummaryRow = {
  __typename?: 'AllergenAuditSummaryRow';
  actor: Scalars['String']['output'];
  actorName: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  kind: AllergenAuditKind;
  status: AllergenAuditStatus;
  /**
   * A newer admin acceptance attested a different allergen set.
   * @deprecated Use status.
   */
  superseded: Scalars['Boolean']['output'];
};

/** Count of active menu items carrying a given allergen. */
export type AllergenStat = {
  __typename?: 'AllergenStat';
  /**
   * The canonical Allergen GraphQL key (e.g. "Cereals", "Nuts", "Sulphur"),
   * matching the Allergen enum used across the platform. Clients map this to a
   * display label via the shared allergen label source.
   */
  allergen: Allergen;
  count: Scalars['Int']['output'];
};

export enum AppArea {
  Admin = 'admin',
  Ca = 'ca',
  User = 'user',
  Vendor = 'vendor'
}

/** Result of refreshing a supplier order's reference fields from its invoice account. */
export type ApplyNewReferenceFieldsToCcSupplierOrderResult = {
  __typename?: 'ApplyNewReferenceFieldsToCCSupplierOrderResult';
  /** Account locations on the order that bill to the invoice account used. */
  accountLocationIds: Array<Scalars['Int']['output']>;
  ccSupplierOrder: CcSupplierOrder;
  invoiceAccountId: Scalars['Int']['output'];
  invoiceAccountLabel: Maybe<Scalars['String']['output']>;
};

export type ApprovedSupplier = {
  __typename?: 'ApprovedSupplier';
  supplierId: Scalars['Int']['output'];
  supplierName: Maybe<Scalars['String']['output']>;
};

/**
 * Result of archiveAccount: account is set on success; blockers is non-empty
 * when archiving was refused by dependency validation; warnings is non-empty
 * when archiving paused for confirmation (account null, blockers empty)
 */
export type ArchiveAccountPayload = {
  __typename?: 'ArchiveAccountPayload';
  account: Maybe<Account>;
  blockers: Array<ArchiveBlocker>;
  warnings: Array<ArchiveWarning>;
};

/** A dependency preventing an account from being archived */
export type ArchiveBlocker = {
  __typename?: 'ArchiveBlocker';
  code: ArchiveBlockerCode;
  count: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
};

/** Why an account cannot be archived right now */
export enum ArchiveBlockerCode {
  ActiveStandingOrderTemplates = 'ACTIVE_STANDING_ORDER_TEMPLATES',
  FutureOrders = 'FUTURE_ORDERS',
  UninvoicedOrders = 'UNINVOICED_ORDERS'
}

/** Something worth confirming before archiving; the archive proceeds once acknowledged */
export type ArchiveWarning = {
  __typename?: 'ArchiveWarning';
  code: ArchiveWarningCode;
  count: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
};

/**
 * Something worth confirming before an account is archived. Unlike a blocker it
 * does not refuse the archive: archiveAccount returns warnings once with account
 * null, and proceeds when called again with acknowledgeWarnings: true.
 */
export enum ArchiveWarningCode {
  UserCreditBalances = 'USER_CREDIT_BALANCES'
}

export type Asset = {
  __typename?: 'Asset';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AssetSearchInput = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AssignApprovedSuppliersInput = {
  approvedSupplierIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AssignBasketToGuestInput = {
  assignToAccount?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};

export type AssignUsersToTeamResult = {
  __typename?: 'AssignUsersToTeamResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AvailabilitiesAccount = {
  __typename?: 'AvailabilitiesAccount';
  data: Account;
  id: Scalars['Int']['output'];
  manager: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type AvailabilitiesAccountInput = {
  id: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type AvailabilitiesVendor = {
  __typename?: 'AvailabilitiesVendor';
  contact: Maybe<VendorContact>;
  contactId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  location: Maybe<VendorLocation>;
  locationId: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  url: Maybe<Scalars['String']['output']>;
};

export type AvailabilitiesVendorInput = {
  contactId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum AvailabilityServiceType {
  Cc = 'CC',
  Gm = 'GM'
}

export type BankAccountData = {
  __typename?: 'BankAccountData';
  accountName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  accountType: Maybe<Scalars['String']['output']>;
  bankAddress: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  bic: Maybe<Scalars['String']['output']>;
  bsb: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  iban: Maybe<Scalars['String']['output']>;
  sortCode: Maybe<Scalars['String']['output']>;
};

export type BankAccountDataInput = {
  accountName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  accountType?: InputMaybe<Scalars['String']['input']>;
  bankAddress: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  bic?: InputMaybe<Scalars['String']['input']>;
  bsb?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
};

export type BasketFeeBreakdown = {
  __typename?: 'BasketFeeBreakdown';
  taxRate: Scalars['Float']['output'];
  taxValue: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalExTax: Scalars['Int']['output'];
};

export type BasketItem = {
  __typename?: 'BasketItem';
  acknowledgedAt: Maybe<Scalars['DateTime']['output']>;
  addedByName: Maybe<Scalars['String']['output']>;
  addedByUserId: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  item: Maybe<MenuItem>;
  itemReference: Scalars['String']['output'];
  note: Maybe<Scalars['String']['output']>;
  options: Array<BasketItemOption>;
  qty: Scalars['Int']['output'];
};

export type BasketItemInput = {
  acknowledgedAt?: InputMaybe<Scalars['DateTime']['input']>;
  item: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  options: Array<BasketItemOptionInput>;
  qty: Scalars['Int']['input'];
};

export type BasketItemOption = {
  __typename?: 'BasketItemOption';
  category: Maybe<MenuItemOptions>;
  item: Maybe<MenuItem>;
  optionItem: Maybe<OptionItem>;
  qty: Scalars['Int']['output'];
};

export type BasketItemOptionInput = {
  categoryId: Scalars['ID']['input'];
  item: Scalars['ID']['input'];
  optionItemId: Scalars['ID']['input'];
  qty: Scalars['Int']['input'];
};

export enum BasketSource {
  Emma = 'emma',
  Ia = 'ia',
  Marketplace = 'marketplace'
}

export enum BasketStatus {
  Ordered = 'ordered',
  Saved = 'saved'
}

export type BasketSubtotalBreakdown = {
  __typename?: 'BasketSubtotalBreakdown';
  subtotal: Scalars['Int']['output'];
  subtotalExTax: Scalars['Int']['output'];
  taxRateTotalBreakdown: Array<BasketTaxRateTotal>;
  taxValue: Scalars['Int']['output'];
};

export type BasketTaxRateTotal = {
  __typename?: 'BasketTaxRateTotal';
  itemValue: Scalars['Int']['output'];
  rate: Scalars['Float']['output'];
  taxValue: Scalars['Int']['output'];
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  alias: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
};

export type BillingAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
};

export type BillingContact = {
  __typename?: 'BillingContact';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  tenantId: Maybe<Scalars['String']['output']>;
};

export type BillingContactInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type BillingDetails = {
  __typename?: 'BillingDetails';
  address: BillingAddress;
  contact: BillingContact;
  vatNumber: Maybe<Scalars['String']['output']>;
};

export type BillingDetailsInput = {
  address: BillingAddressInput;
  contact: BillingContactInput;
};

export type BillingEntitiesInput = {
  filters?: InputMaybe<BillingEntityFiltersInput>;
};

export type BillingEntity = {
  __typename?: 'BillingEntity';
  address: Scalars['String']['output'];
  bankAccountData: Maybe<Array<BankAccountData>>;
  businessNumber: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  companyNumber: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
  taxNumber: Maybe<Scalars['String']['output']>;
  tenantId: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
  vatRegion: VatRegion;
  vatRegionId: Scalars['ID']['output'];
};

export type BillingEntityFiltersInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export enum BillingField {
  AccountName = 'accountName',
  AccountNumber = 'accountNumber',
  BankCode = 'bankCode',
  BankName = 'bankName',
  BranchCode = 'branchCode',
  BsbNumber = 'bsbNumber',
  SortCode = 'sortCode'
}

export type BillingFieldsInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};

export type BlockedMenuItemDeletion = {
  __typename?: 'BlockedMenuItemDeletion';
  id: Scalars['ID']['output'];
  linkedItemNames: Array<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /** One of: IS_OPTION_FOR, OPTIONS_IN_DRAFT, or a raw error message. */
  reason: Scalars['String']['output'];
};

export type BulkCreateStandingOrdersInput = {
  fromDate: Scalars['DateTime']['input'];
  standingOrderId?: InputMaybe<Scalars['String']['input']>;
  untilDate: Scalars['DateTime']['input'];
};

export type BulkMenuItemMutationResponse = {
  __typename?: 'BulkMenuItemMutationResponse';
  failedIds: Array<Scalars['ID']['output']>;
  successfulIds: Array<Scalars['ID']['output']>;
};

export type CcAccount = {
  __typename?: 'CCAccount';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CcAccountLocation = {
  __typename?: 'CCAccountLocation';
  address: BillingAddress;
  id: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
};

export type CcAccountLocationOrder = {
  __typename?: 'CCAccountLocationOrder';
  accountLocation: AccountLocation;
  id: Scalars['ID']['output'];
};

export type CcAccountOrder = {
  __typename?: 'CCAccountOrder';
  accountLocation: AccountLocation;
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isClosed: Scalars['Boolean']['output'];
  items: Array<CcOrderItem>;
  meal: Meal;
  /** The DateTime value for when the order is open for use */
  orderOpeningTime: Maybe<Scalars['DateTime']['output']>;
  publishedVendors: Array<CcMealVendor>;
};

export type CcAccountOrderQueryInput = {
  accountLocationId?: InputMaybe<Scalars['ID']['input']>;
  hasRatedItem?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  meal?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
};

export type CcAccountOrdersPaged = {
  __typename?: 'CCAccountOrdersPaged';
  orders: Array<CcAccountOrder>;
  pageInfo: PageInfo;
};

export type CcAccountOrdersQueryInput = {
  accountLocationId?: InputMaybe<Scalars['ID']['input']>;
  includePublishedSlots?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  meal?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
};

export type CcAllOrdersWithItemsInput = {
  ccSupplierOrderId?: InputMaybe<Scalars['Int']['input']>;
  ccSupplierOrderIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRangeTypeInput>;
  invoiceOrderFor?: InputMaybe<InvoiceOrderForInput>;
};

export type CcAvailabilitiesPaged = {
  __typename?: 'CCAvailabilitiesPaged';
  pageInfo: PageInfo;
  rows: Array<CcAvailability>;
};

export type CcAvailability = {
  __typename?: 'CCAvailability';
  accountLocationId: Scalars['Int']['output'];
  arrivalTime: Scalars['DateTime']['output'];
  avgOrders: Maybe<Scalars['Int']['output']>;
  clusterId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  maxOrders: Scalars['Int']['output'];
  meal: Scalars['String']['output'];
  minOrders: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vendorQty: Maybe<Scalars['Int']['output']>;
  weekday: Scalars['Int']['output'];
};

export type CcAvailabilityQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CcCluster = {
  __typename?: 'CCCluster';
  /** Account Locations for this cluster */
  accountLocations: Array<AccountLocation>;
  /** CC Supplier Orders for this cluster */
  ccSupplierOrders: CcSupplierOrderPaged;
  /** Cluster code */
  code: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Cluster name */
  name: Scalars['String']['output'];
};


export type CcClusterCcSupplierOrdersArgs = {
  input: CcSupplierOrdersInput;
};

export type CcClusterInput = {
  id: Scalars['ID']['input'];
};

export type CcClusterListFilters = {
  orderBy?: InputMaybe<CcClusterSortBy>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CcClusterSortBy = {
  order: CcClusterSortOrder;
  term: CcClusterSortTerm;
};

export enum CcClusterSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum CcClusterSortTerm {
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export type CcClustersPaged = {
  __typename?: 'CCClustersPaged';
  pageInfo: PageInfo;
  rows: Array<CcCluster>;
};

export type CcDateMealServiceData = {
  __typename?: 'CCDateMealServiceData';
  breakfast: Maybe<CcMealService>;
  date: Scalars['DateTime']['output'];
  dinner: Maybe<CcMealService>;
  lunch: Maybe<CcMealService>;
};

export type CcInvoice = Invoice & {
  __typename?: 'CCInvoice';
  account: CcAccount;
  accountLocation: CcAccountLocation;
  additionalItemsTaxInvoiceNumber: Scalars['String']['output'];
  additionalTotal: Scalars['Float']['output'];
  additionalTotalExVat: Scalars['Float']['output'];
  additionalTotalVat: Scalars['Float']['output'];
  additionalVatSummary: Array<VatSummary>;
  amountDue: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  asset: Maybe<Asset>;
  assets: Array<Asset>;
  billingDetails: BillingDetails;
  billingEntity: BillingEntity;
  budgetCode: Maybe<Scalars['String']['output']>;
  canApprove: Scalars['Boolean']['output'];
  canCancel: Scalars['Boolean']['output'];
  canPay: Scalars['Boolean']['output'];
  currency: Currency;
  dueDate: Scalars['DateTime']['output'];
  friendlyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAlreadyApproved: Scalars['Boolean']['output'];
  issueDate: Maybe<Scalars['DateTime']['output']>;
  items: InvoiceItemsPaged;
  mealsDonated: Scalars['Int']['output'];
  overdue: Scalars['Boolean']['output'];
  paymentHistory: Array<PaymentHistory>;
  paymentStatus: PaymentStatus;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  status: InvoiceStatus;
  supplierOrderBreakdown: CcSupplierOrderBreakdownPaged;
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalQuantity: Scalars['Int']['output'];
  totalVat: Scalars['Float']['output'];
  type: InvoiceType;
  vatRegion: VatRegion;
  vatSummary: Array<VatSummary>;
};


export type CcInvoiceAdditionalTotalArgs = {
  checkDelivery: InputMaybe<Scalars['Boolean']['input']>;
};


export type CcInvoiceAdditionalTotalVatArgs = {
  checkDelivery: InputMaybe<Scalars['Boolean']['input']>;
};


export type CcInvoiceAdditionalVatSummaryArgs = {
  checkDelivery: InputMaybe<Scalars['Boolean']['input']>;
};


export type CcInvoiceAssetArgs = {
  input: AssetSearchInput;
};


export type CcInvoiceItemsArgs = {
  input: InputMaybe<InvoiceItemsInput>;
};


export type CcInvoiceSupplierOrderBreakdownArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

export type CcInvoiceOrder = {
  ccSupplierOrderId: Scalars['Int']['input'];
  invoiceOrderFor?: InputMaybe<InvoiceOrderForInput>;
};

export type CcItemsAwaitingReviewInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  periodEnd: Scalars['DateTime']['input'];
  /**
   * Meal-day window, expressed in the viewer's local time — typically seven days
   * ago to the end of yesterday. Passed in rather than derived server-side because
   * ccOrderItems.date is midnight in the canteen's timezone, not UTC.
   */
  periodStart: Scalars['DateTime']['input'];
};

export type CcMealService = {
  __typename?: 'CCMealService';
  availableSubsidy: Scalars['Float']['output'];
  closeTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  meal: Meal;
  menuIsPublished: Scalars['Boolean']['output'];
  openTime: Scalars['DateTime']['output'];
  orderAgainItems: Array<CcOrderAgainItem>;
  orderedItems: CcMealServiceOrderedItems;
  timeslots: Array<CcMealServiceTimeslot>;
};


export type CcMealServiceOrderedItemsArgs = {
  input: InputMaybe<CcMealServiceOrderedItemsQueryInput>;
};

export type CcMealServiceOrderedItems = {
  __typename?: 'CCMealServiceOrderedItems';
  items: Array<CcOrderItem>;
  orderPlaced: Scalars['Boolean']['output'];
};

export type CcMealServiceOrderedItemsQueryInput = {
  acrossAllLocations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CcMealServiceTimeslot = {
  __typename?: 'CCMealServiceTimeslot';
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isPostOrdersCloseTime: Scalars['Boolean']['output'];
  isPreOrdersOpenTime: Scalars['Boolean']['output'];
  orderedItems: CcMealServiceOrderedItems;
  ordersAreOpen: Scalars['Boolean']['output'];
  ordersCloseTime: Scalars['DateTime']['output'];
  ordersOpenTime: Scalars['DateTime']['output'];
  startTime: Scalars['DateTime']['output'];
  vendorMenus: Array<CcVendorMenu>;
};


export type CcMealServiceTimeslotVendorMenusArgs = {
  input: InputMaybe<CcVendorMenusQueryInput>;
};

export type CcMealTimeslot = {
  __typename?: 'CCMealTimeslot';
  endTime: Scalars['DateTime']['output'];
  ordersAreOpen: Scalars['Boolean']['output'];
  ordersCloseTime: Scalars['DateTime']['output'];
  ordersOpenTime: Scalars['DateTime']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type CcMealTimeslotsQueryInput = {
  date: Scalars['String']['input'];
  meal: Meal;
};

export type CcMealVendor = {
  __typename?: 'CCMealVendor';
  arrivalTime: Scalars['DateTime']['output'];
  arrivalTimeEnd: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  vendor: Vendor;
};

export type CcMealVendorsQueryInput = {
  accountLocationId: Scalars['ID']['input'];
  date: Scalars['String']['input'];
  meal: Meal;
};

export type CcMenuDebugInput = {
  accountId: Scalars['ID']['input'];
  accountLocationId: Scalars['ID']['input'];
  date: Scalars['DateTime']['input'];
  meal: Scalars['String']['input'];
  timeslot: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type CcMenuDebugResponse = {
  __typename?: 'CCMenuDebugResponse';
  results: Array<CcMenuDebugTest>;
};

export type CcMenuDebugTest = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSuccessful: Scalars['Boolean']['output'];
};

export type CcMenuDebugTestAllocations = CcMenuDebugTest & {
  __typename?: 'CCMenuDebugTestAllocations';
  ccSubmenuAllocations: Array<CcSubmenuAllocation>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSuccessful: Scalars['Boolean']['output'];
};

export type CcMenuDebugTestAvailabilities = CcMenuDebugTest & {
  __typename?: 'CCMenuDebugTestAvailabilities';
  ccAvailabilities: Array<CcAvailability>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSuccessful: Scalars['Boolean']['output'];
};

export type CcMenuDebugTestCcSupplierOrder = CcMenuDebugTest & {
  __typename?: 'CCMenuDebugTestCCSupplierOrder';
  ccSupplierOrders: Array<CcSupplierOrder>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSuccessful: Scalars['Boolean']['output'];
};

export type CcMenuDebugTestClusterAssignment = CcMenuDebugTest & {
  __typename?: 'CCMenuDebugTestClusterAssignment';
  ccCluster: Maybe<CcCluster>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSuccessful: Scalars['Boolean']['output'];
};

export type CcMenuItem = {
  __typename?: 'CCMenuItem';
  id: Scalars['ID']['output'];
  liveMenuItem: MenuItem;
  liveVariation: MenuItemVariation;
  /**
   * The minimum customer-facing price for the item, calculated from
   * the variation priceCustomerFacing and the total of the cheapest
   * required options for that item
   */
  minimumPurchasablePrice: Scalars['Float']['output'];
  quantityRemaining: Maybe<Scalars['Int']['output']>;
  submenuId: Scalars['String']['output'];
  vendorLocationId: Scalars['String']['output'];
};

export type CcMenuItemFilters = {
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  dietaries?: InputMaybe<Array<Scalars['String']['input']>>;
  menuItemType?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CcMenuQueryInput = {
  date: Scalars['DateTime']['input'];
  meal: Meal;
  timeslotEnd?: InputMaybe<Scalars['DateTime']['input']>;
  timeslotStart?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CcMenuQueryResult = {
  __typename?: 'CCMenuQueryResult';
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mealServiceData: CcMealService;
};

/** Delivery address details */
export type CcOrderAddress = {
  __typename?: 'CCOrderAddress';
  /** City */
  city: Scalars['String']['output'];
  /** Delivery instructions */
  instructions: Maybe<Scalars['String']['output']>;
  /** Latitude coordinate */
  lat: Maybe<Scalars['Float']['output']>;
  /** Address line 1 */
  line1: Scalars['String']['output'];
  /** Address line 2 */
  line2: Maybe<Scalars['String']['output']>;
  /** Address line 3 */
  line3: Maybe<Scalars['String']['output']>;
  /** Longitude coordinate */
  lng: Maybe<Scalars['Float']['output']>;
  /** Delivery location name */
  location: Scalars['String']['output'];
  /** Phone number */
  phone: Maybe<Scalars['String']['output']>;
  /** Postcode */
  postcode: Scalars['String']['output'];
  /** What3words location identifier */
  what3words: Maybe<Scalars['String']['output']>;
};

export type CcOrderAgainItem = {
  __typename?: 'CCOrderAgainItem';
  /** Individual user average rating */
  averageRating: Maybe<Scalars['Float']['output']>;
  itemReference: Scalars['ID']['output'];
  menuItemVariation: MenuItemVariation;
  /** Count for individual user orders in the last 6 months */
  orderCount: Scalars['Int']['output'];
  /** Submenu ID for the item, needed for add-to-cart */
  submenuId: Scalars['ID']['output'];
  vendor: Vendor;
  /** vendorLocation for the submenu item, need the ID for add-to-cart */
  vendorLocation: VendorLocation;
};

/**
 * Complete order confirmation details for a canteen order.
 * For multi-vendor orders (items from multiple suppliers):
 * - reference will be the transaction ID
 * - timeSlot will show the range from earliest to latest delivery
 * - items will include vendor information for frontend grouping
 */
export type CcOrderConfirmation = {
  __typename?: 'CCOrderConfirmation';
  /** Delivery address */
  address: CcOrderAddress;
  /** Currency code (GBP, USD, EUR, etc.) */
  currency: Scalars['String']['output'];
  /** Order date in ISO format */
  date: Scalars['DateTime']['output'];
  /** Whether prices should be hidden for this user */
  hidePrices: Scalars['Boolean']['output'];
  /** Order items (flat array) */
  items: Array<CcOrderItem>;
  /**
   * Order items grouped by vendor.
   * Useful for displaying multi-vendor orders with clear vendor separation.
   * Each group includes the vendor info (with companyName), items, and supplier order details.
   */
  itemsByVendor: Array<GroupedCcOrderItemsByVendor>;
  /** Meal type (breakfast, lunch, dinner) */
  meal: Meal;
  /** Total personal credits used across all items */
  personalCreditsUsed: Scalars['Float']['output'];
  /**
   * Order reference number displayed to the user.
   * For single-vendor orders: supplier order reference.
   * For multi-vendor orders: transaction ID.
   */
  reference: Scalars['String']['output'];
  /** Total company subsidy used across all items */
  subsidyCreditsUsed: Scalars['Float']['output'];
  /** Total amount paid by user (before credits) */
  subtotal: Scalars['Float']['output'];
  /**
   * Delivery time window.
   * For single-vendor orders: specific vendor's arrival time window.
   * For multi-vendor orders: range from earliest to latest delivery across all vendors.
   */
  timeSlot: CcOrderTimeSlot;
  /** Final amount paid by user after deducting all credits */
  total: Scalars['Float']['output'];
};

export type CcOrderItem = {
  __typename?: 'CCOrderItem';
  accountLocation: AccountLocation;
  accountLocationId: Scalars['Int']['output'];
  allergen_celery: Maybe<Scalars['Boolean']['output']>;
  allergen_cereals: Maybe<Scalars['Boolean']['output']>;
  allergen_crustaceans: Maybe<Scalars['Boolean']['output']>;
  allergen_eggs: Maybe<Scalars['Boolean']['output']>;
  allergen_fish: Maybe<Scalars['Boolean']['output']>;
  allergen_lupin: Maybe<Scalars['Boolean']['output']>;
  allergen_milk: Maybe<Scalars['Boolean']['output']>;
  allergen_molluscs: Maybe<Scalars['Boolean']['output']>;
  allergen_mustard: Maybe<Scalars['Boolean']['output']>;
  allergen_nuts: Maybe<Scalars['Boolean']['output']>;
  allergen_peanuts: Maybe<Scalars['Boolean']['output']>;
  allergen_sesame: Maybe<Scalars['Boolean']['output']>;
  allergen_soybeans: Maybe<Scalars['Boolean']['output']>;
  allergen_sulphur: Maybe<Scalars['Boolean']['output']>;
  allergens: Array<Allergen>;
  amountSubsidised: Scalars['Float']['output'];
  availableItemReferences: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  availableItems: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  canCancel: Scalars['Boolean']['output'];
  category: Maybe<Scalars['String']['output']>;
  ccSupplierOrder: Maybe<CcSupplierOrder>;
  chargeVendorRefund: Scalars['Boolean']['output'];
  commissionRate: Scalars['Float']['output'];
  costCentre: Maybe<Scalars['String']['output']>;
  creditRefund: Scalars['Float']['output'];
  cuisine: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  dietaries: Array<Dietary>;
  dietary_halal: Maybe<Scalars['Boolean']['output']>;
  dietary_kosher: Maybe<Scalars['Boolean']['output']>;
  dietary_refined_sugar: Maybe<Scalars['Boolean']['output']>;
  dietary_vegan: Maybe<Scalars['Boolean']['output']>;
  dietary_vegetarian: Maybe<Scalars['Boolean']['output']>;
  feedback: Maybe<Scalars['String']['output']>;
  fullPrice: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  isCollected: Scalars['Boolean']['output'];
  itemReference: Scalars['String']['output'];
  liveMenuItem: MenuItemVariation;
  meal: Scalars['String']['output'];
  mealDealId: Maybe<Scalars['Int']['output']>;
  mealType: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  options: CcOrderItemOptions;
  originalUnitPrice: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  promotionId: Maybe<Scalars['String']['output']>;
  promotionType: Maybe<Scalars['String']['output']>;
  promotionValue: Scalars['Float']['output'];
  qty: Scalars['Int']['output'];
  ratedAt: Maybe<Scalars['DateTime']['output']>;
  rating: Maybe<Scalars['Int']['output']>;
  showOnMenu: Scalars['Boolean']['output'];
  subAllergens: SubAllergens;
  sub_allergen_cereals_barley: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_cereals_kamut: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_cereals_oats: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_cereals_rye: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_cereals_wheat: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_almonds: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_brazil: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_cashew: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_hazelnuts: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_macadamia: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_pecan: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_pistachio: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_walnuts: Maybe<Scalars['Boolean']['output']>;
  subsidyQtyInclusive: Scalars['Float']['output'];
  subsidyRefund: Scalars['Float']['output'];
  supplierUnitPrice: Scalars['Float']['output'];
  supplierUnitPriceExTax: Scalars['Float']['output'];
  transactionId: Scalars['String']['output'];
  type: Maybe<Scalars['String']['output']>;
  unitPrice: Scalars['Float']['output'];
  user: User;
  userId: Scalars['ID']['output'];
  vat: Maybe<Scalars['Float']['output']>;
  vendor: Vendor;
};

export type CcOrderItemOption = {
  __typename?: 'CCOrderItemOption';
  allergen_celery: Maybe<Scalars['Boolean']['output']>;
  allergen_cereals: Maybe<Scalars['Boolean']['output']>;
  allergen_crustaceans: Maybe<Scalars['Boolean']['output']>;
  allergen_eggs: Maybe<Scalars['Boolean']['output']>;
  allergen_fish: Maybe<Scalars['Boolean']['output']>;
  allergen_lupin: Maybe<Scalars['Boolean']['output']>;
  allergen_milk: Maybe<Scalars['Boolean']['output']>;
  allergen_molluscs: Maybe<Scalars['Boolean']['output']>;
  allergen_mustard: Maybe<Scalars['Boolean']['output']>;
  allergen_nuts: Maybe<Scalars['Boolean']['output']>;
  allergen_peanuts: Maybe<Scalars['Boolean']['output']>;
  allergen_sesame: Maybe<Scalars['Boolean']['output']>;
  allergen_soybeans: Maybe<Scalars['Boolean']['output']>;
  allergen_sulphur: Maybe<Scalars['Boolean']['output']>;
  allergens: Array<Allergen>;
  category: Maybe<Scalars['String']['output']>;
  commissionRate: Scalars['Float']['output'];
  description: Maybe<Scalars['String']['output']>;
  dietaries: Array<Dietary>;
  dietary_halal: Maybe<Scalars['Boolean']['output']>;
  dietary_kosher: Maybe<Scalars['Boolean']['output']>;
  dietary_refined_sugar: Maybe<Scalars['Boolean']['output']>;
  dietary_vegan: Maybe<Scalars['Boolean']['output']>;
  dietary_vegetarian: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  liveMenuItem: Maybe<MenuItem>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  qty: Scalars['Int']['output'];
  subAllergens: SubAllergens;
  sub_allergen_cereals_barley: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_cereals_kamut: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_cereals_oats: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_cereals_rye: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_cereals_wheat: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_almonds: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_brazil: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_cashew: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_hazelnuts: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_macadamia: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_pecan: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_pistachio: Maybe<Scalars['Boolean']['output']>;
  sub_allergen_nuts_walnuts: Maybe<Scalars['Boolean']['output']>;
  supplierUnitPrice: Scalars['Float']['output'];
  supplierUnitPriceExTax: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  vat: Maybe<Scalars['Float']['output']>;
};

export type CcOrderItemOptions = {
  __typename?: 'CCOrderItemOptions';
  items: Array<CcOrderItemOption>;
};

export type CcOrderItemQueryInput = {
  ccSupplierOrderId?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CcOrderItemsPaged = {
  __typename?: 'CCOrderItemsPaged';
  pageInfo: PageInfo;
  rows: Array<CcOrderItem>;
};

export type CcOrderPrintPdfResponse = {
  __typename?: 'CCOrderPrintPdfResponse';
  url: Scalars['String']['output'];
};

export type CcOrderProgressResponse = {
  __typename?: 'CCOrderProgressResponse';
  continuationUri: Maybe<Scalars['String']['output']>;
  detail: Scalars['String']['output'];
  initiationId: Scalars['String']['output'];
  paymentId: Maybe<Scalars['String']['output']>;
  paymentToken: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transactionId: Maybe<Scalars['String']['output']>;
};

/** A scheduled notification for CC Order Reminders. */
export type CcOrderReminderNotification = {
  __typename?: 'CCOrderReminderNotification';
  accountId: Scalars['Int']['output'];
  accountLocationIdArray: Array<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  cutOffTime: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  meal: Meal;
  notificationStatus: Scalars['String']['output'];
  sendTime: Scalars['String']['output'];
  timezone: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  vendors: Array<CcOrderReminderNotificationVendor>;
};

/** Embedded vendor document within a CC order reminder notification. */
export type CcOrderReminderNotificationVendor = {
  __typename?: 'CCOrderReminderNotificationVendor';
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  keywords: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quote: Scalars['String']['output'];
};

export enum CcOrderSource {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

/** Time slot for order delivery */
export type CcOrderTimeSlot = {
  __typename?: 'CCOrderTimeSlot';
  /** End time of delivery window (e.g., "12:30") */
  end: Scalars['String']['output'];
  /** Start time of delivery window (e.g., "12:00") */
  start: Scalars['String']['output'];
};

export type CcSubmenu = {
  __typename?: 'CCSubmenu';
  copiable: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isUsedLive: Scalars['Boolean']['output'];
  items: CcSubmenuItems;
  liveAllocations: Array<CcSubmenuAllocation>;
  locationCapacities: Array<CcSubmenuLocationCapacity>;
  maxCapacity: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  publicName: Maybe<Scalars['String']['output']>;
  statistics: CcSubmenuStatistics;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vendor: Vendor;
  visibleToClient: Scalars['Boolean']['output'];
};

export type CcSubmenuAllocation = {
  __typename?: 'CCSubmenuAllocation';
  /** CC Cluster */
  ccCluster: CcCluster;
  /** Date of delivery */
  date: Scalars['DateTime']['output'];
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Meal */
  meal: Meal;
  /** ID of cc submenu */
  submenuId: Scalars['ID']['output'];
  /** Vendor location */
  vendorLocation: VendorLocation;
};

export type CcSubmenuItem = {
  __typename?: 'CCSubmenuItem';
  ccVariationId: Scalars['String']['output'];
  coreItem: MenuItem;
  deletedCoreItem: MenuItemIncDeleted;
  id: Scalars['ID']['output'];
  itemCoreId: Scalars['String']['output'];
  menuItemVariation: MenuItemVariation;
  position: Maybe<Scalars['Int']['output']>;
  submenu: CcSubmenu;
};

export type CcSubmenuItemStatistics = {
  __typename?: 'CCSubmenuItemStatistics';
  count: Scalars['Int']['output'];
  maxPrice: Scalars['Int']['output'];
  minPrice: Scalars['Int']['output'];
};

export type CcSubmenuItems = {
  __typename?: 'CCSubmenuItems';
  data: Array<CcSubmenuItem>;
  submenuId: Scalars['ID']['output'];
};

export type CcSubmenuLocationCapacity = {
  __typename?: 'CCSubmenuLocationCapacity';
  maxCapacity: Scalars['Int']['output'];
  vendorLocation: VendorLocation;
};

export type CcSubmenuStatistics = {
  __typename?: 'CCSubmenuStatistics';
  drinks: CcSubmenuItemStatistics;
  mains: CcSubmenuItemStatistics;
  sides: CcSubmenuItemStatistics;
};

export type CcSubmenusPaged = {
  __typename?: 'CCSubmenusPaged';
  pageInfo: PageInfo;
  rows: Array<CcSubmenu>;
};

export type CcSubsidy = {
  __typename?: 'CCSubsidy';
  accountLocationId: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  meal: Maybe<MealType>;
  subsidy: Maybe<Scalars['Decimal']['output']>;
  teamId: Scalars['Int']['output'];
  type: SubsidyType;
  updatedAt: Scalars['DateTime']['output'];
  weekday: Maybe<Scalars['Int']['output']>;
};

export type CcSupplierOrder = {
  __typename?: 'CCSupplierOrder';
  account: Account;
  accountId: Scalars['ID']['output'];
  arrivalTime: Scalars['DateTime']['output'];
  arrivalTimeEnd: Scalars['DateTime']['output'];
  autoSendTime: Scalars['DateTime']['output'];
  bookingStatus: Maybe<Scalars['String']['output']>;
  ccAccountLocationOrders: Array<CcAccountLocationOrder>;
  ccCluster: CcCluster;
  ccOrderItems: Array<CcOrderItem>;
  ccSupplierOrderReferenceFieldValues: Maybe<Array<CcSupplierOrderReferenceFieldValue>>;
  clusterId: Scalars['ID']['output'];
  confirmed: Scalars['Boolean']['output'];
  cutOffTime: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  duration: Scalars['Int']['output'];
  highRisk: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isCollection: Scalars['Boolean']['output'];
  latestProgressStatus: Maybe<CcSupplierOrderStatus>;
  maxOrders: Scalars['Int']['output'];
  meal: Meal;
  menuId: Scalars['ID']['output'];
  minOrders: Scalars['Int']['output'];
  minutesLate: Scalars['Int']['output'];
  notes: Maybe<Scalars['String']['output']>;
  orderTotalBreakdown: Maybe<CcOrderTaxBreakdown>;
  pickupTime: Scalars['DateTime']['output'];
  primaryContact: Maybe<CcSupplierOrderContact>;
  reference: Scalars['String']['output'];
  refunds: Array<Refund>;
  supplierId: Scalars['ID']['output'];
  supplierLocationId: Scalars['ID']['output'];
  thermalBoxes: Scalars['Int']['output'];
  transport: Maybe<Scalars['String']['output']>;
  vendor: Vendor;
  vendorCharges: Array<VendorCharge>;
  vendorLocation: VendorLocation;
};

export type CcSupplierOrderBreakdown = {
  __typename?: 'CCSupplierOrderBreakdown';
  accountLocationOrderId: Scalars['Float']['output'];
  arrivalTime: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  items: Array<InvoiceItem>;
  meal: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  supplierAddress: BillingAddress;
  supplierName: Scalars['String']['output'];
  supplierVatNumber: Maybe<Scalars['String']['output']>;
  taxInvoiceNumber: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
  vatSummary: Array<CcSupplierOrderBreakdownVat>;
};

export type CcSupplierOrderBreakdownPaged = {
  __typename?: 'CCSupplierOrderBreakdownPaged';
  orders: Array<CcSupplierOrderBreakdown>;
  pageInfo: PageInfo;
  vatSummary: Array<CcSupplierOrderBreakdownVat>;
};

export type CcSupplierOrderBreakdownVat = {
  __typename?: 'CCSupplierOrderBreakdownVat';
  quantity: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
  vatRate: Scalars['Float']['output'];
};

export type CcSupplierOrderContact = {
  __typename?: 'CCSupplierOrderContact';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
};

export type CcSupplierOrderFilters = {
  /** One day. Same as dateFrom and dateTo set to it, with the day read in UTC. */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inclusive YYYY-MM-DD, local to each vendor location. Needs vendorLocationIds. */
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Inclusive YYYY-MM-DD, local to each vendor location. Open-ended if omitted. */
  dateTo?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  vendorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  vendorLocationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CcSupplierOrderPaged = {
  __typename?: 'CCSupplierOrderPaged';
  pageInfo: PageInfo;
  rows: Array<CcSupplierOrder>;
};

export enum CcSupplierOrderPricingAudience {
  Customer = 'customer',
  VendorPostCommission = 'vendorPostCommission',
  VendorPreCommission = 'vendorPreCommission'
}

export type CcSupplierOrderQueryOptions = {
  pricingAudience?: InputMaybe<CcSupplierOrderPricingAudience>;
};

export type CcSupplierOrderReferenceFieldOption = {
  __typename?: 'CCSupplierOrderReferenceFieldOption';
  id: Scalars['Int']['output'];
  option: Scalars['String']['output'];
  orderPriority: Scalars['Int']['output'];
  orderReferenceFieldId: Scalars['Int']['output'];
};

export type CcSupplierOrderReferenceFieldValue = {
  __typename?: 'CCSupplierOrderReferenceFieldValue';
  ccSupplierOrderReferenceFieldId: Scalars['Int']['output'];
  description: Maybe<Scalars['String']['output']>;
  fieldType: ReferenceFieldType;
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Array<CcSupplierOrderReferenceFieldOption>;
  orderReferenceFieldId: Scalars['Int']['output'];
  value: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type CcSupplierOrderReferenceFieldValueInput = {
  orderReferenceFieldId: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CcSupplierOrderStatus = {
  __typename?: 'CCSupplierOrderStatus';
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type CcSupplierOrdersInput = {
  /** date is to be depreciated use filters.date instead */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<CcSupplierOrderFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<CcSupplierOrderQueryOptions>;
  orderBy?: InputMaybe<CcSupplierOrdersSortBy>;
};

export type CcSupplierOrdersSortBy = {
  order: CcSupplierOrdersSortOrder;
  term: CcSupplierOrdersSortTerm;
};

export enum CcSupplierOrdersSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum CcSupplierOrdersSortTerm {
  Date = 'date'
}

export type CcTeam = {
  __typename?: 'CCTeam';
  accountId: Scalars['Int']['output'];
  code: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subsidies: Maybe<Array<CcSubsidy>>;
  updatedAt: Scalars['DateTime']['output'];
  users: Maybe<Array<User>>;
};

/** Represents a credit transaction for a user */
export type CcTransaction = {
  __typename?: 'CCTransaction';
  amount: Scalars['Float']['output'];
  createdAt: Maybe<Scalars['DateTime']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  meal: Maybe<Scalars['String']['output']>;
  transactionId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['Int']['output'];
};

/** Paginated response for credit transactions */
export type CcTransactionsPaged = {
  __typename?: 'CCTransactionsPaged';
  pageInfo: PageInfo;
  rows: Array<CcTransaction>;
};

export type CcUserOrder = {
  __typename?: 'CCUserOrder';
  accountLocation: AccountLocation;
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isClosed: Scalars['Boolean']['output'];
  items: Array<CcOrderItem>;
  meal: Meal;
  /** The DateTime value for when the order is open for use */
  orderOpeningTime: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type CcUserOrderQueryInput = {
  hasRatedItem?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  meal?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
};

export type CcUserOrdersPaged = {
  __typename?: 'CCUserOrdersPaged';
  orders: Array<CcUserOrder>;
  pageInfo: PageInfo;
};

export type CcVendorMenu = {
  __typename?: 'CCVendorMenu';
  id: Scalars['ID']['output'];
  menuItems: CcVendorMenuItems;
  vendor: Vendor;
};


export type CcVendorMenuMenuItemsArgs = {
  filters: InputMaybe<CcMenuItemFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CcVendorMenuItems = {
  __typename?: 'CCVendorMenuItems';
  cacheKey: Maybe<Scalars['String']['output']>;
  cacheKeys: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  items: Array<CcMenuItem>;
  pageInfo: PageInfo;
  stats: CcVendorMenuItemsStats;
};

export type CcVendorMenuItemsStats = {
  __typename?: 'CCVendorMenuItemsStats';
  allergens: Array<VendorMenuItemStat>;
  cacheKey: Maybe<Scalars['String']['output']>;
  dietaries: Array<VendorMenuItemStat>;
  id: Scalars['ID']['output'];
};

export type CcVendorMenusDebugInput = {
  accountLocationId?: InputMaybe<Scalars['ID']['input']>;
  date: Scalars['DateTime']['input'];
  meal: Meal;
  timeslotEnd?: InputMaybe<Scalars['DateTime']['input']>;
  timeslotStart?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CcVendorMenusQueryInput = {
  includeVendorsById?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CancelGmOrderGmOrderInput = {
  orderId: Scalars['Int']['input'];
  paymentMethod: PaymentMethod;
  reason: Scalars['String']['input'];
  severity: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type CaterdeskApiAccountAccess = {
  __typename?: 'CaterdeskApiAccountAccess';
  accountContactId: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
};

export type CaterdeskApiScope = {
  __typename?: 'CaterdeskApiScope';
  access: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  resourcePathPattern: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CaterdeskApiScopeResponse = {
  __typename?: 'CaterdeskApiScopeResponse';
  caterdeskApiScopes: Array<CaterdeskApiScope>;
};

export type CaterdeskApiSetPasswordResponse = {
  __typename?: 'CaterdeskApiSetPasswordResponse';
  password: Scalars['String']['output'];
};

export type CaterdeskApiUser = {
  __typename?: 'CaterdeskApiUser';
  accounts: Array<CaterdeskApiAccountAccess>;
  createdAt: Scalars['String']['output'];
  deletedAt: Maybe<Scalars['String']['output']>;
  details: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  passwordUpdatedAt: Maybe<Scalars['String']['output']>;
  roles: Array<CaterdeskApiUserRole>;
  scopes: Array<CaterdeskApiUserScope>;
  tenantAdminId: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  vendors: Array<CaterdeskApiVendorAccess>;
};

export type CaterdeskApiUserAccountAccessInput = {
  accountContactId: Scalars['Int']['input'];
  accountId: Scalars['Int']['input'];
};

export type CaterdeskApiUserCreateInput = {
  accounts?: InputMaybe<Array<CaterdeskApiUserAccountAccessInput>>;
  details?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  roles: Array<CaterdeskApiUserRole>;
  scopes?: InputMaybe<Array<CaterdeskApiUserScopeInput>>;
  tenantAdminId?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
  vendors?: InputMaybe<Array<CaterdeskApiUserVendorAccessInput>>;
};

export type CaterdeskApiUserResponse = {
  __typename?: 'CaterdeskApiUserResponse';
  user: CaterdeskApiUser;
};

export enum CaterdeskApiUserRole {
  ApiUser = 'API_USER',
  TenantAdminApiUser = 'TENANT_ADMIN_API_USER'
}

export type CaterdeskApiUserScope = {
  __typename?: 'CaterdeskApiUserScope';
  access: Scalars['String']['output'];
  scope: Scalars['String']['output'];
};

export type CaterdeskApiUserScopeInput = {
  access: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};

export type CaterdeskApiUserSearch = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdAtFrom?: InputMaybe<Scalars['String']['input']>;
  createdAtTo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<CaterdeskApiUserRole>;
  scopes?: InputMaybe<Array<CaterdeskApiUserScopeInput>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  vendorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CaterdeskApiUserUpdateInput = {
  accounts?: InputMaybe<Array<CaterdeskApiUserAccountAccessInput>>;
  details?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<CaterdeskApiUserRole>>;
  scopes?: InputMaybe<Array<CaterdeskApiUserScopeInput>>;
  tenantAdminId?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  vendors?: InputMaybe<Array<CaterdeskApiUserVendorAccessInput>>;
};

export type CaterdeskApiUserVendorAccessInput = {
  vendorContactId: Scalars['Int']['input'];
  vendorId: Scalars['Int']['input'];
};

export type CaterdeskApiUsersPaged = {
  __typename?: 'CaterdeskApiUsersPaged';
  pageInfo: PageInfo;
  rows: Array<CaterdeskApiUser>;
};

export type CaterdeskApiVendorAccess = {
  __typename?: 'CaterdeskApiVendorAccess';
  vendorContactId: Scalars['Int']['output'];
  vendorId: Scalars['Int']['output'];
};

export type CateringMenuComposition = {
  __typename?: 'CateringMenuComposition';
  /** Active live catering menu items. */
  activeItems: Scalars['Int']['output'];
  /**
   * Count and price range across catering add-ons (isOption) of all statuses
   * (active and inactive). An item can be both a menu item and an add-on, in
   * which case it is counted in both.
   */
  addOns: MenuItemStatistics;
  /** Number of catering menu categories for the vendor. */
  categoryCount: Scalars['Int']['output'];
  /** Catering items in draft (unpublished changes, not in review). */
  draftItems: Scalars['Int']['output'];
  /** Catering items awaiting review. */
  inReviewItems: Scalars['Int']['output'];
  /**
   * Catering items that are published but inactive (isActive false or past their
   * active-to date).
   */
  inactiveItems: Scalars['Int']['output'];
  /**
   * Count and price range across catering menu items (isMenuItem) of all
   * statuses (active and inactive).
   */
  items: MenuItemStatistics;
  /**
   * Total catering (group meals) menu items across ALL statuses (active,
   * inactive, in review and draft), counted from the draft superset.
   */
  totalItems: Scalars['Int']['output'];
  vendorId: Scalars['Int']['output'];
};

export type CcOrderTaxBreakdown = {
  __typename?: 'CcOrderTaxBreakdown';
  taxRateTotals: Array<CcOrderTaxRateTotal>;
  taxValue: Scalars['Int']['output'];
  totalExTax: Scalars['Int']['output'];
  totalIncTax: Scalars['Int']['output'];
};

export type CcOrderTaxRateTotal = {
  __typename?: 'CcOrderTaxRateTotal';
  rate: Scalars['Float']['output'];
  taxValue: Scalars['Int']['output'];
  totalExTax: Scalars['Int']['output'];
  totalIncTax: Scalars['Int']['output'];
};

/**
 * Site considered in scope for this tenant’s run (cron candidates before allocation filtering).
 * Primary source: `cc_weekly_reminder_cron_run_started` → `candidateSites` for this Mongo `tenantId`.
 * If that envelope is missing or stored under another tenant (legacy / mis-keyed audits), the report
 * fills this list from this tenant’s passed-allocation and excluded sites for the same `batchRunId`.
 */
export type CcWeeklyReminderEligibleSite = {
  __typename?: 'CcWeeklyReminderEligibleSite';
  accountId: Scalars['Int']['output'];
  accountLocationId: Scalars['Int']['output'];
  /** Reminder-enabled users at the site when the run started. */
  recipientCount: Scalars['Int']['output'];
};

/**
 * Flattened email send outcome: one row per recipient in an `cc_weekly_reminder_email_sent` or `_failed` audit.
 * Rows that share `auditId` belong to the same notifications batch; tie to the pipeline via `batchRunId` and `dispatchJobId`.
 */
export type CcWeeklyReminderEmailOutcome = {
  __typename?: 'CcWeeklyReminderEmailOutcome';
  accountId: Scalars['Int']['output'];
  accountLocationId: Scalars['Int']['output'];
  auditId: Scalars['ID']['output'];
  /** Correlation id for one `runWeeklyReminders` invocation (cron or admin). */
  batchRunId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  /** One UUID per dispatch job (email locale batch or single push). */
  dispatchJobId: Scalars['String']['output'];
  error: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /** Template/locale bucket for the email job. */
  locale: Scalars['String']['output'];
  outcome: CcWeeklyReminderOutcome;
  /** Mongo tenant the audit document is stored under (matches the report query scope). */
  tenantId: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
};

/**
 * Site excluded after menu rules: no allocations for the week, so no send.
 * From `cc_weekly_reminder_batch_locations_excluded_no_allocations` → `locations[]`.
 */
export type CcWeeklyReminderExcludedLocation = {
  __typename?: 'CcWeeklyReminderExcludedLocation';
  accountId: Scalars['Int']['output'];
  accountLocationId: Scalars['Int']['output'];
  batchRunId: Scalars['String']['output'];
  /** Pipeline reason (e.g. no allocations after menu rules). */
  reason: Scalars['String']['output'];
  recipientCount: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
};

/**
 * Per-site rollup of email/push success vs failure counts within one `batchRunId`, derived from outcome rows.
 * Useful for dashboards without scanning every flat outcome line.
 */
export type CcWeeklyReminderLocationDelivery = {
  __typename?: 'CcWeeklyReminderLocationDelivery';
  accountId: Scalars['Int']['output'];
  accountLocationId: Scalars['Int']['output'];
  batchRunId: Scalars['String']['output'];
  emailFailedCount: Scalars['Int']['output'];
  emailSentCount: Scalars['Int']['output'];
  pushFailedCount: Scalars['Int']['output'];
  pushSentCount: Scalars['Int']['output'];
};

/**
 * Pipeline failed for this site before or during send (EventBridge publish or inline task).
 * From `cc_weekly_reminder_location_failed`; `phase` distinguishes publish vs inline.
 */
export type CcWeeklyReminderLocationFailure = {
  __typename?: 'CcWeeklyReminderLocationFailure';
  accountId: Scalars['Int']['output'];
  accountLocationId: Scalars['Int']['output'];
  batchRunId: Scalars['String']['output'];
  error: Scalars['String']['output'];
  phase: Scalars['String']['output'];
  /** Service dates inferred from allocations on the location when the failure was recorded. */
  serviceDates: Array<Scalars['String']['output']>;
};

/**
 * Shallow allocation/menu load failed for this site during the cron (could not build send context).
 * Nested under `cc_weekly_reminder_cron_run_finished` → `allocationLoadFailures` in audit.
 */
export type CcWeeklyReminderMenuLoadFailure = {
  __typename?: 'CcWeeklyReminderMenuLoadFailure';
  accountId: Scalars['Int']['output'];
  accountLocationId: Scalars['Int']['output'];
  batchRunId: Scalars['String']['output'];
  error: Scalars['String']['output'];
  /** Users at the site in pipeline context when the failure was recorded. */
  recipientCount: Scalars['Int']['output'];
};

/** Whether a single weekly-reminder email or push attempt succeeded (from per-send audit rows). */
export enum CcWeeklyReminderOutcome {
  Failed = 'FAILED',
  Sent = 'SENT'
}

/** Flattened push outcome: one row per `cc_weekly_reminder_push_sent` or `_failed` audit (single device attempt). */
export type CcWeeklyReminderPushOutcome = {
  __typename?: 'CcWeeklyReminderPushOutcome';
  accountId: Scalars['Int']['output'];
  accountLocationId: Scalars['Int']['output'];
  auditId: Scalars['ID']['output'];
  batchRunId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dispatchJobId: Scalars['String']['output'];
  error: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  outcome: CcWeeklyReminderOutcome;
  tenantId: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
};

/**
 * Site passed the allocation gate: menu data existed for the week and the location was queued for sends.
 * Derived from `cc_weekly_reminder_batch_locations_passed_allocation_gate` audit `locations[]`.
 */
export type CcWeeklyReminderReadyLocation = {
  __typename?: 'CcWeeklyReminderReadyLocation';
  accountId: Scalars['Int']['output'];
  accountLocationId: Scalars['Int']['output'];
  /** Distinct menu slots (date / meal / supplier) for the week. */
  allocationCount: Scalars['Int']['output'];
  batchRunId: Scalars['String']['output'];
  /** How many of those users were on the email channel (from audit `subscribers` snapshot). */
  emailRecipientCount: Scalars['Int']['output'];
  /** How many were on the push channel. */
  pushRecipientCount: Scalars['Int']['output'];
  /** Users at this site with weekly reminders enabled when the run was built (`userCount` in audit). */
  recipientCount: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
};

/**
 * Weekly reminder operational report: built from Mongo audit events (`actor` = weekly-reminders pipeline).
 * Requires admin auth or internal origin; results are scoped to one Mongo `tenantId` (from auth or argument).
 */
export type CcWeeklyReminderReport = {
  __typename?: 'CcWeeklyReminderReport';
  /** Chronological merge of email sent + failed outcome rows (capped by `outcomeRowsLimit`). */
  emailOutcomes: Array<CcWeeklyReminderEmailOutcome>;
  /** True when more email outcome rows existed than returned; narrow the window or raise the limit. */
  emailOutcomesTruncated: Scalars['Boolean']['output'];
  /** Maximum rows returned per flat outcome list; see `*Truncated` flags. */
  outcomeRowsLimit: Scalars['Int']['output'];
  pushOutcomes: Array<CcWeeklyReminderPushOutcome>;
  pushOutcomesTruncated: Scalars['Boolean']['output'];
  /** Echo of the request window upper bound (inclusive). */
  queryWindowEnd: Scalars['String']['output'];
  /** Echo of the request window lower bound (inclusive). */
  queryWindowStart: Scalars['String']['output'];
  /** One entry per distinct `batchRunId` observed in the window (ordered by `startedAt`). */
  runs: Array<CcWeeklyReminderRun>;
  summary: CcWeeklyReminderSummary;
  /** Tenant used to query `Audit.tenantId` (ObjectId string). */
  tenantId: Scalars['ID']['output'];
};

/**
 * One correlated weekly-reminder pipeline run for this Mongo tenant. All nested lists and counts refer to the same `batchRunId`.
 * Audit emits separate documents per tenant so counts here are never mixed across tenants.
 */
export type CcWeeklyReminderRun = {
  __typename?: 'CcWeeklyReminderRun';
  batchRunId: Scalars['String']['output'];
  /** Sites that received menu data and entered the send path (`readyCount`). */
  dispatchedLocationCount: Scalars['Int']['output'];
  /** Users at sites that were dispatched (had sends attempted). */
  dispatchedRecipientsCount: Scalars['Int']['output'];
  /** Sites in scope for this tenant in this run (`candidateCount` in finished/started audit). */
  eligibleLocationCount: Scalars['Int']['output'];
  /** Sum of reminder-enabled users at eligible sites. */
  eligibleRecipientCount: Scalars['Int']['output'];
  eligibleSites: Array<CcWeeklyReminderEligibleSite>;
  emailBatchesFailedCount: Scalars['Int']['output'];
  /** Count of distinct email send audit documents (batches). */
  emailBatchesSentCount: Scalars['Int']['output'];
  emailRecipientsFailedCount: Scalars['Int']['output'];
  /** Total email recipient rows (success + failure). */
  emailRecipientsSentCount: Scalars['Int']['output'];
  excludedLocations: Array<CcWeeklyReminderExcludedLocation>;
  /** Matching `cc_weekly_reminder_cron_run_finished` (if present). */
  finishedAt: Maybe<Scalars['String']['output']>;
  locationDeliveries: Array<CcWeeklyReminderLocationDelivery>;
  /** Rows in `locationFailures` for this run. */
  locationFailureCount: Scalars['Int']['output'];
  locationFailures: Array<CcWeeklyReminderLocationFailure>;
  /** Sites where allocation/menu load failed (`allocationLoadFailureCount`). */
  menuLoadFailureCount: Scalars['Int']['output'];
  menuLoadFailures: Array<CcWeeklyReminderMenuLoadFailure>;
  /** Sites skipped for no allocations after menu rules (length of excluded list for this run). */
  noAllocationsLocationCount: Scalars['Int']['output'];
  /** Users at sites excluded for no allocations. */
  noAllocationsRecipientsCount: Scalars['Int']['output'];
  pushFailedCount: Scalars['Int']['output'];
  pushSentCount: Scalars['Int']['output'];
  readyLocations: Array<CcWeeklyReminderReadyLocation>;
  /** First `cc_weekly_reminder_cron_run_started` for this batchRunId + tenant (if present). */
  startedAt: Maybe<Scalars['String']['output']>;
  /** `scheduled` (cron) or `admin` from audit payload. */
  trigger: Scalars['String']['output'];
};

/** Aggregates the same counters as `CcWeeklyReminderRun`, summed across all runs in the query window (after filters). */
export type CcWeeklyReminderSummary = {
  __typename?: 'CcWeeklyReminderSummary';
  dispatchedLocationCount: Scalars['Int']['output'];
  dispatchedRecipientsCount: Scalars['Int']['output'];
  eligibleLocationCount: Scalars['Int']['output'];
  eligibleRecipientCount: Scalars['Int']['output'];
  emailBatchesFailedCount: Scalars['Int']['output'];
  emailBatchesSentCount: Scalars['Int']['output'];
  emailRecipientsFailedCount: Scalars['Int']['output'];
  emailRecipientsSentCount: Scalars['Int']['output'];
  locationFailureCount: Scalars['Int']['output'];
  menuLoadFailureCount: Scalars['Int']['output'];
  noAllocationsRecipientsCount: Scalars['Int']['output'];
  pushFailedCount: Scalars['Int']['output'];
  pushSentCount: Scalars['Int']['output'];
  runCount: Scalars['Int']['output'];
};

export enum CerealSubAllergen {
  Barley = 'barley',
  Kamut = 'kamut',
  Oats = 'oats',
  Rye = 'rye',
  Wheat = 'wheat'
}

export type CheckoutResponse = GmCheckoutErrors | PayByCardResponse | PayByInvoiceResponse | PayByTransferResponse;

export type City = {
  __typename?: 'City';
  code: Scalars['ID']['output'];
  countryCode: CountryCode;
  name: Scalars['String']['output'];
};

export type ClearEmmaMenuItemGroupInput = {
  menuItemIds: Array<Scalars['ID']['input']>;
};

export type ClosestItem = {
  __typename?: 'ClosestItem';
  id: Scalars['ID']['output'];
  minutes: Scalars['Int']['output'];
};

export type ClosestMatchingSupplierLocationsResponse = {
  __typename?: 'ClosestMatchingSupplierLocationsResponse';
  inside: Array<ClosestItem>;
  notFound: Array<Scalars['Int']['output']>;
  outside: Array<ClosestItem>;
};

export type CombinedInvoice = CcInvoice | FlexInvoice | FlexInvoiceAllTypes | GmInvoice;

export type CombinedVendorStatement = VendorFlexInvoice | VendorFlexInvoiceAllTypes | VendorStatement;

export enum Communications {
  CustomerOnly = 'customerOnly',
  NoCommunication = 'noCommunication',
  VendorAndCustomer = 'vendorAndCustomer',
  VendorOnly = 'vendorOnly'
}

export type ConsolidateFlexInvoiceCustomerInput = {
  consolidationFrequency?: InputMaybe<FlexInvoiceConsolidationFrequency>;
  countryCode: Scalars['String']['input'];
  dateRange?: InputMaybe<DateRangeTypeInput>;
};

export type ConsolidateFlexInvoiceInput = {
  actor?: InputMaybe<FlexConsolidationActorInput>;
  customers?: InputMaybe<ConsolidateFlexInvoiceCustomerInput>;
  override?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers?: InputMaybe<ConsolidateFlexInvoiceSupplierInput>;
};

export type ConsolidateFlexInvoiceResult = {
  __typename?: 'ConsolidateFlexInvoiceResult';
  customers: Maybe<ConsolidateFlexInvoiceResultCustomer>;
  suppliers: Maybe<ConsolidateFlexInvoiceResultSupplier>;
};

export type ConsolidateFlexInvoiceResultCustomer = {
  __typename?: 'ConsolidateFlexInvoiceResultCustomer';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type ConsolidateFlexInvoiceResultSupplier = {
  __typename?: 'ConsolidateFlexInvoiceResultSupplier';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type ConsolidateFlexInvoiceSupplierInput = {
  countryCode: Scalars['String']['input'];
  dateRange?: InputMaybe<DateRangeTypeInput>;
};

export type Coordinates = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Country = {
  __typename?: 'Country';
  aliases: Array<Scalars['String']['output']>;
  code: CountryCode;
  currency: Currency;
  defaultLanguage: Language;
  flagImageUri: FlagImageUri;
  id: Scalars['ID']['output'];
  languages: Array<Language>;
  locales: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requiredTaxFields: Array<RequiredTaxFields>;
};

export enum CountryCode {
  Au = 'AU',
  Cz = 'CZ',
  De = 'DE',
  Dk = 'DK',
  Ec = 'EC',
  Fr = 'FR',
  Gb = 'GB',
  Ie = 'IE',
  It = 'IT',
  Lu = 'LU',
  Nl = 'NL',
  Nz = 'NZ',
  Sg = 'SG',
  Us = 'US'
}

export type Coupon = {
  __typename?: 'Coupon';
  accountId: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  discountNumeric: Maybe<Scalars['Float']['output']>;
  discountPercentage: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  maxUses: Maybe<Scalars['Int']['output']>;
  maxUsesPerUser: Maybe<Scalars['Int']['output']>;
  minOrder: Maybe<Scalars['Float']['output']>;
  supplierId: Maybe<Scalars['Int']['output']>;
  uses: Maybe<Scalars['Int']['output']>;
  validFrom: Maybe<Scalars['String']['output']>;
  validUntil: Maybe<Scalars['String']['output']>;
};

export type CouponUsesPerUser = {
  __typename?: 'CouponUsesPerUser';
  coupon: Coupon;
  id: Scalars['ID']['output'];
  user: User;
  usesPerUser: Maybe<Scalars['Int']['output']>;
};

export type CouponsPaged = {
  __typename?: 'CouponsPaged';
  pageInfo: Maybe<PageInfo>;
  rows: Array<Coupon>;
};

export type CreateAccountCountryFlexMappingInput = {
  accountId: Scalars['Int']['input'];
  country: Scalars['String']['input'];
  flexDeferredCustomerId: Scalars['String']['input'];
};

export type CreateAccountIdentityProviderInput = {
  accountId: Scalars['ID']['input'];
  attributeMapping: Array<AccountIdentityProviderAttributeMappingInput>;
  metadataXml: Scalars['String']['input'];
  signUpCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAccountInput = {
  name: Scalars['String']['input'];
};

/** Data for creation */
export type CreateAccountLocationInput = {
  /** Address for the location */
  addressData: AccountLocationAddressInput;
  /** The budget for the account location */
  budget?: InputMaybe<Scalars['Float']['input']>;
  /** Cluster ID to assign */
  clusterId?: InputMaybe<Scalars['String']['input']>;
  /** Contact preferences */
  contactPreferences?: InputMaybe<AccountLocationContactPreferencesInput>;
  /** Delivery preferences */
  deliveryPreferences?: InputMaybe<AccountLocationDeliveryPreferencesInput>;
  /** Whether the account is active for Cloud Canteen */
  isCCActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The label for the account location */
  label: Scalars['String']['input'];
  /** The menu coverage tolerance for the account location */
  menuCoverageTolerance?: InputMaybe<Scalars['Float']['input']>;
  /** Whether menu automation is opted out for this location */
  optOutMenuAutomation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** timezone */
  timezone: Scalars['String']['input'];
};

export type CreateAlertInput = {
  destinations: AlertDestinationsInput;
  eventName: Scalars['String']['input'];
  filters: Array<AlertFilterInput>;
  name: Scalars['String']['input'];
};

export type CreateBillingEntityInput = {
  address: Scalars['String']['input'];
  bankAccountData?: InputMaybe<Array<BankAccountDataInput>>;
  businessNumber?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  companyNumber?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  vatRegionId: Scalars['ID']['input'];
};

export type CreateCcClusterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  demoCluster?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCcOrderForUserInput = {
  date: Scalars['String']['input'];
  items: Array<InitiateCcOrderItemInput>;
  meal: Scalars['String']['input'];
  /**
   * Free-text note from the manager, stored against each order item and shown to
   * the vendor. Max 255 characters.
   */
  notes?: InputMaybe<Scalars['String']['input']>;
  orderSource?: InputMaybe<CcOrderSource>;
  timeslotStart?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type CreateCcOrderPrintPdfInput = {
  accountLocationId: Scalars['Int']['input'];
  date: Scalars['String']['input'];
  meal: Meal;
};

export type CreateCcSubmenuInput = {
  copiable: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  publicName?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  vendorId: Scalars['Int']['input'];
  visibleToClient: Scalars['Boolean']['input'];
};

export type CreateCcTeamInput = {
  name: Scalars['String']['input'];
};

export type CreateDeliveryRegionInput = {
  deliveryFee?: InputMaybe<DeliveryFeeInput>;
  minOrderValue?: InputMaybe<Scalars['Int']['input']>;
  minOrderValueExTax?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderPosition: Scalars['Int']['input'];
  polygonCoordinates?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
  regionType: RegionType;
  serviceTimes: Array<CreateServiceTimeInput>;
  serviceType: ServiceType;
  value: Scalars['String']['input'];
  vendorLocationId: Scalars['Int']['input'];
};

export type CreateDraftMenuItemInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  categoryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  centegraProductId?: InputMaybe<Scalars['Int']['input']>;
  cuisineTag?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaries?: InputMaybe<Array<Scalars['String']['input']>>;
  group?: InputMaybe<Scalars['String']['input']>;
  groupReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCombo?: InputMaybe<Scalars['Boolean']['input']>;
  isHot?: InputMaybe<Scalars['Boolean']['input']>;
  isMenuItem?: InputMaybe<Scalars['Boolean']['input']>;
  isOption?: InputMaybe<Scalars['Boolean']['input']>;
  kitchenStation?: InputMaybe<Scalars['String']['input']>;
  macros?: InputMaybe<MacrosInput>;
  markupRate?: InputMaybe<Scalars['Float']['input']>;
  meta?: InputMaybe<UpdateMenuItemMetaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  occasions?: InputMaybe<Array<MenuItemOccasion>>;
  options?: InputMaybe<Array<MenuItemOptionCategoryInput>>;
  priceExTax?: InputMaybe<Scalars['Int']['input']>;
  proteins?: InputMaybe<Array<Scalars['String']['input']>>;
  reducedCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  standardCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  subAllergenCereals?: InputMaybe<SubAllergenCerealsInput>;
  subAllergenNuts?: InputMaybe<SubAllergenNutsInput>;
  supplierExternalId?: InputMaybe<SupplierExternalId>;
  supplierId: Scalars['Int']['input'];
  translations?: InputMaybe<MenuItemTranslationsInput>;
  updateLive?: InputMaybe<Scalars['Boolean']['input']>;
  variations?: InputMaybe<Array<MenuItemVariationInput>>;
  vatBandId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateFlexInvoiceAccountInput = {
  accountId: Scalars['ID']['input'];
  addressCity: Scalars['String']['input'];
  addressCountry: Scalars['String']['input'];
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressPostcode: Scalars['String']['input'];
  autoInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  autoPay?: InputMaybe<Scalars['Boolean']['input']>;
  contactFirstName: Scalars['String']['input'];
  contactLastName: Scalars['String']['input'];
  contactPhoneNumber: Scalars['String']['input'];
  emailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  entityNumber: Scalars['String']['input'];
  entityRegion: Scalars['String']['input'];
  entityTaxNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceByPantryOrder?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceByStandingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceConsolidationFrequency?: InputMaybe<InvoiceConsolidationFrequency>;
  invoiceConsolidationType?: InputMaybe<InvoiceConsolidationType>;
  invoicePerContact?: InputMaybe<Scalars['Boolean']['input']>;
  invoicePerOrderRecipientType?: InputMaybe<InvoicePerOrderRecipientType>;
  invoicePerReferenceField?: InputMaybe<Scalars['Boolean']['input']>;
  invoicePerType?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primaryEmail: Scalars['String']['input'];
  referenceFieldLabelsForInvoice?: InputMaybe<Array<Scalars['String']['input']>>;
  standingOrderInvoicingRules?: InputMaybe<StandingOrderInvoicingRulesInput>;
  timezone: Scalars['String']['input'];
  vatRegionId: Scalars['Int']['input'];
};

export type CreateFlexInvoiceInput = {
  countryCode: Scalars['String']['input'];
  deferredCustomerId: Scalars['ID']['input'];
  orderIds: Array<Scalars['ID']['input']>;
};

export type CreateGmBasketConfigInput = {
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateGmBasketInput = {
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  couponId?: InputMaybe<Scalars['Int']['input']>;
  customItems?: InputMaybe<Array<GmBasketCustomItemInput>>;
  customName?: InputMaybe<Scalars['String']['input']>;
  isCateringTeamOrder?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<BasketItemInput>;
  logistics?: InputMaybe<GmServiceLogisticsInput>;
  options?: InputMaybe<GmServiceOptionsInput>;
  orderNotes?: InputMaybe<Scalars['String']['input']>;
  quoteCollectionId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<GmServiceSettingsInput>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  utmData?: InputMaybe<UtmTrackingDataInput>;
};

export type CreateGmInvoices = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type CreateGmOrderFromBasketInput = {
  basketId: Scalars['String']['input'];
  proposedTotalIncTax?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateGmOrderFromBasketOptionsInput = {
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  notifyVendor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateInvoiceAccountInput = {
  accountId: Scalars['ID']['input'];
  additionalEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  autoInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  businessNumber?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoiceByPantryOrder?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceByStandingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceConsolidationFrequency?: InputMaybe<InvoiceConsolidationFrequency>;
  invoiceConsolidationType?: InputMaybe<InvoiceConsolidationType>;
  invoicePerContact?: InputMaybe<Scalars['Boolean']['input']>;
  invoicePerOrderRecipientType?: InputMaybe<InvoicePerOrderRecipientType>;
  invoicePerReferenceField?: InputMaybe<Scalars['Boolean']['input']>;
  invoicePerType?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault: Scalars['Boolean']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  referenceFieldLabelsForInvoice?: InputMaybe<Array<Scalars['String']['input']>>;
  standingOrderInvoicingRules?: InputMaybe<StandingOrderInvoicingRulesInput>;
  vat?: InputMaybe<Scalars['String']['input']>;
  vatRegionId: Scalars['Int']['input'];
};

export type CreateMenuItemGroupInput = {
  categoryId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  occasions: Array<Scalars['String']['input']>;
  occasionsReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  suitability: Array<MenuItemSuitabilityOccasionInput>;
  vendorId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOrUpdateMyFavouriteInput = {
  favouriteId: Scalars['Int']['input'];
  favouriteType: UserFavouriteType;
  isFavourite: Scalars['Boolean']['input'];
};

export type CreatePlatformAlertInput = {
  countryCodes: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  portals: Array<PortalType>;
  severity: AlertSeverity;
  targetAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetVendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateQuoteCollectionInput = {
  accountId: Scalars['Int']['input'];
  basketId?: InputMaybe<Scalars['String']['input']>;
  emmaAutomationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReferenceFieldInput = {
  active: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  isInvoiceSummaryField?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  options: Array<CreateReferenceFieldOptionInput>;
  required: Scalars['Boolean']['input'];
  type: ReferenceFieldType;
};

export type CreateReferenceFieldOptionInput = {
  option: Scalars['String']['input'];
  orderPriority: Scalars['Int']['input'];
};

export type CreateServiceTimeInput = {
  endTime: Scalars['String']['input'];
  mealType: Meal;
  startTime: Scalars['String']['input'];
  weekdays: Array<Scalars['Int']['input']>;
};

export type CreateTenantInput = {
  name: Scalars['String']['input'];
};

export type CreateUserInput = {
  /** The users account id */
  accountId: Scalars['Int']['input'];
  /** The users account location id */
  accountLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** The users email */
  email: Scalars['String']['input'];
  /** The users first name */
  firstName: Scalars['String']['input'];
  /** The users last name */
  lastName: Scalars['String']['input'];
  /** Users locale */
  locale: Scalars['String']['input'];
  /** The users phone number */
  phone: Scalars['String']['input'];
  /** Users role */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Users reason for signup */
  signUpType?: InputMaybe<SignUpType>;
  /** The users team id */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateVendorFlexInvoiceInput = {
  countryCode: Scalars['String']['input'];
  deferredSupplierId: Scalars['ID']['input'];
  orderIds: Array<Scalars['ID']['input']>;
};

export type CreditCardFeeFlag = {
  __typename?: 'CreditCardFeeFlag';
  /** ISO country code, e.g. AU */
  countryCode: Scalars['String']['output'];
  /** Whether credit card fees are passed on to customers in this country */
  enabled: Scalars['Boolean']['output'];
};

export type CreditTransaction = {
  __typename?: 'CreditTransaction';
  /** Amount of the transaction */
  amount: Scalars['Float']['output'];
  /** When the transaction was created */
  createdAt: Scalars['String']['output'];
  /** Currency code (e.g., GBP, USD) */
  currency: Scalars['String']['output'];
  /** Description of the transaction */
  description: Scalars['String']['output'];
  /** Unique identifier for this transaction */
  id: Scalars['ID']['output'];
  /** The user's balance after this transaction (null for historical transactions where balance wasn't tracked) */
  newBalance: Maybe<Scalars['Float']['output']>;
  /** The transaction ID for tracking */
  transactionId: Scalars['String']['output'];
  /** Type of transaction (e.g., 'credits', 'subsidy', 'topup', 'admin-increase', 'admin-decrease', 'refund-credits') */
  type: Scalars['String']['output'];
  /** When the transaction was last updated */
  updatedAt: Scalars['String']['output'];
  /** The user this transaction belongs to */
  userId: Scalars['ID']['output'];
};

export type CreditTransactionsPaged = {
  __typename?: 'CreditTransactionsPaged';
  pageInfo: PageInfo;
  rows: Array<CreditTransaction>;
};

export enum Currency {
  Aud = 'AUD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Nzd = 'NZD',
  Sgd = 'SGD',
  Usd = 'USD'
}

export type CustomerOrderAmountAggregate = {
  __typename?: 'CustomerOrderAmountAggregate';
  current: Maybe<Array<AggregateByPeriod>>;
  previous: Maybe<Array<AggregateByPeriod>>;
};

export type CustomerOrderCityAggregate = {
  __typename?: 'CustomerOrderCityAggregate';
  city: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  spend: Scalars['Float']['output'];
};

export type CustomerOrderItem = {
  __typename?: 'CustomerOrderItem';
  category: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  subTotal: Scalars['Float']['output'];
  taxPercentage: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type CustomerOrderLocationAggregate = {
  __typename?: 'CustomerOrderLocationAggregate';
  locationLabel: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  spend: Scalars['Float']['output'];
};

export type CustomerOrderOwnershipAggregate = {
  __typename?: 'CustomerOrderOwnershipAggregate';
  averageOrderValue: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  totalSpend: Scalars['Float']['output'];
};

export type CustomerOrderPostcodeAggregate = {
  __typename?: 'CustomerOrderPostcodeAggregate';
  orderCount: Scalars['Int']['output'];
  postcode: Scalars['String']['output'];
  spend: Scalars['Float']['output'];
};

export type CustomerOrderResult = {
  __typename?: 'CustomerOrderResult';
  flexDeferredCustomerOrderId: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
};

export type CustomerOrderServiceTypeAggregate = {
  __typename?: 'CustomerOrderServiceTypeAggregate';
  orderCount: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  serviceType: OrderServiceType;
  spend: Scalars['Float']['output'];
};

export type CustomerOrderTotals = {
  __typename?: 'CustomerOrderTotals';
  averageOrderValue: Scalars['Float']['output'];
  avgPerOrderPerHead: Maybe<Scalars['Float']['output']>;
  percentageChange: Maybe<Scalars['Float']['output']>;
  previousPeriodSpend: Maybe<Scalars['Float']['output']>;
  serviceTypeAggregate: Maybe<Array<CustomerOrderServiceTypeAggregate>>;
  spendPerHead: Scalars['Float']['output'];
  totalSpend: Scalars['Float']['output'];
};

export type CustomerOrderUserAggregate = {
  __typename?: 'CustomerOrderUserAggregate';
  averageOrderValue: Scalars['Float']['output'];
  numberOfVendors: Scalars['Int']['output'];
  orderCount: Scalars['Int']['output'];
  spend: Scalars['Float']['output'];
  user: Scalars['String']['output'];
};

export type CustomerOrderVendorAggregate = {
  __typename?: 'CustomerOrderVendorAggregate';
  averageOrderValue: Scalars['Float']['output'];
  orderCount: Scalars['Int']['output'];
  totalSpend: Scalars['Float']['output'];
  vendor: Scalars['String']['output'];
};

export type CustomerOrdersAllType = {
  __typename?: 'CustomerOrdersAllType';
  contact: Scalars['String']['output'];
  deliveryAddress: Scalars['String']['output'];
  deliveryCity: Scalars['String']['output'];
  deliveryDate: Scalars['String']['output'];
  deliveryPostcode: Maybe<Scalars['String']['output']>;
  deliveryTime: Maybe<Scalars['String']['output']>;
  flexDeferredCustomerOrderId: Maybe<Scalars['String']['output']>;
  headCount: Maybe<Scalars['Int']['output']>;
  invoiceAccountName: Maybe<Scalars['String']['output']>;
  locationLabel: Maybe<Scalars['String']['output']>;
  orderItems: Maybe<Array<Maybe<CustomerOrderItem>>>;
  orderNumber: Scalars['String']['output'];
  orderType: OrderType;
  referenceFields: Maybe<Array<Maybe<OrderReferenceFieldResolvedValue>>>;
  serviceType: Maybe<OrderServiceType>;
  subTotal: Scalars['Float']['output'];
  supplierName: Scalars['String']['output'];
  supplierTags: Maybe<Array<OrderSupplierTag>>;
  timezone: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type CustomerOrdersAllTypePaged = {
  __typename?: 'CustomerOrdersAllTypePaged';
  items: Array<CustomerOrdersAllType>;
  pageInfo: PageInfo;
};

export type CustomerOrdersAllTypeWithFlexData = {
  __typename?: 'CustomerOrdersAllTypeWithFlexData';
  flexInvoiceNumber: Maybe<Scalars['String']['output']>;
  order: CustomerOrdersAllType;
};

export type CustomerOrdersReport = {
  __typename?: 'CustomerOrdersReport';
  aggregateByCity: Maybe<Array<CustomerOrderCityAggregate>>;
  aggregateByLocation: Maybe<Array<CustomerOrderLocationAggregate>>;
  aggregateByOrderType: Maybe<Array<OrderTypeAmount>>;
  aggregateByOwnership: Maybe<Array<CustomerOrderOwnershipAggregate>>;
  aggregateByPeriod: Maybe<CustomerOrderAmountAggregate>;
  aggregateByPostcode: Maybe<Array<CustomerOrderPostcodeAggregate>>;
  aggregateByServiceType: Maybe<Array<CustomerOrderServiceTypeAggregate>>;
  aggregateByUser: Maybe<Array<CustomerOrderUserAggregate>>;
  aggregateByVendor: Maybe<Array<CustomerOrderVendorAggregate>>;
  allOrderTypesWithFlexData: Maybe<Array<CustomerOrdersAllTypeWithFlexData>>;
  allOrders: Array<CustomerOrdersAllType>;
  allOrdersWithPaging: Maybe<CustomerOrdersAllTypePaged>;
  orderItemsCsv: Maybe<OrderItemsCsvResult>;
  totals: Maybe<CustomerOrderTotals>;
};


export type CustomerOrdersReportAggregateByPeriodArgs = {
  dataAggregation: DataAggregation;
  period: TimePeriod;
};


export type CustomerOrdersReportAllOrdersWithPagingArgs = {
  allOrdersWithPagingInput: InputMaybe<AllOrdersWithPagingInput>;
};

/**
 * Input for fetching a customer orders report when scoped to a specific Account entity.
 * The account id is derived from the parent Account, so it is not part of this input.
 */
export type CustomerOrdersReportForAccountInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  dateRange: DateRangeInput;
  invoiceAccountId?: InputMaybe<Scalars['Int']['input']>;
  paidByCard?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  serviceTypes?: InputMaybe<Array<OrderServiceType>>;
};

export type CustomerOrdersReportInput = {
  accountId: Scalars['Int']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  dateRange: DateRangeInput;
  invoiceAccountId?: InputMaybe<Scalars['Int']['input']>;
  paidByCard?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  serviceTypes?: InputMaybe<Array<OrderServiceType>>;
};

/** Lightweight summary of customer orders for fast analytics/visualisation. */
export type CustomerOrdersSummary = {
  __typename?: 'CustomerOrdersSummary';
  /**
   * Breakdown of totalSpend by order type (CC vs GM), based on Flex order data.
   * Orders without an orderType are excluded from this breakdown but included in totalSpend.
   */
  orderTypeTotals: Maybe<Array<OrderTypeAmount>>;
  /** Total spend (sum of subTotals) over the requested period. */
  totalSpend: Scalars['Float']['output'];
  /** Weekly totals over the requested period (date is week start). */
  weeklyTotals: Array<AggregateByPeriod>;
};

export type CustomerPriceItem = {
  __typename?: 'CustomerPriceItem';
  /** This price item is Customer or Vendor */
  customerPriceType: CustomerPriceType;
  /** The final price used for customer */
  isCustomerFinalPrice: Scalars['Boolean']['output'];
  /** The price, inclusive of tax */
  price: Scalars['Float']['output'];
  /** The price, exclusive of tax */
  priceExTax: Scalars['Float']['output'];
  /** The monetary tax value on the price */
  priceTaxValue: Scalars['Float']['output'];
};

export enum CustomerPriceType {
  Customer = 'customer',
  CustomerCostPlus = 'customerCostPlus'
}

export enum DataAggregation {
  Day = 'DAY',
  Week = 'WEEK'
}

export type DateRangeInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type DateRangeTypeInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

/** Data for deletion */
export type DeleteAccountLocationInput = {
  /** ID of location to be deleted */
  id: Scalars['ID']['input'];
};

/** Result returned after attempting to delete an account location */
export type DeleteAccountLocationResult = {
  __typename?: 'DeleteAccountLocationResult';
  /** The deleted location (with deletedAt timestamp set) */
  location: Maybe<AccountLocation>;
  /** Human-readable message about the operation */
  message: Scalars['String']['output'];
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
};

export type DeleteBillingEntityInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCcTeamResult = {
  __typename?: 'DeleteCCTeamResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteMenuItemInput = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  publish?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteMenuItemOptions = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteMenuItemsResponse = {
  __typename?: 'DeleteMenuItemsResponse';
  blocked: Array<BlockedMenuItemDeletion>;
  deletedIds: Array<Scalars['ID']['output']>;
};

export enum DeliveryBy {
  Feedr = 'feedr',
  Vendor = 'vendor'
}

export type DeliveryDocketPdfInput = {
  orderId: Scalars['String']['input'];
};

export type DeliveryDocketPdfResponse = {
  __typename?: 'DeliveryDocketPdfResponse';
  url: Scalars['String']['output'];
};

export type DeliveryFee = {
  __typename?: 'DeliveryFee';
  tax: Scalars['Int']['output'];
  taxRate: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
  totalExTax: Scalars['Int']['output'];
};

export type DeliveryFeeInput = {
  tax: Scalars['Int']['input'];
  taxRate: Scalars['Float']['input'];
  total: Scalars['Int']['input'];
  totalExTax: Scalars['Int']['input'];
};

export type DeliveryPartner = {
  __typename?: 'DeliveryPartner';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  vehicles: Array<Maybe<Vehicle>>;
};

export type DeliveryRegion = {
  __typename?: 'DeliveryRegion';
  deliveryFee: Maybe<DeliveryFee>;
  id: Scalars['ID']['output'];
  minOrderValue: Maybe<Scalars['Int']['output']>;
  minOrderValueExTax: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  orderPosition: Scalars['Int']['output'];
  polygonCoordinates: Array<Array<Array<Scalars['Float']['output']>>>;
  regionType: RegionType;
  serviceTimes: Array<Maybe<ServiceTime>>;
  serviceType: ServiceType;
  value: Scalars['String']['output'];
  vendorLocationId: Scalars['Int']['output'];
};

export type DeliveryRegionInput = {
  /** The location to check if it is within the delivery region */
  location?: InputMaybe<LocationInput>;
  /** The service type to filter by */
  serviceType?: InputMaybe<ServiceType>;
};

export enum DeliveryStatus {
  DriverAtDropoff = 'driver_at_dropoff',
  DriverAtPickup = 'driver_at_pickup',
  DriverEnRouteToPickup = 'driver_en_route_to_pickup',
  Failed = 'failed',
  InTransit = 'in_transit',
  LookingForDriver = 'looking_for_driver',
  Pending = 'pending',
  Success = 'success'
}

export enum Dietary {
  ContainsNuts = 'containsNuts',
  Halal = 'halal',
  HighProtein = 'highProtein',
  Kosher = 'kosher',
  LowCarb = 'lowCarb',
  LowCarbon = 'lowCarbon',
  NoDairy = 'noDairy',
  NoGluten = 'noGluten',
  NoRefinedSugar = 'noRefinedSugar',
  NonHfss = 'nonHfss',
  Pescatarian = 'pescatarian',
  PlantPacked = 'plantPacked',
  Vegan = 'vegan',
  Vegetarian = 'vegetarian',
  VeryLowCarbon = 'veryLowCarbon'
}

/** Count of active menu items carrying a given dietary tag. */
export type DietaryStat = {
  __typename?: 'DietaryStat';
  count: Scalars['Int']['output'];
  /**
   * The canonical Dietary GraphQL key (e.g. "Vegan", "PlantPacked", "NonHfss"),
   * matching the Dietary enum used across the platform. Clients map this to a
   * display label via the shared dietary label source.
   */
  dietary: Dietary;
};

export type EmmaAlgorithmResponse = {
  __typename?: 'EmmaAlgorithmResponse';
  baskets: Array<EmmaBasket>;
  briefing: Maybe<EmmaBriefingType>;
  createdAt: Scalars['DateTime']['output'];
  formResponseId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemGroups: Array<EmmaItemGroup>;
  numberOfPeople: Scalars['Int']['output'];
  recipe: Maybe<EmmaRecipe>;
  status: Maybe<EmmaAlgorithmResponseStatus>;
  subtotal: Scalars['Int']['output'];
  supplier: Vendor;
  test: Maybe<EmmaTestData>;
};

export type EmmaAlgorithmResponsePaged = {
  __typename?: 'EmmaAlgorithmResponsePaged';
  pageInfo: PageInfo;
  rows: Array<EmmaAlgorithmResponse>;
};

export type EmmaAlgorithmResponsePagedSortInput = {
  field: EmmaAlgorithmResponsePagedSortInput_SortField;
  order: EmmaAlgorithmResponsePagedSortInput_SortOrder;
};

export enum EmmaAlgorithmResponsePagedSortInput_SortField {
  BudgetDifference = 'budget_difference',
  SupplierName = 'supplier_name'
}

export enum EmmaAlgorithmResponsePagedSortInput_SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum EmmaAlgorithmResponseStatus {
  Converted = 'CONVERTED',
  Draft = 'DRAFT',
  Open = 'OPEN',
  Sent = 'SENT'
}

export type EmmaAllergensMatch = {
  __typename?: 'EmmaAllergensMatch';
  dairy: Scalars['Boolean']['output'];
  gluten: Scalars['Boolean']['output'];
  nuts: Scalars['Boolean']['output'];
};

export type EmmaAutomation = {
  __typename?: 'EmmaAutomation';
  /** The date the automation was created */
  createdAt: Maybe<Scalars['String']['output']>;
  /** Whether the automation is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Number of days to wait before sending follow-up email */
  followUpEmailDelay: Maybe<Scalars['Int']['output']>;
  /** The ID of the automation */
  id: Scalars['ID']['output'];
  /** The maximum number of quotes to send (Multi-quote if more than 1) */
  maxNumberOfQuotesToSend: Scalars['Int']['output'];
  /** The ID for the message template to use when sending the automation email */
  messageTemplateId: Maybe<Scalars['Int']['output']>;
  /** The name of the automation */
  name: Scalars['String']['output'];
  /** Whether to send a follow-up email */
  sendFollowUpEmail: Scalars['Boolean']['output'];
  /** The tenant ID of the automation */
  tenantId: Scalars['String']['output'];
  /** The triggers for the automation */
  triggers: EmmaAutomationTriggers;
};

export type EmmaAutomationFiltersInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  sendFollowUpEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmmaAutomationTracking = {
  __typename?: 'EmmaAutomationTracking';
  emmaAutomationId: Scalars['String']['output'];
  quoteReminderSentAt: Maybe<Scalars['DateTime']['output']>;
  quoteSentAt: Scalars['DateTime']['output'];
};

export type EmmaAutomationTrackingInput = {
  emmaAutomationId?: InputMaybe<Scalars['String']['input']>;
  quoteReminderSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  quoteSentAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmmaAutomationTriggerPrice = {
  __typename?: 'EmmaAutomationTriggerPrice';
  /** The maximum price to trigger the automation */
  max: Maybe<Scalars['Float']['output']>;
  /** The minimum price to trigger the automation */
  min: Maybe<Scalars['Float']['output']>;
};

export type EmmaAutomationTriggerPriceInput = {
  /** The maximum price to trigger the automation */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** The minimum price to trigger the automation */
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type EmmaAutomationTriggers = {
  __typename?: 'EmmaAutomationTriggers';
  /** The occasion for the automation */
  occasions: Array<Scalars['String']['output']>;
  /** The price for the automation */
  price: Maybe<EmmaAutomationTriggerPrice>;
};

export type EmmaAutomationTriggersInput = {
  /** The occasion for the automation */
  occasions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The price for the automation */
  price?: InputMaybe<EmmaAutomationTriggerPriceInput>;
};

export type EmmaBasket = {
  __typename?: 'EmmaBasket';
  createdAt: Scalars['DateTime']['output'];
  friendlyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: EmmaAlgorithmResponseStatus;
};

export type EmmaBriefingAllergens = {
  __typename?: 'EmmaBriefingAllergens';
  dairy: Maybe<Scalars['Int']['output']>;
  gluten: Maybe<Scalars['Int']['output']>;
  nuts: Maybe<Scalars['Int']['output']>;
};

export type EmmaBriefingBudget = {
  __typename?: 'EmmaBriefingBudget';
  type: EmmaBudgetType;
  value: Scalars['Int']['output'];
};

export type EmmaBriefingDietaries = {
  __typename?: 'EmmaBriefingDietaries';
  halal: Maybe<Scalars['Int']['output']>;
  vegan: Maybe<Scalars['Int']['output']>;
  vegetarian: Maybe<Scalars['Int']['output']>;
};

export type EmmaBriefingType = {
  __typename?: 'EmmaBriefingType';
  allergens: EmmaBriefingAllergens;
  budget: EmmaBriefingBudget;
  dietaryPreferences: EmmaBriefingDietaries;
  headcount: Scalars['Int']['output'];
  occasion: Scalars['String']['output'];
};

export enum EmmaBudgetType {
  Individual = 'Individual',
  Total = 'Total'
}

export type EmmaCategoriseItemInput = {
  text: Scalars['String']['input'];
};

export type EmmaCategoriseItemResponse = {
  __typename?: 'EmmaCategoriseItemResponse';
  category: Maybe<Scalars['String']['output']>;
  occasions: Array<Scalars['String']['output']>;
};

export type EmmaCategory = {
  __typename?: 'EmmaCategory';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  occasions: Array<Scalars['String']['output']>;
  tasteProfile: Maybe<EmmaTasteProfile>;
  value: Scalars['String']['output'];
};

export type EmmaCoveringAllergens = {
  __typename?: 'EmmaCoveringAllergens';
  allergen: EmmaBriefingAllergens;
  quantity: Scalars['Int']['output'];
};

export type EmmaCoveringDietaries = {
  __typename?: 'EmmaCoveringDietaries';
  dietary: EmmaBriefingDietaries;
  quantity: Scalars['Int']['output'];
};

export type EmmaCreateAutomationInput = {
  enabled: Scalars['Boolean']['input'];
  followUpEmailDelay?: InputMaybe<Scalars['Int']['input']>;
  maxNumberOfQuotesToSend: Scalars['Int']['input'];
  messageTemplateId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sendFollowUpEmail: Scalars['Boolean']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
  triggers: EmmaAutomationTriggersInput;
};

export type EmmaCreateRecipeGroupInput = {
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type EmmaCreateRecipeInput = {
  active: Scalars['Boolean']['input'];
  groups: Array<EmmaCreateRecipeGroupInput>;
  name: Scalars['String']['input'];
  occasion: Scalars['String']['input'];
};

export type EmmaDietariesMatch = {
  __typename?: 'EmmaDietariesMatch';
  halal: Scalars['Boolean']['output'];
  vegan: Scalars['Boolean']['output'];
  vegetarian: Scalars['Boolean']['output'];
};

export type EmmaFormAddress = {
  __typename?: 'EmmaFormAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  flatOrBuilding: Maybe<Scalars['String']['output']>;
  floorOrBuildingName: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  postcode: Scalars['String']['output'];
  street: Maybe<Scalars['String']['output']>;
};

export type EmmaFormAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  flatOrBuilding?: InputMaybe<Scalars['String']['input']>;
  floorOrBuildingName?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  postcode: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
};

export type EmmaFormAllergen = {
  __typename?: 'EmmaFormAllergen';
  dairy: Scalars['Int']['output'];
  gluten: Scalars['Int']['output'];
};

export type EmmaFormAllergenInput = {
  dairy: Scalars['Int']['input'];
  gluten: Scalars['Int']['input'];
};

export type EmmaFormAnalyticsInput = {
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export enum EmmaFormBudgetType {
  PerHead = 'PER_HEAD',
  Total = 'TOTAL'
}

export type EmmaFormContact = {
  __typename?: 'EmmaFormContact';
  address: EmmaFormAddress;
  companyName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  locale: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
};

export type EmmaFormContactInput = {
  address: EmmaFormAddressInput;
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type EmmaFormDietaryRequirement = {
  __typename?: 'EmmaFormDietaryRequirement';
  halal: Scalars['Int']['output'];
  vegan: Scalars['Int']['output'];
  vegetarian: Scalars['Int']['output'];
};

export type EmmaFormDietaryRequirementInput = {
  halal: Scalars['Int']['input'];
  vegan: Scalars['Int']['input'];
  vegetarian: Scalars['Int']['input'];
};

export type EmmaFormInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  adminAssigned?: InputMaybe<EmmaFormResponseAdminUserInput>;
  algorithmOnly?: InputMaybe<Scalars['Boolean']['input']>;
  allergens?: InputMaybe<EmmaFormAllergenInput>;
  analytics?: InputMaybe<EmmaFormAnalyticsInput>;
  budget: Scalars['Float']['input'];
  budgetType: EmmaFormBudgetType;
  contact: EmmaFormContactInput;
  date: Scalars['String']['input'];
  /** Timezone-agnostic representation of user input date in format of dd/MM/yyyy HH:mm */
  datetimeFormatted: Scalars['String']['input'];
  dietaryRequirements?: InputMaybe<EmmaFormDietaryRequirementInput>;
  disableAutomation?: InputMaybe<Scalars['Boolean']['input']>;
  drinks?: InputMaybe<Array<Scalars['String']['input']>>;
  equipment?: InputMaybe<Array<Scalars['String']['input']>>;
  eventStyle?: InputMaybe<Array<Scalars['String']['input']>>;
  foodServiceTime?: InputMaybe<Scalars['String']['input']>;
  hasAllergenOrDietaryRequirement?: InputMaybe<Scalars['Boolean']['input']>;
  headcount: Scalars['Int']['input'];
  occasion: Scalars['String']['input'];
  occasionSubTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  onsiteFacilities?: InputMaybe<Array<Scalars['String']['input']>>;
  prefillResult?: InputMaybe<EmmaPrefillResultInput>;
  requirements?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceStyle?: InputMaybe<Array<Scalars['String']['input']>>;
  servingType: EmmaFormServingType;
  source?: InputMaybe<EmmaFormSource>;
  staffServiceTime?: InputMaybe<Scalars['String']['input']>;
  subscribeToUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  supplierIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  temperature?: InputMaybe<EmmaFormTemperature>;
  tenantId: Scalars['String']['input'];
  time?: InputMaybe<Scalars['String']['input']>;
};

export type EmmaFormResponse = {
  __typename?: 'EmmaFormResponse';
  additionalDetails: Maybe<Scalars['String']['output']>;
  adminAssigned: Maybe<EmmaFormResponseAdminUser>;
  /** @deprecated Use the 'algorithmResultsPaged' field instead */
  algorithmResults: Array<EmmaAlgorithmResponse>;
  algorithmResultsPaged: EmmaAlgorithmResponsePaged;
  allergens: Maybe<EmmaFormAllergen>;
  budget: Scalars['Float']['output'];
  budgetType: EmmaFormBudgetType;
  contact: EmmaFormContact;
  createdAt: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  dietaryRequirements: Maybe<EmmaFormDietaryRequirement>;
  disableAutomation: Maybe<Scalars['Boolean']['output']>;
  drinks: Maybe<Array<Scalars['String']['output']>>;
  equipment: Maybe<Array<Scalars['String']['output']>>;
  eventStyle: Maybe<Array<Scalars['String']['output']>>;
  foodServiceTime: Maybe<Scalars['String']['output']>;
  hasAllergenOrDietaryRequirement: Maybe<Scalars['Boolean']['output']>;
  headcount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isRunning: Scalars['Boolean']['output'];
  occasion: Scalars['String']['output'];
  occasionSubTypes: Maybe<Array<Scalars['String']['output']>>;
  onsiteFacilities: Maybe<Array<Scalars['String']['output']>>;
  requirements: Maybe<Array<Scalars['String']['output']>>;
  serviceStyle: Maybe<Array<Scalars['String']['output']>>;
  servingType: EmmaFormServingType;
  staffServiceTime: Maybe<Scalars['String']['output']>;
  status: EmmaFormResponseStatus;
  subscribeToUpdates: Maybe<Scalars['Boolean']['output']>;
  tenantId: Scalars['String']['output'];
  time: Maybe<Scalars['String']['output']>;
  unassignedBaskets: Array<EmmaBasket>;
};


export type EmmaFormResponseAlgorithmResultsPagedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  showTests: InputMaybe<Scalars['Boolean']['input']>;
  sort: InputMaybe<EmmaAlgorithmResponsePagedSortInput>;
};

export type EmmaFormResponseAdminUser = {
  __typename?: 'EmmaFormResponseAdminUser';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EmmaFormResponseAdminUserInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type EmmaFormResponsePaged = {
  __typename?: 'EmmaFormResponsePaged';
  items: Array<EmmaFormResponse>;
  pageInfo: PageInfo;
};

export enum EmmaFormResponseStatus {
  Converted = 'CONVERTED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Noresults = 'NORESULTS',
  Open = 'OPEN',
  Sent = 'SENT'
}

export type EmmaFormResponsesFiltersInput = {
  adminAssigned?: InputMaybe<Scalars['String']['input']>;
  eventDateFrom?: InputMaybe<Scalars['String']['input']>;
  eventDateTo?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<EmmaFormSource>;
  status?: InputMaybe<EmmaFormResponseStatus>;
};

export type EmmaFormResponsesInput = {
  filters?: InputMaybe<EmmaFormResponsesFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EmmaFormResponsesSortInput>;
};

export enum EmmaFormResponsesSortField {
  CreatedAt = 'CREATED_AT',
  EventDate = 'EVENT_DATE'
}

export type EmmaFormResponsesSortInput = {
  field: EmmaFormResponsesSortField;
  order: EmmaFormResponsesSortOrder;
};

export enum EmmaFormResponsesSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum EmmaFormServingType {
  Both = 'BOTH',
  Individual = 'INDIVIDUAL',
  Sharing = 'SHARING'
}

export enum EmmaFormSource {
  CateringQuote = 'CATERING_QUOTE',
  Marketplace = 'MARKETPLACE'
}

export type EmmaFormSubmissionResponse = {
  __typename?: 'EmmaFormSubmissionResponse';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum EmmaFormTemperature {
  Both = 'BOTH',
  Cold = 'COLD',
  Hot = 'HOT'
}

export type EmmaItemGroup = {
  __typename?: 'EmmaItemGroup';
  displayOrder: Scalars['Int']['output'];
  items: Array<EmmaMenuItemType>;
  name: Scalars['String']['output'];
  rank: Scalars['Float']['output'];
};

export type EmmaItemLevelMatching = {
  __typename?: 'EmmaItemLevelMatching';
  allergens: EmmaAllergensMatch;
  dietaries: EmmaDietariesMatch;
};

export type EmmaMenuItemGroupInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  menuItemIds: Array<Scalars['ID']['input']>;
  occasions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EmmaMenuItemType = {
  __typename?: 'EmmaMenuItemType';
  adjustedWeight: Scalars['Float']['output'];
  allergens: EmmaAllergensMatch;
  coveringAllergens: Array<EmmaCoveringAllergens>;
  coveringDietaries: Array<EmmaCoveringDietaries>;
  dietaries: EmmaDietariesMatch;
  disabledAllergens: EmmaBriefingAllergens;
  disabledDietaries: EmmaBriefingDietaries;
  fullServings: Scalars['Int']['output'];
  groupId: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isMasterItem: Scalars['Boolean']['output'];
  item: MenuItemIncDeleted;
  itemLevel: EmmaItemLevelMatching;
  itemName: Maybe<Scalars['String']['output']>;
  itemRank: Scalars['Float']['output'];
  itemType: Scalars['String']['output'];
  occasionRanking: Maybe<EmmaOccasionRanking>;
  piecesPerItem: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  ranking: Scalars['Float']['output'];
  serving: Scalars['Int']['output'];
  tasteProfile: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
};

export type EmmaOccasion = {
  __typename?: 'EmmaOccasion';
  activeFrom: Maybe<OccasionDayMonth>;
  activeTo: Maybe<OccasionDayMonth>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmmaOccasionFilters = {
  activeDate?: InputMaybe<OccasionDayMonthInput>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmmaOccasionInput = {
  activeFrom?: InputMaybe<OccasionDayMonthInput>;
  activeTo?: InputMaybe<OccasionDayMonthInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type EmmaOccasionRanking = {
  __typename?: 'EmmaOccasionRanking';
  afternoonTeaRanking: Scalars['Float']['output'];
  afternoonTeaWeight: Scalars['Float']['output'];
  breakfastRanking: Scalars['Float']['output'];
  breakfastWeight: Scalars['Float']['output'];
  fingerFoodRanking: Scalars['Float']['output'];
  fingerFoodWeight: Scalars['Float']['output'];
  lunchColdRanking: Scalars['Float']['output'];
  lunchColdWeight: Scalars['Float']['output'];
  lunchHotRanking: Scalars['Float']['output'];
  lunchHotWeight: Scalars['Float']['output'];
  lunchRanking: Scalars['Float']['output'];
  lunchWeight: Scalars['Float']['output'];
  morningTeaRanking: Scalars['Float']['output'];
  morningTeaWeight: Scalars['Float']['output'];
  ranking: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
};

export type EmmaPrefillResultDetail = {
  fieldId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EmmaPrefillResultInput = {
  budget?: InputMaybe<Scalars['Float']['input']>;
  budgetType?: InputMaybe<EmmaFormBudgetType>;
  dairy?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  details: Array<EmmaPrefillResultDetail>;
  gluten?: InputMaybe<Scalars['Int']['input']>;
  halal?: InputMaybe<Scalars['Int']['input']>;
  headcount?: InputMaybe<Scalars['Int']['input']>;
  hour?: InputMaybe<Scalars['Int']['input']>;
  inputText?: InputMaybe<Scalars['String']['input']>;
  minute?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  occasion?: InputMaybe<Scalars['String']['input']>;
  servingType?: InputMaybe<EmmaFormServingType>;
  vegan?: InputMaybe<Scalars['Int']['input']>;
  vegetarian?: InputMaybe<Scalars['Int']['input']>;
};

export type EmmaRandomUnreviewedItemInput = {
  smallestCategoryFirst?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type EmmaRecipe = {
  __typename?: 'EmmaRecipe';
  active: Scalars['Boolean']['output'];
  groups: Array<EmmaRecipeGroup>;
  hasTasteProfile: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  occasion: Scalars['String']['output'];
  tasteProfile: Maybe<EmmaRecipeTasteProfile>;
};

export type EmmaRecipeGroup = {
  __typename?: 'EmmaRecipeGroup';
  name: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
};

export enum EmmaRecipeTasteProfile {
  Balanced = 'BALANCED',
  MoreSavoury = 'MORE_SAVOURY',
  MoreSweet = 'MORE_SWEET'
}

export enum EmmaTasteProfile {
  Neutral = 'NEUTRAL',
  Savoury = 'SAVOURY',
  Sweet = 'SWEET',
  SweetSavoury = 'SWEET_SAVOURY'
}

export type EmmaTestData = {
  __typename?: 'EmmaTestData';
  /** The name of the test */
  name: Scalars['String']['output'];
  /** The version number of the test */
  version: Scalars['Int']['output'];
};

export type EmmaUpdateAutomationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  followUpEmailDelay?: InputMaybe<Scalars['Int']['input']>;
  maxNumberOfQuotesToSend?: InputMaybe<Scalars['Int']['input']>;
  messageTemplateId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendFollowUpEmail?: InputMaybe<Scalars['Boolean']['input']>;
  triggers?: InputMaybe<EmmaAutomationTriggersInput>;
};

export type EmmaUpdateRecipeGroupInput = {
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type EmmaUpdateRecipeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<EmmaUpdateRecipeGroupInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  occasion?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCcSubmenus = {
  submenuName?: InputMaybe<Scalars['String']['input']>;
  vendorGroupCode?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['Int']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterStatTag = {
  __typename?: 'FilterStatTag';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  position: Maybe<Scalars['Int']['output']>;
};

export type FlagImageUri = {
  __typename?: 'FlagImageUri';
  rectangle: Scalars['String']['output'];
  square: Scalars['String']['output'];
};

export type FlexConsolidationActorInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FlexConsolidationRunStatus = {
  __typename?: 'FlexConsolidationRunStatus';
  completedAt: Maybe<Scalars['String']['output']>;
  hasRun: Scalars['Boolean']['output'];
  status: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type FlexInvoice = {
  __typename?: 'FlexInvoice';
  accountName: Scalars['String']['output'];
  country: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  csv: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  location: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  status: Maybe<FlexInvoiceStatus>;
  timezone: Maybe<Scalars['String']['output']>;
  total: Scalars['String']['output'];
};

export type FlexInvoiceAccount = {
  __typename?: 'FlexInvoiceAccount';
  accountId: Scalars['ID']['output'];
  addressCity: Scalars['String']['output'];
  addressCountry: Scalars['String']['output'];
  addressLine1: Scalars['String']['output'];
  addressLine2: Maybe<Scalars['String']['output']>;
  addressPostcode: Scalars['String']['output'];
  autoInvoice: Maybe<Scalars['Boolean']['output']>;
  autoPay: Scalars['Boolean']['output'];
  chargeCreditCardFee: Scalars['Boolean']['output'];
  contactFirstName: Scalars['String']['output'];
  contactLastName: Scalars['String']['output'];
  contactPhoneNumber: Scalars['String']['output'];
  emailAddresses: Maybe<Array<Scalars['String']['output']>>;
  entityNumber: Scalars['String']['output'];
  entityRegion: Scalars['String']['output'];
  entityTaxNumber: Maybe<Scalars['String']['output']>;
  flexDeferredCustomerId: Scalars['ID']['output'];
  /** The internal ID that references the InvoiceAccount within our system */
  id: Scalars['ID']['output'];
  invoiceByPantryOrder: Maybe<Scalars['Boolean']['output']>;
  invoiceByStandingOrder: Maybe<Scalars['Boolean']['output']>;
  invoiceConsolidationFrequency: Maybe<InvoiceConsolidationFrequency>;
  invoiceConsolidationType: Maybe<InvoiceConsolidationType>;
  invoicePerContact: Maybe<Scalars['Boolean']['output']>;
  invoicePerOrderRecipientType: Maybe<InvoicePerOrderRecipientType>;
  invoicePerReferenceField: Maybe<Scalars['Boolean']['output']>;
  invoicePerType: Maybe<Scalars['Boolean']['output']>;
  isDefault: Scalars['Boolean']['output'];
  isPaymentMethodSaved: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paymentTerms: Maybe<Scalars['Int']['output']>;
  primaryEmail: Scalars['String']['output'];
  referenceFieldLabelsForInvoice: Maybe<Array<Scalars['String']['output']>>;
  referenceFields: Array<ReferenceField>;
  standingOrderInvoicingRules: Maybe<StandingOrderInvoicingRules>;
  tenantId: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  /** The internal region id that needs to be stored against the invoice account */
  vatRegionId: Scalars['Int']['output'];
};

export type FlexInvoiceAllTypes = {
  __typename?: 'FlexInvoiceAllTypes';
  accountAddress: Scalars['String']['output'];
  accountBusinessNumber: Scalars['String']['output'];
  accountContact: Maybe<Scalars['String']['output']>;
  accountId: Maybe<Scalars['Int']['output']>;
  accountName: Scalars['String']['output'];
  accountTaxNumber: Scalars['String']['output'];
  assets: Maybe<Array<FlexInvoiceAsset>>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  csv: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  entityName: Scalars['String']['output'];
  flexDeferredCustomerId: Maybe<Scalars['String']['output']>;
  flexInvoiceId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  instant: Maybe<Scalars['Boolean']['output']>;
  invoiceType: Maybe<FlexInvoiceType>;
  location: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  status: Maybe<FlexInvoiceStatus>;
  timezone: Maybe<Scalars['String']['output']>;
  total: Scalars['String']['output'];
};

export type FlexInvoiceAllTypesPaged = {
  __typename?: 'FlexInvoiceAllTypesPaged';
  items: Array<Maybe<FlexInvoiceAllTypes>>;
  pageInfo: PageInfo;
};

export type FlexInvoiceAsset = {
  __typename?: 'FlexInvoiceAsset';
  link: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum FlexInvoiceConsolidationFrequency {
  Daily = 'DAILY',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum FlexInvoiceStatus {
  Paid = 'Paid',
  Unpaid = 'Unpaid'
}

export enum FlexInvoiceType {
  AdjustmentInvoice = 'AdjustmentInvoice',
  Invoice = 'Invoice'
}

export type FlexInvoicesFiltersInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdDateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  createdDateStart?: InputMaybe<Scalars['DateTime']['input']>;
  deferredCustomerId?: InputMaybe<Scalars['ID']['input']>;
  deferredCustomerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  instant?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  placedBy?: InputMaybe<Scalars['String']['input']>;
};

export type FlexInvoicesInput = {
  filters?: InputMaybe<FlexInvoicesFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FlexInvoicesOrderByInput>;
};

export type FlexInvoicesOrderByInput = {
  accountName?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  dueDate?: InputMaybe<Sort>;
  number?: InputMaybe<Sort>;
  total?: InputMaybe<Sort>;
};

export type FlexInvoicesPaged = {
  __typename?: 'FlexInvoicesPaged';
  items: Array<Maybe<FlexInvoice>>;
  pageInfo: PageInfo;
};

export type FlexInvoicingClient = {
  __typename?: 'FlexInvoicingClient';
  /** The clientId of the tenant associated with flex invoicing */
  clientId: Scalars['String']['output'];
  /** Country associated with this flex invoicing */
  countryCode: Scalars['String']['output'];
  /** Short corde for easier identification */
  shortCode: Scalars['String']['output'];
};

export type FlexInvoicingFlags = {
  __typename?: 'FlexInvoicingFlags';
  countryCode: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type FlexInvoicingPaymentSettings = {
  __typename?: 'FlexInvoicingPaymentSettings';
  billingEntityCode: Maybe<Scalars['String']['output']>;
  chargeCreditCardFee: Scalars['Boolean']['output'];
  countryCode: Scalars['String']['output'];
  enableInvoicePaymentByCard: Scalars['Boolean']['output'];
};

export type ForceRunStandingOrderGenerationInput = {
  runDate?: InputMaybe<Scalars['DateTime']['input']>;
  standingOrderId?: InputMaybe<Scalars['String']['input']>;
  standingOrderTemplateId?: InputMaybe<Scalars['String']['input']>;
};

export type GlCodeServiceTypeOverride = {
  __typename?: 'GLCodeServiceTypeOverride';
  customerGLCode: Maybe<Scalars['String']['output']>;
  serviceType: Scalars['String']['output'];
  vendorGLCode: Maybe<Scalars['String']['output']>;
};

export type GlCodes = {
  __typename?: 'GLCodes';
  customerGLCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemType: Scalars['String']['output'];
  serviceTypeOverrides: Maybe<Array<GlCodeServiceTypeOverride>>;
  vendorGLCode: Scalars['String']['output'];
};

export type GmAccount = {
  __typename?: 'GMAccount';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GmAccountLocation = {
  __typename?: 'GMAccountLocation';
  address: BillingAddress;
  id: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
};

export type GmAllOrdersWithItemsInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRangeTypeInput>;
  invoiceOrderFor?: InputMaybe<InvoiceOrderForInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type GmInvoice = Invoice & {
  __typename?: 'GMInvoice';
  account: GmAccount;
  accountLocation: GmAccountLocation;
  additionalTotal: Scalars['Float']['output'];
  additionalTotalExVat: Scalars['Float']['output'];
  additionalTotalVat: Scalars['Float']['output'];
  additionalVatSummary: Array<VatSummary>;
  amountDue: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  asset: Maybe<Asset>;
  assets: Array<Asset>;
  billingDetails: BillingDetails;
  billingEntity: BillingEntity;
  budgetCode: Maybe<Scalars['String']['output']>;
  canApprove: Scalars['Boolean']['output'];
  canCancel: Scalars['Boolean']['output'];
  canPay: Scalars['Boolean']['output'];
  canRecreate: Scalars['Boolean']['output'];
  currency: Currency;
  dueDate: Scalars['DateTime']['output'];
  foodSalesDiscountPercent: Scalars['Float']['output'];
  friendlyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAlreadyApproved: Scalars['Boolean']['output'];
  isInvoiceAccount: Scalars['Boolean']['output'];
  issueDate: Maybe<Scalars['DateTime']['output']>;
  items: InvoiceItemsPaged;
  mealsDonated: Scalars['Int']['output'];
  overdue: Scalars['Boolean']['output'];
  paymentHistory: Array<PaymentHistory>;
  paymentStatus: PaymentStatus;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  status: InvoiceStatus;
  supplierOrderBreakdown: GmSupplierOrderBreakdownPaged;
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalQuantity: Scalars['Int']['output'];
  totalVat: Scalars['Float']['output'];
  type: InvoiceType;
  vatRegion: VatRegion;
  vatSummary: Array<VatSummary>;
  vendorOwnDelivery: Scalars['Boolean']['output'];
};


export type GmInvoiceAdditionalTotalArgs = {
  checkDelivery: InputMaybe<Scalars['Boolean']['input']>;
};


export type GmInvoiceAdditionalTotalVatArgs = {
  checkDelivery: InputMaybe<Scalars['Boolean']['input']>;
};


export type GmInvoiceAdditionalVatSummaryArgs = {
  checkDelivery: InputMaybe<Scalars['Boolean']['input']>;
};


export type GmInvoiceAssetArgs = {
  input: AssetSearchInput;
};


export type GmInvoiceItemsArgs = {
  input: InputMaybe<InvoiceItemsInput>;
};


export type GmInvoiceSupplierOrderBreakdownArgs = {
  checkDelivery: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

export type GmInvoiceOrder = {
  invoiceOrderFor?: InputMaybe<InvoiceOrderForInput>;
  orderId: Scalars['Int']['input'];
};

export type GmReferenceFieldValueInput = {
  orderReferenceFieldId: Scalars['Int']['input'];
  referenceFieldValueId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GmServiceAddons = {
  __typename?: 'GMServiceAddons';
  napkins: Scalars['Boolean']['output'];
  plates: Scalars['Boolean']['output'];
  service: Scalars['Boolean']['output'];
};

export enum GmServiceFormat {
  Individual = 'individual',
  Sharing = 'sharing'
}

export type GmServiceNotes = {
  __typename?: 'GMServiceNotes';
  account: Maybe<Scalars['String']['output']>;
  cart: Maybe<Scalars['String']['output']>;
  vendor: Maybe<Scalars['String']['output']>;
};

export type GmServiceOptions = {
  __typename?: 'GMServiceOptions';
  addons: GmServiceAddons;
  budgetCode: Maybe<Scalars['String']['output']>;
  format: Maybe<GmServiceFormat>;
  isHighRisk: Scalars['Boolean']['output'];
  notes: GmServiceNotes;
  rep: Scalars['Boolean']['output'];
  thermalBox: Maybe<Scalars['Boolean']['output']>;
};

export type GmSupplierOrderBreakdown = {
  __typename?: 'GMSupplierOrderBreakdown';
  arrivalTime: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  friendlyOrderId: Scalars['String']['output'];
  items: Array<InvoiceItem>;
  orderId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  supplierAddress: BillingAddress;
  supplierName: Scalars['String']['output'];
  supplierVatNumber: Maybe<Scalars['String']['output']>;
  taxInvoiceNumber: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
  vatSummary: Array<GmSupplierOrderBreakdownVat>;
};

export type GmSupplierOrderBreakdownPaged = {
  __typename?: 'GMSupplierOrderBreakdownPaged';
  orders: Array<GmSupplierOrderBreakdown>;
  pageInfo: PageInfo;
  vatSummary: Array<GmSupplierOrderBreakdownVat>;
};

export type GmSupplierOrderBreakdownVat = {
  __typename?: 'GMSupplierOrderBreakdownVat';
  quantity: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
  vatRate: Scalars['Float']['output'];
};

export type GenerateTenantImageUploadUrlInput = {
  contentType: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  type: TenantImageUploadType;
};

export type GeocodeContext = {
  __typename?: 'GeocodeContext';
  /** @deprecated Use Address.country instead */
  country: Maybe<Scalars['String']['output']>;
  district: Maybe<Scalars['String']['output']>;
  locality: Maybe<Scalars['String']['output']>;
  neighborhood: Maybe<Scalars['String']['output']>;
  place: Maybe<Scalars['String']['output']>;
  /** @deprecated Use Address.postcode instead */
  postcode: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
};

export type GmAvailability = {
  __typename?: 'GmAvailability';
  id: Scalars['ID']['output'];
  /** @deprecated Use itemsPaged instead */
  items: Array<Maybe<MenuItem>>;
  itemsPaged: MenuItemPaged;
  itemsPagedv2: GmMenuItems;
  myBaskets: GmBasketPaged;
  myLastBasket: Maybe<GmBasket>;
  vendorId: Scalars['ID']['output'];
};


export type GmAvailabilityItemsPagedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type GmAvailabilityItemsPagedv2Args = {
  filters: InputMaybe<GmMenuItemFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorting: InputMaybe<GmMenuItemSortingOptions>;
};


export type GmAvailabilityMyBasketsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GmBasket = {
  __typename?: 'GmBasket';
  allergens: Maybe<Array<Scalars['String']['output']>>;
  availabilityId: Scalars['String']['output'];
  basketTotalBreakdown: GmOrderTaxBreakdown;
  checkoutRestrictions: GmBasketCheckoutRestrictions;
  contributors: Array<GmBasketContributor>;
  coupon: Maybe<Coupon>;
  couponId: Maybe<Coupon>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  customItems: Array<GmBasketCustomItem>;
  customName: Maybe<Scalars['String']['output']>;
  /**
   * Delivery fee value inclusive of tax
   * @deprecated use deliveryFeeBreakdown
   */
  deliveryFee: Scalars['Int']['output'];
  /** Delivery fee tax breakdown */
  deliveryFeeBreakdown: BasketFeeBreakdown;
  discountBreakdown: GmOrderTaxBreakdown;
  duplicated: Maybe<Scalars['Boolean']['output']>;
  editSessionId: Maybe<Scalars['String']['output']>;
  fees: Array<GmOrderFeeBreakdown>;
  friendlyId: Scalars['String']['output'];
  hasEnterpriseDiscount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isCateringTeamOrder: Scalars['Boolean']['output'];
  /** @deprecated use isCateringTeamOrder */
  isGroupOrder: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  items: Array<BasketItem>;
  logistics: GmServiceLogistics;
  margin: Margin;
  options: Maybe<GmServiceOptions>;
  orderNotes: Maybe<Scalars['String']['output']>;
  orderNotesUpdatedAt: Maybe<Scalars['String']['output']>;
  /**
   * Product fee value inclusive of tax
   * @deprecated use productFeeBreakdown
   */
  productFee: Scalars['Int']['output'];
  /** Product fee tax breakdown */
  productFeeBreakdown: BasketFeeBreakdown;
  quoteCollection: Maybe<QuoteCollection>;
  settings: GmServiceSettings;
  /**
   * Subtotal inclusive of tax
   * @deprecated use subtotalBreakdown
   */
  subtotal: Scalars['Int']['output'];
  /** Subtotal tax breakdown */
  subtotalBreakdown: BasketSubtotalBreakdown;
  /** Thermal box fee tax breakdown */
  thermalBoxFeeBreakdown: BasketFeeBreakdown;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  user: Maybe<User>;
  userId: Maybe<Scalars['Int']['output']>;
  /** UTM Tracking data */
  utmData: Maybe<UtmTrackingData>;
  vendor: Vendor;
};

export type GmBasketCheckoutRestrictions = {
  __typename?: 'GmBasketCheckoutRestrictions';
  companyAdminOnly: Maybe<Scalars['Boolean']['output']>;
};

export type GmBasketContributor = {
  __typename?: 'GmBasketContributor';
  name: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type GmBasketCustomItem = {
  __typename?: 'GmBasketCustomItem';
  commissionRate: Scalars['Float']['output'];
  customerPriceExTax: Scalars['Int']['output'];
  customerPriceIncTax: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  taxRate: Scalars['Float']['output'];
  vendorPriceExTax: Scalars['Int']['output'];
  vendorPriceExTaxExCom: Scalars['Int']['output'];
};

export type GmBasketCustomItemInput = {
  commissionRate: Scalars['Float']['input'];
  customerPriceExTax?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  taxRate: Scalars['Float']['input'];
  vendorPriceExTax?: InputMaybe<Scalars['Int']['input']>;
};

export type GmBasketFiltersInput = {
  accountLocationId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDateFrom?: InputMaybe<Scalars['String']['input']>;
  deliveryDateTo?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type GmBasketPaged = {
  __typename?: 'GmBasketPaged';
  pageInfo: PageInfo;
  rows: Array<GmBasket>;
};

export type GmBasketQueryOptions = {
  isInternalBasketRequest?: InputMaybe<Scalars['Boolean']['input']>;
  pricingAudience?: InputMaybe<GmOrderPricingAudience>;
};

export type GmBasketsFilters = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountManager?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  deliveryDateFrom?: InputMaybe<Scalars['String']['input']>;
  friendlyId?: InputMaybe<Scalars['String']['input']>;
  globalSearch?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['Int']['input']>;
};

export type GmCheckoutErrors = {
  __typename?: 'GmCheckoutErrors';
  errors: Array<GmValidationError>;
};

export enum GmInvoicingFormat {
  Monthly = 'MONTHLY',
  PerOrder = 'PER_ORDER'
}

export type GmIssue = {
  __typename?: 'GmIssue';
  accountId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  refunds: Array<GmRefund>;
  severity: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  vendorCharges: Array<GmVendorCharge>;
  vendorId: Scalars['Int']['output'];
};

export type GmIssueInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  refund?: InputMaybe<GmRefundInput>;
  severity: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  vendorCharge?: InputMaybe<GmVendorChargeInput>;
};

export type GmIssuesPaged = {
  __typename?: 'GmIssuesPaged';
  data: Array<GmIssue>;
};

export enum GmItemPackaging {
  Both = 'both',
  Individual = 'individual',
  Sharing = 'sharing',
  Unknown = 'unknown'
}

export type GmItemSearchDateTimeInput = {
  date: Scalars['Int']['input'];
  hour?: InputMaybe<Scalars['Int']['input']>;
  minute?: InputMaybe<Scalars['Int']['input']>;
  month: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type GmItemSearchResult = {
  __typename?: 'GmItemSearchResult';
  permalink: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  supplierId: Scalars['Int']['output'];
  supplierName: Scalars['String']['output'];
};

export type GmMenuCategory = {
  __typename?: 'GmMenuCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type GmMenuCategoryInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

export type GmMenuItemDateSearchInput = {
  date: Scalars['Int']['input'];
  hour?: InputMaybe<Scalars['Int']['input']>;
  minute?: InputMaybe<Scalars['Int']['input']>;
  month: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type GmMenuItemFilters = {
  MenuItemAudience?: InputMaybe<MenuItemAudience>;
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryId?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDate?: InputMaybe<GmMenuItemDateSearchInput>;
  dietaries?: InputMaybe<Array<Scalars['String']['input']>>;
  ignoreDeliveryDate?: InputMaybe<Scalars['Boolean']['input']>;
  ignorePrivateItems?: InputMaybe<Scalars['Boolean']['input']>;
  isHot?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GmMenuItemSortingOptions = {
  categorySortPriority?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GmMenuItemStat = {
  __typename?: 'GmMenuItemStat';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type GmMenuItemStats = {
  __typename?: 'GmMenuItemStats';
  allergens: Array<GmMenuItemStat>;
  categories: Array<GmMenuItemStat>;
  dietaries: Array<GmMenuItemStat>;
};

export type GmMenuItems = {
  __typename?: 'GmMenuItems';
  cacheKeys: Maybe<Array<Scalars['String']['output']>>;
  items: Array<MenuItem>;
  pageInfo: PageInfo;
  stats: GmMenuItemStats;
};

export type GmOrder = {
  __typename?: 'GmOrder';
  account: Account;
  accountLocation: AccountLocation;
  addons: GmServiceAddons;
  allergens: Maybe<Array<Scalars['String']['output']>>;
  basketId: Scalars['String']['output'];
  budgetCode: Maybe<Scalars['String']['output']>;
  coupon: Maybe<Coupon>;
  currentStatus: GmOrderStatus;
  customName: Maybe<Scalars['String']['output']>;
  customerRefundBreakdown: GmOrderTaxBreakdown;
  deliveryDate: Scalars['String']['output'];
  deliveryFinish: Scalars['DateTime']['output'];
  deliveryInstructions: Maybe<Scalars['String']['output']>;
  deliveryStart: Scalars['DateTime']['output'];
  deliveryTimeSlot: Scalars['String']['output'];
  discountBreakdown: GmOrderTaxBreakdown;
  fees: Array<GmOrderFeeBreakdown>;
  format: Maybe<GmServiceFormat>;
  hasEnterpriseDiscount: Scalars['Boolean']['output'];
  headCount: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceAccount: Maybe<InvoiceAccount>;
  invoicingData: GmOrderInvoicingData;
  isCateringTeamOrder: Scalars['Boolean']['output'];
  isFirstOrderForUser: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use isCateringTeamOrder */
  isGroupOrder: Scalars['Boolean']['output'];
  isHighRisk: Scalars['Boolean']['output'];
  issues: GmIssuesPaged;
  logistics: GmServiceLogistics;
  margin: Margin;
  meetingRoom: Maybe<Scalars['String']['output']>;
  notes: Maybe<GmServiceNotes>;
  orderId: Scalars['String']['output'];
  orderItems: GmOrderItems;
  orderNotes: Maybe<Scalars['String']['output']>;
  orderNotesUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  orderTotalBreakdown: GmOrderTaxBreakdown;
  orderType: GmOrderType;
  paymentInstructions: Maybe<GmOrderPaymentInstructions>;
  paymentMethod: PaymentMethod;
  placedBy: Maybe<Scalars['String']['output']>;
  /** When this order was rated, or null if it has not been rated yet. */
  ratedAt: Maybe<Scalars['DateTime']['output']>;
  referenceFieldValues: Array<GmReferenceFieldValue>;
  rep: Scalars['Boolean']['output'];
  standingOrder: Maybe<StandingOrder>;
  subtotalExTax: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  thermalBox: Scalars['Boolean']['output'];
  user: User;
  /** Time and date at which a user can no longer edit the order */
  userEditCutOffTime: Scalars['DateTime']['output'];
  vendor: Vendor;
  vendorChargeBreakdown: GmOrderTaxBreakdown;
  vendorContact: Maybe<VendorContact>;
  vendorLocation: VendorLocation;
  vendorPickupTime: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type GmOrderBankAccountData = {
  __typename?: 'GmOrderBankAccountData';
  bankName: Maybe<Scalars['String']['output']>;
  bic: Maybe<Scalars['String']['output']>;
  iban: Maybe<Scalars['String']['output']>;
};

export type GmOrderFeeBreakdown = {
  __typename?: 'GmOrderFeeBreakdown';
  calculatedByPercentage: Maybe<Scalars['Float']['output']>;
  code: GmOrderFeeCode;
  description: Scalars['String']['output'];
  isCustom: Maybe<Scalars['Boolean']['output']>;
  taxRate: Scalars['Float']['output'];
  taxValue: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalExTax: Scalars['Int']['output'];
};

export enum GmOrderFeeCode {
  CreditCard = 'creditCard',
  Delivery = 'delivery',
  Product = 'product'
}

export type GmOrderInvoicingData = {
  __typename?: 'GmOrderInvoicingData';
  deferredCustomerInvoiceNumber: Maybe<Scalars['String']['output']>;
  flexDeferredCustomerOrderId: Maybe<Scalars['String']['output']>;
  flexDeferredSupplierOrderId: Maybe<Scalars['String']['output']>;
};

export type GmOrderItem = {
  __typename?: 'GmOrderItem';
  addedBy: Maybe<User>;
  addedByUserId: Maybe<Scalars['Int']['output']>;
  commissionRate: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  descriptionLong: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCustom: Scalars['Boolean']['output'];
  liveMenuItem: Maybe<MenuItem>;
  name: Scalars['String']['output'];
  note: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  orderItemOptions: Array<GmOrderItemOption>;
  pendingEditConfirmation: Scalars['Boolean']['output'];
  price: Scalars['Int']['output'];
  priceExTax: Scalars['Int']['output'];
  priceTaxValue: Scalars['Int']['output'];
  priceVendor: Scalars['Int']['output'];
  priceVendorExTax: Scalars['Int']['output'];
  priceVendorExTaxExCom: Scalars['Int']['output'];
  priceVendorTaxValue: Scalars['Int']['output'];
  qty: Scalars['Int']['output'];
  quantityAdjustable: Scalars['Boolean']['output'];
  servings: Maybe<Scalars['Int']['output']>;
  subtotal: Scalars['Int']['output'];
  subtotalExTax: Scalars['Int']['output'];
  subtotalTaxValue: Scalars['Int']['output'];
  taxRate: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GmOrderItemOption = {
  __typename?: 'GmOrderItemOption';
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  liveMenuItem: Maybe<MenuItem>;
  name: Scalars['String']['output'];
  optionCategoryId: Scalars['String']['output'];
  optionReference: Scalars['String']['output'];
  optionType: OrderedItemOptionType;
  orderId: Scalars['Int']['output'];
  orderItemId: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  priceExTax: Scalars['Int']['output'];
  priceTaxValue: Scalars['Int']['output'];
  priceVendor: Scalars['Int']['output'];
  priceVendorExTax: Scalars['Int']['output'];
  priceVendorExTaxExCom: Scalars['Int']['output'];
  qty: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
  subtotalExTax: Scalars['Float']['output'];
  subtotalTaxValue: Scalars['Int']['output'];
  taxRate: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GmOrderItems = {
  __typename?: 'GmOrderItems';
  items: Array<GmOrderItem>;
};

export type GmOrderLite = {
  __typename?: 'GmOrderLite';
  accountId: Scalars['String']['output'];
  accountLocationCity: Scalars['String']['output'];
  accountLocationCountry: Scalars['String']['output'];
  accountLocationLine1: Maybe<Scalars['String']['output']>;
  accountLocationLine2: Maybe<Scalars['String']['output']>;
  accountLocationLine3: Maybe<Scalars['String']['output']>;
  accountLocationPostalCode: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  deliveryDate: Scalars['String']['output'];
  deliveryTimeSlot: Scalars['String']['output'];
  headCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isCateringTeamOrder: Scalars['Boolean']['output'];
  isFirstOrderForUser: Scalars['Boolean']['output'];
  /** @deprecated use isCateringTeamOrder */
  isGroupOrder: Scalars['Boolean']['output'];
  orderId: Scalars['String']['output'];
  orderTotal: Scalars['Float']['output'];
  paymentMethod: PaymentMethod;
  placedAsGuest: Scalars['Boolean']['output'];
  tenantName: Scalars['String']['output'];
  userEditCutoffTime: Scalars['Date']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
  vendorCurrency: Scalars['String']['output'];
  vendorId: Scalars['String']['output'];
  vendorIsPantry: Scalars['Boolean']['output'];
  vendorName: Scalars['String']['output'];
};

export type GmOrderPaged = {
  __typename?: 'GmOrderPaged';
  data: Array<GmOrder>;
  pageInfo: PageInfo;
};

export type GmOrderPaymentInstructions = {
  __typename?: 'GmOrderPaymentInstructions';
  bankAccountData: Maybe<GmOrderBankAccountData>;
};

export type GmOrderPdfInput = {
  basketId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderType: GmOrderPdfInputOrderType;
  pdfType: GmOrderPdfInputPdfType;
};

export enum GmOrderPdfInputOrderType {
  Draft = 'draft',
  Placed = 'placed'
}

export enum GmOrderPdfInputPdfType {
  Menu = 'menu',
  Summary = 'summary'
}

export type GmOrderPdfResponse = {
  __typename?: 'GmOrderPdfResponse';
  url: Scalars['String']['output'];
};

export enum GmOrderPricingAudience {
  Customer = 'customer',
  VendorPostCommission = 'vendorPostCommission',
  VendorPreCommission = 'vendorPreCommission'
}

export type GmOrderQueryOptions = {
  pricingAudience?: InputMaybe<GmOrderPricingAudience>;
};

export type GmOrderStatus = {
  __typename?: 'GmOrderStatus';
  cancellationNote: Maybe<Scalars['String']['output']>;
  cancellationReason: Maybe<Scalars['String']['output']>;
  cancelledByName: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type GmOrderTaxBreakdown = {
  __typename?: 'GmOrderTaxBreakdown';
  taxRateTotals: Array<GmOrderTaxRateTotal>;
  taxValue: Scalars['Int']['output'];
  totalExTax: Scalars['Int']['output'];
  totalIncTax: Scalars['Int']['output'];
};

export type GmOrderTaxRateTotal = {
  __typename?: 'GmOrderTaxRateTotal';
  rate: Scalars['Float']['output'];
  taxValue: Scalars['Int']['output'];
  totalExTax: Scalars['Int']['output'];
  totalIncTax: Scalars['Int']['output'];
};

export enum GmOrderType {
  BespokeEvents = 'bespokeEvents',
  OfflineMealPlan = 'offlineMealPlan',
  OnsiteKitchen = 'onsiteKitchen',
  PantryFill = 'pantryFill',
  PopUps = 'popUps',
  ProductFees = 'productFees',
  ProductFeesCatering = 'productFeesCatering',
  ProductFeesCloudCanteen = 'productFeesCloudCanteen',
  ProductFeesPantry = 'productFeesPantry',
  Seasonal = 'seasonal',
  Staffing = 'staffing',
  Standard = 'standard'
}

export type GmOrdersDeliveryTimeFilter = {
  condition: GmOrdersDeliveryTimeFilterCondition;
  value: Scalars['DateTime']['input'];
};

export enum GmOrdersDeliveryTimeFilterCondition {
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte'
}

export type GmOrdersFilters = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryTime?: InputMaybe<GmOrdersDeliveryTimeFilter>;
  deliveryTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  globalSearch?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
  vendorLocationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GmOrdersSortBy = {
  order: GmOrdersSortOrder;
  term: GmOrdersSortTerm;
};

export enum GmOrdersSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum GmOrdersSortTerm {
  DeliveryTime = 'deliveryTime'
}

export type GmReferenceFieldOption = {
  __typename?: 'GmReferenceFieldOption';
  id: Scalars['Int']['output'];
  option: Scalars['String']['output'];
  orderPriority: Scalars['Int']['output'];
  orderReferenceFieldId: Scalars['Int']['output'];
};

export type GmReferenceFieldValue = {
  __typename?: 'GmReferenceFieldValue';
  description: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  fieldType: ReferenceFieldType;
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Maybe<Array<GmReferenceFieldOption>>;
  orderReferenceFieldId: Scalars['Int']['output'];
  referenceFieldId: Scalars['Int']['output'];
  referenceFieldValueId: Maybe<Scalars['Int']['output']>;
  value: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type GmRefund = {
  __typename?: 'GmRefund';
  accountId: Scalars['Int']['output'];
  fixedAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  notes: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
  readOnly: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
};

export type GmRefundInput = {
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  issueRefund?: InputMaybe<Scalars['Boolean']['input']>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  taxRate: Scalars['Float']['input'];
};

export type GmServiceAddonsInput = {
  napkins: Scalars['Boolean']['input'];
  plates: Scalars['Boolean']['input'];
  service?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GmServiceFormatInput {
  Individual = 'individual',
  Sharing = 'sharing'
}

export type GmServiceLocation = AccountLocation | Address | NewAccountLocation;

export type GmServiceLocationInput = {
  accountLocation?: InputMaybe<AccountLocationInput>;
  address?: InputMaybe<AddressInput>;
};

export type GmServiceLogistics = {
  __typename?: 'GmServiceLogistics';
  customDeliveryFee: Maybe<Scalars['Int']['output']>;
  deliveryBy: Maybe<DeliveryBy>;
  internalNote: Maybe<Scalars['String']['output']>;
  transport: Maybe<Scalars['String']['output']>;
};

export type GmServiceLogisticsInput = {
  customDeliveryFee?: InputMaybe<Scalars['Int']['input']>;
  deliveryBy?: InputMaybe<DeliveryBy>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  transport?: InputMaybe<Scalars['String']['input']>;
};

export type GmServiceNotesInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  cart?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type GmServiceOptionsInput = {
  addons?: InputMaybe<GmServiceAddonsInput>;
  budgetCode?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<GmServiceFormatInput>;
  isHighRisk?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<GmServiceNotesInput>;
  rep?: InputMaybe<Scalars['Boolean']['input']>;
  thermalBox?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GmServiceSettings = {
  __typename?: 'GmServiceSettings';
  account: Maybe<AvailabilitiesAccount>;
  additionalCorrespondents: Maybe<Array<Scalars['String']['output']>>;
  billingAddress: Maybe<GmServiceLocation>;
  billingAddressId: Maybe<Scalars['Int']['output']>;
  billingAddressSameAsDelivery: Scalars['Boolean']['output'];
  customProductFeePercentage: Maybe<Scalars['Float']['output']>;
  deliveryDate: Scalars['String']['output'];
  deliveryInstructions: Maybe<Scalars['String']['output']>;
  deliveryTimeSlot: Scalars['String']['output'];
  emmaAlgorithmResponseId: Maybe<Scalars['String']['output']>;
  emmaAutomationTracking: Maybe<EmmaAutomationTracking>;
  emmaFormResponseId: Maybe<Scalars['String']['output']>;
  feedrAdminApproved: Maybe<Scalars['Boolean']['output']>;
  feedrCreated: Maybe<Scalars['Boolean']['output']>;
  headCount: Scalars['Int']['output'];
  invoiceAccount: Maybe<InvoiceAccount>;
  invoiceAccountId: Maybe<Scalars['Int']['output']>;
  isGuestBasket: Maybe<Scalars['Boolean']['output']>;
  location: Maybe<GmServiceLocation>;
  meetingRoom: Maybe<Scalars['String']['output']>;
  orderType: Maybe<GmOrderType>;
  paymentMethod: Maybe<PaymentMethod>;
  placedBy: Maybe<Scalars['String']['output']>;
  placedByManuallyEdited: Maybe<Scalars['Boolean']['output']>;
  referenceFieldValues: Maybe<Array<GmReferenceFieldValue>>;
  tenantId: Scalars['String']['output'];
  vendor: AvailabilitiesVendor;
  vendorPickupTime: Maybe<Scalars['String']['output']>;
};

export type GmServiceSettingsInput = {
  account?: InputMaybe<AvailabilitiesAccountInput>;
  basketSource?: InputMaybe<BasketSource>;
  billingAddress?: InputMaybe<GmServiceLocationInput>;
  billingAddressId?: InputMaybe<Scalars['Int']['input']>;
  billingAddressSameAsDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  customProductFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  deliveryDate: Scalars['String']['input'];
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  deliveryTimeSlot: Scalars['String']['input'];
  emmaAlgorithmResponseId?: InputMaybe<Scalars['String']['input']>;
  emmaAutomationTracking?: InputMaybe<EmmaAutomationTrackingInput>;
  emmaFormResponseId?: InputMaybe<Scalars['String']['input']>;
  feedrAdminApproved?: InputMaybe<Scalars['Boolean']['input']>;
  feedrCreated?: InputMaybe<Scalars['Boolean']['input']>;
  headCount: Scalars['Int']['input'];
  invoiceAccountId?: InputMaybe<Scalars['Int']['input']>;
  location: GmServiceLocationInput;
  meetingRoom?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<GmOrderType>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  placedBy?: InputMaybe<Scalars['String']['input']>;
  placedByManuallyEdited?: InputMaybe<Scalars['Boolean']['input']>;
  referenceFieldValues?: InputMaybe<Array<GmReferenceFieldValueInput>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<AvailabilitiesVendorInput>;
  vendorPickupTime?: InputMaybe<Scalars['String']['input']>;
};

export type GmValidationError = {
  __typename?: 'GmValidationError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GmVendorCharge = {
  __typename?: 'GmVendorCharge';
  fixedAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  notes: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
  vendorId: Scalars['Int']['output'];
};

export type GmVendorChargeInput = {
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  taxRate: Scalars['Float']['input'];
};

export type GoogleGeocode = {
  __typename?: 'GoogleGeocode';
  address_components: Array<AddressComponent>;
  formatted_address: Scalars['String']['output'];
  geometry: GoogleGeometry;
  place_id: Scalars['String']['output'];
  types: Array<Scalars['String']['output']>;
};

export type GoogleGeometry = {
  __typename?: 'GoogleGeometry';
  location: Location;
  viewport: Viewport;
};

export type GroupedCcOrderItem = {
  __typename?: 'GroupedCCOrderItem';
  id: Scalars['ID']['output'];
  orderItems: Array<CcOrderItem>;
  supplierOrder: CcSupplierOrder;
};

export type GroupedCcOrderItemByDateInput = {
  date: Scalars['DateTime']['input'];
};

/**
 * Order items grouped by vendor for multi-vendor order display.
 * Each group contains all items from a single vendor along with the vendor information
 * and the associated supplier order details.
 */
export type GroupedCcOrderItemsByVendor = {
  __typename?: 'GroupedCCOrderItemsByVendor';
  /** Order items from this vendor */
  items: Array<CcOrderItem>;
  /** Supplier order for this vendor */
  supplierOrder: CcSupplierOrder;
  /** The vendor for this group of items */
  vendor: Vendor;
};

export type HeadCountRange = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type HeadCountRanges = {
  __typename?: 'HeadCountRanges';
  less50: Maybe<Scalars['Int']['output']>;
  less100: Maybe<Scalars['Int']['output']>;
  less500: Maybe<Scalars['Int']['output']>;
  less1000: Maybe<Scalars['Int']['output']>;
  more1000: Maybe<Scalars['Int']['output']>;
};

export type InitiateCcOrderInput = {
  date: Scalars['DateTime']['input'];
  items: Array<InitiateCcOrderItemInput>;
  meal: Scalars['String']['input'];
  minimumPaymentValue?: InputMaybe<Scalars['Int']['input']>;
  orderSource?: InputMaybe<CcOrderSource>;
  paymentCurrency?: InputMaybe<Scalars['String']['input']>;
  timeslotStart: Scalars['DateTime']['input'];
  topupValue?: InputMaybe<Scalars['Int']['input']>;
};

export type InitiateCcOrderItemInput = {
  coreId: Scalars['String']['input'];
  options?: InputMaybe<Array<InitiateCcOrderItemOptionInput>>;
  quantity: Scalars['Int']['input'];
  submenuId: Scalars['String']['input'];
  variationId: Scalars['String']['input'];
  vendorLocationId: Scalars['String']['input'];
};

export type InitiateCcOrderItemOptionInput = {
  optionCategoryId: Scalars['String']['input'];
  optionItemId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type InitiateCcOrderResponse = {
  __typename?: 'InitiateCCOrderResponse';
  progressId: Scalars['ID']['output'];
};

export type InitiateInvoiceCardPaymentResult = {
  __typename?: 'InitiateInvoiceCardPaymentResult';
  authToken: Scalars['JWT']['output'];
};

export type InitiatePaymentInput = {
  /**
   * The unique identifier for the entity that will receive the payment.
   * e.g. FEEDRUK
   */
  billingEntityCode: Scalars['NonEmptyString']['input'];
  currency: Currency;
  /** Lines of text to be displayed to the user in the payment page */
  descriptions?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  expireAfterSeconds: Scalars['Int']['input'];
  /** Whether the payment is a hold rather than a charge. Payment holds are not captured automatically. */
  hold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Line items to be displayed to the user in the payment page */
  lineItems?: InputMaybe<Array<LineItemInput>>;
  /**
   * Identifier of the product the user is paying for
   * e.g. "INV-12345" or "CC-12345"
   */
  productIdentifier?: InputMaybe<Scalars['NonEmptyString']['input']>;
  /**
   * Name of the product the user is paying for
   * e.g. "GM Order" or "Invoice"
   */
  productType?: InputMaybe<Scalars['NonEmptyString']['input']>;
  /** URL to redirect the user to if payment succeeds */
  successRedirectUrl: Scalars['URL']['input'];
  /** URL to send a POST request to if payments succeeds */
  successWebhookUrl?: InputMaybe<Scalars['URL']['input']>;
  total: Scalars['PositiveInt']['input'];
  userId: Scalars['ID']['input'];
};

export type InitiatePaymentResult = {
  __typename?: 'InitiatePaymentResult';
  authToken: Scalars['JWT']['output'];
  payment: Payment;
};

export type InstantGmAllOrdersWithItemsInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRangeTypeInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type InternalOriginAuthOverrideInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  adminId?: InputMaybe<Scalars['Int']['input']>;
  sub?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  vendorContactId?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['Int']['input']>;
};

export type Invoice = {
  additionalTotal: Scalars['Float']['output'];
  additionalTotalExVat: Scalars['Float']['output'];
  additionalTotalVat: Scalars['Float']['output'];
  additionalVatSummary: Array<VatSummary>;
  amountDue: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  asset: Maybe<Asset>;
  assets: Array<Asset>;
  billingDetails: BillingDetails;
  billingEntity: BillingEntity;
  budgetCode: Maybe<Scalars['String']['output']>;
  canApprove: Scalars['Boolean']['output'];
  canCancel: Scalars['Boolean']['output'];
  canPay: Scalars['Boolean']['output'];
  currency: Currency;
  dueDate: Scalars['DateTime']['output'];
  friendlyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAlreadyApproved: Scalars['Boolean']['output'];
  issueDate: Maybe<Scalars['DateTime']['output']>;
  items: InvoiceItemsPaged;
  overdue: Scalars['Boolean']['output'];
  paymentHistory: Array<PaymentHistory>;
  paymentStatus: PaymentStatus;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  status: InvoiceStatus;
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalQuantity: Scalars['Int']['output'];
  totalVat: Scalars['Float']['output'];
  type: InvoiceType;
  vatRegion: VatRegion;
  vatSummary: Array<VatSummary>;
};


export type InvoiceAdditionalTotalArgs = {
  checkDelivery: InputMaybe<Scalars['Boolean']['input']>;
};


export type InvoiceAdditionalTotalVatArgs = {
  checkDelivery: InputMaybe<Scalars['Boolean']['input']>;
};


export type InvoiceAdditionalVatSummaryArgs = {
  checkDelivery: InputMaybe<Scalars['Boolean']['input']>;
};


export type InvoiceAssetArgs = {
  input: AssetSearchInput;
};


export type InvoiceItemsArgs = {
  input: InputMaybe<InvoiceItemsInput>;
};

export type InvoiceAccount = {
  __typename?: 'InvoiceAccount';
  /** The account id associated to the invoice account */
  accountId: Scalars['ID']['output'];
  /** Email address associated with account */
  additionalEmails: Maybe<Array<Scalars['String']['output']>>;
  /** Approved: The invoice account has been approved */
  approved: Maybe<Scalars['Boolean']['output']>;
  /** If customer should be invoiced (flex) automatically */
  autoInvoice: Maybe<Scalars['Boolean']['output']>;
  /** If the account should auto pay any and all invoices (default: false) */
  autoPay: Maybe<Scalars['Boolean']['output']>;
  /** business number */
  businessNumber: Maybe<Scalars['String']['output']>;
  /** The city of the invoice account */
  city: Scalars['String']['output'];
  /** The country of the invoice account */
  country: Maybe<Scalars['String']['output']>;
  /** Email address associated with account */
  email: Maybe<Scalars['String']['output']>;
  /** First name of invoice account contact */
  firstName: Maybe<Scalars['String']['output']>;
  /** The id of the customer associated to the flex invoice account */
  flexDeferredCustomerId: Maybe<Scalars['ID']['output']>;
  /** The unique identifier of the invoice account */
  id: Scalars['ID']['output'];
  /** If invoice should be split by pantry order service type */
  invoiceByPantryOrder: Maybe<Scalars['Boolean']['output']>;
  /** If invoice should be split by standing order */
  invoiceByStandingOrder: Maybe<Scalars['Boolean']['output']>;
  /** The invoice consolidation frequency */
  invoiceConsolidationFrequency: Maybe<InvoiceConsolidationFrequency>;
  /** The invoice consolidation type */
  invoiceConsolidationType: Maybe<InvoiceConsolidationType>;
  /** If invoice should be per contact */
  invoicePerContact: Maybe<Scalars['Boolean']['output']>;
  /** Specifies the type of email recipient when the consolidation type is set to per order */
  invoicePerOrderRecipientType: Maybe<InvoicePerOrderRecipientType>;
  /** If invoice should be per reference field */
  invoicePerReferenceField: Maybe<Scalars['Boolean']['output']>;
  /** If invoice should be per order type */
  invoicePerType: Maybe<Scalars['Boolean']['output']>;
  /** Is the invoice account the defaultapproved */
  isDefault: Scalars['Boolean']['output'];
  /** The name of the invoice account */
  label: Maybe<Scalars['String']['output']>;
  /** Last name of invoice account contact */
  lastName: Maybe<Scalars['String']['output']>;
  /** The first line of the invoice account address */
  line1: Scalars['String']['output'];
  /** The second line of the invoice account address */
  line2: Maybe<Scalars['String']['output']>;
  /** Locale of the invoice account contact */
  locale: Scalars['String']['output'];
  /** Order reference fields */
  orderReferenceFields: Array<OrderReferenceField>;
  /** Phone number for invoice account contact */
  phone: Maybe<Scalars['String']['output']>;
  /** The postcode of the invoice account */
  postcode: Scalars['String']['output'];
  /** Reference field labels selected for the invoice account */
  referenceFieldLabelsForInvoice: Maybe<Array<Scalars['String']['output']>>;
  /** Rules for standing order invoicing */
  standingOrderInvoicingRules: Maybe<StandingOrderInvoicingRules>;
  /** VAT number of account */
  vat: Maybe<Scalars['String']['output']>;
  /** VAT region */
  vatRegion: VatRegion;
  /** VAT region id */
  vatRegionId: Scalars['Int']['output'];
};

export enum InvoiceConsolidationFrequency {
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum InvoiceConsolidationType {
  EndOfPeriod = 'EndOfPeriod',
  PerOrder = 'PerOrder'
}

export type InvoiceFiltersInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Scalars['String']['input']>;
  dateEnd?: InputMaybe<Scalars['String']['input']>;
  dateStart?: InputMaybe<Scalars['String']['input']>;
  excludeStatus?: InputMaybe<Array<InvoiceStatus>>;
  gmCreatorOrPlacerUserId?: InputMaybe<Scalars['ID']['input']>;
  gmOrderId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instant?: InputMaybe<Scalars['Boolean']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  paymentType?: InputMaybe<PaymentType>;
  placedBy?: InputMaybe<Scalars['String']['input']>;
  sourceFromSystemFeedr?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  type?: InputMaybe<InvoiceType>;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  additional: Scalars['Boolean']['output'];
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPromotionItem: Scalars['Boolean']['output'];
  optionId: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
  unitDiscount: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  vatRate: Scalars['Float']['output'];
};

export type InvoiceItemInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  foodSaleDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  unitDiscount?: InputMaybe<Scalars['Float']['input']>;
  unitPrice: Scalars['Float']['input'];
  vatBandId: Scalars['String']['input'];
  vatRate: Scalars['Float']['input'];
};

export type InvoiceItemsDeliveryInput = {
  checkDelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceItemsInput = {
  additional?: InputMaybe<Scalars['Boolean']['input']>;
  checkDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type InvoiceItemsPaged = {
  __typename?: 'InvoiceItemsPaged';
  items: Array<InvoiceItem>;
  pageInfo: PageInfo;
};

export type InvoiceOrder = {
  __typename?: 'InvoiceOrder';
  budgetCode: Maybe<Scalars['String']['output']>;
  contact: Scalars['String']['output'];
  customerName: Maybe<Scalars['String']['output']>;
  deferredCustomerInvoiceId: Maybe<Scalars['ID']['output']>;
  deferredCustomerInvoiceNumber: Maybe<Scalars['String']['output']>;
  deliveryDate: Scalars['DateTime']['output'];
  deliveryTimezone: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  referenceFields: Maybe<Array<InvoiceOrderReferenceField>>;
  shippingAddress: Scalars['String']['output'];
  supplier: Scalars['String']['output'];
  total: Scalars['String']['output'];
};

export type InvoiceOrderByInput = {
  direction?: InputMaybe<OrderDirection>;
  property?: InputMaybe<OrderByProperties>;
};

export type InvoiceOrderFiltersInput = {
  /**
   * Filters to all flex customer targets belonging to this account, fanning
   * the query out per target and summing results. Designed for count-style
   * consumption (pass `limit: 1` and read `pageInfo.count`, which is the sum
   * across the account's deferred customers) rather than as a browsable list:
   * when an account has multiple deferred customers, `limit`/`offset` are
   * applied independently to each customer's results before concatenation, so
   * paging through `items` is not stable for UI pagination.
   */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  autoInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  deferredCustomerId?: InputMaybe<Scalars['ID']['input']>;
  deferredCustomerInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  deferredCustomerOrderId?: InputMaybe<Scalars['ID']['input']>;
  deliveryDateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryDateStart?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceConsolidationFrequency?: InputMaybe<InvoiceConsolidationFrequency>;
  invoiceConsolidationType?: InputMaybe<InvoiceConsolidationType>;
  number?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  uninvoiced?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InvoiceOrderForInput {
  All = 'ALL',
  Customer = 'CUSTOMER',
  Supplier = 'SUPPLIER'
}

export type InvoiceOrderInput = {
  /**
   * Required unless filters.accountId is given, in which case the country is
   * derived from the account's flex customer targets. Still fails (fail-closed)
   * when no country can be derived (e.g. targets without a vat region and no
   * countryCode supplied), or when a supplied countryCode contradicts the
   * derived one.
   */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<InvoiceOrderFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<InvoiceOrderOrderByInput>;
  /**
   * Tenant scope for private-queries API-key callers ONLY (required with a valid
   * x-api-key; ignored for authenticated callers, whose tenant comes from auth).
   */
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type InvoiceOrderLineItem = {
  __typename?: 'InvoiceOrderLineItem';
  commission: Maybe<Scalars['Float']['output']>;
  commissionType: Maybe<Scalars['String']['output']>;
  glCode: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  taxPercentage: Scalars['Float']['output'];
};

export type InvoiceOrderOrderByInput = {
  contact?: InputMaybe<Sort>;
  customerName?: InputMaybe<Sort>;
  deliveryDate?: InputMaybe<Sort>;
  number?: InputMaybe<Sort>;
  referenceField?: InputMaybe<InvoiceOrderReferenceFieldOrderByInput>;
  shippingAddress?: InputMaybe<Sort>;
  supplier?: InputMaybe<Sort>;
};

export type InvoiceOrderReferenceField = {
  __typename?: 'InvoiceOrderReferenceField';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type InvoiceOrderReferenceFieldOrderByInput = {
  label: Scalars['String']['input'];
  sort: Sort;
};

export type InvoiceOrdersPaged = {
  __typename?: 'InvoiceOrdersPaged';
  items: Array<Maybe<InvoiceOrder>>;
  pageInfo: PageInfo;
};

export enum InvoicePerOrderRecipientType {
  InvoiceRecipients = 'INVOICE_RECIPIENTS',
  Requester = 'REQUESTER',
  RequesterAndInvoiceRecipients = 'REQUESTER_AND_INVOICE_RECIPIENTS'
}

export enum InvoiceStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Void = 'VOID'
}

export enum InvoiceType {
  Cc = 'CC',
  Gm = 'GM'
}

export type InvoicesCombinedPaged = {
  __typename?: 'InvoicesCombinedPaged';
  items: Array<CombinedInvoice>;
  pageInfo: PageInfo;
};

export type InvoicesPaged = {
  __typename?: 'InvoicesPaged';
  items: Array<Invoice>;
  pageInfo: PageInfo;
};

export type ItemSearchMatchingItem = {
  __typename?: 'ItemSearchMatchingItem';
  /** MongoDB item ID */
  id: Scalars['String']['output'];
  /** Display name of the matching menu item */
  name: Scalars['String']['output'];
};

export type ItemSearchMetadata = {
  __typename?: 'ItemSearchMetadata';
  /** Individual menu items that matched the search query */
  items: Array<ItemSearchMatchingItem>;
  /** Rank score from the item search Lambda (1 = best match) */
  rank: Scalars['Int']['output'];
  /** Human-readable explanation of why this vendor matched the search */
  reason: Scalars['String']['output'];
};

export enum Language {
  De = 'de',
  En = 'en',
  It = 'it',
  Nl = 'nl'
}

export type LanguageData = {
  __typename?: 'LanguageData';
  code: Language;
  label: Scalars['String']['output'];
};

export type LatestFlexConsolidationRunInput = {
  consolidationFrequency?: InputMaybe<FlexInvoiceConsolidationFrequency>;
  countryCode: Scalars['String']['input'];
  dateRange: DateRangeTypeInput;
};

export type LineItem = {
  __typename?: 'LineItem';
  amount: Scalars['Int']['output'];
  name: Scalars['NonEmptyString']['output'];
};

export type LineItemInput = {
  amount: Scalars['Int']['input'];
  name: Scalars['NonEmptyString']['input'];
};

export type ListInvoicesInput = {
  filters?: InputMaybe<InvoiceFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<InvoiceOrderByInput>;
};

export type ListVendorStatementsInput = {
  filters?: InputMaybe<VendorStatementFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VendorStatementOrderByInput>;
};

export type Location = {
  __typename?: 'Location';
  lat: Scalars['Int']['output'];
  lng: Scalars['Int']['output'];
};

export type LocationInput = {
  /** The latitude of the location */
  lat: Scalars['Float']['input'];
  /** The longitude of the location */
  lng: Scalars['Float']['input'];
};

export type LookupAddressResponse = {
  __typename?: 'LookupAddressResponse';
  locations: Array<AddressLocation>;
  queryResponse: Array<Scalars['String']['output']>;
};

export type MacrosInput = {
  carbs?: InputMaybe<Scalars['Float']['input']>;
  fat?: InputMaybe<Scalars['Float']['input']>;
  fibre?: InputMaybe<Scalars['Float']['input']>;
  kcal?: InputMaybe<Scalars['Float']['input']>;
  kj?: InputMaybe<Scalars['Float']['input']>;
  monounsaturates?: InputMaybe<Scalars['Float']['input']>;
  polyunsaturates?: InputMaybe<Scalars['Float']['input']>;
  protein?: InputMaybe<Scalars['Float']['input']>;
  salt?: InputMaybe<Scalars['Float']['input']>;
  saturates?: InputMaybe<Scalars['Float']['input']>;
  sugar?: InputMaybe<Scalars['Float']['input']>;
};

export type Margin = {
  __typename?: 'Margin';
  percentage: Scalars['Float']['output'];
  value: Scalars['Int']['output'];
};

export type MarkFlexInvoicesAsPaidInput = {
  countryCode: Scalars['String']['input'];
  filename?: InputMaybe<Scalars['String']['input']>;
  invoiceNumbers: Array<Scalars['String']['input']>;
};

export type MarkFlexInvoicesAsPaidResult = {
  __typename?: 'MarkFlexInvoicesAsPaidResult';
  batchId: Scalars['String']['output'];
  failedCount: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  totalInvoices: Scalars['Int']['output'];
};

export type MarketplaceBanding = {
  __typename?: 'MarketplaceBanding';
  message: Scalars['String']['output'];
  status: MarketplaceBandingStatus;
};

export enum MarketplaceBandingStatus {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export enum Meal {
  Breakfast = 'breakfast',
  Dinner = 'dinner',
  Lunch = 'lunch'
}

export enum MealType {
  Breakfast = 'breakfast',
  Dinner = 'dinner',
  Lunch = 'lunch'
}

export type MealTypes = {
  __typename?: 'MealTypes';
  breakfast: Maybe<Scalars['Int']['output']>;
  dinner: Maybe<Scalars['Int']['output']>;
  lunch: Maybe<Scalars['Int']['output']>;
};

export type MenuCsvDownload = {
  __typename?: 'MenuCsvDownload';
  /** Menu items in CSV format, including headers, for bulk download purposes */
  csvData: Scalars['String']['output'];
  /** Number of menu items included in the csvData */
  itemCount: Scalars['Int']['output'];
};

export enum MenuCsvDownloadDishType {
  Groups = 'groups',
  Items = 'items',
  Options = 'options'
}

export type MenuCsvDownloadInput = {
  dishType?: InputMaybe<MenuCsvDownloadDishType>;
  menuType: MenuCsvDownloadMenuType;
};

export enum MenuCsvDownloadMenuType {
  Drafts = 'drafts',
  InReview = 'inReview',
  Lives = 'lives'
}

export type MenuItem = {
  __typename?: 'MenuItem';
  _id: Scalars['ID']['output'];
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  alacalcFetchedAt: Maybe<Scalars['DateTime']['output']>;
  alacalcId: Maybe<Scalars['Int']['output']>;
  allergenAudit: Array<AllergenAudit>;
  allergenAuditSummary: AllergenAuditSummary;
  allergen_celery: Maybe<Scalars['Boolean']['output']>;
  allergen_cereals: Maybe<Scalars['Boolean']['output']>;
  allergen_crustaceans: Maybe<Scalars['Boolean']['output']>;
  allergen_eggs: Maybe<Scalars['Boolean']['output']>;
  allergen_fish: Maybe<Scalars['Boolean']['output']>;
  allergen_lupin: Maybe<Scalars['Boolean']['output']>;
  allergen_milk: Maybe<Scalars['Boolean']['output']>;
  allergen_molluscs: Maybe<Scalars['Boolean']['output']>;
  allergen_mustard: Maybe<Scalars['Boolean']['output']>;
  allergen_none: Maybe<Scalars['Boolean']['output']>;
  allergen_nuts: Maybe<Scalars['Boolean']['output']>;
  allergen_peanuts: Maybe<Scalars['Boolean']['output']>;
  allergen_sesame: Maybe<Scalars['Boolean']['output']>;
  allergen_soybeans: Maybe<Scalars['Boolean']['output']>;
  allergen_sulphur: Maybe<Scalars['Boolean']['output']>;
  allergens: Array<Allergen>;
  associatedStandingOrders: StandingOrdersPage;
  category: Maybe<Scalars['String']['output']>;
  centegraProductId: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  cuisineTag: Maybe<Scalars['String']['output']>;
  /** All price items by customerPriceType */
  customerPriceItems: Maybe<Array<CustomerPriceItem>>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  dietaries: Array<Dietary>;
  dietary_halal: Maybe<Scalars['Boolean']['output']>;
  dietary_highprotein: Maybe<Scalars['Boolean']['output']>;
  dietary_kosher: Maybe<Scalars['Boolean']['output']>;
  dietary_low_carbon: Maybe<Scalars['Boolean']['output']>;
  dietary_lowcarb: Maybe<Scalars['Boolean']['output']>;
  dietary_non_hfss: Maybe<Scalars['Boolean']['output']>;
  dietary_pescatarian: Maybe<Scalars['Boolean']['output']>;
  dietary_powerplant: Maybe<Scalars['Boolean']['output']>;
  dietary_refined_sugar: Maybe<Scalars['Boolean']['output']>;
  dietary_vegan: Maybe<Scalars['Boolean']['output']>;
  dietary_vegetarian: Maybe<Scalars['Boolean']['output']>;
  dietary_verylow_carbon: Maybe<Scalars['Boolean']['output']>;
  futureGmOrders: GmOrderPaged;
  group: Maybe<MenuItemGroup>;
  image: Maybe<Scalars['String']['output']>;
  /** @deprecated no longer needed */
  inReview: Maybe<Scalars['Boolean']['output']>;
  ingredients: Maybe<Scalars['String']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  isCombo: Maybe<Scalars['Boolean']['output']>;
  isHot: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `isModifierOnly` instead. */
  isMenuItem: Maybe<Scalars['Boolean']['output']>;
  isModifierOnly: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `isModifierOnly` instead. Name is changing to modifier rather than add-on / option and all menu items are also modifiers */
  isOption: Maybe<Scalars['Boolean']['output']>;
  /** Array of menu items for which this item is an option item for */
  isOptionFor: Array<MenuItem>;
  isVAT: Maybe<Scalars['Boolean']['output']>;
  kitchenStation: Maybe<Scalars['String']['output']>;
  legacyId: Maybe<Scalars['Int']['output']>;
  /** @deprecated no longer needed */
  locked: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated no longer needed */
  lockedTimestamp: Maybe<Scalars['DateTime']['output']>;
  macros_carbs: Maybe<Scalars['Float']['output']>;
  macros_fat: Maybe<Scalars['Float']['output']>;
  macros_fibre: Maybe<Scalars['Float']['output']>;
  macros_kcal: Maybe<Scalars['Float']['output']>;
  macros_kj: Maybe<Scalars['Float']['output']>;
  macros_monounsaturates: Maybe<Scalars['Float']['output']>;
  macros_polyunsaturates: Maybe<Scalars['Float']['output']>;
  macros_protein: Maybe<Scalars['Float']['output']>;
  macros_salt: Maybe<Scalars['Float']['output']>;
  macros_saturates: Maybe<Scalars['Float']['output']>;
  macros_sugar: Maybe<Scalars['Float']['output']>;
  /** The markup rate as a % */
  markupRate: Maybe<Scalars['Float']['output']>;
  mealTag: Maybe<Scalars['String']['output']>;
  meta: Maybe<MenuItemMeta>;
  migratedAt: Maybe<Scalars['DateTime']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /** The type of occasions the menu item is suitable for */
  occasions: Array<MenuItemOccasion>;
  options: Maybe<Array<Maybe<MenuItemOptions>>>;
  /** The price the vendor charges, inclusive of tax */
  price: Maybe<Scalars['Float']['output']>;
  /** The price the customer pays */
  priceCustomerFacing: Scalars['Float']['output'];
  /** The price the customer pays, exclusive of tax */
  priceCustomerFacingExTax: Scalars['Float']['output'];
  /** The price the vendor charges, exclusive of tax */
  priceExTax: Maybe<Scalars['Float']['output']>;
  proteins: Array<Protein>;
  publishedTimestamp: Maybe<Scalars['DateTime']['output']>;
  /** The reduced commission rate as a % */
  reducedCommissionRate: Maybe<Scalars['Float']['output']>;
  /** @deprecated no longer needed */
  requestDeleteTimestamp: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated no longer needed */
  requestToDelete: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated no longer needed */
  sentForApprovalTimestamp: Maybe<Scalars['DateTime']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  /** The standard commission rate as a % */
  standardCommissionRate: Maybe<Scalars['Float']['output']>;
  subAllergens: SubAllergens;
  sub_allergen_cereals: Maybe<SubAllergenCereals>;
  sub_allergen_nuts: Maybe<SubAllergenNuts>;
  suitability: Array<MenuItemSuitabilityOccasion>;
  /** External ids related to supplier */
  supplierExternalId: Maybe<SupplierExternalIdOutput>;
  supplierId: Scalars['Int']['output'];
  /** The tax rate expressed as a decimal */
  taxRate: Scalars['Float']['output'];
  /** The monetary tax value on the price the vendor charges */
  taxValue: Maybe<Scalars['Float']['output']>;
  translations: Maybe<Array<Translation>>;
  /** @deprecated no longer needed */
  unlockedTimestamp: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variations: Maybe<Array<MenuItemVariation>>;
  vatBand: Maybe<VatBand>;
  vatBandId: Maybe<Scalars['Int']['output']>;
  vendor: Vendor;
};


export type MenuItemAllergenAuditArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemAssociatedStandingOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemFutureGmOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemVariationsArgs = {
  varType: InputMaybe<Scalars['String']['input']>;
};

export enum MenuItemAudience {
  Customer = 'CUSTOMER',
  InternalAdmin = 'INTERNAL_ADMIN'
}

export type MenuItemCategory = {
  __typename?: 'MenuItemCategory';
  id: Scalars['ID']['output'];
  items: MenuItemsPaged;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


export type MenuItemCategoryItemsArgs = {
  input: MenuItemCategoryItemsInput;
};

export type MenuItemCategoryItemsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  manuallyReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemFiltersInput = {
  allergens?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  dietaries?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hasVatBand?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inReview?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeNonMenuItems?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isModifierOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  itemType?: InputMaybe<Array<MenuItemType>>;
  meal?: InputMaybe<Array<Meal>>;
  /**
   * Items missing ANY of the selected data kinds (OR semantics). Definitions are
   * shared with MenuStatistics.missing* so counts always match the overview chart.
   */
  missingData?: InputMaybe<Array<MenuItemMissingData>>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<ServiceType>;
  /**
   * Items matching ANY of the selected statuses (OR semantics). Each status means
   * exactly what isActive: true, isActive: false or isPrivate: true means alone,
   * and it replaces those two fields when set.
   */
  statuses?: InputMaybe<Array<MenuItemStatusFilter>>;
  subAllergens?: InputMaybe<Scalars['String']['input']>;
  variationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type MenuItemGroup = {
  __typename?: 'MenuItemGroup';
  allItemsReviewed: Scalars['Boolean']['output'];
  category: MenuItemCategory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  occasions: Array<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  sizes: Array<MenuItemGroupSize>;
  suitability: Array<MenuItemSuitabilityOccasion>;
  weight: Scalars['Float']['output'];
};

export type MenuItemGroupSize = {
  __typename?: 'MenuItemGroupSize';
  id: Scalars['ID']['output'];
  liveGmVariations: Array<MenuItemVariation>;
  minQty: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packaging: MenuItemGroupSizePackaging;
  servings: Scalars['Int']['output'];
};

export enum MenuItemGroupSizePackaging {
  Individual = 'INDIVIDUAL',
  Sharing = 'SHARING'
}

export type MenuItemGroupsInput = {
  allItemsReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemGroupsPaged = {
  __typename?: 'MenuItemGroupsPaged';
  groups: Array<MenuItemGroup>;
  pageInfo: PageInfo;
};

export type MenuItemIncDeleted = {
  __typename?: 'MenuItemIncDeleted';
  _id: Scalars['ID']['output'];
  item: MenuItem;
};

export type MenuItemMeta = {
  __typename?: 'MenuItemMeta';
  categoryConfidence: Maybe<Scalars['Float']['output']>;
  categoryReviewed: Maybe<Scalars['Boolean']['output']>;
};

export enum MenuItemMissingData {
  FoodGoals = 'foodGoals',
  Images = 'images',
  Nutritional = 'nutritional'
}

export enum MenuItemOccasion {
  AfternoonTea = 'afternoon_tea',
  Breakfast = 'breakfast',
  Dinner = 'dinner',
  Lunch = 'lunch',
  MorningTea = 'morning_tea'
}

export type MenuItemOptionCategoryInput = {
  categoryType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<OptionItemInput>>;
  maxQty?: InputMaybe<Scalars['Int']['input']>;
  minQty?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  optionType?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  printExtraLabel?: InputMaybe<Scalars['Boolean']['input']>;
  qtyPerPerson?: InputMaybe<Scalars['Int']['input']>;
};

export enum MenuItemOptionType {
  Numbers = 'numbers',
  Ticks = 'ticks'
}

export type MenuItemOptions = {
  __typename?: 'MenuItemOptions';
  _id: Scalars['ID']['output'];
  categoryType: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<Maybe<OptionItem>>>;
  maxQty: Maybe<Scalars['Int']['output']>;
  minQty: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  optionType: Maybe<MenuItemOptionType>;
  position: Maybe<Scalars['Int']['output']>;
  printExtraLabel: Maybe<Scalars['Boolean']['output']>;
  qtyPerPerson: Maybe<Scalars['Int']['output']>;
};

export type MenuItemOrderByInput = {
  direction: SortDirection;
  field: MenuItemSortField;
};

export type MenuItemPaged = {
  __typename?: 'MenuItemPaged';
  pageInfo: PageInfo;
  rows: Array<Maybe<MenuItem>>;
};

export type MenuItemPriceSyncStatusInput = {
  syncJobId: Scalars['ID']['input'];
};

export type MenuItemPriceSyncStatusResponse = {
  __typename?: 'MenuItemPriceSyncStatusResponse';
  batchesCompleted: Scalars['Int']['output'];
  estimatedItemsCompleted: Scalars['Int']['output'];
  finishTime: Maybe<Scalars['DateTime']['output']>;
  startTime: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  syncJobId: Scalars['ID']['output'];
};

export enum MenuItemSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type MenuItemStatistics = {
  __typename?: 'MenuItemStatistics';
  count: Scalars['Int']['output'];
  maxPrice: Scalars['Int']['output'];
  minPrice: Scalars['Int']['output'];
};

export enum MenuItemStatusFilter {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Private = 'PRIVATE'
}

export type MenuItemSuitabilityOccasion = {
  __typename?: 'MenuItemSuitabilityOccasion';
  occasion: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
};

export type MenuItemSuitabilityOccasionInput = {
  occasion: Scalars['String']['input'];
  rank: Scalars['Int']['input'];
  weight: Scalars['Float']['input'];
};

export type MenuItemTranslationDataInput = {
  key: Scalars['String']['input'];
  language: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemTranslationsInput = {
  data: Array<MenuItemTranslationDataInput>;
  defaultLanguage: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export enum MenuItemType {
  Drink = 'drink',
  Main = 'main',
  Side = 'side',
  Unknown = 'unknown'
}

export type MenuItemVariation = {
  __typename?: 'MenuItemVariation';
  _id: Scalars['ID']['output'];
  avgRating: Maybe<Scalars['Int']['output']>;
  categoryId: Maybe<Scalars['Int']['output']>;
  categoryIdArray: Maybe<Array<Scalars['Int']['output']>>;
  /** The core item the variation belongs to */
  coreLiveItem: Maybe<MenuItem>;
  /** All price items by customerPriceType */
  customerPriceItems: Maybe<Array<CustomerPriceItem>>;
  dailyStock: Maybe<Scalars['Int']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  discountPrice: Maybe<Scalars['Float']['output']>;
  feedrDiscountPrice: Maybe<Scalars['Float']['output']>;
  futureCcOrders: CcOrderItemsPaged;
  group: Maybe<MenuItemGroup>;
  internalAdminOnly: Maybe<Scalars['Boolean']['output']>;
  internalName: Maybe<Scalars['String']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  isBreakfast: Maybe<Scalars['Boolean']['output']>;
  isCombo: Maybe<Scalars['Boolean']['output']>;
  isDinner: Maybe<Scalars['Boolean']['output']>;
  isLunch: Maybe<Scalars['Boolean']['output']>;
  isPricePerHead: Maybe<Scalars['Boolean']['output']>;
  isPrivate: Maybe<Scalars['Boolean']['output']>;
  isPromo: Maybe<Scalars['Boolean']['output']>;
  isSampleBreakfast: Maybe<Scalars['Boolean']['output']>;
  isSampleDinner: Maybe<Scalars['Boolean']['output']>;
  isSampleLunch: Maybe<Scalars['Boolean']['output']>;
  /** The markup rate as a % */
  markupRate: Maybe<Scalars['Float']['output']>;
  /** The markup value in currency */
  markupValue: Scalars['Float']['output'];
  minQty: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  orderLimit: Maybe<Scalars['Int']['output']>;
  packaging: Maybe<GmItemPackaging>;
  piecesPerItem: Maybe<Scalars['Int']['output']>;
  popularity: Scalars['Int']['output'];
  position: Maybe<Scalars['Int']['output']>;
  /** The price the vendor charges */
  price: Maybe<Scalars['Float']['output']>;
  /** The price the customer pays */
  priceCustomerFacing: Scalars['Float']['output'];
  /** The price the customer pays, exclusive of tax */
  priceCustomerFacingExTax: Scalars['Float']['output'];
  /** The price the vendor charges, exclusive of tax */
  priceExTax: Maybe<Scalars['Float']['output']>;
  privateAccessAccountIdArray: Maybe<Array<Scalars['Int']['output']>>;
  privateAccessAccounts: Array<Account>;
  /** The reduced commission rate as a % */
  reducedCommissionRate: Maybe<Scalars['Float']['output']>;
  /** The reduced commission value in currency */
  reducedCommissionValue: Scalars['Float']['output'];
  servings: Maybe<Scalars['Float']['output']>;
  /** The standard commission rate as a % */
  standardCommissionRate: Maybe<Scalars['Float']['output']>;
  /** The standard commission value in currency */
  standardCommissionValue: Scalars['Float']['output'];
  /** The tax rate expressed as a decimal */
  taxRate: Scalars['Float']['output'];
  /** The monetary tax value on the price the vendor charges */
  taxValue: Maybe<Scalars['Float']['output']>;
  /** The monetary tax value on the price the customer pays */
  taxValueCustomerFacing: Scalars['Float']['output'];
  type: Maybe<Scalars['String']['output']>;
  varType: Maybe<Scalars['String']['output']>;
};


export type MenuItemVariationFutureCcOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemVariationInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  categoryIdArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  dailyStock?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalAdminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBreakfast?: InputMaybe<Scalars['Boolean']['input']>;
  isDinner?: InputMaybe<Scalars['Boolean']['input']>;
  isLunch?: InputMaybe<Scalars['Boolean']['input']>;
  isPricePerHead?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  markupRate?: InputMaybe<Scalars['Float']['input']>;
  minQuantity?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderLimit?: InputMaybe<Scalars['Int']['input']>;
  packaging?: InputMaybe<GmItemPackaging>;
  position?: InputMaybe<Scalars['Int']['input']>;
  priceExTax?: InputMaybe<Scalars['Int']['input']>;
  privateAccessAccountIdArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  reducedCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  servings?: InputMaybe<Scalars['Float']['input']>;
  standardCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  varType?: InputMaybe<Scalars['String']['input']>;
};

export type MenuItemsPaged = {
  __typename?: 'MenuItemsPaged';
  items: Maybe<Array<MenuItem>>;
  pageInfo: PageInfo;
};

export type MenuLastUpdatedAtInput = {
  serviceType?: InputMaybe<ServiceType>;
};

export type MenuStatistics = {
  __typename?: 'MenuStatistics';
  activeCcItems: Scalars['Int']['output'];
  activeGmItems: Scalars['Int']['output'];
  /**
   * Distinct active items across BOTH services. Unlike activeGmItems +
   * activeCcItems (which count per service and so double-count an item that has
   * both a catering and a canteen variation), this counts each active document
   * once. Use this for the whole-supplier "Active" figure (progress tracker,
   * dietary/allergen denominator).
   */
  activeItems: Scalars['Int']['output'];
  allMenuItemCount: Maybe<Scalars['Int']['output']>;
  /**
   * Breakdown of active menu items by allergen (only allergens with count > 0 are
   * meaningful to display; the "no known allergens" sentinel is excluded). All
   * other defined allergen keys are returned.
   */
  allergenBreakdown: Array<AllergenStat>;
  /**
   * Breakdown of active menu items by dietary tag (only tags with count > 0 are
   * meaningful to display; all defined dietary keys are returned).
   */
  dietaryBreakdown: Array<DietaryStat>;
  drinks: MenuItemStatistics;
  inDraft: Scalars['Int']['output'];
  inReview: Scalars['Int']['output'];
  /**
   * Canteen menu items that are published but inactive (isActive false or past
   * their active-to date).
   */
  inactiveCcItems: Scalars['Int']['output'];
  /** Null when the vendor has never published a menu (no draft with a publish timestamp). */
  lastPublished: Maybe<Scalars['DateTime']['output']>;
  mains: MenuItemStatistics;
  missingFoodGoals: Scalars['Int']['output'];
  missingImages: Scalars['Int']['output'];
  missingNutrional: Scalars['Int']['output'];
  publishedMenuItemCount: Maybe<Scalars['Int']['output']>;
  sides: MenuItemStatistics;
  /** Total menu items across all statuses (from the draft superset). */
  totalItems: Scalars['Int']['output'];
  vendorId: Scalars['Int']['output'];
};

export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  body: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  dynamicMessageTemplateType: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDynamic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenantId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type MessageTemplatePaged = {
  __typename?: 'MessageTemplatePaged';
  pageInfo: PageInfo;
  rows: Array<MessageTemplate>;
};

export type MessageTemplatesFilters = {
  id?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type ModifierCategory = {
  __typename?: 'ModifierCategory';
  _id: Scalars['ID']['output'];
  draftItems: Array<Maybe<OptionItem>>;
  liveItems: Array<OptionItem>;
  maxQty: Maybe<Scalars['Int']['output']>;
  minQty: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  optionType: MenuItemOptionType;
  qtyPerPerson: Maybe<Scalars['Int']['output']>;
  vendorId: Scalars['Int']['output'];
};

export type ModifierCategoryInput = {
  maxQty?: InputMaybe<Scalars['Int']['input']>;
  minQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  optionType: MenuItemOptionType;
  options: Array<ModifierOptionInput>;
  qtyPerPerson?: InputMaybe<Scalars['Int']['input']>;
  vendorId: Scalars['Int']['input'];
};

export type ModifierCategoryMutationPayload = {
  __typename?: 'ModifierCategoryMutationPayload';
  id: Maybe<Scalars['ID']['output']>;
};

export type ModifierCategoryUpdateInput = {
  maxQty?: InputMaybe<Scalars['Int']['input']>;
  minQty?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  optionType?: InputMaybe<MenuItemOptionType>;
  options?: InputMaybe<Array<ModifierOptionInput>>;
  qtyPerPerson?: InputMaybe<Scalars['Int']['input']>;
};

export type ModifierOptionInput = {
  itemId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
  price: Scalars['Float']['input'];
};

export enum Modules {
  MenuManager = 'MENU_MANAGER'
}

export type MoveInvoiceAccountInput = {
  countryCode: Scalars['String']['input'];
  flexDeferredCustomerId: Scalars['String']['input'];
  flexDeferredCustomerOrderId: Scalars['String']['input'];
};

export type MoveInvoiceAccountResponse = {
  __typename?: 'MoveInvoiceAccountResponse';
  count: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateFleetConnection: Scalars['ID']['output'];
  /**
   * Activate a platform alert
   * tenantId is optional - will be extracted from auth context for admin users
   */
  activatePlatformAlert: PlatformAlert;
  addInvoiceItem: InvoiceItem;
  addInvoicePayment: Invoice;
  addItemToGmBasket: GmBasket;
  addTenantContactRegion: TenantContact;
  addVendorStatementItem: InvoiceItem;
  adjustQuantityEmmaAlgorithmResponses: EmmaAlgorithmResponse;
  /** Decrease a user's credit balance (admin only) */
  adminDecreaseUserCredits: CreditTransaction;
  /** Increase a user's credit balance (admin only) */
  adminIncreaseUserCredits: CreditTransaction;
  applyCreditCardFee: GmOrderTaxBreakdown;
  applyEditSessionChangesToBasket: GmBasket;
  /**
   * Handle updating the reference fields to the latest version and clearing
   * out the existing values.
   */
  applyNewReferenceFieldsToBasket: GmBasket;
  /**
   * Replace the order's reference fields with the latest set on the invoice account
   * the current fields belong to, clearing every value. Locked once the customer
   * order is synced to Flex.
   */
  applyNewReferenceFieldsToCCSupplierOrder: ApplyNewReferenceFieldsToCcSupplierOrderResult;
  /**
   * Handle updating the reference fields to the latest version and clearing
   * out the existing values. This will NOT update the reference fields
   * on the flex order (if it is synced and/or invoiced).
   */
  applyNewReferenceFieldsToOrder: GmOrder;
  applyNewReferenceFieldsToStandingOrderTemplate: GmBasket;
  approveInvoice: Invoice;
  approveVendorStatement: VendorStatement;
  /**
   * Archive an account: soft-deletes it and cascades to its locations,
   * exclusively-owned clusters and active users. Admin only. Irreversible: there
   * is no unarchive. When the account has something worth confirming (users
   * holding credit) the first call returns warnings instead of archiving; call
   * again with acknowledgeWarnings: true to proceed.
   */
  archiveAccount: ArchiveAccountPayload;
  assignBasketToGuest: GmBasket;
  /**
   * Sets the members of a CC team. Replaces existing membership — users currently
   * on the team who are not in userIds will be unassigned. Pass an empty userIds
   * list to clear all members. Pass teamId: null to unassign the given users from
   * any team. Requires admin or account manager role.
   */
  assignUsersToTeam: AssignUsersToTeamResult;
  bulkCreateStandingOrders: Maybe<Scalars['Void']['output']>;
  /** Cancel a GM order, create a GM issue, and refund payment when applicable. */
  cancelGmOrder: Scalars['Boolean']['output'];
  cancelInvoice: Invoice;
  cancelVendorStatement: VendorStatement;
  checkout: CheckoutResponse;
  clearEmmaMenuItemGroup: Scalars['Boolean']['output'];
  confirmGmOrder: Scalars['Boolean']['output'];
  consolidateFlexInvoice: ConsolidateFlexInvoiceResult;
  createAccount: Account;
  createAccountCountryFlexMapping: AccountCountryFlexMapping;
  createAccountIdentityProvider: Scalars['Boolean']['output'];
  createAlert: Alert;
  createBillingEntity: BillingEntity;
  createCCCluster: CcCluster;
  createCCLaunchServicePdf: Maybe<Scalars['Void']['output']>;
  createCCOrderForUser: InitiateCcOrderResponse;
  createCCOrderPrintPdf: CcOrderPrintPdfResponse;
  createCCSubmenu: CcSubmenu;
  /**
   * Creates a new CC team under the given account. Assigns a unique 6-character
   * alphanumeric code automatically. Requires admin or account manager role.
   */
  createCCTeam: CcTeam;
  /** Create a Caterdesk API user */
  createCaterdeskApiUser: CaterdeskApiUserResponse;
  createCcOrderReminderNotification: Scalars['Boolean']['output'];
  createDeliveryDocketPdf: DeliveryDocketPdfResponse;
  createDeliveryRegion: DeliveryRegion;
  createEmmaAutomation: EmmaAutomation;
  createEmmaOccasion: EmmaOccasion;
  createEmmaRecipe: EmmaRecipe;
  createFlexInvoice: Scalars['ID']['output'];
  /**
   * These invoice account mutations are used for the new finance page and will
   * update the attributes both locally (within Feedr platform) and within
   * Flex Invoicing.
   */
  createFlexInvoiceAccount: FlexInvoiceAccount;
  createGmBasket: GmBasket;
  createGmInvoices: Array<Scalars['ID']['output']>;
  createGmIssue: GmIssue;
  createGmOrderFromBasket: GmOrder;
  createGmOrderPdf: GmOrderPdfResponse;
  createInvoiceAccount: InvoiceAccount;
  createMenuItem: MenuItem;
  createMenuItemGroup: MenuItemGroup;
  createOneGmInvoice: Scalars['ID']['output'];
  /** Create or Update a User Favourite */
  createOrUpdateMyFavourite: Scalars['Boolean']['output'];
  /**
   * Create a new platform alert (inactive by default)
   * tenantId is optional - will be extracted from auth context for admin users
   */
  createPlatformAlert: PlatformAlert;
  createQuoteCollection: QuoteCollection;
  /**
   * Invoice account reference fields are to be updated using these methods
   * to keep things simpler rather than updating them through the flex
   * invoice accounts.
   */
  createReferenceField: ReferenceField;
  createRefund: Refund;
  createStandingOrder: Scalars['ID']['output'];
  createTenant: Tenant;
  /** Create a new user */
  createUser: User;
  createVendorCharge: VendorCharge;
  createVendorFlexInvoice: Scalars['ID']['output'];
  createVendorTag: VendorTag;
  deactivateFleetConnection: Scalars['ID']['output'];
  /**
   * Deactivate a platform alert
   * tenantId is optional - will be extracted from auth context for admin users
   */
  deactivatePlatformAlert: PlatformAlert;
  /**
   * Soft-deletes an account location by setting the deletedAt timestamp.
   *
   * Security checks:
   * - Requires authentication
   * - Verifies location belongs to user's account
   * - Validates location is not assigned to any active users
   * - Validates location is not the account's only location
   *
   * Returns error if location is in use or user lacks permission.
   */
  deleteAccountLocation: DeleteAccountLocationResult;
  /**
   * Delete an internal admin user. Only deletes admin record - linked
   * user or supplierContact records for the same person is unaffected.
   * Admin only.
   */
  deleteAdmin: Scalars['Boolean']['output'];
  deleteAlert: Scalars['ID']['output'];
  deleteBillingEntity: Scalars['ID']['output'];
  deleteCCCluster: CcCluster;
  deleteCCOrderItem: CcOrderItem;
  deleteCCSubmenu: Maybe<CcSubmenu>;
  /**
   * Soft-deletes a CC team by setting the deletedAt timestamp.
   * Will fail if any active users are assigned to the team.
   * Requires admin or account manager role.
   */
  deleteCCTeam: DeleteCcTeamResult;
  deleteDeliveryRegion: DeliveryRegion;
  deleteEmmaAutomation: Scalars['Boolean']['output'];
  deleteEmmaFormResponse: Scalars['Boolean']['output'];
  deleteEmmaOccasion: Scalars['Boolean']['output'];
  deleteEmmaRecipe: Scalars['Boolean']['output'];
  /**
   * Fully offboard a Feedr identity: soft-deletes the feedrUsers row and
   * every linked user/admin/supplierContact record in one transaction, then
   * disables the shared Cognito identity. Admin only.
   */
  deleteFeedrUser: Scalars['Boolean']['output'];
  deleteFlexInvoiceAccount: Scalars['Int']['output'];
  deleteGmBasket: Maybe<GmBasket>;
  deleteGmIssue: Maybe<Scalars['Void']['output']>;
  deleteGmMenuCategories: Scalars['Boolean']['output'];
  deleteInvoiceAccount: Scalars['Int']['output'];
  deleteMenuItem: MenuItem;
  deleteMenuItemGroup: Scalars['Boolean']['output'];
  deleteMenuItems: DeleteMenuItemsResponse;
  /**
   * Delete a platform alert
   * tenantId is optional - will be extracted from auth context for admin users
   */
  deletePlatformAlert: Scalars['Boolean']['output'];
  deleteQuoteCollection: QuoteCollection;
  deleteReferenceField: Scalars['Int']['output'];
  deleteRefund: Refund;
  deleteStandingOrder: Maybe<Scalars['Void']['output']>;
  /**
   * Delete a supplier contact. Only removes the supplier-contact record - any
   * linked consumer user or admin for the same person is unaffected.
   * Admin only.
   */
  deleteSupplierContact: Scalars['Boolean']['output'];
  /** Delete a user */
  deleteUser: Scalars['Boolean']['output'];
  deleteVendorCharge: VendorCharge;
  duplicateGmBasket: Scalars['ID']['output'];
  duplicateMenuItem: MenuItem;
  emmaCategoriseItem: EmmaCategoriseItemResponse;
  forcePlaceGmOrder: Scalars['Int']['output'];
  forceRunStandingOrderGeneration: Maybe<Scalars['Void']['output']>;
  /** Send user a forgot password email */
  forgotPassword: Scalars['Boolean']['output'];
  generateSlackAlertingOAuthUrl: Scalars['String']['output'];
  generateStripeSetupIntentOnFlex: SetupIntent;
  generateTenantImageUploadUrl: TenantImageUpload;
  incrementLiveMenuItemPopularities: Scalars['Boolean']['output'];
  initiateCCOrder: InitiateCcOrderResponse;
  initiateInvoiceCardPayment: InitiateInvoiceCardPaymentResult;
  initiatePayment: InitiatePaymentResult;
  invoicingSendEmailToAssociatedContacts: Scalars['Boolean']['output'];
  markFlexInvoicesAsPaid: MarkFlexInvoicesAsPaidResult;
  moveInvoiceAccount: MoveInvoiceAccountResponse;
  /** Prepares basket data for quotes without saving a new basket to the database. */
  prepareEmptyBasketFromQuoteRequest: QuoteRequestBasket;
  publishInReviewMenuItems: BulkMenuItemMutationResponse;
  /**
   * Legacy canteen item rating. Writes the rating onto the order item and feeds the
   * vendor rating ledger.
   * @deprecated Use reviewCCOrderItem, which records the review in the reviews service.
   */
  rateCCOrderItem: Maybe<Scalars['Void']['output']>;
  /**
   * Rate a delivered GM order. The caller must own the order, it must be
   * delivered, and it must not be a standing order.
   */
  rateGmOrder: Scalars['Boolean']['output'];
  recreateInvoice: Scalars['ID']['output'];
  redeployFrontends: Scalars['Boolean']['output'];
  refundPayment: RefundResult;
  regenerateEmmaAlgorithmResponses: Scalars['Boolean']['output'];
  removeFlexInvoiceOrder: Scalars['Boolean']['output'];
  removeInvoiceItem: Scalars['ID']['output'];
  removeItemFromGmBasket: GmBasket;
  removeOrdersFromFlexInvoice: Scalars['Boolean']['output'];
  removeOrdersFromVendorFlexInvoice: Scalars['Boolean']['output'];
  removeVendorStatementItem: Scalars['ID']['output'];
  /** Resend signup confirmation to user */
  resendSignupConfirmation: Scalars['Boolean']['output'];
  restoreDeletedAccountLocation: Scalars['Boolean']['output'];
  restoreDeletedInvoiceAccount: Scalars['Boolean']['output'];
  restoreMenuItem: MenuItem;
  /**
   * Restore an archived user: clears deletedAt and re-enables their login.
   * Admin only. Rejected when the user's account is archived.
   */
  restoreUser: User;
  /** Rate a collected canteen item. Records the review in the reviews service. */
  reviewCCOrderItem: Scalars['Boolean']['output'];
  sendCCLaunchServiceEmail: AccountLocation;
  sendCcOrderReminderNotification: Scalars['Boolean']['output'];
  sendFlexInvoiceByEmail: Scalars['Boolean']['output'];
  sendGmMultiQuotes: Maybe<Scalars['Void']['output']>;
  sendGmQuote: Maybe<Scalars['Void']['output']>;
  /**
   * Handle syncing a order with flex as an instant order. This functionality
   * is only available for tenant admins.
   */
  sendInstantGmOrderToFlex: SendInstantGmOrderToFlexResult;
  sendVendorFlexInvoiceByEmail: Scalars['Boolean']['output'];
  /** Set the password for a Caterdesk API user linked to the logged-in user */
  setMyCaterdeskApiUserPassword: CaterdeskApiSetPasswordResponse;
  /** Set a Caterdesk API user's password and return it */
  setPasswordCaterdeskApiUser: CaterdeskApiSetPasswordResponse;
  /**
   * Atomically replaces the entire subsidy plan for a team.
   * Submitting subsidies of any one type (meal | daily | week) removes all
   * subsidies of the other two types for that team — only one type can be
   * active per team at a time. Pass an empty array to clear all subsidies.
   * Requires admin or account manager role.
   */
  setTeamSubsidies: Array<CcSubsidy>;
  setUserForGuestGmBaskets: Scalars['Boolean']['output'];
  /** Sign up as a new user */
  signUp: NewUserSignupResponse;
  startPayment: StartPaymentResult;
  submitEmmaForm: EmmaFormSubmissionResponse;
  syncGMOrderToExternal: Scalars['Boolean']['output'];
  syncInstantGMOrderWithFlex: Scalars['Boolean']['output'];
  syncInvoiceOrderWithFlex: SyncInvoiceOrderResult;
  syncMenuItemPrices: SyncMenuItemPricesResponse;
  trackCheckoutStarted: Scalars['Boolean']['output'];
  unlockAllMenuItemsForVendor: BulkMenuItemMutationResponse;
  /** Unsubscribe a user from email notifications identified via a JSON web token */
  unsubscribeUserFromEmailNotification: Scalars['Boolean']['output'];
  updateAccount: Account;
  updateAccountFinanceSettings: AccountFinanceSettings;
  updateAccountIdentityProvider: Scalars['Boolean']['output'];
  updateAccountLocationReferenceFields: Maybe<Scalars['Void']['output']>;
  updateAccountLocationVendorPreferences: Maybe<Scalars['Void']['output']>;
  /** Update Admin user */
  updateAdminUser: Scalars['Boolean']['output'];
  updateAlert: Alert;
  updateBillingEntity: BillingEntity;
  updateCCCluster: CcCluster;
  updateCCSubmenu: CcSubmenu;
  updateCCSupplierOrderReferenceFieldValues: Maybe<Scalars['Void']['output']>;
  updateCCSupplierOrderStatus: CcSupplierOrderStatus;
  /**
   * Updates an existing CC team. Optionally accepts a code to override the
   * auto-generated team code (e.g. to correct a misspelled name). If omitted,
   * the existing code is preserved. Requires admin or account manager role.
   */
  updateCCTeam: CcTeam;
  /** Update a Caterdesk API user */
  updateCaterdeskApiUser: CaterdeskApiUserResponse;
  updateDeliveryRegion: Maybe<Scalars['Void']['output']>;
  updateEmmaAutomation: EmmaAutomation;
  updateEmmaFormResponse: EmmaFormSubmissionResponse;
  updateEmmaFormResponseAdminAssigned: Scalars['Boolean']['output'];
  updateEmmaOccasion: EmmaOccasion;
  updateEmmaRecipe: EmmaRecipe;
  updateFlexInvoiceAccount: FlexInvoiceAccount;
  updateFlexInvoiceDetails: Scalars['Boolean']['output'];
  updateFlexInvoicingPaymentSettings: FlexInvoicingPaymentSettings;
  updateGmBasket: GmBasket;
  updateGmOrder: GmOrder;
  updateGmOrderStatus: GmOrderStatus;
  updateInvoice: Invoice;
  updateInvoiceAccount: InvoiceAccount;
  updateItemInGmBasket: GmBasket;
  updateItemQtyInGmBasket: GmBasket;
  /** A user can update their own data */
  updateMe: User;
  updateMenuItem: MenuItem;
  updateMenuItemGroup: MenuItemGroup;
  updateMenuItemGroups: Array<MenuItemGroup>;
  updateMenuItems: BulkMenuItemMutationResponse;
  updateMultipleVendorTags: Maybe<Scalars['Void']['output']>;
  /**
   * Update an existing platform alert
   * tenantId is optional - will be extracted from auth context for admin users
   */
  updatePlatformAlert: PlatformAlert;
  updateReferenceField: ReferenceField;
  updateReferenceFieldInBasket: GmBasket;
  updateStandingOrder: StandingOrder;
  updateStandingOrderTemplate: GmBasket;
  updateTenant: Tenant;
  /** Update a user as an admin */
  updateUser: User;
  /** Update the users selected allergens */
  updateUserAllergens: UserAllergens;
  /** Update the users autopilotSettings */
  updateUserAutopilotSettings: UserAutopilotSettings;
  /** Update the users selected dietary preferences */
  updateUserDietaryPreferences: UserDietaryPreferences;
  updateVendor: Vendor;
  updateVendorFlexInvoiceDetails: Scalars['Boolean']['output'];
  upsertEmmaMenuItemGroup: Scalars['Boolean']['output'];
  upsertGmMenuCategories: Array<GmMenuCategory>;
};


export type MutationActivateFleetConnectionArgs = {
  fleetId: Scalars['ID']['input'];
  supplierLocationId: Scalars['Int']['input'];
};


export type MutationActivatePlatformAlertArgs = {
  id: Scalars['ID']['input'];
  tenantId: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddInvoiceItemArgs = {
  input: InvoiceItemInput;
  invoiceId: Scalars['ID']['input'];
};


export type MutationAddInvoicePaymentArgs = {
  id: Scalars['ID']['input'];
  input: AddInvoicePaymentInput;
};


export type MutationAddItemToGmBasketArgs = {
  basketId: Scalars['ID']['input'];
  editSessionId: InputMaybe<Scalars['ID']['input']>;
  isStandingOrderTemplate: InputMaybe<Scalars['Boolean']['input']>;
  itemPayload: BasketItemInput;
};


export type MutationAddTenantContactRegionArgs = {
  input: AddTenantContactRegionInput;
};


export type MutationAddVendorStatementItemArgs = {
  input: InvoiceItemInput;
  vendorStatementId: Scalars['ID']['input'];
};


export type MutationAdjustQuantityEmmaAlgorithmResponsesArgs = {
  id: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
  qty: Scalars['Int']['input'];
};


export type MutationAdminDecreaseUserCreditsArgs = {
  input: AdminDecreaseUserCreditsInput;
};


export type MutationAdminIncreaseUserCreditsArgs = {
  input: AdminIncreaseUserCreditsInput;
};


export type MutationApplyCreditCardFeeArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationApplyEditSessionChangesToBasketArgs = {
  basketId: Scalars['ID']['input'];
  editSessionId: Scalars['ID']['input'];
};


export type MutationApplyNewReferenceFieldsToBasketArgs = {
  basketId: Scalars['ID']['input'];
  invoiceAccountId: Scalars['Int']['input'];
};


export type MutationApplyNewReferenceFieldsToCcSupplierOrderArgs = {
  ccSupplierOrderId: Scalars['Int']['input'];
};


export type MutationApplyNewReferenceFieldsToOrderArgs = {
  invoiceAccountId: Scalars['Int']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationApplyNewReferenceFieldsToStandingOrderTemplateArgs = {
  invoiceAccountId: Scalars['Int']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationApproveInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveVendorStatementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveAccountArgs = {
  accountId: Scalars['ID']['input'];
  acknowledgeWarnings?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAssignBasketToGuestArgs = {
  basketId: Scalars['ID']['input'];
  input: AssignBasketToGuestInput;
};


export type MutationAssignUsersToTeamArgs = {
  teamId: InputMaybe<Scalars['Int']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};


export type MutationBulkCreateStandingOrdersArgs = {
  input: BulkCreateStandingOrdersInput;
};


export type MutationCancelGmOrderArgs = {
  input: CancelGmOrderGmOrderInput;
};


export type MutationCancelInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelVendorStatementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCheckoutArgs = {
  basketId: Scalars['ID']['input'];
  paymentMethod: PaymentMethod;
  proposedTotalIncTax: InputMaybe<Scalars['Int']['input']>;
};


export type MutationClearEmmaMenuItemGroupArgs = {
  input: ClearEmmaMenuItemGroupInput;
};


export type MutationConfirmGmOrderArgs = {
  token: Scalars['String']['input'];
};


export type MutationConsolidateFlexInvoiceArgs = {
  input: ConsolidateFlexInvoiceInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateAccountCountryFlexMappingArgs = {
  input: CreateAccountCountryFlexMappingInput;
};


export type MutationCreateAccountIdentityProviderArgs = {
  input: CreateAccountIdentityProviderInput;
};


export type MutationCreateAlertArgs = {
  input: CreateAlertInput;
};


export type MutationCreateBillingEntityArgs = {
  input: CreateBillingEntityInput;
};


export type MutationCreateCcClusterArgs = {
  input: CreateCcClusterInput;
};


export type MutationCreateCcLaunchServicePdfArgs = {
  accountId: Scalars['Int']['input'];
  accountLocationId: Scalars['Int']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCcOrderForUserArgs = {
  input: CreateCcOrderForUserInput;
};


export type MutationCreateCcOrderPrintPdfArgs = {
  input: CreateCcOrderPrintPdfInput;
};


export type MutationCreateCcSubmenuArgs = {
  input: CreateCcSubmenuInput;
};


export type MutationCreateCcTeamArgs = {
  accountId: Scalars['Int']['input'];
  input: CreateCcTeamInput;
};


export type MutationCreateCaterdeskApiUserArgs = {
  input: CaterdeskApiUserCreateInput;
};


export type MutationCreateCcOrderReminderNotificationArgs = {
  ccSupplierOrderId: Scalars['Int']['input'];
};


export type MutationCreateDeliveryDocketPdfArgs = {
  input: DeliveryDocketPdfInput;
};


export type MutationCreateDeliveryRegionArgs = {
  input: CreateDeliveryRegionInput;
};


export type MutationCreateEmmaAutomationArgs = {
  input: EmmaCreateAutomationInput;
};


export type MutationCreateEmmaOccasionArgs = {
  input: EmmaOccasionInput;
  tenantId: Scalars['String']['input'];
};


export type MutationCreateEmmaRecipeArgs = {
  input: EmmaCreateRecipeInput;
};


export type MutationCreateFlexInvoiceArgs = {
  input: CreateFlexInvoiceInput;
};


export type MutationCreateFlexInvoiceAccountArgs = {
  input: CreateFlexInvoiceAccountInput;
};


export type MutationCreateGmBasketArgs = {
  availabilityId: Scalars['ID']['input'];
  basketPayload: CreateGmBasketInput;
  config: InputMaybe<CreateGmBasketConfigInput>;
};


export type MutationCreateGmInvoicesArgs = {
  input: CreateGmInvoices;
};


export type MutationCreateGmIssueArgs = {
  input: GmIssueInput;
};


export type MutationCreateGmOrderFromBasketArgs = {
  input: CreateGmOrderFromBasketInput;
  options: InputMaybe<UpdateGmOrderMutationOptionsInput>;
};


export type MutationCreateGmOrderPdfArgs = {
  input: GmOrderPdfInput;
};


export type MutationCreateInvoiceAccountArgs = {
  input: CreateInvoiceAccountInput;
};


export type MutationCreateMenuItemArgs = {
  allergenWarningAccepted: InputMaybe<Scalars['Boolean']['input']>;
  authOverride: InputMaybe<InternalOriginAuthOverrideInput>;
  input: CreateDraftMenuItemInput;
};


export type MutationCreateMenuItemGroupArgs = {
  input: CreateMenuItemGroupInput;
};


export type MutationCreateOneGmInvoiceArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationCreateOrUpdateMyFavouriteArgs = {
  input: CreateOrUpdateMyFavouriteInput;
};


export type MutationCreatePlatformAlertArgs = {
  input: CreatePlatformAlertInput;
  tenantId: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateQuoteCollectionArgs = {
  input: CreateQuoteCollectionInput;
};


export type MutationCreateReferenceFieldArgs = {
  input: CreateReferenceFieldInput;
  invoiceAccountId: Scalars['ID']['input'];
};


export type MutationCreateRefundArgs = {
  input: RefundInput;
};


export type MutationCreateStandingOrderArgs = {
  standingOrder: StandingOrderInput;
};


export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVendorChargeArgs = {
  input: RefundInput;
};


export type MutationCreateVendorFlexInvoiceArgs = {
  input: CreateVendorFlexInvoiceInput;
};


export type MutationCreateVendorTagArgs = {
  input: VendorTagCreateInput;
};


export type MutationDeactivateFleetConnectionArgs = {
  connectedFleetId: Scalars['ID']['input'];
  supplierLocationId: Scalars['Int']['input'];
};


export type MutationDeactivatePlatformAlertArgs = {
  id: Scalars['ID']['input'];
  tenantId: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteAccountLocationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteAdminArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAlertArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBillingEntityArgs = {
  input: DeleteBillingEntityInput;
};


export type MutationDeleteCcClusterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCcOrderItemArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCcSubmenuArgs = {
  id: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCcTeamArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteDeliveryRegionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmmaAutomationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmmaFormResponseArgs = {
  input: Scalars['ID']['input'];
};


export type MutationDeleteEmmaOccasionArgs = {
  id: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationDeleteEmmaRecipeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeedrUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFlexInvoiceAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGmBasketArgs = {
  basketId: Scalars['ID']['input'];
  ordered: Scalars['Boolean']['input'];
};


export type MutationDeleteGmIssueArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteGmMenuCategoriesArgs = {
  categoryIds: Array<Scalars['Int']['input']>;
  vendorId: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteInvoiceAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMenuItemArgs = {
  authOverride: InputMaybe<InternalOriginAuthOverrideInput>;
  id: Scalars['ID']['input'];
  options: InputMaybe<DeleteMenuItemOptions>;
};


export type MutationDeleteMenuItemGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMenuItemsArgs = {
  input: Array<DeleteMenuItemInput>;
};


export type MutationDeletePlatformAlertArgs = {
  id: Scalars['ID']['input'];
  tenantId: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteQuoteCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReferenceFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRefundArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteStandingOrderArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationDeleteSupplierContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVendorChargeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDuplicateGmBasketArgs = {
  basketId: Scalars['ID']['input'];
  orderId: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDuplicateMenuItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmmaCategoriseItemArgs = {
  input: EmmaCategoriseItemInput;
};


export type MutationForcePlaceGmOrderArgs = {
  basketId: Scalars['ID']['input'];
};


export type MutationForceRunStandingOrderGenerationArgs = {
  input: ForceRunStandingOrderGenerationInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGenerateStripeSetupIntentOnFlexArgs = {
  invoiceAccountId: Scalars['Int']['input'];
};


export type MutationGenerateTenantImageUploadUrlArgs = {
  input: GenerateTenantImageUploadUrlInput;
};


export type MutationIncrementLiveMenuItemPopularitiesArgs = {
  variationIds: Array<Scalars['ID']['input']>;
};


export type MutationInitiateCcOrderArgs = {
  input: InitiateCcOrderInput;
};


export type MutationInitiateInvoiceCardPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInitiatePaymentArgs = {
  input: InitiatePaymentInput;
};


export type MutationInvoicingSendEmailToAssociatedContactsArgs = {
  invoiceOrStatementId: Scalars['ID']['input'];
};


export type MutationMarkFlexInvoicesAsPaidArgs = {
  input: MarkFlexInvoicesAsPaidInput;
};


export type MutationMoveInvoiceAccountArgs = {
  input: MoveInvoiceAccountInput;
};


export type MutationPrepareEmptyBasketFromQuoteRequestArgs = {
  input: PrepareEmptyBasketFromQuoteRequestInput;
};


export type MutationPublishInReviewMenuItemsArgs = {
  allergenWarningAccepted: InputMaybe<Scalars['Boolean']['input']>;
  ids: InputMaybe<Array<Scalars['ID']['input']>>;
  supplierId: Scalars['ID']['input'];
};


export type MutationRateCcOrderItemArgs = {
  input: RateCcOrderItemInput;
};


export type MutationRateGmOrderArgs = {
  input: RateGmOrderInput;
};


export type MutationRecreateInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRefundPaymentArgs = {
  input: RefundPaymentInput;
};


export type MutationRegenerateEmmaAlgorithmResponsesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveFlexInvoiceOrderArgs = {
  input: InputMaybe<RemoveFlexInvoiceOrder>;
};


export type MutationRemoveInvoiceItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveItemFromGmBasketArgs = {
  basketId: Scalars['ID']['input'];
  editSessionId: InputMaybe<Scalars['ID']['input']>;
  isStandingOrderTemplate: InputMaybe<Scalars['Boolean']['input']>;
  itemReference: Scalars['String']['input'];
};


export type MutationRemoveOrdersFromFlexInvoiceArgs = {
  id: Scalars['ID']['input'];
  input: RemoveOrdersFromFlexInvoiceInput;
};


export type MutationRemoveOrdersFromVendorFlexInvoiceArgs = {
  id: Scalars['ID']['input'];
  input: RemoveOrdersFromVendorFlexInvoiceInput;
};


export type MutationRemoveVendorStatementItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendSignupConfirmationArgs = {
  email: Scalars['String']['input'];
  input: SignupConfirmationInput;
};


export type MutationRestoreDeletedAccountLocationArgs = {
  accountLocationId: Scalars['Int']['input'];
};


export type MutationRestoreDeletedInvoiceAccountArgs = {
  invoiceAccountId: Scalars['Int']['input'];
};


export type MutationRestoreMenuItemArgs = {
  id: Scalars['ID']['input'];
  options: InputMaybe<RestoreMenuItemOptions>;
};


export type MutationRestoreUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReviewCcOrderItemArgs = {
  input: ReviewCcOrderItemInput;
};


export type MutationSendCcLaunchServiceEmailArgs = {
  accountLocationId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


export type MutationSendCcOrderReminderNotificationArgs = {
  notificationId: Scalars['String']['input'];
};


export type MutationSendFlexInvoiceByEmailArgs = {
  emailAddresses: Array<Scalars['String']['input']>;
  flexInvoiceId: Scalars['ID']['input'];
  invoiceType: InputMaybe<FlexInvoiceType>;
};


export type MutationSendGmMultiQuotesArgs = {
  input: SendGmMultiQuotesInput;
};


export type MutationSendGmQuoteArgs = {
  input: SendGmQuoteInput;
};


export type MutationSendInstantGmOrderToFlexArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationSendVendorFlexInvoiceByEmailArgs = {
  emailAddresses: Array<Scalars['String']['input']>;
  invoiceType: InputMaybe<FlexInvoiceType>;
  vendorFlexInvoiceId: Scalars['ID']['input'];
};


export type MutationSetMyCaterdeskApiUserPasswordArgs = {
  input: SetMyCaterdeskApiUserPasswordInput;
};


export type MutationSetPasswordCaterdeskApiUserArgs = {
  input: SetPasswordCaterdeskApiUserInput;
};


export type MutationSetTeamSubsidiesArgs = {
  subsidies: Array<SubsidyInput>;
  teamId: Scalars['Int']['input'];
};


export type MutationSetUserForGuestGmBasketsArgs = {
  basketIds: Array<Scalars['ID']['input']>;
};


export type MutationSignUpArgs = {
  input: NewUserSignupInput;
};


export type MutationStartPaymentArgs = {
  input: StartPaymentInput;
};


export type MutationSubmitEmmaFormArgs = {
  input: EmmaFormInput;
};


export type MutationSyncGmOrderToExternalArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationSyncInstantGmOrderWithFlexArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationSyncInvoiceOrderWithFlexArgs = {
  input: SyncInvoiceOrderWithFlex;
};


export type MutationSyncMenuItemPricesArgs = {
  input: SyncMenuItemPricesInput;
};


export type MutationTrackCheckoutStartedArgs = {
  basketId: Scalars['ID']['input'];
};


export type MutationUnlockAllMenuItemsForVendorArgs = {
  ids: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorId: Scalars['ID']['input'];
};


export type MutationUnsubscribeUserFromEmailNotificationArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateAccountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAccountInput;
};


export type MutationUpdateAccountFinanceSettingsArgs = {
  accountId: Scalars['Int']['input'];
  input: UpdateAccountFinanceSettingsInput;
};


export type MutationUpdateAccountIdentityProviderArgs = {
  input: UpdateAccountIdentityProviderInput;
};


export type MutationUpdateAccountLocationReferenceFieldsArgs = {
  accountLocationId: Scalars['Int']['input'];
  input: UpdateAccountLocationReferenceFieldsInput;
};


export type MutationUpdateAccountLocationVendorPreferencesArgs = {
  accountLocationId: Scalars['Int']['input'];
  input: UpdateAccountLocationVendorPreferencesInput;
};


export type MutationUpdateAdminUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAdminUserInput;
};


export type MutationUpdateAlertArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAlertInput;
};


export type MutationUpdateBillingEntityArgs = {
  input: UpdateBillingEntityInput;
};


export type MutationUpdateCcClusterArgs = {
  input: UpdateCcClusterInput;
};


export type MutationUpdateCcSubmenuArgs = {
  input: UpdateCcSubmenuInput;
};


export type MutationUpdateCcSupplierOrderReferenceFieldValuesArgs = {
  ccSupplierOrderId: Scalars['Int']['input'];
  input: UpdateCcSupplierOrderReferenceFieldValueInput;
};


export type MutationUpdateCcSupplierOrderStatusArgs = {
  eta: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Int']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdateCcTeamArgs = {
  id: Scalars['Int']['input'];
  input: UpdateCcTeamInput;
};


export type MutationUpdateCaterdeskApiUserArgs = {
  email: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['ID']['input']>;
  input: CaterdeskApiUserUpdateInput;
};


export type MutationUpdateDeliveryRegionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeliveryRegionInput;
};


export type MutationUpdateEmmaAutomationArgs = {
  id: Scalars['ID']['input'];
  input: EmmaUpdateAutomationInput;
};


export type MutationUpdateEmmaFormResponseArgs = {
  input: UpdateEmmaFormInput;
};


export type MutationUpdateEmmaFormResponseAdminAssignedArgs = {
  input: Scalars['ID']['input'];
};


export type MutationUpdateEmmaOccasionArgs = {
  id: Scalars['ID']['input'];
  input: EmmaOccasionInput;
  tenantId: Scalars['String']['input'];
};


export type MutationUpdateEmmaRecipeArgs = {
  id: Scalars['ID']['input'];
  input: EmmaUpdateRecipeInput;
};


export type MutationUpdateFlexInvoiceAccountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFlexInvoiceAccountInput;
};


export type MutationUpdateFlexInvoiceDetailsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFlexInvoiceDetailsInput;
};


export type MutationUpdateFlexInvoicingPaymentSettingsArgs = {
  input: UpdateFlexInvoicingPaymentSettingsInput;
};


export type MutationUpdateGmBasketArgs = {
  basketId: Scalars['ID']['input'];
  basketPayload: UpdateGmBasketInput;
  config: InputMaybe<UpdateGmBasketConfigInput>;
};


export type MutationUpdateGmOrderArgs = {
  input: UpdateGmOrderInput;
  options: InputMaybe<UpdateGmOrderMutationOptionsInput>;
};


export type MutationUpdateGmOrderStatusArgs = {
  cancellationNote: InputMaybe<Scalars['String']['input']>;
  cancellationReason: InputMaybe<Scalars['String']['input']>;
  eta: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Int']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdateInvoiceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateInvoiceInput;
};


export type MutationUpdateInvoiceAccountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateInvoiceAccountInput;
};


export type MutationUpdateItemInGmBasketArgs = {
  basketId: Scalars['ID']['input'];
  editSessionId: InputMaybe<Scalars['ID']['input']>;
  isStandingOrderTemplate: InputMaybe<Scalars['Boolean']['input']>;
  itemPayload: UpdateBasketItemInput;
  itemReference: Scalars['String']['input'];
};


export type MutationUpdateItemQtyInGmBasketArgs = {
  basketId: Scalars['ID']['input'];
  editSessionId: InputMaybe<Scalars['ID']['input']>;
  isStandingOrderTemplate: InputMaybe<Scalars['Boolean']['input']>;
  itemReference: Scalars['String']['input'];
  qty: Scalars['Int']['input'];
};


export type MutationUpdateMeArgs = {
  userPayload: UpdateUserInput;
};


export type MutationUpdateMenuItemArgs = {
  allergenWarningAccepted: InputMaybe<Scalars['Boolean']['input']>;
  authOverride: InputMaybe<InternalOriginAuthOverrideInput>;
  input: UpdateMenuItemInput;
  publish: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateMenuItemGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMenuItemGroupInput;
};


export type MutationUpdateMenuItemGroupsArgs = {
  input: Array<UpdateMenuItemGroupsInput>;
};


export type MutationUpdateMenuItemsArgs = {
  input: Array<UpdateMenuItemInput>;
};


export type MutationUpdateMultipleVendorTagsArgs = {
  input: Array<VendorTagUpdateInput>;
};


export type MutationUpdatePlatformAlertArgs = {
  input: UpdatePlatformAlertInput;
  tenantId: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateReferenceFieldArgs = {
  id: Scalars['ID']['input'];
  input: UpdateReferenceFieldInput;
};


export type MutationUpdateReferenceFieldInBasketArgs = {
  basketId: Scalars['ID']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  orderReferenceFieldId: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MutationUpdateStandingOrderArgs = {
  standingOrderPayload: UpdateStandingOrderInput;
  templateId: Scalars['ID']['input'];
};


export type MutationUpdateStandingOrderTemplateArgs = {
  options: InputMaybe<UpdateGmOrderMutationOptionsInput>;
  templateId: Scalars['ID']['input'];
  templatePayload: UpdateGmBasketInput;
};


export type MutationUpdateTenantArgs = {
  input: UpdateTenantInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};


export type MutationUpdateUserAllergensArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserAllergensInput;
};


export type MutationUpdateUserAutopilotSettingsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserAutopilotSettingsInput;
};


export type MutationUpdateUserDietaryPreferencesArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserDietaryPreferencesInput;
};


export type MutationUpdateVendorArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVendorInput;
};


export type MutationUpdateVendorFlexInvoiceDetailsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVendorFlexInvoiceDetailsInput;
};


export type MutationUpsertEmmaMenuItemGroupArgs = {
  input: EmmaMenuItemGroupInput;
};


export type MutationUpsertGmMenuCategoriesArgs = {
  categories: Array<GmMenuCategoryInput>;
  vendorId: InputMaybe<Scalars['Int']['input']>;
};

export type MyCaterdeskApiEntityAccess = {
  __typename?: 'MyCaterdeskApiEntityAccess';
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type MyCaterdeskApiUser = {
  __typename?: 'MyCaterdeskApiUser';
  accounts: Array<MyCaterdeskApiEntityAccess>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  roles: Array<CaterdeskApiUserRole>;
  scopes: Array<CaterdeskApiUserScope>;
  tenantWideAccess: Scalars['Boolean']['output'];
  vendors: Array<MyCaterdeskApiEntityAccess>;
};

export type NavLink = {
  __typename?: 'NavLink';
  href: Maybe<Scalars['String']['output']>;
  ssgPage: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

export type NewAccountLocation = {
  __typename?: 'NewAccountLocation';
  address: Address;
  label: Maybe<Scalars['String']['output']>;
};

export type NewUserSignupInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  subscribeMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['String']['input'];
};

export type NewUserSignupResponse = {
  __typename?: 'NewUserSignupResponse';
  resetPasswordEmailSent: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type NotificationEvent = NotificationEventEmail | NotificationEventPush;

export type NotificationEventEmail = {
  __typename?: 'NotificationEventEmail';
  attachments: Array<NotificationEventEmailAttachment>;
  canPreview: Scalars['Boolean']['output'];
  contentHtml: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  hasAttachments: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  sentAt: Scalars['DateTime']['output'];
  status: NotificationEventEmailStatus;
  subject: Scalars['String']['output'];
};

export type NotificationEventEmailAttachment = {
  __typename?: 'NotificationEventEmailAttachment';
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  presignedUrl: Scalars['String']['output'];
};

export enum NotificationEventEmailStatus {
  Bounced = 'BOUNCED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Dropped = 'DROPPED',
  Processed = 'PROCESSED',
  Sent = 'SENT'
}

export type NotificationEventPush = {
  __typename?: 'NotificationEventPush';
  body: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sentAt: Scalars['DateTime']['output'];
  status: NotificationEventPushStatus;
  title: Scalars['String']['output'];
};

export enum NotificationEventPushStatus {
  Failed = 'FAILED',
  Sent = 'SENT'
}

export type NotificationHistoryInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sentAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  sentAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export enum NutSubAllergen {
  Almonds = 'almonds',
  Brazil = 'brazil',
  Cashew = 'cashew',
  Hazelnuts = 'hazelnuts',
  Macadamia = 'macadamia',
  Pecan = 'pecan',
  Pistachio = 'pistachio',
  Walnuts = 'walnuts'
}

export type OccasionDayMonth = {
  __typename?: 'OccasionDayMonth';
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
};

export type OccasionDayMonthInput = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
};

export type OptionItem = {
  __typename?: 'OptionItem';
  _id: Scalars['ID']['output'];
  /** All price items by customerPriceType */
  customerPriceItems: Maybe<Array<CustomerPriceItem>>;
  item: Maybe<MenuItem>;
  legacyItemId: Maybe<Scalars['Int']['output']>;
  /** The markup rate as a % */
  markupRate: Maybe<Scalars['Float']['output']>;
  /** The markup value in currency */
  markupValue: Scalars['Float']['output'];
  position: Maybe<Scalars['Int']['output']>;
  /** The price the vendor charges, inclusive of tax */
  price: Maybe<Scalars['Float']['output']>;
  /** The price the customer pays */
  priceCustomerFacing: Scalars['Float']['output'];
  /** The price the customer pays, exclusive of tax */
  priceCustomerFacingExTax: Scalars['Float']['output'];
  /** The price the vendor charges, exclusive of tax */
  priceExTax: Maybe<Scalars['Float']['output']>;
  /** The reduced commission rate as a % */
  reducedCommissionRate: Maybe<Scalars['Float']['output']>;
  /** The reduced commission value in currency */
  reducedCommissionValue: Scalars['Float']['output'];
  /** The standard commission rate as a % */
  standardCommissionRate: Maybe<Scalars['Float']['output']>;
  /** The standard commission value in currency */
  standardCommissionValue: Scalars['Float']['output'];
  /** The tax rate expressed as a decimal */
  taxRate: Scalars['Float']['output'];
  /** The monetary tax value on the price the vendor charges */
  taxValue: Maybe<Scalars['Float']['output']>;
  /** The monetary tax value on the price the customer pays */
  taxValueCustomerFacing: Scalars['Float']['output'];
};

export type OptionItemInput = {
  coreId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  markupRate?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  priceExTax?: InputMaybe<Scalars['Int']['input']>;
  reducedCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  standardCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  vatBandId?: InputMaybe<Scalars['Int']['input']>;
};

export enum OrderByProperties {
  CreatedAt = 'createdAt',
  DueDate = 'dueDate',
  PeriodEnd = 'periodEnd',
  Total = 'total'
}

export type OrderDeliveryUpdate = {
  __typename?: 'OrderDeliveryUpdate';
  deliveryStatus: Maybe<DeliveryStatus>;
  driver: Maybe<OrderDeliveryUpdateDriver>;
  etaDropoff: Maybe<Scalars['DateTime']['output']>;
  etaPickup: Maybe<Scalars['DateTime']['output']>;
  feedrOrderId: Scalars['ID']['output'];
};

export type OrderDeliveryUpdateDriver = {
  __typename?: 'OrderDeliveryUpdateDriver';
  location: Maybe<OrderDeliveryUpdateDriverLocation>;
};

export type OrderDeliveryUpdateDriverLocation = {
  __typename?: 'OrderDeliveryUpdateDriverLocation';
  lat: Maybe<Scalars['Float']['output']>;
  long: Maybe<Scalars['Float']['output']>;
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type OrderReferenceField = {
  __typename?: 'OrderReferenceField';
  description: Maybe<Scalars['String']['output']>;
  fieldType: ReferenceFieldType;
  id: Scalars['Int']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Array<OrderReferenceFieldOption>;
  referenceFieldId: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type OrderReferenceFieldFilterInput = {
  fieldType?: InputMaybe<ReferenceFieldType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  referenceFieldId?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderReferenceFieldInput = {
  /** Returns all fields matching the filters */
  filter?: InputMaybe<Array<OrderReferenceFieldFilterInput>>;
  /** Return all of the latest active order reference fields for the invoice account id */
  invoiceAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderReferenceFieldOption = {
  __typename?: 'OrderReferenceFieldOption';
  id: Scalars['Int']['output'];
  option: Scalars['String']['output'];
  orderPriority: Scalars['Int']['output'];
  orderReferenceFieldId: Scalars['Int']['output'];
};

export type OrderReferenceFieldResolvedValue = {
  __typename?: 'OrderReferenceFieldResolvedValue';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum OrderServiceType {
  BespokeEvents = 'bespokeEvents',
  CloudCanteen = 'cloudCanteen',
  OfflineMealPlan = 'offlineMealPlan',
  PantryFill = 'pantryFill',
  PopUps = 'popUps',
  ProductFees = 'productFees',
  Seasonal = 'seasonal',
  Standard = 'standard',
  UnknownValue = 'unknownValue'
}

export type OrderSupplierTag = {
  __typename?: 'OrderSupplierTag';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum OrderType {
  Cc = 'CC',
  Gm = 'GM'
}

export type OrderTypeAmount = {
  __typename?: 'OrderTypeAmount';
  amount: Scalars['Float']['output'];
  orderType: OrderType;
};

export enum OrderedItemOptionType {
  Numbers = 'numbers',
  Ticks = 'ticks'
}

export type OrdersReportInput = {
  countryCode: Scalars['String']['input'];
  dateRange: DateRangeTypeInput;
};

export type OrdersReportResult = {
  __typename?: 'OrdersReportResult';
  CC: OrdersReportResultCc;
  GM: OrdersReportResultGm;
};

export type OrdersReportResultCc = {
  __typename?: 'OrdersReportResultCC';
  customerOrders: Array<Maybe<CustomerOrderResult>>;
  supplierOrders: Array<Maybe<SupplierOrderResult>>;
};

export type OrdersReportResultGm = {
  __typename?: 'OrdersReportResultGM';
  customerOrders: Array<Maybe<CustomerOrderResult>>;
  supplierOrders: Array<Maybe<SupplierOrderResult>>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type PaginationInput = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PayByCardResponse = {
  __typename?: 'PayByCardResponse';
  authToken: Scalars['String']['output'];
};

export type PayByInvoiceResponse = {
  __typename?: 'PayByInvoiceResponse';
  orderId: Scalars['Int']['output'];
};

export type PayByTransferResponse = {
  __typename?: 'PayByTransferResponse';
  orderId: Scalars['Int']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  /**
   * The unique Identifier for the entity that receives the payment.
   * e.g. FEEDRUK
   */
  billingEntityCode: Scalars['NonEmptyString']['output'];
  currency: Currency;
  /** Lines of text to be displayed to the user in the payment page */
  descriptions: Array<Scalars['NonEmptyString']['output']>;
  /** Whether the payment is a hold rather than a charge. Payment holds are not captured automatically. */
  hold: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Line items to be displayed to the user in the payment page */
  lineItems: Array<LineItem>;
  /**
   * Identifier of the product the user is paying for
   * e.g. "INV-12345" or "CC-12345"
   */
  productIdentifier: Maybe<Scalars['NonEmptyString']['output']>;
  /**
   * Name of the product the user is paying for
   * e.g. "GM Order" or "Invoice"
   */
  productType: Maybe<Scalars['NonEmptyString']['output']>;
  /** Stripe publishable key for the payment */
  stripePublishableKey: Scalars['NonEmptyString']['output'];
  /** URL to redirect the user to if payment succeeds */
  successRedirectUrl: Scalars['URL']['output'];
  total: Scalars['PositiveInt']['output'];
  user: User;
};

export type PaymentAuthToken = {
  __typename?: 'PaymentAuthToken';
  expiryTimestamp: Scalars['Timestamp']['output'];
};

export type PaymentCard = {
  __typename?: 'PaymentCard';
  brand: Scalars['NonEmptyString']['output'];
  lastFourDigits: Scalars['NonEmptyString']['output'];
  stripeId: Scalars['ID']['output'];
};

export type PaymentHistory = {
  __typename?: 'PaymentHistory';
  amount: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  source: PaymentSource;
};

export enum PaymentMethod {
  Card = 'card',
  Invoice = 'invoice',
  Transfer = 'transfer'
}

export enum PaymentSource {
  Manual = 'MANUAL',
  Xero = 'XERO'
}

export enum PaymentStatus {
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export enum PaymentType {
  Card = 'Card',
  InvoiceAccount = 'InvoiceAccount'
}

export type PlatformAlert = {
  __typename?: 'PlatformAlert';
  countryCodes: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  portals: Array<PortalType>;
  severity: AlertSeverity;
  targetAccountIds: Array<Scalars['ID']['output']>;
  targetUserIds: Array<Scalars['ID']['output']>;
  targetVendorIds: Array<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformAlertConnection = {
  __typename?: 'PlatformAlertConnection';
  items: Array<PlatformAlert>;
  pageInfo: PlatformAlertPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PlatformAlertFilterInput = {
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  portals?: InputMaybe<Array<PortalType>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<AlertSeverity>;
};

export type PlatformAlertPageInfo = {
  __typename?: 'PlatformAlertPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PopularItem = {
  __typename?: 'PopularItem';
  accountCount: Maybe<Scalars['Int']['output']>;
  itemReference: Scalars['ID']['output'];
  orderCount: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
};

export enum PopularItemsScope {
  Account = 'ACCOUNT',
  Global = 'GLOBAL'
}

export enum PortalType {
  Catering = 'CATERING',
  CloudCanteen = 'CLOUD_CANTEEN',
  Customer = 'CUSTOMER',
  Vendor = 'VENDOR'
}

export type PriceLevels = {
  __typename?: 'PriceLevels';
  one: Maybe<Scalars['Int']['output']>;
  three: Maybe<Scalars['Int']['output']>;
  two: Maybe<Scalars['Int']['output']>;
};

export type PrivateSupplier = {
  __typename?: 'PrivateSupplier';
  supplierId: Scalars['Int']['output'];
  supplierName: Maybe<Scalars['String']['output']>;
};

export type ProposedGmOrderTotals = {
  __typename?: 'ProposedGmOrderTotals';
  discountBreakdown: GmOrderTaxBreakdown;
  fees: Array<GmOrderFeeBreakdown>;
  hasEnterpriseDiscount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  minimumOrderValue: Scalars['Int']['output'];
  orderPlacementCutOffTime: Scalars['DateTime']['output'];
  orderTotalBreakdown: GmOrderTaxBreakdown;
  subtotalExTax: Scalars['Int']['output'];
};

export type ProposedGmOrderTotalsInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  customDeliveryFee?: InputMaybe<Scalars['Float']['input']>;
  deliveryLat?: InputMaybe<Scalars['Float']['input']>;
  deliveryLng?: InputMaybe<Scalars['Float']['input']>;
  deliveryStartTime: Scalars['DateTime']['input'];
  discountNumeric?: InputMaybe<Scalars['Int']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  existingOrderId?: InputMaybe<Scalars['String']['input']>;
  headCount: Scalars['Int']['input'];
  paymentMethod?: InputMaybe<PaymentMethod>;
  productFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  proposedItems: Array<ProposedGmOrderTotalsInputItem>;
  tenantId: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['Int']['input']>;
  vendorLocationId: Scalars['Int']['input'];
  withThermalBoxes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposedGmOrderTotalsInputItem = {
  options?: InputMaybe<Array<ProposedGmOrderTotalsOptionItem>>;
  priceExTax: Scalars['Int']['input'];
  priceIncTax: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
  taxRate: Scalars['Float']['input'];
};

export type ProposedGmOrderTotalsOptionItem = {
  priceExTax: Scalars['Int']['input'];
  priceIncTax: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
  taxRate: Scalars['Float']['input'];
};

export enum Protein {
  Beef = 'beef',
  Fish = 'fish',
  Lamb = 'lamb',
  Plantbased = 'plantbased',
  Pork = 'pork',
  Poultry = 'poultry',
  Shellfish = 'shellfish'
}

export type PublishAllMenuItemPayload = {
  __typename?: 'PublishAllMenuItemPayload';
  failedIds: Array<Scalars['ID']['output']>;
  success: Array<PublishMenuItemPayload>;
};

export type PublishMenuItemPayload = {
  __typename?: 'PublishMenuItemPayload';
  id: Maybe<Scalars['ID']['output']>;
  publishedTimestamp: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Fetches account by id */
  account: Account;
  /** Fetches account location by id */
  accountLocation: AccountLocation;
  /** Fetches private suppliers for the specified accountId */
  accountPrivateSuppliers: AccountPrivateSuppliers;
  /** Search for accounts */
  accounts: AccountsPaged;
  /**
   * Get the highest-priority active alert for an authenticated user or vendor.
   * Applies full priority logic: severity > targeted (userId/accountId/vendorId match) > recency.
   * Unauthenticated callers should use latestActivePlatformAlert instead.
   * tenantId is optional - will be extracted from auth context.
   */
  activePlatformAlertForUser: Maybe<PlatformAlert>;
  /** Fetches credit transactions for a specific user (admin only) */
  adminUserCreditTransactions: CreditTransactionsPaged;
  admins: AdminsPaged;
  alertTenantConfig: AlertTenantConfig;
  alertTypes: Array<AlertType>;
  alerts: AlertsPaged;
  /** Find all accounts SSO settings by domain */
  allSsoSettingsByDomain: Maybe<Array<SsoSettings>>;
  /** To get all availale devlivery partner of a vendor location */
  availableDeliveryPartners: Maybe<Array<Maybe<DeliveryPartner>>>;
  billingEntities: Array<Maybe<BillingEntity>>;
  billingFields: Array<Maybe<BillingField>>;
  calculateVatForItem: VatCalculationResult;
  caterdeskApiScopes: CaterdeskApiScopeResponse;
  caterdeskApiUser: CaterdeskApiUserResponse;
  caterdeskApiUsers: CaterdeskApiUsersPaged;
  /** Fetches a cc cluster by id */
  ccCluster: CcCluster;
  /** Fetches multiple CC clusters */
  ccClusters: CcClustersPaged;
  ccMenuDebug: Array<CcMenuDebugTest>;
  /**
   * Fetches complete order confirmation details by transaction ID.
   * Returns order reference, items, pricing, and delivery information.
   *
   * Authorization: User must own the order being queried.
   */
  ccOrderByTransaction: CcOrderConfirmation;
  /** Fetch a cc order item by id */
  ccOrderItem: CcOrderItem;
  ccOrderProgress: CcOrderProgressResponse;
  /** Fetch a CC Supplier Order Notification for daily reminders */
  ccOrderReminderNotification: CcOrderReminderNotification;
  /**   Fetches a cc submenu by id */
  ccSubmenu: CcSubmenu;
  /** Fetches multiple CC submenus */
  ccSubmenus: CcSubmenusPaged;
  /** Fetches a cc supplier order by id */
  ccSupplierOrder: CcSupplierOrder;
  /** Fetches CCSupplierOrder by filter */
  ccSupplierOrders: CcSupplierOrderPaged;
  /** Fetches a single CC team by ID, scoped to the caller's account and tenant */
  ccTeam: CcTeam;
  /**
   * Returns subsidies for a CC team, scoped to the caller's tenant.
   * Meal-type subsidies are filtered to those with an active availability
   * window for the account. daily/week subsidies are returned unfiltered.
   * Requires admin or account manager role.
   */
  ccTeamSubsidies: Array<CcSubsidy>;
  /**
   * Fetches CC teams for the given account, scoped to the caller's tenant.
   * Pass includeDeleted: true to include soft-deleted teams.
   */
  ccTeams: Array<CcTeam>;
  ccVendorMenusDebug: Scalars['String']['output'];
  /**
   * Weekly reminder operational report: Mongo audit-backed runs, per-site rollups, and flat email/push outcomes.
   * **Auth:** admin session or internal GraphQL origin.
   * **Tenant:** defaults from auth context; for internal calls without tenant, pass `tenantId` (Mongo ObjectId string).
   * **Optional `accountId`:** restricts every list and recomputes counts to that account only.
   */
  ccWeeklyReminderReport: CcWeeklyReminderReport;
  cities: Array<City>;
  closestMatchingSupplierLocations: Maybe<ClosestMatchingSupplierLocationsResponse>;
  countries: Array<Country>;
  coupons: CouponsPaged;
  customerFlexInvoiceCSV: Scalars['String']['output'];
  customerFlexInvoicePDF: Scalars['String']['output'];
  customerOrdersReport: CustomerOrdersReport;
  /** Fast, summary-only version of customer orders for charting/analytics. */
  customerOrdersSummary: CustomerOrdersSummary;
  deliveryPartner: Maybe<DeliveryPartner>;
  deliveryPartners: Maybe<Array<Maybe<DeliveryPartner>>>;
  /** Fetches a delivery region for a vendor location by region id */
  deliveryRegion: DeliveryRegion;
  draftMenuItem: MenuItem;
  emmaAutomation: EmmaAutomation;
  emmaAutomations: Array<EmmaAutomation>;
  emmaCategories: Array<EmmaCategory>;
  emmaFormResponse: EmmaFormResponse;
  emmaFormResponses: EmmaFormResponsePaged;
  emmaOccasions: Array<EmmaOccasion>;
  emmaRecipes: Array<EmmaRecipe>;
  /** @deprecated Use verifyCoupon instead. */
  findCoupon: Maybe<Coupon>;
  flexInvoice: FlexInvoice;
  /** Fetches flex invoice account by id */
  flexInvoiceAccount: FlexInvoiceAccount;
  flexInvoiceAllTypes: FlexInvoiceAllTypesPaged;
  flexInvoices: FlexInvoicesPaged;
  getGeocode: GoogleGeocode;
  /** Get the logged in user performing the ghost */
  ghosterUser: Maybe<User>;
  gmAvailabilityById: GmAvailability;
  gmAvailabilityByVendorId: Maybe<GmAvailability>;
  gmBasket: Maybe<GmBasket>;
  gmBaskets: GmBasketPaged;
  gmIssues: Array<GmIssue>;
  gmItemSearch: Array<GmItemSearchResult>;
  gmOrder: GmOrder;
  gmOrderLite: Maybe<GmOrderLite>;
  gmOrders: GmOrderPaged;
  /**
   * Tenant-managed internal admin links.
   * tenantId is required for API-key/internal callers; derived from auth context for admins.
   */
  internalAdminTenantLinks: Array<TenantInternalAdminLink>;
  invoice: Invoice;
  /** Fetches invoice account by id */
  invoiceAccount: InvoiceAccount;
  invoiceCombined: CombinedInvoice;
  invoiceOrders: InvoiceOrdersPaged;
  invoices: InvoicesPaged;
  invoicesCombined: InvoicesCombinedPaged;
  isSendGridDomainValid: SendGridDomainStatus;
  languages: Array<LanguageData>;
  /**
   * Get the highest-priority untargeted active alert for a country and portal.
   * Unauthenticated callers must supply tenantId explicitly.
   * Authenticated users have tenantId derived from their auth context.
   * Only untargeted alerts are returned — use activePlatformAlertForUser for targeted alert support.
   */
  latestActivePlatformAlert: Maybe<PlatformAlert>;
  latestFlexConsolidationRun: FlexConsolidationRunStatus;
  liveMenuItem: MenuItem;
  liveMenuItems: MenuItemsPaged;
  lookupAddress: Maybe<LookupAddressResponse>;
  /** Fetches the currently logged in user */
  me: User;
  menuItemCategories: Array<MenuItemCategory>;
  menuItemGroup: MenuItemGroup;
  menuItemPriceSyncStatus: MenuItemPriceSyncStatusResponse;
  messageTemplates: MessageTemplatePaged;
  myCaterdeskApiUsers: Array<MyCaterdeskApiUser>;
  /**
   * The locations the signed-in vendor contact can access, not every location
   * the vendor has. Vendor requests only.
   */
  myVendorLocations: Array<VendorLocation>;
  notificationHistory: Maybe<UserNotificationHistoryPaged>;
  orderDeliveryUpdates: Array<OrderDeliveryUpdate>;
  /** Fetch reference fields based on a provided filter representing an AND OR array */
  orderReferenceFields: Array<OrderReferenceField>;
  ordersReport: OrdersReportResult;
  payment: Payment;
  paymentAuthToken: PaymentAuthToken;
  /**
   * Get a single platform alert by ID
   * tenantId is optional - will be extracted from auth context for admin users
   */
  platformAlert: Maybe<PlatformAlert>;
  /**
   * Get paginated list of platform alerts with optional filtering
   * tenantId is optional - will be extracted from auth context for admin users
   */
  platformAlerts: PlatformAlertConnection;
  proposedGmOrderTotals: ProposedGmOrderTotals;
  quoteCollection: Maybe<QuoteCollection>;
  quoteCollections: QuoteCollectionPaged;
  /** Fetch reference fields for an invoice account by invoice account id */
  referenceFields: ReferenceFieldsPaged;
  retrieveStripePublishableKey: Scalars['String']['output'];
  /**
   * Liveness/readiness signal for the reviews subgraph. Returns "ok" when the
   * service is serving GraphQL. Domain queries are added in later tickets.
   */
  reviewsServiceStatus: Scalars['String']['output'];
  sendgridIpPools: Array<SendGridIpPool>;
  serviceVatBand: VatBand;
  /** Fetches metadata for user signing up */
  signupMetadata: Maybe<SignupMetadata>;
  /** Find an accounts SSO settings by company code */
  ssoSettingsByCompanyCode: Maybe<SsoSettings>;
  /** Find an accounts SSO settings by domain */
  ssoSettingsByDomain: Maybe<SsoSettings>;
  standingOrder: Maybe<StandingOrder>;
  standingOrderPlacementProgressRecords: StandingOrderPlacementProgressRecordsPaged;
  standingOrderTemplate: GmBasket;
  standingOrders: Array<StandingOrder>;
  standingOrdersPage: StandingOrdersPage;
  /** @deprecated Use standingOrders instead */
  standingOrdersWithMenuItem: Array<StandingOrder>;
  stripeCustomerSession: Maybe<StripeCustomerSession>;
  summaryFlexReportCSV: Scalars['String']['output'];
  syncedInvoiceOrders: Array<Maybe<SyncedInvoiceOrdersResult>>;
  /** Fetches all tags */
  tags: TagsPaged;
  tempEmmaRandomUnreviewedItem: Maybe<MenuItem>;
  tenant: Maybe<Tenant>;
  tenants: TenantsPaged;
  timezoneForLatLng: Scalars['String']['output'];
  timezones: Array<Timezone>;
  /**
   * Catering-active vendors that deliver to any of the given locations, ranked by
   * catering (GM) rating — highest first, unrated last.
   */
  topRatedGmVendors: VendorsPaged;
  /** Fetches user by id */
  user: User;
  /** Fetches credit transactions for the authenticated user */
  userCreditTransactions: CcTransactionsPaged;
  /** Fetches all users */
  users: UsersPaged;
  vatBand: Maybe<VatBand>;
  vatBands: Array<VatBand>;
  vatRegion: Maybe<VatRegion>;
  vatRegions: Array<VatRegion>;
  /** Fetches a vendor by their ID */
  vendor: Vendor;
  /** Fetches a vendor by their permalink and optional tenantId */
  vendorByPermalink: Maybe<Vendor>;
  vendorCategoryItems: VendorCategoryItemsPage;
  /** Fetches all vendor contacts */
  vendorContacts: VendorContactsPaged;
  vendorFlexInvoice: VendorFlexInvoice;
  vendorFlexInvoiceAllTypes: VendorFlexInvoiceAllTypesPaged;
  vendorFlexInvoiceCSV: Scalars['String']['output'];
  vendorFlexInvoicePDF: Scalars['String']['output'];
  vendorFlexInvoices: VendorFlexInvoicesPaged;
  /** Get vendor highlight categories for a location */
  vendorHighlightsForLocation: VendorHighlightCategoriesForLocation;
  vendorInvoiceOrders: VendorInvoiceOrdersPaged;
  /** Fetches a vendor location by their ID */
  vendorLocation: VendorLocation;
  vendorMenuCategories: VendorMenuCategoryConnection;
  /** Fetches rating data for a vendor */
  vendorRating: Maybe<VendorRatingData>;
  vendorStatement: VendorStatement;
  vendorStatementCombined: CombinedVendorStatement;
  vendorStatements: VendorStatementsPaged;
  vendorStatementsCombined: VendorStatementsCombinedPaged;
  /** Fast, summary-only view of vendor statements for charting/analytics. */
  vendorStatementsSummary: VendorStatementsSummary;
  /** Public marketplace vendors query */
  vendors: VendorsPaged;
  /** Get vendor highlight category vendors for a location */
  vendorsForHighlightCategoryForLocation: VendorHighlightCategoryVendorsPaged;
  /** Get in-range locations for a list of vendors */
  vendorsInRangeLocations: Array<VendorInRangeLocations>;
  /** Fetches all vendors for internal purposes */
  vendorsList: VendorsListPaged;
  /** Fetches multiple vendors tags */
  vendorsTags: Maybe<Array<Maybe<VendorTag>>>;
  verifyCoupon: Maybe<Coupon>;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountPrivateSuppliersArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccountsArgs = {
  input: AccountSearch;
};


export type QueryActivePlatformAlertForUserArgs = {
  accountId: InputMaybe<Scalars['ID']['input']>;
  countryCode: Scalars['String']['input'];
  portal: PortalType;
  tenantId: InputMaybe<Scalars['ID']['input']>;
  userId: InputMaybe<Scalars['ID']['input']>;
  vendorId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminUserCreditTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryAdminsArgs = {
  input: InputMaybe<AdminSearch>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAlertsArgs = {
  input: InputMaybe<AlertsInput>;
};


export type QueryAllSsoSettingsByDomainArgs = {
  domain: Scalars['String']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  tenantId: InputMaybe<Scalars['String']['input']>;
};


export type QueryAvailableDeliveryPartnersArgs = {
  vendorLocationId: Scalars['Int']['input'];
};


export type QueryBillingEntitiesArgs = {
  input: BillingEntitiesInput;
};


export type QueryBillingFieldsArgs = {
  input: BillingFieldsInput;
};


export type QueryCalculateVatForItemArgs = {
  input: VatCalculationInput;
};


export type QueryCaterdeskApiScopesArgs = {
  caterdeskApiScopeId: InputMaybe<Scalars['String']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCaterdeskApiUserArgs = {
  email: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCaterdeskApiUsersArgs = {
  input: InputMaybe<CaterdeskApiUserSearch>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCcClusterArgs = {
  input: CcClusterInput;
};


export type QueryCcClustersArgs = {
  filters: InputMaybe<CcClusterListFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCcMenuDebugArgs = {
  input: CcMenuDebugInput;
};


export type QueryCcOrderByTransactionArgs = {
  transactionId: Scalars['String']['input'];
};


export type QueryCcOrderItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCcOrderProgressArgs = {
  progressId: Scalars['String']['input'];
};


export type QueryCcOrderReminderNotificationArgs = {
  accountId: Scalars['Int']['input'];
  date: InputMaybe<Scalars['String']['input']>;
};


export type QueryCcSubmenuArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCcSubmenusArgs = {
  filters: InputMaybe<FilterCcSubmenus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCcSupplierOrderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCcSupplierOrdersArgs = {
  input: CcSupplierOrdersInput;
};


export type QueryCcTeamArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCcTeamSubsidiesArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryCcTeamsArgs = {
  accountId: Scalars['Int']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCcVendorMenusDebugArgs = {
  input: CcVendorMenusDebugInput;
};


export type QueryCcWeeklyReminderReportArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  outcomeRowsLimit?: InputMaybe<Scalars['Int']['input']>;
  queryWindowEnd: Scalars['String']['input'];
  queryWindowStart: Scalars['String']['input'];
  tenantId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClosestMatchingSupplierLocationsArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  minutes: InputMaybe<Scalars['Int']['input']>;
  supplierLocationIds: Array<Scalars['Int']['input']>;
  transport: InputMaybe<TransportProfile>;
};


export type QueryCouponsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerFlexInvoiceCsvArgs = {
  invoiceId: Scalars['ID']['input'];
  invoiceType: FlexInvoiceType;
};


export type QueryCustomerFlexInvoicePdfArgs = {
  invoiceId: Scalars['ID']['input'];
  invoiceType: FlexInvoiceType;
};


export type QueryCustomerOrdersReportArgs = {
  input: InputMaybe<CustomerOrdersReportInput>;
};


export type QueryCustomerOrdersSummaryArgs = {
  input: CustomerOrdersReportInput;
};


export type QueryDeliveryPartnerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeliveryRegionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDraftMenuItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmmaAutomationArgs = {
  id: Scalars['ID']['input'];
  tenantId: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmmaAutomationsArgs = {
  filters: InputMaybe<EmmaAutomationFiltersInput>;
  tenantId: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmmaCategoriesArgs = {
  active: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEmmaFormResponseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmmaFormResponsesArgs = {
  input: InputMaybe<EmmaFormResponsesInput>;
};


export type QueryEmmaOccasionsArgs = {
  filters: InputMaybe<EmmaOccasionFilters>;
  tenantId: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindCouponArgs = {
  code: Scalars['String']['input'];
};


export type QueryFlexInvoiceArgs = {
  accountId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryFlexInvoiceAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFlexInvoiceAllTypesArgs = {
  input: InputMaybe<FlexInvoicesInput>;
};


export type QueryFlexInvoicesArgs = {
  input: InputMaybe<FlexInvoicesInput>;
};


export type QueryGetGeocodeArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type QueryGmAvailabilityByIdArgs = {
  availabilityId: Scalars['ID']['input'];
};


export type QueryGmAvailabilityByVendorIdArgs = {
  initialCategoryIds: InputMaybe<Array<Scalars['ID']['input']>>;
  initialItemLimit: InputMaybe<Scalars['Int']['input']>;
  vendorId: Scalars['ID']['input'];
};


export type QueryGmBasketArgs = {
  id: Scalars['ID']['input'];
  options: InputMaybe<GmBasketQueryOptions>;
};


export type QueryGmBasketsArgs = {
  filters: GmBasketsFilters;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGmIssuesArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryGmItemSearchArgs = {
  bestForTags: InputMaybe<Array<Scalars['String']['input']>>;
  cuisineTags: InputMaybe<Array<Scalars['String']['input']>>;
  dateTime: InputMaybe<GmItemSearchDateTimeInput>;
  dietaryTags: InputMaybe<Array<Scalars['String']['input']>>;
  diversityOfOwnershipTags: InputMaybe<Array<Scalars['String']['input']>>;
  headCount: InputMaybe<Scalars['Int']['input']>;
  highlightsTags: InputMaybe<Array<Scalars['String']['input']>>;
  keyDatesTags: InputMaybe<Array<Scalars['String']['input']>>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  occasionTags: InputMaybe<Array<Scalars['String']['input']>>;
  queryText: Scalars['String']['input'];
  supplierType: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type QueryGmOrderArgs = {
  id: Scalars['ID']['input'];
  options: InputMaybe<GmOrderQueryOptions>;
};


export type QueryGmOrderLiteArgs = {
  id: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryGmOrdersArgs = {
  filters: InputMaybe<GmOrdersFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  options: InputMaybe<GmOrderQueryOptions>;
  sortBy: InputMaybe<GmOrdersSortBy>;
};


export type QueryInternalAdminTenantLinksArgs = {
  tenantId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoiceAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoiceCombinedArgs = {
  accountId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryInvoiceOrdersArgs = {
  input: InputMaybe<InvoiceOrderInput>;
};


export type QueryInvoicesArgs = {
  input: InputMaybe<ListInvoicesInput>;
};


export type QueryInvoicesCombinedArgs = {
  accountId: Scalars['Int']['input'];
  deferredCustomerIds: InputMaybe<Array<Scalars['ID']['input']>>;
  input: InputMaybe<ListInvoicesInput>;
};


export type QueryIsSendGridDomainValidArgs = {
  input: SendGridDomainStatusInput;
};


export type QueryLatestActivePlatformAlertArgs = {
  countryCode: Scalars['String']['input'];
  portal: PortalType;
  tenantId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLatestFlexConsolidationRunArgs = {
  input: LatestFlexConsolidationRunInput;
};


export type QueryLiveMenuItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLiveMenuItemsArgs = {
  filters: InputMaybe<MenuItemFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLookupAddressArgs = {
  allowAnyCity?: InputMaybe<Scalars['Boolean']['input']>;
  correctLatLng: InputMaybe<Scalars['Boolean']['input']>;
  countries: InputMaybe<Array<CountryCode>>;
  country: InputMaybe<CountryCode>;
  includeTimezoneIdInResponse?: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  useGoogle: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMenuItemGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMenuItemPriceSyncStatusArgs = {
  input: MenuItemPriceSyncStatusInput;
};


export type QueryMessageTemplatesArgs = {
  filters: InputMaybe<MessageTemplatesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNotificationHistoryArgs = {
  input: InputMaybe<NotificationHistoryInput>;
};


export type QueryOrderDeliveryUpdatesArgs = {
  feedrOrderIds: Array<Scalars['String']['input']>;
};


export type QueryOrderReferenceFieldsArgs = {
  input: OrderReferenceFieldInput;
};


export type QueryOrdersReportArgs = {
  input: InputMaybe<OrdersReportInput>;
};


export type QueryPaymentArgs = {
  authToken: Scalars['JWT']['input'];
};


export type QueryPaymentAuthTokenArgs = {
  authToken: Scalars['JWT']['input'];
};


export type QueryPlatformAlertArgs = {
  id: Scalars['ID']['input'];
  tenantId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlatformAlertsArgs = {
  filter: InputMaybe<PlatformAlertFilterInput>;
  pagination: InputMaybe<PaginationInput>;
  tenantId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProposedGmOrderTotalsArgs = {
  input: ProposedGmOrderTotalsInput;
};


export type QueryQuoteCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuoteCollectionsArgs = {
  filters: QuoteCollectionsFilters;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReferenceFieldsArgs = {
  invoiceAccountId: Scalars['ID']['input'];
  options: InputMaybe<ReferenceFieldsOptionsInput>;
};


export type QueryRetrieveStripePublishableKeyArgs = {
  billingEntityCode: Scalars['String']['input'];
};


export type QueryServiceVatBandArgs = {
  vatRegionId: Scalars['ID']['input'];
};


export type QuerySignupMetadataArgs = {
  token: Scalars['ID']['input'];
};


export type QuerySsoSettingsByCompanyCodeArgs = {
  companyCode: Scalars['String']['input'];
  tenantId: InputMaybe<Scalars['String']['input']>;
};


export type QuerySsoSettingsByDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryStandingOrderArgs = {
  basketId: InputMaybe<Scalars['ID']['input']>;
  id: InputMaybe<Scalars['ID']['input']>;
  templateId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStandingOrderPlacementProgressRecordsArgs = {
  input: InputMaybe<StandingOrderPlacementProgressRecordSearch>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStandingOrderTemplateArgs = {
  id: Scalars['ID']['input'];
  options: InputMaybe<StandingOrderTemplateQueryOptions>;
};


export type QueryStandingOrdersArgs = {
  input: StandingOrdersInput;
};


export type QueryStandingOrdersPageArgs = {
  filters: InputMaybe<StandingOrdersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStandingOrdersWithMenuItemArgs = {
  menuItemId: Scalars['ID']['input'];
};


export type QueryStripeCustomerSessionArgs = {
  billingEntityCode: Scalars['String']['input'];
};


export type QuerySummaryFlexReportCsvArgs = {
  input: SummaryFlexReportCsvInput;
};


export type QuerySyncedInvoiceOrdersArgs = {
  input: InputMaybe<SyncedInvoiceOrdersInput>;
};


export type QueryTagsArgs = {
  filters: InputMaybe<VendorTagsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<Scalars['String']['input']>;
};


export type QueryTempEmmaRandomUnreviewedItemArgs = {
  input: InputMaybe<EmmaRandomUnreviewedItemInput>;
};


export type QueryTenantArgs = {
  input: TenantInput;
};


export type QueryTenantsArgs = {
  input: TenantsPagedInput;
};


export type QueryTimezoneForLatLngArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type QueryTopRatedGmVendorsArgs = {
  limit?: Scalars['Int']['input'];
  locations: Array<Coordinates>;
  offset?: Scalars['Int']['input'];
};


export type QueryUserArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryUserCreditTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersArgs = {
  input: InputMaybe<UserSearch>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVatBandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVatRegionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorByPermalinkArgs = {
  permalink: Scalars['String']['input'];
  tenantId: InputMaybe<Scalars['String']['input']>;
};


export type QueryVendorCategoryItemsArgs = {
  categoryId: Scalars['ID']['input'];
  filters: InputMaybe<VendorMenuFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorContactsArgs = {
  filters: InputMaybe<VendorContactFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVendorFlexInvoiceArgs = {
  countryCode: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QueryVendorFlexInvoiceAllTypesArgs = {
  input: InputMaybe<VendorFlexInvoicesInput>;
};


export type QueryVendorFlexInvoiceCsvArgs = {
  invoiceId: Scalars['ID']['input'];
  invoiceType: FlexInvoiceType;
};


export type QueryVendorFlexInvoicePdfArgs = {
  invoiceId: Scalars['ID']['input'];
  invoiceType: FlexInvoiceType;
};


export type QueryVendorFlexInvoicesArgs = {
  input: InputMaybe<VendorFlexInvoicesInput>;
};


export type QueryVendorHighlightsForLocationArgs = {
  filters: VendorHighlightCategoriesFilterInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location: Coordinates;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVendorInvoiceOrdersArgs = {
  input: InputMaybe<VendorInvoiceOrderInput>;
};


export type QueryVendorLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorMenuCategoriesArgs = {
  filters: InputMaybe<VendorMenuFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  previewLimit?: InputMaybe<Scalars['Int']['input']>;
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorRatingArgs = {
  input: InputMaybe<VendorRatingQueryInput>;
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorStatementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorStatementCombinedArgs = {
  countryCode: Scalars['String']['input'];
  deferredSupplierId: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryVendorStatementsArgs = {
  input: InputMaybe<ListVendorStatementsInput>;
};


export type QueryVendorStatementsCombinedArgs = {
  countryCode: Scalars['String']['input'];
  deferredSupplierId: InputMaybe<Scalars['String']['input']>;
  input: InputMaybe<ListVendorStatementsInput>;
};


export type QueryVendorStatementsSummaryArgs = {
  input: InputMaybe<ListVendorStatementsInput>;
};


export type QueryVendorsArgs = {
  filters: InputMaybe<VendorFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<VendorMarketplaceOrderByInput>;
  queryVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVendorsForHighlightCategoryForLocationArgs = {
  filters: InputMaybe<VendorHighlightCategoriesFilterInput>;
  highlightCategoryId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  location: Coordinates;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVendorsInRangeLocationsArgs = {
  input: VendorsInRangeLocationsInput;
};


export type QueryVendorsListArgs = {
  filters: InputMaybe<VendorListFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<VendorsOrderByInput>;
};


export type QueryVendorsTagsArgs = {
  filters: InputMaybe<VendorTagsFilters>;
  vendorIds: Array<Scalars['ID']['input']>;
};


export type QueryVerifyCouponArgs = {
  input: VerifyCouponInput;
};

export type QuoteCollection = {
  __typename?: 'QuoteCollection';
  account: Account;
  baskets: Array<GmBasket>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** ID of the EmmaAutomation, if any, used to create the quote collection */
  emmaAutomationId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type QuoteCollectionPaged = {
  __typename?: 'QuoteCollectionPaged';
  pageInfo: PageInfo;
  rows: Array<QuoteCollection>;
};

export type QuoteCollectionsFilters = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  emmaAutomationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteRequestBasket = {
  __typename?: 'QuoteRequestBasket';
  settings: QuoteRequestBasketSettings;
  user: QuoteRequestBasketUser;
};

export type QuoteRequestBasketContactInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type QuoteRequestBasketInput = {
  address: AddressInput;
  contact: QuoteRequestBasketContactInput;
};

export type QuoteRequestBasketSettings = {
  __typename?: 'QuoteRequestBasketSettings';
  account: Account;
  invoiceAccount: Maybe<InvoiceAccount>;
  location: GmServiceLocation;
};

export type QuoteRequestBasketUser = {
  __typename?: 'QuoteRequestBasketUser';
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  phone: Scalars['String']['output'];
};

export type RateCcOrderItemInput = {
  ccOrderItemId: Scalars['Int']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  maxRating: Scalars['Int']['input'];
  rating: Scalars['Int']['input'];
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId: Scalars['Int']['input'];
};

export type RateGmOrderInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
};

export enum Recurrence {
  Fortnightly = 'fortnightly',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export type ReferenceField = {
  __typename?: 'ReferenceField';
  /** Is the field active (e.g. turned on) to be shown for end users. */
  active: Scalars['Boolean']['output'];
  /** An optional description that can be shown with the field. */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Specifies whether the reference field will serve as the basis for invoice summarization. */
  isInvoiceSummaryField: Maybe<Scalars['Boolean']['output']>;
  /** The label of the field shown to end users. */
  label: Scalars['String']['output'];
  /** The options that are added for the dropdown and validated input type. */
  options: Array<ReferenceFieldOption>;
  /**
   * When the field is active, is it required to fill in this field
   * before placing the order.
   */
  required: Scalars['Boolean']['output'];
  /** The type of field that we will render (as specified in the enum). */
  type: ReferenceFieldType;
};

export type ReferenceFieldOption = {
  __typename?: 'ReferenceFieldOption';
  /** The unique ID of the reference field. */
  id: Scalars['ID']['output'];
  /** The actual option that is displayed to the user. */
  option: Scalars['String']['output'];
  /** The ordering priority for the option in a list. */
  orderPriority: Scalars['Int']['output'];
  /** The associated reference field ID the option is linked to. */
  referenceFieldId: Scalars['ID']['output'];
};

/** Reference field types will be added here as they are implemented. */
export enum ReferenceFieldType {
  Dropdown = 'DROPDOWN',
  FreeText = 'FREE_TEXT',
  ValidatedInput = 'VALIDATED_INPUT'
}

export type ReferenceFieldsOptionsInput = {
  /**
   * In the case that a write has taken place in the database and you are
   * retrieving this data from the database, you'll want to set this to
   * `true` to ensure that the fresh data is always returned.
   */
  requireFreshData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReferenceFieldsPaged = {
  __typename?: 'ReferenceFieldsPaged';
  rows: Array<ReferenceField>;
};

export type Refund = {
  __typename?: 'Refund';
  accountId: Scalars['Int']['output'];
  ccSupplierOrderId: Scalars['Int']['output'];
  fixedAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
};

export type RefundInput = {
  ccSupplierOrderId: Scalars['Int']['input'];
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  reason: Scalars['String']['input'];
  taxRate?: InputMaybe<Scalars['Float']['input']>;
};

export type RefundPaymentInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  paymentId: Scalars['ID']['input'];
};

export type RefundResult = {
  __typename?: 'RefundResult';
  amount: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  message: Maybe<Scalars['String']['output']>;
};

export enum RegionType {
  CustomPolygon = 'custom_polygon',
  CycleMinuteRadius = 'cycle_minute_radius',
  KilometerRadius = 'kilometer_radius',
  MileRadius = 'mile_radius'
}

export type RemoveFlexInvoiceOrder = {
  CC?: InputMaybe<CcInvoiceOrder>;
  GM?: InputMaybe<GmInvoiceOrder>;
};

export type RemoveOrdersFromFlexInvoiceInput = {
  countryCode: Scalars['String']['input'];
  orderIds: Array<Scalars['String']['input']>;
};

export type RemoveOrdersFromVendorFlexInvoiceInput = {
  countryCode: Scalars['String']['input'];
  orderIds: Array<Scalars['String']['input']>;
};

export enum RequiredTaxFields {
  GstNumber = 'gstNumber',
  VatNumber = 'vatNumber'
}

export type RestoreMenuItemOptions = {
  publish?: InputMaybe<Scalars['Boolean']['input']>;
  restoreLive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewCcOrderItemInput = {
  ccOrderItemId: Scalars['Int']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Star rating from 1 to 5. */
  rating: Scalars['Int']['input'];
};

export type SendGmMultiQuotesInput = {
  emails: Array<Scalars['String']['input']>;
  isReminder?: InputMaybe<Scalars['Boolean']['input']>;
  note: Scalars['String']['input'];
  quoteCollectionId: Scalars['ID']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type SendGmQuoteInput = {
  basketId: Scalars['ID']['input'];
  ccEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  emails: Array<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type SendGridDomainStatus = {
  __typename?: 'SendGridDomainStatus';
  isValid: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type SendGridDomainStatusInput = {
  domain: Scalars['String']['input'];
};

export type SendGridIpPool = {
  __typename?: 'SendGridIpPool';
  name: Scalars['String']['output'];
};

/** Result of the sync operation for an Instant GM order. */
export type SendInstantGmOrderToFlexResult = {
  __typename?: 'SendInstantGmOrderToFlexResult';
  /**
   * Status of the order sync operation.
   *
   * Possible values:
   * - "SUCCESS": The order was successfully synced.
   * - "FAILED_TO_SYNC": An error occurred during the sync process.
   */
  status: Scalars['String']['output'];
};

export type ServiceTime = {
  __typename?: 'ServiceTime';
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mealType: Meal;
  startTime: Scalars['String']['output'];
  weekdays: Array<Scalars['Int']['output']>;
};

export enum ServiceType {
  Cc = 'cc',
  Gm = 'gm'
}

export type SetMyCaterdeskApiUserPasswordInput = {
  id: Scalars['ID']['input'];
};

export type SetPasswordCaterdeskApiUserInput = {
  email: Scalars['String']['input'];
};

export type SetupIntent = {
  __typename?: 'SetupIntent';
  clientSecret: Maybe<Scalars['String']['output']>;
  customerSessionClientSecret: Maybe<Scalars['String']['output']>;
};

export enum SignUpType {
  Campaign = 'CAMPAIGN',
  JoinCanteenExisting = 'JOIN_CANTEEN_EXISTING',
  JoinCateringExisting = 'JOIN_CATERING_EXISTING',
  /** @deprecated use JOIN_CATERING_TEAM_ORDER; still returned for existing users */
  JoinCateringGroupOrder = 'JOIN_CATERING_GROUP_ORDER',
  JoinCateringTeamOrder = 'JOIN_CATERING_TEAM_ORDER',
  Marketplace = 'MARKETPLACE'
}

export type SignupConfirmationInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  ccActiveAccount?: InputMaybe<Scalars['Boolean']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type SignupMetadata = {
  __typename?: 'SignupMetadata';
  accountId: Maybe<Scalars['Int']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  subscribeNewsletter: Scalars['Boolean']['output'];
};

export enum Sort {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SsoSettings = {
  __typename?: 'SsoSettings';
  code: Scalars['String']['output'];
  /** For accounts sharing SSO providers we may have an override here */
  codeOverride: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StandingOrder = {
  __typename?: 'StandingOrder';
  _id: Scalars['ID']['output'];
  activeFrom: Scalars['DateTime']['output'];
  activeUntil: Maybe<Scalars['DateTime']['output']>;
  basketId: Scalars['String']['output'];
  communications: Communications;
  daysOfOccurrence: Array<Scalars['Int']['output']>;
  friendlyId: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nextDeliveryDate: Maybe<Scalars['DateTime']['output']>;
  nthOfMonthOccurrence: Maybe<Scalars['Int']['output']>;
  pausedFrom: Maybe<Scalars['DateTime']['output']>;
  pausedUntil: Maybe<Scalars['DateTime']['output']>;
  recurrence: Recurrence;
  standingOrderTemplate: GmBasket;
  templateId: Maybe<Scalars['String']['output']>;
  templateSettings: TemplateSettings;
};

export type StandingOrderInput = {
  activeFrom: Scalars['Date']['input'];
  activeUntil?: InputMaybe<Scalars['Date']['input']>;
  basketId: Scalars['String']['input'];
  communications: Communications;
  daysOfOccurrence: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  nthOfMonthOccurrence?: InputMaybe<Scalars['Int']['input']>;
  pausedFrom?: InputMaybe<Scalars['Date']['input']>;
  pausedUntil?: InputMaybe<Scalars['Date']['input']>;
  recurrence: Recurrence;
};

export type StandingOrderInvoicingRules = {
  __typename?: 'StandingOrderInvoicingRules';
  applyStandingOrderInvoicingRules: Maybe<Scalars['Boolean']['output']>;
  autoInvoice: Maybe<Scalars['Boolean']['output']>;
  consolidateInvoice: Maybe<Scalars['Boolean']['output']>;
  invoiceConsolidationFrequency: Maybe<InvoiceConsolidationFrequency>;
  invoiceEmailRecipientType: Maybe<InvoicePerOrderRecipientType>;
  referenceFieldLabelsForStandingOrderInvoice: Maybe<Array<Scalars['String']['output']>>;
  splitByContact: Maybe<Scalars['Boolean']['output']>;
  splitByReferenceFields: Maybe<Scalars['Boolean']['output']>;
};

export type StandingOrderInvoicingRulesInput = {
  applyStandingOrderInvoicingRules?: InputMaybe<Scalars['Boolean']['input']>;
  autoInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  consolidateInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceConsolidationFrequency?: InputMaybe<InvoiceConsolidationFrequency>;
  invoiceEmailRecipientType?: InputMaybe<InvoicePerOrderRecipientType>;
  referenceFieldLabelsForStandingOrderInvoice?: InputMaybe<Array<Scalars['String']['input']>>;
  splitByContact?: InputMaybe<Scalars['Boolean']['input']>;
  splitByReferenceFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandingOrderPlacementProgressData = {
  __typename?: 'StandingOrderPlacementProgressData';
  message: Scalars['String']['output'];
  time: Scalars['DateTime']['output'];
};

export type StandingOrderPlacementProgressRecord = {
  __typename?: 'StandingOrderPlacementProgressRecord';
  associatedOrders: GmOrderPaged;
  forDeliveryOn: Array<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  progressData: Array<StandingOrderPlacementProgressData>;
  runTime: Scalars['DateTime']['output'];
  standingOrder: StandingOrder;
  status: StandingOrderPlacementProgressStatus;
};

export type StandingOrderPlacementProgressRecordSearch = {
  runTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  runTimeUntil?: InputMaybe<Scalars['DateTime']['input']>;
  sortBy?: InputMaybe<StandingOrderPlacementProgressRecordSortBy>;
  standingOrderId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type StandingOrderPlacementProgressRecordSortBy = {
  order: StandingOrderPlacementProgressRecordSortOrder;
  term: StandingOrderPlacementProgressRecordSortTerm;
};

export enum StandingOrderPlacementProgressRecordSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum StandingOrderPlacementProgressRecordSortTerm {
  RunTime = 'runTime',
  StandingOrderId = 'standingOrderId',
  Status = 'status'
}

export type StandingOrderPlacementProgressRecordsPaged = {
  __typename?: 'StandingOrderPlacementProgressRecordsPaged';
  data: Array<StandingOrderPlacementProgressRecord>;
  pageInfo: PageInfo;
};

export enum StandingOrderPlacementProgressStatus {
  Failures = 'failures',
  Initiated = 'initiated',
  Skipped = 'skipped'
}

export type StandingOrderTemplateQueryOptions = {
  pricingAudience?: InputMaybe<GmOrderPricingAudience>;
};

export type StandingOrdersInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Find standing orders saved to a specific account location */
  accountLocationId?: InputMaybe<Scalars['Int']['input']>;
  accountManager?: InputMaybe<Scalars['String']['input']>;
  friendlyId?: InputMaybe<Scalars['String']['input']>;
  /** Find standing orders that contain a specific menu item */
  menuItemId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** Find standing orders saved to a specific vendor */
  vendorId?: InputMaybe<Scalars['Int']['input']>;
  /** Find standing orders saved to a specific vendor location */
  vendorLocationId?: InputMaybe<Scalars['Int']['input']>;
};

export type StandingOrdersPage = {
  __typename?: 'StandingOrdersPage';
  pageInfo: PageInfo;
  standingOrders: Maybe<Array<StandingOrder>>;
};

export type StartPaymentInput = {
  authToken: Scalars['JWT']['input'];
};

export type StartPaymentResult = {
  __typename?: 'StartPaymentResult';
  customerId: Scalars['NonEmptyString']['output'];
  ephemeralKey: Maybe<Scalars['NonEmptyString']['output']>;
  stripeClientSecret: Scalars['NonEmptyString']['output'];
};

export type Stripe = {
  __typename?: 'Stripe';
  /** The country code for the stripe */
  countryCode: Scalars['String']['output'];
  /** The fees for the stripe */
  fees: Maybe<StripeProcessingFees>;
};

export type StripeCustomerSession = {
  __typename?: 'StripeCustomerSession';
  clientSecret: Scalars['NonEmptyString']['output'];
  customerId: Scalars['NonEmptyString']['output'];
  ephemeralKey: Scalars['NonEmptyString']['output'];
};

export type StripeFees = {
  __typename?: 'StripeFees';
  fixedAmount: Maybe<Scalars['Float']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
};

export type StripeProcessingFees = {
  __typename?: 'StripeProcessingFees';
  domestic: Maybe<StripeFees>;
  international: Maybe<StripeFees>;
};

export type SubAllergenCereals = {
  __typename?: 'SubAllergenCereals';
  barley: Maybe<Scalars['Boolean']['output']>;
  kamut: Maybe<Scalars['Boolean']['output']>;
  oats: Maybe<Scalars['Boolean']['output']>;
  rye: Maybe<Scalars['Boolean']['output']>;
  wheat: Maybe<Scalars['Boolean']['output']>;
};

export type SubAllergenCerealsInput = {
  barley?: InputMaybe<Scalars['Boolean']['input']>;
  kamut?: InputMaybe<Scalars['Boolean']['input']>;
  oats?: InputMaybe<Scalars['Boolean']['input']>;
  rye?: InputMaybe<Scalars['Boolean']['input']>;
  wheat?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubAllergenNuts = {
  __typename?: 'SubAllergenNuts';
  almonds: Maybe<Scalars['Boolean']['output']>;
  brazil: Maybe<Scalars['Boolean']['output']>;
  cashew: Maybe<Scalars['Boolean']['output']>;
  hazelnuts: Maybe<Scalars['Boolean']['output']>;
  macadamia: Maybe<Scalars['Boolean']['output']>;
  pecan: Maybe<Scalars['Boolean']['output']>;
  pistachio: Maybe<Scalars['Boolean']['output']>;
  walnuts: Maybe<Scalars['Boolean']['output']>;
};

export type SubAllergenNutsInput = {
  almonds?: InputMaybe<Scalars['Boolean']['input']>;
  brazil?: InputMaybe<Scalars['Boolean']['input']>;
  cashew?: InputMaybe<Scalars['Boolean']['input']>;
  hazelnuts?: InputMaybe<Scalars['Boolean']['input']>;
  macadamia?: InputMaybe<Scalars['Boolean']['input']>;
  pecan?: InputMaybe<Scalars['Boolean']['input']>;
  pistachio?: InputMaybe<Scalars['Boolean']['input']>;
  walnuts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubAllergens = {
  __typename?: 'SubAllergens';
  cereals: Array<CerealSubAllergen>;
  nuts: Array<NutSubAllergen>;
};

export type SubsidyInput = {
  meal?: InputMaybe<MealType>;
  subsidy?: InputMaybe<Scalars['Decimal']['input']>;
  type: SubsidyType;
  weekday?: InputMaybe<Scalars['Int']['input']>;
};

export enum SubsidyType {
  Daily = 'daily',
  Meal = 'meal',
  Week = 'week'
}

export type SummaryFlexReportCsvInput = {
  adjustments?: InputMaybe<Scalars['Boolean']['input']>;
  country: Scalars['String']['input'];
  dateRange: DateRangeInput;
  reportType: SummaryFlexReportType;
};

export enum SummaryFlexReportType {
  Customers = 'customers',
  CustomersOnlyXeroV2 = 'customersOnlyXeroV2',
  CustomersXeroV2 = 'customersXeroV2',
  Suppliers = 'suppliers',
  SuppliersOnlyXeroV2 = 'suppliersOnlyXeroV2',
  SuppliersXeroV2 = 'suppliersXeroV2'
}

export type SupplierExternalId = {
  catalogueId?: InputMaybe<Scalars['String']['input']>;
  catalogueSectionId?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierExternalIdOutput = {
  __typename?: 'SupplierExternalIdOutput';
  catalogueId: Maybe<Scalars['String']['output']>;
  catalogueSectionId: Maybe<Scalars['String']['output']>;
  itemId: Maybe<Scalars['String']['output']>;
  variantId: Maybe<Scalars['String']['output']>;
};

export type SupplierOrderResult = {
  __typename?: 'SupplierOrderResult';
  flexDeferredSupplierOrderId: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
};

export type SyncCcInvoiceOrderWithFlex = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  ccSupplierOrderId?: InputMaybe<Scalars['Int']['input']>;
  ccSupplierOrderIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRangeTypeInput>;
  invoiceOrderFor?: InputMaybe<InvoiceOrderForInput>;
};

export type SyncGmInvoiceOrderWithFlex = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRangeTypeInput>;
  invoiceOrderFor?: InputMaybe<InvoiceOrderForInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SyncInvoiceOrderResult = {
  __typename?: 'SyncInvoiceOrderResult';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type SyncInvoiceOrderWithFlex = {
  CC?: InputMaybe<SyncCcInvoiceOrderWithFlex>;
  GM?: InputMaybe<SyncGmInvoiceOrderWithFlex>;
};

export type SyncMenuItemPricesInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  cursorItemId?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  maxBatches: Scalars['Int']['input'];
  setMarkupAndCommissionRates?: InputMaybe<SyncMenuItemPricesMarkupAndCommissionInput>;
  vatBandId?: InputMaybe<Scalars['String']['input']>;
  vendorIdArray?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SyncMenuItemPricesMarkupAndCommissionInput = {
  markupRate: Scalars['Float']['input'];
  reducedCommissionRate: Scalars['Float']['input'];
  standardCommissionRate: Scalars['Float']['input'];
};

export type SyncMenuItemPricesResponse = {
  __typename?: 'SyncMenuItemPricesResponse';
  syncJobId: Scalars['ID']['output'];
};

export type SyncedInvoiceOrdersInput = {
  CC?: InputMaybe<CcAllOrdersWithItemsInput>;
  GM?: InputMaybe<GmAllOrdersWithItemsInput>;
  InstantGM?: InputMaybe<InstantGmAllOrdersWithItemsInput>;
};

export type SyncedInvoiceOrdersResult = {
  __typename?: 'SyncedInvoiceOrdersResult';
  clientId: Maybe<Scalars['String']['output']>;
  contact: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  customerName: Maybe<Scalars['String']['output']>;
  deferredCustomerId: Maybe<Scalars['String']['output']>;
  deferredSupplierId: Maybe<Scalars['String']['output']>;
  deliveryDate: Maybe<Scalars['DateTime']['output']>;
  deliveryTimezone: Maybe<Scalars['String']['output']>;
  instant: Maybe<Scalars['Boolean']['output']>;
  lineItems: Array<InvoiceOrderLineItem>;
  number: Maybe<Scalars['String']['output']>;
  orderFor: Scalars['String']['output'];
  orderType: Scalars['String']['output'];
  placedBy: Maybe<Scalars['String']['output']>;
  shippingAddress: Maybe<Scalars['String']['output']>;
  shortCode: Maybe<Scalars['String']['output']>;
  supplier: Maybe<Scalars['String']['output']>;
  tenantId: Maybe<Scalars['String']['output']>;
};

export type TagsPaged = {
  __typename?: 'TagsPaged';
  pageInfo: PageInfo;
  rows: Array<VendorTag>;
};

export type TemplateSettings = {
  __typename?: 'TemplateSettings';
  vendor: AvailabilitiesVendor;
};

export type Tenant = {
  __typename?: 'Tenant';
  /** Accounting information */
  accounting: Maybe<TenantAccounting>;
  /** Get active alerts for specific countries and portals (for end-users) */
  activePlatformAlerts: Array<PlatformAlert>;
  billingEntities: Array<BillingEntity>;
  /** Vercel project id used for tenant client deployments */
  clientVercelProjectId: Scalars['String']['output'];
  /** Cognito configuration for this tenant */
  cognitoConfiguration: TenantCognitoConfiguration;
  /** Contact information for tenant */
  contact: Maybe<TenantContact>;
  /** Content Security Policy for the tenant */
  contentSecurityPolicy: TenantContentSecurityPolicy;
  /** The countries this tenant is available in */
  countries: Array<Scalars['String']['output']>;
  /** The locale to use a default */
  defaultLocale: Scalars['String']['output'];
  /** The primary domain for this tenant */
  domain: Scalars['String']['output'];
  /** Feature configuration for this tenant */
  features: Maybe<TenantFeatures>;
  /** A per tenant flag to use flex invoicing related invoicing pages */
  flexInvoicingFlags: Array<FlexInvoicingFlags>;
  flexInvoicingPaymentSettings: Array<FlexInvoicingPaymentSettings>;
  /** Guest accounts for GM Orders */
  guestAccountData: Array<TenantGuestAccount>;
  id: Scalars['ID']['output'];
  /** Integrations made within a tenant */
  integrations: Maybe<TenantIntegrations>;
  /** Tenant-managed links shown in the internal admin nav (PT-1974) */
  internalAdminLinks: Array<TenantInternalAdminLink>;
  /** Whether this tenant is a single vendor tenant */
  isSingleVendor: Scalars['Boolean']['output'];
  /**
   * Get the latest active platform alert for a specific country and portal
   * Returns the most recently updated active alert matching the criteria
   */
  latestActivePlatformAlert: Maybe<PlatformAlert>;
  /** Marketing configuration for this tenant */
  marketing: TenantMarketing;
  /** Mobile app configuration for this tenant */
  mobileApp: Maybe<TenantMobileApp>;
  /** The name of the tenant */
  name: Scalars['String']['output'];
  /** Payment settings for the tenant */
  payments: Maybe<TenantPayments>;
  /** List of permissions enabled or disabled per tenant */
  permissions: TenantPermissions;
  /** Get a single platform alert by ID for this tenant */
  platformAlert: Maybe<PlatformAlert>;
  /** Get paginated list of platform alerts for this tenant with optional filtering */
  platformAlerts: PlatformAlertConnection;
  slackAlertingConfigured: Scalars['Boolean']['output'];
  /** Transport types for this tenant */
  transportTypes: TenantTransportTypes;
  /** URI restrictions applicable at tenant level */
  uriRestrictedAccessRules: Array<UriRestrictedAccessRules>;
  /** Vercel project id used for tenant frontend deployments */
  vercelProjectId: Scalars['String']['output'];
};


export type TenantActivePlatformAlertsArgs = {
  countryCodes: Array<Scalars['String']['input']>;
  portals: Array<PortalType>;
};


export type TenantBillingEntitiesArgs = {
  input: BillingEntitiesInput;
};


export type TenantLatestActivePlatformAlertArgs = {
  countryCode: Scalars['String']['input'];
  portal: PortalType;
};


export type TenantPlatformAlertArgs = {
  id: Scalars['ID']['input'];
};


export type TenantPlatformAlertsArgs = {
  filter: InputMaybe<PlatformAlertFilterInput>;
  pagination: InputMaybe<PaginationInput>;
};

export type TenantAccounting = {
  __typename?: 'TenantAccounting';
  regions: Maybe<Array<Maybe<TenantAccountingRegions>>>;
};

export type TenantAccountingRegions = {
  __typename?: 'TenantAccountingRegions';
  countryCode: Scalars['String']['output'];
  glCodes: Maybe<Array<Maybe<GlCodes>>>;
};

export type TenantCateringAllergenTooltip = {
  __typename?: 'TenantCateringAllergenTooltip';
  visibility: Scalars['Boolean']['output'];
};

export type TenantCateringCoupons = {
  __typename?: 'TenantCateringCoupons';
  visibility: Scalars['Boolean']['output'];
};

export type TenantCateringFilters = {
  __typename?: 'TenantCateringFilters';
  allergens: Scalars['Boolean']['output'];
  dietary: Scalars['Boolean']['output'];
};

export type TenantCognitoConfiguration = {
  __typename?: 'TenantCognitoConfiguration';
  userPoolClientId: Scalars['String']['output'];
  userPoolDomain: Scalars['String']['output'];
  userPoolId: Scalars['String']['output'];
};

export type TenantContact = {
  __typename?: 'TenantContact';
  regions: Maybe<Array<Maybe<TenantContactRegions>>>;
};

export type TenantContactRegions = {
  __typename?: 'TenantContactRegions';
  countryCode: Scalars['String']['output'];
  email: Maybe<TenantContactRegionsEmail>;
  phone: Maybe<TenantContactRegionsPhone>;
};

export type TenantContactRegionsEmail = {
  __typename?: 'TenantContactRegionsEmail';
  default: Scalars['String']['output'];
  sales: Maybe<Scalars['String']['output']>;
  support: Maybe<Scalars['String']['output']>;
  vendors: Maybe<Scalars['String']['output']>;
};

export type TenantContactRegionsPhone = {
  __typename?: 'TenantContactRegionsPhone';
  default: Scalars['String']['output'];
  sales: Maybe<Scalars['String']['output']>;
  support: Maybe<Scalars['String']['output']>;
  vendors: Maybe<Scalars['String']['output']>;
};

export type TenantContentSecurityPolicy = {
  __typename?: 'TenantContentSecurityPolicy';
  connectSrc: Array<Scalars['String']['output']>;
  fontSrc: Array<Scalars['String']['output']>;
  frameSrc: Array<Scalars['String']['output']>;
  imgSrc: Array<Scalars['String']['output']>;
  mediaSrc: Array<Scalars['String']['output']>;
  scriptSrc: Array<Scalars['String']['output']>;
  styleSrc: Array<Scalars['String']['output']>;
};

export type TenantEmailDisclaimerText = {
  __typename?: 'TenantEmailDisclaimerText';
  /** The disclaimer text provided by tenants to display in platform emails to customers */
  disclaimerText: Scalars['String']['output'];
  /** The locale for the disclaimer text, e.g. en-gb */
  locale: Scalars['String']['output'];
};

export type TenantFeatures = {
  __typename?: 'TenantFeatures';
  calendarTopPicks: Maybe<TenantFeaturesCalendarTopPicks>;
  canCancelCateringInvoiceOrders: Scalars['Boolean']['output'];
  cateringAllergenTooltip: Maybe<TenantCateringAllergenTooltip>;
  cateringCoupons: Maybe<TenantCateringCoupons>;
  cateringFilters: Maybe<TenantCateringFilters>;
  /** @deprecated Renamed to cateringTeamOrder (PT-2299); both read the same setting. */
  cateringGroupOrdering: Maybe<TenantFeaturesCateringGroupOrdering>;
  /** Absent means team ordering is off for every country. */
  cateringTeamOrder: Maybe<TenantFeaturesCateringTeamOrder>;
  ccShowTimeslotWindow: Maybe<TenantFeaturesCcShowTimeslotWindow>;
  ccTopupAmounts: Maybe<TenantFeaturesCcTopupAmounts>;
  charityMeals: Maybe<TenantFeaturesCharityMeals>;
  emma: Maybe<TenantFeaturesEmma>;
  gmDeliveryTimeslots: TenantFeaturesGmDeliveryTimeslots;
  gmExpressCheckout: Maybe<TenantGmExpressCheckout>;
  gmHideDeliveryWindow: Maybe<TenantFeaturesGmHideDeliveryWindow>;
  gmShowFullAddress: Maybe<TenantFeaturesGmShowFullAddress>;
  menuItemAllergenAudit: Maybe<TenantFeaturesMenuItemAllergenAudit>;
  prerenderMarketplaceMenu: Maybe<TenantFeaturesPreRenderMarketplaceMenu>;
  printLabels: TenantPrintLabels;
  serviceOptions: Maybe<TenantServiceOptions>;
  vendorHelpCentre: Maybe<TenantFeaturesVendorHelpCentre>;
};

export type TenantFeaturesCalendarTopPicks = {
  __typename?: 'TenantFeaturesCalendarTopPicks';
  visibility: Scalars['Boolean']['output'];
};

export type TenantFeaturesCateringGroupOrdering = {
  __typename?: 'TenantFeaturesCateringGroupOrdering';
  visibility: Maybe<TenantFeaturesCateringGroupOrderingVisibility>;
};

export type TenantFeaturesCateringGroupOrderingVisibility = {
  __typename?: 'TenantFeaturesCateringGroupOrderingVisibility';
  regions: Array<Scalars['String']['output']>;
};

export type TenantFeaturesCateringTeamOrder = {
  __typename?: 'TenantFeaturesCateringTeamOrder';
  visibility: Maybe<TenantFeaturesCateringTeamOrderVisibility>;
};

export type TenantFeaturesCateringTeamOrderVisibility = {
  __typename?: 'TenantFeaturesCateringTeamOrderVisibility';
  /** ISO-2 country codes, lowercase like the tenant's `countries`, where customers can create team orders. Empty means off. */
  regions: Array<Scalars['String']['output']>;
};

export type TenantFeaturesCcShowTimeslotWindow = {
  __typename?: 'TenantFeaturesCcShowTimeslotWindow';
  visibility: Scalars['Boolean']['output'];
};

export type TenantFeaturesCcTopupAmounts = {
  __typename?: 'TenantFeaturesCcTopupAmounts';
  highestTopup: Maybe<Scalars['Int']['output']>;
  minimumTopup: Maybe<Scalars['Int']['output']>;
  topupValues: Array<Maybe<Scalars['Int']['output']>>;
};

export type TenantFeaturesCharityMeals = {
  __typename?: 'TenantFeaturesCharityMeals';
  visibility: TenantFeaturesCharityMealsVisibility;
};

export type TenantFeaturesCharityMealsVisibility = {
  __typename?: 'TenantFeaturesCharityMealsVisibility';
  regions: Array<Scalars['String']['output']>;
};

export type TenantFeaturesEmma = {
  __typename?: 'TenantFeaturesEmma';
  /** Emails used in emma quotes as a bcc address */
  bccAddresses: Maybe<Array<Scalars['String']['output']>>;
  /** Default supplier to use when generating baskets from zero-results requests */
  defaultSupplierId: Maybe<Scalars['Int']['output']>;
  /** Email used to send emma related emails */
  fromAddress: Maybe<Scalars['String']['output']>;
  /** Rules for handling Emma features and processes for specific regions */
  regionSpecificRules: Maybe<Array<TenantFeaturesEmmaRegionSpecificRules>>;
  /** Whether to show Subscribe to Updates Checkbox on Quote Request Form */
  showSubscribeToUpdatesCheckbox: Scalars['Boolean']['output'];
  /** Rules for handling suppliers used in Emma features and processes */
  supplierSpecificRules: Maybe<TenantFeaturesEmmaSupplierSpecificRules>;
  visibility: Scalars['Boolean']['output'];
};

export type TenantFeaturesEmmaRegionSpecificRules = {
  __typename?: 'TenantFeaturesEmmaRegionSpecificRules';
  /** Country code for the region e.g. gb, au */
  countryCode: Scalars['String']['output'];
  /** Time restraints to use per occasion when filtering items for algorithm responses, based on the requested event time */
  occasionItemTimeRestraints: Array<OccasionItemTimeRestraints>;
};

export type TenantFeaturesEmmaSupplierSpecificRules = {
  __typename?: 'TenantFeaturesEmmaSupplierSpecificRules';
  /** List of supplier IDs to use when running the Emma algorithm */
  allowedSupplierIds: Array<Scalars['Int']['output']>;
  /** Whether Emma algorithm should run using allowed suppliers, bypassing filtering */
  forceAllowedSuppliers: Scalars['Boolean']['output'];
  /** List of supplier IDs to skip when running the Emma algorithm. Superceded by any suppliers in allowedSupplierIds */
  prohibitedSupplierIds: Array<Scalars['Int']['output']>;
};

export type TenantFeaturesGmDeliveryTimeslots = {
  __typename?: 'TenantFeaturesGmDeliveryTimeslots';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type TenantFeaturesGmHideDeliveryWindow = {
  __typename?: 'TenantFeaturesGmHideDeliveryWindow';
  visibility: Scalars['Boolean']['output'];
};

export type TenantFeaturesGmShowFullAddress = {
  __typename?: 'TenantFeaturesGmShowFullAddress';
  visibility: Maybe<TenantFeaturesGmShowFullAddressVisibility>;
};

export type TenantFeaturesGmShowFullAddressVisibility = {
  __typename?: 'TenantFeaturesGmShowFullAddressVisibility';
  regions: Array<Scalars['String']['output']>;
};

export type TenantFeaturesMenuItemAllergenAudit = {
  __typename?: 'TenantFeaturesMenuItemAllergenAudit';
  /** Whether allergen acceptance audit tracking is enabled when publishing menu items */
  enabled: Scalars['Boolean']['output'];
};

export type TenantFeaturesPreRenderMarketplaceMenu = {
  __typename?: 'TenantFeaturesPreRenderMarketplaceMenu';
  permalinks: Array<Scalars['String']['output']>;
};

export type TenantFeaturesVendorHelpCentre = {
  __typename?: 'TenantFeaturesVendorHelpCentre';
  link: Scalars['String']['output'];
};

export type TenantGmExpressCheckout = {
  __typename?: 'TenantGmExpressCheckout';
  visibility: Scalars['Boolean']['output'];
};

export type TenantGuestAccount = {
  __typename?: 'TenantGuestAccount';
  /** Invoice account for the guest account */
  guestInvoiceAccountId: Maybe<Scalars['String']['output']>;
  /** Account id of the guest account */
  id: Scalars['String']['output'];
  /** Locale for the guest account */
  locale: Scalars['String']['output'];
};

export type TenantImageUpload = {
  __typename?: 'TenantImageUpload';
  fullUrl: Scalars['String']['output'];
  presignedUrl: Scalars['String']['output'];
};

export enum TenantImageUploadType {
  AssetAuthBackground = 'ASSET_AUTH_BACKGROUND',
  AssetMarketplaceHeader = 'ASSET_MARKETPLACE_HEADER',
  AssetOrderConfirmation = 'ASSET_ORDER_CONFIRMATION',
  AssetPlaceholder = 'ASSET_PLACEHOLDER',
  EmailBannerUrl = 'EMAIL_BANNER_URL',
  EmailBannerUrlAlt = 'EMAIL_BANNER_URL_ALT',
  EmailBannerUrlAlt1 = 'EMAIL_BANNER_URL_ALT1',
  EmailLogo = 'EMAIL_LOGO',
  LogoDefault = 'LOGO_DEFAULT',
  LogoFavicon = 'LOGO_FAVICON',
  LogoLoadingIndicator = 'LOGO_LOADING_INDICATOR',
  LogoRainbow = 'LOGO_RAINBOW',
  LogoWhite = 'LOGO_WHITE',
  OccasionImage = 'OCCASION_IMAGE'
}

export type TenantInput = {
  /** The id of the tenant to fetch */
  id: Scalars['ID']['input'];
};

export type TenantIntegrations = {
  __typename?: 'TenantIntegrations';
  acteol: Maybe<TenantIntegrationsActeol>;
  bingAds: Maybe<TenantIntegrationsBingAds>;
  flexInvoicingClients: Maybe<Array<FlexInvoicingClient>>;
  googleTagManager: Maybe<TenantIntegrationsGoogleTagManager>;
  hotjar: Maybe<TenantIntegrationsHotjar>;
  intercom: Maybe<TenantIntegrationsIntercom>;
  linkedIn: Maybe<TenantIntegrationsLinkedIn>;
  oneTrust: Maybe<TenantIntegrationsOneTrust>;
  orkestro: Maybe<TenantIntegrationsOrkestro>;
  posthog: Maybe<TenantIntegrationsPosthog>;
  segment: Maybe<TenantIntegrationsSegment>;
  svix: Maybe<TenantIntegrationsSvix>;
  vanillaBlue: Maybe<TenantIntegrationsVanillaBlue>;
  zendesk: Maybe<TenantIntegrationsZendesk>;
};

export type TenantIntegrationsActeol = {
  __typename?: 'TenantIntegrationsActeol';
  enabled: Scalars['Boolean']['output'];
};

export type TenantIntegrationsBingAds = {
  __typename?: 'TenantIntegrationsBingAds';
  tagId: Scalars['String']['output'];
};

export type TenantIntegrationsGoogleTagManager = {
  __typename?: 'TenantIntegrationsGoogleTagManager';
  containerId: Scalars['String']['output'];
};

export type TenantIntegrationsHotjar = {
  __typename?: 'TenantIntegrationsHotjar';
  regions: Maybe<Array<Maybe<TenantIntegrationsHotjarRegions>>>;
};

export type TenantIntegrationsHotjarRegions = {
  __typename?: 'TenantIntegrationsHotjarRegions';
  countryCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type TenantIntegrationsIntercom = {
  __typename?: 'TenantIntegrationsIntercom';
  regions: Maybe<Array<Maybe<TenantIntegrationsIntercomRegions>>>;
};

export type TenantIntegrationsIntercomRegions = {
  __typename?: 'TenantIntegrationsIntercomRegions';
  countryCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type TenantIntegrationsLinkedIn = {
  __typename?: 'TenantIntegrationsLinkedIn';
  pid: Scalars['Int']['output'];
};

export type TenantIntegrationsOneTrust = {
  __typename?: 'TenantIntegrationsOneTrust';
  id: Scalars['String']['output'];
};

export type TenantIntegrationsOrkestro = {
  __typename?: 'TenantIntegrationsOrkestro';
  enabled: Scalars['Boolean']['output'];
  regions: Maybe<Array<Maybe<TenantIntegrationsOrkestroRegions>>>;
};

export type TenantIntegrationsOrkestroRegions = {
  __typename?: 'TenantIntegrationsOrkestroRegions';
  countryCode: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type TenantIntegrationsPosthog = {
  __typename?: 'TenantIntegrationsPosthog';
  apiHost: Maybe<Scalars['String']['output']>;
  apiKey: Scalars['String']['output'];
};

export type TenantIntegrationsSegment = {
  __typename?: 'TenantIntegrationsSegment';
  clientWriteKey: Maybe<Scalars['String']['output']>;
  writeKey: Scalars['String']['output'];
};

export type TenantIntegrationsSvix = {
  __typename?: 'TenantIntegrationsSvix';
  appId: Scalars['String']['output'];
  appPortalUrls: Array<Scalars['String']['output']>;
};


export type TenantIntegrationsSvixAppPortalUrlsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type TenantIntegrationsVanillaBlue = {
  __typename?: 'TenantIntegrationsVanillaBlue';
  regions: Maybe<Array<Maybe<TenantIntegrationsVanillaBlueRegions>>>;
};

export type TenantIntegrationsVanillaBlueRegions = {
  __typename?: 'TenantIntegrationsVanillaBlueRegions';
  accountId: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  key: Scalars['String']['output'];
  supplierId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TenantIntegrationsZendesk = {
  __typename?: 'TenantIntegrationsZendesk';
  regions: Maybe<Array<Maybe<TenantIntegrationsZendeskRegions>>>;
};

export type TenantIntegrationsZendeskRegions = {
  __typename?: 'TenantIntegrationsZendeskRegions';
  countryCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type TenantInternalAdminLink = {
  __typename?: 'TenantInternalAdminLink';
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TenantMarketing = {
  __typename?: 'TenantMarketing';
  /** Generic image assets for this tenant */
  assets: Maybe<TenantMarketingAssets>;
  /** The marketing email configuration for this tenant */
  email: TenantMarketingEmail;
  /** Country-specific links for PDFs, emails, and other stuff */
  links: Array<TenantMarketingLink>;
  /** The logos for this tenant */
  logos: TenantMarketingLogos;
  /** The navigation links for account dashboard */
  navLinks: Array<TenantNavigationLink>;
  /** The marketing pages for this tenant */
  pages: Maybe<TenantMarketingPages>;
  /** The sitemaps for this tenant */
  sitemaps: Array<TenantMarketingSitemaps>;
  /** The theme for this tenant */
  theme: Maybe<TenantMarketingTheme>;
};

export type TenantMarketingAssets = {
  __typename?: 'TenantMarketingAssets';
  /** The background image to use for the auth page */
  authBackgroundImage: Maybe<Scalars['String']['output']>;
  /** The images to use for the marketplace header */
  marketplaceHeaderImages: Maybe<Array<Scalars['String']['output']>>;
  /** The image to use on the order confirmation page */
  orderConfirmationImage: Maybe<Scalars['String']['output']>;
  /** The image to use for a square placeholder image */
  placeholder: Maybe<Scalars['String']['output']>;
};

export type TenantMarketingEmail = {
  __typename?: 'TenantMarketingEmail';
  /** The banner URLs for different email templates. Used by the Notifications Service */
  bannerUrl: Maybe<Scalars['String']['output']>;
  bannerUrlAlt: Maybe<Scalars['String']['output']>;
  bannerUrlAlt1: Maybe<Scalars['String']['output']>;
  /** Disclaimer text to be included in emails per locale */
  emailDisclaimerText: Maybe<Array<TenantEmailDisclaimerText>>;
  /** The email address that emails will be sent from. Used by the Notifications Service */
  fromAddress: Scalars['String']['output'];
  /** The SendGrid IP Pool to use for sending emails */
  ipPoolName: Scalars['String']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
};

export type TenantMarketingLink = {
  __typename?: 'TenantMarketingLink';
  blog: Maybe<Scalars['String']['output']>;
  /** The country code, e.g. 'gb' */
  countryCode: Scalars['String']['output'];
  emailUs: Maybe<Scalars['String']['output']>;
  facebook: Maybe<Scalars['String']['output']>;
  faq: Maybe<Scalars['String']['output']>;
  instagram: Maybe<Scalars['String']['output']>;
  linkedin: Maybe<Scalars['String']['output']>;
  liveChat: Maybe<Scalars['String']['output']>;
  privacy: Scalars['String']['output'];
  requestAQuote: Maybe<Scalars['String']['output']>;
  /** Link for terms and condition */
  terms: Scalars['String']['output'];
  twitter: Maybe<Scalars['String']['output']>;
};

export type TenantMarketingLogos = {
  __typename?: 'TenantMarketingLogos';
  /** The default logo to use for the tenant */
  default: Scalars['String']['output'];
  /** The icon to show in the browser tab for the tenant */
  favicon: Scalars['String']['output'];
  /** The loading indicator to use for the tenant */
  loadingIndicator: Maybe<Scalars['String']['output']>;
  /** A rainbow logo to use for the tenant */
  rainbow: Maybe<Scalars['String']['output']>;
  /** The logo to use for the tenant when the background is dark */
  white: Maybe<Scalars['String']['output']>;
};

export type TenantMarketingPageRegions = {
  __typename?: 'TenantMarketingPageRegions';
  /** The country code, e.g. 'gb' */
  code: Scalars['String']['output'];
  /** The url to the marketing page for this region */
  url: Scalars['String']['output'];
};

export type TenantMarketingPages = {
  __typename?: 'TenantMarketingPages';
  /** A list of regions supported by the tenant with a url to their marketing page */
  regions: Array<TenantMarketingPageRegions>;
  /** The page to be shown when no locale is present. Likely a country switcher page. */
  rootUrl: Maybe<Scalars['String']['output']>;
  /** Whether or not to index this tenant in search engines */
  shouldIndex: Scalars['Boolean']['output'];
};

export type TenantMarketingSitemaps = {
  __typename?: 'TenantMarketingSitemaps';
  forceReplaceHostname: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TenantMarketingTheme = {
  __typename?: 'TenantMarketingTheme';
  palette: Maybe<TenantMarketingThemePalette>;
};

export type TenantMarketingThemePalette = {
  __typename?: 'TenantMarketingThemePalette';
  background: Maybe<TenantPaletteColorBackground>;
  common: Maybe<TenantPaletteColorCommon>;
  error: Maybe<TenantPaletteColorOptions>;
  info: Maybe<TenantPaletteColorOptions>;
  inverted: Maybe<TenantPaletteColorOptions>;
  primary: Maybe<TenantPaletteColorOptions>;
  secondary: Maybe<TenantPaletteColorOptions>;
  success: Maybe<TenantPaletteColorOptions>;
  text: Maybe<TenantPaletteColorText>;
  warning: Maybe<TenantPaletteColorOptions>;
};

export type TenantMobileApp = {
  __typename?: 'TenantMobileApp';
  appleAppStoreId: Maybe<Scalars['String']['output']>;
  bundleId: Scalars['String']['output'];
  /** Public App Store listing URL shown in the canteen app-promo card (PT-1680) */
  canteenAppStoreUrl: Maybe<Scalars['String']['output']>;
  /** Public Google Play listing URL shown in the canteen app-promo card (PT-1680) */
  canteenPlayStoreUrl: Maybe<Scalars['String']['output']>;
  easProjectId: Scalars['String']['output'];
  enabled: Maybe<Scalars['Boolean']['output']>;
  firebaseProjectId: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  integrations: Maybe<TenantMobileAppIntegrations>;
  merchantId: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  schemes: Array<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type TenantMobileAppIntegrations = {
  __typename?: 'TenantMobileAppIntegrations';
  zendesk: Maybe<TenantMobileAppIntegrationsZendesk>;
};

export type TenantMobileAppIntegrationsZendesk = {
  __typename?: 'TenantMobileAppIntegrationsZendesk';
  regions: Array<TenantMobileAppIntegrationsZendeskRegions>;
};

export type TenantMobileAppIntegrationsZendeskRegions = {
  __typename?: 'TenantMobileAppIntegrationsZendeskRegions';
  androidChannelKey: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  iosChannelKey: Scalars['String']['output'];
};

export type TenantNavigationLink = {
  __typename?: 'TenantNavigationLink';
  href: Maybe<Scalars['String']['output']>;
  subLinks: Maybe<Array<TenantNavigationSubLink>>;
  title: Scalars['String']['output'];
};

export type TenantNavigationSubLink = {
  __typename?: 'TenantNavigationSubLink';
  description: Maybe<Scalars['String']['output']>;
  href: Maybe<Scalars['String']['output']>;
  links: Maybe<Array<Maybe<NavLink>>>;
  sameTab: Maybe<Scalars['Boolean']['output']>;
  ssgPage: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  type: TenantNavigationSubLinkType;
};

export enum TenantNavigationSubLinkType {
  Callback = 'callback',
  Cell = 'cell',
  Link = 'link',
  Redirect = 'redirect'
}

export type TenantPaletteColorBackground = {
  __typename?: 'TenantPaletteColorBackground';
  default: Maybe<Scalars['String']['output']>;
  paper: Maybe<Scalars['String']['output']>;
};

export type TenantPaletteColorCommon = {
  __typename?: 'TenantPaletteColorCommon';
  black: Maybe<Scalars['String']['output']>;
  white: Maybe<Scalars['String']['output']>;
};

export type TenantPaletteColorOptions = {
  __typename?: 'TenantPaletteColorOptions';
  contrastText: Maybe<Scalars['String']['output']>;
  dark: Maybe<Scalars['String']['output']>;
  light: Maybe<Scalars['String']['output']>;
  main: Scalars['String']['output'];
};

export type TenantPaletteColorText = {
  __typename?: 'TenantPaletteColorText';
  disabled: Maybe<Scalars['String']['output']>;
  primary: Maybe<Scalars['String']['output']>;
  secondary: Maybe<Scalars['String']['output']>;
};

export type TenantPayments = {
  __typename?: 'TenantPayments';
  /** Global setting for the tenant to pass on credit card fees to customers/users */
  chargeCreditCardFee: Maybe<Scalars['Boolean']['output']>;
  /**
   * Per-country overrides for chargeCreditCardFee. A country with an entry here
   * uses that entry; a country without one falls back to chargeCreditCardFee.
   * Lets a single multi-country tenant charge in some countries and not others.
   */
  creditCardFeeFlags: Maybe<Array<CreditCardFeeFlag>>;
  /** Stripe Processing Fees */
  stripe: Maybe<Array<Maybe<Stripe>>>;
};

export type TenantPermissions = {
  __typename?: 'TenantPermissions';
  /** Enable users to pay for orders via credit card */
  allowCreditCardPayments: Scalars['Boolean']['output'];
  /** Enable users to pay for orders via direct bank transfer to the tenant */
  allowTransferPayments: Maybe<Scalars['Boolean']['output']>;
  /** Allow tenants users to sign in to the platform */
  allowUserSignIn: Scalars['Boolean']['output'];
  /**
   * Auto-populate the catering order "Placed by" field with the acting placer
   * (PT-1505). Off for tenants whose reporting needs placedBy human-owned
   * (PT-1871, EatFirst commission reports). Missing = on.
   */
  autoPopulatePlacedBy: Maybe<Scalars['Boolean']['output']>;
  /** New suppliers allowed to be created via Internal Admin */
  createVendors: Scalars['Boolean']['output'];
  /** Guests allowed to place orders via invoice for the tenant */
  guestCheckoutByInvoiceAccountGm: Maybe<Scalars['Boolean']['output']>;
};

export type TenantPrintLabels = {
  __typename?: 'TenantPrintLabels';
  CC: TenantPrintLabelsOptions;
  GM: TenantPrintLabelsOptions;
};

export type TenantPrintLabelsOptions = {
  __typename?: 'TenantPrintLabelsOptions';
  VPA4: Scalars['Boolean']['output'];
  VPDymo: Scalars['Boolean']['output'];
  VPPackage: Scalars['Boolean']['output'];
  VPSummary: Scalars['Boolean']['output'];
};

export type TenantServiceOptions = {
  __typename?: 'TenantServiceOptions';
  cutleryExtras: TenantServiceOptionsVisibility;
  staffServices: TenantServiceOptionsVisibility;
  visibility: Scalars['Boolean']['output'];
};

export type TenantServiceOptionsVisibility = {
  __typename?: 'TenantServiceOptionsVisibility';
  visibility: Scalars['Boolean']['output'];
};

export type TenantTransportType = {
  __typename?: 'TenantTransportType';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TenantTransportTypes = {
  __typename?: 'TenantTransportTypes';
  regions: Array<TenantTransportTypesRegion>;
};

export type TenantTransportTypesRegion = {
  __typename?: 'TenantTransportTypesRegion';
  countryCode: Scalars['String']['output'];
  types: Array<TenantTransportType>;
};

export type TenantsPaged = {
  __typename?: 'TenantsPaged';
  pageInfo: PageInfo;
  rows: Array<Tenant>;
};

export type TenantsPagedInput = {
  /** Amount of results to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Amount of results to skip */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum TimePeriod {
  Custom = 'CUSTOM',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type TimeRange = {
  __typename?: 'TimeRange';
  /** End time in 24 hour format */
  end: Scalars['String']['output'];
  /** Start time in 24 hour format */
  start: Scalars['String']['output'];
};

export type Timezone = {
  __typename?: 'Timezone';
  code: Scalars['String']['output'];
  countryCode: CountryCode;
  label: Scalars['String']['output'];
};

export type Translation = {
  __typename?: 'Translation';
  key: Scalars['String']['output'];
  language: Language;
  value: Scalars['String']['output'];
};

export enum TransportProfile {
  Cycling = 'Cycling',
  Driving = 'Driving',
  Walking = 'Walking'
}

export type UpdateAccountDomainInput = {
  domain: Scalars['String']['input'];
};

export type UpdateAccountFinanceSettingsInput = {
  additionalBillingNotes?: InputMaybe<Scalars['String']['input']>;
  allowMinTopUpCc: Scalars['Boolean']['input'];
  budgetCodeCc?: InputMaybe<Scalars['String']['input']>;
  budgetCodeGm?: InputMaybe<Scalars['String']['input']>;
  chargeCreditCardFee?: InputMaybe<Scalars['Boolean']['input']>;
  contractDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  contractDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  deliverySurchargeCc?: InputMaybe<Scalars['Int']['input']>;
  deliverySurchargeCcExTax?: InputMaybe<Scalars['Int']['input']>;
  enterpriseCostPlusPricing?: InputMaybe<Scalars['Boolean']['input']>;
  feeAndDiscountNotesGm?: InputMaybe<Scalars['String']['input']>;
  invoicingFormatGm: GmInvoicingFormat;
  isBudgetCodeMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  minMonthlyCateringSpendExTax?: InputMaybe<Scalars['Int']['input']>;
  minOrderValueCc?: InputMaybe<Scalars['Int']['input']>;
  minOrderValueCcExTax?: InputMaybe<Scalars['Int']['input']>;
  minPlatformFeeCc?: InputMaybe<Scalars['Int']['input']>;
  minPlatformFeeCcExTax?: InputMaybe<Scalars['Int']['input']>;
  minPlatformFeeCcMonthlyExTax?: InputMaybe<Scalars['Int']['input']>;
  minPlatformFeeGm?: InputMaybe<Scalars['Int']['input']>;
  orderValPercentEnterpriseDiscountGm?: InputMaybe<Scalars['Float']['input']>;
  orderValPercentPlatformFeeCc?: InputMaybe<Scalars['Float']['input']>;
  orderValPercentPlatformFeeGm?: InputMaybe<Scalars['Float']['input']>;
  paymentDueDaysAfterInvoice?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAccountIdentityProviderInput = {
  accountId: Scalars['ID']['input'];
  attributeMapping?: InputMaybe<Array<AccountIdentityProviderAttributeMappingInput>>;
  metadataXml?: InputMaybe<Scalars['String']['input']>;
  signUpCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountInput = {
  addPrimaryContact?: InputMaybe<AccountPrimaryContactInput>;
  /**
   * Assign a list of approved supplier IDs to a specific account.
   * This will determine how those suppliers are displayed in the marketplace when that account views it.
   */
  assignApprovedSuppliers?: InputMaybe<AssignApprovedSuppliersInput>;
  autoSendMenu?: InputMaybe<Scalars['Boolean']['input']>;
  autopilotEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  /** Create a new account location within this account */
  createAccountLocation?: InputMaybe<CreateAccountLocationInput>;
  currency?: InputMaybe<Currency>;
  /** Soft delete an account location within this account */
  deleteAccountLocation?: InputMaybe<DeleteAccountLocationInput>;
  domains?: InputMaybe<Array<UpdateAccountDomainInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  highRisk?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isCCActive?: InputMaybe<Scalars['Boolean']['input']>;
  isGMActive?: InputMaybe<Scalars['Boolean']['input']>;
  managerId?: InputMaybe<Scalars['Int']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  napkinsCutlery?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  removePrimaryContact?: InputMaybe<AccountPrimaryContactInput>;
  signUpCode?: InputMaybe<Scalars['String']['input']>;
  ssoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  topUpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an account location within this account */
  updateAccountLocation?: InputMaybe<UpdateAccountLocationInput>;
  updateUserInterfaceSettings?: InputMaybe<UpdateAccountUserInterfaceSettingsInput>;
};

/** Update data */
export type UpdateAccountLocationInput = {
  /** Address for the location */
  addressData?: InputMaybe<AccountLocationAddressInput>;
  /** The budget for the account location */
  budget?: InputMaybe<Scalars['Float']['input']>;
  /** Cluster ID to assign */
  clusterId?: InputMaybe<Scalars['String']['input']>;
  /** Contact preferences */
  contactPreferences?: InputMaybe<AccountLocationContactPreferencesInput>;
  /** Delivery preferences */
  deliveryPreferences?: InputMaybe<AccountLocationDeliveryPreferencesInput>;
  /** The id of the location to update */
  id: Scalars['ID']['input'];
  /** Whether the account is active for Cloud Canteen */
  isCCActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The label for the account location */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The menu coverage tolerance for the account location */
  menuCoverageTolerance?: InputMaybe<Scalars['Float']['input']>;
  /** Whether menu automation is opted out for this location */
  optOutMenuAutomation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** timezone */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountLocationReferenceFieldValueInput = {
  orderReferenceFieldId: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountLocationReferenceFieldsInput = {
  referenceFieldValues?: InputMaybe<Array<UpdateAccountLocationReferenceFieldValueInput>>;
};

export type UpdateAccountLocationVendorPreferencesInput = {
  blacklisted: Array<Scalars['Int']['input']>;
  preferred: Array<Scalars['Int']['input']>;
  updateAllLocationsInCluster?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAccountUserInterfaceSettingsInput = {
  hideCCPrices?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAdminUserInput = {
  /** The countries the admin has access to */
  countryFlags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAlertInput = {
  destinations?: InputMaybe<AlertDestinationsInput>;
  filters?: InputMaybe<Array<AlertFilterInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBasketItemInput = {
  acknowledgedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<BasketItemOptionInput>>;
  qty?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBillingEntityInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bankAccountData?: InputMaybe<Array<BankAccountDataInput>>;
  businessNumber?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  companyNumber?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  vatRegionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCcClusterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  demoCluster?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCcSubmenuInput = {
  copiable?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<UpdateCcSubmenuItemInput>>;
  locationCapacities?: InputMaybe<Array<UpdateCcSubmenuLocationCapacityInput>>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  visibleToClient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCcSubmenuItemInput = {
  ccVariationId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  itemCoreId: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

export type UpdateCcSubmenuLocationCapacityInput = {
  maxCapacity: Scalars['Int']['input'];
  vendorLocationId: Scalars['ID']['input'];
};

export type UpdateCcSupplierOrderReferenceFieldValueInput = {
  budgetCode?: InputMaybe<Scalars['String']['input']>;
  referenceFieldValues?: InputMaybe<Array<CcSupplierOrderReferenceFieldValueInput>>;
};

export type UpdateCcTeamInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateCreditCardFeeFlag = {
  countryCode: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type UpdateDeliveryRegionInput = {
  deliveryFee?: InputMaybe<DeliveryFeeInput>;
  minOrderValue?: InputMaybe<Scalars['Int']['input']>;
  minOrderValueExTax?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderPosition?: InputMaybe<Scalars['Int']['input']>;
  polygonCoordinates?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
  regionType?: InputMaybe<RegionType>;
  serviceTimes?: InputMaybe<Array<CreateServiceTimeInput>>;
  serviceType?: InputMaybe<ServiceType>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmmaFormInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  adminAssigned?: InputMaybe<EmmaFormResponseAdminUserInput>;
  allergens?: InputMaybe<EmmaFormAllergenInput>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  budgetType?: InputMaybe<EmmaFormBudgetType>;
  contact?: InputMaybe<EmmaFormContactInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  dietaryRequirements?: InputMaybe<EmmaFormDietaryRequirementInput>;
  drinks?: InputMaybe<Array<Scalars['String']['input']>>;
  equipment?: InputMaybe<Array<Scalars['String']['input']>>;
  eventStyle?: InputMaybe<Array<Scalars['String']['input']>>;
  foodServiceTime?: InputMaybe<Scalars['String']['input']>;
  hasAllergenOrDietaryRequirement?: InputMaybe<Scalars['Boolean']['input']>;
  headcount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  occasion?: InputMaybe<Scalars['String']['input']>;
  occasionSubTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  onsiteFacilities?: InputMaybe<Array<Scalars['String']['input']>>;
  requirements?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceStyle?: InputMaybe<Array<Scalars['String']['input']>>;
  servingType?: InputMaybe<EmmaFormServingType>;
  staffServiceTime?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<EmmaFormTemperature>;
  time?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFlexInvoiceAccountInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressPostcode?: InputMaybe<Scalars['String']['input']>;
  autoInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  autoPay?: InputMaybe<Scalars['Boolean']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  emailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  entityNumber?: InputMaybe<Scalars['String']['input']>;
  entityRegion?: InputMaybe<Scalars['String']['input']>;
  entityTaxNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceByPantryOrder?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceByStandingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceConsolidationFrequency?: InputMaybe<InvoiceConsolidationFrequency>;
  invoiceConsolidationType?: InputMaybe<InvoiceConsolidationType>;
  invoicePerContact?: InputMaybe<Scalars['Boolean']['input']>;
  invoicePerOrderRecipientType?: InputMaybe<InvoicePerOrderRecipientType>;
  invoicePerReferenceField?: InputMaybe<Scalars['Boolean']['input']>;
  invoicePerType?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  referenceFieldLabelsForInvoice?: InputMaybe<Array<Scalars['String']['input']>>;
  standingOrderInvoicingRules?: InputMaybe<StandingOrderInvoicingRulesInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  vatRegionId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFlexInvoiceDetailsInput = {
  accountAddress?: InputMaybe<Scalars['String']['input']>;
  accountBusinessNumber?: InputMaybe<Scalars['String']['input']>;
  accountContact?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountTaxNumber?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
};

export type UpdateFlexInvoicingFlags = {
  countryCode: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type UpdateFlexInvoicingPaymentSettingsInput = {
  chargeCreditCardFee?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode: Scalars['String']['input'];
  enableInvoicePaymentByCard?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['ID']['input'];
};

export type UpdateGlCodeServiceTypeOverride = {
  customerGLCode?: InputMaybe<Scalars['String']['input']>;
  serviceType: GmOrderType;
  vendorGLCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGmBasketConfigInput = {
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGmBasketInput = {
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  couponId?: InputMaybe<Scalars['Int']['input']>;
  customItems?: InputMaybe<Array<GmBasketCustomItemInput>>;
  customName?: InputMaybe<Scalars['String']['input']>;
  isCateringTeamOrder?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<BasketItemInput>>;
  logistics?: InputMaybe<GmServiceLogisticsInput>;
  options?: InputMaybe<GmServiceOptionsInput>;
  orderNotes?: InputMaybe<Scalars['String']['input']>;
  quoteCollectionId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<UpdateGmServiceSettingsInput>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  utmData?: InputMaybe<UtmTrackingDataInput>;
};

export type UpdateGmOrderAddItemInput = {
  liveItemId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<UpdateGmOrderAddItemOptionInput>>;
  quantity: Scalars['Int']['input'];
  variationId: Scalars['String']['input'];
};

export type UpdateGmOrderAddItemOptionInput = {
  optionCategoryId: Scalars['String']['input'];
  optionItemId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type UpdateGmOrderCustomItenInput = {
  commissionRate: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  descriptionLong?: InputMaybe<Scalars['String']['input']>;
  itemQuantity: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  priceCustomerFacingExTax: Scalars['Int']['input'];
  priceExTax: Scalars['Int']['input'];
  taxRate: Scalars['Float']['input'];
};

export type UpdateGmOrderDeliveryDateInput = {
  date: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type UpdateGmOrderDeliveryTimeslotInput = {
  timeslotEndHour: Scalars['Int']['input'];
  timeslotEndMinute: Scalars['Int']['input'];
  timeslotStartHour: Scalars['Int']['input'];
  timeslotStartMinute: Scalars['Int']['input'];
};

export type UpdateGmOrderInput = {
  addCustomItems?: InputMaybe<Array<UpdateGmOrderCustomItenInput>>;
  addItems?: InputMaybe<Array<UpdateGmOrderAddItemInput>>;
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  couponId?: InputMaybe<Scalars['String']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  logistics?: InputMaybe<UpdateGmOrderServiceLogisticsInput>;
  options?: InputMaybe<UpdateGmOrderServiceOptionsInput>;
  orderNotes?: InputMaybe<Scalars['String']['input']>;
  proposedTotalIncTax?: InputMaybe<Scalars['Int']['input']>;
  removeItems?: InputMaybe<Array<UpdateGmOrderRemoveItemInput>>;
  settings?: InputMaybe<UpdateGmOrderServiceSettingsInput>;
  updateItems?: InputMaybe<Array<UpdateGmOrderUpdateItemInput>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGmOrderMutationOptionsInput = {
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  notifyVendor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGmOrderRemoveItemInput = {
  orderItemId: Scalars['String']['input'];
};

export type UpdateGmOrderServiceLogisticsInput = {
  customDeliveryFee?: InputMaybe<Scalars['Int']['input']>;
  deliveryBy?: InputMaybe<DeliveryBy>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  transport?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGmOrderServiceOptionsInput = {
  addons?: InputMaybe<GmServiceAddonsInput>;
  budgetCode?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<GmServiceFormatInput>;
  isHighRisk?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<GmServiceNotesInput>;
  rep?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGmOrderServiceSettingsInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  accountLocationId?: InputMaybe<Scalars['String']['input']>;
  customProductFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  deliveryDate?: InputMaybe<UpdateGmOrderDeliveryDateInput>;
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  deliveryTimeSlot?: InputMaybe<UpdateGmOrderDeliveryTimeslotInput>;
  headCount?: InputMaybe<Scalars['Int']['input']>;
  invoiceAccountId?: InputMaybe<Scalars['String']['input']>;
  meetingRoom?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<GmOrderType>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  placedBy?: InputMaybe<Scalars['String']['input']>;
  referenceFieldValues?: InputMaybe<Array<GmReferenceFieldValueInput>>;
  vendorContactId?: InputMaybe<Scalars['String']['input']>;
  vendorLocationId?: InputMaybe<Scalars['String']['input']>;
  vendorPickupTime?: InputMaybe<UpdateGmOrderVendorPickupTimeInput>;
};

export type UpdateGmOrderUpdateItemInput = {
  commissionRate?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionLong?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<UpdateGmOrderUpdateItemOptionInput>>;
  orderItemId: Scalars['String']['input'];
  priceCustomerFacingExTax?: InputMaybe<Scalars['Int']['input']>;
  priceExTax?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  taxRate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateGmOrderUpdateItemOptionInput = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  optionCategoryId?: InputMaybe<Scalars['String']['input']>;
  optionItemId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type UpdateGmOrderVendorPickupTimeInput = {
  hour: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type UpdateGmServiceSettingsInput = {
  account?: InputMaybe<AvailabilitiesAccountInput>;
  basketSource?: InputMaybe<BasketSource>;
  billingAddress?: InputMaybe<GmServiceLocationInput>;
  billingAddressId?: InputMaybe<Scalars['Int']['input']>;
  billingAddressSameAsDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  customProductFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  deliveryTimeSlot?: InputMaybe<Scalars['String']['input']>;
  emmaAlgorithmResponseId?: InputMaybe<Scalars['String']['input']>;
  emmaAutomationTracking?: InputMaybe<EmmaAutomationTrackingInput>;
  emmaFormResponseId?: InputMaybe<Scalars['String']['input']>;
  feedrAdminApproved?: InputMaybe<Scalars['Boolean']['input']>;
  feedrCreated?: InputMaybe<Scalars['Boolean']['input']>;
  headCount?: InputMaybe<Scalars['Int']['input']>;
  invoiceAccountId?: InputMaybe<Scalars['Int']['input']>;
  isGuestBasket?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GmServiceLocationInput>;
  meetingRoom?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<GmOrderType>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  placedBy?: InputMaybe<Scalars['String']['input']>;
  placedByManuallyEdited?: InputMaybe<Scalars['Boolean']['input']>;
  referenceFieldValues?: InputMaybe<Array<GmReferenceFieldValueInput>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<AvailabilitiesVendorInput>;
  vendorPickupTime?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInvoiceAccountInput = {
  additionalEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  autoInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  businessNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoiceByPantryOrder?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceByStandingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceConsolidationFrequency?: InputMaybe<InvoiceConsolidationFrequency>;
  invoiceConsolidationType?: InputMaybe<InvoiceConsolidationType>;
  invoicePerContact?: InputMaybe<Scalars['Boolean']['input']>;
  invoicePerOrderRecipientType?: InputMaybe<InvoicePerOrderRecipientType>;
  invoicePerReferenceField?: InputMaybe<Scalars['Boolean']['input']>;
  invoicePerType?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  referenceFieldLabelsForInvoice?: InputMaybe<Array<Scalars['String']['input']>>;
  standingOrderInvoicingRules?: InputMaybe<StandingOrderInvoicingRulesInput>;
  vat?: InputMaybe<Scalars['String']['input']>;
  vatRegionId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateInvoiceInput = {
  billingDetails?: InputMaybe<BillingDetailsInput>;
  budgetCode?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  foodSalesDiscountPercent?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMenuItemGroupInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  occasions?: InputMaybe<Array<Scalars['String']['input']>>;
  occasionsReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  suitability?: InputMaybe<Array<MenuItemSuitabilityOccasionInput>>;
};

export type UpdateMenuItemGroupsInput = {
  id: Scalars['ID']['input'];
  update: UpdateMenuItemGroupInput;
};

export type UpdateMenuItemInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  categoryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  centegraProductId?: InputMaybe<Scalars['Int']['input']>;
  cuisineTag?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaries?: InputMaybe<Array<Scalars['String']['input']>>;
  group?: InputMaybe<Scalars['String']['input']>;
  groupReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCombo?: InputMaybe<Scalars['Boolean']['input']>;
  isHot?: InputMaybe<Scalars['Boolean']['input']>;
  isMenuItem?: InputMaybe<Scalars['Boolean']['input']>;
  isOption?: InputMaybe<Scalars['Boolean']['input']>;
  kitchenStation?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  macros?: InputMaybe<MacrosInput>;
  markupRate?: InputMaybe<Scalars['Float']['input']>;
  meta?: InputMaybe<UpdateMenuItemMetaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  occasions?: InputMaybe<Array<MenuItemOccasion>>;
  options?: InputMaybe<Array<MenuItemOptionCategoryInput>>;
  priceExTax?: InputMaybe<Scalars['Int']['input']>;
  proteins?: InputMaybe<Array<Scalars['String']['input']>>;
  reducedCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  requestToDelete?: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  standardCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  subAllergenCereals?: InputMaybe<SubAllergenCerealsInput>;
  subAllergenNuts?: InputMaybe<SubAllergenNutsInput>;
  supplierExternalId?: InputMaybe<SupplierExternalId>;
  translations?: InputMaybe<MenuItemTranslationsInput>;
  updateLive?: InputMaybe<Scalars['Boolean']['input']>;
  variations?: InputMaybe<Array<MenuItemVariationInput>>;
  vatBandId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMenuItemMetaInput = {
  categoryConfidence?: InputMaybe<Scalars['Float']['input']>;
  categoryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePlatformAlertInput = {
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  portals?: InputMaybe<Array<PortalType>>;
  severity?: InputMaybe<AlertSeverity>;
  targetAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetVendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReferenceFieldInput = {
  active: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  isInvoiceSummaryField?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  options: Array<UpdateReferenceFieldOptionInput>;
  required: Scalars['Boolean']['input'];
  type: ReferenceFieldType;
};

export type UpdateReferenceFieldOptionInput = {
  option: Scalars['String']['input'];
  orderPriority: Scalars['Int']['input'];
};

export type UpdateStandingOrderInput = {
  activeFrom?: InputMaybe<Scalars['Date']['input']>;
  activeUntil?: InputMaybe<Scalars['Date']['input']>;
  communications?: InputMaybe<Communications>;
  daysOfOccurrence?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nthOfMonthOccurrence?: InputMaybe<Scalars['Int']['input']>;
  pausedFrom?: InputMaybe<Scalars['Date']['input']>;
  pausedUntil?: InputMaybe<Scalars['Date']['input']>;
  recurrence?: InputMaybe<Recurrence>;
};

export type UpdateTenantAccounting = {
  regions: Array<UpdateTenantAccountingRegion>;
};

export type UpdateTenantAccountingGlCode = {
  id: Scalars['String']['input'];
  serviceTypeOverrides: Array<UpdateGlCodeServiceTypeOverride>;
};

export type UpdateTenantAccountingRegion = {
  countryCode: Scalars['String']['input'];
  glCodes: Array<UpdateTenantAccountingGlCode>;
};

export type UpdateTenantContact = {
  regions?: InputMaybe<Array<UpdateTenantContactRegion>>;
};

export type UpdateTenantContactEmail = {
  default?: InputMaybe<Scalars['String']['input']>;
  sales?: InputMaybe<Scalars['String']['input']>;
  support?: InputMaybe<Scalars['String']['input']>;
  vendors?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantContactPhone = {
  default?: InputMaybe<Scalars['String']['input']>;
  sales?: InputMaybe<Scalars['String']['input']>;
  support?: InputMaybe<Scalars['String']['input']>;
  vendors?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantContactRegion = {
  countryCode: Scalars['String']['input'];
  email?: InputMaybe<UpdateTenantContactEmail>;
  phone?: InputMaybe<UpdateTenantContactPhone>;
};

export type UpdateTenantContactRegionInput = {
  countryCode: Scalars['String']['input'];
  email?: InputMaybe<UpdateTenantContactEmail>;
  phone?: InputMaybe<UpdateTenantContactPhone>;
};

export type UpdateTenantContentSecurityPolicy = {
  connectSrc?: InputMaybe<Array<Scalars['String']['input']>>;
  fontSrc?: InputMaybe<Array<Scalars['String']['input']>>;
  frameSrc?: InputMaybe<Array<Scalars['String']['input']>>;
  imgSrc?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaSrc?: InputMaybe<Array<Scalars['String']['input']>>;
  scriptSrc?: InputMaybe<Array<Scalars['String']['input']>>;
  styleSrc?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateTenantFeatureCalendarTopPicks = {
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantFeatureCateringAllergenTooltip = {
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantFeatureCateringCoupons = {
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantFeatureCateringFilters = {
  allergens?: InputMaybe<Scalars['Boolean']['input']>;
  dietary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantFeatureCateringGroupOrdering = {
  visibility?: InputMaybe<UpdateTenantFeatureCateringGroupOrderingVisibility>;
};

export type UpdateTenantFeatureCateringGroupOrderingVisibility = {
  regions: Array<Scalars['String']['input']>;
};

export type UpdateTenantFeatureCateringTeamOrder = {
  visibility?: InputMaybe<UpdateTenantFeatureCateringTeamOrderVisibility>;
};

export type UpdateTenantFeatureCateringTeamOrderVisibility = {
  regions: Array<Scalars['String']['input']>;
};

export type UpdateTenantFeatureCcShowTimeslotWindow = {
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantFeatureCharityMeals = {
  visibility?: InputMaybe<UpdateTenantFeatureCharityMealsVisibility>;
};

export type UpdateTenantFeatureCharityMealsVisibility = {
  regions: Array<Scalars['String']['input']>;
};

export type UpdateTenantFeatureEmma = {
  showSubscribeToUpdatesCheckbox?: InputMaybe<Scalars['Boolean']['input']>;
  supplierSpecificRules?: InputMaybe<UpdateTenantFeatureEmmaSupplierSpecificRules>;
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantFeatureEmmaSupplierSpecificRules = {
  allowedSupplierIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  forceAllowedSuppliers?: InputMaybe<Scalars['Boolean']['input']>;
  prohibitedSupplierIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateTenantFeatureGmDeliveryTimeslots = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantFeatureGmExpressCheckout = {
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantFeatureGmHideDeliveryWindow = {
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantFeatureGmShowFullAddress = {
  visibility?: InputMaybe<UpdateTenantFeatureGmShowFullAddressVisibility>;
};

export type UpdateTenantFeatureGmShowFullAddressVisibility = {
  regions: Array<Scalars['String']['input']>;
};

export type UpdateTenantFeatureMenuItemAllergenAudit = {
  enabled: Scalars['Boolean']['input'];
};

export type UpdateTenantFeaturePrerenderMarketplaceMenu = {
  permalinks: Array<Scalars['String']['input']>;
};

export type UpdateTenantFeaturePrintLabels = {
  CC?: InputMaybe<UpdateTenantFeaturePrintLabelsOptions>;
  GM?: InputMaybe<UpdateTenantFeaturePrintLabelsOptions>;
};

export type UpdateTenantFeaturePrintLabelsOptions = {
  VPA4?: InputMaybe<Scalars['Boolean']['input']>;
  VPDymo?: InputMaybe<Scalars['Boolean']['input']>;
  VPPackage?: InputMaybe<Scalars['Boolean']['input']>;
  VPSummary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantFeatureServiceOptions = {
  cutleryExtras?: InputMaybe<UpdateTenantFeatureServiceOptionsVisibility>;
  staffServices?: InputMaybe<UpdateTenantFeatureServiceOptionsVisibility>;
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantFeatureServiceOptionsVisibility = {
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantFeatureVendorHelpCentre = {
  link?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantFeatures = {
  calendarTopPicks?: InputMaybe<UpdateTenantFeatureCalendarTopPicks>;
  canCancelCateringInvoiceOrders?: InputMaybe<Scalars['Boolean']['input']>;
  cateringAllergenTooltip?: InputMaybe<UpdateTenantFeatureCateringAllergenTooltip>;
  cateringCoupons?: InputMaybe<UpdateTenantFeatureCateringCoupons>;
  cateringFilters?: InputMaybe<UpdateTenantFeatureCateringFilters>;
  cateringTeamOrder?: InputMaybe<UpdateTenantFeatureCateringTeamOrder>;
  ccShowTimeslotWindow?: InputMaybe<UpdateTenantFeatureCcShowTimeslotWindow>;
  charityMeals?: InputMaybe<UpdateTenantFeatureCharityMeals>;
  emma?: InputMaybe<UpdateTenantFeatureEmma>;
  gmDeliveryTimeslots?: InputMaybe<UpdateTenantFeatureGmDeliveryTimeslots>;
  gmExpressCheckout?: InputMaybe<UpdateTenantFeatureGmExpressCheckout>;
  gmHideDeliveryWindow?: InputMaybe<UpdateTenantFeatureGmHideDeliveryWindow>;
  gmShowFullAddress?: InputMaybe<UpdateTenantFeatureGmShowFullAddress>;
  menuItemAllergenAudit?: InputMaybe<UpdateTenantFeatureMenuItemAllergenAudit>;
  prerenderMarketplaceMenu?: InputMaybe<UpdateTenantFeaturePrerenderMarketplaceMenu>;
  printLabels?: InputMaybe<UpdateTenantFeaturePrintLabels>;
  serviceOptions?: InputMaybe<UpdateTenantFeatureServiceOptions>;
  vendorHelpCentre?: InputMaybe<UpdateTenantFeatureVendorHelpCentre>;
};

export type UpdateTenantGuestAccountData = {
  guestInvoiceAccountId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export type UpdateTenantInput = {
  accounting?: InputMaybe<UpdateTenantAccounting>;
  clientVercelProjectId?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<UpdateTenantContact>;
  contentSecurityPolicy?: InputMaybe<UpdateTenantContentSecurityPolicy>;
  features?: InputMaybe<UpdateTenantFeatures>;
  flexInvoicingFlags?: InputMaybe<Array<UpdateFlexInvoicingFlags>>;
  guestAccountData?: InputMaybe<Array<UpdateTenantGuestAccountData>>;
  id: Scalars['ID']['input'];
  integrations?: InputMaybe<UpdateTenantIntegrations>;
  internalAdminLinks?: InputMaybe<Array<UpdateTenantInternalAdminLink>>;
  isSingleVendor?: InputMaybe<Scalars['Boolean']['input']>;
  marketing?: InputMaybe<UpdateTenantMarketing>;
  mobileApp?: InputMaybe<UpdateTenantMobileApp>;
  payments?: InputMaybe<UpdateTenantPayments>;
  permissions?: InputMaybe<UpdateTenantPermissions>;
  transportTypes?: InputMaybe<UpdateTenantTransportTypes>;
  vercelProjectId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantIntegrations = {
  googleTagManager?: InputMaybe<UpdateTenantIntegrationsGoogleTagManager>;
};

export type UpdateTenantIntegrationsGoogleTagManager = {
  containerId: Scalars['String']['input'];
};

export type UpdateTenantInternalAdminLink = {
  label: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UpdateTenantMarketing = {
  assets?: InputMaybe<UpdateTenantMarketingAssets>;
  email?: InputMaybe<UpdateTenantMarketingEmail>;
  links?: InputMaybe<Array<UpdateTenantMarketingLinks>>;
  logos?: InputMaybe<UpdateTenantMarketingLogos>;
  pages?: InputMaybe<UpdateTenantMarketingPages>;
  theme?: InputMaybe<UpdateTenantMarketingTheme>;
};

export type UpdateTenantMarketingAssets = {
  authBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  marketplaceHeaderImages?: InputMaybe<Array<Scalars['String']['input']>>;
  orderConfirmationImage?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantMarketingEmail = {
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  bannerUrlAlt?: InputMaybe<Scalars['String']['input']>;
  bannerUrlAlt1?: InputMaybe<Scalars['String']['input']>;
  emailDisclaimerText?: InputMaybe<Array<UpdateTenantMarketingEmailDisclaimerText>>;
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  ipPoolName?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantMarketingEmailDisclaimerText = {
  disclaimerText: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export type UpdateTenantMarketingLinks = {
  blog?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  emailUs?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  faq?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  liveChat?: InputMaybe<Scalars['String']['input']>;
  privacy: Scalars['String']['input'];
  requestAQuote?: InputMaybe<Scalars['String']['input']>;
  terms: Scalars['String']['input'];
  twitter?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantMarketingLogos = {
  default?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<Scalars['String']['input']>;
  loadingIndicator?: InputMaybe<Scalars['String']['input']>;
  rainbow?: InputMaybe<Scalars['String']['input']>;
  white?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantMarketingPages = {
  shouldIndex?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantMarketingPalette = {
  background?: InputMaybe<UpdateTenantPaletteColorBackground>;
  common?: InputMaybe<UpdateTenantPaletteColorCommon>;
  error?: InputMaybe<UpdateTenantPaletteColorOptions>;
  info?: InputMaybe<UpdateTenantPaletteColorOptions>;
  inverted?: InputMaybe<UpdateTenantPaletteColorOptions>;
  primary?: InputMaybe<UpdateTenantPaletteColorOptions>;
  secondary?: InputMaybe<UpdateTenantPaletteColorOptions>;
  success?: InputMaybe<UpdateTenantPaletteColorOptions>;
  text?: InputMaybe<UpdateTenantPaletteColorText>;
  warning?: InputMaybe<UpdateTenantPaletteColorOptions>;
};

export type UpdateTenantMarketingTheme = {
  palette?: InputMaybe<UpdateTenantMarketingPalette>;
};

export type UpdateTenantMobileApp = {
  /** http(s) URL; "" or null clears it, omitted leaves it unchanged */
  canteenAppStoreUrl?: InputMaybe<Scalars['String']['input']>;
  /** http(s) URL; "" or null clears it, omitted leaves it unchanged */
  canteenPlayStoreUrl?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  firebaseProjectId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantPaletteColorBackground = {
  default?: InputMaybe<Scalars['String']['input']>;
  paper?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantPaletteColorCommon = {
  black?: InputMaybe<Scalars['String']['input']>;
  white?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantPaletteColorOptions = {
  contrastText?: InputMaybe<Scalars['String']['input']>;
  dark?: InputMaybe<Scalars['String']['input']>;
  light?: InputMaybe<Scalars['String']['input']>;
  main?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantPaletteColorText = {
  disabled?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  secondary?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantPayments = {
  chargeCreditCardFee?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Upserted by countryCode. Countries absent from the list are left untouched,
   * so a single country can be changed without restating the others.
   */
  creditCardFeeFlags?: InputMaybe<Array<UpdateCreditCardFeeFlag>>;
};

export type UpdateTenantPermissions = {
  allowCreditCardPayments?: InputMaybe<Scalars['Boolean']['input']>;
  allowTransferPayments?: InputMaybe<Scalars['Boolean']['input']>;
  allowUserSignIn?: InputMaybe<Scalars['Boolean']['input']>;
  autoPopulatePlacedBy?: InputMaybe<Scalars['Boolean']['input']>;
  createVendors?: InputMaybe<Scalars['Boolean']['input']>;
  guestCheckoutByInvoiceAccountGm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTenantTransportType = {
  name: Scalars['String']['input'];
};

export type UpdateTenantTransportTypes = {
  regions: Array<UpdateTenantTransportTypesRegion>;
};

export type UpdateTenantTransportTypesRegion = {
  countryCode: Scalars['String']['input'];
  types: Array<UpdateTenantTransportType>;
};

export type UpdateUserAccountSettingsInput = {
  /** The cost centre for the user within their account - for invoicing purposes for larger companies */
  costCentre?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserAllergensInput = {
  /** The user is allergic to celery */
  celery?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to cereals */
  cereals?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to crustaceans */
  crustaceans?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to eggs */
  eggs?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to fish */
  fish?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to lupin */
  lupin?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to milk */
  milk?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to molluscs */
  molluscs?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to mustard */
  mustard?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to nuts */
  nuts?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to peanuts */
  peanuts?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to sesame */
  sesame?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to soybeans */
  soybeans?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is allergic to sulphur */
  sulphur?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserAutopilotSettingsInput = {
  /** Whether the user has autopilot enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user has opted in to Autopilot on Fridays */
  friday?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user has opted in to Autopilot on Mondays */
  monday?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user has opted in to Autopilot on Saturdays */
  saturday?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user has opted in to Autopilot on Sundays */
  sunday?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user has opted in to Autopilot on Thursdays */
  thursday?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user has opted in to Autopilot on Tuesdays */
  tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user can edit their own autopilot settings */
  userCanEdit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user has opted in to Autopilot on Wednesdays */
  wednesday?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserContactPreferencesInput = {
  /** User has opted to prefer to receive notifications via this method */
  notificationPreference?: InputMaybe<Scalars['String']['input']>;
  /** User has opted whether or not to receive notifications about their food deliveries */
  remindersDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  /** User has opted whether or not to receive notifications about upcoming orders only for which they have a subsidy available */
  remindersSubsidised?: InputMaybe<Scalars['Boolean']['input']>;
  /** User has opted whether or not to receive notifications about upcoming orders for which they do not have subsidy available */
  remindersUnsubsidised?: InputMaybe<Scalars['Boolean']['input']>;
  /** User has opted whether or not to receive weekly menu notifications */
  remindersWeekly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserDietaryPreferencesInput = {
  /** The user follows a halal diet */
  halal?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user follows a kosher diet */
  kosher?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user avoids refined sugar */
  refinedSugar?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is a vegan */
  vegan?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user is a vegetarian */
  vegetarian?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserInput = {
  /** The users account id */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** The users account location id */
  accountLocationId?: InputMaybe<Scalars['Int']['input']>;
  accountSettings?: InputMaybe<UpdateUserAccountSettingsInput>;
  contactPreferences?: InputMaybe<UpdateUserContactPreferencesInput>;
  /** The users email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The users first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoiceApproved?: InputMaybe<Scalars['Boolean']['input']>;
  languageSettings?: InputMaybe<UpdateUserLanguageSettingsInput>;
  /** The users last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingSettings?: InputMaybe<UpdateUserOnboardingSettingsInput>;
  /** The users phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The users last privacyAccepted date (as UTC DateTime) */
  privacyAccepted?: InputMaybe<Scalars['String']['input']>;
  /** Users role */
  role?: InputMaybe<Scalars['String']['input']>;
  signUpType?: InputMaybe<UserSignUpType>;
  subsidySettings?: InputMaybe<UpdateUserSubsidySettingsInput>;
  /** The users team id */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserLanguageSettingsInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserOnboardingSettingsInput = {
  /** true stamps ccAppPromoDismissedAt with now, false clears it, omitted leaves it unchanged */
  ccAppPromoDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /** User has completed cc onboarding */
  ccOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserSubsidySettingsInput = {
  /** User has a subsidy limit */
  unlimitedSubsidy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateVendorExternalUrlInput = {
  data: VendorExternalUrlInput;
  id: Scalars['String']['input'];
};

export type UpdateVendorFinanceSettingsInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingLine1?: InputMaybe<Scalars['String']['input']>;
  billingLine2?: InputMaybe<Scalars['String']['input']>;
  billingPostcode?: InputMaybe<Scalars['String']['input']>;
  branchCode?: InputMaybe<Scalars['String']['input']>;
  bsbNumber?: InputMaybe<Scalars['String']['input']>;
  businessNumber?: InputMaybe<Scalars['String']['input']>;
  chargeCommissionOnDeliveryFees?: InputMaybe<Scalars['Boolean']['input']>;
  financeContactId?: InputMaybe<Scalars['Int']['input']>;
  isVatRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  legacyVatRegionId?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMadeDaysAfterStatementEnd?: InputMaybe<Scalars['Int']['input']>;
  reducedCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  standardCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVendorFlexFinanceSettingsInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  additionalEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressPostcode?: InputMaybe<Scalars['String']['input']>;
  autoInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  branchCode?: InputMaybe<Scalars['String']['input']>;
  bsbNumber?: InputMaybe<Scalars['String']['input']>;
  chargeCommissionOnDeliveryFees?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmailAddress?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  entityNumber?: InputMaybe<Scalars['String']['input']>;
  entityRegion?: InputMaybe<Scalars['String']['input']>;
  entityTaxNumber?: InputMaybe<Scalars['String']['input']>;
  financeContactId?: InputMaybe<Scalars['Int']['input']>;
  invoiceLocationsSeparately?: InputMaybe<Scalars['Boolean']['input']>;
  isVatRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  legacyVatRegionId?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['Int']['input']>;
  reducedCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  standardCommissionRate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateVendorFlexInvoiceDetailsInput = {
  accountAddress?: InputMaybe<Scalars['String']['input']>;
  accountBankDetails?: InputMaybe<Scalars['String']['input']>;
  accountBusinessNumber?: InputMaybe<Scalars['String']['input']>;
  accountContact?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountTaxNumber?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
};

export type UpdateVendorInput = {
  addExternalUrl?: InputMaybe<VendorExternalUrlInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  financeSettings?: InputMaybe<UpdateVendorFinanceSettingsInput>;
  flexFinanceSettings?: InputMaybe<UpdateVendorFlexFinanceSettingsInput>;
  markupSettings?: InputMaybe<UpdateVendorMarkupSettingsInput>;
  updateExternalUrl?: InputMaybe<UpdateVendorExternalUrlInput>;
};

export type UpdateVendorMarkupSettingsInput = {
  /** The default markup percentage applied to all of the menu items that belong to the vendor */
  defaultMarkupPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type UriRestrictedAccessRules = {
  __typename?: 'UriRestrictedAccessRules';
  /** Optional redirect URI path to use in place of restriction */
  redirectUri: Maybe<Scalars['String']['output']>;
  /** URI path which is restricted for the tenant */
  uri: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  account: Maybe<Account>;
  accountLocation: Maybe<AccountLocation>;
  accountSettings: UserAccountSettings;
  allergens: UserAllergens;
  autopilotSettings: UserAutopilotSettings;
  /**
   * The viewer's delivered canteen items that have no review yet, earliest first.
   * pageInfo.count is the total awaiting feedback, not the size of this page.
   */
  ccItemsAwaitingReview: CcOrderItemsPaged;
  ccMenu: Maybe<CcMenuQueryResult>;
  ccOrders: CcUserOrdersPaged;
  contactPreferences: UserContactPreferences;
  /** When the user was archived (ISO 8601). Null while the user is active. */
  deletedAt: Maybe<Scalars['String']['output']>;
  dietaryPreferences: UserDietaryPreferences;
  /** The users email address */
  email: Scalars['String']['output'];
  /** The users first name */
  firstName: Scalars['String']['output'];
  flexDeferredCustomerId: Maybe<Scalars['String']['output']>;
  /** The users full name */
  fullName: Scalars['String']['output'];
  gmBaskets: GmBasketPaged;
  groupedOrderItemsByDate: Array<GroupedCcOrderItem>;
  /**
   * True once the user has at least one live (not deleted) canteen order line placed
   * from the mobile app (ccOrderItems.orderSource = MOBILE). Drives the web app-promo
   * card (PT-1680).
   */
  hasPlacedCcOrderViaMobile: Scalars['Boolean']['output'];
  hasPreviousGmOrders: Scalars['Boolean']['output'];
  hasSelectedPreferredLocation: Scalars['Boolean']['output'];
  /** The unique identifier of the user */
  id: Scalars['ID']['output'];
  intercomUserHash: Scalars['String']['output'];
  invoiceApproved: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isUser: Scalars['Boolean']['output'];
  isVendor: Scalars['Boolean']['output'];
  languageSettings: UserLanguageSettings;
  /** The users last name */
  lastName: Scalars['String']['output'];
  legacyAdminId: Maybe<Scalars['Int']['output']>;
  marketingOptIn: Scalars['Boolean']['output'];
  modules: Maybe<Array<Maybe<Modules>>>;
  nativeAppSettings: UserNativeAppSettings;
  notificationHistory: Maybe<UserNotificationHistoryPaged>;
  onboardingSettings: UserOnboardingSettings;
  /** The users phone number */
  phone: Maybe<Scalars['String']['output']>;
  privacyAccepted: Maybe<Scalars['String']['output']>;
  /** The users role in the account */
  role: Maybe<UserRole>;
  /** @deprecated Frontend uses stripe elements package so no longer required */
  savedCard: Maybe<PaymentCard>;
  subsidySettings: UserSubsidySettings;
  teamId: Maybe<Scalars['Int']['output']>;
  tenant: Tenant;
  upcomingCcMenus: Array<CcDateMealServiceData>;
  upcomingCcMenusFromOrders: Array<CcDateMealServiceData>;
  vendor: Maybe<Vendor>;
  wallet: UserWallet;
};


export type UserCcItemsAwaitingReviewArgs = {
  input: CcItemsAwaitingReviewInput;
};


export type UserCcMenuArgs = {
  input: CcMenuQueryInput;
};


export type UserCcOrdersArgs = {
  input: CcUserOrderQueryInput;
};


export type UserGmBasketsArgs = {
  filters: InputMaybe<GmBasketFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserGroupedOrderItemsByDateArgs = {
  input: GroupedCcOrderItemByDateInput;
};


export type UserNotificationHistoryArgs = {
  input: InputMaybe<UserNotificationHistoryInput>;
};

export type UserAccountSettings = {
  __typename?: 'UserAccountSettings';
  /** The cost centre for the user within their account - for invoicing purposes for larger companies */
  costCentre: Maybe<Scalars['String']['output']>;
};

export type UserAllergens = {
  __typename?: 'UserAllergens';
  /** The user is allergic to celery */
  celery: Scalars['Boolean']['output'];
  /** The user is allergic to cereals */
  cereals: Scalars['Boolean']['output'];
  /** The user is allergic to crustaceans */
  crustaceans: Scalars['Boolean']['output'];
  /** The user is allergic to eggs */
  eggs: Scalars['Boolean']['output'];
  /** The user is allergic to fish */
  fish: Scalars['Boolean']['output'];
  /** The user is allergic to lupin */
  lupin: Scalars['Boolean']['output'];
  /** The user is allergic to milk */
  milk: Scalars['Boolean']['output'];
  /** The user is allergic to molluscs */
  molluscs: Scalars['Boolean']['output'];
  /** The user is allergic to mustard */
  mustard: Scalars['Boolean']['output'];
  /** The user is allergic to nuts */
  nuts: Scalars['Boolean']['output'];
  /** The user is allergic to peanuts */
  peanuts: Scalars['Boolean']['output'];
  /** The user is allergic to sesame */
  sesame: Scalars['Boolean']['output'];
  /** The user is allergic to soybeans */
  soybeans: Scalars['Boolean']['output'];
  /** The user is allergic to sulphur */
  sulphur: Scalars['Boolean']['output'];
};

export type UserAutopilotSettings = {
  __typename?: 'UserAutopilotSettings';
  /** Checks if any days are enabled. */
  active: Scalars['Boolean']['output'];
  /** Whether Autopilot is enabled for this user. */
  enabled: Scalars['Boolean']['output'];
  /** Whether the user has opted in to Autopilot on Fridays */
  friday: Scalars['Boolean']['output'];
  /** Whether the user has opted in to Autopilot on Mondays */
  monday: Scalars['Boolean']['output'];
  /** Whether the user has opted in to Autopilot on Saturdays */
  saturday: Scalars['Boolean']['output'];
  /** Whether the user has opted in to Autopilot on Sundays */
  sunday: Scalars['Boolean']['output'];
  /** Whether the user has opted in to Autopilot on Thursdays */
  thursday: Scalars['Boolean']['output'];
  /** Whether the user has opted in to Autopilot on Tuesdays */
  tuesday: Scalars['Boolean']['output'];
  /** Whether this user has permission to edit their autopilot settings. */
  userCanEdit: Scalars['Boolean']['output'];
  /** Whether the user has opted in to Autopilot on Wednesdays */
  wednesday: Scalars['Boolean']['output'];
};

export type UserContactPreferences = {
  __typename?: 'UserContactPreferences';
  /** User has been selected as a primary contact for the account they belong to */
  isAccountPrimaryContact: Scalars['Boolean']['output'];
  /** User has opted to prefer to receive notifications via this method */
  notificationPreference: Scalars['String']['output'];
  /** User has opted whether or not to receive notifications about their food deliveries */
  remindersDeliveries: Scalars['Boolean']['output'];
  /** User has opted whether or not to receive notifications about upcoming orders only for which they have a subsidy available */
  remindersSubsidised: Scalars['Boolean']['output'];
  /** User has opted whether or not to receive notifications about upcoming orders for which they do not have subsidy available */
  remindersUnsubsidised: Scalars['Boolean']['output'];
  /** User has opted whether or not to receive weekly menu notifications */
  remindersWeekly: Scalars['Boolean']['output'];
};

export type UserDietaryPreferences = {
  __typename?: 'UserDietaryPreferences';
  /** The user follows a halal diet */
  halal: Scalars['Boolean']['output'];
  /** The user follows a kosher diet */
  kosher: Scalars['Boolean']['output'];
  /** The user avoids refined sugar */
  refinedSugar: Scalars['Boolean']['output'];
  /** The user is a vegan */
  vegan: Scalars['Boolean']['output'];
  /** The user is a vegetarian */
  vegetarian: Scalars['Boolean']['output'];
};

export enum UserFavouriteType {
  Supplier = 'SUPPLIER'
}

export type UserLanguageSettings = {
  __typename?: 'UserLanguageSettings';
  locale: Scalars['String']['output'];
};

export type UserNativeAppSettings = {
  __typename?: 'UserNativeAppSettings';
  /** User has used mobile app at least once */
  hasApp: Scalars['Boolean']['output'];
};

export type UserNotificationHistoryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserNotificationHistoryPaged = {
  __typename?: 'UserNotificationHistoryPaged';
  items: Array<NotificationEvent>;
  pageInfo: PageInfo;
};

export type UserOnboardingSettings = {
  __typename?: 'UserOnboardingSettings';
  /** User chose "Do not show again" on the canteen mobile-app promo card (PT-1680) */
  ccAppPromoDismissed: Scalars['Boolean']['output'];
  /** User has completed cc onboarding */
  ccOnboarded: Scalars['Boolean']['output'];
};

export enum UserOrderByProperties {
  Account = 'account',
  AccountLocation = 'accountLocation',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  Role = 'role'
}

export enum UserOrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum UserRole {
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER'
}

export type UserSearch = {
  /** Filter by account id */
  accountId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by account location id assigned to the user */
  accountLocationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user has autopilot enabled */
  autopilotEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether user has a role as an internal admin */
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** User ordering results by */
  orderBy?: InputMaybe<UsersOrderByInput>;
  /** User searching by name or email */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by archived state. Defaults to active users only.
   * ARCHIVED and ALL are restricted to Internal Admin and internal services.
   */
  status?: InputMaybe<UserStatusFilter>;
};

export enum UserSignUpType {
  Campaign = 'CAMPAIGN',
  JoinCanteenExisting = 'JOIN_CANTEEN_EXISTING',
  JoinCateringExisting = 'JOIN_CATERING_EXISTING',
  /** @deprecated use JOIN_CATERING_TEAM_ORDER; still returned for existing users */
  JoinCateringGroupOrder = 'JOIN_CATERING_GROUP_ORDER',
  JoinCateringTeamOrder = 'JOIN_CATERING_TEAM_ORDER',
  Marketplace = 'MARKETPLACE'
}

export enum UserStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Archived = 'ARCHIVED'
}

export type UserSubsidySettings = {
  __typename?: 'UserSubsidySettings';
  /** User has a subsidy limit */
  unlimitedSubsidy: Scalars['Boolean']['output'];
  /** ID of the user to whom the settings belong */
  userId: Scalars['ID']['output'];
};

export type UserWallet = {
  __typename?: 'UserWallet';
  /** User balance (used for Canteen) */
  balance: Scalars['Float']['output'];
};

export type UsersOrderByInput = {
  direction?: InputMaybe<UserOrderDirection>;
  property?: InputMaybe<UserOrderByProperties>;
};

export type UsersPaged = {
  __typename?: 'UsersPaged';
  pageInfo: PageInfo;
  rows: Array<User>;
};

export type UtmTrackingData = {
  __typename?: 'UtmTrackingData';
  campaign: Maybe<Scalars['String']['output']>;
  medium: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
};

export type UtmTrackingDataInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type VatBand = {
  __typename?: 'VatBand';
  id: Scalars['ID']['output'];
  invoiceItemEligible: Scalars['Boolean']['output'];
  legacyId: Maybe<Scalars['Int']['output']>;
  menuItemEligible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  vatRegion: VatRegion;
};

export type VatBandFilters = {
  invoiceItemEligible?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemEligible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VatCalculationInput = {
  itemPrice: Scalars['Int']['input'];
  priceIncludesVat?: InputMaybe<Scalars['Boolean']['input']>;
  vendorLocationId?: InputMaybe<Scalars['Int']['input']>;
};

export type VatCalculationResult = {
  __typename?: 'VatCalculationResult';
  legacyVatBandId: Scalars['Int']['output'];
  totalExVat: Scalars['Int']['output'];
  totalIncVat: Scalars['Int']['output'];
  totalVat: Scalars['Int']['output'];
  vatBandId: Scalars['String']['output'];
  vatRate: Scalars['Float']['output'];
};

export type VatRegion = {
  __typename?: 'VatRegion';
  businessNumberIdentifierName: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  legacyId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  taxAcronym: Scalars['String']['output'];
  vatBands: Array<VatBand>;
};


export type VatRegionVatBandsArgs = {
  filters: InputMaybe<VatBandFilters>;
};

export type VatSummary = {
  __typename?: 'VatSummary';
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
  vatBandId: Scalars['String']['output'];
  vatRate: Scalars['Float']['output'];
};

export enum Vehicle {
  Bicycle = 'bicycle',
  BicycleCargo = 'bicycle_cargo',
  Car = 'car',
  Large = 'large',
  Medium = 'medium',
  Motorcycle = 'motorcycle',
  Small = 'small',
  Van = 'van',
  VanSmall = 'van_small',
  Walk = 'walk',
  Xlarge = 'xlarge',
  Xsmall = 'xsmall'
}

export type Vendor = {
  __typename?: 'Vendor';
  /** A list of account IDs that have access to the vendor's private items. */
  accountIdsWithPrivateItemAccess: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Latest time vendor will accept breakfast orders */
  breakfastCutOff: Maybe<Scalars['Float']['output']>;
  /** The vendor's menu categories */
  categories: Array<Maybe<VendorCategory>>;
  cateringComposition: CateringMenuComposition;
  /**
   * The vendor's Cloud Canteen (CC) rating, averaged from rated CC order items.
   * Null when the vendor has no CC ratings yet. Distinct from `rating`, which is
   * the legacy Mongo-backed CC score.
   */
  ccRating: Maybe<Scalars['Float']['output']>;
  /** The number of Cloud Canteen (CC) ratings the vendor has. */
  ccTotalRatings: Maybe<Scalars['Int']['output']>;
  /** The company name of the vendor */
  companyName: Scalars['String']['output'];
  /** The contacts associated with the vendor, across all locations */
  contacts: Array<VendorContact>;
  /** Currency vendor operates in */
  currency: Maybe<Currency>;
  /** Full description of the vendor */
  descriptionFull: Maybe<Scalars['String']['output']>;
  /** Shorter description of the vendor */
  descriptionShort: Maybe<Scalars['String']['output']>;
  /** Latest time vendor will accept dinner orders */
  dinnerCutOff: Maybe<Scalars['Float']['output']>;
  draftMenuItem: MenuItem;
  draftMenuItems: MenuItemsPaged;
  draftMenuOptions: MenuItemsPaged;
  emmaSuitability: Maybe<VendorEmmaSuitability>;
  /** External urls */
  externalUrlData: VendorExternalUrlData;
  /** The finance settings of the vendor */
  financeSettings: VendorFinanceSettings;
  /** The new flex finance settings of the vendor */
  flexFinanceSettings: Maybe<VendorFlexFinanceSettings>;
  /** The full name for the vendor */
  fullName: Maybe<Scalars['String']['output']>;
  gmAvailability: Maybe<GmAvailability>;
  gmCategories: Array<GmMenuCategory>;
  /**
   * The vendor's catering (GM) rating, averaged from delivered GM order reviews.
   * Null when the vendor has no GM ratings yet.
   */
  gmRating: Maybe<Scalars['Float']['output']>;
  /** The number of catering (GM) ratings the vendor has. */
  gmTotalRatings: Maybe<Scalars['Int']['output']>;
  /** Desc */
  groupCode: Maybe<Scalars['String']['output']>;
  /** Guide price for a meal from the vendor */
  guidePrice: Maybe<Scalars['Float']['output']>;
  /**
   * Unknown original use
   * @deprecated legacy, not used
   */
  hasCeramics: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unknown original use
   * @deprecated legacy field no longer used
   */
  hasLabels: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier of the vendor */
  id: Scalars['ID']['output'];
  /** Images representing the vendor */
  images: Maybe<Array<Maybe<VendorImage>>>;
  /** In range locations based off delivery regions for the vendor for a specific service type */
  inRangeLocations: Array<VendorLocation>;
  /** Integration settings for the vendor e.g. centegra */
  integrationSettings: VendorIntegrationSettings;
  /**
   * Can be seen / purchased from on GM platform
   * @deprecated being replaced with more apt name, isGMDiscoverable, to avoid confusion
   */
  isActive: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the vendor is an approved supplier for the currently logged-in account. */
  isApprovedSupplier: Maybe<Scalars['Boolean']['output']>;
  /** Vendor is available for cloud canteen service */
  isCCActive: Maybe<Scalars['Boolean']['output']>;
  /** Vendor active for click and collect service */
  isClickAndCollectActive: Maybe<Scalars['Boolean']['output']>;
  /**
   * Old field - to mark vendor as ready for cloud canteen
   * @deprecated legacy field no longer in use
   */
  isDailyMenuReady: Maybe<Scalars['Boolean']['output']>;
  /** If the vendor is currently being created and is not yet live */
  isDraft: Maybe<Scalars['Boolean']['output']>;
  /** Usable by the Emma algorithm when generating the results */
  isEmmaDiscoverable: Scalars['Boolean']['output'];
  /** Vendor active for group meals (the isActive field is also used for this) */
  isGMActive: Maybe<Scalars['Boolean']['output']>;
  /** Can be seen / purchased from on GM platform */
  isGMDiscoverable: Scalars['Boolean']['output'];
  /** Vendor active for home delivery service */
  isHomeDeliveryActive: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if this vendor is a favourite for the logged on user */
  isMyFavourite: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the vendor is a pantry type */
  isPantry: Maybe<Scalars['Boolean']['output']>;
  /**
   * Populated when the vendor was returned as part of an item search result.
   * Null for all standard marketplace requests.
   */
  itemSearchMetadata: Maybe<ItemSearchMetadata>;
  /** Keywords for describing the vendor */
  keywords: Maybe<Scalars['String']['output']>;
  /** Vendor label preferences array */
  labelPreferences: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  liveMenuItem: MenuItem;
  liveMenuItems: MenuItemsPaged;
  liveMenuLastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  liveMenuOptions: MenuItemsPaged;
  /** Locations of the vendor */
  locations: Array<VendorLocation>;
  /** Url of logo image for vendor */
  logo: Maybe<Scalars['String']['output']>;
  /** Latest time vendor will accept lunch orders */
  lunchCutOff: Maybe<Scalars['Float']['output']>;
  /** Settings for markup applied to vendor menu items */
  markupSettings: VendorMarkupSettings;
  menuCsvDownload: MenuCsvDownload;
  menuItemGroups: MenuItemGroupsPaged;
  /**
   * Suppliers menu has been moved from postgres to mongodb
   * @deprecated Migration is complete now, no menu items in postgres
   */
  menuMigrated: Maybe<Scalars['Boolean']['output']>;
  /** Meta description for vendor page */
  metaDescription: Maybe<Scalars['String']['output']>;
  /** Meta title for vendor page */
  metaTitle: Maybe<Scalars['String']['output']>;
  modifierCategories: Array<Maybe<ModifierCategory>>;
  modifierCategory: ModifierCategory;
  /** Permalink text for the vendor */
  permalink: Maybe<Scalars['String']['output']>;
  popularItems: Array<PopularItem>;
  /** Shorthand prefix vendor code */
  prefix: Maybe<Scalars['String']['output']>;
  /** Rough price guide on scale of 1-3 */
  priceLevel: Maybe<Scalars['Int']['output']>;
  /** A postive quote from a customer about the vendors food */
  quote: Maybe<Scalars['String']['output']>;
  /** The name of the customer who provided a positive quote about the vendors food */
  quoteAuthor: Maybe<Scalars['String']['output']>;
  /** The vendor's rating based on reviews */
  rating: Maybe<Scalars['Float']['output']>;
  /** Date and time the vendor rating was last calculated */
  ratingCalculatedAt: Maybe<Scalars['String']['output']>;
  /** Last time a schedule was sent to vendor by Feedr team */
  scheduleSent: Maybe<Scalars['String']['output']>;
  /** Information about where the vendor sources their ingredients (provenenace, welfare etc) */
  sourcing: Maybe<Scalars['String']['output']>;
  statistics: MenuStatistics;
  /** Tags representing the vendor */
  tags: Maybe<Array<Maybe<VendorTag>>>;
  /** Additional information about the vendor that is not covered by other fields */
  tips: Maybe<Scalars['String']['output']>;
  topRatedMenuItems: MenuItemsPaged;
  /** The total number of ratings the vendor has */
  totalRatings: Maybe<Scalars['Int']['output']>;
  /** The translations for the appropriate vendor fields */
  translations: Maybe<Array<Translation>>;
  /** Date vendor was last updated */
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Vendor registered VAT number */
  vatNumber: Maybe<Scalars['String']['output']>;
  /**
   * Vendor finance statements for this supplier.
   * The vendor id is derived from this Vendor; filters control the statement scope.
   */
  vendorStatements: VendorStatementsPaged;
  /**
   * Fast, summary-only view of vendor statements for this supplier (weekly totals and total amount).
   * The vendor id is derived from this Vendor; filters control the statement scope.
   */
  vendorStatementsSummary: VendorStatementsSummary;
};


export type VendorDraftMenuItemArgs = {
  id: Scalars['ID']['input'];
};


export type VendorDraftMenuItemsArgs = {
  filters: InputMaybe<MenuItemFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<MenuItemOrderByInput>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type VendorDraftMenuOptionsArgs = {
  filters: InputMaybe<MenuItemFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<MenuItemOrderByInput>;
};


export type VendorEmmaSuitabilityArgs = {
  tenantId: Scalars['ID']['input'];
};


export type VendorInRangeLocationsArgs = {
  countryCode: InputMaybe<Scalars['String']['input']>;
  dateTime: InputMaybe<VendorListDateSearchInput>;
  headCount: InputMaybe<Scalars['Int']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  serviceType: ServiceType;
};


export type VendorLiveMenuItemArgs = {
  id: Scalars['ID']['input'];
};


export type VendorLiveMenuItemsArgs = {
  filters: InputMaybe<MenuItemFiltersInput>;
  language: InputMaybe<Language>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<MenuItemOrderByInput>;
};


export type VendorLiveMenuLastUpdatedAtArgs = {
  filters: InputMaybe<MenuLastUpdatedAtInput>;
};


export type VendorLiveMenuOptionsArgs = {
  filters: InputMaybe<MenuItemFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<MenuItemOrderByInput>;
};


export type VendorLocationsArgs = {
  isCCActive: InputMaybe<Scalars['Boolean']['input']>;
  isGMActive: InputMaybe<Scalars['Boolean']['input']>;
};


export type VendorMenuCsvDownloadArgs = {
  filters: InputMaybe<MenuItemFiltersInput>;
  input: MenuCsvDownloadInput;
};


export type VendorMenuItemGroupsArgs = {
  input: InputMaybe<MenuItemGroupsInput>;
};


export type VendorModifierCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type VendorPopularItemsArgs = {
  scope?: InputMaybe<PopularItemsScope>;
};


export type VendorRatingArgs = {
  input: InputMaybe<VendorRatingQueryInput>;
};


export type VendorTagsArgs = {
  filters: InputMaybe<VendorTagsFilters>;
};


export type VendorTopRatedMenuItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type VendorVendorStatementsArgs = {
  input: InputMaybe<ListVendorStatementsInput>;
};


export type VendorVendorStatementsSummaryArgs = {
  input: InputMaybe<ListVendorStatementsInput>;
};

export type VendorCategory = {
  __typename?: 'VendorCategory';
  /** The unique identifier of the vendor category */
  id: Scalars['ID']['output'];
  /** The name of the menu category */
  name: Maybe<Scalars['String']['output']>;
  /** The position of the category - the order they should appear in */
  position: Maybe<Scalars['Int']['output']>;
};

export type VendorCategoryItemsPage = {
  __typename?: 'VendorCategoryItemsPage';
  categoryId: Scalars['ID']['output'];
  items: Array<MenuItem>;
  pageInfo: VendorMenuItemsPageInfo;
};

export type VendorCharge = {
  __typename?: 'VendorCharge';
  ccSupplierOrderId: Scalars['Int']['output'];
  fixedAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
  vendorId: Scalars['Int']['output'];
};

export type VendorContact = {
  __typename?: 'VendorContact';
  /** Contact type */
  contactTypes: Array<Scalars['String']['output']>;
  /** Email address of the contact */
  email: Maybe<Scalars['String']['output']>;
  /** Full name of the contact */
  fullName: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the vendor contact */
  id: Scalars['Int']['output'];
  /** Selected locale of the contact */
  locale: Scalars['String']['output'];
  /** Phone number */
  phone: Maybe<Scalars['String']['output']>;
  /** Tenant id of which the contact belongs to */
  tenantId: Scalars['String']['output'];
  /** Supplier id of which the contact belongs to */
  vendor: Maybe<Vendor>;
};

export type VendorContactFilters = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<VendorContactType>>;
};

export enum VendorContactType {
  Finance = 'finance',
  Order = 'order',
  Other = 'other',
  Schedule = 'schedule'
}

export type VendorContactsPaged = {
  __typename?: 'VendorContactsPaged';
  pageInfo: PageInfo;
  rows: Array<VendorContact>;
};

export type VendorEmmaSuitability = {
  __typename?: 'VendorEmmaSuitability';
  /** Public - marketplace banding color and message */
  marketplaceBanding: MarketplaceBanding;
  /** Admin only - per-occasion breakdown */
  occasionScores: Maybe<Array<VendorOccasionSuitabilityScore>>;
  /** Admin only - overall suitability statistics */
  overallScore: Maybe<VendorSuitabilityScore>;
  /** Admin only - total live items for context */
  totalLiveItems: Maybe<Scalars['Int']['output']>;
};

export type VendorExternalUrl = {
  __typename?: 'VendorExternalUrl';
  /** The copy to show to the public to describe the url destination */
  copy: Scalars['String']['output'];
  /** The unique ID */
  id: Scalars['ID']['output'];
  /** Tags to describe the purpose and use case of the url */
  tags: VendorExternalUrlTags;
  /** The destination URL */
  url: Scalars['String']['output'];
};

export type VendorExternalUrlData = {
  __typename?: 'VendorExternalUrlData';
  data: Array<Maybe<VendorExternalUrl>>;
};

export type VendorExternalUrlInput = {
  copy: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type VendorExternalUrlTags = {
  __typename?: 'VendorExternalUrlTags';
  data: Array<Scalars['String']['output']>;
};

export type VendorFilters = {
  bestForTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  catersForTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  corporateTags?: InputMaybe<Array<Scalars['String']['input']>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  cuisineTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateTime?: InputMaybe<VendorListDateSearchInput>;
  dietaryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  diversityOfOwnershipTags?: InputMaybe<Array<Scalars['String']['input']>>;
  getStats?: InputMaybe<Scalars['Boolean']['input']>;
  headCount?: InputMaybe<Scalars['Int']['input']>;
  headCountRange?: InputMaybe<HeadCountRange>;
  highlightsTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCCActive?: InputMaybe<Scalars['Boolean']['input']>;
  isClickAndCollectActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isEmmaDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  isGMActive?: InputMaybe<Scalars['Boolean']['input']>;
  isGMDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  itemSearch?: InputMaybe<Scalars['String']['input']>;
  keyDatesTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Coordinates>;
  mealType?: InputMaybe<Array<Scalars['String']['input']>>;
  minDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  minimumOneActiveService?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  occasionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceLevel?: InputMaybe<Scalars['Int']['input']>;
  priceLevelRange?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<ServiceType>;
  supplierType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type VendorFinanceSettings = {
  __typename?: 'VendorFinanceSettings';
  /** Account name */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account number */
  accountNumber: Maybe<Scalars['String']['output']>;
  bankCode: Maybe<Scalars['String']['output']>;
  /** Bank name */
  bankName: Maybe<Scalars['String']['output']>;
  /** Billing address city */
  billingCity: Maybe<Scalars['String']['output']>;
  /** Billing country */
  billingCountry: Maybe<Scalars['String']['output']>;
  /** Line 1 of the vendor billing address */
  billingLine1: Maybe<Scalars['String']['output']>;
  /** Line 2 of the vendor billing address */
  billingLine2: Maybe<Scalars['String']['output']>;
  /** Billing postcode */
  billingPostcode: Maybe<Scalars['String']['output']>;
  /** Bank Branch Code (for SG accounts) */
  branchCode: Maybe<Scalars['String']['output']>;
  /** BSB number (for AU accounts) */
  bsbNumber: Maybe<Scalars['String']['output']>;
  businessNumber: Maybe<Scalars['String']['output']>;
  /** Finance contact */
  financeContact: Maybe<VendorContact>;
  /** The unique identifier of the vendor finance settings record */
  id: Scalars['Int']['output'];
  /** Is the supplier vat registered */
  isVatRegistered: Scalars['Boolean']['output'];
  /** Finance related notes */
  notes: Maybe<Scalars['String']['output']>;
  /** How many days after the end of a statement period the vendor should be paid by the company */
  paymentMadeDaysAfterStatementEnd: Scalars['Int']['output'];
  /** The reduced commission rate in % */
  reducedCommissionRate: Maybe<Scalars['Float']['output']>;
  /** Sort code (for UK accounts) */
  sortCode: Maybe<Scalars['String']['output']>;
  /** The standard commission rate in % */
  standardCommissionRate: Maybe<Scalars['Float']['output']>;
  /** VAT number */
  vatNumber: Maybe<Scalars['String']['output']>;
  /** Vat region */
  vatRegion: VatRegion;
};

export type VendorFlexFinanceSettings = {
  __typename?: 'VendorFlexFinanceSettings';
  /** The bank account name */
  accountName: Maybe<Scalars['String']['output']>;
  /** The bank account number */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Additional email addresses stored in flex */
  additionalEmails: Maybe<Array<Scalars['String']['output']>>;
  /** The city for the billing address */
  addressCity: Maybe<Scalars['String']['output']>;
  /** THe country for the billing address */
  addressCountry: Maybe<Scalars['String']['output']>;
  /** Line 1 of the billing address */
  addressLine1: Maybe<Scalars['String']['output']>;
  /** Line 2 of the billing address */
  addressLine2: Maybe<Scalars['String']['output']>;
  /** The postcode for the billing address */
  addressPostcode: Maybe<Scalars['String']['output']>;
  /** Is the supplier supports auto invoicing? */
  autoInvoice: Maybe<Scalars['Boolean']['output']>;
  /** The bank code (for SG accounts) */
  bankCode: Maybe<Scalars['String']['output']>;
  /** The bank name */
  bankName: Maybe<Scalars['String']['output']>;
  /** The bank branch code (for SG accounts) */
  branchCode: Maybe<Scalars['String']['output']>;
  /** The bank BSB number (for AU accounts) */
  bsbNumber: Maybe<Scalars['String']['output']>;
  /** Charge commission on delivery fees? */
  chargeCommissionOnDeliveryFees: Maybe<Scalars['Boolean']['output']>;
  /** The finance contacts' preferred email address */
  contactEmailAddress: Maybe<Scalars['String']['output']>;
  /** The finance contacts' first name */
  contactFirstName: Maybe<Scalars['String']['output']>;
  /** The finance contacts' last name */
  contactLastName: Maybe<Scalars['String']['output']>;
  /** The business / company name */
  entityName: Maybe<Scalars['String']['output']>;
  /** The business registration number */
  entityNumber: Maybe<Scalars['String']['output']>;
  /** The region the business is registered in */
  entityRegion: Maybe<Scalars['String']['output']>;
  /** The specific tax number for the registered business */
  entityTaxNumber: Maybe<Scalars['String']['output']>;
  /** The finance contact the finance settings is associated with */
  financeContact: Maybe<VendorContact>;
  /** The unique identifier of the flex vendor record */
  flexDeferredSupplierId: Scalars['ID']['output'];
  /** The unique identifier of the vendor finance settings record */
  id: Scalars['Int']['output'];
  /** If autoInvoice is enabled, will the invoices be consolidated based on locations? */
  invoiceLocationsSeparately: Maybe<Scalars['Boolean']['output']>;
  /** Is the supplier VAT registered? */
  isVatRegistered: Scalars['Boolean']['output'];
  /** The markup rate in % */
  markUpRate: Maybe<Scalars['Float']['output']>;
  /** Any supplier notes that need to be saved */
  notes: Maybe<Scalars['String']['output']>;
  /** The payment terms of invoices that will be created */
  paymentTerms: Maybe<Scalars['String']['output']>;
  /** The reduced commission rate in % */
  reducedCommissionRate: Maybe<Scalars['Float']['output']>;
  /** The bank sort code (for UK accounts) */
  sortCode: Maybe<Scalars['String']['output']>;
  /** The standard commission rate in % */
  standardCommissionRate: Maybe<Scalars['Float']['output']>;
  /** The region that the supplier resides in */
  vatRegion: VatRegion;
};

export type VendorFlexInvoice = {
  __typename?: 'VendorFlexInvoice';
  accountName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  csv: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  location: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  status: Scalars['String']['output'];
  timezone: Maybe<Scalars['String']['output']>;
  total: Scalars['String']['output'];
  vendorId: Maybe<Scalars['String']['output']>;
};

export type VendorFlexInvoiceAllTypes = {
  __typename?: 'VendorFlexInvoiceAllTypes';
  accountAddress: Maybe<Scalars['String']['output']>;
  accountBankDetails: Maybe<Scalars['String']['output']>;
  accountBusinessNumber: Maybe<Scalars['String']['output']>;
  accountContact: Maybe<Scalars['String']['output']>;
  accountName: Scalars['String']['output'];
  accountTaxNumber: Maybe<Scalars['String']['output']>;
  assets: Maybe<Array<FlexInvoiceAsset>>;
  createdAt: Scalars['DateTime']['output'];
  csv: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  /** @deprecated Tenant bank details are not displayed on supplier invoices. Use accountBankDetails for the vendor's bank details. */
  entityBankDetails: Maybe<Scalars['String']['output']>;
  entityName: Scalars['String']['output'];
  flexDeferredSupplierId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceType: Maybe<FlexInvoiceType>;
  location: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supplierId: Maybe<Scalars['Int']['output']>;
  timezone: Maybe<Scalars['String']['output']>;
  total: Scalars['String']['output'];
  vendorId: Maybe<Scalars['String']['output']>;
};

export type VendorFlexInvoiceAllTypesPaged = {
  __typename?: 'VendorFlexInvoiceAllTypesPaged';
  items: Array<Maybe<VendorFlexInvoiceAllTypes>>;
  pageInfo: PageInfo;
};

export enum VendorFlexInvoiceStatus {
  Paid = 'Paid',
  Unpaid = 'Unpaid'
}

export type VendorFlexInvoicesFiltersInput = {
  accountAddress?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdDateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  createdDateStart?: InputMaybe<Scalars['DateTime']['input']>;
  deferredSupplierId?: InputMaybe<Scalars['ID']['input']>;
  deferredSupplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type VendorFlexInvoicesInput = {
  filters?: InputMaybe<VendorFlexInvoicesFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VendorFlexInvoicesOrderByInput>;
};

export type VendorFlexInvoicesOrderByInput = {
  accountName?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  dueDate?: InputMaybe<Sort>;
  number?: InputMaybe<Sort>;
  total?: InputMaybe<Sort>;
};

export type VendorFlexInvoicesPaged = {
  __typename?: 'VendorFlexInvoicesPaged';
  items: Array<Maybe<VendorFlexInvoice>>;
  pageInfo: PageInfo;
};

export type VendorHighlightCategoriesFilterInput = {
  bestForTags?: InputMaybe<Array<Scalars['String']['input']>>;
  corporateTags?: InputMaybe<Array<Scalars['String']['input']>>;
  cuisineTags?: InputMaybe<Array<Scalars['String']['input']>>;
  dateTime?: InputMaybe<VendorListDateSearchInput>;
  dietaryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  diversityOfOwnershipTags?: InputMaybe<Array<Scalars['String']['input']>>;
  getStats?: InputMaybe<Scalars['Boolean']['input']>;
  headCount?: InputMaybe<Scalars['Int']['input']>;
  highlightsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isGMActive?: InputMaybe<Scalars['Boolean']['input']>;
  itemSearch?: InputMaybe<Scalars['String']['input']>;
  keyDatesTags?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<Coordinates>;
  minDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  occasionTags?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<ServiceType>;
  supplierType?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type VendorHighlightCategoriesForLocation = {
  __typename?: 'VendorHighlightCategoriesForLocation';
  highlightCategories: Array<VendorHighlightCategory>;
  pageInfo: PageInfo;
};

export type VendorHighlightCategory = {
  __typename?: 'VendorHighlightCategory';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  vendors: VendorHighlightCategoryVendorsPaged;
};


export type VendorHighlightCategoryVendorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type VendorHighlightCategoryVendorsPaged = {
  __typename?: 'VendorHighlightCategoryVendorsPaged';
  pageInfo: PageInfo;
  vendors: Array<Vendor>;
};

export type VendorImage = {
  __typename?: 'VendorImage';
  /** The alt text for the image */
  alt: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the vendor image */
  id: Scalars['ID']['output'];
  /** If the image is active or not */
  isActive: Scalars['Boolean']['output'];
  /** Image name */
  name: Maybe<Scalars['String']['output']>;
  /** Position image should be displayed in a list or gallery */
  position: Maybe<Scalars['Int']['output']>;
  /** The https url for the image */
  secureUrl: Scalars['String']['output'];
  /** The unique identifier of the supplier that the image belongs to */
  supplierId: Maybe<Scalars['ID']['output']>;
  /** The image type */
  type: Maybe<Scalars['String']['output']>;
  /** URL of the image */
  url: Maybe<Scalars['String']['output']>;
};

export type VendorInRangeLocations = {
  __typename?: 'VendorInRangeLocations';
  locations: Array<VendorLocation>;
  vendorId: Scalars['Int']['output'];
};

export type VendorIntegrationSettings = {
  __typename?: 'VendorIntegrationSettings';
  centegraRequired: Scalars['Boolean']['output'];
};

export type VendorInvoiceOrder = {
  __typename?: 'VendorInvoiceOrder';
  contact: Scalars['String']['output'];
  deferredSupplierInvoiceId: Maybe<Scalars['ID']['output']>;
  deferredSupplierInvoiceNumber: Maybe<Scalars['String']['output']>;
  deliveryDate: Scalars['DateTime']['output'];
  deliveryTimezone: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  shippingAddress: Scalars['String']['output'];
  supplier: Scalars['String']['output'];
  supplierLocation: Maybe<Scalars['String']['output']>;
  total: Scalars['String']['output'];
};

export type VendorInvoiceOrderFiltersInput = {
  contact?: InputMaybe<Scalars['String']['input']>;
  deferredSupplierId?: InputMaybe<Scalars['ID']['input']>;
  deferredSupplierInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  deferredSupplierOrderId?: InputMaybe<Scalars['ID']['input']>;
  deliveryDateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryDateStart?: InputMaybe<Scalars['DateTime']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  supplierLocation?: InputMaybe<Scalars['String']['input']>;
  uninvoiced?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorInvoiceOrderInput = {
  countryCode: Scalars['String']['input'];
  filters?: InputMaybe<VendorInvoiceOrderFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VendorInvoiceOrderOrderByInput>;
};

export type VendorInvoiceOrderOrderByInput = {
  contact?: InputMaybe<Sort>;
  deliveryDate?: InputMaybe<Sort>;
  number?: InputMaybe<Sort>;
  shippingAddress?: InputMaybe<Sort>;
  supplier?: InputMaybe<Sort>;
};

export type VendorInvoiceOrdersPaged = {
  __typename?: 'VendorInvoiceOrdersPaged';
  items: Array<Maybe<VendorInvoiceOrder>>;
  pageInfo: PageInfo;
};

export type VendorListDateSearchInput = {
  date: Scalars['Int']['input'];
  hour?: InputMaybe<Scalars['Int']['input']>;
  minute?: InputMaybe<Scalars['Int']['input']>;
  month: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type VendorListFilters = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCCActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isEmmaDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  isGMActive?: InputMaybe<Scalars['Boolean']['input']>;
  isGMDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VendorLocation = {
  __typename?: 'VendorLocation';
  /** The city associated with the address */
  city: Maybe<Scalars['String']['output']>;
  /** The closing dates of the location */
  closingDates: VendorLocationClosingDate;
  /** The contacts associated with the vendor location */
  contacts: Array<VendorContact>;
  /** The country associated with the address */
  country: Maybe<Scalars['String']['output']>;
  /** The regions the vendor location can deliver to */
  deliveryRegions: Array<DeliveryRegion>;
  /** The details of the location */
  details: VendorLocationDetails;
  /** The email associated with the address */
  email: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the vendor location */
  id: Scalars['ID']['output'];
  /** The instructions associated with the address */
  instructions: Maybe<Scalars['String']['output']>;
  /** Whether the location is the default address */
  isDefault: Scalars['Boolean']['output'];
  /** Reference label of the address */
  label: Maybe<Scalars['String']['output']>;
  /** The latitude of the location */
  lat: Maybe<Scalars['Float']['output']>;
  /** Line 1 of the address */
  line1: Maybe<Scalars['String']['output']>;
  /** Line 2 of the address */
  line2: Maybe<Scalars['String']['output']>;
  /** Line 3 of the address */
  line3: Maybe<Scalars['String']['output']>;
  /** The longitude of the location */
  lng: Maybe<Scalars['Float']['output']>;
  /** The note associated with the address */
  note: Maybe<Scalars['String']['output']>;
  /** The dates and times that the location is open */
  openingTimes: Array<VendorLocationOpeningTime>;
  /** The phone number associated with the address */
  phone: Maybe<Scalars['String']['output']>;
  /** The pick up wait time for the location */
  pickupWaitTime: Maybe<Scalars['Int']['output']>;
  /** The postcode associated with the address */
  postcode: Maybe<Scalars['String']['output']>;
  /** The preferred courier */
  preferredCourier: Maybe<Scalars['String']['output']>;
  /** The dates and times that the location is open for a meal type */
  serviceTimes: Array<VendorLocationServiceTime>;
  /** The vendor's id that the location belongs to */
  supplierId: Scalars['ID']['output'];
  /** The timezone of the vendor location */
  timezone: Scalars['String']['output'];
  /** The vendor */
  vendor: Vendor;
  /** The what 3 words associated to the address */
  what3words: Maybe<Scalars['String']['output']>;
};


export type VendorLocationContactsArgs = {
  input: InputMaybe<VendorContactFilters>;
};


export type VendorLocationDeliveryRegionsArgs = {
  input: InputMaybe<DeliveryRegionInput>;
};

export type VendorLocationClosingDate = {
  __typename?: 'VendorLocationClosingDate';
  /** The dates the vendor location is closed */
  closedDates: Array<Scalars['DateTime']['output']>;
  /** The days of the week the vendor location is closed [1-7] */
  closedWeekdays: Array<Scalars['Int']['output']>;
};

export type VendorLocationDetails = {
  __typename?: 'VendorLocationDetails';
  /** The cut off of time for breakfast when users can place their order */
  ccBreakfastCutOff: Maybe<Scalars['Int']['output']>;
  /** The cut off of time for dinner when users can place their order */
  ccDinnerCutOff: Maybe<Scalars['Int']['output']>;
  /** The cut off of time for lunch when users can place their order */
  ccLunchCutOff: Maybe<Scalars['Int']['output']>;
  /** The maximum distance away in minutes for a CC order */
  ccMaxDistanceMinutes: Maybe<Scalars['Int']['output']>;
  /** The maximum order size for the week */
  ccWeekMaxOrderSize: Maybe<Scalars['Int']['output']>;
  /** The maximum order size per day for the week */
  ccWeekMaxOrdersPerDay: Maybe<Scalars['Int']['output']>;
  /** The maximum order size for the weekend */
  ccWeekendMaxOrderSize: Maybe<Scalars['Int']['output']>;
  /** The maximum order size per day for the weekend */
  ccWeekendMaxOrdersPerDay: Maybe<Scalars['Int']['output']>;
  /** The notice period (in hours) that currently applies, taking large-order rules into account */
  effectiveMinimumNoticePeriod: Maybe<Scalars['Int']['output']>;
  /** Whether the vendor offers country wide delivery for GM */
  gmAllowCountryWideDelivery: Maybe<Scalars['Boolean']['output']>;
  /** The minimum notice needed before placing a large order for GM */
  gmLargeOrderNoticePeriod: Maybe<Scalars['Int']['output']>;
  /** The amount of when it becomes a large order */
  gmLargeOrderThreshold: Maybe<Scalars['Int']['output']>;
  /** The maximum distance away in minutes for a GM order */
  gmMaxDistanceMinutes: Maybe<Scalars['Int']['output']>;
  /** The maximum amount of items you can place for a GM order */
  gmMaxOrder: Maybe<Scalars['Int']['output']>;
  /** The minimum notice needed before placing order for GM */
  gmMinNoticePeriod: Maybe<Scalars['Int']['output']>;
  /** The minimum amount of items needed to place a GM order */
  gmMinOrder: Maybe<Scalars['Int']['output']>;
  /** Whether the vendor location does individual packaing format */
  gmPackagingIndividual: Maybe<Scalars['Boolean']['output']>;
  /** Whether the vendor location does sharing packaing format */
  gmPackagingSharing: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier of the vendor location detail */
  id: Scalars['ID']['output'];
  /** Whether the vendor location is cloud canteen active or not */
  isCCActive: Scalars['Boolean']['output'];
  /** Whether the vendor location is click and collect active or not */
  isClickAndCollectActive: Scalars['Boolean']['output'];
  /** Whether the vendor location is group meal active or not */
  isGMActive: Scalars['Boolean']['output'];
  /** Whether the vendor location is home delivery active or not */
  isHomeDeliveryActive: Scalars['Boolean']['output'];
  /**
   * The minimum order amount you have to reach to place a GM order
   * @deprecated being replaced with ex. tax equivalent, use minOrderValueExTax instead
   */
  minOrderValue: Maybe<Scalars['Float']['output']>;
  /** The minimum order amount (excl. tax) you have to reach to place a GM order */
  minOrderValueExTax: Maybe<Scalars['Float']['output']>;
  /** Whether the vendor location does it's own delivery or not */
  ownDelivery: Scalars['Boolean']['output'];
  /** Whether the vendor location does it's own delivery by any mode */
  ownDeliveryMethodAny: Scalars['Boolean']['output'];
  /** Whether the vendor location does it's own delivery by walking */
  ownDeliveryMethodWalking: Scalars['Boolean']['output'];
  /** The vendor's id that the detail belongs to */
  supplierId: Scalars['ID']['output'];
  /** The vendor location's id that the detail belongs to */
  supplierLocationId: Scalars['ID']['output'];
};

export type VendorLocationOpeningTime = {
  __typename?: 'VendorLocationOpeningTime';
  /** The end time the location opens (for the weekdays selected) */
  endTime: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the vendor location opening time */
  id: Scalars['ID']['output'];
  /** The start time the location opens (for the weekdays selected) */
  startTime: Maybe<Scalars['String']['output']>;
  /** The vendor locations id */
  supplierLocationId: Scalars['Int']['output'];
  /** The weekdays the vendor location opening times apply to */
  weekdays: Array<Scalars['Int']['output']>;
};

export type VendorLocationServiceTime = {
  __typename?: 'VendorLocationServiceTime';
  /** The end time the locations service opens (for the weekdays selected) */
  endTime: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the vendor location service time */
  id: Scalars['ID']['output'];
  /** The meal type this time is for */
  mealType: Scalars['String']['output'];
  /** The start time the locations service opens (for the weekdays selected) */
  startTime: Maybe<Scalars['String']['output']>;
  /** The vendor locations id */
  supplierLocationId: Scalars['Int']['output'];
  /** The weekdays the vendor location service times apply to */
  weekdays: Array<Scalars['Int']['output']>;
};

export type VendorMarketplaceOrderByInput = {
  direction?: InputMaybe<VendorOrderDirection>;
  property?: InputMaybe<VendorMarketplaceOrderByProperties>;
};

export enum VendorMarketplaceOrderByProperties {
  Alphabetical = 'alphabetical',
  DeliveryFee = 'deliveryFee',
  Distance = 'distance',
  Favourites = 'favourites',
  MinOrderValue = 'minOrderValue',
  Price = 'price'
}

export type VendorMarkupSettings = {
  __typename?: 'VendorMarkupSettings';
  /** The default markup percentage applied to all of the menu items that belong to the vendor */
  defaultMarkupPercentage: Scalars['Float']['output'];
};

export enum VendorMenuAllergen {
  Celery = 'CELERY',
  Cereals = 'CEREALS',
  Crustaceans = 'CRUSTACEANS',
  Eggs = 'EGGS',
  Fish = 'FISH',
  Lupin = 'LUPIN',
  Milk = 'MILK',
  Molluscs = 'MOLLUSCS',
  Mustard = 'MUSTARD',
  Nuts = 'NUTS',
  Peanuts = 'PEANUTS',
  Sesame = 'SESAME',
  Soybeans = 'SOYBEANS',
  Sulphur = 'SULPHUR'
}

export type VendorMenuCategory = {
  __typename?: 'VendorMenuCategory';
  description: Maybe<Scalars['String']['output']>;
  hasMoreItems: Scalars['Boolean']['output'];
  heroAssets: Array<VendorMenuCategoryHeroAsset>;
  id: Scalars['ID']['output'];
  isEmpty: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position: Maybe<Scalars['Int']['output']>;
};

export type VendorMenuCategoryConnection = {
  __typename?: 'VendorMenuCategoryConnection';
  pageInfo: VendorMenuCategoryPageInfo;
  rows: Array<VendorMenuCategory>;
};

export type VendorMenuCategoryHeroAsset = {
  __typename?: 'VendorMenuCategoryHeroAsset';
  altText: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type VendorMenuCategoryPageInfo = {
  __typename?: 'VendorMenuCategoryPageInfo';
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export enum VendorMenuDietary {
  Halal = 'HALAL',
  Highprotein = 'HIGHPROTEIN',
  Kosher = 'KOSHER',
  Lowcarb = 'LOWCARB',
  Powerplant = 'POWERPLANT',
  RefinedSugar = 'REFINED_SUGAR',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN'
}

export type VendorMenuFiltersInput = {
  allergens?: InputMaybe<Array<VendorMenuAllergen>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dietaries?: InputMaybe<Array<VendorMenuDietary>>;
  itemName?: InputMaybe<Scalars['String']['input']>;
};

export type VendorMenuItemStat = {
  __typename?: 'VendorMenuItemStat';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type VendorMenuItemsPageInfo = {
  __typename?: 'VendorMenuItemsPageInfo';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextOffset: Maybe<Scalars['Int']['output']>;
  offset: Scalars['Int']['output'];
};

export type VendorOccasionSuitabilityScore = {
  __typename?: 'VendorOccasionSuitabilityScore';
  occasion: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  suitableItems: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
};

export enum VendorOrderByProperties {
  CompanyName = 'companyName',
  Id = 'id'
}

export enum VendorOrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type VendorPreference = {
  __typename?: 'VendorPreference';
  blacklisted: Scalars['Boolean']['output'];
  preferred: Scalars['Boolean']['output'];
  vendor: Vendor;
  vendorId: Scalars['Int']['output'];
};

export type VendorRatingData = {
  __typename?: 'VendorRatingData';
  maxRating: Scalars['Int']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  rating: Scalars['Float']['output'];
  totalReviewsInPeriod: Scalars['Int']['output'];
};

export type VendorRatingQueryInput = {
  maxRating?: InputMaybe<Scalars['Int']['input']>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VendorSearchStats = {
  __typename?: 'VendorSearchStats';
  bestForTags: Maybe<Array<FilterStatTag>>;
  cuisineTags: Maybe<Array<FilterStatTag>>;
  dietaryTags: Maybe<Array<FilterStatTag>>;
  diversityOfOwnershipTags: Maybe<Array<FilterStatTag>>;
  headCount: HeadCountRanges;
  keyDatesTags: Maybe<Array<FilterStatTag>>;
  mealType: MealTypes;
  occasionTags: Maybe<Array<FilterStatTag>>;
  priceLevel: PriceLevels;
};

export type VendorStatement = {
  __typename?: 'VendorStatement';
  additionalTotal: Scalars['Float']['output'];
  additionalTotalExVat: Scalars['Float']['output'];
  additionalTotalVat: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  asset: Maybe<Asset>;
  assets: Array<Asset>;
  billingDetails: VendorStatementBillingDetails;
  billingEntity: BillingEntity;
  canApprove: Scalars['Boolean']['output'];
  canCancel: Scalars['Boolean']['output'];
  commissions: Array<Maybe<VendorStatementCommission>>;
  currency: Currency;
  feeSummary: VendorStatementFeeSummary;
  friendlyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAlreadyApproved: Scalars['Boolean']['output'];
  issueDate: Maybe<Scalars['DateTime']['output']>;
  paidDate: Scalars['DateTime']['output'];
  paymentStatus: PaymentStatus;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  reseller: Maybe<Scalars['Boolean']['output']>;
  serviceOrderBreakdown: VendorStatementServiceOrderBreakdown;
  serviceOriginalOrderBreakdown: VendorStatementServiceOrderBreakdown;
  serviceTotals: VendorStatementServiceTotals;
  status: InvoiceStatus;
  summary: Array<Maybe<VendorStatementSummaryItem>>;
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
  vatRegion: VatRegion;
  vendorLocationName: Scalars['String']['output'];
  vendorLocationTimezone: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
};


export type VendorStatementAssetArgs = {
  input: AssetSearchInput;
};

export type VendorStatementBillingContact = {
  __typename?: 'VendorStatementBillingContact';
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  tenantId: Maybe<Scalars['String']['output']>;
};

export type VendorStatementBillingDetails = {
  __typename?: 'VendorStatementBillingDetails';
  address: BillingAddress;
  contact: VendorStatementBillingContact;
};

export type VendorStatementCommission = {
  __typename?: 'VendorStatementCommission';
  commissionRate: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  editible: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  serviceType: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
  vatRate: Scalars['Float']['output'];
};

export type VendorStatementFeeSummary = {
  __typename?: 'VendorStatementFeeSummary';
  items: Array<Maybe<VendorStatementSummaryItem>>;
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
};

export type VendorStatementFiltersInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  dateEnd?: InputMaybe<Scalars['String']['input']>;
  dateStart?: InputMaybe<Scalars['String']['input']>;
  excludeStatus?: InputMaybe<Array<InvoiceStatus>>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  sourceFromSystemFeedr?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  vendorId?: InputMaybe<Scalars['Int']['input']>;
  vendorLocationName?: InputMaybe<Scalars['String']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type VendorStatementOrderBreakdownItem = {
  __typename?: 'VendorStatementOrderBreakdownItem';
  billingDetails: BillingDetails;
  date: Scalars['DateTime']['output'];
  discount: Scalars['Float']['output'];
  friendlyOrderId: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  items: Array<InvoiceItem>;
  orderHref: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  taxInvoiceId: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
};


export type VendorStatementOrderBreakdownItemOrderHrefArgs = {
  appArea: AppArea;
};

export type VendorStatementOrderByInput = {
  direction?: InputMaybe<OrderDirection>;
  property?: InputMaybe<OrderByProperties>;
};

export type VendorStatementServiceOrderBreakdown = {
  __typename?: 'VendorStatementServiceOrderBreakdown';
  CC: Array<VendorStatementOrderBreakdownItem>;
  GM: Array<VendorStatementOrderBreakdownItem>;
};

export type VendorStatementServiceTotals = {
  __typename?: 'VendorStatementServiceTotals';
  ccTotal: Scalars['Float']['output'];
  ccTotalExVat: Scalars['Float']['output'];
  ccTotalQuantity: Scalars['Float']['output'];
  ccTotalVat: Scalars['Float']['output'];
  gmTotal: Scalars['Float']['output'];
  gmTotalExVat: Scalars['Float']['output'];
  gmTotalQuantity: Scalars['Float']['output'];
  gmTotalVat: Scalars['Float']['output'];
};

export type VendorStatementSummaryItem = {
  __typename?: 'VendorStatementSummaryItem';
  description: Scalars['String']['output'];
  editible: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  serviceType: Maybe<Scalars['String']['output']>;
  subTotalExVat: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
  totalExVat: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
  vatRate: Scalars['Float']['output'];
};

export type VendorStatementsCombinedPaged = {
  __typename?: 'VendorStatementsCombinedPaged';
  items: Array<CombinedVendorStatement>;
  pageInfo: PageInfo;
};

export type VendorStatementsPaged = {
  __typename?: 'VendorStatementsPaged';
  items: Array<VendorStatement>;
  pageInfo: PageInfo;
};

/** Lightweight summary of vendor statements for fast analytics/visualisation. */
export type VendorStatementsSummary = {
  __typename?: 'VendorStatementsSummary';
  /**
   * Breakdown of totalAmount by order type (e.g. CC vs GM), based on Flex order data.
   * Orders without an orderType are excluded from this breakdown but included in totalAmount.
   */
  orderTypeTotals: Maybe<Array<OrderTypeAmount>>;
  /** Total statement amount over the requested period. */
  totalAmount: Scalars['Float']['output'];
  /** Weekly totals over the requested period (date is week start, Sunday 00:00 UTC). */
  weeklyTotals: Array<AggregateByPeriod>;
};

export type VendorSuitabilityScore = {
  __typename?: 'VendorSuitabilityScore';
  percentage: Scalars['Float']['output'];
  suitableItems: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
};

export type VendorTag = {
  __typename?: 'VendorTag';
  /** The color of the tag */
  color: Maybe<Scalars['String']['output']>;
  /** Assignments to countries */
  countryAssignments: Array<VendorTagCountryAssignment>;
  /** The unique identifier of the group of the vendor tag */
  groupId: Maybe<Scalars['ID']['output']>;
  /** The tag group label */
  groupLabel: Maybe<Scalars['String']['output']>;
  /** The tag groupName */
  groupName: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the vendor tag */
  id: Scalars['ID']['output'];
  /** The url to the image for the tag */
  image: Maybe<Scalars['String']['output']>;
  /** The label to display on the tag */
  label: Maybe<Scalars['String']['output']>;
  /** The name of the tag */
  name: Maybe<Scalars['String']['output']>;
  /** The permalink for the tag */
  permalink: Maybe<Scalars['String']['output']>;
  /** Position to show in a list */
  position: Maybe<Scalars['Int']['output']>;
  /** The tag type */
  type: Maybe<Scalars['String']['output']>;
};

export type VendorTagCountryAssignment = {
  __typename?: 'VendorTagCountryAssignment';
  countryCode: Scalars['String']['output'];
  isPublicFilterGm: Scalars['Boolean']['output'];
  position: Maybe<Scalars['Int']['output']>;
};

export type VendorTagCreateInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  groupPermalink?: InputMaybe<Scalars['String']['input']>;
  isPublicFilterGm?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type VendorTagUpdateInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isPublicFilterGm?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type VendorTagsFilters = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  groupPermalink?: InputMaybe<Scalars['String']['input']>;
  isPublicFilterGm?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type VendorsInRangeLocationsInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateTime?: InputMaybe<VendorListDateSearchInput>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  serviceType: ServiceType;
  totalCost?: InputMaybe<Scalars['Float']['input']>;
  vendorIds: Array<Scalars['ID']['input']>;
};

export type VendorsListPaged = {
  __typename?: 'VendorsListPaged';
  pageInfo: PageInfo;
  rows: Array<Vendor>;
};

export type VendorsOrderByInput = {
  direction?: InputMaybe<VendorOrderDirection>;
  property?: InputMaybe<VendorOrderByProperties>;
};

export type VendorsPaged = {
  __typename?: 'VendorsPaged';
  pageInfo: PageInfo;
  rows: Array<Vendor>;
  stats: Maybe<VendorSearchStats>;
};

export type VerifyCouponInput = {
  basketId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};

export type Viewport = {
  __typename?: 'Viewport';
  northeast: Location;
  southwest: Location;
};

export type OccasionItemTimeRestraints = {
  __typename?: 'occasionItemTimeRestraints';
  /** Start and end times to allow breakfast items for the occasion */
  breakfast: Maybe<TimeRange>;
  /** Start and end times to allow dinner items for the occasion */
  dinner: Maybe<TimeRange>;
  /** Start and end times to allow lunch items for the occasion */
  lunch: Maybe<TimeRange>;
  /** Name of the occasion e.g. BREAKFAST, MORNING_TEA */
  occasion: Scalars['String']['output'];
};

export type OrderItemsCsvResult = {
  __typename?: 'orderItemsCsvResult';
  url: Maybe<Scalars['String']['output']>;
};

export type PrepareEmptyBasketFromQuoteRequestInput = {
  locale: Scalars['String']['input'];
  quoteRequestBasketInput: QuoteRequestBasketInput;
  tenantId: Scalars['String']['input'];
};

export type TenantFromPrebuildFragment = { __typename?: 'Tenant', id: string, name: string, domain: string, countries: Array<string>, isSingleVendor: boolean, defaultLocale: string, vercelProjectId: string, clientVercelProjectId: string, marketing: { __typename?: 'TenantMarketing', pages: { __typename?: 'TenantMarketingPages', shouldIndex: boolean, rootUrl: string | null, regions: Array<{ __typename?: 'TenantMarketingPageRegions', code: string, url: string }> } | null, sitemaps: Array<{ __typename?: 'TenantMarketingSitemaps', name: string, url: string, forceReplaceHostname: boolean }>, links: Array<{ __typename?: 'TenantMarketingLink', countryCode: string, requestAQuote: string | null, terms: string, privacy: string }>, logos: { __typename?: 'TenantMarketingLogos', default: string, white: string | null, rainbow: string | null, favicon: string, loadingIndicator: string | null }, navLinks: Array<{ __typename?: 'TenantNavigationLink', title: string, href: string | null, subLinks: Array<{ __typename?: 'TenantNavigationSubLink', title: string, href: string | null, type: TenantNavigationSubLinkType, description: string | null, sameTab: boolean | null, ssgPage: boolean | null, links: Array<{ __typename?: 'NavLink', title: string, href: string | null, ssgPage: boolean | null } | null> | null }> | null }>, theme: { __typename?: 'TenantMarketingTheme', palette: { __typename?: 'TenantMarketingThemePalette', primary: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, secondary: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, success: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, warning: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, info: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, error: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, inverted: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, text: { __typename?: 'TenantPaletteColorText', primary: string | null, secondary: string | null, disabled: string | null } | null, background: { __typename?: 'TenantPaletteColorBackground', default: string | null, paper: string | null } | null, common: { __typename?: 'TenantPaletteColorCommon', black: string | null, white: string | null } | null } | null } | null, assets: { __typename?: 'TenantMarketingAssets', placeholder: string | null, authBackgroundImage: string | null, marketplaceHeaderImages: Array<string> | null, orderConfirmationImage: string | null } | null }, cognitoConfiguration: { __typename?: 'TenantCognitoConfiguration', userPoolDomain: string, userPoolId: string, userPoolClientId: string }, contact: { __typename?: 'TenantContact', regions: Array<{ __typename?: 'TenantContactRegions', countryCode: string, email: { __typename?: 'TenantContactRegionsEmail', default: string, sales: string | null, support: string | null, vendors: string | null } | null, phone: { __typename?: 'TenantContactRegionsPhone', default: string, sales: string | null, support: string | null, vendors: string | null } | null } | null> | null } | null, integrations: { __typename?: 'TenantIntegrations', oneTrust: { __typename?: 'TenantIntegrationsOneTrust', id: string } | null, hotjar: { __typename?: 'TenantIntegrationsHotjar', regions: Array<{ __typename?: 'TenantIntegrationsHotjarRegions', id: string, countryCode: string } | null> | null } | null, linkedIn: { __typename?: 'TenantIntegrationsLinkedIn', pid: number } | null, segment: { __typename?: 'TenantIntegrationsSegment', clientWriteKey: string | null } | null, posthog: { __typename?: 'TenantIntegrationsPosthog', apiKey: string, apiHost: string | null } | null, zendesk: { __typename?: 'TenantIntegrationsZendesk', regions: Array<{ __typename?: 'TenantIntegrationsZendeskRegions', id: string, countryCode: string } | null> | null } | null, intercom: { __typename?: 'TenantIntegrationsIntercom', regions: Array<{ __typename?: 'TenantIntegrationsIntercomRegions', id: string, countryCode: string } | null> | null } | null, googleTagManager: { __typename?: 'TenantIntegrationsGoogleTagManager', containerId: string } | null, flexInvoicingClients: Array<{ __typename?: 'FlexInvoicingClient', clientId: string, shortCode: string, countryCode: string }> | null, bingAds: { __typename?: 'TenantIntegrationsBingAds', tagId: string } | null } | null, flexInvoicingFlags: Array<{ __typename?: 'FlexInvoicingFlags', countryCode: string, enabled: boolean }>, billingEntities: Array<{ __typename?: 'BillingEntity', id: string, countryCode: string, code: string, email: string | null, phone: string | null }>, mobileApp: { __typename?: 'TenantMobileApp', bundleId: string } | null, uriRestrictedAccessRules: Array<{ __typename?: 'UriRestrictedAccessRules', uri: string, redirectUri: string | null }>, features: { __typename?: 'TenantFeatures', canCancelCateringInvoiceOrders: boolean, calendarTopPicks: { __typename?: 'TenantFeaturesCalendarTopPicks', visibility: boolean } | null, charityMeals: { __typename?: 'TenantFeaturesCharityMeals', visibility: { __typename?: 'TenantFeaturesCharityMealsVisibility', regions: Array<string> } } | null, cateringAllergenTooltip: { __typename?: 'TenantCateringAllergenTooltip', visibility: boolean } | null, serviceOptions: { __typename?: 'TenantServiceOptions', visibility: boolean, staffServices: { __typename?: 'TenantServiceOptionsVisibility', visibility: boolean }, cutleryExtras: { __typename?: 'TenantServiceOptionsVisibility', visibility: boolean } } | null, emma: { __typename?: 'TenantFeaturesEmma', visibility: boolean, defaultSupplierId: number | null, showSubscribeToUpdatesCheckbox: boolean } | null, vendorHelpCentre: { __typename?: 'TenantFeaturesVendorHelpCentre', link: string } | null, cateringCoupons: { __typename?: 'TenantCateringCoupons', visibility: boolean } | null, cateringFilters: { __typename?: 'TenantCateringFilters', allergens: boolean, dietary: boolean } | null, printLabels: { __typename?: 'TenantPrintLabels', CC: { __typename?: 'TenantPrintLabelsOptions', VPDymo: boolean, VPA4: boolean, VPPackage: boolean, VPSummary: boolean }, GM: { __typename?: 'TenantPrintLabelsOptions', VPDymo: boolean, VPA4: boolean, VPPackage: boolean, VPSummary: boolean } }, prerenderMarketplaceMenu: { __typename?: 'TenantFeaturesPreRenderMarketplaceMenu', permalinks: Array<string> } | null, gmExpressCheckout: { __typename?: 'TenantGmExpressCheckout', visibility: boolean } | null, gmShowFullAddress: { __typename?: 'TenantFeaturesGmShowFullAddress', visibility: { __typename?: 'TenantFeaturesGmShowFullAddressVisibility', regions: Array<string> } | null } | null, gmHideDeliveryWindow: { __typename?: 'TenantFeaturesGmHideDeliveryWindow', visibility: boolean } | null, ccShowTimeslotWindow: { __typename?: 'TenantFeaturesCcShowTimeslotWindow', visibility: boolean } | null, gmDeliveryTimeslots: { __typename?: 'TenantFeaturesGmDeliveryTimeslots', start: string, end: string }, ccTopupAmounts: { __typename?: 'TenantFeaturesCcTopupAmounts', minimumTopup: number | null, topupValues: Array<number | null> } | null, menuItemAllergenAudit: { __typename?: 'TenantFeaturesMenuItemAllergenAudit', enabled: boolean } | null, cateringTeamOrder: { __typename?: 'TenantFeaturesCateringTeamOrder', visibility: { __typename?: 'TenantFeaturesCateringTeamOrderVisibility', regions: Array<string> } | null } | null } | null, contentSecurityPolicy: { __typename?: 'TenantContentSecurityPolicy', mediaSrc: Array<string>, fontSrc: Array<string>, styleSrc: Array<string>, scriptSrc: Array<string>, imgSrc: Array<string>, connectSrc: Array<string>, frameSrc: Array<string> }, transportTypes: { __typename?: 'TenantTransportTypes', regions: Array<{ __typename?: 'TenantTransportTypesRegion', countryCode: string, types: Array<{ __typename?: 'TenantTransportType', name: string, value: string }> }> }, guestAccountData: Array<{ __typename?: 'TenantGuestAccount', id: string, guestInvoiceAccountId: string | null }>, permissions: { __typename?: 'TenantPermissions', guestCheckoutByInvoiceAccountGm: boolean | null, allowUserSignIn: boolean, allowCreditCardPayments: boolean, allowTransferPayments: boolean | null, autoPopulatePlacedBy: boolean | null }, payments: { __typename?: 'TenantPayments', chargeCreditCardFee: boolean | null } | null };

export type PrebuildTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type PrebuildTenantsQuery = { __typename?: 'Query', tenants: { __typename?: 'TenantsPaged', rows: Array<{ __typename?: 'Tenant', id: string, name: string, domain: string, countries: Array<string>, isSingleVendor: boolean, defaultLocale: string, vercelProjectId: string, clientVercelProjectId: string, marketing: { __typename?: 'TenantMarketing', pages: { __typename?: 'TenantMarketingPages', shouldIndex: boolean, rootUrl: string | null, regions: Array<{ __typename?: 'TenantMarketingPageRegions', code: string, url: string }> } | null, sitemaps: Array<{ __typename?: 'TenantMarketingSitemaps', name: string, url: string, forceReplaceHostname: boolean }>, links: Array<{ __typename?: 'TenantMarketingLink', countryCode: string, requestAQuote: string | null, terms: string, privacy: string }>, logos: { __typename?: 'TenantMarketingLogos', default: string, white: string | null, rainbow: string | null, favicon: string, loadingIndicator: string | null }, navLinks: Array<{ __typename?: 'TenantNavigationLink', title: string, href: string | null, subLinks: Array<{ __typename?: 'TenantNavigationSubLink', title: string, href: string | null, type: TenantNavigationSubLinkType, description: string | null, sameTab: boolean | null, ssgPage: boolean | null, links: Array<{ __typename?: 'NavLink', title: string, href: string | null, ssgPage: boolean | null } | null> | null }> | null }>, theme: { __typename?: 'TenantMarketingTheme', palette: { __typename?: 'TenantMarketingThemePalette', primary: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, secondary: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, success: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, warning: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, info: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, error: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, inverted: { __typename?: 'TenantPaletteColorOptions', light: string | null, main: string, dark: string | null, contrastText: string | null } | null, text: { __typename?: 'TenantPaletteColorText', primary: string | null, secondary: string | null, disabled: string | null } | null, background: { __typename?: 'TenantPaletteColorBackground', default: string | null, paper: string | null } | null, common: { __typename?: 'TenantPaletteColorCommon', black: string | null, white: string | null } | null } | null } | null, assets: { __typename?: 'TenantMarketingAssets', placeholder: string | null, authBackgroundImage: string | null, marketplaceHeaderImages: Array<string> | null, orderConfirmationImage: string | null } | null }, cognitoConfiguration: { __typename?: 'TenantCognitoConfiguration', userPoolDomain: string, userPoolId: string, userPoolClientId: string }, contact: { __typename?: 'TenantContact', regions: Array<{ __typename?: 'TenantContactRegions', countryCode: string, email: { __typename?: 'TenantContactRegionsEmail', default: string, sales: string | null, support: string | null, vendors: string | null } | null, phone: { __typename?: 'TenantContactRegionsPhone', default: string, sales: string | null, support: string | null, vendors: string | null } | null } | null> | null } | null, integrations: { __typename?: 'TenantIntegrations', oneTrust: { __typename?: 'TenantIntegrationsOneTrust', id: string } | null, hotjar: { __typename?: 'TenantIntegrationsHotjar', regions: Array<{ __typename?: 'TenantIntegrationsHotjarRegions', id: string, countryCode: string } | null> | null } | null, linkedIn: { __typename?: 'TenantIntegrationsLinkedIn', pid: number } | null, segment: { __typename?: 'TenantIntegrationsSegment', clientWriteKey: string | null } | null, posthog: { __typename?: 'TenantIntegrationsPosthog', apiKey: string, apiHost: string | null } | null, zendesk: { __typename?: 'TenantIntegrationsZendesk', regions: Array<{ __typename?: 'TenantIntegrationsZendeskRegions', id: string, countryCode: string } | null> | null } | null, intercom: { __typename?: 'TenantIntegrationsIntercom', regions: Array<{ __typename?: 'TenantIntegrationsIntercomRegions', id: string, countryCode: string } | null> | null } | null, googleTagManager: { __typename?: 'TenantIntegrationsGoogleTagManager', containerId: string } | null, flexInvoicingClients: Array<{ __typename?: 'FlexInvoicingClient', clientId: string, shortCode: string, countryCode: string }> | null, bingAds: { __typename?: 'TenantIntegrationsBingAds', tagId: string } | null } | null, flexInvoicingFlags: Array<{ __typename?: 'FlexInvoicingFlags', countryCode: string, enabled: boolean }>, billingEntities: Array<{ __typename?: 'BillingEntity', id: string, countryCode: string, code: string, email: string | null, phone: string | null }>, mobileApp: { __typename?: 'TenantMobileApp', bundleId: string } | null, uriRestrictedAccessRules: Array<{ __typename?: 'UriRestrictedAccessRules', uri: string, redirectUri: string | null }>, features: { __typename?: 'TenantFeatures', canCancelCateringInvoiceOrders: boolean, calendarTopPicks: { __typename?: 'TenantFeaturesCalendarTopPicks', visibility: boolean } | null, charityMeals: { __typename?: 'TenantFeaturesCharityMeals', visibility: { __typename?: 'TenantFeaturesCharityMealsVisibility', regions: Array<string> } } | null, cateringAllergenTooltip: { __typename?: 'TenantCateringAllergenTooltip', visibility: boolean } | null, serviceOptions: { __typename?: 'TenantServiceOptions', visibility: boolean, staffServices: { __typename?: 'TenantServiceOptionsVisibility', visibility: boolean }, cutleryExtras: { __typename?: 'TenantServiceOptionsVisibility', visibility: boolean } } | null, emma: { __typename?: 'TenantFeaturesEmma', visibility: boolean, defaultSupplierId: number | null, showSubscribeToUpdatesCheckbox: boolean } | null, vendorHelpCentre: { __typename?: 'TenantFeaturesVendorHelpCentre', link: string } | null, cateringCoupons: { __typename?: 'TenantCateringCoupons', visibility: boolean } | null, cateringFilters: { __typename?: 'TenantCateringFilters', allergens: boolean, dietary: boolean } | null, printLabels: { __typename?: 'TenantPrintLabels', CC: { __typename?: 'TenantPrintLabelsOptions', VPDymo: boolean, VPA4: boolean, VPPackage: boolean, VPSummary: boolean }, GM: { __typename?: 'TenantPrintLabelsOptions', VPDymo: boolean, VPA4: boolean, VPPackage: boolean, VPSummary: boolean } }, prerenderMarketplaceMenu: { __typename?: 'TenantFeaturesPreRenderMarketplaceMenu', permalinks: Array<string> } | null, gmExpressCheckout: { __typename?: 'TenantGmExpressCheckout', visibility: boolean } | null, gmShowFullAddress: { __typename?: 'TenantFeaturesGmShowFullAddress', visibility: { __typename?: 'TenantFeaturesGmShowFullAddressVisibility', regions: Array<string> } | null } | null, gmHideDeliveryWindow: { __typename?: 'TenantFeaturesGmHideDeliveryWindow', visibility: boolean } | null, ccShowTimeslotWindow: { __typename?: 'TenantFeaturesCcShowTimeslotWindow', visibility: boolean } | null, gmDeliveryTimeslots: { __typename?: 'TenantFeaturesGmDeliveryTimeslots', start: string, end: string }, ccTopupAmounts: { __typename?: 'TenantFeaturesCcTopupAmounts', minimumTopup: number | null, topupValues: Array<number | null> } | null, menuItemAllergenAudit: { __typename?: 'TenantFeaturesMenuItemAllergenAudit', enabled: boolean } | null, cateringTeamOrder: { __typename?: 'TenantFeaturesCateringTeamOrder', visibility: { __typename?: 'TenantFeaturesCateringTeamOrderVisibility', regions: Array<string> } | null } | null } | null, contentSecurityPolicy: { __typename?: 'TenantContentSecurityPolicy', mediaSrc: Array<string>, fontSrc: Array<string>, styleSrc: Array<string>, scriptSrc: Array<string>, imgSrc: Array<string>, connectSrc: Array<string>, frameSrc: Array<string> }, transportTypes: { __typename?: 'TenantTransportTypes', regions: Array<{ __typename?: 'TenantTransportTypesRegion', countryCode: string, types: Array<{ __typename?: 'TenantTransportType', name: string, value: string }> }> }, guestAccountData: Array<{ __typename?: 'TenantGuestAccount', id: string, guestInvoiceAccountId: string | null }>, permissions: { __typename?: 'TenantPermissions', guestCheckoutByInvoiceAccountGm: boolean | null, allowUserSignIn: boolean, allowCreditCardPayments: boolean, allowTransferPayments: boolean | null, autoPopulatePlacedBy: boolean | null }, payments: { __typename?: 'TenantPayments', chargeCreditCardFee: boolean | null } | null }> } };

export type SubmitEmmaFormMutationVariables = Exact<{
  input: EmmaFormInput;
}>;


export type SubmitEmmaFormMutation = { __typename?: 'Mutation', submitEmmaForm: { __typename?: 'EmmaFormSubmissionResponse', message: string, success: boolean, id: string } };

export type AlertTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AlertTypesQuery = { __typename?: 'Query', alertTypes: Array<{ __typename?: 'AlertType', eventName: string, name: string, description: string, filters: Array<
      | { __typename: 'AlertTypeFilterAccount', name: string, field: string, type: AlertTypeFilterFieldType }
      | { __typename: 'AlertTypeFilterBoolean', name: string, field: string, type: AlertTypeFilterFieldType }
      | { __typename: 'AlertTypeFilterCountry', name: string, field: string, type: AlertTypeFilterFieldType }
      | { __typename: 'AlertTypeFilterDropdown', name: string, field: string, type: AlertTypeFilterFieldType, options: Array<string> }
      | { __typename: 'AlertTypeFilterNumber', name: string, field: string, type: AlertTypeFilterFieldType, condition: Array<string> }
      | { __typename: 'AlertTypeFilterString', name: string, field: string, type: AlertTypeFilterFieldType }
      | { __typename: 'AlertTypeFilterSupplier', name: string, field: string, type: AlertTypeFilterFieldType }
    > }> };

export type AlertsQueryVariables = Exact<{
  input: InputMaybe<AlertsInput>;
}>;


export type AlertsQuery = { __typename?: 'Query', alertTenantConfig: { __typename?: 'AlertTenantConfig', slackEnabled: boolean }, alerts: { __typename?: 'AlertsPaged', pageInfo: { __typename?: 'PageInfo', count: number, offset: number, limit: number, hasMore: boolean }, rows: Array<{ __typename?: 'Alert', id: string, name: string, eventName: string, filters: Array<
        | { __typename?: 'AlertFilterBoolean', field: string, value: boolean, type: AlertFilterFieldType }
        | { __typename?: 'AlertFilterNumber', field: string, valueInt: number, type: AlertFilterFieldType, condition: AlertFilterNumberCondition }
        | { __typename?: 'AlertFilterString', field: string, values: Array<string>, type: AlertFilterFieldType }
      >, destinations: { __typename?: 'AlertDestinations', slack: { __typename?: 'AlertSlackDestination', enabled: boolean, channels: Array<string> }, email: { __typename?: 'AlertEmailDestination', enabled: boolean, addresses: Array<string> } } }> } };

export type CreateAlertMutationVariables = Exact<{
  input: CreateAlertInput;
}>;


export type CreateAlertMutation = { __typename?: 'Mutation', createAlert: { __typename?: 'Alert', id: string } };

export type UpdateAlertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateAlertInput;
}>;


export type UpdateAlertMutation = { __typename?: 'Mutation', updateAlert: { __typename?: 'Alert', id: string } };

export type DeleteAlertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAlertMutation = { __typename?: 'Mutation', deleteAlert: string };

export type GenerateSlackAlertingOAuthUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateSlackAlertingOAuthUrlMutation = { __typename?: 'Mutation', generateSlackAlertingOAuthUrl: string };

export type AlertingPopulateAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type AlertingPopulateAccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, name: string } };

export type AlertingSupplierFilterQueryVariables = Exact<{
  filters: VendorFilters;
}>;


export type AlertingSupplierFilterQuery = { __typename?: 'Query', vendors: { __typename?: 'VendorsPaged', rows: Array<{ __typename?: 'Vendor', id: string, companyName: string }> } };

export type AlertingPopulateSupplierQueryVariables = Exact<{
  supplierId: Scalars['ID']['input'];
}>;


export type AlertingPopulateSupplierQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', id: string, companyName: string } };

export type UpdateCcClusterMutationVariables = Exact<{
  input: UpdateCcClusterInput;
}>;


export type UpdateCcClusterMutation = { __typename?: 'Mutation', updateCCCluster: { __typename?: 'CCCluster', id: string, name: string, code: string | null } };

export type DeleteCcClusterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCcClusterMutation = { __typename?: 'Mutation', deleteCCCluster: { __typename?: 'CCCluster', id: string, name: string, code: string | null } };

export type GetCcClustersQueryVariables = Exact<{
  input: CcSupplierOrdersInput;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  filters: InputMaybe<CcClusterListFilters>;
}>;


export type GetCcClustersQuery = { __typename?: 'Query', ccClusters: { __typename?: 'CCClustersPaged', rows: Array<{ __typename?: 'CCCluster', id: string, name: string, code: string | null, ccSupplierOrders: { __typename?: 'CCSupplierOrderPaged', rows: Array<{ __typename?: 'CCSupplierOrder', id: string, date: any, meal: Meal, reference: string, confirmed: boolean, accountId: string, vendor: { __typename?: 'Vendor', companyName: string } }>, pageInfo: { __typename?: 'PageInfo', count: number } }, accountLocations: Array<{ __typename?: 'AccountLocation', id: string, label: string | null, account: { __typename?: 'Account', id: string }, address: { __typename?: 'Address', street: string | null, city: string | null } }> }>, pageInfo: { __typename?: 'PageInfo', offset: number, limit: number, count: number, hasMore: boolean } } };

export type IncreaseUserCreditsMutationVariables = Exact<{
  input: AdminIncreaseUserCreditsInput;
}>;


export type IncreaseUserCreditsMutation = { __typename?: 'Mutation', adminIncreaseUserCredits: { __typename?: 'CreditTransaction', id: string, transactionId: string, userId: string, amount: number, type: string, description: string, currency: string, newBalance: number | null, createdAt: string } };

export type DecreaseUserCreditsMutationVariables = Exact<{
  input: AdminDecreaseUserCreditsInput;
}>;


export type DecreaseUserCreditsMutation = { __typename?: 'Mutation', adminDecreaseUserCredits: { __typename?: 'CreditTransaction', id: string, transactionId: string, userId: string, amount: number, type: string, description: string, currency: string, newBalance: number | null, createdAt: string } };

export type CcSubmenuLiveMenuItemsQueryVariables = Exact<{
  supplierId: Scalars['ID']['input'];
}>;


export type CcSubmenuLiveMenuItemsQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', id: string, liveMenuItems: { __typename?: 'MenuItemsPaged', pageInfo: { __typename?: 'PageInfo', limit: number, offset: number, count: number, hasMore: boolean }, items: Array<{ __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, activeTo: any | null, activeFrom: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null }> | null }> | null } } };

export type CcSubmenu_SupplierLiveMenuItemFragment = { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, activeTo: any | null, activeFrom: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null }> | null };

export type CcSubmenu_VariationDataFragment = { __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null };

export type CcSubmenu_ItemDataFragment = { __typename?: 'CCSubmenuItem', ccVariationId: string, itemCoreId: string, deletedCoreItem: { __typename?: 'MenuItemIncDeleted', _id: string, item: { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, activeTo: any | null, activeFrom: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null }> | null } } };

export type GetCcSubmenuQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetCcSubmenuQuery = { __typename?: 'Query', ccSubmenu: { __typename?: 'CCSubmenu', id: string, description: string, isActive: boolean, maxCapacity: number | null, name: string, publicName: string | null, copiable: boolean, tenantId: string, visibleToClient: boolean, isUsedLive: boolean, liveAllocations: Array<{ __typename?: 'CCSubmenuAllocation', date: any, meal: Meal }>, locationCapacities: Array<{ __typename?: 'CCSubmenuLocationCapacity', maxCapacity: number, vendorLocation: { __typename?: 'VendorLocation', id: string, label: string | null, line1: string | null, city: string | null, postcode: string | null } }>, vendor: { __typename?: 'Vendor', id: string, groupCode: string | null, companyName: string, isCCActive: boolean | null, currency: Currency | null, locations: Array<{ __typename?: 'VendorLocation', id: string, label: string | null, line1: string | null, city: string | null, postcode: string | null }> }, items: { __typename?: 'CCSubmenuItems', submenuId: string, data: Array<{ __typename?: 'CCSubmenuItem', ccVariationId: string, itemCoreId: string, deletedCoreItem: { __typename?: 'MenuItemIncDeleted', _id: string, item: { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, activeTo: any | null, activeFrom: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null }> | null } } }> } } };

export type EmmaFormResponsesQueryVariables = Exact<{
  input: EmmaFormResponsesInput;
}>;


export type EmmaFormResponsesQuery = { __typename?: 'Query', emmaFormResponses: { __typename?: 'EmmaFormResponsePaged', pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean, limit: number, offset: number }, items: Array<{ __typename?: 'EmmaFormResponse', id: string, headcount: number, date: string, time: string | null, budgetType: EmmaFormBudgetType, budget: number, occasion: string, createdAt: string | null, subscribeToUpdates: boolean | null, status: EmmaFormResponseStatus, contact: { __typename?: 'EmmaFormContact', firstName: string, lastName: string, companyName: string }, adminAssigned: { __typename?: 'EmmaFormResponseAdminUser', id: number, name: string } | null }> } };

export type MessageTemplatesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MessageTemplatesQuery = { __typename?: 'Query', messageTemplates: { __typename?: 'MessageTemplatePaged', rows: Array<{ __typename?: 'MessageTemplate', body: string | null, id: number, name: string }> } };

export type GetSignupMetadataQueryVariables = Exact<{
  token: Scalars['ID']['input'];
}>;


export type GetSignupMetadataQuery = { __typename?: 'Query', signupMetadata: { __typename?: 'SignupMetadata', firstName: string, lastName: string, phone: string, email: string, companyName: string | null, subscribeNewsletter: boolean, accountId: number | null } | null };

export type GetCaInvoiceAccountsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCaInvoiceAccountsListQuery = { __typename?: 'Query', me: { __typename?: 'User', account: { __typename?: 'Account', id: string, invoiceAccounts: Array<{ __typename?: 'InvoiceAccount', id: string, label: string | null, flexDeferredCustomerId: string | null }> } | null } };

export type CustomerOrdersReportQueryVariables = Exact<{
  input: InputMaybe<CustomerOrdersReportInput>;
  period: TimePeriod;
  dataAggregation: DataAggregation;
}>;


export type CustomerOrdersReportQuery = { __typename?: 'Query', customerOrdersReport: { __typename?: 'CustomerOrdersReport', aggregateByPeriod: { __typename?: 'CustomerOrderAmountAggregate', current: Array<{ __typename?: 'AggregateByPeriod', amount: number, date: string }> | null, previous: Array<{ __typename?: 'AggregateByPeriod', amount: number, date: string }> | null } | null, aggregateByUser: Array<{ __typename?: 'CustomerOrderUserAggregate', user: string, spend: number, orderCount: number, averageOrderValue: number, numberOfVendors: number }> | null, aggregateByVendor: Array<{ __typename?: 'CustomerOrderVendorAggregate', vendor: string, totalSpend: number, orderCount: number, averageOrderValue: number }> | null, aggregateByServiceType: Array<{ __typename?: 'CustomerOrderServiceTypeAggregate', serviceType: OrderServiceType, spend: number, orderCount: number, percentage: number }> | null, aggregateByLocation: Array<{ __typename?: 'CustomerOrderLocationAggregate', locationLabel: string, spend: number, orderCount: number, percentage: number }> | null, aggregateByOwnership: Array<{ __typename?: 'CustomerOrderOwnershipAggregate', category: string, totalSpend: number, orderCount: number, averageOrderValue: number }> | null, aggregateByPostcode: Array<{ __typename?: 'CustomerOrderPostcodeAggregate', postcode: string, spend: number, orderCount: number }> | null, aggregateByCity: Array<{ __typename?: 'CustomerOrderCityAggregate', city: string, spend: number, orderCount: number }> | null, totals: { __typename?: 'CustomerOrderTotals', averageOrderValue: number, percentageChange: number | null, previousPeriodSpend: number | null, spendPerHead: number, totalSpend: number, avgPerOrderPerHead: number | null, serviceTypeAggregate: Array<{ __typename?: 'CustomerOrderServiceTypeAggregate', serviceType: OrderServiceType, spend: number, orderCount: number, percentage: number }> | null } | null } };

export type CustomerOrdersAllTypeTableFragment = { __typename?: 'CustomerOrdersAllType', orderNumber: string, supplierName: string, deliveryAddress: string, deliveryDate: string, contact: string, subTotal: number, total: number, orderType: OrderType, serviceType: OrderServiceType | null };

export type CustomerOrdersReportPagedQueryVariables = Exact<{
  customerOrdersReportInput: InputMaybe<CustomerOrdersReportInput>;
  allOrdersWithPagingInput: InputMaybe<AllOrdersWithPagingInput>;
}>;


export type CustomerOrdersReportPagedQuery = { __typename?: 'Query', customerOrdersReport: { __typename?: 'CustomerOrdersReport', allOrdersWithPaging: { __typename?: 'CustomerOrdersAllTypePaged', items: Array<{ __typename?: 'CustomerOrdersAllType', orderNumber: string, supplierName: string, deliveryAddress: string, deliveryDate: string, contact: string, subTotal: number, total: number, orderType: OrderType, serviceType: OrderServiceType | null }>, pageInfo: { __typename?: 'PageInfo', offset: number, limit: number, count: number, hasMore: boolean } } | null } };

export type GetOrdersReportQueryVariables = Exact<{
  input: InputMaybe<CustomerOrdersReportInput>;
}>;


export type GetOrdersReportQuery = { __typename?: 'Query', customerOrdersReport: { __typename?: 'CustomerOrdersReport', allOrderTypesWithFlexData: Array<{ __typename?: 'CustomerOrdersAllTypeWithFlexData', flexInvoiceNumber: string | null, order: { __typename?: 'CustomerOrdersAllType', invoiceAccountName: string | null, orderNumber: string, supplierName: string, deliveryAddress: string, deliveryDate: string, deliveryTime: string | null, contact: string, headCount: number | null, total: number, subTotal: number, orderType: OrderType, serviceType: OrderServiceType | null, referenceFields: Array<{ __typename?: 'OrderReferenceFieldResolvedValue', label: string, value: string } | null> | null } }> | null } };

export type GetOrderItemsReportQueryVariables = Exact<{
  input: InputMaybe<CustomerOrdersReportInput>;
}>;


export type GetOrderItemsReportQuery = { __typename?: 'Query', customerOrdersReport: { __typename?: 'CustomerOrdersReport', orderItemsCsv: { __typename?: 'orderItemsCsvResult', url: string | null } | null } };

export type GetAccountLocationsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  filters: InputMaybe<AccountLocationFilters>;
}>;


export type GetAccountLocationsQuery = { __typename?: 'Query', account: { __typename?: 'Account', locationsPaged: { __typename?: 'AccountLocationsPaged', rows: Array<{ __typename?: 'AccountLocation', address: { __typename?: 'Address', city: string | null, postcode: string | null } }> } } };

export type GetCaUsersListPageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCaUsersListPageDataQuery = { __typename?: 'Query', me: { __typename?: 'User', account: { __typename?: 'Account', id: string, signUpCode: string | null, onboardingLink: string, ssoEnabled: boolean, isCCActive: boolean, isGMActive: boolean } | null } };

export type UserAllergensFragment = { __typename?: 'UserAllergens', celery: boolean, cereals: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, lupin: boolean, milk: boolean, molluscs: boolean, mustard: boolean, nuts: boolean, peanuts: boolean, sesame: boolean, soybeans: boolean, sulphur: boolean };

export type UserDietaryPreferencesFragment = { __typename?: 'UserDietaryPreferences', vegan: boolean, vegetarian: boolean, halal: boolean, kosher: boolean, noRefinedSugar: boolean };

export type UserContactPreferencesFragment = { __typename?: 'UserContactPreferences', notificationPreference: string, remindersDeliveries: boolean, remindersSubsidised: boolean, remindersUnsubsidised: boolean, remindersWeekly: boolean, isAccountPrimaryContact: boolean };

export type GetUserAccountDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAccountDataQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone: string | null, fullName: string, role: UserRole | null, teamId: number | null, invoiceApproved: boolean, privacyAccepted: string | null, contactPreferences: { __typename?: 'UserContactPreferences', notificationPreference: string, remindersDeliveries: boolean, remindersSubsidised: boolean, remindersUnsubsidised: boolean, remindersWeekly: boolean, isAccountPrimaryContact: boolean }, languageSettings: { __typename?: 'UserLanguageSettings', locale: string }, dietaryPreferences: { __typename?: 'UserDietaryPreferences', vegan: boolean, vegetarian: boolean, halal: boolean, kosher: boolean, noRefinedSugar: boolean }, allergens: { __typename?: 'UserAllergens', celery: boolean, cereals: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, lupin: boolean, milk: boolean, molluscs: boolean, mustard: boolean, nuts: boolean, peanuts: boolean, sesame: boolean, soybeans: boolean, sulphur: boolean }, autopilotSettings: { __typename?: 'UserAutopilotSettings', enabled: boolean, active: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean, userCanEdit: boolean }, accountLocation: { __typename?: 'AccountLocation', id: string, label: string | null, isCCActive: boolean, isGmActive: boolean, timezone: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, street: string | null, city: string | null, postcode: string | null, country: string | null, latitude: number | null, longitude: number | null } } | null, nativeAppSettings: { __typename?: 'UserNativeAppSettings', hasApp: boolean }, account: { __typename?: 'Account', id: string, name: string, isCCActive: boolean, isGMActive: boolean, topUpEnabled: boolean, ssoEnabled: boolean, autopilotEnabled: boolean, currency: Currency, managerName: string | null, ccTeams: Array<{ __typename?: 'CCTeam', id: number, name: string, code: string | null } | null> | null, locations: Array<{ __typename?: 'AccountLocation', id: string, label: string | null, isCCActive: boolean, isGmActive: boolean, address: { __typename?: 'Address', label: string | null, city: string | null, postcode: string | null, country: string | null } } | null> | null } | null } };

export type UpdateUserAllergensMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateUserAllergensInput;
}>;


export type UpdateUserAllergensMutation = { __typename?: 'Mutation', updateUserAllergens: { __typename?: 'UserAllergens', celery: boolean, cereals: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, lupin: boolean, milk: boolean, molluscs: boolean, mustard: boolean, nuts: boolean, peanuts: boolean, sesame: boolean, soybeans: boolean, sulphur: boolean } };

export type UpdateUserAutopilotSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateUserAutopilotSettingsInput;
}>;


export type UpdateUserAutopilotSettingsMutation = { __typename?: 'Mutation', updateUserAutopilotSettings: { __typename?: 'UserAutopilotSettings', enabled: boolean, active: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean, userCanEdit: boolean } };

export type UpdateUserDietaryPreferencesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateUserDietaryPreferencesInput;
}>;


export type UpdateUserDietaryPreferencesMutation = { __typename?: 'Mutation', updateUserDietaryPreferences: { __typename?: 'UserDietaryPreferences', vegan: boolean, vegetarian: boolean, halal: boolean, kosher: boolean, refinedSugar: boolean } };

export type GetDashboardCcOrdersDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardCcOrdersDataQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, role: UserRole | null, account: { __typename?: 'Account', id: string, name: string, userInterfaceSettings: { __typename?: 'AccountUserInterfaceSettings', hideCCPrices: boolean }, locationsPaged: { __typename?: 'AccountLocationsPaged', rows: Array<{ __typename?: 'AccountLocation', id: string, label: string | null }> } } | null } };

export type CancelCcOrderItemMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CancelCcOrderItemMutation = { __typename?: 'Mutation', deleteCCOrderItem: { __typename?: 'CCOrderItem', id: number } };

export type GetDashboardCanteenTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardCanteenTeamsQuery = { __typename?: 'Query', me: { __typename?: 'User', account: { __typename?: 'Account', id: string, isCCActive: boolean, onboardingLink: string, signUpCode: string | null, locationsPaged: { __typename?: 'AccountLocationsPaged', rows: Array<{ __typename?: 'AccountLocation', id: string, label: string | null, ccAvailabilities: { __typename?: 'CCAvailabilitiesPaged', rows: Array<{ __typename?: 'CCAvailability', weekday: number, meal: string }> } }> }, ccTeams: Array<{ __typename?: 'CCTeam', id: number, code: string | null, name: string, users: Array<{ __typename?: 'User', id: string, fullName: string, email: string }> | null } | null> | null } | null } };

export type CcSubsidyFieldsFragment = { __typename?: 'CCSubsidy', id: number, teamId: number, accountLocationId: number | null, meal: MealType | null, subsidy: any | null, type: SubsidyType, weekday: number | null };

export type GetTeamSubsidiesQueryVariables = Exact<{
  teamId: Scalars['Int']['input'];
}>;


export type GetTeamSubsidiesQuery = { __typename?: 'Query', ccTeamSubsidies: Array<{ __typename?: 'CCSubsidy', id: number, teamId: number, accountLocationId: number | null, meal: MealType | null, subsidy: any | null, type: SubsidyType, weekday: number | null }> };

export type SetTeamSubsidiesMutationVariables = Exact<{
  teamId: Scalars['Int']['input'];
  subsidies: Array<SubsidyInput> | SubsidyInput;
}>;


export type SetTeamSubsidiesMutation = { __typename?: 'Mutation', setTeamSubsidies: Array<{ __typename?: 'CCSubsidy', id: number, teamId: number, accountLocationId: number | null, meal: MealType | null, subsidy: any | null, type: SubsidyType, weekday: number | null }> };

export type CreateCanteenTeamMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  input: CreateCcTeamInput;
}>;


export type CreateCanteenTeamMutation = { __typename?: 'Mutation', createCCTeam: { __typename?: 'CCTeam', id: number, name: string } };

export type AssignCanteenTeamUserMutationVariables = Exact<{
  teamId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type AssignCanteenTeamUserMutation = { __typename?: 'Mutation', assignUsersToTeam: { __typename?: 'AssignUsersToTeamResult', success: boolean, message: string } };

export type RemoveCanteenTeamUserMutationVariables = Exact<{
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type RemoveCanteenTeamUserMutation = { __typename?: 'Mutation', assignUsersToTeam: { __typename?: 'AssignUsersToTeamResult', success: boolean, message: string } };

export type SearchCanteenTeamUsersQueryVariables = Exact<{
  input: UserSearch;
}>;


export type SearchCanteenTeamUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersPaged', rows: Array<{ __typename?: 'User', id: string, fullName: string, email: string, teamId: number | null }> } };

export type UpdateCanteenTeamMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateCcTeamInput;
}>;


export type UpdateCanteenTeamMutation = { __typename?: 'Mutation', updateCCTeam: { __typename?: 'CCTeam', id: number, name: string, code: string | null } };

export type DeleteCanteenTeamMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCanteenTeamMutation = { __typename?: 'Mutation', deleteCCTeam: { __typename?: 'DeleteCCTeamResult', success: boolean, message: string } };

export type DeleteAccountLocationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteAccountLocationMutation = { __typename?: 'Mutation', deleteAccountLocation: { __typename?: 'DeleteAccountLocationResult', success: boolean, message: string, location: { __typename?: 'AccountLocation', id: string, label: string | null, deletedAt: string | null } | null } };

export type CcMealServiceForConfirmationFragment = { __typename?: 'CCMealService', meal: Meal, menuIsPublished: boolean, openTime: any, closeTime: any, orderedItems: { __typename?: 'CCMealServiceOrderedItems', orderPlaced: boolean }, timeslots: Array<{ __typename?: 'CCMealServiceTimeslot', vendorMenus: Array<{ __typename?: 'CCVendorMenu', menuItems: { __typename?: 'CCVendorMenuItems', pageInfo: { __typename?: 'PageInfo', count: number } } }> }> };

export type CcConfirmationUpcomingMenusQueryVariables = Exact<{ [key: string]: never; }>;


export type CcConfirmationUpcomingMenusQuery = { __typename?: 'Query', me: { __typename?: 'User', accountLocation: { __typename?: 'AccountLocation', timezone: string } | null, upcomingCcMenus: Array<{ __typename?: 'CCDateMealServiceData', date: any, lunch: { __typename?: 'CCMealService', meal: Meal, menuIsPublished: boolean, openTime: any, closeTime: any, orderedItems: { __typename?: 'CCMealServiceOrderedItems', orderPlaced: boolean }, timeslots: Array<{ __typename?: 'CCMealServiceTimeslot', vendorMenus: Array<{ __typename?: 'CCVendorMenu', menuItems: { __typename?: 'CCVendorMenuItems', pageInfo: { __typename?: 'PageInfo', count: number } } }> }> } | null, dinner: { __typename?: 'CCMealService', meal: Meal, menuIsPublished: boolean, openTime: any, closeTime: any, orderedItems: { __typename?: 'CCMealServiceOrderedItems', orderPlaced: boolean }, timeslots: Array<{ __typename?: 'CCMealServiceTimeslot', vendorMenus: Array<{ __typename?: 'CCVendorMenu', menuItems: { __typename?: 'CCVendorMenuItems', pageInfo: { __typename?: 'PageInfo', count: number } } }> }> } | null, breakfast: { __typename?: 'CCMealService', meal: Meal, menuIsPublished: boolean, openTime: any, closeTime: any, orderedItems: { __typename?: 'CCMealServiceOrderedItems', orderPlaced: boolean }, timeslots: Array<{ __typename?: 'CCMealServiceTimeslot', vendorMenus: Array<{ __typename?: 'CCVendorMenu', menuItems: { __typename?: 'CCVendorMenuItems', pageInfo: { __typename?: 'PageInfo', count: number } } }> }> } | null }> } };

export type OrderConfirmationItemDetailsFragment = { __typename?: 'CCOrderItem', id: number, transactionId: string, name: string, qty: number, price: number, description: string | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, accountLocation: { __typename?: 'AccountLocation', id: string, timezone: string }, liveMenuItem: { __typename?: 'MenuItemVariation', coreLiveItem: { __typename?: 'MenuItem', image: string | null } | null }, options: { __typename?: 'CCOrderItemOptions', items: Array<{ __typename?: 'CCOrderItemOption', id: number, name: string, price: number }> } };

export type CcOrderByTransactionQueryVariables = Exact<{
  transactionId: Scalars['String']['input'];
}>;


export type CcOrderByTransactionQuery = { __typename?: 'Query', ccOrderByTransaction: { __typename?: 'CCOrderConfirmation', reference: string, date: any, meal: Meal, subsidyCreditsUsed: number, personalCreditsUsed: number, subtotal: number, total: number, currency: string, hidePrices: boolean, timeSlot: { __typename?: 'CCOrderTimeSlot', start: string, end: string }, address: { __typename?: 'CCOrderAddress', line1: string, line2: string | null, city: string, postcode: string, location: string }, itemsByVendor: Array<{ __typename?: 'GroupedCCOrderItemsByVendor', vendor: { __typename?: 'Vendor', id: string, companyName: string }, items: Array<{ __typename?: 'CCOrderItem', id: number, transactionId: string, name: string, qty: number, price: number, description: string | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, accountLocation: { __typename?: 'AccountLocation', id: string, timezone: string }, liveMenuItem: { __typename?: 'MenuItemVariation', coreLiveItem: { __typename?: 'MenuItem', image: string | null } | null }, options: { __typename?: 'CCOrderItemOptions', items: Array<{ __typename?: 'CCOrderItemOption', id: number, name: string, price: number }> } }>, supplierOrder: { __typename?: 'CCSupplierOrder', id: string, reference: string, arrivalTime: any, duration: number } }> } };

export type TrackingUserOrderInfoQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type TrackingUserOrderInfoQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, groupedOrderItemsByDate: Array<{ __typename?: 'GroupedCCOrderItem', id: string, orderItems: Array<{ __typename?: 'CCOrderItem', id: number, transactionId: string, name: string, fullPrice: number, qty: number }>, supplierOrder: { __typename?: 'CCSupplierOrder', id: string, meal: Meal, arrivalTime: any, arrivalTimeEnd: any, vendor: { __typename?: 'Vendor', id: string, companyName: string, logo: string | null, currency: Currency | null }, vendorLocation: { __typename?: 'VendorLocation', id: string, lat: number | null, lng: number | null }, ccAccountLocationOrders: Array<{ __typename?: 'CCAccountLocationOrder', accountLocation: { __typename?: 'AccountLocation', id: string, label: string | null, lat: number | null, lng: number | null } }> } }> } };

export type TrackingCaClusterOrdersQueryVariables = Exact<{
  clusterId: Scalars['ID']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type TrackingCaClusterOrdersQuery = { __typename?: 'Query', ccCluster: { __typename?: 'CCCluster', id: string, name: string, ccSupplierOrders: { __typename?: 'CCSupplierOrderPaged', rows: Array<{ __typename?: 'CCSupplierOrder', id: string, date: any, arrivalTime: any, arrivalTimeEnd: any, vendor: { __typename?: 'Vendor', id: string, companyName: string, logo: string | null, currency: Currency | null }, vendorLocation: { __typename?: 'VendorLocation', id: string, lat: number | null, lng: number | null }, ccAccountLocationOrders: Array<{ __typename?: 'CCAccountLocationOrder', accountLocation: { __typename?: 'AccountLocation', id: string, label: string | null, lat: number | null, lng: number | null } }> }>, pageInfo: { __typename?: 'PageInfo', offset: number, limit: number, count: number, hasMore: boolean } } } };

export type GetAccountsForSignupConfirmationQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetAccountsForSignupConfirmationQuery = { __typename?: 'Query', accounts: { __typename?: 'AccountsPaged', rows: Array<{ __typename?: 'Account', id: string, name: string, isCCActive: boolean }> } };

export type ResendSignupConfirmationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  input: SignupConfirmationInput;
}>;


export type ResendSignupConfirmationMutation = { __typename?: 'Mutation', resendSignupConfirmation: boolean };

export type GetUserForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  accountId: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserForEditQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone: string | null, fullName: string, role: UserRole | null, teamId: number | null, invoiceApproved: boolean, privacyAccepted: string | null, contactPreferences: { __typename?: 'UserContactPreferences', notificationPreference: string, remindersDeliveries: boolean, remindersSubsidised: boolean, remindersUnsubsidised: boolean, remindersWeekly: boolean, isAccountPrimaryContact: boolean }, languageSettings: { __typename?: 'UserLanguageSettings', locale: string }, dietaryPreferences: { __typename?: 'UserDietaryPreferences', vegan: boolean, vegetarian: boolean, halal: boolean, kosher: boolean, noRefinedSugar: boolean }, allergens: { __typename?: 'UserAllergens', celery: boolean, cereals: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, lupin: boolean, milk: boolean, molluscs: boolean, mustard: boolean, nuts: boolean, peanuts: boolean, sesame: boolean, soybeans: boolean, sulphur: boolean }, autopilotSettings: { __typename?: 'UserAutopilotSettings', enabled: boolean, active: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean, userCanEdit: boolean }, accountLocation: { __typename?: 'AccountLocation', id: string, label: string | null, isCCActive: boolean, isGmActive: boolean, timezone: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, street: string | null, city: string | null, postcode: string | null, country: string | null, latitude: number | null, longitude: number | null } } | null, nativeAppSettings: { __typename?: 'UserNativeAppSettings', hasApp: boolean }, accountSettings: { __typename?: 'UserAccountSettings', costCentre: string | null }, subsidySettings: { __typename?: 'UserSubsidySettings', unlimitedSubsidy: boolean }, wallet: { __typename?: 'UserWallet', balance: number }, account: { __typename?: 'Account', id: string, name: string, isCCActive: boolean, isGMActive: boolean, topUpEnabled: boolean, ssoEnabled: boolean, autopilotEnabled: boolean, invoiceApproved: boolean | null, currency: Currency, managerName: string | null, userInterfaceSettings: { __typename?: 'AccountUserInterfaceSettings', hideCCPrices: boolean }, ccTeams: Array<{ __typename?: 'CCTeam', id: number, name: string, code: string | null } | null> | null, locations: Array<{ __typename?: 'AccountLocation', id: string, label: string | null, isCCActive: boolean, isGmActive: boolean, address: { __typename?: 'Address', label: string | null, city: string | null, postcode: string | null, country: string | null } } | null> | null } | null } };

export type UpdateUserForEditMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
}>;


export type UpdateUserForEditMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email: string, privacyAccepted: string | null, teamId: number | null, phone: string | null, accountLocation: { __typename?: 'AccountLocation', id: string, label: string | null } | null, contactPreferences: { __typename?: 'UserContactPreferences', notificationPreference: string, remindersDeliveries: boolean, remindersSubsidised: boolean, remindersUnsubsidised: boolean, remindersWeekly: boolean, isAccountPrimaryContact: boolean }, allergens: { __typename?: 'UserAllergens', celery: boolean, cereals: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, lupin: boolean, milk: boolean, molluscs: boolean, mustard: boolean, nuts: boolean, peanuts: boolean, sesame: boolean, soybeans: boolean, sulphur: boolean }, dietaryPreferences: { __typename?: 'UserDietaryPreferences', vegan: boolean, vegetarian: boolean, halal: boolean, kosher: boolean, noRefinedSugar: boolean }, accountSettings: { __typename?: 'UserAccountSettings', costCentre: string | null } } };

export type GetAccountTeamsForUserCreateQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetAccountTeamsForUserCreateQuery = { __typename?: 'Query', account: { __typename?: 'Account', ccTeams: Array<{ __typename?: 'CCTeam', id: number, name: string } | null> | null } };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type GetAccountLocationsForUserListQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetAccountLocationsForUserListQuery = { __typename?: 'Query', account: { __typename?: 'Account', locations: Array<{ __typename?: 'AccountLocation', id: string, label: string | null } | null> | null } };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type RestoreUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type RestoreUserMutation = { __typename?: 'Mutation', restoreUser: { __typename?: 'User', id: string, deletedAt: string | null } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string } };

export type GetAccountDetailsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetAccountDetailsQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, name: string, archivedAt: any | null, isCCActive: boolean, isGMActive: boolean, napkinsCutlery: boolean, autoSendMenu: boolean, highRisk: boolean, ssoEnabled: boolean, autopilotEnabled: boolean, topUpEnabled: boolean, currency: Currency, invoiceApproved: boolean | null, managerName: string | null, onboardingLink: string, notes: string, code: string | null, externalId: string | null, signUpCode: string | null, archivedBy: { __typename?: 'Admin', fullName: string } | null, primaryContacts: { __typename?: 'UsersPaged', rows: Array<{ __typename?: 'User', id: string, fullName: string, phone: string | null, email: string }> }, userInterfaceSettings: { __typename?: 'AccountUserInterfaceSettings', hideCCPrices: boolean }, approvedSuppliers: Array<{ __typename?: 'ApprovedSupplier', supplierId: number, supplierName: string | null }> | null } };

export type GetAccountPrivateSuppliersQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type GetAccountPrivateSuppliersQuery = { __typename?: 'Query', accountPrivateSuppliers: { __typename?: 'AccountPrivateSuppliers', suppliers: Array<{ __typename?: 'PrivateSupplier', supplierId: number, supplierName: string | null }> | null } };

export type AdminUpdateAccountDetailsMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: UpdateAccountInput;
}>;


export type AdminUpdateAccountDetailsMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', id: string, name: string, isCCActive: boolean, isGMActive: boolean, napkinsCutlery: boolean, autoSendMenu: boolean, highRisk: boolean, ssoEnabled: boolean, autopilotEnabled: boolean, currency: Currency, invoiceApproved: boolean | null, topUpEnabled: boolean, managerName: string | null, onboardingLink: string, notes: string, code: string | null, externalId: string | null, signUpCode: string | null, userInterfaceSettings: { __typename?: 'AccountUserInterfaceSettings', hideCCPrices: boolean } } };

export type AdminGetAccountLocationForEditQueryVariables = Exact<{
  accountLocationId: Scalars['ID']['input'];
}>;


export type AdminGetAccountLocationForEditQuery = { __typename?: 'Query', accountLocation: { __typename?: 'AccountLocation', id: string, label: string | null, isCCActive: boolean, phone: string | null, what3words: string | null, timezone: string, ccCluster: { __typename?: 'CCCluster', id: string, name: string } | null, address: { __typename?: 'Address', street: string | null, latitude: number | null, longitude: number | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, country: string | null, postcode: string | null, city: string | null }, contactPreferences: { __typename?: 'AccountLocationContactPreferences', dailyReminderDefaultOptIn: boolean }, deliveryPreferences: { __typename?: 'AccountLocationDeliveryPreferences', deliveryInstructions: string | null, preferredCourier: string | null, packingInstructions: string | null } } };

export type AdminUpdateAccountLocationMutationVariables = Exact<{
  updateAccountId: Scalars['ID']['input'];
  input: UpdateAccountLocationInput;
}>;


export type AdminUpdateAccountLocationMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', id: string } };

export type AdminCreateAccountLocationMutationVariables = Exact<{
  updateAccountId: Scalars['ID']['input'];
  input: CreateAccountLocationInput;
}>;


export type AdminCreateAccountLocationMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', id: string } };

export type AdminCreateCcClusterMutationVariables = Exact<{
  input: CreateCcClusterInput;
}>;


export type AdminCreateCcClusterMutation = { __typename?: 'Mutation', createCCCluster: { __typename?: 'CCCluster', id: string, name: string } };

export type AdminGetLocationsListForAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  filters: AccountLocationFilters;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminGetLocationsListForAccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', locationsPaged: { __typename?: 'AccountLocationsPaged', rows: Array<{ __typename?: 'AccountLocation', id: string, label: string | null, isCCActive: boolean, archivedAt: any | null, address: { __typename?: 'Address', flatOrBuilding: string | null, floorOrBuildingName: string | null, street: string | null, postcode: string | null, city: string | null, country: string | null } }>, pageInfo: { __typename?: 'PageInfo', limit: number, offset: number, count: number, hasMore: boolean } } } };

export type AdminSearchClustersForAccountLocationQueryVariables = Exact<{
  filters: CcClusterListFilters;
}>;


export type AdminSearchClustersForAccountLocationQuery = { __typename?: 'Query', ccClusters: { __typename?: 'CCClustersPaged', rows: Array<{ __typename?: 'CCCluster', id: string, name: string, code: string | null }> } };

export type AdminDeleteAccountLocationMutationVariables = Exact<{
  updateAccountId: Scalars['ID']['input'];
  input: DeleteAccountLocationInput;
}>;


export type AdminDeleteAccountLocationMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', id: string } };

export type ArchiveAccountMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  acknowledgeWarnings: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArchiveAccountMutation = { __typename?: 'Mutation', archiveAccount: { __typename?: 'ArchiveAccountPayload', account: { __typename?: 'Account', id: string, archivedAt: any | null } | null, blockers: Array<{ __typename?: 'ArchiveBlocker', code: ArchiveBlockerCode, message: string, count: number | null }>, warnings: Array<{ __typename?: 'ArchiveWarning', code: ArchiveWarningCode, message: string, count: number | null }> } };

export type AvailsOrderReferenceFieldsQueryVariables = Exact<{
  input: OrderReferenceFieldInput;
}>;


export type AvailsOrderReferenceFieldsQuery = { __typename?: 'Query', orderReferenceFields: Array<{ __typename?: 'OrderReferenceField', id: number, referenceFieldId: number, description: string | null, fieldType: ReferenceFieldType, isRequired: boolean, label: string, version: number, options: Array<{ __typename?: 'OrderReferenceFieldOption', id: number, orderReferenceFieldId: number, option: string, orderPriority: number }> }> };

export type AvailsAccountLocationReferenceFieldsQueryVariables = Exact<{
  accountLocationId: Scalars['ID']['input'];
  input: AccountLocationReferenceFieldValueInput;
}>;


export type AvailsAccountLocationReferenceFieldsQuery = { __typename?: 'Query', accountLocation: { __typename?: 'AccountLocation', id: string, accountLocationReferenceFieldValues: Array<{ __typename?: 'AccountLocationReferenceFieldValue', accountLocationReferenceFieldId: number, orderReferenceFieldId: number, description: string | null, fieldType: ReferenceFieldType, isRequired: boolean, label: string, value: string | null, version: number, options: Array<{ __typename?: 'AccountLocationReferenceFieldValueOption', id: number, accountLocationReferenceFieldId: number, option: string, orderPriority: number }> }> } };

export type UpdateAvailsAccountLocationReferenceFieldsMutationVariables = Exact<{
  accountLocationId: Scalars['Int']['input'];
  input: UpdateAccountLocationReferenceFieldsInput;
}>;


export type UpdateAvailsAccountLocationReferenceFieldsMutation = { __typename?: 'Mutation', updateAccountLocationReferenceFields: any | null };

export type AdminCreateAccountMutationVariables = Exact<{
  input: CreateAccountInput;
}>;


export type AdminCreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'Account', id: string } };

export type GetFinanceSettingsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetFinanceSettingsQuery = { __typename?: 'Query', account: { __typename?: 'Account', isCCActive: boolean, currency: Currency, financeSettings: { __typename?: 'AccountFinanceSettings', allowMinTopUpCc: boolean, contractDateFrom: any | null, contractDateTo: any | null, invoicingFormatGm: GmInvoicingFormat, paymentDueDaysAfterInvoice: number | null, additionalBillingNotes: string | null, chargeCreditCardFee: boolean | null } } };

export type UpdateFinanceSettingsMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  input: UpdateAccountFinanceSettingsInput;
}>;


export type UpdateFinanceSettingsMutation = { __typename?: 'Mutation', updateAccountFinanceSettings: { __typename?: 'AccountFinanceSettings', allowMinTopUpCc: boolean, contractDateFrom: any | null, contractDateTo: any | null, invoicingFormatGm: GmInvoicingFormat, paymentDueDaysAfterInvoice: number | null, additionalBillingNotes: string | null, chargeCreditCardFee: boolean | null } };

export type GenerateStripeSetupIntentOnFlexMutationVariables = Exact<{
  invoiceAccountId: Scalars['Int']['input'];
}>;


export type GenerateStripeSetupIntentOnFlexMutation = { __typename?: 'Mutation', generateStripeSetupIntentOnFlex: { __typename?: 'SetupIntent', clientSecret: string | null, customerSessionClientSecret: string | null } };

export type GetStripePublishableKeyQueryVariables = Exact<{
  billingEntityCode: Scalars['String']['input'];
}>;


export type GetStripePublishableKeyQuery = { __typename?: 'Query', retrieveStripePublishableKey: string };

export type UpdateFlexInvoiceAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateFlexInvoiceAccountInput;
}>;


export type UpdateFlexInvoiceAccountMutation = { __typename?: 'Mutation', updateFlexInvoiceAccount: { __typename?: 'FlexInvoiceAccount', id: string, accountId: string, name: string, timezone: string, locale: string, addressLine1: string, addressLine2: string | null, addressCity: string, addressCountry: string, addressPostcode: string, contactFirstName: string, contactLastName: string, contactPhoneNumber: string, primaryEmail: string, emailAddresses: Array<string> | null, entityNumber: string, entityRegion: string, entityTaxNumber: string | null, vatRegionId: number, isDefault: boolean, autoInvoice: boolean | null, invoicePerContact: boolean | null, invoicePerReferenceField: boolean | null, invoicePerType: boolean | null, invoiceByPantryOrder: boolean | null, invoiceByStandingOrder: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, invoiceConsolidationType: InvoiceConsolidationType | null, invoicePerOrderRecipientType: InvoicePerOrderRecipientType | null, referenceFieldLabelsForInvoice: Array<string> | null, autoPay: boolean, standingOrderInvoicingRules: { __typename?: 'StandingOrderInvoicingRules', applyStandingOrderInvoicingRules: boolean | null, autoInvoice: boolean | null, consolidateInvoice: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, splitByContact: boolean | null, splitByReferenceFields: boolean | null, referenceFieldLabelsForStandingOrderInvoice: Array<string> | null, invoiceEmailRecipientType: InvoicePerOrderRecipientType | null } | null } };

export type CreateFlexInvoiceAccountMutationVariables = Exact<{
  input: CreateFlexInvoiceAccountInput;
}>;


export type CreateFlexInvoiceAccountMutation = { __typename?: 'Mutation', createFlexInvoiceAccount: { __typename?: 'FlexInvoiceAccount', id: string, accountId: string, name: string, timezone: string, locale: string, addressLine1: string, addressLine2: string | null, addressCity: string, addressCountry: string, addressPostcode: string, contactFirstName: string, contactLastName: string, contactPhoneNumber: string, primaryEmail: string, emailAddresses: Array<string> | null, entityNumber: string, entityRegion: string, entityTaxNumber: string | null, vatRegionId: number, isDefault: boolean, autoInvoice: boolean | null, invoicePerContact: boolean | null, invoicePerReferenceField: boolean | null, invoicePerType: boolean | null, invoiceByPantryOrder: boolean | null, invoiceByStandingOrder: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, invoiceConsolidationType: InvoiceConsolidationType | null, invoicePerOrderRecipientType: InvoicePerOrderRecipientType | null, referenceFieldLabelsForInvoice: Array<string> | null, autoPay: boolean, standingOrderInvoicingRules: { __typename?: 'StandingOrderInvoicingRules', applyStandingOrderInvoicingRules: boolean | null, autoInvoice: boolean | null, consolidateInvoice: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, splitByContact: boolean | null, splitByReferenceFields: boolean | null, referenceFieldLabelsForStandingOrderInvoice: Array<string> | null, invoiceEmailRecipientType: InvoicePerOrderRecipientType | null } | null } };

export type DeleteFlexInvoiceAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFlexInvoiceAccountMutation = { __typename?: 'Mutation', deleteFlexInvoiceAccount: number };

export type FlexInvoiceAccountFragment = { __typename?: 'FlexInvoiceAccount', id: string, accountId: string, name: string, timezone: string, locale: string, addressLine1: string, addressLine2: string | null, addressCity: string, addressCountry: string, addressPostcode: string, contactFirstName: string, contactLastName: string, contactPhoneNumber: string, primaryEmail: string, emailAddresses: Array<string> | null, entityNumber: string, entityRegion: string, entityTaxNumber: string | null, vatRegionId: number, isDefault: boolean, autoInvoice: boolean | null, invoicePerContact: boolean | null, invoicePerReferenceField: boolean | null, invoicePerType: boolean | null, invoiceByPantryOrder: boolean | null, invoiceByStandingOrder: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, invoiceConsolidationType: InvoiceConsolidationType | null, invoicePerOrderRecipientType: InvoicePerOrderRecipientType | null, referenceFieldLabelsForInvoice: Array<string> | null, autoPay: boolean, standingOrderInvoicingRules: { __typename?: 'StandingOrderInvoicingRules', applyStandingOrderInvoicingRules: boolean | null, autoInvoice: boolean | null, consolidateInvoice: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, splitByContact: boolean | null, splitByReferenceFields: boolean | null, referenceFieldLabelsForStandingOrderInvoice: Array<string> | null, invoiceEmailRecipientType: InvoicePerOrderRecipientType | null } | null };

export type GetFlexInvoiceAccountsForAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetFlexInvoiceAccountsForAccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', flexInvoiceAccounts: Array<{ __typename?: 'FlexInvoiceAccount', id: string, accountId: string, name: string, timezone: string, locale: string, addressLine1: string, addressLine2: string | null, addressCity: string, addressCountry: string, addressPostcode: string, contactFirstName: string, contactLastName: string, contactPhoneNumber: string, primaryEmail: string, emailAddresses: Array<string> | null, entityNumber: string, entityRegion: string, entityTaxNumber: string | null, vatRegionId: number, isDefault: boolean, autoInvoice: boolean | null, invoicePerContact: boolean | null, invoicePerReferenceField: boolean | null, invoicePerType: boolean | null, invoiceByPantryOrder: boolean | null, invoiceByStandingOrder: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, invoiceConsolidationType: InvoiceConsolidationType | null, invoicePerOrderRecipientType: InvoicePerOrderRecipientType | null, referenceFieldLabelsForInvoice: Array<string> | null, autoPay: boolean, standingOrderInvoicingRules: { __typename?: 'StandingOrderInvoicingRules', applyStandingOrderInvoicingRules: boolean | null, autoInvoice: boolean | null, consolidateInvoice: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, splitByContact: boolean | null, splitByReferenceFields: boolean | null, referenceFieldLabelsForStandingOrderInvoice: Array<string> | null, invoiceEmailRecipientType: InvoicePerOrderRecipientType | null } | null }> } };

export type GetFlexInvoiceAccountQueryVariables = Exact<{
  invoiceAccountId: Scalars['ID']['input'];
}>;


export type GetFlexInvoiceAccountQuery = { __typename?: 'Query', flexInvoiceAccount: { __typename?: 'FlexInvoiceAccount', isPaymentMethodSaved: boolean, id: string, accountId: string, name: string, timezone: string, locale: string, addressLine1: string, addressLine2: string | null, addressCity: string, addressCountry: string, addressPostcode: string, contactFirstName: string, contactLastName: string, contactPhoneNumber: string, primaryEmail: string, emailAddresses: Array<string> | null, entityNumber: string, entityRegion: string, entityTaxNumber: string | null, vatRegionId: number, isDefault: boolean, autoInvoice: boolean | null, invoicePerContact: boolean | null, invoicePerReferenceField: boolean | null, invoicePerType: boolean | null, invoiceByPantryOrder: boolean | null, invoiceByStandingOrder: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, invoiceConsolidationType: InvoiceConsolidationType | null, invoicePerOrderRecipientType: InvoicePerOrderRecipientType | null, referenceFieldLabelsForInvoice: Array<string> | null, autoPay: boolean, referenceFields: Array<{ __typename?: 'ReferenceField', id: string, label: string, type: ReferenceFieldType, description: string | null, active: boolean, required: boolean }>, standingOrderInvoicingRules: { __typename?: 'StandingOrderInvoicingRules', applyStandingOrderInvoicingRules: boolean | null, autoInvoice: boolean | null, consolidateInvoice: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, splitByContact: boolean | null, splitByReferenceFields: boolean | null, referenceFieldLabelsForStandingOrderInvoice: Array<string> | null, invoiceEmailRecipientType: InvoicePerOrderRecipientType | null } | null } };

export type UpdateInvoiceAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateInvoiceAccountInput;
}>;


export type UpdateInvoiceAccountMutation = { __typename?: 'Mutation', updateInvoiceAccount: { __typename?: 'InvoiceAccount', id: string, additionalEmails: Array<string> | null, city: string, country: string | null, email: string | null, firstName: string | null, isDefault: boolean, label: string | null, lastName: string | null, line1: string, line2: string | null, phone: string | null, postcode: string, vat: string | null, vatRegionId: number, accountId: string, autoInvoice: boolean | null, invoicePerContact: boolean | null, invoicePerReferenceField: boolean | null, invoicePerType: boolean | null, invoiceByPantryOrder: boolean | null, invoiceByStandingOrder: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, invoiceConsolidationType: InvoiceConsolidationType | null, invoicePerOrderRecipientType: InvoicePerOrderRecipientType | null, referenceFieldLabelsForInvoice: Array<string> | null, autoPay: boolean | null } };

export type CreateInvoiceAccountMutationVariables = Exact<{
  input: CreateInvoiceAccountInput;
}>;


export type CreateInvoiceAccountMutation = { __typename?: 'Mutation', createInvoiceAccount: { __typename?: 'InvoiceAccount', id: string, additionalEmails: Array<string> | null, city: string, country: string | null, email: string | null, firstName: string | null, isDefault: boolean, label: string | null, lastName: string | null, line1: string, line2: string | null, phone: string | null, postcode: string, vat: string | null, vatRegionId: number, accountId: string, autoInvoice: boolean | null, invoicePerContact: boolean | null, invoicePerReferenceField: boolean | null, invoicePerType: boolean | null, invoiceByPantryOrder: boolean | null, invoiceByStandingOrder: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, invoiceConsolidationType: InvoiceConsolidationType | null, invoicePerOrderRecipientType: InvoicePerOrderRecipientType | null, referenceFieldLabelsForInvoice: Array<string> | null, autoPay: boolean | null } };

export type DeleteInvoiceAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteInvoiceAccountMutation = { __typename?: 'Mutation', deleteInvoiceAccount: number };

export type InvoiceAccountFragment = { __typename?: 'InvoiceAccount', id: string, additionalEmails: Array<string> | null, city: string, country: string | null, email: string | null, firstName: string | null, isDefault: boolean, label: string | null, lastName: string | null, line1: string, line2: string | null, phone: string | null, postcode: string, vat: string | null, vatRegionId: number, accountId: string, autoInvoice: boolean | null, invoicePerContact: boolean | null, invoicePerReferenceField: boolean | null, invoicePerType: boolean | null, invoiceByPantryOrder: boolean | null, invoiceByStandingOrder: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, invoiceConsolidationType: InvoiceConsolidationType | null, invoicePerOrderRecipientType: InvoicePerOrderRecipientType | null, referenceFieldLabelsForInvoice: Array<string> | null, autoPay: boolean | null };

export type GetInvoiceAccountsForAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetInvoiceAccountsForAccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', invoiceAccounts: Array<{ __typename?: 'InvoiceAccount', id: string, additionalEmails: Array<string> | null, city: string, country: string | null, email: string | null, firstName: string | null, isDefault: boolean, label: string | null, lastName: string | null, line1: string, line2: string | null, phone: string | null, postcode: string, vat: string | null, vatRegionId: number, accountId: string, autoInvoice: boolean | null, invoicePerContact: boolean | null, invoicePerReferenceField: boolean | null, invoicePerType: boolean | null, invoiceByPantryOrder: boolean | null, invoiceByStandingOrder: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, invoiceConsolidationType: InvoiceConsolidationType | null, invoicePerOrderRecipientType: InvoicePerOrderRecipientType | null, referenceFieldLabelsForInvoice: Array<string> | null, autoPay: boolean | null }> } };

export type CreateReferenceFieldMutationVariables = Exact<{
  invoiceAccountId: Scalars['ID']['input'];
  input: CreateReferenceFieldInput;
}>;


export type CreateReferenceFieldMutation = { __typename?: 'Mutation', createReferenceField: { __typename?: 'ReferenceField', id: string, label: string, description: string | null, type: ReferenceFieldType, active: boolean, required: boolean, isInvoiceSummaryField: boolean | null, options: Array<{ __typename?: 'ReferenceFieldOption', id: string, referenceFieldId: string, option: string, orderPriority: number }> } };

export type UpdateReferenceFieldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateReferenceFieldInput;
}>;


export type UpdateReferenceFieldMutation = { __typename?: 'Mutation', updateReferenceField: { __typename?: 'ReferenceField', id: string, label: string, description: string | null, type: ReferenceFieldType, active: boolean, required: boolean, isInvoiceSummaryField: boolean | null, options: Array<{ __typename?: 'ReferenceFieldOption', id: string, referenceFieldId: string, option: string, orderPriority: number }> } };

export type DeleteReferenceFieldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteReferenceFieldMutation = { __typename?: 'Mutation', deleteReferenceField: number };

export type GetReferenceFieldsForInvoiceAccountQueryVariables = Exact<{
  invoiceAccountId: Scalars['ID']['input'];
  options: InputMaybe<ReferenceFieldsOptionsInput>;
}>;


export type GetReferenceFieldsForInvoiceAccountQuery = { __typename?: 'Query', referenceFields: { __typename?: 'ReferenceFieldsPaged', rows: Array<{ __typename?: 'ReferenceField', id: string, label: string, type: ReferenceFieldType, description: string | null, active: boolean, required: boolean, isInvoiceSummaryField: boolean | null, options: Array<{ __typename?: 'ReferenceFieldOption', id: string, referenceFieldId: string, option: string, orderPriority: number }> }> } };

export type GetAllVatRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllVatRegionsQuery = { __typename?: 'Query', vatRegions: Array<{ __typename?: 'VatRegion', code: string, legacyId: number, name: string }> };

export type GetAccountFinanceSettingsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetAccountFinanceSettingsQuery = { __typename?: 'Query', account: { __typename?: 'Account', isCCActive: boolean, currency: Currency, financeSettings: { __typename?: 'AccountFinanceSettings', allowMinTopUpCc: boolean, budgetCodeCc: string | null, budgetCodeGm: string | null, contractDateFrom: any | null, contractDateTo: any | null, deliverySurchargeCc: number | null, deliverySurchargeCcExTax: number | null, invoicingFormatGm: GmInvoicingFormat, minOrderValueCc: number | null, minOrderValueCcExTax: number | null, minPlatformFeeCc: number | null, minPlatformFeeGm: number | null, orderValPercentPlatformFeeCc: number | null, orderValPercentPlatformFeeGm: number | null, paymentDueDaysAfterInvoice: number | null, additionalBillingNotes: string | null, isBudgetCodeMandatory: boolean | null, minPlatformFeeCcMonthlyExTax: number, orderValPercentEnterpriseDiscountGm: number | null, feeAndDiscountNotesGm: string | null, enterpriseCostPlusPricing: boolean, minMonthlyCateringSpendExTax: number } } };

export type UpdateAccountFinanceSettingsMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  input: UpdateAccountFinanceSettingsInput;
}>;


export type UpdateAccountFinanceSettingsMutation = { __typename?: 'Mutation', updateAccountFinanceSettings: { __typename?: 'AccountFinanceSettings', allowMinTopUpCc: boolean, budgetCodeCc: string | null, budgetCodeGm: string | null, contractDateFrom: any | null, contractDateTo: any | null, deliverySurchargeCc: number | null, deliverySurchargeCcExTax: number | null, invoicingFormatGm: GmInvoicingFormat, minOrderValueCc: number | null, minOrderValueCcExTax: number | null, minPlatformFeeCc: number | null, minPlatformFeeGm: number | null, orderValPercentPlatformFeeCc: number | null, orderValPercentPlatformFeeGm: number | null, paymentDueDaysAfterInvoice: number | null, additionalBillingNotes: string | null, isBudgetCodeMandatory: boolean | null, orderValPercentEnterpriseDiscountGm: number | null, feeAndDiscountNotesGm: string | null, enterpriseCostPlusPricing: boolean, minMonthlyCateringSpendExTax: number } };

export type FlexInvoiceCsvQueryVariables = Exact<{
  flexDeferredCustomerInvoiceId: Scalars['ID']['input'];
  accountId: Scalars['Int']['input'];
}>;


export type FlexInvoiceCsvQuery = { __typename?: 'Query', flexInvoice: { __typename?: 'FlexInvoice', id: string, csv: string | null } };

export type GetLegacyFlexDeferredCustomersForAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetLegacyFlexDeferredCustomersForAccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', defaultFlexDeferredCustomerId: string | null, invoiceAccounts: Array<{ __typename?: 'InvoiceAccount', flexDeferredCustomerId: string | null }> } };

export type GetAccountCountryFlexDeferredCustomersForAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetAccountCountryFlexDeferredCustomersForAccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', accountCountryFlexMappings: Array<{ __typename?: 'AccountCountryFlexMapping', country: string, flexDeferredCustomerId: string }>, invoiceAccounts: Array<{ __typename?: 'InvoiceAccount', flexDeferredCustomerId: string | null }> } };

export type FlexInvoicesQueryVariables = Exact<{
  input: FlexInvoicesInput;
}>;


export type FlexInvoicesQuery = { __typename?: 'Query', flexInvoices: { __typename?: 'FlexInvoicesPaged', items: Array<{ __typename?: 'FlexInvoice', id: string, accountName: string, number: string, total: string, createdAt: any, dueDate: any, status: FlexInvoiceStatus | null, country: string | null } | null>, pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean, limit: number, offset: number } } };

export type FlexInvoiceAllTypesQueryVariables = Exact<{
  flexInvoiceAllTypesInput: InputMaybe<FlexInvoicesInput>;
}>;


export type FlexInvoiceAllTypesQuery = { __typename?: 'Query', flexInvoiceAllTypes: { __typename?: 'FlexInvoiceAllTypesPaged', items: Array<{ __typename?: 'FlexInvoiceAllTypes', id: string, flexInvoiceId: string, invoiceType: FlexInvoiceType | null, number: string, createdAt: any, entityName: string, accountName: string, accountBusinessNumber: string, accountTaxNumber: string, accountAddress: string, accountContact: string | null, dueDate: any, total: string, status: FlexInvoiceStatus | null, csv: string | null, timezone: string | null, location: string | null, country: string | null, flexDeferredCustomerId: string | null, instant: boolean | null, assets: Array<{ __typename?: 'FlexInvoiceAsset', type: string, link: string }> | null } | null>, pageInfo: { __typename?: 'PageInfo', offset: number, limit: number, count: number, hasMore: boolean } } };

export type GetOrdersForFlexInvoiceQueryVariables = Exact<{
  input: InputMaybe<InvoiceOrderInput>;
}>;


export type GetOrdersForFlexInvoiceQuery = { __typename?: 'Query', invoiceOrders: { __typename?: 'InvoiceOrdersPaged', items: Array<{ __typename?: 'InvoiceOrder', id: string, number: string } | null> } };

export type RemoveOrdersFromFlexInvoiceMutationVariables = Exact<{
  flexInvoiceId: Scalars['ID']['input'];
  input: RemoveOrdersFromFlexInvoiceInput;
}>;


export type RemoveOrdersFromFlexInvoiceMutation = { __typename?: 'Mutation', removeOrdersFromFlexInvoice: boolean };

export type SendFlexInvoiceByEmailMutationVariables = Exact<{
  flexInvoiceId: Scalars['ID']['input'];
  emailAddresses: Array<Scalars['String']['input']> | Scalars['String']['input'];
  invoiceType: InputMaybe<FlexInvoiceType>;
}>;


export type SendFlexInvoiceByEmailMutation = { __typename?: 'Mutation', sendFlexInvoiceByEmail: boolean };

export type UpdateFlexInvoiceDetailsMutationVariables = Exact<{
  flexInvoiceId: Scalars['ID']['input'];
  updates: UpdateFlexInvoiceDetailsInput;
}>;


export type UpdateFlexInvoiceDetailsMutation = { __typename?: 'Mutation', updateFlexInvoiceDetails: boolean };

export type GetAccountNameQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetAccountNameQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, name: string, isCCActive: boolean, archivedAt: any | null, archivedBy: { __typename?: 'Admin', fullName: string } | null } };

export type MarkFlexInvoicesAsPaidMutationVariables = Exact<{
  input: MarkFlexInvoicesAsPaidInput;
}>;


export type MarkFlexInvoicesAsPaidMutation = { __typename?: 'Mutation', markFlexInvoicesAsPaid: { __typename?: 'MarkFlexInvoicesAsPaidResult', batchId: string, filename: string, totalInvoices: number, successCount: number, failedCount: number } };

export type ConsolidateFlexInvoiceMutationVariables = Exact<{
  input: ConsolidateFlexInvoiceInput;
}>;


export type ConsolidateFlexInvoiceMutation = { __typename?: 'Mutation', consolidateFlexInvoice: { __typename?: 'ConsolidateFlexInvoiceResult', customers: { __typename?: 'ConsolidateFlexInvoiceResultCustomer', message: string | null, status: string | null } | null, suppliers: { __typename?: 'ConsolidateFlexInvoiceResultSupplier', message: string | null, status: string | null } | null } };

export type LatestFlexConsolidationRunQueryVariables = Exact<{
  input: LatestFlexConsolidationRunInput;
}>;


export type LatestFlexConsolidationRunQuery = { __typename?: 'Query', latestFlexConsolidationRun: { __typename?: 'FlexConsolidationRunStatus', hasRun: boolean, status: string | null, type: string | null, completedAt: string | null } };

export type SyncInvoiceOrderWithFlexMutationVariables = Exact<{
  input: SyncInvoiceOrderWithFlex;
}>;


export type SyncInvoiceOrderWithFlexMutation = { __typename?: 'Mutation', syncInvoiceOrderWithFlex: { __typename?: 'SyncInvoiceOrderResult', message: string | null, status: string | null } };

export type SearchFlexInvoiceQueryVariables = Exact<{
  flexInvoiceAllTypesInput: InputMaybe<FlexInvoicesInput>;
}>;


export type SearchFlexInvoiceQuery = { __typename?: 'Query', flexInvoiceAllTypes: { __typename?: 'FlexInvoiceAllTypesPaged', items: Array<{ __typename?: 'FlexInvoiceAllTypes', number: string, accountId: number | null } | null> } };

export type SearchVendorFlexInvoiceQueryVariables = Exact<{
  input: VendorFlexInvoicesInput;
}>;


export type SearchVendorFlexInvoiceQuery = { __typename?: 'Query', vendorFlexInvoiceAllTypes: { __typename?: 'VendorFlexInvoiceAllTypesPaged', items: Array<{ __typename?: 'VendorFlexInvoiceAllTypes', number: string, supplierId: number | null } | null> } };

export type SummaryFlexReportCsvQueryVariables = Exact<{
  input: SummaryFlexReportCsvInput;
}>;


export type SummaryFlexReportCsvQuery = { __typename?: 'Query', summaryFlexReportCSV: string };

export type OrdersReportQueryVariables = Exact<{
  input: OrdersReportInput;
}>;


export type OrdersReportQuery = { __typename?: 'Query', ordersReport: { __typename?: 'OrdersReportResult', CC: { __typename?: 'OrdersReportResultCC', customerOrders: Array<{ __typename?: 'CustomerOrderResult', orderId: string, flexDeferredCustomerOrderId: string | null } | null>, supplierOrders: Array<{ __typename?: 'SupplierOrderResult', orderId: string, flexDeferredSupplierOrderId: string | null } | null> }, GM: { __typename?: 'OrdersReportResultGM', customerOrders: Array<{ __typename?: 'CustomerOrderResult', orderId: string, flexDeferredCustomerOrderId: string | null } | null>, supplierOrders: Array<{ __typename?: 'SupplierOrderResult', orderId: string, flexDeferredSupplierOrderId: string | null } | null> } } };

export type AdminAccountRowFragment = { __typename?: 'Account', id: string, signUpCode: string | null, name: string, archivedAt: any | null, currency: Currency, isCCActive: boolean, isGMActive: boolean, ssoEnabled: boolean, onboardingStatus: string | null, users: { __typename?: 'UsersPaged', pageInfo: { __typename?: 'PageInfo', count: number } }, locations: Array<{ __typename?: 'AccountLocation', address: { __typename?: 'Address', country: string | null } } | null> | null };

export type CustomerOrdersSummaryValueInsightsFragment = { __typename?: 'CustomerOrdersSummary', totalSpend: number, weeklyTotals: Array<{ __typename?: 'AggregateByPeriod', amount: number, date: string }>, orderTypeTotals: Array<{ __typename?: 'OrderTypeAmount', amount: number, orderType: OrderType }> | null };

export type AdminVendorRowFragment = { __typename?: 'Vendor', companyName: string, currency: Currency | null, id: string, isDraft: boolean | null, isCCActive: boolean | null, isGMActive: boolean | null, logo: string | null, locations: Array<{ __typename?: 'VendorLocation', country: string | null, contacts: Array<{ __typename?: 'VendorContact', fullName: string | null, email: string | null }> }> };

export type VendorStatementsSummaryValueInsightsFragment = { __typename?: 'VendorStatementsSummary', totalAmount: number, weeklyTotals: Array<{ __typename?: 'AggregateByPeriod', amount: number, date: string }>, orderTypeTotals: Array<{ __typename?: 'OrderTypeAmount', amount: number, orderType: OrderType }> | null };

export type GetAllAccountsQueryVariables = Exact<{
  input: AccountSearch;
}>;


export type GetAllAccountsQuery = { __typename?: 'Query', accounts: { __typename?: 'AccountsPaged', pageInfo: { __typename?: 'PageInfo', count: number }, rows: Array<{ __typename?: 'Account', id: string, signUpCode: string | null, name: string, archivedAt: any | null, currency: Currency, isCCActive: boolean, isGMActive: boolean, ssoEnabled: boolean, onboardingStatus: string | null, users: { __typename?: 'UsersPaged', pageInfo: { __typename?: 'PageInfo', count: number } }, locations: Array<{ __typename?: 'AccountLocation', address: { __typename?: 'Address', country: string | null } } | null> | null }> } };

export type GetAllAccountsWithSummaryQueryVariables = Exact<{
  input: AccountSearch;
  ordersInput: CustomerOrdersReportForAccountInput;
}>;


export type GetAllAccountsWithSummaryQuery = { __typename?: 'Query', accounts: { __typename?: 'AccountsPaged', pageInfo: { __typename?: 'PageInfo', count: number }, rows: Array<{ __typename?: 'Account', id: string, signUpCode: string | null, name: string, archivedAt: any | null, currency: Currency, isCCActive: boolean, isGMActive: boolean, ssoEnabled: boolean, onboardingStatus: string | null, customerOrdersSummary: { __typename?: 'CustomerOrdersSummary', totalSpend: number, weeklyTotals: Array<{ __typename?: 'AggregateByPeriod', amount: number, date: string }>, orderTypeTotals: Array<{ __typename?: 'OrderTypeAmount', amount: number, orderType: OrderType }> | null }, users: { __typename?: 'UsersPaged', pageInfo: { __typename?: 'PageInfo', count: number } }, locations: Array<{ __typename?: 'AccountLocation', address: { __typename?: 'Address', country: string | null } } | null> | null }> } };

export type GetAllAdminsQueryVariables = Exact<{
  input: InputMaybe<AdminSearch>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllAdminsQuery = { __typename?: 'Query', admins: { __typename?: 'AdminsPaged', pageInfo: { __typename?: 'PageInfo', count: number }, rows: Array<{ __typename?: 'Admin', id: string, feedrUserId: number | null, fullName: string, email: string, roles: Array<string>, countryFlags: Array<string> }> } };

export type AdminGetStandingOrdersQueryVariables = Exact<{
  input: StandingOrdersInput;
}>;


export type AdminGetStandingOrdersQuery = { __typename?: 'Query', standingOrders: Array<{ __typename?: 'StandingOrder', _id: string }> };

export type GetAllVendorsQueryVariables = Exact<{
  filters: InputMaybe<VendorListFilters>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<VendorsOrderByInput>;
}>;


export type GetAllVendorsQuery = { __typename?: 'Query', vendorsList: { __typename?: 'VendorsListPaged', pageInfo: { __typename?: 'PageInfo', count: number }, rows: Array<{ __typename?: 'Vendor', companyName: string, currency: Currency | null, id: string, isDraft: boolean | null, isCCActive: boolean | null, isGMActive: boolean | null, logo: string | null, locations: Array<{ __typename?: 'VendorLocation', country: string | null, contacts: Array<{ __typename?: 'VendorContact', fullName: string | null, email: string | null }> }> }> } };

export type GetAllVendorsWithSummaryQueryVariables = Exact<{
  filters: InputMaybe<VendorListFilters>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<VendorsOrderByInput>;
  vendorStatementsInput: ListVendorStatementsInput;
}>;


export type GetAllVendorsWithSummaryQuery = { __typename?: 'Query', vendorsList: { __typename?: 'VendorsListPaged', pageInfo: { __typename?: 'PageInfo', count: number }, rows: Array<{ __typename?: 'Vendor', companyName: string, currency: Currency | null, id: string, isDraft: boolean | null, isCCActive: boolean | null, isGMActive: boolean | null, logo: string | null, vendorStatementsSummary: { __typename?: 'VendorStatementsSummary', totalAmount: number, weeklyTotals: Array<{ __typename?: 'AggregateByPeriod', amount: number, date: string }>, orderTypeTotals: Array<{ __typename?: 'OrderTypeAmount', amount: number, orderType: OrderType }> | null }, locations: Array<{ __typename?: 'VendorLocation', country: string | null, contacts: Array<{ __typename?: 'VendorContact', fullName: string | null, email: string | null }> }> }> } };

export type GetAllUsersQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  input: InputMaybe<UserSearch>;
}>;


export type GetAllUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersPaged', pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean }, rows: Array<{ __typename?: 'User', email: string, firstName: string, lastName: string, phone: string | null, id: string, role: UserRole | null, deletedAt: string | null, flexDeferredCustomerId: string | null, languageSettings: { __typename?: 'UserLanguageSettings', locale: string }, account: { __typename?: 'Account', id: string, name: string, ssoEnabled: boolean, onboardingLink: string, autopilotEnabled: boolean, archivedAt: any | null } | null, accountLocation: { __typename?: 'AccountLocation', label: string | null } | null, autopilotSettings: { __typename?: 'UserAutopilotSettings', enabled: boolean } }> } };

export type MenuDebugGetAccountDataQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type MenuDebugGetAccountDataQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, name: string, locations: Array<{ __typename?: 'AccountLocation', id: string, label: string | null, timezone: string, isCCActive: boolean, ccAvailabilities: { __typename?: 'CCAvailabilitiesPaged', rows: Array<{ __typename?: 'CCAvailability', id: string, weekday: number, meal: string, arrivalTime: any }> } } | null> | null } };

export type MenuDebugVendorSearchQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type MenuDebugVendorSearchQuery = { __typename?: 'Query', vendors: { __typename?: 'VendorsPaged', rows: Array<{ __typename?: 'Vendor', companyName: string, id: string }> } };

export type MenuDebugGetVendorQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
}>;


export type MenuDebugGetVendorQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', id: string, companyName: string } };

export type GetMenuDebugResultsQueryVariables = Exact<{
  input: CcMenuDebugInput;
}>;


export type GetMenuDebugResultsQuery = { __typename?: 'Query', ccMenuDebug: Array<
    | { __typename?: 'CCMenuDebugTestAllocations', description: string, id: string, isSuccessful: boolean, ccSubmenuAllocations: Array<{ __typename?: 'CCSubmenuAllocation', date: any, id: string, submenuId: string, meal: Meal, ccCluster: { __typename?: 'CCCluster', id: string, name: string }, vendorLocation: { __typename?: 'VendorLocation', id: string, label: string | null, vendor: { __typename?: 'Vendor', id: string, companyName: string } } }> }
    | { __typename?: 'CCMenuDebugTestAvailabilities', description: string, id: string, isSuccessful: boolean, ccAvailabilities: Array<{ __typename?: 'CCAvailability', id: string, arrivalTime: any, weekday: number, meal: string, duration: number }> }
    | { __typename?: 'CCMenuDebugTestCCSupplierOrder', description: string, id: string, isSuccessful: boolean, ccSupplierOrders: Array<{ __typename?: 'CCSupplierOrder', id: string, accountId: string, date: any, meal: Meal, arrivalTime: any, arrivalTimeEnd: any, vendor: { __typename?: 'Vendor', id: string, companyName: string }, vendorLocation: { __typename?: 'VendorLocation', id: string, label: string | null }, latestProgressStatus: { __typename?: 'CCSupplierOrderStatus', id: string, timestamp: any, status: string } | null, ccCluster: { __typename?: 'CCCluster', id: string, name: string } }> }
    | { __typename?: 'CCMenuDebugTestClusterAssignment', description: string, id: string, isSuccessful: boolean, ccCluster: { __typename?: 'CCCluster', id: string, name: string } | null }
  > };

export type CcMenuDebugTestCcSupplierOrderFragment = { __typename?: 'CCMenuDebugTestCCSupplierOrder', description: string, id: string, isSuccessful: boolean, ccSupplierOrders: Array<{ __typename?: 'CCSupplierOrder', id: string, accountId: string, date: any, meal: Meal, arrivalTime: any, arrivalTimeEnd: any, vendor: { __typename?: 'Vendor', id: string, companyName: string }, vendorLocation: { __typename?: 'VendorLocation', id: string, label: string | null }, latestProgressStatus: { __typename?: 'CCSupplierOrderStatus', id: string, timestamp: any, status: string } | null, ccCluster: { __typename?: 'CCCluster', id: string, name: string } }> };

export type CcMenuDebugTestClusterAssignmentFragment = { __typename?: 'CCMenuDebugTestClusterAssignment', description: string, id: string, isSuccessful: boolean, ccCluster: { __typename?: 'CCCluster', id: string, name: string } | null };

export type CcMenuDebugTestAvailabilitiesFragment = { __typename?: 'CCMenuDebugTestAvailabilities', description: string, id: string, isSuccessful: boolean, ccAvailabilities: Array<{ __typename?: 'CCAvailability', id: string, arrivalTime: any, weekday: number, meal: string, duration: number }> };

export type CcMenuDebugTestAllocationsFragment = { __typename?: 'CCMenuDebugTestAllocations', description: string, id: string, isSuccessful: boolean, ccSubmenuAllocations: Array<{ __typename?: 'CCSubmenuAllocation', date: any, id: string, submenuId: string, meal: Meal, ccCluster: { __typename?: 'CCCluster', id: string, name: string }, vendorLocation: { __typename?: 'VendorLocation', id: string, label: string | null, vendor: { __typename?: 'Vendor', id: string, companyName: string } } }> };

export type AdminGetVendorFinanceDataQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
}>;


export type AdminGetVendorFinanceDataQuery = { __typename?: 'Query', vatRegions: Array<{ __typename?: 'VatRegion', id: string, legacyId: number, name: string }>, vendor: { __typename?: 'Vendor', id: string, contacts: Array<{ __typename?: 'VendorContact', id: number, fullName: string | null }>, markupSettings: { __typename?: 'VendorMarkupSettings', defaultMarkupPercentage: number }, financeSettings: { __typename?: 'VendorFinanceSettings', id: number, accountName: string | null, billingCity: string | null, billingCountry: string | null, billingPostcode: string | null, reducedCommissionRate: number | null, standardCommissionRate: number | null, billingLine1: string | null, billingLine2: string | null, sortCode: string | null, bsbNumber: string | null, branchCode: string | null, accountNumber: string | null, bankName: string | null, notes: string | null, vatNumber: string | null, isVatRegistered: boolean, paymentMadeDaysAfterStatementEnd: number, businessNumber: string | null, bankCode: string | null, financeContact: { __typename?: 'VendorContact', email: string | null, fullName: string | null, id: number } | null, vatRegion: { __typename?: 'VatRegion', id: string, legacyId: number } } } };

export type AdminGetVendorFlexFinanceDataQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
}>;


export type AdminGetVendorFlexFinanceDataQuery = { __typename?: 'Query', vatRegions: Array<{ __typename?: 'VatRegion', id: string, legacyId: number, name: string }>, vendor: { __typename?: 'Vendor', id: string, currency: Currency | null, contacts: Array<{ __typename?: 'VendorContact', id: number, fullName: string | null, email: string | null }>, markupSettings: { __typename?: 'VendorMarkupSettings', defaultMarkupPercentage: number }, flexFinanceSettings: { __typename?: 'VendorFlexFinanceSettings', id: number, flexDeferredSupplierId: string, reducedCommissionRate: number | null, standardCommissionRate: number | null, chargeCommissionOnDeliveryFees: boolean | null, addressCity: string | null, addressCountry: string | null, addressPostcode: string | null, addressLine1: string | null, addressLine2: string | null, contactFirstName: string | null, contactLastName: string | null, contactEmailAddress: string | null, additionalEmails: Array<string> | null, accountName: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, bsbNumber: string | null, branchCode: string | null, bankCode: string | null, isVatRegistered: boolean, entityName: string | null, entityNumber: string | null, entityRegion: string | null, entityTaxNumber: string | null, notes: string | null, paymentTerms: string | null, autoInvoice: boolean | null, invoiceLocationsSeparately: boolean | null, financeContact: { __typename?: 'VendorContact', id: number, email: string | null, fullName: string | null } | null, vatRegion: { __typename?: 'VatRegion', id: string, legacyId: number } } | null } };

export type AdminUpdateVendorFinanceWithMarkupSettingsMutationVariables = Exact<{
  vendorId: Scalars['ID']['input'];
  financeSettingsInput: UpdateVendorFinanceSettingsInput;
  markupSettingsInput: UpdateVendorMarkupSettingsInput;
}>;


export type AdminUpdateVendorFinanceWithMarkupSettingsMutation = { __typename?: 'Mutation', updateVendor: { __typename?: 'Vendor', id: string, financeSettings: { __typename?: 'VendorFinanceSettings', id: number } } };

export type AdminUpdateVendorFlexFinanceWithMarkupSettingsMutationVariables = Exact<{
  vendorId: Scalars['ID']['input'];
  financeSettingsInput: UpdateVendorFlexFinanceSettingsInput;
  markupSettingsInput: UpdateVendorMarkupSettingsInput;
  currency: InputMaybe<Currency>;
}>;


export type AdminUpdateVendorFlexFinanceWithMarkupSettingsMutation = { __typename?: 'Mutation', updateVendor: { __typename?: 'Vendor', id: string, financeSettings: { __typename?: 'VendorFinanceSettings', id: number } } };

export type GetBillingFieldsQueryVariables = Exact<{
  input: BillingFieldsInput;
}>;


export type GetBillingFieldsQuery = { __typename?: 'Query', billingFields: Array<BillingField | null> };

export type GetVendorFlexInvoiceCsvQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  invoiceType: FlexInvoiceType;
}>;


export type GetVendorFlexInvoiceCsvQuery = { __typename?: 'Query', vendorFlexInvoiceCSV: string };

export type VendorFlexInvoicesQueryVariables = Exact<{
  input: VendorFlexInvoicesInput;
}>;


export type VendorFlexInvoicesQuery = { __typename?: 'Query', vendorFlexInvoices: { __typename?: 'VendorFlexInvoicesPaged', items: Array<{ __typename?: 'VendorFlexInvoice', id: string, accountName: string, number: string, total: string, createdAt: any, dueDate: any, status: string } | null>, pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean, limit: number, offset: number } } };

export type VendorFlexInvoiceAllTypesQueryVariables = Exact<{
  input: InputMaybe<VendorFlexInvoicesInput>;
}>;


export type VendorFlexInvoiceAllTypesQuery = { __typename?: 'Query', vendorFlexInvoiceAllTypes: { __typename?: 'VendorFlexInvoiceAllTypesPaged', items: Array<{ __typename?: 'VendorFlexInvoiceAllTypes', id: string, invoiceType: FlexInvoiceType | null, number: string, createdAt: any, accountName: string, entityName: string, total: string, dueDate: any, status: string, csv: string | null, timezone: string | null, location: string | null, vendorId: string | null, accountBusinessNumber: string | null, accountTaxNumber: string | null, accountContact: string | null, accountAddress: string | null, accountBankDetails: string | null, assets: Array<{ __typename?: 'FlexInvoiceAsset', type: string, link: string }> | null } | null>, pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean, limit: number, offset: number } } };

export type GetOrdersForVendorFlexInvoiceQueryVariables = Exact<{
  input: InputMaybe<VendorInvoiceOrderInput>;
}>;


export type GetOrdersForVendorFlexInvoiceQuery = { __typename?: 'Query', vendorInvoiceOrders: { __typename?: 'VendorInvoiceOrdersPaged', items: Array<{ __typename?: 'VendorInvoiceOrder', id: string, number: string } | null> } };

export type RemoveOrdersFromVendorFlexInvoiceMutationVariables = Exact<{
  vendorFlexInvoiceId: Scalars['ID']['input'];
  input: RemoveOrdersFromVendorFlexInvoiceInput;
}>;


export type RemoveOrdersFromVendorFlexInvoiceMutation = { __typename?: 'Mutation', removeOrdersFromVendorFlexInvoice: boolean };

export type SendVendorFlexInvoiceByEmailMutationVariables = Exact<{
  vendorFlexInvoiceId: Scalars['ID']['input'];
  emailAddresses: Array<Scalars['String']['input']> | Scalars['String']['input'];
  invoiceType: InputMaybe<FlexInvoiceType>;
}>;


export type SendVendorFlexInvoiceByEmailMutation = { __typename?: 'Mutation', sendVendorFlexInvoiceByEmail: boolean };

export type UpdateVendorFlexInvoiceDetailsMutationVariables = Exact<{
  vendorFlexInvoiceId: Scalars['ID']['input'];
  updates: UpdateVendorFlexInvoiceDetailsInput;
}>;


export type UpdateVendorFlexInvoiceDetailsMutation = { __typename?: 'Mutation', updateVendorFlexInvoiceDetails: boolean };

export type GetVendorDetailsQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
}>;


export type GetVendorDetailsQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', id: string, companyName: string, currency: Currency | null, fullName: string | null, isDraft: boolean | null, sourcing: string | null, logo: string | null, locations: Array<{ __typename?: 'VendorLocation', country: string | null }>, flexFinanceSettings: { __typename?: 'VendorFlexFinanceSettings', flexDeferredSupplierId: string } | null, contacts: Array<{ __typename?: 'VendorContact', id: number }> } };

export type GetVendorNameQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
}>;


export type GetVendorNameQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', id: string, companyName: string } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, fullName: string, intercomUserHash: string, isAdmin: boolean, isUser: boolean, isVendor: boolean, teamId: number | null, legacyAdminId: number | null, role: UserRole | null, invoiceApproved: boolean, marketingOptIn: boolean, hasPreviousGmOrders: boolean, account: { __typename?: 'Account', id: string, name: string, managerName: string | null, ccTeams: Array<{ __typename?: 'CCTeam', code: string | null, name: string, id: number } | null> | null, locations: Array<{ __typename?: 'AccountLocation', id: string, isCCActive: boolean, label: string | null, address: { __typename?: 'Address', flatOrBuilding: string | null, floorOrBuildingName: string | null, street: string | null, city: string | null, postcode: string | null, country: string | null } } | null> | null } | null, accountLocation: { __typename?: 'AccountLocation', id: string } | null, languageSettings: { __typename?: 'UserLanguageSettings', locale: string }, vendor: { __typename?: 'Vendor', companyName: string, id: string } | null } };

export type GetSsoSettingsByCompanyCodeQueryVariables = Exact<{
  companyCode: Scalars['String']['input'];
  tenantId: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSsoSettingsByCompanyCodeQuery = { __typename?: 'Query', ssoSettingsByCompanyCode: { __typename?: 'SsoSettings', enabled: boolean, code: string, id: string } | null };

export type HomeRealmDiscoveryQueryVariables = Exact<{
  domain: Scalars['String']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  tenantId: InputMaybe<Scalars['String']['input']>;
}>;


export type HomeRealmDiscoveryQuery = { __typename?: 'Query', allSsoSettingsByDomain: Array<{ __typename?: 'SsoSettings', name: string, enabled: boolean, code: string, codeOverride: string | null }> | null };

export type UpdateMeMutationVariables = Exact<{
  userPayload: UpdateUserInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, privacyAccepted: string | null, teamId: number | null, phone: string | null, accountLocation: { __typename?: 'AccountLocation', id: string, label: string | null } | null, contactPreferences: { __typename?: 'UserContactPreferences', notificationPreference: string, remindersDeliveries: boolean, remindersSubsidised: boolean, remindersUnsubsidised: boolean, remindersWeekly: boolean, isAccountPrimaryContact: boolean }, allergens: { __typename?: 'UserAllergens', celery: boolean, cereals: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, lupin: boolean, milk: boolean, molluscs: boolean, mustard: boolean, nuts: boolean, peanuts: boolean, sesame: boolean, soybeans: boolean, sulphur: boolean }, dietaryPreferences: { __typename?: 'UserDietaryPreferences', vegan: boolean, vegetarian: boolean, halal: boolean, kosher: boolean, noRefinedSugar: boolean } } };

export type GetAdminCanteenTeamsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetAdminCanteenTeamsQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, isCCActive: boolean, onboardingLink: string, signUpCode: string | null, locationsPaged: { __typename?: 'AccountLocationsPaged', rows: Array<{ __typename?: 'AccountLocation', id: string, label: string | null, ccAvailabilities: { __typename?: 'CCAvailabilitiesPaged', rows: Array<{ __typename?: 'CCAvailability', weekday: number, meal: string }> } }> }, ccTeams: Array<{ __typename?: 'CCTeam', id: number, code: string | null, name: string, users: Array<{ __typename?: 'User', id: string, fullName: string, email: string }> | null } | null> | null } };

type UserBasketSettingsLocation_AccountLocation_Fragment = { __typename: 'AccountLocation', id: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } };

type UserBasketSettingsLocation_Address_Fragment = { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null };

type UserBasketSettingsLocation_NewAccountLocation_Fragment = { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } };

export type UserBasketSettingsLocationFragment =
  | UserBasketSettingsLocation_AccountLocation_Fragment
  | UserBasketSettingsLocation_Address_Fragment
  | UserBasketSettingsLocation_NewAccountLocation_Fragment
;

export type AuthAccountFragment = { __typename?: 'Account', id: string, name: string, invoiceApproved: boolean | null, signUpCode: string | null, invoiceAccounts: Array<{ __typename?: 'InvoiceAccount', id: string, label: string | null, line1: string, line2: string | null, city: string, postcode: string, country: string | null, isDefault: boolean, autoPay: boolean | null, vatRegionId: number }>, locations: Array<{ __typename: 'AccountLocation', id: string, isGmActive: boolean, isBillingAddress: boolean | null, label: string | null, address: { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, street: string | null, postcode: string | null, city: string | null, country: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } } | null> | null };

export type AuthGmQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthGmQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, role: UserRole | null, invoiceApproved: boolean, privacyAccepted: string | null, accountLocation: { __typename?: 'AccountLocation', id: string, isGmActive: boolean, address: { __typename?: 'Address', country: string | null } } | null, account: { __typename?: 'Account', id: string, name: string, invoiceApproved: boolean | null, signUpCode: string | null, invoiceAccounts: Array<{ __typename?: 'InvoiceAccount', id: string, label: string | null, line1: string, line2: string | null, city: string, postcode: string, country: string | null, isDefault: boolean, autoPay: boolean | null, vatRegionId: number }>, locations: Array<{ __typename: 'AccountLocation', id: string, isGmActive: boolean, isBillingAddress: boolean | null, label: string | null, address: { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, street: string | null, postcode: string | null, city: string | null, country: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } } | null> | null } | null }, ghosterUser: { __typename?: 'User', id: string } | null };

export type UpdateMeGmMutationVariables = Exact<{
  userPayload: UpdateUserInput;
}>;


export type UpdateMeGmMutation = { __typename?: 'Mutation', updateMe: { __typename?: 'User', id: string, privacyAccepted: string | null } };

export type CreateOrUpdateMyFavouriteMutationVariables = Exact<{
  input: CreateOrUpdateMyFavouriteInput;
}>;


export type CreateOrUpdateMyFavouriteMutation = { __typename?: 'Mutation', createOrUpdateMyFavourite: boolean };

export type CheckoutBasketFragment = { __typename?: 'GmBasket', id: string, friendlyId: string, isCateringTeamOrder: boolean, userId: number | null, hasEnterpriseDiscount: boolean, itemCount: number, allergens: Array<string> | null, user: { __typename?: 'User', fullName: string, id: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, vendor: { __typename?: 'Vendor', id: string, companyName: string, isPantry: boolean | null, currency: Currency | null, permalink: string | null, locations: Array<{ __typename?: 'VendorLocation', id: string, country: string | null }>, financeSettings: { __typename?: 'VendorFinanceSettings', billingCountry: string | null } }, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', isGuestBasket: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, deliveryDate: string, deliveryTimeSlot: string, deliveryInstructions: string | null, headCount: number, meetingRoom: string | null, feedrAdminApproved: boolean | null, feedrCreated: boolean | null, invoiceAccountId: number | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', id: number, name: string, locationId: number | null, location: { __typename?: 'VendorLocation', country: string | null } | null }, location:
      | { __typename: 'AccountLocation', id: string, label: string | null, instructions: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
      | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
      | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
     | null, referenceFieldValues: Array<{ __typename?: 'GmReferenceFieldValue', orderReferenceFieldId: number, referenceFieldId: number, label: string, description: string | null, fieldType: ReferenceFieldType, value: string | null, isRequired: boolean, version: number, error: string | null, options: Array<{ __typename?: 'GmReferenceFieldOption', id: number, option: string, orderPriority: number, orderReferenceFieldId: number }> | null }> | null, billingAddress:
      | { __typename: 'AccountLocation', id: string, label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
      | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
      | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
     | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number, taxRateTotalBreakdown: Array<{ __typename?: 'BasketTaxRateTotal', rate: number, taxValue: number, itemValue: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } };

export type GetCheckoutBasketQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCheckoutBasketQuery = { __typename?: 'Query', basket: { __typename?: 'GmBasket', id: string, friendlyId: string, isCateringTeamOrder: boolean, userId: number | null, hasEnterpriseDiscount: boolean, itemCount: number, allergens: Array<string> | null, user: { __typename?: 'User', fullName: string, id: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, vendor: { __typename?: 'Vendor', id: string, companyName: string, isPantry: boolean | null, currency: Currency | null, permalink: string | null, locations: Array<{ __typename?: 'VendorLocation', id: string, country: string | null }>, financeSettings: { __typename?: 'VendorFinanceSettings', billingCountry: string | null } }, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', isGuestBasket: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, deliveryDate: string, deliveryTimeSlot: string, deliveryInstructions: string | null, headCount: number, meetingRoom: string | null, feedrAdminApproved: boolean | null, feedrCreated: boolean | null, invoiceAccountId: number | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', id: number, name: string, locationId: number | null, location: { __typename?: 'VendorLocation', country: string | null } | null }, location:
        | { __typename: 'AccountLocation', id: string, label: string | null, instructions: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null, referenceFieldValues: Array<{ __typename?: 'GmReferenceFieldValue', orderReferenceFieldId: number, referenceFieldId: number, label: string, description: string | null, fieldType: ReferenceFieldType, value: string | null, isRequired: boolean, version: number, error: string | null, options: Array<{ __typename?: 'GmReferenceFieldOption', id: number, option: string, orderPriority: number, orderReferenceFieldId: number }> | null }> | null, billingAddress:
        | { __typename: 'AccountLocation', id: string, label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number, taxRateTotalBreakdown: Array<{ __typename?: 'BasketTaxRateTotal', rate: number, taxValue: number, itemValue: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } | null };

export type GetTenantGuestInvoiceAccountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTenantGuestInvoiceAccountsQuery = { __typename?: 'Query', account: { __typename?: 'Account', invoiceApproved: boolean | null, invoiceAccounts: Array<{ __typename?: 'InvoiceAccount', id: string, additionalEmails: Array<string> | null, city: string, country: string | null, email: string | null, firstName: string | null, isDefault: boolean, label: string | null, lastName: string | null, line1: string, line2: string | null, phone: string | null, postcode: string, vat: string | null, vatRegionId: number, accountId: string, autoInvoice: boolean | null, invoicePerContact: boolean | null, invoicePerReferenceField: boolean | null, invoicePerType: boolean | null, invoiceByPantryOrder: boolean | null, invoiceByStandingOrder: boolean | null, invoiceConsolidationFrequency: InvoiceConsolidationFrequency | null, invoiceConsolidationType: InvoiceConsolidationType | null, invoicePerOrderRecipientType: InvoicePerOrderRecipientType | null, referenceFieldLabelsForInvoice: Array<string> | null, autoPay: boolean | null }> } };

export type UpdateCheckoutBasketMutationVariables = Exact<{
  basketId: Scalars['ID']['input'];
  basketPayload: UpdateGmBasketInput;
}>;


export type UpdateCheckoutBasketMutation = { __typename?: 'Mutation', basket: { __typename?: 'GmBasket', id: string, friendlyId: string, isCateringTeamOrder: boolean, userId: number | null, hasEnterpriseDiscount: boolean, itemCount: number, allergens: Array<string> | null, user: { __typename?: 'User', fullName: string, id: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, vendor: { __typename?: 'Vendor', id: string, companyName: string, isPantry: boolean | null, currency: Currency | null, permalink: string | null, locations: Array<{ __typename?: 'VendorLocation', id: string, country: string | null }>, financeSettings: { __typename?: 'VendorFinanceSettings', billingCountry: string | null } }, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', isGuestBasket: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, deliveryDate: string, deliveryTimeSlot: string, deliveryInstructions: string | null, headCount: number, meetingRoom: string | null, feedrAdminApproved: boolean | null, feedrCreated: boolean | null, invoiceAccountId: number | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', id: number, name: string, locationId: number | null, location: { __typename?: 'VendorLocation', country: string | null } | null }, location:
        | { __typename: 'AccountLocation', id: string, label: string | null, instructions: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null, referenceFieldValues: Array<{ __typename?: 'GmReferenceFieldValue', orderReferenceFieldId: number, referenceFieldId: number, label: string, description: string | null, fieldType: ReferenceFieldType, value: string | null, isRequired: boolean, version: number, error: string | null, options: Array<{ __typename?: 'GmReferenceFieldOption', id: number, option: string, orderPriority: number, orderReferenceFieldId: number }> | null }> | null, billingAddress:
        | { __typename: 'AccountLocation', id: string, label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number, taxRateTotalBreakdown: Array<{ __typename?: 'BasketTaxRateTotal', rate: number, taxValue: number, itemValue: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } };

export type CheckoutMutationVariables = Exact<{
  basketId: Scalars['ID']['input'];
  paymentMethod: PaymentMethod;
  proposedTotalIncTax: InputMaybe<Scalars['Int']['input']>;
}>;


export type CheckoutMutation = { __typename?: 'Mutation', checkout:
    | { __typename?: 'GmCheckoutErrors', errors: Array<{ __typename?: 'GmValidationError', message: string, code: string }> }
    | { __typename?: 'PayByCardResponse', authToken: string }
    | { __typename?: 'PayByInvoiceResponse', orderId: number }
    | { __typename?: 'PayByTransferResponse', orderId: number }
   };

export type AssignBasketToGuestMutationVariables = Exact<{
  basketId: Scalars['ID']['input'];
  input: AssignBasketToGuestInput;
}>;


export type AssignBasketToGuestMutation = { __typename?: 'Mutation', assignBasketToGuest: { __typename?: 'GmBasket', id: string, friendlyId: string, isCateringTeamOrder: boolean, userId: number | null, hasEnterpriseDiscount: boolean, itemCount: number, allergens: Array<string> | null, user: { __typename?: 'User', fullName: string, id: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, vendor: { __typename?: 'Vendor', id: string, companyName: string, isPantry: boolean | null, currency: Currency | null, permalink: string | null, locations: Array<{ __typename?: 'VendorLocation', id: string, country: string | null }>, financeSettings: { __typename?: 'VendorFinanceSettings', billingCountry: string | null } }, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', isGuestBasket: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, deliveryDate: string, deliveryTimeSlot: string, deliveryInstructions: string | null, headCount: number, meetingRoom: string | null, feedrAdminApproved: boolean | null, feedrCreated: boolean | null, invoiceAccountId: number | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', id: number, name: string, locationId: number | null, location: { __typename?: 'VendorLocation', country: string | null } | null }, location:
        | { __typename: 'AccountLocation', id: string, label: string | null, instructions: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null, referenceFieldValues: Array<{ __typename?: 'GmReferenceFieldValue', orderReferenceFieldId: number, referenceFieldId: number, label: string, description: string | null, fieldType: ReferenceFieldType, value: string | null, isRequired: boolean, version: number, error: string | null, options: Array<{ __typename?: 'GmReferenceFieldOption', id: number, option: string, orderPriority: number, orderReferenceFieldId: number }> | null }> | null, billingAddress:
        | { __typename: 'AccountLocation', id: string, label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number, taxRateTotalBreakdown: Array<{ __typename?: 'BasketTaxRateTotal', rate: number, taxValue: number, itemValue: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } };

export type LookupAddressQueryVariables = Exact<{
  query: Scalars['String']['input'];
  countries: InputMaybe<Array<CountryCode> | CountryCode>;
  useGoogle: InputMaybe<Scalars['Boolean']['input']>;
  allowAnyCity?: InputMaybe<Scalars['Boolean']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
}>;


export type LookupAddressQuery = { __typename?: 'Query', lookupAddress: { __typename?: 'LookupAddressResponse', locations: Array<{ __typename?: 'AddressLocation', relevance: number, address: { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, street: string | null, postcode: string | null, city: string | null, country: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }, context: { __typename?: 'GeocodeContext', region: string | null } }> } | null };

export type MenuVendorLocationDeliveryRegionFragment = { __typename?: 'DeliveryRegion', id: string, minOrderValue: number | null, minOrderValueExTax: number | null, orderPosition: number, serviceType: ServiceType, deliveryFee: { __typename?: 'DeliveryFee', total: number, taxRate: number } | null };

export type MenuVendorLocationWithDeliveryRegionsFragment = { __typename?: 'VendorLocation', id: string, timezone: string, country: string | null, city: string | null, deliveryRegions: Array<{ __typename?: 'DeliveryRegion', id: string, minOrderValue: number | null, minOrderValueExTax: number | null, orderPosition: number, serviceType: ServiceType, deliveryFee: { __typename?: 'DeliveryFee', total: number, taxRate: number } | null }>, details: { __typename?: 'VendorLocationDetails', minOrderValue: number | null, minOrderValueExTax: number | null, gmMaxDistanceMinutes: number | null, gmMinNoticePeriod: number | null, gmMaxOrder: number | null, gmLargeOrderThreshold: number | null, gmLargeOrderNoticePeriod: number | null, isGMActive: boolean, gmAllowCountryWideDelivery: boolean | null }, closingDates: { __typename?: 'VendorLocationClosingDate', closedWeekdays: Array<number>, closedDates: Array<any> }, openingTimes: Array<{ __typename?: 'VendorLocationOpeningTime', startTime: string | null, endTime: string | null, weekdays: Array<number> }> };

export type MenuVendorLocationFragment = { __typename?: 'VendorLocation', id: string, timezone: string, country: string | null, city: string | null, details: { __typename?: 'VendorLocationDetails', minOrderValue: number | null, minOrderValueExTax: number | null, gmMaxDistanceMinutes: number | null, gmMinNoticePeriod: number | null, gmMaxOrder: number | null, gmLargeOrderThreshold: number | null, gmLargeOrderNoticePeriod: number | null, isGMActive: boolean, gmAllowCountryWideDelivery: boolean | null }, closingDates: { __typename?: 'VendorLocationClosingDate', closedWeekdays: Array<number>, closedDates: Array<any> }, openingTimes: Array<{ __typename?: 'VendorLocationOpeningTime', startTime: string | null, endTime: string | null, weekdays: Array<number> }> };

export type MenuVendorCategoryFragment = { __typename?: 'VendorCategory', id: string, name: string | null, position: number | null };

export type MenuVendorFragment = { __typename?: 'Vendor', id: string, isDraft: boolean | null, isGMActive: boolean | null, permalink: string | null, companyName: string, metaTitle: string | null, metaDescription: string | null, logo: string | null, keywords: string | null, descriptionFull: string | null, descriptionShort: string | null, currency: Currency | null, sourcing: string | null, quote: string | null, rating: number | null, totalRatings: number | null, gmRating: number | null, gmTotalRatings: number | null, priceLevel: number | null, isMyFavourite: boolean | null, isPantry: boolean | null, gmAvailability: { __typename?: 'GmAvailability', id: string } | null, images: Array<{ __typename?: 'VendorImage', secureUrl: string, position: number | null } | null> | null, locations: Array<{ __typename?: 'VendorLocation', id: string, timezone: string, country: string | null, city: string | null, deliveryRegions: Array<{ __typename?: 'DeliveryRegion', id: string, minOrderValue: number | null, minOrderValueExTax: number | null, orderPosition: number, serviceType: ServiceType, deliveryFee: { __typename?: 'DeliveryFee', total: number, taxRate: number } | null }>, details: { __typename?: 'VendorLocationDetails', minOrderValue: number | null, minOrderValueExTax: number | null, gmMaxDistanceMinutes: number | null, gmMinNoticePeriod: number | null, gmMaxOrder: number | null, gmLargeOrderThreshold: number | null, gmLargeOrderNoticePeriod: number | null, isGMActive: boolean, gmAllowCountryWideDelivery: boolean | null }, closingDates: { __typename?: 'VendorLocationClosingDate', closedWeekdays: Array<number>, closedDates: Array<any> }, openingTimes: Array<{ __typename?: 'VendorLocationOpeningTime', startTime: string | null, endTime: string | null, weekdays: Array<number> }> }>, categories: Array<{ __typename?: 'VendorCategory', id: string, name: string | null, position: number | null } | null>, popularItems: Array<{ __typename?: 'PopularItem', itemReference: string, rank: number, orderCount: number, accountCount: number | null }>, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, externalUrlData: { __typename?: 'VendorExternalUrlData', data: Array<{ __typename?: 'VendorExternalUrl', copy: string, id: string, url: string, tags: { __typename?: 'VendorExternalUrlTags', data: Array<string> } } | null> } };

export type MenuCustomerPriceItemFragment = { __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number };

export type MenuItemVariationFragment = { __typename?: 'MenuItemVariation', categoryId: number | null, categoryIdArray: Array<number> | null, servings: number | null, popularity: number, packaging: GmItemPackaging | null, minQty: number | null, price: number | null, priceExTax: number | null, taxValue: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, privateAccessAccountIdArray: Array<number> | null, taxValueCustomerFacing: number, isCombo: boolean | null, isPricePerHead: boolean | null, position: number | null, isPrivate: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null };

export type MenuOptionMenuItemFragment = { __typename?: 'MenuItem', _id: string, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, name: string | null, shortDescription: string | null, description: string | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, subAllergens: { __typename?: 'SubAllergens', cereals: Array<CerealSubAllergen>, nuts: Array<NutSubAllergen> } };

export type MenuOptionItemFragment = { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, item: { __typename?: 'MenuItem', _id: string, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, name: string | null, shortDescription: string | null, description: string | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, subAllergens: { __typename?: 'SubAllergens', cereals: Array<CerealSubAllergen>, nuts: Array<NutSubAllergen> } } | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null };

export type MenuItemOptionFragment = { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null, name: string | null, position: number | null, minQty: number | null, maxQty: number | null, qtyPerPerson: number | null, categoryType: string | null, items: Array<{ __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, item: { __typename?: 'MenuItem', _id: string, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, name: string | null, shortDescription: string | null, description: string | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, subAllergens: { __typename?: 'SubAllergens', cereals: Array<CerealSubAllergen>, nuts: Array<NutSubAllergen> } } | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null> | null };

export type MenuItemBaseFragment = { __typename?: 'MenuItem', _id: string, isActive: boolean | null, name: string | null, image: string | null, shortDescription: string | null, description: string | null, ingredients: string | null, price: number | null, priceExTax: number | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, taxRate: number, updatedAt: any, isHot: boolean | null, activeFrom: any | null, activeTo: any | null, macros_carbs: number | null, macros_fat: number | null, macros_protein: number | null, macros_kcal: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, macros_fibre: number | null, subAllergens: { __typename?: 'SubAllergens', nuts: Array<NutSubAllergen>, cereals: Array<CerealSubAllergen> }, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, categoryId: number | null, categoryIdArray: Array<number> | null, servings: number | null, popularity: number, packaging: GmItemPackaging | null, minQty: number | null, price: number | null, priceExTax: number | null, taxValue: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, privateAccessAccountIdArray: Array<number> | null, taxValueCustomerFacing: number, isCombo: boolean | null, isPricePerHead: boolean | null, position: number | null, isPrivate: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null };

export type MenuItemFragment = { __typename?: 'MenuItem', _id: string, isActive: boolean | null, name: string | null, image: string | null, shortDescription: string | null, description: string | null, ingredients: string | null, price: number | null, priceExTax: number | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, taxRate: number, updatedAt: any, isHot: boolean | null, activeFrom: any | null, activeTo: any | null, macros_carbs: number | null, macros_fat: number | null, macros_protein: number | null, macros_kcal: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, macros_fibre: number | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null, name: string | null, position: number | null, minQty: number | null, maxQty: number | null, qtyPerPerson: number | null, categoryType: string | null, items: Array<{ __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, item: { __typename?: 'MenuItem', _id: string, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, name: string | null, shortDescription: string | null, description: string | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, subAllergens: { __typename?: 'SubAllergens', cereals: Array<CerealSubAllergen>, nuts: Array<NutSubAllergen> } } | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null> | null } | null> | null, subAllergens: { __typename?: 'SubAllergens', nuts: Array<NutSubAllergen>, cereals: Array<CerealSubAllergen> }, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, categoryId: number | null, categoryIdArray: Array<number> | null, servings: number | null, popularity: number, packaging: GmItemPackaging | null, minQty: number | null, price: number | null, priceExTax: number | null, taxValue: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, privateAccessAccountIdArray: Array<number> | null, taxValueCustomerFacing: number, isCombo: boolean | null, isPricePerHead: boolean | null, position: number | null, isPrivate: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null };

export type MenuItemListItemFragment = { __typename?: 'MenuItem', _id: string, isActive: boolean | null, name: string | null, image: string | null, shortDescription: string | null, description: string | null, ingredients: string | null, price: number | null, priceExTax: number | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, taxRate: number, updatedAt: any, isHot: boolean | null, activeFrom: any | null, activeTo: any | null, macros_carbs: number | null, macros_fat: number | null, macros_protein: number | null, macros_kcal: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, macros_fibre: number | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null, name: string | null, position: number | null, minQty: number | null, maxQty: number | null, qtyPerPerson: number | null, categoryType: string | null } | null> | null, subAllergens: { __typename?: 'SubAllergens', nuts: Array<NutSubAllergen>, cereals: Array<CerealSubAllergen> }, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, categoryId: number | null, categoryIdArray: Array<number> | null, servings: number | null, popularity: number, packaging: GmItemPackaging | null, minQty: number | null, price: number | null, priceExTax: number | null, taxValue: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, privateAccessAccountIdArray: Array<number> | null, taxValueCustomerFacing: number, isCombo: boolean | null, isPricePerHead: boolean | null, position: number | null, isPrivate: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null };

export type MenuItemOptionListNoItemsFragment = { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null, name: string | null, position: number | null, minQty: number | null, maxQty: number | null, qtyPerPerson: number | null, categoryType: string | null };

export type MenuAvailabilityWithItemsPagedFragment = { __typename?: 'GmAvailability', id: string, itemsPagedv2: { __typename?: 'GmMenuItems', cacheKeys: Array<string> | null, items: Array<{ __typename?: 'MenuItem', _id: string, isActive: boolean | null, name: string | null, image: string | null, shortDescription: string | null, description: string | null, ingredients: string | null, price: number | null, priceExTax: number | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, taxRate: number, updatedAt: any, isHot: boolean | null, activeFrom: any | null, activeTo: any | null, macros_carbs: number | null, macros_fat: number | null, macros_protein: number | null, macros_kcal: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, macros_fibre: number | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null, name: string | null, position: number | null, minQty: number | null, maxQty: number | null, qtyPerPerson: number | null, categoryType: string | null, items: Array<{ __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, item: { __typename?: 'MenuItem', _id: string, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, name: string | null, shortDescription: string | null, description: string | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, subAllergens: { __typename?: 'SubAllergens', cereals: Array<CerealSubAllergen>, nuts: Array<NutSubAllergen> } } | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null> | null } | null> | null, subAllergens: { __typename?: 'SubAllergens', nuts: Array<NutSubAllergen>, cereals: Array<CerealSubAllergen> }, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, categoryId: number | null, categoryIdArray: Array<number> | null, servings: number | null, popularity: number, packaging: GmItemPackaging | null, minQty: number | null, price: number | null, priceExTax: number | null, taxValue: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, privateAccessAccountIdArray: Array<number> | null, taxValueCustomerFacing: number, isCombo: boolean | null, isPricePerHead: boolean | null, position: number | null, isPrivate: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null }>, pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean }, stats: { __typename?: 'GmMenuItemStats', allergens: Array<{ __typename?: 'GmMenuItemStat', id: string, label: string, value: number, name: string }>, dietaries: Array<{ __typename?: 'GmMenuItemStat', id: string, label: string, value: number, name: string }>, categories: Array<{ __typename?: 'GmMenuItemStat', id: string, label: string, value: number, name: string }> } }, myLastBasket: { __typename?: 'GmBasket', id: string } | null, myBaskets: { __typename?: 'GmBasketPaged', rows: Array<{ __typename?: 'GmBasket', id: string, friendlyId: string }> } };

export type MenuAvailabilityWithItemsPagedListFragment = { __typename?: 'GmAvailability', id: string, itemsPagedv2: { __typename?: 'GmMenuItems', cacheKeys: Array<string> | null, items: Array<{ __typename?: 'MenuItem', _id: string, isActive: boolean | null, name: string | null, image: string | null, shortDescription: string | null, description: string | null, ingredients: string | null, price: number | null, priceExTax: number | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, taxRate: number, updatedAt: any, isHot: boolean | null, activeFrom: any | null, activeTo: any | null, macros_carbs: number | null, macros_fat: number | null, macros_protein: number | null, macros_kcal: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, macros_fibre: number | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null, name: string | null, position: number | null, minQty: number | null, maxQty: number | null, qtyPerPerson: number | null, categoryType: string | null } | null> | null, subAllergens: { __typename?: 'SubAllergens', nuts: Array<NutSubAllergen>, cereals: Array<CerealSubAllergen> }, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, categoryId: number | null, categoryIdArray: Array<number> | null, servings: number | null, popularity: number, packaging: GmItemPackaging | null, minQty: number | null, price: number | null, priceExTax: number | null, taxValue: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, privateAccessAccountIdArray: Array<number> | null, taxValueCustomerFacing: number, isCombo: boolean | null, isPricePerHead: boolean | null, position: number | null, isPrivate: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null }>, pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean }, stats: { __typename?: 'GmMenuItemStats', allergens: Array<{ __typename?: 'GmMenuItemStat', id: string, label: string, value: number, name: string }>, dietaries: Array<{ __typename?: 'GmMenuItemStat', id: string, label: string, value: number, name: string }>, categories: Array<{ __typename?: 'GmMenuItemStat', id: string, label: string, value: number, name: string }> } }, myLastBasket: { __typename?: 'GmBasket', id: string } | null, myBaskets: { __typename?: 'GmBasketPaged', rows: Array<{ __typename?: 'GmBasket', id: string, friendlyId: string }> } };

export type MenuAvailabilityFragment = { __typename?: 'GmAvailability', id: string, items: Array<{ __typename?: 'MenuItem', _id: string, isActive: boolean | null, name: string | null, image: string | null, shortDescription: string | null, description: string | null, ingredients: string | null, price: number | null, priceExTax: number | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, taxRate: number, updatedAt: any, isHot: boolean | null, activeFrom: any | null, activeTo: any | null, macros_carbs: number | null, macros_fat: number | null, macros_protein: number | null, macros_kcal: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, macros_fibre: number | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null, name: string | null, position: number | null, minQty: number | null, maxQty: number | null, qtyPerPerson: number | null, categoryType: string | null, items: Array<{ __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, item: { __typename?: 'MenuItem', _id: string, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, name: string | null, shortDescription: string | null, description: string | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, subAllergens: { __typename?: 'SubAllergens', cereals: Array<CerealSubAllergen>, nuts: Array<NutSubAllergen> } } | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null> | null } | null> | null, subAllergens: { __typename?: 'SubAllergens', nuts: Array<NutSubAllergen>, cereals: Array<CerealSubAllergen> }, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, categoryId: number | null, categoryIdArray: Array<number> | null, servings: number | null, popularity: number, packaging: GmItemPackaging | null, minQty: number | null, price: number | null, priceExTax: number | null, taxValue: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, privateAccessAccountIdArray: Array<number> | null, taxValueCustomerFacing: number, isCombo: boolean | null, isPricePerHead: boolean | null, position: number | null, isPrivate: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null>, myLastBasket: { __typename?: 'GmBasket', id: string } | null, myBaskets: { __typename?: 'GmBasketPaged', rows: Array<{ __typename?: 'GmBasket', id: string, friendlyId: string }> } };

export type GetVendorQueryVariables = Exact<{
  permalink: Scalars['String']['input'];
  maxRating: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
}>;


export type GetVendorQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', id: string, isDraft: boolean | null, isGMActive: boolean | null, permalink: string | null, companyName: string, metaTitle: string | null, metaDescription: string | null, logo: string | null, keywords: string | null, descriptionFull: string | null, descriptionShort: string | null, currency: Currency | null, sourcing: string | null, quote: string | null, rating: number | null, totalRatings: number | null, gmRating: number | null, gmTotalRatings: number | null, priceLevel: number | null, isMyFavourite: boolean | null, isPantry: boolean | null, ratingScaled: number | null, gmAvailability: { __typename?: 'GmAvailability', id: string } | null, images: Array<{ __typename?: 'VendorImage', secureUrl: string, position: number | null } | null> | null, locations: Array<{ __typename?: 'VendorLocation', id: string, timezone: string, country: string | null, city: string | null, deliveryRegions: Array<{ __typename?: 'DeliveryRegion', id: string, minOrderValue: number | null, minOrderValueExTax: number | null, orderPosition: number, serviceType: ServiceType, deliveryFee: { __typename?: 'DeliveryFee', total: number, taxRate: number } | null }>, details: { __typename?: 'VendorLocationDetails', minOrderValue: number | null, minOrderValueExTax: number | null, gmMaxDistanceMinutes: number | null, gmMinNoticePeriod: number | null, gmMaxOrder: number | null, gmLargeOrderThreshold: number | null, gmLargeOrderNoticePeriod: number | null, isGMActive: boolean, gmAllowCountryWideDelivery: boolean | null }, closingDates: { __typename?: 'VendorLocationClosingDate', closedWeekdays: Array<number>, closedDates: Array<any> }, openingTimes: Array<{ __typename?: 'VendorLocationOpeningTime', startTime: string | null, endTime: string | null, weekdays: Array<number> }> }>, categories: Array<{ __typename?: 'VendorCategory', id: string, name: string | null, position: number | null } | null>, popularItems: Array<{ __typename?: 'PopularItem', itemReference: string, rank: number, orderCount: number, accountCount: number | null }>, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, externalUrlData: { __typename?: 'VendorExternalUrlData', data: Array<{ __typename?: 'VendorExternalUrl', copy: string, id: string, url: string, tags: { __typename?: 'VendorExternalUrlTags', data: Array<string> } } | null> } } | null };

export type GetVendorAvailabilityQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
  filters: InputMaybe<GmMenuItemFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorting: InputMaybe<GmMenuItemSortingOptions>;
}>;


export type GetVendorAvailabilityQuery = { __typename?: 'Query', availability: { __typename?: 'GmAvailability', id: string, itemsPagedv2: { __typename?: 'GmMenuItems', cacheKeys: Array<string> | null, items: Array<{ __typename?: 'MenuItem', _id: string, isActive: boolean | null, name: string | null, image: string | null, shortDescription: string | null, description: string | null, ingredients: string | null, price: number | null, priceExTax: number | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, taxRate: number, updatedAt: any, isHot: boolean | null, activeFrom: any | null, activeTo: any | null, macros_carbs: number | null, macros_fat: number | null, macros_protein: number | null, macros_kcal: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, macros_fibre: number | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null, name: string | null, position: number | null, minQty: number | null, maxQty: number | null, qtyPerPerson: number | null, categoryType: string | null, items: Array<{ __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, item: { __typename?: 'MenuItem', _id: string, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, name: string | null, shortDescription: string | null, description: string | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, subAllergens: { __typename?: 'SubAllergens', cereals: Array<CerealSubAllergen>, nuts: Array<NutSubAllergen> } } | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null> | null } | null> | null, subAllergens: { __typename?: 'SubAllergens', nuts: Array<NutSubAllergen>, cereals: Array<CerealSubAllergen> }, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, categoryId: number | null, categoryIdArray: Array<number> | null, servings: number | null, popularity: number, packaging: GmItemPackaging | null, minQty: number | null, price: number | null, priceExTax: number | null, taxValue: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, privateAccessAccountIdArray: Array<number> | null, taxValueCustomerFacing: number, isCombo: boolean | null, isPricePerHead: boolean | null, position: number | null, isPrivate: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null }>, pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean }, stats: { __typename?: 'GmMenuItemStats', allergens: Array<{ __typename?: 'GmMenuItemStat', id: string, label: string, value: number, name: string }>, dietaries: Array<{ __typename?: 'GmMenuItemStat', id: string, label: string, value: number, name: string }>, categories: Array<{ __typename?: 'GmMenuItemStat', id: string, label: string, value: number, name: string }> } }, myLastBasket: { __typename?: 'GmBasket', id: string } | null, myBaskets: { __typename?: 'GmBasketPaged', rows: Array<{ __typename?: 'GmBasket', id: string, friendlyId: string }> } } | null };

export type GetVendorAvailabilityListQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
  filters: InputMaybe<GmMenuItemFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorting: InputMaybe<GmMenuItemSortingOptions>;
}>;


export type GetVendorAvailabilityListQuery = { __typename?: 'Query', availability: { __typename?: 'GmAvailability', id: string, itemsPagedv2: { __typename?: 'GmMenuItems', cacheKeys: Array<string> | null, items: Array<{ __typename?: 'MenuItem', _id: string, isActive: boolean | null, name: string | null, image: string | null, shortDescription: string | null, description: string | null, ingredients: string | null, price: number | null, priceExTax: number | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, taxRate: number, updatedAt: any, isHot: boolean | null, activeFrom: any | null, activeTo: any | null, macros_carbs: number | null, macros_fat: number | null, macros_protein: number | null, macros_kcal: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, macros_fibre: number | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null, name: string | null, position: number | null, minQty: number | null, maxQty: number | null, qtyPerPerson: number | null, categoryType: string | null } | null> | null, subAllergens: { __typename?: 'SubAllergens', nuts: Array<NutSubAllergen>, cereals: Array<CerealSubAllergen> }, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, categoryId: number | null, categoryIdArray: Array<number> | null, servings: number | null, popularity: number, packaging: GmItemPackaging | null, minQty: number | null, price: number | null, priceExTax: number | null, taxValue: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, privateAccessAccountIdArray: Array<number> | null, taxValueCustomerFacing: number, isCombo: boolean | null, isPricePerHead: boolean | null, position: number | null, isPrivate: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null }>, pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean }, stats: { __typename?: 'GmMenuItemStats', allergens: Array<{ __typename?: 'GmMenuItemStat', id: string, label: string, value: number, name: string }>, dietaries: Array<{ __typename?: 'GmMenuItemStat', id: string, label: string, value: number, name: string }>, categories: Array<{ __typename?: 'GmMenuItemStat', id: string, label: string, value: number, name: string }> } }, myLastBasket: { __typename?: 'GmBasket', id: string } | null, myBaskets: { __typename?: 'GmBasketPaged', rows: Array<{ __typename?: 'GmBasket', id: string, friendlyId: string }> } } | null };

export type GetLiveMenuItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLiveMenuItemQuery = { __typename?: 'Query', liveMenuItem: { __typename?: 'MenuItem', _id: string, isActive: boolean | null, name: string | null, image: string | null, shortDescription: string | null, description: string | null, ingredients: string | null, price: number | null, priceExTax: number | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, taxRate: number, updatedAt: any, isHot: boolean | null, activeFrom: any | null, activeTo: any | null, macros_carbs: number | null, macros_fat: number | null, macros_protein: number | null, macros_kcal: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, macros_fibre: number | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null, name: string | null, position: number | null, minQty: number | null, maxQty: number | null, qtyPerPerson: number | null, categoryType: string | null, items: Array<{ __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, item: { __typename?: 'MenuItem', _id: string, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, name: string | null, shortDescription: string | null, description: string | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, subAllergens: { __typename?: 'SubAllergens', cereals: Array<CerealSubAllergen>, nuts: Array<NutSubAllergen> } } | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null> | null } | null> | null, subAllergens: { __typename?: 'SubAllergens', nuts: Array<NutSubAllergen>, cereals: Array<CerealSubAllergen> }, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, categoryId: number | null, categoryIdArray: Array<number> | null, servings: number | null, popularity: number, packaging: GmItemPackaging | null, minQty: number | null, price: number | null, priceExTax: number | null, taxValue: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, privateAccessAccountIdArray: Array<number> | null, taxValueCustomerFacing: number, isCombo: boolean | null, isPricePerHead: boolean | null, position: number | null, isPrivate: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } };

export type GetDraftMenuItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDraftMenuItemQuery = { __typename?: 'Query', draftMenuItem: { __typename?: 'MenuItem', _id: string, isActive: boolean | null, name: string | null, image: string | null, shortDescription: string | null, description: string | null, ingredients: string | null, price: number | null, priceExTax: number | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, taxRate: number, updatedAt: any, isHot: boolean | null, activeFrom: any | null, activeTo: any | null, macros_carbs: number | null, macros_fat: number | null, macros_protein: number | null, macros_kcal: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, macros_fibre: number | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null, name: string | null, position: number | null, minQty: number | null, maxQty: number | null, qtyPerPerson: number | null, categoryType: string | null, items: Array<{ __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, item: { __typename?: 'MenuItem', _id: string, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, name: string | null, shortDescription: string | null, description: string | null, dietaries: Array<Dietary>, allergens: Array<Allergen>, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, subAllergens: { __typename?: 'SubAllergens', cereals: Array<CerealSubAllergen>, nuts: Array<NutSubAllergen> } } | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null> | null } | null> | null, subAllergens: { __typename?: 'SubAllergens', nuts: Array<NutSubAllergen>, cereals: Array<CerealSubAllergen> }, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, categoryId: number | null, categoryIdArray: Array<number> | null, servings: number | null, popularity: number, packaging: GmItemPackaging | null, minQty: number | null, price: number | null, priceExTax: number | null, taxValue: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, privateAccessAccountIdArray: Array<number> | null, taxValueCustomerFacing: number, isCombo: boolean | null, isPricePerHead: boolean | null, position: number | null, isPrivate: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } };

export type TagsQueryVariables = Exact<{
  filters: InputMaybe<VendorTagsFilters>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<Scalars['String']['input']>;
}>;


export type TagsQuery = { __typename?: 'Query', tags: { __typename?: 'TagsPaged', rows: Array<{ __typename?: 'VendorTag', id: string, label: string | null, name: string | null, groupId: string | null }>, pageInfo: { __typename?: 'PageInfo', hasMore: boolean } } };

export type GetVendorsInRangeLocationsQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  serviceType: ServiceType;
  countryCode: InputMaybe<Scalars['String']['input']>;
  dateTime: InputMaybe<VendorListDateSearchInput>;
}>;


export type GetVendorsInRangeLocationsQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', inRangeLocations: Array<{ __typename?: 'VendorLocation', id: string, timezone: string, country: string | null, city: string | null, deliveryRegions: Array<{ __typename?: 'DeliveryRegion', id: string, minOrderValue: number | null, minOrderValueExTax: number | null, orderPosition: number, serviceType: ServiceType, deliveryFee: { __typename?: 'DeliveryFee', total: number, taxRate: number } | null }>, details: { __typename?: 'VendorLocationDetails', minOrderValue: number | null, minOrderValueExTax: number | null, gmMaxDistanceMinutes: number | null, gmMinNoticePeriod: number | null, gmMaxOrder: number | null, gmLargeOrderThreshold: number | null, gmLargeOrderNoticePeriod: number | null, isGMActive: boolean, gmAllowCountryWideDelivery: boolean | null }, closingDates: { __typename?: 'VendorLocationClosingDate', closedWeekdays: Array<number>, closedDates: Array<any> }, openingTimes: Array<{ __typename?: 'VendorLocationOpeningTime', startTime: string | null, endTime: string | null, weekdays: Array<number> }> }> } };

export type EmmaFormResponseGetVendorLocationsQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
}>;


export type EmmaFormResponseGetVendorLocationsQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', companyName: string, locations: Array<{ __typename?: 'VendorLocation', id: string, isDefault: boolean }> } };

export type VerifyCouponQueryVariables = Exact<{
  input: VerifyCouponInput;
}>;


export type VerifyCouponQuery = { __typename?: 'Query', verifyCoupon: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null };

export type GetPastOrdersForReorderQueryVariables = Exact<{
  filters: GmOrdersFilters;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sortBy: GmOrdersSortBy;
}>;


export type GetPastOrdersForReorderQuery = { __typename?: 'Query', gmOrders: { __typename?: 'GmOrderPaged', pageInfo: { __typename?: 'PageInfo', count: number }, data: Array<{ __typename?: 'GmOrder', id: string, orderId: string, customName: string | null, deliveryDate: string, currentStatus: { __typename?: 'GmOrderStatus', name: string }, vendor: { __typename?: 'Vendor', id: string }, orderItems: { __typename?: 'GmOrderItems', items: Array<{ __typename?: 'GmOrderItem', id: string, name: string, qty: number, servings: number | null, subtotalExTax: number, note: string | null, liveMenuItem: { __typename?: 'MenuItem', _id: string, name: string | null } | null, orderItemOptions: Array<{ __typename?: 'GmOrderItemOption', id: string, name: string, qty: number, optionCategoryId: string, optionReference: string, liveMenuItem: { __typename?: 'MenuItem', _id: string, name: string | null } | null }> }> } }> } };

export type AddItemToBasketMutationVariables = Exact<{
  basketId: Scalars['ID']['input'];
  itemPayload: BasketItemInput;
  isStandingOrderTemplate: InputMaybe<Scalars['Boolean']['input']>;
  editSessionId: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddItemToBasketMutation = { __typename?: 'Mutation', basket: { __typename?: 'GmBasket', id: string, friendlyId: string, customName: string | null, editSessionId: string | null, isCateringTeamOrder: boolean, userId: number | null, itemCount: number, hasEnterpriseDiscount: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', deliveryDate: string, deliveryTimeSlot: string, headCount: number, feedrAdminApproved: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, isGuestBasket: boolean | null, emmaFormResponseId: string | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', locationId: number | null }, location:
        | { __typename: 'AccountLocation', instructions: string | null, id: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null }, logistics: { __typename?: 'GmServiceLogistics', customDeliveryFee: number | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number }, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } };

export type BasketCustomerPriceItemFragment = { __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number };

export type BasketItemFragment = { __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> };

export type BasketCustomItemFragment = { __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number };

export type BasketFragment = { __typename?: 'GmBasket', id: string, friendlyId: string, customName: string | null, editSessionId: string | null, isCateringTeamOrder: boolean, userId: number | null, itemCount: number, hasEnterpriseDiscount: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', deliveryDate: string, deliveryTimeSlot: string, headCount: number, feedrAdminApproved: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, isGuestBasket: boolean | null, emmaFormResponseId: string | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', locationId: number | null }, location:
      | { __typename: 'AccountLocation', instructions: string | null, id: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
      | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
      | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
     | null }, logistics: { __typename?: 'GmServiceLogistics', customDeliveryFee: number | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number }, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } };

export type CreateBasketMutationVariables = Exact<{
  availabilityId: Scalars['ID']['input'];
  basketPayload: CreateGmBasketInput;
}>;


export type CreateBasketMutation = { __typename?: 'Mutation', basket: { __typename?: 'GmBasket', id: string, friendlyId: string, customName: string | null, editSessionId: string | null, isCateringTeamOrder: boolean, userId: number | null, itemCount: number, hasEnterpriseDiscount: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', deliveryDate: string, deliveryTimeSlot: string, headCount: number, feedrAdminApproved: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, isGuestBasket: boolean | null, emmaFormResponseId: string | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', locationId: number | null }, location:
        | { __typename: 'AccountLocation', instructions: string | null, id: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null }, logistics: { __typename?: 'GmServiceLogistics', customDeliveryFee: number | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number }, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } };

export type GetBasketQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBasketQuery = { __typename?: 'Query', basket: { __typename?: 'GmBasket', id: string, friendlyId: string, customName: string | null, editSessionId: string | null, isCateringTeamOrder: boolean, userId: number | null, itemCount: number, hasEnterpriseDiscount: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', deliveryDate: string, deliveryTimeSlot: string, headCount: number, feedrAdminApproved: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, isGuestBasket: boolean | null, emmaFormResponseId: string | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', locationId: number | null }, location:
        | { __typename: 'AccountLocation', instructions: string | null, id: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null }, logistics: { __typename?: 'GmServiceLogistics', customDeliveryFee: number | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number }, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } | null };

export type GmMenuStandingOrderDataFragment = { __typename?: 'StandingOrder', _id: string, name: string, activeFrom: any, activeUntil: any | null, recurrence: Recurrence, daysOfOccurrence: Array<number>, nextDeliveryDate: any | null };

export type GetStandingOrderQueryVariables = Exact<{
  standingOrderId: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetStandingOrderQuery = { __typename?: 'Query', standingOrder: { __typename?: 'StandingOrder', _id: string, name: string, activeFrom: any, activeUntil: any | null, recurrence: Recurrence, daysOfOccurrence: Array<number>, nextDeliveryDate: any | null, standingOrderTemplate: { __typename?: 'GmBasket', id: string, friendlyId: string, customName: string | null, editSessionId: string | null, isCateringTeamOrder: boolean, userId: number | null, itemCount: number, hasEnterpriseDiscount: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', deliveryDate: string, deliveryTimeSlot: string, headCount: number, feedrAdminApproved: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, isGuestBasket: boolean | null, emmaFormResponseId: string | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', locationId: number | null }, location:
          | { __typename: 'AccountLocation', instructions: string | null, id: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
          | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
          | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
         | null }, logistics: { __typename?: 'GmServiceLogistics', customDeliveryFee: number | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number }, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } } | null };

export type RemoveItemFromBasketMutationVariables = Exact<{
  basketId: Scalars['ID']['input'];
  itemReference: Scalars['String']['input'];
  isStandingOrderTemplate: InputMaybe<Scalars['Boolean']['input']>;
  editSessionId: InputMaybe<Scalars['ID']['input']>;
}>;


export type RemoveItemFromBasketMutation = { __typename?: 'Mutation', basket: { __typename?: 'GmBasket', id: string, friendlyId: string, customName: string | null, editSessionId: string | null, isCateringTeamOrder: boolean, userId: number | null, itemCount: number, hasEnterpriseDiscount: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', deliveryDate: string, deliveryTimeSlot: string, headCount: number, feedrAdminApproved: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, isGuestBasket: boolean | null, emmaFormResponseId: string | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', locationId: number | null }, location:
        | { __typename: 'AccountLocation', instructions: string | null, id: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null }, logistics: { __typename?: 'GmServiceLogistics', customDeliveryFee: number | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number }, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } };

export type SaveStandingOrderChangesMutationVariables = Exact<{
  basketId: Scalars['ID']['input'];
  editSessionId: Scalars['ID']['input'];
}>;


export type SaveStandingOrderChangesMutation = { __typename?: 'Mutation', basket: { __typename?: 'GmBasket', id: string, friendlyId: string, customName: string | null, editSessionId: string | null, isCateringTeamOrder: boolean, userId: number | null, itemCount: number, hasEnterpriseDiscount: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', deliveryDate: string, deliveryTimeSlot: string, headCount: number, feedrAdminApproved: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, isGuestBasket: boolean | null, emmaFormResponseId: string | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', locationId: number | null }, location:
        | { __typename: 'AccountLocation', instructions: string | null, id: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null }, logistics: { __typename?: 'GmServiceLogistics', customDeliveryFee: number | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number }, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } };

export type UpdateBasketMutationVariables = Exact<{
  basketId: Scalars['ID']['input'];
  basketPayload: UpdateGmBasketInput;
}>;


export type UpdateBasketMutation = { __typename?: 'Mutation', basket: { __typename?: 'GmBasket', id: string, friendlyId: string, customName: string | null, editSessionId: string | null, isCateringTeamOrder: boolean, userId: number | null, itemCount: number, hasEnterpriseDiscount: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', deliveryDate: string, deliveryTimeSlot: string, headCount: number, feedrAdminApproved: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, isGuestBasket: boolean | null, emmaFormResponseId: string | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', locationId: number | null }, location:
        | { __typename: 'AccountLocation', instructions: string | null, id: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null }, logistics: { __typename?: 'GmServiceLogistics', customDeliveryFee: number | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number }, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } };

export type UpdateItemInBasketMutationVariables = Exact<{
  basketId: Scalars['ID']['input'];
  itemReference: Scalars['String']['input'];
  itemPayload: UpdateBasketItemInput;
  isStandingOrderTemplate: InputMaybe<Scalars['Boolean']['input']>;
  editSessionId: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateItemInBasketMutation = { __typename?: 'Mutation', basket: { __typename?: 'GmBasket', id: string, friendlyId: string, customName: string | null, editSessionId: string | null, isCateringTeamOrder: boolean, userId: number | null, itemCount: number, hasEnterpriseDiscount: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', deliveryDate: string, deliveryTimeSlot: string, headCount: number, feedrAdminApproved: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, isGuestBasket: boolean | null, emmaFormResponseId: string | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', locationId: number | null }, location:
        | { __typename: 'AccountLocation', instructions: string | null, id: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null }, logistics: { __typename?: 'GmServiceLogistics', customDeliveryFee: number | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number }, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } };

export type UpdateItemQtyInGmBasketMutationVariables = Exact<{
  basketId: Scalars['ID']['input'];
  itemReference: Scalars['String']['input'];
  qty: Scalars['Int']['input'];
  isStandingOrderTemplate: InputMaybe<Scalars['Boolean']['input']>;
  editSessionId: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateItemQtyInGmBasketMutation = { __typename?: 'Mutation', basket: { __typename?: 'GmBasket', id: string, friendlyId: string, customName: string | null, editSessionId: string | null, isCateringTeamOrder: boolean, userId: number | null, itemCount: number, hasEnterpriseDiscount: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', deliveryDate: string, deliveryTimeSlot: string, headCount: number, feedrAdminApproved: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, isGuestBasket: boolean | null, emmaFormResponseId: string | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', locationId: number | null }, location:
        | { __typename: 'AccountLocation', instructions: string | null, id: string, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null }, logistics: { __typename?: 'GmServiceLogistics', customDeliveryFee: number | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number }, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } };

export type UpdateReferenceFieldInBasketMutationVariables = Exact<{
  basketId: Scalars['ID']['input'];
  orderReferenceFieldId: Scalars['Int']['input'];
  value: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateReferenceFieldInBasketMutation = { __typename?: 'Mutation', updateReferenceFieldInBasket: { __typename?: 'GmBasket', id: string, friendlyId: string, isCateringTeamOrder: boolean, userId: number | null, hasEnterpriseDiscount: boolean, itemCount: number, allergens: Array<string> | null, user: { __typename?: 'User', fullName: string, id: string } | null, contributors: Array<{ __typename?: 'GmBasketContributor', userId: number, name: string }>, vendor: { __typename?: 'Vendor', id: string, companyName: string, isPantry: boolean | null, currency: Currency | null, permalink: string | null, locations: Array<{ __typename?: 'VendorLocation', id: string, country: string | null }>, financeSettings: { __typename?: 'VendorFinanceSettings', billingCountry: string | null } }, items: Array<{ __typename?: 'BasketItem', qty: number, itemReference: string, acknowledgedAt: any | null, note: string | null, addedByUserId: number | null, addedByName: string | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, taxRate: number, taxValue: number | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, servings: number | null, minQty: number | null, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, isActive: boolean | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null }> | null, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, options: Array<{ __typename?: 'BasketItemOption', qty: number, category: { __typename?: 'MenuItemOptions', _id: string, optionType: MenuItemOptionType | null } | null, optionItem: { __typename?: 'OptionItem', _id: string, price: number | null, priceExTax: number | null, priceCustomerFacing: number, priceCustomerFacingExTax: number, taxRate: number, taxValue: number | null, taxValueCustomerFacing: number, customerPriceItems: Array<{ __typename?: 'CustomerPriceItem', customerPriceType: CustomerPriceType, isCustomerFinalPrice: boolean, price: number, priceExTax: number, priceTaxValue: number }> | null } | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, isActive: boolean | null, activeFrom: any | null, activeTo: any | null, updatedAt: any, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null } | null }> }>, customItems: Array<{ __typename?: 'GmBasketCustomItem', description: string, id: string, name: string, notes: string | null, customerPriceExTax: number, quantity: number }>, options: { __typename?: 'GMServiceOptions', format: GmServiceFormat | null, rep: boolean, isHighRisk: boolean, thermalBox: boolean | null, budgetCode: string | null, addons: { __typename?: 'GMServiceAddons', napkins: boolean, plates: boolean, service: boolean }, notes: { __typename?: 'GMServiceNotes', cart: string | null, account: string | null, vendor: string | null } } | null, settings: { __typename?: 'GmServiceSettings', isGuestBasket: boolean | null, paymentMethod: PaymentMethod | null, billingAddressSameAsDelivery: boolean, deliveryDate: string, deliveryTimeSlot: string, deliveryInstructions: string | null, headCount: number, meetingRoom: string | null, feedrAdminApproved: boolean | null, feedrCreated: boolean | null, invoiceAccountId: number | null, account: { __typename?: 'AvailabilitiesAccount', id: number, name: string } | null, vendor: { __typename?: 'AvailabilitiesVendor', id: number, name: string, locationId: number | null, location: { __typename?: 'VendorLocation', country: string | null } | null }, location:
        | { __typename: 'AccountLocation', id: string, label: string | null, instructions: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null, referenceFieldValues: Array<{ __typename?: 'GmReferenceFieldValue', orderReferenceFieldId: number, referenceFieldId: number, label: string, description: string | null, fieldType: ReferenceFieldType, value: string | null, isRequired: boolean, version: number, error: string | null, options: Array<{ __typename?: 'GmReferenceFieldOption', id: number, option: string, orderPriority: number, orderReferenceFieldId: number }> | null }> | null, billingAddress:
        | { __typename: 'AccountLocation', id: string, label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
        | { __typename: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null }
        | { __typename: 'NewAccountLocation', label: string | null, address: { __typename?: 'Address', label: string | null, flatOrBuilding: string | null, floorOrBuildingName: string | null, city: string | null, country: string | null, postcode: string | null, street: string | null, latitude: number | null, longitude: number | null, timezoneId: string | null } }
       | null }, subtotalBreakdown: { __typename?: 'BasketSubtotalBreakdown', subtotalExTax: number, subtotal: number, taxValue: number, taxRateTotalBreakdown: Array<{ __typename?: 'BasketTaxRateTotal', rate: number, taxValue: number, itemValue: number }> }, couponId: { __typename?: 'Coupon', id: string, code: string, discountPercentage: number | null, discountNumeric: number | null } | null, fees: Array<{ __typename?: 'GmOrderFeeBreakdown', description: string, code: GmOrderFeeCode, totalExTax: number }>, discountBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number, totalExTax: number, taxValue: number, taxRateTotals: Array<{ __typename?: 'GmOrderTaxRateTotal', rate: number, totalExTax: number }> }, checkoutRestrictions: { __typename?: 'GmBasketCheckoutRestrictions', companyAdminOnly: boolean | null } } };

export type TrackCheckoutStartedMutationVariables = Exact<{
  basketId: Scalars['ID']['input'];
}>;


export type TrackCheckoutStartedMutation = { __typename?: 'Mutation', trackCheckoutStarted: boolean };

export type CreateFlexInvoiceMutationVariables = Exact<{
  input: CreateFlexInvoiceInput;
}>;


export type CreateFlexInvoiceMutation = { __typename?: 'Mutation', createFlexInvoice: string };

export type AccountsQueryVariables = Exact<{
  input: AccountSearch;
}>;


export type AccountsQuery = { __typename?: 'Query', accounts: { __typename?: 'AccountsPaged', rows: Array<{ __typename?: 'Account', id: string, name: string, notes: string, locations: Array<{ __typename?: 'AccountLocation', id: string, label: string | null, timezone: string } | null> | null, invoiceAccounts: Array<{ __typename?: 'InvoiceAccount', id: string, label: string | null, flexDeferredCustomerId: string | null, country: string | null, vatRegionId: number }> }> } };

export type InvoiceOrdersQueryVariables = Exact<{
  input: InputMaybe<InvoiceOrderInput>;
}>;


export type InvoiceOrdersQuery = { __typename?: 'Query', invoiceOrders: { __typename?: 'InvoiceOrdersPaged', items: Array<{ __typename?: 'InvoiceOrder', id: string, deliveryDate: any, deliveryTimezone: string | null, number: string, contact: string, supplier: string, shippingAddress: string, total: string, budgetCode: string | null, customerName: string | null, referenceFields: Array<{ __typename?: 'InvoiceOrderReferenceField', label: string, value: string }> | null } | null>, pageInfo: { __typename?: 'PageInfo', count: number, limit: number, offset: number } } };

export type CreateVendorFlexInvoiceMutationVariables = Exact<{
  input: CreateVendorFlexInvoiceInput;
}>;


export type CreateVendorFlexInvoiceMutation = { __typename?: 'Mutation', createVendorFlexInvoice: string };

export type VendorInvoiceOrdersQueryVariables = Exact<{
  input: InputMaybe<VendorInvoiceOrderInput>;
}>;


export type VendorInvoiceOrdersQuery = { __typename?: 'Query', vendorInvoiceOrders: { __typename?: 'VendorInvoiceOrdersPaged', items: Array<{ __typename?: 'VendorInvoiceOrder', id: string, deliveryDate: any, deliveryTimezone: string | null, number: string, contact: string, total: string, supplier: string, shippingAddress: string } | null>, pageInfo: { __typename?: 'PageInfo', count: number, limit: number, offset: number } } };

export type SearchVendorsQueryVariables = Exact<{
  name: InputMaybe<Scalars['String']['input']>;
  tenantId: InputMaybe<Scalars['String']['input']>;
  countryCode: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchVendorsQuery = { __typename?: 'Query', vendors: { __typename?: 'VendorsPaged', rows: Array<{ __typename?: 'Vendor', id: string, companyName: string, locations: Array<{ __typename?: 'VendorLocation', id: string, label: string | null, country: string | null }> }> } };

export type GetVendorWithFlexFinanceSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVendorWithFlexFinanceSettingsQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', id: string, companyName: string, flexFinanceSettings: { __typename?: 'VendorFlexFinanceSettings', flexDeferredSupplierId: string } | null } };

export type CheckForGeneratedCcInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type CheckForGeneratedCcInvoiceQuery = { __typename?: 'Query', invoice:
    | { __typename?: 'CCInvoice', id: string }
    | { __typename?: 'GMInvoice', id: string }
   };

export type CheckForGeneratedVendorStatementQueryVariables = Exact<{
  statementId: Scalars['ID']['input'];
}>;


export type CheckForGeneratedVendorStatementQuery = { __typename?: 'Query', vendorStatement: { __typename?: 'VendorStatement', id: string } };

export type GetInvoicePdfQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type GetInvoicePdfQuery = { __typename?: 'Query', invoice:
    | { __typename?: 'CCInvoice', id: string, type: InvoiceType, overviewPdf: { __typename?: 'Asset', type: string, url: string } | null, detailedPdf: { __typename?: 'Asset', type: string, url: string } | null, csv: { __typename?: 'Asset', type: string, url: string } | null }
    | { __typename?: 'GMInvoice', id: string, type: InvoiceType, overviewPdf: { __typename?: 'Asset', type: string, url: string } | null, detailedPdf: { __typename?: 'Asset', type: string, url: string } | null, csv: { __typename?: 'Asset', type: string, url: string } | null }
   };

export type GetVendorStatementPdfQueryVariables = Exact<{
  vendorStatementId: Scalars['ID']['input'];
}>;


export type GetVendorStatementPdfQuery = { __typename?: 'Query', vendorStatement: { __typename?: 'VendorStatement', id: string, overviewPdf: { __typename?: 'Asset', type: string, url: string } | null, detailedPdf: { __typename?: 'Asset', type: string, url: string } | null } };

export type CcInvoiceFragment = { __typename?: 'CCInvoice', mealsDonated: number, additionalItemsTaxInvoiceNumber: string, id: string, friendlyId: string, status: InvoiceStatus, paymentStatus: PaymentStatus, budgetCode: string | null, canPay: boolean, canCancel: boolean, isAlreadyApproved: boolean, dueDate: any, issueDate: any | null, periodStart: any, periodEnd: any, total: number, totalVat: number, totalExVat: number, additionalTotal: number, additionalTotalExVat: number, additionalTotalVat: number, totalQuantity: number, amountDue: number, currency: Currency, account: { __typename?: 'CCAccount', id: number, name: string }, accountLocation: { __typename?: 'CCAccountLocation', id: number, timezone: string, address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } }, supplierOrderBreakdown: { __typename?: 'CCSupplierOrderBreakdownPaged', pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean, limit: number, offset: number }, vatSummary: Array<{ __typename?: 'CCSupplierOrderBreakdownVat', vatRate: number, quantity: number, total: number, totalExVat: number, totalVat: number }>, orders: Array<{ __typename?: 'CCSupplierOrderBreakdown', date: any, supplierName: string, meal: string, arrivalTime: any, supplierVatNumber: string | null, quantity: number, totalExVat: number, totalVat: number, total: number, taxInvoiceNumber: string, supplierAddress: { __typename?: 'BillingAddress', line1: string, line2: string | null, city: string, country: string, postcode: string }, vatSummary: Array<{ __typename?: 'CCSupplierOrderBreakdownVat', vatRate: number, quantity: number, total: number, totalExVat: number, totalVat: number }>, items: Array<{ __typename?: 'InvoiceItem', id: string, optionId: number | null, description: string, quantity: number, unitPrice: number, unitDiscount: number, vatRate: number, total: number, isPromotionItem: boolean }> }> }, additionalVatSummary: Array<{ __typename?: 'VatSummary', vatBandId: string, vatRate: number, total: number, totalExVat: number, totalVat: number }>, overviewPdf: { __typename?: 'Asset', url: string } | null, detailedPdf: { __typename?: 'Asset', url: string } | null, csv: { __typename?: 'Asset', url: string } | null, vatSummary: Array<{ __typename?: 'VatSummary', vatBandId: string, vatRate: number, total: number, totalExVat: number, totalVat: number }>, vatRegion: { __typename?: 'VatRegion', id: string, name: string, vatBands: Array<{ __typename?: 'VatBand', id: string, name: string, rate: number }> }, paymentHistory: Array<{ __typename?: 'PaymentHistory', date: any, amount: number }>, billingDetails: { __typename?: 'BillingDetails', vatNumber: string | null, address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, city: string, postcode: string, country: string }, contact: { __typename?: 'BillingContact', firstName: string, lastName: string, email: string } }, items: { __typename?: 'InvoiceItemsPaged', items: Array<{ __typename?: 'InvoiceItem', id: string, description: string, quantity: number, unitPrice: number, unitDiscount: number, vatRate: number, total: number }> }, additionalItems: { __typename?: 'InvoiceItemsPaged', pageInfo: { __typename?: 'PageInfo', count: number, limit: number, offset: number }, items: Array<{ __typename?: 'InvoiceItem', id: string, description: string, quantity: number, vatRate: number, total: number, totalExVat: number, totalVat: number }> }, billingEntity: { __typename?: 'BillingEntity', code: string, name: string, address: string, companyNumber: string | null, vatNumber: string | null, tenantId: string | null, bankAccountData: Array<{ __typename?: 'BankAccountData', accountName: string, currency: string, sortCode: string | null, accountNumber: string, bic: string | null, iban: string | null }> | null } };

export type GetCcInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  supplierOrderBreakdownLimit: Scalars['Int']['input'];
  supplierOrderBreakdownOffset: Scalars['Int']['input'];
  additionalItemsLimit: Scalars['Int']['input'];
  additionalItemsOffset: Scalars['Int']['input'];
}>;


export type GetCcInvoiceQuery = { __typename?: 'Query', invoice:
    | { __typename?: 'CCInvoice', mealsDonated: number, additionalItemsTaxInvoiceNumber: string, id: string, friendlyId: string, status: InvoiceStatus, paymentStatus: PaymentStatus, budgetCode: string | null, canPay: boolean, canCancel: boolean, isAlreadyApproved: boolean, dueDate: any, issueDate: any | null, periodStart: any, periodEnd: any, total: number, totalVat: number, totalExVat: number, additionalTotal: number, additionalTotalExVat: number, additionalTotalVat: number, totalQuantity: number, amountDue: number, currency: Currency, account: { __typename?: 'CCAccount', id: number, name: string }, accountLocation: { __typename?: 'CCAccountLocation', id: number, timezone: string, address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } }, supplierOrderBreakdown: { __typename?: 'CCSupplierOrderBreakdownPaged', pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean, limit: number, offset: number }, vatSummary: Array<{ __typename?: 'CCSupplierOrderBreakdownVat', vatRate: number, quantity: number, total: number, totalExVat: number, totalVat: number }>, orders: Array<{ __typename?: 'CCSupplierOrderBreakdown', date: any, supplierName: string, meal: string, arrivalTime: any, supplierVatNumber: string | null, quantity: number, totalExVat: number, totalVat: number, total: number, taxInvoiceNumber: string, supplierAddress: { __typename?: 'BillingAddress', line1: string, line2: string | null, city: string, country: string, postcode: string }, vatSummary: Array<{ __typename?: 'CCSupplierOrderBreakdownVat', vatRate: number, quantity: number, total: number, totalExVat: number, totalVat: number }>, items: Array<{ __typename?: 'InvoiceItem', id: string, optionId: number | null, description: string, quantity: number, unitPrice: number, unitDiscount: number, vatRate: number, total: number, isPromotionItem: boolean }> }> }, additionalVatSummary: Array<{ __typename?: 'VatSummary', vatBandId: string, vatRate: number, total: number, totalExVat: number, totalVat: number }>, overviewPdf: { __typename?: 'Asset', url: string } | null, detailedPdf: { __typename?: 'Asset', url: string } | null, csv: { __typename?: 'Asset', url: string } | null, vatSummary: Array<{ __typename?: 'VatSummary', vatBandId: string, vatRate: number, total: number, totalExVat: number, totalVat: number }>, vatRegion: { __typename?: 'VatRegion', id: string, name: string, vatBands: Array<{ __typename?: 'VatBand', id: string, name: string, rate: number }> }, paymentHistory: Array<{ __typename?: 'PaymentHistory', date: any, amount: number }>, billingDetails: { __typename?: 'BillingDetails', vatNumber: string | null, address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, city: string, postcode: string, country: string }, contact: { __typename?: 'BillingContact', firstName: string, lastName: string, email: string } }, items: { __typename?: 'InvoiceItemsPaged', items: Array<{ __typename?: 'InvoiceItem', id: string, description: string, quantity: number, unitPrice: number, unitDiscount: number, vatRate: number, total: number }> }, additionalItems: { __typename?: 'InvoiceItemsPaged', pageInfo: { __typename?: 'PageInfo', count: number, limit: number, offset: number }, items: Array<{ __typename?: 'InvoiceItem', id: string, description: string, quantity: number, vatRate: number, total: number, totalExVat: number, totalVat: number }> }, billingEntity: { __typename?: 'BillingEntity', code: string, name: string, address: string, companyNumber: string | null, vatNumber: string | null, tenantId: string | null, bankAccountData: Array<{ __typename?: 'BankAccountData', accountName: string, currency: string, sortCode: string | null, accountNumber: string, bic: string | null, iban: string | null }> | null } }
    | { __typename?: 'GMInvoice' }
   };

export type CcInvoiceItemFragment = { __typename?: 'InvoiceItem', id: string, description: string, quantity: number, vatRate: number, total: number, totalExVat: number, totalVat: number };

export type CcSupplierOrderBreakdownItemFragment = { __typename?: 'CCSupplierOrderBreakdown', date: any, supplierName: string, meal: string, arrivalTime: any, supplierVatNumber: string | null, quantity: number, totalExVat: number, totalVat: number, total: number, taxInvoiceNumber: string, supplierAddress: { __typename?: 'BillingAddress', line1: string, line2: string | null, city: string, country: string, postcode: string }, vatSummary: Array<{ __typename?: 'CCSupplierOrderBreakdownVat', vatRate: number, quantity: number, total: number, totalExVat: number, totalVat: number }>, items: Array<{ __typename?: 'InvoiceItem', id: string, optionId: number | null, description: string, quantity: number, unitPrice: number, unitDiscount: number, vatRate: number, total: number, isPromotionItem: boolean }> };

export type RemoveInvoiceItemMutationVariables = Exact<{
  invoiceItemId: Scalars['ID']['input'];
}>;


export type RemoveInvoiceItemMutation = { __typename?: 'Mutation', removeInvoiceItem: string };

export type UpdateInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateInvoiceInput;
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', updateInvoice:
    | { __typename?: 'CCInvoice', id: string, dueDate: any, budgetCode: string | null, billingDetails: { __typename?: 'BillingDetails', address: { __typename?: 'BillingAddress', line1: string, line2: string | null, city: string, postcode: string, country: string }, contact: { __typename?: 'BillingContact', firstName: string, lastName: string, email: string } } }
    | { __typename?: 'GMInvoice', id: string, dueDate: any, budgetCode: string | null, billingDetails: { __typename?: 'BillingDetails', address: { __typename?: 'BillingAddress', line1: string, line2: string | null, city: string, postcode: string, country: string }, contact: { __typename?: 'BillingContact', firstName: string, lastName: string, email: string } } }
   };

export type AddInvoiceItemMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  input: InvoiceItemInput;
}>;


export type AddInvoiceItemMutation = { __typename?: 'Mutation', addInvoiceItem: { __typename?: 'InvoiceItem', date: any, description: string, quantity: number, unitPrice: number, vatRate: number } };

export type GmInvoiceFragment = { __typename?: 'GMInvoice', foodSalesDiscountPercent: number, mealsDonated: number, id: string, isInvoiceAccount: boolean, friendlyId: string, status: InvoiceStatus, paymentStatus: PaymentStatus, budgetCode: string | null, canPay: boolean, canCancel: boolean, isAlreadyApproved: boolean, dueDate: any, issueDate: any | null, periodStart: any, periodEnd: any, total: number, totalVat: number, totalExVat: number, additionalTotal: number, additionalTotalExVat: number, additionalTotalVat: number, totalQuantity: number, amountDue: number, currency: Currency, account: { __typename?: 'GMAccount', id: number, name: string }, accountLocation: { __typename?: 'GMAccountLocation', id: number, timezone: string, address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } }, supplierOrderBreakdown: { __typename?: 'GMSupplierOrderBreakdownPaged', pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean, limit: number, offset: number }, vatSummary: Array<{ __typename?: 'GMSupplierOrderBreakdownVat', vatRate: number, quantity: number, total: number, totalExVat: number, totalVat: number }>, orders: Array<{ __typename?: 'GMSupplierOrderBreakdown', orderId: number, friendlyOrderId: string, date: any, supplierName: string, arrivalTime: any, supplierVatNumber: string | null, quantity: number, totalExVat: number, totalVat: number, total: number, taxInvoiceNumber: string, supplierAddress: { __typename?: 'BillingAddress', line1: string, line2: string | null, city: string, country: string, postcode: string }, vatSummary: Array<{ __typename?: 'GMSupplierOrderBreakdownVat', vatRate: number, quantity: number, total: number, totalExVat: number, totalVat: number }>, items: Array<{ __typename?: 'InvoiceItem', id: string, optionId: number | null, description: string, quantity: number, unitPrice: number, unitDiscount: number, vatRate: number, total: number, totalExVat: number, totalVat: number, isPromotionItem: boolean }> }> }, additionalVatSummary: Array<{ __typename?: 'VatSummary', vatBandId: string, vatRate: number, total: number, totalExVat: number, totalVat: number }>, overviewPdf: { __typename?: 'Asset', url: string } | null, detailedPdf: { __typename?: 'Asset', url: string } | null, csv: { __typename?: 'Asset', url: string } | null, vatSummary: Array<{ __typename?: 'VatSummary', vatBandId: string, vatRate: number, total: number, totalExVat: number, totalVat: number }>, vatRegion: { __typename?: 'VatRegion', id: string, name: string, vatBands: Array<{ __typename?: 'VatBand', id: string, name: string, rate: number }> }, paymentHistory: Array<{ __typename?: 'PaymentHistory', date: any, amount: number }>, billingDetails: { __typename?: 'BillingDetails', vatNumber: string | null, address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, city: string, postcode: string, country: string }, contact: { __typename?: 'BillingContact', firstName: string, lastName: string, email: string } }, items: { __typename?: 'InvoiceItemsPaged', items: Array<{ __typename?: 'InvoiceItem', id: string, description: string, quantity: number, unitPrice: number, unitDiscount: number, vatRate: number, total: number }> }, additionalItems: { __typename?: 'InvoiceItemsPaged', pageInfo: { __typename?: 'PageInfo', count: number, limit: number, offset: number }, items: Array<{ __typename?: 'InvoiceItem', id: string, description: string, quantity: number, vatRate: number, total: number, totalExVat: number, totalVat: number }> }, billingEntity: { __typename?: 'BillingEntity', code: string, name: string, address: string, companyNumber: string | null, vatNumber: string | null, tenantId: string | null, bankAccountData: Array<{ __typename?: 'BankAccountData', accountName: string, currency: string, sortCode: string | null, accountNumber: string, bic: string | null, iban: string | null }> | null } };

export type GetGmInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  supplierOrderBreakdownLimit: Scalars['Int']['input'];
  supplierOrderBreakdownOffset: Scalars['Int']['input'];
  checkDelivery: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetGmInvoiceQuery = { __typename?: 'Query', invoice:
    | { __typename?: 'CCInvoice' }
    | { __typename?: 'GMInvoice', foodSalesDiscountPercent: number, mealsDonated: number, id: string, isInvoiceAccount: boolean, friendlyId: string, status: InvoiceStatus, paymentStatus: PaymentStatus, budgetCode: string | null, canPay: boolean, canCancel: boolean, isAlreadyApproved: boolean, dueDate: any, issueDate: any | null, periodStart: any, periodEnd: any, total: number, totalVat: number, totalExVat: number, additionalTotal: number, additionalTotalExVat: number, additionalTotalVat: number, totalQuantity: number, amountDue: number, currency: Currency, account: { __typename?: 'GMAccount', id: number, name: string }, accountLocation: { __typename?: 'GMAccountLocation', id: number, timezone: string, address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } }, supplierOrderBreakdown: { __typename?: 'GMSupplierOrderBreakdownPaged', pageInfo: { __typename?: 'PageInfo', count: number, hasMore: boolean, limit: number, offset: number }, vatSummary: Array<{ __typename?: 'GMSupplierOrderBreakdownVat', vatRate: number, quantity: number, total: number, totalExVat: number, totalVat: number }>, orders: Array<{ __typename?: 'GMSupplierOrderBreakdown', orderId: number, friendlyOrderId: string, date: any, supplierName: string, arrivalTime: any, supplierVatNumber: string | null, quantity: number, totalExVat: number, totalVat: number, total: number, taxInvoiceNumber: string, supplierAddress: { __typename?: 'BillingAddress', line1: string, line2: string | null, city: string, country: string, postcode: string }, vatSummary: Array<{ __typename?: 'GMSupplierOrderBreakdownVat', vatRate: number, quantity: number, total: number, totalExVat: number, totalVat: number }>, items: Array<{ __typename?: 'InvoiceItem', id: string, optionId: number | null, description: string, quantity: number, unitPrice: number, unitDiscount: number, vatRate: number, total: number, totalExVat: number, totalVat: number, isPromotionItem: boolean }> }> }, additionalVatSummary: Array<{ __typename?: 'VatSummary', vatBandId: string, vatRate: number, total: number, totalExVat: number, totalVat: number }>, overviewPdf: { __typename?: 'Asset', url: string } | null, detailedPdf: { __typename?: 'Asset', url: string } | null, csv: { __typename?: 'Asset', url: string } | null, vatSummary: Array<{ __typename?: 'VatSummary', vatBandId: string, vatRate: number, total: number, totalExVat: number, totalVat: number }>, vatRegion: { __typename?: 'VatRegion', id: string, name: string, vatBands: Array<{ __typename?: 'VatBand', id: string, name: string, rate: number }> }, paymentHistory: Array<{ __typename?: 'PaymentHistory', date: any, amount: number }>, billingDetails: { __typename?: 'BillingDetails', vatNumber: string | null, address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, city: string, postcode: string, country: string }, contact: { __typename?: 'BillingContact', firstName: string, lastName: string, email: string } }, items: { __typename?: 'InvoiceItemsPaged', items: Array<{ __typename?: 'InvoiceItem', id: string, description: string, quantity: number, unitPrice: number, unitDiscount: number, vatRate: number, total: number }> }, additionalItems: { __typename?: 'InvoiceItemsPaged', pageInfo: { __typename?: 'PageInfo', count: number, limit: number, offset: number }, items: Array<{ __typename?: 'InvoiceItem', id: string, description: string, quantity: number, vatRate: number, total: number, totalExVat: number, totalVat: number }> }, billingEntity: { __typename?: 'BillingEntity', code: string, name: string, address: string, companyNumber: string | null, vatNumber: string | null, tenantId: string | null, bankAccountData: Array<{ __typename?: 'BankAccountData', accountName: string, currency: string, sortCode: string | null, accountNumber: string, bic: string | null, iban: string | null }> | null } }
   };

export type GmInvoiceItemFragment = { __typename?: 'InvoiceItem', id: string, description: string, quantity: number, vatRate: number, total: number, totalExVat: number, totalVat: number };

export type GmSupplierOrderBreakdownItemFragment = { __typename?: 'GMSupplierOrderBreakdown', orderId: number, friendlyOrderId: string, date: any, supplierName: string, arrivalTime: any, supplierVatNumber: string | null, quantity: number, totalExVat: number, totalVat: number, total: number, taxInvoiceNumber: string, supplierAddress: { __typename?: 'BillingAddress', line1: string, line2: string | null, city: string, country: string, postcode: string }, vatSummary: Array<{ __typename?: 'GMSupplierOrderBreakdownVat', vatRate: number, quantity: number, total: number, totalExVat: number, totalVat: number }>, items: Array<{ __typename?: 'InvoiceItem', id: string, optionId: number | null, description: string, quantity: number, unitPrice: number, unitDiscount: number, vatRate: number, total: number, totalExVat: number, totalVat: number, isPromotionItem: boolean }> };

export type GetVendorStatementQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  appArea?: InputMaybe<AppArea>;
  withOrderBreakdownItems?: InputMaybe<Scalars['Boolean']['input']>;
  withCustomerBillingDetails?: InputMaybe<Scalars['Boolean']['input']>;
  withTaxInvoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  withOrderHref?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetVendorStatementQuery = { __typename?: 'Query', vendorStatement: { __typename?: 'VendorStatement', id: string, friendlyId: string, reseller: boolean | null, status: InvoiceStatus, paymentStatus: PaymentStatus, paidDate: any, issueDate: any | null, periodStart: any, periodEnd: any, currency: Currency, totalExVat: number, totalVat: number, total: number, vendorName: string, vendorLocationName: string, vendorLocationTimezone: string, isAlreadyApproved: boolean, canCancel: boolean, vatRegion: { __typename?: 'VatRegion', id: string, name: string, vatBands: Array<{ __typename?: 'VatBand', id: string, name: string, rate: number }> }, billingDetails: { __typename?: 'VendorStatementBillingDetails', contact: { __typename?: 'VendorStatementBillingContact', fullName: string, email: string }, address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, city: string, postcode: string, country: string } }, billingEntity: { __typename?: 'BillingEntity', code: string, name: string, address: string, email: string | null, vatNumber: string | null, companyNumber: string | null, tenantId: string | null }, serviceTotals: { __typename?: 'VendorStatementServiceTotals', ccTotal: number, gmTotal: number }, overviewPdf: { __typename?: 'Asset', url: string } | null, detailedPdf: { __typename?: 'Asset', url: string } | null, csv: { __typename?: 'Asset', url: string } | null, summary: Array<{ __typename?: 'VendorStatementSummaryItem', id: string, quantity: number, total: number, totalVat: number, totalExVat: number, vatRate: number, description: string, editible: boolean, subTotalExVat: number | null } | null>, feeSummary: { __typename?: 'VendorStatementFeeSummary', total: number, totalVat: number, totalExVat: number, items: Array<{ __typename?: 'VendorStatementSummaryItem', id: string, quantity: number, total: number, totalVat: number, totalExVat: number, vatRate: number, description: string } | null> }, serviceOrderBreakdown: { __typename?: 'VendorStatementServiceOrderBreakdown', CC: Array<{ __typename?: 'VendorStatementOrderBreakdownItem', date: any, orderId: number, friendlyOrderId: string, quantity: number, total: number, totalExVat: number, totalVat: number, discount: number, orderHref?: string | null, taxInvoiceId?: string, items?: Array<{ __typename?: 'InvoiceItem', id: string, description: string, total: number, totalExVat: number, totalVat: number, unitPrice: number, unitDiscount: number, quantity: number, vatRate: number, optionId: number | null, isPromotionItem: boolean }>, billingDetails?: { __typename?: 'BillingDetails', address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } } }>, GM: Array<{ __typename?: 'VendorStatementOrderBreakdownItem', date: any, orderId: number, friendlyOrderId: string, quantity: number, total: number, totalExVat: number, totalVat: number, discount: number, orderHref?: string | null, taxInvoiceId?: string, items?: Array<{ __typename?: 'InvoiceItem', id: string, description: string, total: number, totalExVat: number, totalVat: number, unitPrice: number, unitDiscount: number, quantity: number, vatRate: number, optionId: number | null, isPromotionItem: boolean }>, billingDetails?: { __typename?: 'BillingDetails', address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } } }> }, serviceOriginalOrderBreakdown: { __typename?: 'VendorStatementServiceOrderBreakdown', CC: Array<{ __typename?: 'VendorStatementOrderBreakdownItem', date: any, orderId: number, friendlyOrderId: string, quantity: number, total: number, totalExVat: number, totalVat: number, discount: number, orderHref?: string | null, taxInvoiceId?: string, items?: Array<{ __typename?: 'InvoiceItem', id: string, description: string, total: number, totalExVat: number, totalVat: number, unitPrice: number, unitDiscount: number, quantity: number, vatRate: number, optionId: number | null, isPromotionItem: boolean }>, billingDetails?: { __typename?: 'BillingDetails', address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } } }>, GM: Array<{ __typename?: 'VendorStatementOrderBreakdownItem', date: any, orderId: number, friendlyOrderId: string, quantity: number, total: number, totalExVat: number, totalVat: number, discount: number, orderHref?: string | null, taxInvoiceId?: string, items?: Array<{ __typename?: 'InvoiceItem', id: string, description: string, total: number, totalExVat: number, totalVat: number, unitPrice: number, unitDiscount: number, quantity: number, vatRate: number, optionId: number | null, isPromotionItem: boolean }>, billingDetails?: { __typename?: 'BillingDetails', address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } } }> }, commissions: Array<{ __typename?: 'VendorStatementCommission', id: string, description: string, total: number, totalExVat: number, totalVat: number, vatRate: number, editible: boolean, serviceType: string | null, commissionRate: number } | null> } };

export type VendorStatementSingleFragment = { __typename?: 'VendorStatement', id: string, friendlyId: string, reseller: boolean | null, status: InvoiceStatus, paymentStatus: PaymentStatus, paidDate: any, issueDate: any | null, periodStart: any, periodEnd: any, currency: Currency, totalExVat: number, totalVat: number, total: number, vendorName: string, vendorLocationName: string, vendorLocationTimezone: string, isAlreadyApproved: boolean, canCancel: boolean, vatRegion: { __typename?: 'VatRegion', id: string, name: string, vatBands: Array<{ __typename?: 'VatBand', id: string, name: string, rate: number }> }, billingDetails: { __typename?: 'VendorStatementBillingDetails', contact: { __typename?: 'VendorStatementBillingContact', fullName: string, email: string }, address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, city: string, postcode: string, country: string } }, billingEntity: { __typename?: 'BillingEntity', code: string, name: string, address: string, email: string | null, vatNumber: string | null, companyNumber: string | null, tenantId: string | null }, serviceTotals: { __typename?: 'VendorStatementServiceTotals', ccTotal: number, gmTotal: number }, overviewPdf: { __typename?: 'Asset', url: string } | null, detailedPdf: { __typename?: 'Asset', url: string } | null, csv: { __typename?: 'Asset', url: string } | null, summary: Array<{ __typename?: 'VendorStatementSummaryItem', id: string, quantity: number, total: number, totalVat: number, totalExVat: number, vatRate: number, description: string, editible: boolean, subTotalExVat: number | null } | null>, feeSummary: { __typename?: 'VendorStatementFeeSummary', total: number, totalVat: number, totalExVat: number, items: Array<{ __typename?: 'VendorStatementSummaryItem', id: string, quantity: number, total: number, totalVat: number, totalExVat: number, vatRate: number, description: string } | null> }, serviceOrderBreakdown: { __typename?: 'VendorStatementServiceOrderBreakdown', CC: Array<{ __typename?: 'VendorStatementOrderBreakdownItem', date: any, orderId: number, friendlyOrderId: string, quantity: number, total: number, totalExVat: number, totalVat: number, discount: number, orderHref?: string | null, taxInvoiceId?: string, items?: Array<{ __typename?: 'InvoiceItem', id: string, description: string, total: number, totalExVat: number, totalVat: number, unitPrice: number, unitDiscount: number, quantity: number, vatRate: number, optionId: number | null, isPromotionItem: boolean }>, billingDetails?: { __typename?: 'BillingDetails', address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } } }>, GM: Array<{ __typename?: 'VendorStatementOrderBreakdownItem', date: any, orderId: number, friendlyOrderId: string, quantity: number, total: number, totalExVat: number, totalVat: number, discount: number, orderHref?: string | null, taxInvoiceId?: string, items?: Array<{ __typename?: 'InvoiceItem', id: string, description: string, total: number, totalExVat: number, totalVat: number, unitPrice: number, unitDiscount: number, quantity: number, vatRate: number, optionId: number | null, isPromotionItem: boolean }>, billingDetails?: { __typename?: 'BillingDetails', address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } } }> }, serviceOriginalOrderBreakdown: { __typename?: 'VendorStatementServiceOrderBreakdown', CC: Array<{ __typename?: 'VendorStatementOrderBreakdownItem', date: any, orderId: number, friendlyOrderId: string, quantity: number, total: number, totalExVat: number, totalVat: number, discount: number, orderHref?: string | null, taxInvoiceId?: string, items?: Array<{ __typename?: 'InvoiceItem', id: string, description: string, total: number, totalExVat: number, totalVat: number, unitPrice: number, unitDiscount: number, quantity: number, vatRate: number, optionId: number | null, isPromotionItem: boolean }>, billingDetails?: { __typename?: 'BillingDetails', address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } } }>, GM: Array<{ __typename?: 'VendorStatementOrderBreakdownItem', date: any, orderId: number, friendlyOrderId: string, quantity: number, total: number, totalExVat: number, totalVat: number, discount: number, orderHref?: string | null, taxInvoiceId?: string, items?: Array<{ __typename?: 'InvoiceItem', id: string, description: string, total: number, totalExVat: number, totalVat: number, unitPrice: number, unitDiscount: number, quantity: number, vatRate: number, optionId: number | null, isPromotionItem: boolean }>, billingDetails?: { __typename?: 'BillingDetails', address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } } }> }, commissions: Array<{ __typename?: 'VendorStatementCommission', id: string, description: string, total: number, totalExVat: number, totalVat: number, vatRate: number, editible: boolean, serviceType: string | null, commissionRate: number } | null> };

export type ServiceOrderBreakdownItemFragment = { __typename?: 'VendorStatementOrderBreakdownItem', date: any, orderId: number, friendlyOrderId: string, quantity: number, total: number, totalExVat: number, totalVat: number, discount: number, orderHref?: string | null, taxInvoiceId?: string, billingDetails?: { __typename?: 'BillingDetails', address: { __typename?: 'BillingAddress', alias: string, line1: string, line2: string | null, postcode: string, city: string, country: string } } };

export type AddVendorStatementItemMutationVariables = Exact<{
  vendorStatementId: Scalars['ID']['input'];
  input: InvoiceItemInput;
}>;


export type AddVendorStatementItemMutation = { __typename?: 'Mutation', addVendorStatementItem: { __typename?: 'InvoiceItem', date: any, description: string, quantity: number, unitPrice: number, vatRate: number } };

export type RemoveVendorStatementItemMutationVariables = Exact<{
  itemId: Scalars['ID']['input'];
}>;


export type RemoveVendorStatementItemMutation = { __typename?: 'Mutation', removeVendorStatementItem: string };

export type AuthQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, isAdmin: boolean, isUser: boolean, isVendor: boolean, role: UserRole | null, account: { __typename?: 'Account', id: string } | null } };

export type GetFinanceSettingsForAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetFinanceSettingsForAccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', isCCActive: boolean, currency: Currency, financeSettings: { __typename?: 'AccountFinanceSettings', allowMinTopUpCc: boolean, budgetCodeCc: string | null, budgetCodeGm: string | null, contractDateFrom: any | null, contractDateTo: any | null, deliverySurchargeCc: number | null, invoicingFormatGm: GmInvoicingFormat, minOrderValueCc: number | null, minPlatformFeeCc: number | null, minPlatformFeeGm: number | null, orderValPercentPlatformFeeCc: number | null, orderValPercentPlatformFeeGm: number | null, paymentDueDaysAfterInvoice: number | null, isBudgetCodeMandatory: boolean | null, additionalBillingNotes: string | null, minPlatformFeeCcMonthlyExTax: number } } };

export type AccountDashboardCalendarGmBasketFragment = { __typename?: 'GmBasket', id: string, customName: string | null, user: { __typename?: 'User', id: string, fullName: string } | null, vendor: { __typename?: 'Vendor', permalink: string | null, companyName: string, logo: string | null, keywords: string | null, currency: Currency | null }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number }, settings: { __typename?: 'GmServiceSettings', deliveryDate: string, deliveryTimeSlot: string, location:
      | { __typename?: 'AccountLocation', id: string }
      | { __typename?: 'Address' }
      | { __typename?: 'NewAccountLocation' }
     | null } };

export type GetGmBasketsForAccountDashboardCalendarQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  filters: InputMaybe<GmBasketFiltersInput>;
}>;


export type GetGmBasketsForAccountDashboardCalendarQuery = { __typename?: 'Query', me: { __typename?: 'User', account: { __typename?: 'Account', gmBaskets: { __typename?: 'GmBasketPaged', rows: Array<{ __typename?: 'GmBasket', id: string, customName: string | null, user: { __typename?: 'User', id: string, fullName: string } | null, vendor: { __typename?: 'Vendor', permalink: string | null, companyName: string, logo: string | null, keywords: string | null, currency: Currency | null }, basketTotalBreakdown: { __typename?: 'GmOrderTaxBreakdown', totalIncTax: number }, settings: { __typename?: 'GmServiceSettings', deliveryDate: string, deliveryTimeSlot: string, location:
              | { __typename?: 'AccountLocation', id: string }
              | { __typename?: 'Address' }
              | { __typename?: 'NewAccountLocation' }
             | null } }>, pageInfo: { __typename?: 'PageInfo', count: number } } } | null } };

export type SupplierDraftMenuItemsOrOptionsQueryVariables = Exact<{
  supplierId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  filters: InputMaybe<MenuItemFiltersInput>;
  getItems: Scalars['Boolean']['input'];
}>;


export type SupplierDraftMenuItemsOrOptionsQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', id: string, options?: { __typename?: 'MenuItemsPaged', pageInfo: { __typename?: 'PageInfo', limit: number, offset: number, count: number, hasMore: boolean }, items: Array<{ __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, inReview: boolean | null, publishedTimestamp: any | null, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null }> | null }> | null }, items?: { __typename?: 'MenuItemsPaged', pageInfo: { __typename?: 'PageInfo', limit: number, offset: number, count: number, hasMore: boolean }, items: Array<{ __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, inReview: boolean | null, publishedTimestamp: any | null, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, position: number | null, minQty: number | null, optionType: MenuItemOptionType | null, name: string | null, items: Array<{ __typename?: 'OptionItem', _id: string, position: number | null, price: number | null, priceExTax: number | null, legacyItemId: number | null, item: { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, inReview: boolean | null, publishedTimestamp: any | null, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null }> | null } | null } | null> | null } | null> | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null }> | null }> | null } } };

export type DietariesFragment = { __typename?: 'MenuItem', dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null };

export type AllergensFragment = { __typename?: 'MenuItem', allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null };

export type MacrosFragment = { __typename?: 'MenuItem', macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null };

export type DraftMenuItemFieldsFragment = { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, inReview: boolean | null, publishedTimestamp: any | null, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null }> | null };

export type SupplierLiveMenuItemsQueryVariables = Exact<{
  supplierId: Scalars['ID']['input'];
  itemsLimit: InputMaybe<Scalars['Int']['input']>;
  itemsOffset: InputMaybe<Scalars['Int']['input']>;
  optionsLimit: InputMaybe<Scalars['Int']['input']>;
  optionsOffset: InputMaybe<Scalars['Int']['input']>;
  filters: InputMaybe<MenuItemFiltersInput>;
}>;


export type SupplierLiveMenuItemsQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', id: string, liveMenuOptions: { __typename?: 'MenuItemsPaged', pageInfo: { __typename?: 'PageInfo', limit: number, offset: number, count: number, hasMore: boolean }, items: Array<{ __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, name: string | null, optionType: MenuItemOptionType | null, position: number | null, maxQty: number | null, minQty: number | null, qtyPerPerson: number | null, items: Array<{ __typename?: 'OptionItem', _id: string, position: number | null, price: number | null, priceExTax: number | null, legacyItemId: number | null, item: { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null } | null } | null> | null } | null> | null }> | null }, liveMenuItems: { __typename?: 'MenuItemsPaged', pageInfo: { __typename?: 'PageInfo', limit: number, offset: number, count: number, hasMore: boolean }, items: Array<{ __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, name: string | null, optionType: MenuItemOptionType | null, position: number | null, maxQty: number | null, minQty: number | null, qtyPerPerson: number | null, items: Array<{ __typename?: 'OptionItem', _id: string, position: number | null, price: number | null, priceExTax: number | null, legacyItemId: number | null, item: { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null } | null } | null> | null } | null> | null }> | null } } };

export type SupplierLiveMenuItemsOrOptionsQueryVariables = Exact<{
  supplierId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  filters: InputMaybe<MenuItemFiltersInput>;
  language: InputMaybe<Language>;
  getItems: Scalars['Boolean']['input'];
  getGroups: Scalars['Boolean']['input'];
}>;


export type SupplierLiveMenuItemsOrOptionsQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', id: string, options?: { __typename?: 'MenuItemsPaged', pageInfo: { __typename?: 'PageInfo', limit: number, offset: number, count: number, hasMore: boolean }, items: Array<{ __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, name: string | null, optionType: MenuItemOptionType | null, position: number | null, maxQty: number | null, minQty: number | null, qtyPerPerson: number | null, items: Array<{ __typename?: 'OptionItem', _id: string, position: number | null, price: number | null, priceExTax: number | null, legacyItemId: number | null, item: { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null } | null } | null> | null } | null> | null }> | null }, items?: { __typename?: 'MenuItemsPaged', pageInfo: { __typename?: 'PageInfo', limit: number, offset: number, count: number, hasMore: boolean }, items: Array<{ __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, name: string | null, optionType: MenuItemOptionType | null, position: number | null, maxQty: number | null, minQty: number | null, qtyPerPerson: number | null, items: Array<{ __typename?: 'OptionItem', _id: string, position: number | null, price: number | null, priceExTax: number | null, legacyItemId: number | null, item: { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null } | null } | null> | null } | null> | null }> | null }, menuItemGroups?: { __typename?: 'MenuItemGroupsPaged', pageInfo: { __typename?: 'PageInfo', count: number }, groups: Array<{ __typename?: 'MenuItemGroup', id: string, name: string }> } } };

export type SupplierLiveMenuItemBasicFragment = { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null };

export type SupplierLiveMenuItemOptionOnlyFragment = { __typename?: 'MenuItem', options: Array<{ __typename?: 'MenuItemOptions', _id: string, name: string | null, optionType: MenuItemOptionType | null, position: number | null, maxQty: number | null, minQty: number | null, qtyPerPerson: number | null, items: Array<{ __typename?: 'OptionItem', _id: string, position: number | null, price: number | null, priceExTax: number | null, legacyItemId: number | null, item: { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null } | null } | null> | null } | null> | null };

export type SupplierLiveMenuItemFragment = { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, name: string | null, optionType: MenuItemOptionType | null, position: number | null, maxQty: number | null, minQty: number | null, qtyPerPerson: number | null, items: Array<{ __typename?: 'OptionItem', _id: string, position: number | null, price: number | null, priceExTax: number | null, legacyItemId: number | null, item: { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null } | null } | null> | null } | null> | null };

export type SupplierLiveMenuMoreItemFragment = { __typename?: 'MenuItem', _id: string, deleted: boolean | null, isActive: boolean | null, legacyId: number | null, migratedAt: any | null, description: string | null, shortDescription: string | null, image: string | null, ingredients: string | null, isHot: boolean | null, isVAT: boolean | null, name: string | null, price: number | null, priceExTax: number | null, supplierId: number, deletedAt: any | null, isMenuItem: boolean | null, isOption: boolean | null, mealTag: string | null, cuisineTag: string | null, alacalcFetchedAt: any | null, alacalcId: number | null, vatBandId: number | null, updatedAt: any, locked: boolean | null, lockedTimestamp: any | null, unlockedTimestamp: any | null, sentForApprovalTimestamp: any | null, requestDeleteTimestamp: any | null, requestToDelete: boolean | null, publishedTimestamp: any | null, dietary_vegan: boolean | null, dietary_vegetarian: boolean | null, dietary_kosher: boolean | null, dietary_halal: boolean | null, dietary_powerplant: boolean | null, dietary_lowcarb: boolean | null, dietary_highprotein: boolean | null, allergen_cereals: boolean | null, allergen_crustaceans: boolean | null, allergen_fish: boolean | null, allergen_peanuts: boolean | null, allergen_soybeans: boolean | null, allergen_milk: boolean | null, allergen_nuts: boolean | null, allergen_celery: boolean | null, allergen_mustard: boolean | null, allergen_sesame: boolean | null, allergen_sulphur: boolean | null, allergen_lupin: boolean | null, allergen_molluscs: boolean | null, allergen_eggs: boolean | null, allergen_none: boolean | null, macros_carbs: number | null, macros_fat: number | null, macros_fibre: number | null, macros_kcal: number | null, macros_kj: number | null, macros_protein: number | null, macros_salt: number | null, macros_saturates: number | null, macros_sugar: number | null, options: Array<{ __typename?: 'MenuItemOptions', _id: string, name: string | null, optionType: MenuItemOptionType | null, position: number | null, maxQty: number | null, minQty: number | null, qtyPerPerson: number | null, items: Array<{ __typename?: 'OptionItem', _id: string, position: number | null, price: number | null, priceExTax: number | null, item: { __typename?: 'MenuItem', _id: string, name: string | null, price: number | null, priceExTax: number | null, variations: Array<{ __typename?: 'MenuItemVariation', varType: string | null }> | null } | null } | null> | null } | null> | null, associatedStandingOrders: { __typename?: 'StandingOrdersPage', pageInfo: { __typename?: 'PageInfo', count: number }, standingOrders: Array<{ __typename?: 'StandingOrder', _id: string, activeUntil: any | null }> | null }, translations: Array<{ __typename?: 'Translation', key: string, value: string, language: Language }> | null, variations: Array<{ __typename?: 'MenuItemVariation', _id: string, varType: string | null, discountPrice: number | null, feedrDiscountPrice: number | null, name: string | null, internalName: string | null, price: number | null, priceExTax: number | null, isActive: boolean | null, type: string | null, orderLimit: number | null, dailyStock: number | null, isPromo: boolean | null, isCombo: boolean | null, avgRating: number | null, isBreakfast: boolean | null, isLunch: boolean | null, isDinner: boolean | null, isSampleBreakfast: boolean | null, isSampleLunch: boolean | null, isSampleDinner: boolean | null, categoryId: number | null, categoryIdArray: Array<number> | null, isPricePerHead: boolean | null, servings: number | null, minQty: number | null, position: number | null, packaging: GmItemPackaging | null, popularity: number }> | null };

export type UpdateFinanceSettingsForAccountMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  input: UpdateAccountFinanceSettingsInput;
}>;


export type UpdateFinanceSettingsForAccountMutation = { __typename?: 'Mutation', updateAccountFinanceSettings: { __typename?: 'AccountFinanceSettings', allowMinTopUpCc: boolean, budgetCodeCc: string | null, budgetCodeGm: string | null, contractDateFrom: any | null, contractDateTo: any | null, deliverySurchargeCc: number | null, invoicingFormatGm: GmInvoicingFormat, minOrderValueCc: number | null, minPlatformFeeCc: number | null, minPlatformFeeGm: number | null, orderValPercentPlatformFeeCc: number | null, orderValPercentPlatformFeeGm: number | null, paymentDueDaysAfterInvoice: number | null } };

export type VatBandsForVendorQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
}>;


export type VatBandsForVendorQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', financeSettings: { __typename?: 'VendorFinanceSettings', vatRegion: { __typename?: 'VatRegion', legacyId: number, vatBands: Array<{ __typename?: 'VatBand', id: string, legacyId: number | null, name: string, rate: number, menuItemEligible: boolean, invoiceItemEligible: boolean }> } } } };

export type VpAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type VpAuthQuery = { __typename?: 'Query', me: { __typename?: 'User', email: string, isVendor: boolean, isAdmin: boolean, role: UserRole | null, id: string, firstName: string, lastName: string, vendor: { __typename?: 'Vendor', id: string, currency: Currency | null } | null } };

export type GetAllSupportedTimezonesCitiesAndCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSupportedTimezonesCitiesAndCountriesQuery = { __typename?: 'Query', timezones: Array<{ __typename?: 'Timezone', code: string, countryCode: CountryCode, label: string }>, countries: Array<{ __typename?: 'Country', code: CountryCode, name: string, currency: Currency, languages: Array<Language> }>, cities: Array<{ __typename?: 'City', code: string, name: string, countryCode: CountryCode }> };

export type VendorLocationCountriesQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
}>;


export type VendorLocationCountriesQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', locations: Array<{ __typename?: 'VendorLocation', country: string | null }> } };

export type PageInitQueryVariables = Exact<{ [key: string]: never; }>;


export type PageInitQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, role: UserRole | null, isAdmin: boolean, isVendor: boolean, isUser: boolean, intercomUserHash: string, privacyAccepted: string | null, teamId: number | null, legacyAdminId: number | null, fullName: string, invoiceApproved: boolean, account: { __typename?: 'Account', id: string, name: string, isCCActive: boolean, isGMActive: boolean } | null, accountLocation: { __typename?: 'AccountLocation', id: string } | null, languageSettings: { __typename?: 'UserLanguageSettings', locale: string }, vendor: { __typename?: 'Vendor', companyName: string, id: string } | null }, ghosterUser: { __typename?: 'User', id: string } | null };

export type SyncMenuItemPricesMutationVariables = Exact<{
  input: SyncMenuItemPricesInput;
}>;


export type SyncMenuItemPricesMutation = { __typename?: 'Mutation', syncMenuItemPrices: { __typename?: 'SyncMenuItemPricesResponse', syncJobId: string } };

export type GetMenuItemPriceSyncStatusQueryVariables = Exact<{
  input: MenuItemPriceSyncStatusInput;
}>;


export type GetMenuItemPriceSyncStatusQuery = { __typename?: 'Query', menuItemPriceSyncStatus: { __typename?: 'MenuItemPriceSyncStatusResponse', status: string, syncJobId: string, batchesCompleted: number, estimatedItemsCompleted: number, startTime: any | null, finishTime: any | null } };

export type GetCustomerFlexInvoiceCsvQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  invoiceType: FlexInvoiceType;
}>;


export type GetCustomerFlexInvoiceCsvQuery = { __typename?: 'Query', customerFlexInvoiceCSV: string };

export type ListInvoicesQueryVariables = Exact<{
  input: InputMaybe<ListInvoicesInput>;
}>;


export type ListInvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoicesPaged', items: Array<
      | { __typename?: 'CCInvoice', id: string, type: InvoiceType, friendlyId: string, status: InvoiceStatus, paymentStatus: PaymentStatus, dueDate: any, issueDate: any | null, periodStart: any, periodEnd: any, currency: Currency, total: number, account: { __typename?: 'CCAccount', name: string }, accountLocation: { __typename?: 'CCAccountLocation', timezone: string, address: { __typename?: 'BillingAddress', alias: string } }, billingDetails: { __typename?: 'BillingDetails', contact: { __typename?: 'BillingContact', firstName: string, lastName: string }, address: { __typename?: 'BillingAddress', alias: string } } }
      | { __typename?: 'GMInvoice', isInvoiceAccount: boolean, id: string, type: InvoiceType, friendlyId: string, status: InvoiceStatus, paymentStatus: PaymentStatus, dueDate: any, issueDate: any | null, periodStart: any, periodEnd: any, currency: Currency, total: number, account: { __typename?: 'GMAccount', name: string }, accountLocation: { __typename?: 'GMAccountLocation', timezone: string, address: { __typename?: 'BillingAddress', alias: string } }, billingDetails: { __typename?: 'BillingDetails', contact: { __typename?: 'BillingContact', firstName: string, lastName: string }, address: { __typename?: 'BillingAddress', alias: string } } }
    >, pageInfo: { __typename?: 'PageInfo', count: number, limit: number, offset: number } } };

export type ListInvoicesWithFlexQueryVariables = Exact<{
  input: InputMaybe<ListInvoicesInput>;
  accountId: Scalars['Int']['input'];
  deferredCustomerIds: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ListInvoicesWithFlexQuery = { __typename?: 'Query', invoicesCombined: { __typename?: 'InvoicesCombinedPaged', items: Array<
      | { __typename?: 'CCInvoice', id: string, type: InvoiceType, friendlyId: string, status: InvoiceStatus, paymentStatus: PaymentStatus, dueDate: any, issueDate: any | null, periodStart: any, periodEnd: any, currency: Currency, total: number, account: { __typename?: 'CCAccount', name: string }, accountLocation: { __typename?: 'CCAccountLocation', timezone: string, address: { __typename?: 'BillingAddress', alias: string } }, billingDetails: { __typename?: 'BillingDetails', contact: { __typename?: 'BillingContact', firstName: string, lastName: string }, address: { __typename?: 'BillingAddress', alias: string } } }
      | { __typename?: 'FlexInvoice' }
      | { __typename?: 'FlexInvoiceAllTypes', id: string, invoiceType: FlexInvoiceType | null, number: string, createdAt: any, accountName: string, entityName: string, dueDate: any, csv: string | null, timezone: string | null, location: string | null, country: string | null, instant: boolean | null, flexTotal: string, flexStatus: FlexInvoiceStatus | null, assets: Array<{ __typename?: 'FlexInvoiceAsset', type: string, link: string }> | null }
      | { __typename?: 'GMInvoice', isInvoiceAccount: boolean, id: string, type: InvoiceType, friendlyId: string, status: InvoiceStatus, paymentStatus: PaymentStatus, dueDate: any, issueDate: any | null, periodStart: any, periodEnd: any, currency: Currency, total: number, account: { __typename?: 'GMAccount', name: string }, accountLocation: { __typename?: 'GMAccountLocation', timezone: string, address: { __typename?: 'BillingAddress', alias: string } }, billingDetails: { __typename?: 'BillingDetails', contact: { __typename?: 'BillingContact', firstName: string, lastName: string }, address: { __typename?: 'BillingAddress', alias: string } } }
    >, pageInfo: { __typename?: 'PageInfo', count: number, limit: number, offset: number } } };

export type ListInvoicesInvoiceCcFragment = { __typename?: 'CCInvoice', id: string, type: InvoiceType, friendlyId: string, status: InvoiceStatus, paymentStatus: PaymentStatus, dueDate: any, issueDate: any | null, periodStart: any, periodEnd: any, currency: Currency, total: number, account: { __typename?: 'CCAccount', name: string }, accountLocation: { __typename?: 'CCAccountLocation', timezone: string, address: { __typename?: 'BillingAddress', alias: string } }, billingDetails: { __typename?: 'BillingDetails', contact: { __typename?: 'BillingContact', firstName: string, lastName: string }, address: { __typename?: 'BillingAddress', alias: string } } };

export type ListInvoicesInvoiceGmFragment = { __typename?: 'GMInvoice', isInvoiceAccount: boolean, id: string, type: InvoiceType, friendlyId: string, status: InvoiceStatus, paymentStatus: PaymentStatus, dueDate: any, issueDate: any | null, periodStart: any, periodEnd: any, currency: Currency, total: number, account: { __typename?: 'GMAccount', name: string }, accountLocation: { __typename?: 'GMAccountLocation', timezone: string, address: { __typename?: 'BillingAddress', alias: string } }, billingDetails: { __typename?: 'BillingDetails', contact: { __typename?: 'BillingContact', firstName: string, lastName: string }, address: { __typename?: 'BillingAddress', alias: string } } };

export type ListInvoicesInvoiceFlexAllTypesFragment = { __typename?: 'FlexInvoiceAllTypes', id: string, invoiceType: FlexInvoiceType | null, number: string, createdAt: any, accountName: string, entityName: string, dueDate: any, csv: string | null, timezone: string | null, location: string | null, country: string | null, instant: boolean | null, flexTotal: string, flexStatus: FlexInvoiceStatus | null, assets: Array<{ __typename?: 'FlexInvoiceAsset', type: string, link: string }> | null };

export type ListVendorStatementsQueryVariables = Exact<{
  input: InputMaybe<ListVendorStatementsInput>;
}>;


export type ListVendorStatementsQuery = { __typename?: 'Query', vendorStatements: { __typename?: 'VendorStatementsPaged', items: Array<{ __typename?: 'VendorStatement', id: string, friendlyId: string, reseller: boolean | null, status: InvoiceStatus, paymentStatus: PaymentStatus, paidDate: any, issueDate: any | null, periodStart: any, periodEnd: any, currency: Currency, total: number, vendorName: string, vendorLocationName: string, vendorLocationTimezone: string, serviceTotals: { __typename?: 'VendorStatementServiceTotals', ccTotal: number, gmTotal: number } }>, pageInfo: { __typename?: 'PageInfo', count: number, limit: number, offset: number } } };

export type ListVendorStatementsWithFlexQueryVariables = Exact<{
  input: InputMaybe<ListVendorStatementsInput>;
  countryCode: Scalars['String']['input'];
  deferredSupplierId: InputMaybe<Scalars['String']['input']>;
}>;


export type ListVendorStatementsWithFlexQuery = { __typename?: 'Query', vendorStatementsCombined: { __typename?: 'VendorStatementsCombinedPaged', items: Array<
      | { __typename?: 'VendorFlexInvoice' }
      | { __typename?: 'VendorFlexInvoiceAllTypes', id: string, invoiceType: FlexInvoiceType | null, number: string, createdAt: any, accountName: string, entityName: string, dueDate: any, csv: string | null, timezone: string | null, location: string | null, vendorId: string | null, flexTotal: string, flexStatus: string, assets: Array<{ __typename?: 'FlexInvoiceAsset', type: string, link: string }> | null }
      | { __typename?: 'VendorStatement', id: string, friendlyId: string, reseller: boolean | null, status: InvoiceStatus, paymentStatus: PaymentStatus, paidDate: any, issueDate: any | null, periodStart: any, periodEnd: any, currency: Currency, total: number, vendorName: string, vendorLocationName: string, vendorLocationTimezone: string, serviceTotals: { __typename?: 'VendorStatementServiceTotals', ccTotal: number, gmTotal: number } }
    >, pageInfo: { __typename?: 'PageInfo', count: number, limit: number, offset: number } } };

export type ListVendorStatementsItemsFragment = { __typename?: 'VendorStatement', id: string, friendlyId: string, reseller: boolean | null, status: InvoiceStatus, paymentStatus: PaymentStatus, paidDate: any, issueDate: any | null, periodStart: any, periodEnd: any, currency: Currency, total: number, vendorName: string, vendorLocationName: string, vendorLocationTimezone: string, serviceTotals: { __typename?: 'VendorStatementServiceTotals', ccTotal: number, gmTotal: number } };

export type ListVendorFlexInvoiceAllTypesItemsFragment = { __typename?: 'VendorFlexInvoiceAllTypes', id: string, invoiceType: FlexInvoiceType | null, number: string, createdAt: any, accountName: string, entityName: string, dueDate: any, csv: string | null, timezone: string | null, location: string | null, vendorId: string | null, flexTotal: string, flexStatus: string, assets: Array<{ __typename?: 'FlexInvoiceAsset', type: string, link: string }> | null };

export type InitiatePaymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InitiatePaymentMutation = { __typename?: 'Mutation', initiateInvoiceCardPayment: { __typename?: 'InitiateInvoiceCardPaymentResult', authToken: any } };

export type LineItemFragment = { __typename?: 'LineItem', name: any, amount: number };

export type PaymentCardFragment = { __typename?: 'PaymentCard', stripeId: string, brand: any, lastFourDigits: any };

export type PaymentFragment = { __typename?: 'Payment', id: string, descriptions: Array<any>, total: any, currency: Currency, successRedirectUrl: any, stripePublishableKey: any, lineItems: Array<{ __typename?: 'LineItem', name: any, amount: number }>, user: { __typename?: 'User', id: string } };

export type GetPaymentQueryVariables = Exact<{
  authToken: Scalars['JWT']['input'];
}>;


export type GetPaymentQuery = { __typename?: 'Query', payment: { __typename?: 'Payment', id: string, descriptions: Array<any>, total: any, currency: Currency, successRedirectUrl: any, stripePublishableKey: any, lineItems: Array<{ __typename?: 'LineItem', name: any, amount: number }>, user: { __typename?: 'User', id: string } }, paymentAuthToken: { __typename?: 'PaymentAuthToken', expiryTimestamp: any } };

export type StartPaymentMutationVariables = Exact<{
  input: StartPaymentInput;
}>;


export type StartPaymentMutation = { __typename?: 'Mutation', startPayment: { __typename?: 'StartPaymentResult', stripeClientSecret: any, customerId: any, ephemeralKey: any | null } };

export type AllVendorsQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  tenantId: InputMaybe<Scalars['String']['input']>;
}>;


export type AllVendorsQuery = { __typename?: 'Query', vendors: { __typename?: 'VendorsPaged', rows: Array<{ __typename?: 'Vendor', id: string, permalink: string | null, locations: Array<{ __typename?: 'VendorLocation', country: string | null }> }>, pageInfo: { __typename?: 'PageInfo', count: number } } };

export type GetVendorPermalinkByIdQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
}>;


export type GetVendorPermalinkByIdQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', permalink: string | null, locations: Array<{ __typename?: 'VendorLocation', country: string | null }> } };

export type GetVendorPermalinkByPermalinkQueryVariables = Exact<{
  permalink: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;


export type GetVendorPermalinkByPermalinkQuery = { __typename?: 'Query', vendorByPermalink: { __typename?: 'Vendor', permalink: string | null, locations: Array<{ __typename?: 'VendorLocation', country: string | null }> } | null };

export const TenantFromPrebuildFragmentDoc = gql`
    fragment TenantFromPrebuild on Tenant {
  id
  name
  domain
  countries
  isSingleVendor
  marketing {
    pages {
      shouldIndex
      rootUrl
      regions {
        code
        url
      }
    }
    sitemaps {
      name
      url
      forceReplaceHostname
    }
    links {
      countryCode
      requestAQuote
      terms
      privacy
    }
    logos {
      default
      white
      rainbow
      favicon
      loadingIndicator
    }
    navLinks {
      title
      href
      subLinks {
        title
        href
        type
        description
        links {
          title
          href
          ssgPage
        }
        sameTab
        ssgPage
      }
    }
    theme {
      palette {
        primary {
          light
          main
          dark
          contrastText
        }
        secondary {
          light
          main
          dark
          contrastText
        }
        success {
          light
          main
          dark
          contrastText
        }
        warning {
          light
          main
          dark
          contrastText
        }
        info {
          light
          main
          dark
          contrastText
        }
        error {
          light
          main
          dark
          contrastText
        }
        inverted {
          light
          main
          dark
          contrastText
        }
        text {
          primary
          secondary
          disabled
        }
        background {
          default
          paper
        }
        common {
          black
          white
        }
      }
    }
    assets {
      placeholder
      authBackgroundImage
      marketplaceHeaderImages
      orderConfirmationImage
    }
  }
  cognitoConfiguration {
    userPoolDomain
    userPoolId
    userPoolClientId
  }
  contact {
    regions {
      countryCode
      email {
        default
        sales
        support
        vendors
      }
      phone {
        default
        sales
        support
        vendors
      }
    }
  }
  integrations {
    oneTrust {
      id
    }
    hotjar {
      regions {
        id
        countryCode
      }
    }
    linkedIn {
      pid
    }
    segment {
      clientWriteKey
    }
    posthog {
      apiKey
      apiHost
    }
    zendesk {
      regions {
        id
        countryCode
      }
    }
    intercom {
      regions {
        id
        countryCode
      }
    }
    googleTagManager {
      containerId
    }
    flexInvoicingClients {
      clientId
      shortCode
      countryCode
    }
    bingAds {
      tagId
    }
  }
  flexInvoicingFlags {
    countryCode
    enabled
  }
  billingEntities(input: {}) {
    id
    countryCode
    code
    email
    phone
  }
  mobileApp {
    bundleId
  }
  uriRestrictedAccessRules {
    uri
    redirectUri
  }
  features {
    canCancelCateringInvoiceOrders
    calendarTopPicks {
      visibility
    }
    charityMeals {
      visibility {
        regions
      }
    }
    cateringAllergenTooltip {
      visibility
    }
    serviceOptions {
      visibility
      staffServices {
        visibility
      }
      cutleryExtras {
        visibility
      }
    }
    emma {
      visibility
      defaultSupplierId
      showSubscribeToUpdatesCheckbox
    }
    vendorHelpCentre {
      link
    }
    cateringCoupons {
      visibility
    }
    cateringFilters {
      allergens
      dietary
    }
    printLabels {
      CC {
        VPDymo
        VPA4
        VPPackage
        VPSummary
      }
      GM {
        VPDymo
        VPA4
        VPPackage
        VPSummary
      }
    }
    prerenderMarketplaceMenu {
      permalinks
    }
    gmExpressCheckout {
      visibility
    }
    gmShowFullAddress {
      visibility {
        regions
      }
    }
    gmHideDeliveryWindow {
      visibility
    }
    ccShowTimeslotWindow {
      visibility
    }
    gmDeliveryTimeslots {
      start
      end
    }
    ccTopupAmounts {
      minimumTopup
      topupValues
    }
    menuItemAllergenAudit {
      enabled
    }
    cateringTeamOrder {
      visibility {
        regions
      }
    }
  }
  contentSecurityPolicy {
    mediaSrc
    fontSrc
    styleSrc
    scriptSrc
    imgSrc
    connectSrc
    frameSrc
  }
  defaultLocale
  transportTypes {
    regions {
      countryCode
      types {
        name
        value
      }
    }
  }
  guestAccountData {
    id
    guestInvoiceAccountId
  }
  permissions {
    guestCheckoutByInvoiceAccountGm
    allowUserSignIn
    allowCreditCardPayments
    allowTransferPayments
    autoPopulatePlacedBy
  }
  vercelProjectId
  clientVercelProjectId
  payments {
    chargeCreditCardFee
  }
}
    `;
export const DietariesFragmentDoc = gql`
    fragment Dietaries on MenuItem {
  dietary_vegan
  dietary_vegetarian
  dietary_kosher
  dietary_halal
  dietary_powerplant
  dietary_lowcarb
  dietary_highprotein
}
    `;
export const AllergensFragmentDoc = gql`
    fragment Allergens on MenuItem {
  allergen_cereals
  allergen_crustaceans
  allergen_fish
  allergen_peanuts
  allergen_soybeans
  allergen_milk
  allergen_nuts
  allergen_celery
  allergen_mustard
  allergen_sesame
  allergen_sulphur
  allergen_lupin
  allergen_molluscs
  allergen_eggs
  allergen_none
}
    `;
export const MacrosFragmentDoc = gql`
    fragment Macros on MenuItem {
  macros_carbs
  macros_fat
  macros_fibre
  macros_kcal
  macros_kj
  macros_protein
  macros_salt
  macros_saturates
  macros_sugar
}
    `;
export const CcSubmenu_VariationDataFragmentDoc = gql`
    fragment CcSubmenu_VariationData on MenuItemVariation {
  _id
  varType
  discountPrice
  feedrDiscountPrice
  name
  internalName
  price
  priceExTax
  isActive
  type
  orderLimit
  dailyStock
  isPromo
  isCombo
  avgRating
  isBreakfast
  isLunch
  isDinner
  isSampleBreakfast
  isSampleLunch
  isSampleDinner
}
    `;
export const CcSubmenu_SupplierLiveMenuItemFragmentDoc = gql`
    fragment CcSubmenu_SupplierLiveMenuItem on MenuItem {
  _id
  ...Dietaries
  ...Allergens
  ...Macros
  deleted
  isActive
  legacyId
  migratedAt
  description
  shortDescription
  image
  ingredients
  isHot
  isVAT
  name
  price
  priceExTax
  supplierId
  deletedAt
  isMenuItem
  isOption
  mealTag
  cuisineTag
  alacalcFetchedAt
  alacalcId
  vatBandId
  updatedAt
  locked
  lockedTimestamp
  unlockedTimestamp
  sentForApprovalTimestamp
  requestDeleteTimestamp
  requestToDelete
  publishedTimestamp
  activeTo
  activeFrom
  translations {
    key
    value
    language
  }
  variations(varType: "cc") {
    ...CcSubmenu_VariationData
  }
}
    ${DietariesFragmentDoc}
${AllergensFragmentDoc}
${MacrosFragmentDoc}
${CcSubmenu_VariationDataFragmentDoc}`;
export const CcSubmenu_ItemDataFragmentDoc = gql`
    fragment CcSubmenu_ItemData on CCSubmenuItem {
  ccVariationId
  itemCoreId
  deletedCoreItem {
    _id
    item {
      ...CcSubmenu_SupplierLiveMenuItem
    }
  }
}
    ${CcSubmenu_SupplierLiveMenuItemFragmentDoc}`;
export const CustomerOrdersAllTypeTableFragmentDoc = gql`
    fragment CustomerOrdersAllTypeTable on CustomerOrdersAllType {
  orderNumber
  supplierName
  deliveryAddress
  deliveryDate
  contact
  subTotal
  total
  orderType
  serviceType
}
    `;
export const UserAllergensFragmentDoc = gql`
    fragment UserAllergens on UserAllergens {
  celery
  cereals
  crustaceans
  eggs
  fish
  lupin
  milk
  molluscs
  mustard
  nuts
  peanuts
  sesame
  soybeans
  sulphur
}
    `;
export const UserDietaryPreferencesFragmentDoc = gql`
    fragment UserDietaryPreferences on UserDietaryPreferences {
  vegan
  vegetarian
  halal
  kosher
  noRefinedSugar: refinedSugar
}
    `;
export const UserContactPreferencesFragmentDoc = gql`
    fragment UserContactPreferences on UserContactPreferences {
  notificationPreference
  remindersDeliveries
  remindersSubsidised
  remindersUnsubsidised
  remindersWeekly
  isAccountPrimaryContact
}
    `;
export const CcSubsidyFieldsFragmentDoc = gql`
    fragment CcSubsidyFields on CCSubsidy {
  id
  teamId
  accountLocationId
  meal
  subsidy
  type
  weekday
}
    `;
export const CcMealServiceForConfirmationFragmentDoc = gql`
    fragment CCMealServiceForConfirmation on CCMealService {
  meal
  menuIsPublished
  openTime
  closeTime
  orderedItems {
    orderPlaced
  }
  timeslots {
    vendorMenus {
      menuItems(limit: 1) {
        pageInfo {
          count
        }
      }
    }
  }
}
    `;
export const OrderConfirmationItemDetailsFragmentDoc = gql`
    fragment OrderConfirmationItemDetails on CCOrderItem {
  id
  transactionId
  name
  qty
  price
  description
  dietaries
  allergens
  accountLocation {
    id
    timezone
  }
  liveMenuItem {
    coreLiveItem {
      image
    }
  }
  options {
    items {
      id
      name
      price
    }
  }
}
    `;
export const FlexInvoiceAccountFragmentDoc = gql`
    fragment FlexInvoiceAccount on FlexInvoiceAccount {
  id
  accountId
  name
  timezone
  locale
  addressLine1
  addressLine2
  addressCity
  addressCountry
  addressPostcode
  contactFirstName
  contactLastName
  contactPhoneNumber
  primaryEmail
  emailAddresses
  entityNumber
  entityRegion
  entityTaxNumber
  vatRegionId
  isDefault
  autoInvoice
  invoicePerContact
  invoicePerReferenceField
  invoicePerType
  invoiceByPantryOrder
  invoiceByStandingOrder
  invoiceConsolidationFrequency
  invoiceConsolidationType
  invoicePerOrderRecipientType
  referenceFieldLabelsForInvoice
  standingOrderInvoicingRules {
    applyStandingOrderInvoicingRules
    autoInvoice
    consolidateInvoice
    invoiceConsolidationFrequency
    splitByContact
    splitByReferenceFields
    referenceFieldLabelsForStandingOrderInvoice
    invoiceEmailRecipientType
  }
  autoPay
}
    `;
export const InvoiceAccountFragmentDoc = gql`
    fragment InvoiceAccount on InvoiceAccount {
  id
  additionalEmails
  city
  country
  email
  firstName
  isDefault
  label
  lastName
  line1
  line2
  phone
  postcode
  vat
  vatRegionId
  accountId
  autoInvoice
  invoicePerContact
  invoicePerReferenceField
  invoicePerType
  invoiceByPantryOrder
  invoiceByStandingOrder
  invoiceConsolidationFrequency
  invoiceConsolidationType
  invoicePerOrderRecipientType
  referenceFieldLabelsForInvoice
  autoPay
}
    `;
export const AdminAccountRowFragmentDoc = gql`
    fragment AdminAccountRow on Account {
  id
  signUpCode
  name
  archivedAt
  currency
  isCCActive
  isGMActive
  ssoEnabled
  onboardingStatus
  users {
    pageInfo {
      count
    }
  }
  locations {
    address {
      country
    }
  }
}
    `;
export const CustomerOrdersSummaryValueInsightsFragmentDoc = gql`
    fragment CustomerOrdersSummaryValueInsights on CustomerOrdersSummary {
  totalSpend
  weeklyTotals {
    amount
    date
  }
  orderTypeTotals {
    amount
    orderType
  }
}
    `;
export const AdminVendorRowFragmentDoc = gql`
    fragment AdminVendorRow on Vendor {
  companyName
  currency
  id
  isDraft
  isCCActive
  isGMActive
  logo
  locations {
    country
    contacts {
      fullName
      email
    }
  }
}
    `;
export const VendorStatementsSummaryValueInsightsFragmentDoc = gql`
    fragment VendorStatementsSummaryValueInsights on VendorStatementsSummary {
  totalAmount
  weeklyTotals {
    amount
    date
  }
  orderTypeTotals {
    amount
    orderType
  }
}
    `;
export const CcMenuDebugTestCcSupplierOrderFragmentDoc = gql`
    fragment CCMenuDebugTestCCSupplierOrder on CCMenuDebugTestCCSupplierOrder {
  description
  id
  isSuccessful
  ccSupplierOrders {
    id
    accountId
    date
    meal
    arrivalTime
    arrivalTimeEnd
    vendor {
      id
      companyName
    }
    vendorLocation {
      id
      label
    }
    latestProgressStatus {
      id
      timestamp
      status
    }
    ccCluster {
      id
      name
    }
  }
}
    `;
export const CcMenuDebugTestClusterAssignmentFragmentDoc = gql`
    fragment CCMenuDebugTestClusterAssignment on CCMenuDebugTestClusterAssignment {
  description
  id
  isSuccessful
  ccCluster {
    id
    name
  }
}
    `;
export const CcMenuDebugTestAvailabilitiesFragmentDoc = gql`
    fragment CCMenuDebugTestAvailabilities on CCMenuDebugTestAvailabilities {
  description
  id
  isSuccessful
  ccAvailabilities {
    id
    arrivalTime
    weekday
    meal
    duration
  }
}
    `;
export const CcMenuDebugTestAllocationsFragmentDoc = gql`
    fragment CCMenuDebugTestAllocations on CCMenuDebugTestAllocations {
  description
  id
  isSuccessful
  ccSubmenuAllocations {
    date
    id
    submenuId
    meal
    ccCluster {
      id
      name
    }
    vendorLocation {
      id
      label
      vendor {
        id
        companyName
      }
    }
  }
}
    `;
export const AuthAccountFragmentDoc = gql`
    fragment AuthAccount on Account {
  id
  name
  invoiceApproved
  signUpCode
  invoiceAccounts {
    id
    label
    line1
    line2
    city
    postcode
    country
    isDefault
    autoPay
    vatRegionId
  }
  locations {
    __typename
    id
    isGmActive
    isBillingAddress
    label
    address {
      __typename
      label
      flatOrBuilding
      floorOrBuildingName
      street
      postcode
      city
      country
      latitude
      longitude
      timezoneId
    }
  }
}
    `;
export const BasketCustomerPriceItemFragmentDoc = gql`
    fragment BasketCustomerPriceItem on CustomerPriceItem {
  customerPriceType
  isCustomerFinalPrice
  price
  priceExTax
  priceTaxValue
}
    `;
export const BasketItemFragmentDoc = gql`
    fragment BasketItem on BasketItem {
  item {
    _id
    name
    price
    priceExTax
    taxRate
    taxValue
    isActive
    activeFrom
    activeTo
    variations(varType: "gm") {
      _id
      varType
      servings
      minQty
      price
      priceExTax
      priceCustomerFacing
      priceCustomerFacingExTax
      taxRate
      taxValue
      taxValueCustomerFacing
      isActive
      customerPriceItems {
        ...BasketCustomerPriceItem
      }
    }
    updatedAt
    translations {
      key
      value
      language
    }
    customerPriceItems {
      ...BasketCustomerPriceItem
    }
  }
  qty
  itemReference
  acknowledgedAt
  note
  addedByUserId
  addedByName
  options {
    category {
      _id
      optionType
    }
    optionItem {
      _id
      price
      priceExTax
      priceCustomerFacing
      priceCustomerFacingExTax
      taxRate
      taxValue
      taxValueCustomerFacing
      customerPriceItems {
        ...BasketCustomerPriceItem
      }
    }
    item {
      _id
      name
      isActive
      activeFrom
      activeTo
      updatedAt
      translations {
        key
        value
        language
      }
    }
    qty
  }
}
    ${BasketCustomerPriceItemFragmentDoc}`;
export const BasketCustomItemFragmentDoc = gql`
    fragment BasketCustomItem on GmBasketCustomItem {
  description
  id
  name
  notes
  customerPriceExTax
  quantity
}
    `;
export const CheckoutBasketFragmentDoc = gql`
    fragment CheckoutBasket on GmBasket {
  id
  friendlyId
  isCateringTeamOrder
  userId
  user {
    fullName
    id
  }
  contributors {
    userId
    name
  }
  vendor {
    id
    companyName
    isPantry
    locations {
      id
      country
    }
    currency
    permalink
    financeSettings {
      billingCountry
    }
  }
  items {
    ...BasketItem
  }
  customItems {
    ...BasketCustomItem
  }
  hasEnterpriseDiscount
  options {
    format
    rep
    isHighRisk
    thermalBox
    addons {
      napkins
      plates
      service
    }
    notes {
      cart
      account
      vendor
    }
    budgetCode
  }
  settings {
    isGuestBasket
    account {
      id
      name
    }
    vendor {
      id
      name
      locationId
      location {
        country
      }
    }
    paymentMethod
    billingAddressSameAsDelivery
    location {
      __typename
      ... on Address {
        label
        flatOrBuilding
        floorOrBuildingName
        city
        country
        postcode
        street
        latitude
        longitude
        timezoneId
      }
      ... on AccountLocation {
        id
        address {
          label
          flatOrBuilding
          floorOrBuildingName
          city
          country
          postcode
          street
          latitude
          longitude
          timezoneId
        }
        label
        instructions
      }
      ... on NewAccountLocation {
        label
        address {
          label
          flatOrBuilding
          floorOrBuildingName
          city
          country
          postcode
          street
          latitude
          longitude
          timezoneId
        }
      }
    }
    deliveryDate
    deliveryTimeSlot
    deliveryInstructions
    headCount
    meetingRoom
    feedrAdminApproved
    feedrCreated
    invoiceAccountId
    referenceFieldValues {
      orderReferenceFieldId
      referenceFieldId
      label
      description
      fieldType
      value
      isRequired
      version
      error
      options {
        id
        option
        orderPriority
        orderReferenceFieldId
      }
    }
    billingAddress {
      __typename
      ... on Address {
        label
        flatOrBuilding
        floorOrBuildingName
        city
        country
        postcode
        street
        latitude
        longitude
        timezoneId
      }
      ... on AccountLocation {
        id
        label
        address {
          label
          flatOrBuilding
          floorOrBuildingName
          city
          country
          postcode
          street
          latitude
          longitude
          timezoneId
        }
      }
      ... on NewAccountLocation {
        label
        address {
          label
          flatOrBuilding
          floorOrBuildingName
          city
          country
          postcode
          street
          latitude
          longitude
          timezoneId
        }
      }
    }
  }
  itemCount
  subtotalBreakdown {
    subtotalExTax
    subtotal
    taxValue
    taxRateTotalBreakdown {
      rate
      taxValue
      itemValue
    }
  }
  couponId {
    id
    code
    discountPercentage
    discountNumeric
  }
  fees {
    description
    code
    totalExTax
  }
  discountBreakdown {
    totalIncTax
    totalExTax
  }
  basketTotalBreakdown {
    totalIncTax
    totalExTax
    taxValue
    taxRateTotals {
      rate
      totalExTax
    }
  }
  allergens
  checkoutRestrictions {
    companyAdminOnly
  }
}
    ${BasketItemFragmentDoc}
${BasketCustomItemFragmentDoc}`;
export const MenuVendorLocationFragmentDoc = gql`
    fragment MenuVendorLocation on VendorLocation {
  id
  timezone
  country
  city
  details {
    minOrderValue
    minOrderValueExTax
    gmMaxDistanceMinutes
    gmMinNoticePeriod
    gmMaxOrder
    gmLargeOrderThreshold
    gmLargeOrderNoticePeriod
    isGMActive
    gmAllowCountryWideDelivery
  }
  closingDates {
    closedWeekdays
    closedDates
  }
  openingTimes {
    startTime
    endTime
    weekdays
  }
}
    `;
export const MenuVendorLocationDeliveryRegionFragmentDoc = gql`
    fragment MenuVendorLocationDeliveryRegion on DeliveryRegion {
  id
  minOrderValue
  minOrderValueExTax
  orderPosition
  serviceType
  deliveryFee {
    total
    taxRate
  }
}
    `;
export const MenuVendorLocationWithDeliveryRegionsFragmentDoc = gql`
    fragment MenuVendorLocationWithDeliveryRegions on VendorLocation {
  ...MenuVendorLocation
  deliveryRegions {
    ...MenuVendorLocationDeliveryRegion
  }
}
    ${MenuVendorLocationFragmentDoc}
${MenuVendorLocationDeliveryRegionFragmentDoc}`;
export const MenuVendorCategoryFragmentDoc = gql`
    fragment MenuVendorCategory on VendorCategory {
  id
  name
  position
}
    `;
export const MenuVendorFragmentDoc = gql`
    fragment MenuVendor on Vendor {
  id
  isDraft
  isGMActive
  gmAvailability {
    id
  }
  permalink
  companyName
  metaTitle
  metaDescription
  logo
  keywords
  descriptionFull
  descriptionShort
  currency
  sourcing
  quote
  rating
  totalRatings
  gmRating
  gmTotalRatings
  priceLevel
  isMyFavourite
  images {
    secureUrl
    position
  }
  locations {
    ...MenuVendorLocationWithDeliveryRegions
  }
  categories {
    ...MenuVendorCategory
  }
  popularItems(scope: GLOBAL) {
    itemReference
    rank
    orderCount
    accountCount
  }
  translations {
    key
    value
    language
  }
  externalUrlData {
    data {
      copy
      id
      url
      tags {
        data
      }
    }
  }
  isPantry
}
    ${MenuVendorLocationWithDeliveryRegionsFragmentDoc}
${MenuVendorCategoryFragmentDoc}`;
export const MenuCustomerPriceItemFragmentDoc = gql`
    fragment MenuCustomerPriceItem on CustomerPriceItem {
  customerPriceType
  isCustomerFinalPrice
  price
  priceExTax
  priceTaxValue
}
    `;
export const MenuItemVariationFragmentDoc = gql`
    fragment MenuItemVariation on MenuItemVariation {
  categoryId
  categoryIdArray
  servings
  popularity
  packaging
  minQty
  price
  priceExTax
  taxValue
  priceCustomerFacing
  priceCustomerFacingExTax
  privateAccessAccountIdArray
  taxValueCustomerFacing
  isCombo
  isPricePerHead
  position
  isPrivate
  customerPriceItems {
    ...MenuCustomerPriceItem
  }
}
    ${MenuCustomerPriceItemFragmentDoc}`;
export const MenuItemBaseFragmentDoc = gql`
    fragment MenuItemBase on MenuItem {
  _id
  isActive
  name
  image
  shortDescription
  description
  ingredients
  price
  priceExTax
  dietaries
  allergens
  taxRate
  subAllergens {
    nuts
    cereals
  }
  variations(varType: "gm") {
    _id
    ...MenuItemVariation
  }
  updatedAt
  isHot
  activeFrom
  activeTo
  macros_carbs
  macros_fat
  macros_protein
  macros_kcal
  macros_salt
  macros_saturates
  macros_sugar
  macros_fibre
  translations {
    key
    value
    language
  }
}
    ${MenuItemVariationFragmentDoc}`;
export const MenuOptionMenuItemFragmentDoc = gql`
    fragment MenuOptionMenuItem on MenuItem {
  _id
  isActive
  activeFrom
  activeTo
  updatedAt
  name
  shortDescription
  description
  dietaries
  allergens
  translations {
    key
    value
    language
  }
  subAllergens {
    cereals
    nuts
  }
}
    `;
export const MenuOptionItemFragmentDoc = gql`
    fragment MenuOptionItem on OptionItem {
  _id
  price
  priceExTax
  priceCustomerFacing
  priceCustomerFacingExTax
  taxRate
  taxValue
  taxValueCustomerFacing
  item {
    ...MenuOptionMenuItem
  }
  customerPriceItems {
    ...MenuCustomerPriceItem
  }
}
    ${MenuOptionMenuItemFragmentDoc}
${MenuCustomerPriceItemFragmentDoc}`;
export const MenuItemOptionFragmentDoc = gql`
    fragment MenuItemOption on MenuItemOptions {
  _id
  optionType
  name
  position
  minQty
  maxQty
  qtyPerPerson
  categoryType
  items {
    ...MenuOptionItem
  }
}
    ${MenuOptionItemFragmentDoc}`;
export const MenuItemFragmentDoc = gql`
    fragment MenuItem on MenuItem {
  ...MenuItemBase
  options {
    ...MenuItemOption
  }
}
    ${MenuItemBaseFragmentDoc}
${MenuItemOptionFragmentDoc}`;
export const MenuAvailabilityWithItemsPagedFragmentDoc = gql`
    fragment MenuAvailabilityWithItemsPaged on GmAvailability {
  id
  itemsPagedv2(
    limit: $limit
    offset: $offset
    filters: $filters
    sorting: $sorting
  ) {
    items {
      ...MenuItem
    }
    cacheKeys
    pageInfo {
      count
      hasMore
    }
    stats {
      allergens {
        id
        label
        value
        name
      }
      dietaries {
        id
        label
        value
        name
      }
      categories {
        id
        label
        value
        name
      }
    }
  }
  myLastBasket {
    id
  }
  myBaskets {
    rows {
      id
      friendlyId
    }
  }
}
    ${MenuItemFragmentDoc}`;
export const MenuItemOptionListNoItemsFragmentDoc = gql`
    fragment MenuItemOptionListNoItems on MenuItemOptions {
  _id
  optionType
  name
  position
  minQty
  maxQty
  qtyPerPerson
  categoryType
}
    `;
export const MenuItemListItemFragmentDoc = gql`
    fragment MenuItemListItem on MenuItem {
  ...MenuItemBase
  options {
    ...MenuItemOptionListNoItems
  }
}
    ${MenuItemBaseFragmentDoc}
${MenuItemOptionListNoItemsFragmentDoc}`;
export const MenuAvailabilityWithItemsPagedListFragmentDoc = gql`
    fragment MenuAvailabilityWithItemsPagedList on GmAvailability {
  id
  itemsPagedv2(
    limit: $limit
    offset: $offset
    filters: $filters
    sorting: $sorting
  ) {
    items {
      ...MenuItemListItem
    }
    cacheKeys
    pageInfo {
      count
      hasMore
    }
    stats {
      allergens {
        id
        label
        value
        name
      }
      dietaries {
        id
        label
        value
        name
      }
      categories {
        id
        label
        value
        name
      }
    }
  }
  myLastBasket {
    id
  }
  myBaskets {
    rows {
      id
      friendlyId
    }
  }
}
    ${MenuItemListItemFragmentDoc}`;
export const MenuAvailabilityFragmentDoc = gql`
    fragment MenuAvailability on GmAvailability {
  id
  items {
    ...MenuItem
  }
  myLastBasket {
    id
  }
  myBaskets {
    rows {
      id
      friendlyId
    }
  }
}
    ${MenuItemFragmentDoc}`;
export const UserBasketSettingsLocationFragmentDoc = gql`
    fragment UserBasketSettingsLocation on GmServiceLocation {
  __typename
  ... on Address {
    label
    flatOrBuilding
    floorOrBuildingName
    city
    country
    postcode
    street
    latitude
    longitude
    timezoneId
  }
  ... on AccountLocation {
    id
    address {
      label
      flatOrBuilding
      floorOrBuildingName
      city
      country
      postcode
      street
      latitude
      longitude
      timezoneId
    }
  }
  ... on NewAccountLocation {
    label
    address {
      label
      flatOrBuilding
      floorOrBuildingName
      city
      country
      postcode
      street
      latitude
      longitude
      timezoneId
    }
  }
}
    `;
export const BasketFragmentDoc = gql`
    fragment Basket on GmBasket {
  id
  friendlyId
  customName
  editSessionId
  isCateringTeamOrder
  userId
  user {
    id
    firstName
    lastName
  }
  contributors {
    userId
    name
  }
  items {
    ...BasketItem
  }
  customItems {
    ...BasketCustomItem
  }
  options {
    format
    rep
    isHighRisk
    thermalBox
    addons {
      napkins
      plates
      service
    }
    notes {
      cart
      account
      vendor
    }
    budgetCode
  }
  settings {
    account {
      id
      name
    }
    vendor {
      locationId
    }
    deliveryDate
    deliveryTimeSlot
    headCount
    feedrAdminApproved
    paymentMethod
    billingAddressSameAsDelivery
    isGuestBasket
    emmaFormResponseId
    location {
      ...UserBasketSettingsLocation
      ... on AccountLocation {
        instructions
      }
    }
  }
  logistics {
    customDeliveryFee
  }
  itemCount
  subtotalBreakdown {
    subtotalExTax
    subtotal
    taxValue
  }
  fees {
    description
    code
    totalExTax
  }
  hasEnterpriseDiscount
  discountBreakdown {
    totalIncTax
    totalExTax
  }
  basketTotalBreakdown {
    totalIncTax
    totalExTax
    taxValue
    taxRateTotals {
      rate
      totalExTax
    }
  }
  couponId {
    id
    code
    discountPercentage
    discountNumeric
  }
  checkoutRestrictions {
    companyAdminOnly
  }
}
    ${BasketItemFragmentDoc}
${BasketCustomItemFragmentDoc}
${UserBasketSettingsLocationFragmentDoc}`;
export const GmMenuStandingOrderDataFragmentDoc = gql`
    fragment GmMenuStandingOrderData on StandingOrder {
  _id
  name
  activeFrom
  activeUntil
  recurrence
  daysOfOccurrence
  nextDeliveryDate
}
    `;
export const CcInvoiceItemFragmentDoc = gql`
    fragment CCInvoiceItem on InvoiceItem {
  id
  description
  quantity
  vatRate
  total
  totalExVat
  totalVat
}
    `;
export const CcSupplierOrderBreakdownItemFragmentDoc = gql`
    fragment CCSupplierOrderBreakdownItem on CCSupplierOrderBreakdown {
  date
  supplierName
  supplierAddress {
    line1
    line2
    city
    country
    postcode
  }
  meal
  arrivalTime
  supplierVatNumber
  quantity
  totalExVat
  totalVat
  total
  taxInvoiceNumber
  vatSummary {
    vatRate
    quantity
    total
    totalExVat
    totalVat
  }
  items {
    id
    optionId
    description
    quantity
    unitPrice
    unitDiscount
    vatRate
    total
    isPromotionItem
  }
}
    `;
export const CcInvoiceFragmentDoc = gql`
    fragment CcInvoice on CCInvoice {
  id
  friendlyId
  status
  paymentStatus
  budgetCode
  canPay
  canCancel
  isAlreadyApproved
  dueDate
  issueDate
  periodStart
  periodEnd
  total
  totalVat
  totalExVat
  additionalTotal
  additionalTotalExVat
  additionalTotalVat
  additionalVatSummary {
    vatBandId
    vatRate
    total
    totalExVat
    totalVat
  }
  totalQuantity
  amountDue
  currency
  overviewPdf: asset(input: {type: "overview"}) {
    url
  }
  detailedPdf: asset(input: {type: "detailed"}) {
    url
  }
  csv: asset(input: {type: "csv"}) {
    url
  }
  vatSummary {
    vatBandId
    vatRate
    total
    totalExVat
    totalVat
  }
  vatRegion {
    id
    name
    vatBands(filters: {invoiceItemEligible: true}) {
      id
      name
      rate
    }
  }
  paymentHistory {
    date
    amount
  }
  billingDetails {
    vatNumber
    address {
      alias
      line1
      line2
      city
      postcode
      country
    }
    contact {
      firstName
      lastName
      email
    }
  }
  items {
    items {
      id
      description
      quantity
      unitPrice
      unitDiscount
      vatRate
      total
    }
  }
  additionalItems: items(
    input: {additional: true, limit: $additionalItemsLimit, offset: $additionalItemsOffset}
  ) {
    pageInfo {
      count
      limit
      offset
    }
    items {
      ...CCInvoiceItem
    }
  }
  billingEntity {
    code
    name
    address
    companyNumber
    vatNumber
    tenantId
    bankAccountData {
      accountName
      currency
      sortCode
      accountNumber
      bic
      iban
    }
  }
  ... on CCInvoice {
    mealsDonated
    account {
      id
      name
    }
    accountLocation {
      id
      timezone
      address {
        alias
        line1
        line2
        postcode
        city
        country
      }
    }
    additionalItemsTaxInvoiceNumber
    supplierOrderBreakdown(
      limit: $supplierOrderBreakdownLimit
      offset: $supplierOrderBreakdownOffset
    ) {
      pageInfo {
        count
        hasMore
        limit
        offset
      }
      vatSummary {
        vatRate
        quantity
        total
        totalExVat
        totalVat
      }
      orders {
        ...CCSupplierOrderBreakdownItem
      }
    }
  }
}
    ${CcInvoiceItemFragmentDoc}
${CcSupplierOrderBreakdownItemFragmentDoc}`;
export const GmInvoiceItemFragmentDoc = gql`
    fragment GMInvoiceItem on InvoiceItem {
  id
  description
  quantity
  vatRate
  total
  totalExVat
  totalVat
}
    `;
export const GmSupplierOrderBreakdownItemFragmentDoc = gql`
    fragment GMSupplierOrderBreakdownItem on GMSupplierOrderBreakdown {
  orderId
  friendlyOrderId
  date
  supplierName
  supplierAddress {
    line1
    line2
    city
    country
    postcode
  }
  arrivalTime
  supplierVatNumber
  quantity
  totalExVat
  totalVat
  total
  taxInvoiceNumber
  vatSummary {
    vatRate
    quantity
    total
    totalExVat
    totalVat
  }
  items {
    id
    optionId
    description
    quantity
    unitPrice
    unitDiscount
    vatRate
    total
    totalExVat
    totalVat
    isPromotionItem
  }
}
    `;
export const GmInvoiceFragmentDoc = gql`
    fragment GmInvoice on GMInvoice {
  id
  isInvoiceAccount
  friendlyId
  status
  paymentStatus
  budgetCode
  canPay
  canCancel
  isAlreadyApproved
  dueDate
  issueDate
  periodStart
  periodEnd
  total
  totalVat
  totalExVat
  additionalTotal(checkDelivery: $checkDelivery)
  additionalTotalExVat
  additionalTotalVat(checkDelivery: $checkDelivery)
  additionalVatSummary(checkDelivery: $checkDelivery) {
    vatBandId
    vatRate
    total
    totalExVat
    totalVat
  }
  totalQuantity
  amountDue
  currency
  overviewPdf: asset(input: {type: "overview"}) {
    url
  }
  detailedPdf: asset(input: {type: "detailed"}) {
    url
  }
  csv: asset(input: {type: "csv"}) {
    url
  }
  vatSummary {
    vatBandId
    vatRate
    total
    totalExVat
    totalVat
  }
  vatRegion {
    id
    name
    vatBands(filters: {invoiceItemEligible: true}) {
      id
      name
      rate
    }
  }
  paymentHistory {
    date
    amount
  }
  billingDetails {
    vatNumber
    address {
      alias
      line1
      line2
      city
      postcode
      country
    }
    contact {
      firstName
      lastName
      email
    }
  }
  items {
    items {
      id
      description
      quantity
      unitPrice
      unitDiscount
      vatRate
      total
    }
  }
  additionalItems: items(input: {additional: true, checkDelivery: $checkDelivery}) {
    pageInfo {
      count
      limit
      offset
    }
    items {
      ...GMInvoiceItem
    }
  }
  billingEntity {
    code
    name
    address
    companyNumber
    vatNumber
    tenantId
    bankAccountData {
      accountName
      currency
      sortCode
      accountNumber
      bic
      iban
    }
  }
  ... on GMInvoice {
    account {
      id
      name
    }
    accountLocation {
      id
      timezone
      address {
        alias
        line1
        line2
        postcode
        city
        country
      }
    }
    foodSalesDiscountPercent
    mealsDonated
    supplierOrderBreakdown(
      limit: $supplierOrderBreakdownLimit
      offset: $supplierOrderBreakdownOffset
      checkDelivery: $checkDelivery
    ) {
      pageInfo {
        count
        hasMore
        limit
        offset
      }
      vatSummary {
        vatRate
        quantity
        total
        totalExVat
        totalVat
      }
      orders {
        ...GMSupplierOrderBreakdownItem
      }
    }
  }
}
    ${GmInvoiceItemFragmentDoc}
${GmSupplierOrderBreakdownItemFragmentDoc}`;
export const ServiceOrderBreakdownItemFragmentDoc = gql`
    fragment ServiceOrderBreakdownItem on VendorStatementOrderBreakdownItem {
  date
  orderId
  friendlyOrderId
  quantity
  total
  totalExVat
  totalVat
  discount
  orderHref(appArea: $appArea) @include(if: $withOrderHref)
  billingDetails @include(if: $withCustomerBillingDetails) {
    address {
      alias
      line1
      line2
      postcode
      city
      country
    }
  }
  taxInvoiceId @include(if: $withTaxInvoiceId)
}
    `;
export const VendorStatementSingleFragmentDoc = gql`
    fragment VendorStatementSingle on VendorStatement {
  id
  friendlyId
  reseller
  status
  paymentStatus
  paidDate
  issueDate
  periodStart
  periodEnd
  currency
  totalExVat
  totalVat
  total
  vendorName
  vendorLocationName
  vendorLocationTimezone
  vatRegion {
    id
    name
    vatBands(filters: {invoiceItemEligible: true}) {
      id
      name
      rate
    }
  }
  billingDetails {
    contact {
      fullName
      email
    }
    address {
      alias
      line1
      line2
      city
      postcode
      country
    }
  }
  billingEntity {
    code
    name
    address
    email
    vatNumber
    companyNumber
    tenantId
  }
  serviceTotals {
    ccTotal
    gmTotal
  }
  isAlreadyApproved
  canCancel
  overviewPdf: asset(input: {type: "overview"}) {
    url
  }
  detailedPdf: asset(input: {type: "detailed"}) {
    url
  }
  csv: asset(input: {type: "csv"}) {
    url
  }
  summary {
    id
    quantity
    total
    totalVat
    totalExVat
    vatRate
    description
    editible
    subTotalExVat
  }
  feeSummary {
    total
    totalVat
    totalExVat
    items {
      id
      quantity
      total
      totalVat
      totalExVat
      vatRate
      description
    }
  }
  serviceOrderBreakdown {
    CC {
      ...ServiceOrderBreakdownItem
      items @include(if: $withOrderBreakdownItems) {
        id
        description
        total
        totalExVat
        totalVat
        unitPrice
        unitDiscount
        quantity
        vatRate
        optionId
        isPromotionItem
      }
    }
    GM {
      ...ServiceOrderBreakdownItem
      items @include(if: $withOrderBreakdownItems) {
        id
        description
        total
        totalExVat
        totalVat
        unitPrice
        unitDiscount
        quantity
        vatRate
        optionId
        isPromotionItem
      }
    }
  }
  serviceOriginalOrderBreakdown {
    CC {
      ...ServiceOrderBreakdownItem
      items @include(if: $withOrderBreakdownItems) {
        id
        description
        total
        totalExVat
        totalVat
        unitPrice
        unitDiscount
        quantity
        vatRate
        optionId
        isPromotionItem
      }
    }
    GM {
      ...ServiceOrderBreakdownItem
      items @include(if: $withOrderBreakdownItems) {
        id
        description
        total
        totalExVat
        totalVat
        unitPrice
        unitDiscount
        quantity
        vatRate
        optionId
        isPromotionItem
      }
    }
  }
  commissions {
    id
    description
    total
    totalExVat
    totalVat
    vatRate
    editible
    serviceType
    commissionRate
  }
}
    ${ServiceOrderBreakdownItemFragmentDoc}`;
export const AccountDashboardCalendarGmBasketFragmentDoc = gql`
    fragment AccountDashboardCalendarGmBasket on GmBasket {
  id
  customName
  user {
    id
    fullName
  }
  vendor {
    permalink
    companyName
    logo
    keywords
    currency
  }
  basketTotalBreakdown {
    totalIncTax
  }
  settings {
    deliveryDate
    deliveryTimeSlot
    location {
      ... on AccountLocation {
        id
      }
    }
  }
}
    `;
export const DraftMenuItemFieldsFragmentDoc = gql`
    fragment DraftMenuItemFields on MenuItem {
  _id
  ...Dietaries
  ...Allergens
  ...Macros
  deleted
  isActive
  legacyId
  migratedAt
  description
  shortDescription
  image
  ingredients
  isHot
  isVAT
  name
  price
  priceExTax
  supplierId
  deletedAt
  isMenuItem
  isOption
  mealTag
  cuisineTag
  alacalcFetchedAt
  alacalcId
  vatBandId
  inReview
  publishedTimestamp
  locked
  lockedTimestamp
  unlockedTimestamp
  sentForApprovalTimestamp
  requestDeleteTimestamp
  requestToDelete
  associatedStandingOrders(limit: 1) {
    pageInfo {
      count
    }
    standingOrders {
      _id
      activeUntil
    }
  }
  translations {
    key
    value
    language
  }
  variations {
    _id
    varType
    discountPrice
    feedrDiscountPrice
    name
    internalName
    price
    priceExTax
    isActive
    type
    orderLimit
    dailyStock
    isPromo
    isCombo
    avgRating
    isBreakfast
    isLunch
    isDinner
    isSampleBreakfast
    isSampleLunch
    isSampleDinner
    categoryId
    categoryIdArray
    isPricePerHead
    servings
    minQty
    position
    packaging
  }
}
    ${DietariesFragmentDoc}
${AllergensFragmentDoc}
${MacrosFragmentDoc}`;
export const SupplierLiveMenuItemBasicFragmentDoc = gql`
    fragment SupplierLiveMenuItemBasic on MenuItem {
  _id
  ...Dietaries
  ...Allergens
  ...Macros
  deleted
  isActive
  legacyId
  migratedAt
  description
  shortDescription
  image
  ingredients
  isHot
  isVAT
  name
  price
  priceExTax
  supplierId
  deletedAt
  isMenuItem
  isOption
  mealTag
  cuisineTag
  alacalcFetchedAt
  alacalcId
  vatBandId
  updatedAt
  locked
  lockedTimestamp
  unlockedTimestamp
  sentForApprovalTimestamp
  requestDeleteTimestamp
  requestToDelete
  publishedTimestamp
  associatedStandingOrders(limit: 1) {
    pageInfo {
      count
    }
    standingOrders {
      _id
      activeUntil
    }
  }
  translations {
    key
    value
    language
  }
  variations {
    _id
    varType
    discountPrice
    feedrDiscountPrice
    name
    internalName
    price
    priceExTax
    isActive
    type
    orderLimit
    dailyStock
    isPromo
    isCombo
    avgRating
    isBreakfast
    isLunch
    isDinner
    isSampleBreakfast
    isSampleLunch
    isSampleDinner
    categoryId
    categoryIdArray
    isPricePerHead
    servings
    minQty
    position
    packaging
    popularity
  }
}
    ${DietariesFragmentDoc}
${AllergensFragmentDoc}
${MacrosFragmentDoc}`;
export const SupplierLiveMenuItemOptionOnlyFragmentDoc = gql`
    fragment SupplierLiveMenuItemOptionOnly on MenuItem {
  options {
    _id
    name
    optionType
    position
    maxQty
    minQty
    qtyPerPerson
    items {
      _id
      position
      price
      priceExTax
      legacyItemId
      item {
        ...SupplierLiveMenuItemBasic
      }
    }
  }
}
    ${SupplierLiveMenuItemBasicFragmentDoc}`;
export const SupplierLiveMenuItemFragmentDoc = gql`
    fragment SupplierLiveMenuItem on MenuItem {
  ...SupplierLiveMenuItemBasic
  ...SupplierLiveMenuItemOptionOnly
}
    ${SupplierLiveMenuItemBasicFragmentDoc}
${SupplierLiveMenuItemOptionOnlyFragmentDoc}`;
export const SupplierLiveMenuMoreItemFragmentDoc = gql`
    fragment SupplierLiveMenuMoreItem on MenuItem {
  ...SupplierLiveMenuItemBasic
  options {
    _id
    name
    optionType
    position
    maxQty
    minQty
    qtyPerPerson
    items {
      _id
      position
      price
      priceExTax
      item {
        _id
        name
        price
        priceExTax
        variations {
          varType
        }
      }
    }
  }
}
    ${SupplierLiveMenuItemBasicFragmentDoc}`;
export const ListInvoicesInvoiceCcFragmentDoc = gql`
    fragment ListInvoicesInvoiceCC on CCInvoice {
  id
  type
  friendlyId
  status
  paymentStatus
  dueDate
  issueDate
  periodStart
  periodEnd
  currency
  total
  billingDetails {
    contact {
      firstName
      lastName
    }
    address {
      alias
    }
  }
  ... on CCInvoice {
    account {
      name
    }
    accountLocation {
      address {
        alias
      }
      timezone
    }
  }
}
    `;
export const ListInvoicesInvoiceGmFragmentDoc = gql`
    fragment ListInvoicesInvoiceGM on GMInvoice {
  id
  type
  friendlyId
  status
  paymentStatus
  dueDate
  issueDate
  periodStart
  periodEnd
  currency
  total
  billingDetails {
    contact {
      firstName
      lastName
    }
    address {
      alias
    }
  }
  ... on GMInvoice {
    isInvoiceAccount
    account {
      name
    }
    accountLocation {
      address {
        alias
      }
      timezone
    }
  }
}
    `;
export const ListInvoicesInvoiceFlexAllTypesFragmentDoc = gql`
    fragment ListInvoicesInvoiceFlexAllTypes on FlexInvoiceAllTypes {
  id
  invoiceType
  number
  createdAt
  accountName
  entityName
  dueDate
  csv
  timezone
  location
  country
  instant
  assets {
    type
    link
  }
  ... on FlexInvoiceAllTypes {
    flexTotal: total
    flexStatus: status
  }
}
    `;
export const ListVendorStatementsItemsFragmentDoc = gql`
    fragment ListVendorStatementsItems on VendorStatement {
  id
  friendlyId
  reseller
  status
  paymentStatus
  paidDate
  issueDate
  periodStart
  periodEnd
  currency
  total
  vendorName
  vendorLocationName
  vendorLocationTimezone
  serviceTotals {
    ccTotal
    gmTotal
  }
}
    `;
export const ListVendorFlexInvoiceAllTypesItemsFragmentDoc = gql`
    fragment ListVendorFlexInvoiceAllTypesItems on VendorFlexInvoiceAllTypes {
  id
  invoiceType
  number
  createdAt
  accountName
  entityName
  dueDate
  csv
  timezone
  location
  vendorId
  assets {
    type
    link
  }
  ... on VendorFlexInvoiceAllTypes {
    flexTotal: total
    flexStatus: status
  }
}
    `;
export const PaymentCardFragmentDoc = gql`
    fragment PaymentCard on PaymentCard {
  stripeId
  brand
  lastFourDigits
}
    `;
export const LineItemFragmentDoc = gql`
    fragment LineItem on LineItem {
  name
  amount
}
    `;
export const PaymentFragmentDoc = gql`
    fragment Payment on Payment {
  id
  descriptions
  lineItems {
    ...LineItem
  }
  user {
    id
  }
  total
  currency
  successRedirectUrl
  stripePublishableKey
}
    ${LineItemFragmentDoc}`;
export const PrebuildTenantsDocument = gql`
    query PrebuildTenants {
  tenants(input: {limit: 100, offset: 0}) {
    rows {
      ...TenantFromPrebuild
    }
  }
}
    ${TenantFromPrebuildFragmentDoc}`;

/**
 * __usePrebuildTenantsQuery__
 *
 * To run a query within a React component, call `usePrebuildTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrebuildTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrebuildTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrebuildTenantsQuery(baseOptions?: Apollo.QueryHookOptions<PrebuildTenantsQuery, PrebuildTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrebuildTenantsQuery, PrebuildTenantsQueryVariables>(PrebuildTenantsDocument, options);
      }
export function usePrebuildTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrebuildTenantsQuery, PrebuildTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrebuildTenantsQuery, PrebuildTenantsQueryVariables>(PrebuildTenantsDocument, options);
        }
// @ts-ignore
export function usePrebuildTenantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PrebuildTenantsQuery, PrebuildTenantsQueryVariables>): Apollo.UseSuspenseQueryResult<PrebuildTenantsQuery, PrebuildTenantsQueryVariables>;
export function usePrebuildTenantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrebuildTenantsQuery, PrebuildTenantsQueryVariables>): Apollo.UseSuspenseQueryResult<PrebuildTenantsQuery | undefined, PrebuildTenantsQueryVariables>;
export function usePrebuildTenantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrebuildTenantsQuery, PrebuildTenantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrebuildTenantsQuery, PrebuildTenantsQueryVariables>(PrebuildTenantsDocument, options);
        }
export type PrebuildTenantsQueryHookResult = ReturnType<typeof usePrebuildTenantsQuery>;
export type PrebuildTenantsLazyQueryHookResult = ReturnType<typeof usePrebuildTenantsLazyQuery>;
export type PrebuildTenantsSuspenseQueryHookResult = ReturnType<typeof usePrebuildTenantsSuspenseQuery>;
export type PrebuildTenantsQueryResult = Apollo.QueryResult<PrebuildTenantsQuery, PrebuildTenantsQueryVariables>;
export const SubmitEmmaFormDocument = gql`
    mutation SubmitEmmaForm($input: EmmaFormInput!) {
  submitEmmaForm(input: $input) {
    message
    success
    id
  }
}
    `;
export type SubmitEmmaFormMutationFn = Apollo.MutationFunction<SubmitEmmaFormMutation, SubmitEmmaFormMutationVariables>;

/**
 * __useSubmitEmmaFormMutation__
 *
 * To run a mutation, you first call `useSubmitEmmaFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEmmaFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEmmaFormMutation, { data, loading, error }] = useSubmitEmmaFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitEmmaFormMutation(baseOptions?: Apollo.MutationHookOptions<SubmitEmmaFormMutation, SubmitEmmaFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitEmmaFormMutation, SubmitEmmaFormMutationVariables>(SubmitEmmaFormDocument, options);
      }
export type SubmitEmmaFormMutationHookResult = ReturnType<typeof useSubmitEmmaFormMutation>;
export type SubmitEmmaFormMutationResult = Apollo.MutationResult<SubmitEmmaFormMutation>;
export type SubmitEmmaFormMutationOptions = Apollo.BaseMutationOptions<SubmitEmmaFormMutation, SubmitEmmaFormMutationVariables>;
export const AlertTypesDocument = gql`
    query AlertTypes {
  alertTypes {
    eventName
    name
    description
    filters {
      ... on AlertTypeFilterSupplier {
        name
        field
        type
        __typename
      }
      ... on AlertTypeFilterBoolean {
        name
        field
        type
        __typename
      }
      ... on AlertTypeFilterCountry {
        name
        field
        type
        __typename
      }
      ... on AlertTypeFilterDropdown {
        name
        field
        type
        options
        __typename
      }
      ... on AlertTypeFilterAccount {
        name
        field
        type
        __typename
      }
      ... on AlertTypeFilterNumber {
        name
        field
        type
        condition
        __typename
      }
      ... on AlertTypeFilterString {
        name
        field
        type
        __typename
      }
    }
  }
}
    `;

/**
 * __useAlertTypesQuery__
 *
 * To run a query within a React component, call `useAlertTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlertTypesQuery(baseOptions?: Apollo.QueryHookOptions<AlertTypesQuery, AlertTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertTypesQuery, AlertTypesQueryVariables>(AlertTypesDocument, options);
      }
export function useAlertTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertTypesQuery, AlertTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertTypesQuery, AlertTypesQueryVariables>(AlertTypesDocument, options);
        }
// @ts-ignore
export function useAlertTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlertTypesQuery, AlertTypesQueryVariables>): Apollo.UseSuspenseQueryResult<AlertTypesQuery, AlertTypesQueryVariables>;
export function useAlertTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertTypesQuery, AlertTypesQueryVariables>): Apollo.UseSuspenseQueryResult<AlertTypesQuery | undefined, AlertTypesQueryVariables>;
export function useAlertTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertTypesQuery, AlertTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlertTypesQuery, AlertTypesQueryVariables>(AlertTypesDocument, options);
        }
export type AlertTypesQueryHookResult = ReturnType<typeof useAlertTypesQuery>;
export type AlertTypesLazyQueryHookResult = ReturnType<typeof useAlertTypesLazyQuery>;
export type AlertTypesSuspenseQueryHookResult = ReturnType<typeof useAlertTypesSuspenseQuery>;
export type AlertTypesQueryResult = Apollo.QueryResult<AlertTypesQuery, AlertTypesQueryVariables>;
export const AlertsDocument = gql`
    query Alerts($input: AlertsInput) {
  alertTenantConfig {
    slackEnabled
  }
  alerts(input: $input) {
    pageInfo {
      count
      offset
      limit
      hasMore
    }
    rows {
      id
      name
      eventName
      filters {
        ... on AlertFilterBoolean {
          field
          value
          type
        }
        ... on AlertFilterString {
          field
          values
          type
        }
        ... on AlertFilterNumber {
          field
          valueInt
          type
          condition
        }
      }
      destinations {
        slack {
          enabled
          channels
        }
        email {
          enabled
          addresses
        }
      }
    }
  }
}
    `;

/**
 * __useAlertsQuery__
 *
 * To run a query within a React component, call `useAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlertsQuery(baseOptions?: Apollo.QueryHookOptions<AlertsQuery, AlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertsQuery, AlertsQueryVariables>(AlertsDocument, options);
      }
export function useAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertsQuery, AlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertsQuery, AlertsQueryVariables>(AlertsDocument, options);
        }
// @ts-ignore
export function useAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlertsQuery, AlertsQueryVariables>): Apollo.UseSuspenseQueryResult<AlertsQuery, AlertsQueryVariables>;
export function useAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertsQuery, AlertsQueryVariables>): Apollo.UseSuspenseQueryResult<AlertsQuery | undefined, AlertsQueryVariables>;
export function useAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertsQuery, AlertsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlertsQuery, AlertsQueryVariables>(AlertsDocument, options);
        }
export type AlertsQueryHookResult = ReturnType<typeof useAlertsQuery>;
export type AlertsLazyQueryHookResult = ReturnType<typeof useAlertsLazyQuery>;
export type AlertsSuspenseQueryHookResult = ReturnType<typeof useAlertsSuspenseQuery>;
export type AlertsQueryResult = Apollo.QueryResult<AlertsQuery, AlertsQueryVariables>;
export const CreateAlertDocument = gql`
    mutation CreateAlert($input: CreateAlertInput!) {
  createAlert(input: $input) {
    id
  }
}
    `;
export type CreateAlertMutationFn = Apollo.MutationFunction<CreateAlertMutation, CreateAlertMutationVariables>;

/**
 * __useCreateAlertMutation__
 *
 * To run a mutation, you first call `useCreateAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertMutation, { data, loading, error }] = useCreateAlertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAlertMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlertMutation, CreateAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlertMutation, CreateAlertMutationVariables>(CreateAlertDocument, options);
      }
export type CreateAlertMutationHookResult = ReturnType<typeof useCreateAlertMutation>;
export type CreateAlertMutationResult = Apollo.MutationResult<CreateAlertMutation>;
export type CreateAlertMutationOptions = Apollo.BaseMutationOptions<CreateAlertMutation, CreateAlertMutationVariables>;
export const UpdateAlertDocument = gql`
    mutation UpdateAlert($id: ID!, $input: UpdateAlertInput!) {
  updateAlert(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateAlertMutationFn = Apollo.MutationFunction<UpdateAlertMutation, UpdateAlertMutationVariables>;

/**
 * __useUpdateAlertMutation__
 *
 * To run a mutation, you first call `useUpdateAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertMutation, { data, loading, error }] = useUpdateAlertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlertMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlertMutation, UpdateAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlertMutation, UpdateAlertMutationVariables>(UpdateAlertDocument, options);
      }
export type UpdateAlertMutationHookResult = ReturnType<typeof useUpdateAlertMutation>;
export type UpdateAlertMutationResult = Apollo.MutationResult<UpdateAlertMutation>;
export type UpdateAlertMutationOptions = Apollo.BaseMutationOptions<UpdateAlertMutation, UpdateAlertMutationVariables>;
export const DeleteAlertDocument = gql`
    mutation DeleteAlert($id: ID!) {
  deleteAlert(id: $id)
}
    `;
export type DeleteAlertMutationFn = Apollo.MutationFunction<DeleteAlertMutation, DeleteAlertMutationVariables>;

/**
 * __useDeleteAlertMutation__
 *
 * To run a mutation, you first call `useDeleteAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertMutation, { data, loading, error }] = useDeleteAlertMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlertMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlertMutation, DeleteAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlertMutation, DeleteAlertMutationVariables>(DeleteAlertDocument, options);
      }
export type DeleteAlertMutationHookResult = ReturnType<typeof useDeleteAlertMutation>;
export type DeleteAlertMutationResult = Apollo.MutationResult<DeleteAlertMutation>;
export type DeleteAlertMutationOptions = Apollo.BaseMutationOptions<DeleteAlertMutation, DeleteAlertMutationVariables>;
export const GenerateSlackAlertingOAuthUrlDocument = gql`
    mutation GenerateSlackAlertingOAuthUrl {
  generateSlackAlertingOAuthUrl
}
    `;
export type GenerateSlackAlertingOAuthUrlMutationFn = Apollo.MutationFunction<GenerateSlackAlertingOAuthUrlMutation, GenerateSlackAlertingOAuthUrlMutationVariables>;

/**
 * __useGenerateSlackAlertingOAuthUrlMutation__
 *
 * To run a mutation, you first call `useGenerateSlackAlertingOAuthUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSlackAlertingOAuthUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSlackAlertingOAuthUrlMutation, { data, loading, error }] = useGenerateSlackAlertingOAuthUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateSlackAlertingOAuthUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSlackAlertingOAuthUrlMutation, GenerateSlackAlertingOAuthUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSlackAlertingOAuthUrlMutation, GenerateSlackAlertingOAuthUrlMutationVariables>(GenerateSlackAlertingOAuthUrlDocument, options);
      }
export type GenerateSlackAlertingOAuthUrlMutationHookResult = ReturnType<typeof useGenerateSlackAlertingOAuthUrlMutation>;
export type GenerateSlackAlertingOAuthUrlMutationResult = Apollo.MutationResult<GenerateSlackAlertingOAuthUrlMutation>;
export type GenerateSlackAlertingOAuthUrlMutationOptions = Apollo.BaseMutationOptions<GenerateSlackAlertingOAuthUrlMutation, GenerateSlackAlertingOAuthUrlMutationVariables>;
export const AlertingPopulateAccountDocument = gql`
    query AlertingPopulateAccount($accountId: ID!) {
  account(id: $accountId) {
    id
    name
  }
}
    `;

/**
 * __useAlertingPopulateAccountQuery__
 *
 * To run a query within a React component, call `useAlertingPopulateAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertingPopulateAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertingPopulateAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAlertingPopulateAccountQuery(baseOptions: Apollo.QueryHookOptions<AlertingPopulateAccountQuery, AlertingPopulateAccountQueryVariables> & ({ variables: AlertingPopulateAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertingPopulateAccountQuery, AlertingPopulateAccountQueryVariables>(AlertingPopulateAccountDocument, options);
      }
export function useAlertingPopulateAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertingPopulateAccountQuery, AlertingPopulateAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertingPopulateAccountQuery, AlertingPopulateAccountQueryVariables>(AlertingPopulateAccountDocument, options);
        }
// @ts-ignore
export function useAlertingPopulateAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlertingPopulateAccountQuery, AlertingPopulateAccountQueryVariables>): Apollo.UseSuspenseQueryResult<AlertingPopulateAccountQuery, AlertingPopulateAccountQueryVariables>;
export function useAlertingPopulateAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertingPopulateAccountQuery, AlertingPopulateAccountQueryVariables>): Apollo.UseSuspenseQueryResult<AlertingPopulateAccountQuery | undefined, AlertingPopulateAccountQueryVariables>;
export function useAlertingPopulateAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertingPopulateAccountQuery, AlertingPopulateAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlertingPopulateAccountQuery, AlertingPopulateAccountQueryVariables>(AlertingPopulateAccountDocument, options);
        }
export type AlertingPopulateAccountQueryHookResult = ReturnType<typeof useAlertingPopulateAccountQuery>;
export type AlertingPopulateAccountLazyQueryHookResult = ReturnType<typeof useAlertingPopulateAccountLazyQuery>;
export type AlertingPopulateAccountSuspenseQueryHookResult = ReturnType<typeof useAlertingPopulateAccountSuspenseQuery>;
export type AlertingPopulateAccountQueryResult = Apollo.QueryResult<AlertingPopulateAccountQuery, AlertingPopulateAccountQueryVariables>;
export const AlertingSupplierFilterDocument = gql`
    query AlertingSupplierFilter($filters: VendorFilters!) {
  vendors(filters: $filters) {
    rows {
      id
      companyName
    }
  }
}
    `;

/**
 * __useAlertingSupplierFilterQuery__
 *
 * To run a query within a React component, call `useAlertingSupplierFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertingSupplierFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertingSupplierFilterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAlertingSupplierFilterQuery(baseOptions: Apollo.QueryHookOptions<AlertingSupplierFilterQuery, AlertingSupplierFilterQueryVariables> & ({ variables: AlertingSupplierFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertingSupplierFilterQuery, AlertingSupplierFilterQueryVariables>(AlertingSupplierFilterDocument, options);
      }
export function useAlertingSupplierFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertingSupplierFilterQuery, AlertingSupplierFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertingSupplierFilterQuery, AlertingSupplierFilterQueryVariables>(AlertingSupplierFilterDocument, options);
        }
// @ts-ignore
export function useAlertingSupplierFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlertingSupplierFilterQuery, AlertingSupplierFilterQueryVariables>): Apollo.UseSuspenseQueryResult<AlertingSupplierFilterQuery, AlertingSupplierFilterQueryVariables>;
export function useAlertingSupplierFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertingSupplierFilterQuery, AlertingSupplierFilterQueryVariables>): Apollo.UseSuspenseQueryResult<AlertingSupplierFilterQuery | undefined, AlertingSupplierFilterQueryVariables>;
export function useAlertingSupplierFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertingSupplierFilterQuery, AlertingSupplierFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlertingSupplierFilterQuery, AlertingSupplierFilterQueryVariables>(AlertingSupplierFilterDocument, options);
        }
export type AlertingSupplierFilterQueryHookResult = ReturnType<typeof useAlertingSupplierFilterQuery>;
export type AlertingSupplierFilterLazyQueryHookResult = ReturnType<typeof useAlertingSupplierFilterLazyQuery>;
export type AlertingSupplierFilterSuspenseQueryHookResult = ReturnType<typeof useAlertingSupplierFilterSuspenseQuery>;
export type AlertingSupplierFilterQueryResult = Apollo.QueryResult<AlertingSupplierFilterQuery, AlertingSupplierFilterQueryVariables>;
export const AlertingPopulateSupplierDocument = gql`
    query AlertingPopulateSupplier($supplierId: ID!) {
  vendor(id: $supplierId) {
    id
    companyName
  }
}
    `;

/**
 * __useAlertingPopulateSupplierQuery__
 *
 * To run a query within a React component, call `useAlertingPopulateSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertingPopulateSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertingPopulateSupplierQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useAlertingPopulateSupplierQuery(baseOptions: Apollo.QueryHookOptions<AlertingPopulateSupplierQuery, AlertingPopulateSupplierQueryVariables> & ({ variables: AlertingPopulateSupplierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertingPopulateSupplierQuery, AlertingPopulateSupplierQueryVariables>(AlertingPopulateSupplierDocument, options);
      }
export function useAlertingPopulateSupplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertingPopulateSupplierQuery, AlertingPopulateSupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertingPopulateSupplierQuery, AlertingPopulateSupplierQueryVariables>(AlertingPopulateSupplierDocument, options);
        }
// @ts-ignore
export function useAlertingPopulateSupplierSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlertingPopulateSupplierQuery, AlertingPopulateSupplierQueryVariables>): Apollo.UseSuspenseQueryResult<AlertingPopulateSupplierQuery, AlertingPopulateSupplierQueryVariables>;
export function useAlertingPopulateSupplierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertingPopulateSupplierQuery, AlertingPopulateSupplierQueryVariables>): Apollo.UseSuspenseQueryResult<AlertingPopulateSupplierQuery | undefined, AlertingPopulateSupplierQueryVariables>;
export function useAlertingPopulateSupplierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertingPopulateSupplierQuery, AlertingPopulateSupplierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlertingPopulateSupplierQuery, AlertingPopulateSupplierQueryVariables>(AlertingPopulateSupplierDocument, options);
        }
export type AlertingPopulateSupplierQueryHookResult = ReturnType<typeof useAlertingPopulateSupplierQuery>;
export type AlertingPopulateSupplierLazyQueryHookResult = ReturnType<typeof useAlertingPopulateSupplierLazyQuery>;
export type AlertingPopulateSupplierSuspenseQueryHookResult = ReturnType<typeof useAlertingPopulateSupplierSuspenseQuery>;
export type AlertingPopulateSupplierQueryResult = Apollo.QueryResult<AlertingPopulateSupplierQuery, AlertingPopulateSupplierQueryVariables>;
export const UpdateCcClusterDocument = gql`
    mutation updateCCCluster($input: UpdateCCClusterInput!) {
  updateCCCluster(input: $input) {
    id
    name
    code
  }
}
    `;
export type UpdateCcClusterMutationFn = Apollo.MutationFunction<UpdateCcClusterMutation, UpdateCcClusterMutationVariables>;

/**
 * __useUpdateCcClusterMutation__
 *
 * To run a mutation, you first call `useUpdateCcClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCcClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCcClusterMutation, { data, loading, error }] = useUpdateCcClusterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCcClusterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCcClusterMutation, UpdateCcClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCcClusterMutation, UpdateCcClusterMutationVariables>(UpdateCcClusterDocument, options);
      }
export type UpdateCcClusterMutationHookResult = ReturnType<typeof useUpdateCcClusterMutation>;
export type UpdateCcClusterMutationResult = Apollo.MutationResult<UpdateCcClusterMutation>;
export type UpdateCcClusterMutationOptions = Apollo.BaseMutationOptions<UpdateCcClusterMutation, UpdateCcClusterMutationVariables>;
export const DeleteCcClusterDocument = gql`
    mutation deleteCCCluster($id: ID!) {
  deleteCCCluster(id: $id) {
    id
    name
    code
  }
}
    `;
export type DeleteCcClusterMutationFn = Apollo.MutationFunction<DeleteCcClusterMutation, DeleteCcClusterMutationVariables>;

/**
 * __useDeleteCcClusterMutation__
 *
 * To run a mutation, you first call `useDeleteCcClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCcClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCcClusterMutation, { data, loading, error }] = useDeleteCcClusterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCcClusterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCcClusterMutation, DeleteCcClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCcClusterMutation, DeleteCcClusterMutationVariables>(DeleteCcClusterDocument, options);
      }
export type DeleteCcClusterMutationHookResult = ReturnType<typeof useDeleteCcClusterMutation>;
export type DeleteCcClusterMutationResult = Apollo.MutationResult<DeleteCcClusterMutation>;
export type DeleteCcClusterMutationOptions = Apollo.BaseMutationOptions<DeleteCcClusterMutation, DeleteCcClusterMutationVariables>;
export const GetCcClustersDocument = gql`
    query getCcClusters($input: CCSupplierOrdersInput!, $limit: Int, $offset: Int, $filters: CCClusterListFilters) {
  ccClusters(limit: $limit, offset: $offset, filters: $filters) {
    rows {
      id
      name
      code
      ccSupplierOrders(input: $input) {
        rows {
          id
          date
          meal
          reference
          confirmed
          accountId
          vendor {
            companyName
          }
        }
        pageInfo {
          count
        }
      }
      accountLocations {
        id
        label
        account {
          id
        }
        address {
          street
          city
        }
      }
    }
    pageInfo {
      offset
      limit
      count
      hasMore
    }
  }
}
    `;

/**
 * __useGetCcClustersQuery__
 *
 * To run a query within a React component, call `useGetCcClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCcClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCcClustersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCcClustersQuery(baseOptions: Apollo.QueryHookOptions<GetCcClustersQuery, GetCcClustersQueryVariables> & ({ variables: GetCcClustersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCcClustersQuery, GetCcClustersQueryVariables>(GetCcClustersDocument, options);
      }
export function useGetCcClustersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCcClustersQuery, GetCcClustersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCcClustersQuery, GetCcClustersQueryVariables>(GetCcClustersDocument, options);
        }
// @ts-ignore
export function useGetCcClustersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCcClustersQuery, GetCcClustersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCcClustersQuery, GetCcClustersQueryVariables>;
export function useGetCcClustersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCcClustersQuery, GetCcClustersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCcClustersQuery | undefined, GetCcClustersQueryVariables>;
export function useGetCcClustersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCcClustersQuery, GetCcClustersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCcClustersQuery, GetCcClustersQueryVariables>(GetCcClustersDocument, options);
        }
export type GetCcClustersQueryHookResult = ReturnType<typeof useGetCcClustersQuery>;
export type GetCcClustersLazyQueryHookResult = ReturnType<typeof useGetCcClustersLazyQuery>;
export type GetCcClustersSuspenseQueryHookResult = ReturnType<typeof useGetCcClustersSuspenseQuery>;
export type GetCcClustersQueryResult = Apollo.QueryResult<GetCcClustersQuery, GetCcClustersQueryVariables>;
export const IncreaseUserCreditsDocument = gql`
    mutation IncreaseUserCredits($input: AdminIncreaseUserCreditsInput!) {
  adminIncreaseUserCredits(input: $input) {
    id
    transactionId
    userId
    amount
    type
    description
    currency
    newBalance
    createdAt
  }
}
    `;
export type IncreaseUserCreditsMutationFn = Apollo.MutationFunction<IncreaseUserCreditsMutation, IncreaseUserCreditsMutationVariables>;

/**
 * __useIncreaseUserCreditsMutation__
 *
 * To run a mutation, you first call `useIncreaseUserCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncreaseUserCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [increaseUserCreditsMutation, { data, loading, error }] = useIncreaseUserCreditsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIncreaseUserCreditsMutation(baseOptions?: Apollo.MutationHookOptions<IncreaseUserCreditsMutation, IncreaseUserCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IncreaseUserCreditsMutation, IncreaseUserCreditsMutationVariables>(IncreaseUserCreditsDocument, options);
      }
export type IncreaseUserCreditsMutationHookResult = ReturnType<typeof useIncreaseUserCreditsMutation>;
export type IncreaseUserCreditsMutationResult = Apollo.MutationResult<IncreaseUserCreditsMutation>;
export type IncreaseUserCreditsMutationOptions = Apollo.BaseMutationOptions<IncreaseUserCreditsMutation, IncreaseUserCreditsMutationVariables>;
export const DecreaseUserCreditsDocument = gql`
    mutation DecreaseUserCredits($input: AdminDecreaseUserCreditsInput!) {
  adminDecreaseUserCredits(input: $input) {
    id
    transactionId
    userId
    amount
    type
    description
    currency
    newBalance
    createdAt
  }
}
    `;
export type DecreaseUserCreditsMutationFn = Apollo.MutationFunction<DecreaseUserCreditsMutation, DecreaseUserCreditsMutationVariables>;

/**
 * __useDecreaseUserCreditsMutation__
 *
 * To run a mutation, you first call `useDecreaseUserCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecreaseUserCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decreaseUserCreditsMutation, { data, loading, error }] = useDecreaseUserCreditsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDecreaseUserCreditsMutation(baseOptions?: Apollo.MutationHookOptions<DecreaseUserCreditsMutation, DecreaseUserCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DecreaseUserCreditsMutation, DecreaseUserCreditsMutationVariables>(DecreaseUserCreditsDocument, options);
      }
export type DecreaseUserCreditsMutationHookResult = ReturnType<typeof useDecreaseUserCreditsMutation>;
export type DecreaseUserCreditsMutationResult = Apollo.MutationResult<DecreaseUserCreditsMutation>;
export type DecreaseUserCreditsMutationOptions = Apollo.BaseMutationOptions<DecreaseUserCreditsMutation, DecreaseUserCreditsMutationVariables>;
export const CcSubmenuLiveMenuItemsDocument = gql`
    query ccSubmenuLiveMenuItems($supplierId: ID!) {
  vendor(id: $supplierId) {
    id
    liveMenuItems(limit: 10000) {
      pageInfo {
        limit
        offset
        count
        hasMore
      }
      items {
        ...CcSubmenu_SupplierLiveMenuItem
      }
    }
  }
}
    ${CcSubmenu_SupplierLiveMenuItemFragmentDoc}`;

/**
 * __useCcSubmenuLiveMenuItemsQuery__
 *
 * To run a query within a React component, call `useCcSubmenuLiveMenuItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCcSubmenuLiveMenuItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCcSubmenuLiveMenuItemsQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useCcSubmenuLiveMenuItemsQuery(baseOptions: Apollo.QueryHookOptions<CcSubmenuLiveMenuItemsQuery, CcSubmenuLiveMenuItemsQueryVariables> & ({ variables: CcSubmenuLiveMenuItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CcSubmenuLiveMenuItemsQuery, CcSubmenuLiveMenuItemsQueryVariables>(CcSubmenuLiveMenuItemsDocument, options);
      }
export function useCcSubmenuLiveMenuItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CcSubmenuLiveMenuItemsQuery, CcSubmenuLiveMenuItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CcSubmenuLiveMenuItemsQuery, CcSubmenuLiveMenuItemsQueryVariables>(CcSubmenuLiveMenuItemsDocument, options);
        }
// @ts-ignore
export function useCcSubmenuLiveMenuItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CcSubmenuLiveMenuItemsQuery, CcSubmenuLiveMenuItemsQueryVariables>): Apollo.UseSuspenseQueryResult<CcSubmenuLiveMenuItemsQuery, CcSubmenuLiveMenuItemsQueryVariables>;
export function useCcSubmenuLiveMenuItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CcSubmenuLiveMenuItemsQuery, CcSubmenuLiveMenuItemsQueryVariables>): Apollo.UseSuspenseQueryResult<CcSubmenuLiveMenuItemsQuery | undefined, CcSubmenuLiveMenuItemsQueryVariables>;
export function useCcSubmenuLiveMenuItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CcSubmenuLiveMenuItemsQuery, CcSubmenuLiveMenuItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CcSubmenuLiveMenuItemsQuery, CcSubmenuLiveMenuItemsQueryVariables>(CcSubmenuLiveMenuItemsDocument, options);
        }
export type CcSubmenuLiveMenuItemsQueryHookResult = ReturnType<typeof useCcSubmenuLiveMenuItemsQuery>;
export type CcSubmenuLiveMenuItemsLazyQueryHookResult = ReturnType<typeof useCcSubmenuLiveMenuItemsLazyQuery>;
export type CcSubmenuLiveMenuItemsSuspenseQueryHookResult = ReturnType<typeof useCcSubmenuLiveMenuItemsSuspenseQuery>;
export type CcSubmenuLiveMenuItemsQueryResult = Apollo.QueryResult<CcSubmenuLiveMenuItemsQuery, CcSubmenuLiveMenuItemsQueryVariables>;
export const GetCcSubmenuDocument = gql`
    query getCcSubmenu($id: Int!) {
  ccSubmenu(id: $id) {
    id
    description
    isActive
    maxCapacity
    name
    publicName
    copiable
    tenantId
    visibleToClient
    isUsedLive
    liveAllocations {
      date
      meal
    }
    locationCapacities {
      vendorLocation {
        id
        label
        line1
        city
        postcode
      }
      maxCapacity
    }
    vendor {
      id
      groupCode
      companyName
      isCCActive
      currency
      locations(isCCActive: true) {
        id
        label
        line1
        city
        postcode
      }
    }
    items {
      submenuId
      data {
        ...CcSubmenu_ItemData
      }
    }
  }
}
    ${CcSubmenu_ItemDataFragmentDoc}`;

/**
 * __useGetCcSubmenuQuery__
 *
 * To run a query within a React component, call `useGetCcSubmenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCcSubmenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCcSubmenuQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCcSubmenuQuery(baseOptions: Apollo.QueryHookOptions<GetCcSubmenuQuery, GetCcSubmenuQueryVariables> & ({ variables: GetCcSubmenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCcSubmenuQuery, GetCcSubmenuQueryVariables>(GetCcSubmenuDocument, options);
      }
export function useGetCcSubmenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCcSubmenuQuery, GetCcSubmenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCcSubmenuQuery, GetCcSubmenuQueryVariables>(GetCcSubmenuDocument, options);
        }
// @ts-ignore
export function useGetCcSubmenuSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCcSubmenuQuery, GetCcSubmenuQueryVariables>): Apollo.UseSuspenseQueryResult<GetCcSubmenuQuery, GetCcSubmenuQueryVariables>;
export function useGetCcSubmenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCcSubmenuQuery, GetCcSubmenuQueryVariables>): Apollo.UseSuspenseQueryResult<GetCcSubmenuQuery | undefined, GetCcSubmenuQueryVariables>;
export function useGetCcSubmenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCcSubmenuQuery, GetCcSubmenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCcSubmenuQuery, GetCcSubmenuQueryVariables>(GetCcSubmenuDocument, options);
        }
export type GetCcSubmenuQueryHookResult = ReturnType<typeof useGetCcSubmenuQuery>;
export type GetCcSubmenuLazyQueryHookResult = ReturnType<typeof useGetCcSubmenuLazyQuery>;
export type GetCcSubmenuSuspenseQueryHookResult = ReturnType<typeof useGetCcSubmenuSuspenseQuery>;
export type GetCcSubmenuQueryResult = Apollo.QueryResult<GetCcSubmenuQuery, GetCcSubmenuQueryVariables>;
export const EmmaFormResponsesDocument = gql`
    query EmmaFormResponses($input: EmmaFormResponsesInput!) {
  emmaFormResponses(input: $input) {
    pageInfo {
      count
      hasMore
      limit
      offset
    }
    items {
      id
      headcount
      date
      time
      budgetType
      budget
      occasion
      createdAt
      subscribeToUpdates
      contact {
        firstName
        lastName
        companyName
      }
      adminAssigned {
        id
        name
      }
      status
    }
  }
}
    `;

/**
 * __useEmmaFormResponsesQuery__
 *
 * To run a query within a React component, call `useEmmaFormResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmmaFormResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmmaFormResponsesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmmaFormResponsesQuery(baseOptions: Apollo.QueryHookOptions<EmmaFormResponsesQuery, EmmaFormResponsesQueryVariables> & ({ variables: EmmaFormResponsesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmmaFormResponsesQuery, EmmaFormResponsesQueryVariables>(EmmaFormResponsesDocument, options);
      }
export function useEmmaFormResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmmaFormResponsesQuery, EmmaFormResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmmaFormResponsesQuery, EmmaFormResponsesQueryVariables>(EmmaFormResponsesDocument, options);
        }
// @ts-ignore
export function useEmmaFormResponsesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmmaFormResponsesQuery, EmmaFormResponsesQueryVariables>): Apollo.UseSuspenseQueryResult<EmmaFormResponsesQuery, EmmaFormResponsesQueryVariables>;
export function useEmmaFormResponsesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmmaFormResponsesQuery, EmmaFormResponsesQueryVariables>): Apollo.UseSuspenseQueryResult<EmmaFormResponsesQuery | undefined, EmmaFormResponsesQueryVariables>;
export function useEmmaFormResponsesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmmaFormResponsesQuery, EmmaFormResponsesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmmaFormResponsesQuery, EmmaFormResponsesQueryVariables>(EmmaFormResponsesDocument, options);
        }
export type EmmaFormResponsesQueryHookResult = ReturnType<typeof useEmmaFormResponsesQuery>;
export type EmmaFormResponsesLazyQueryHookResult = ReturnType<typeof useEmmaFormResponsesLazyQuery>;
export type EmmaFormResponsesSuspenseQueryHookResult = ReturnType<typeof useEmmaFormResponsesSuspenseQuery>;
export type EmmaFormResponsesQueryResult = Apollo.QueryResult<EmmaFormResponsesQuery, EmmaFormResponsesQueryVariables>;
export const MessageTemplatesDocument = gql`
    query MessageTemplates($limit: Int = 50, $offset: Int = 0) {
  messageTemplates(limit: $limit, offset: $offset) {
    rows {
      body
      id
      name
    }
  }
}
    `;

/**
 * __useMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTemplatesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMessageTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<MessageTemplatesQuery, MessageTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageTemplatesQuery, MessageTemplatesQueryVariables>(MessageTemplatesDocument, options);
      }
export function useMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageTemplatesQuery, MessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageTemplatesQuery, MessageTemplatesQueryVariables>(MessageTemplatesDocument, options);
        }
// @ts-ignore
export function useMessageTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTemplatesQuery, MessageTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<MessageTemplatesQuery, MessageTemplatesQueryVariables>;
export function useMessageTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MessageTemplatesQuery, MessageTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<MessageTemplatesQuery | undefined, MessageTemplatesQueryVariables>;
export function useMessageTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MessageTemplatesQuery, MessageTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MessageTemplatesQuery, MessageTemplatesQueryVariables>(MessageTemplatesDocument, options);
        }
export type MessageTemplatesQueryHookResult = ReturnType<typeof useMessageTemplatesQuery>;
export type MessageTemplatesLazyQueryHookResult = ReturnType<typeof useMessageTemplatesLazyQuery>;
export type MessageTemplatesSuspenseQueryHookResult = ReturnType<typeof useMessageTemplatesSuspenseQuery>;
export type MessageTemplatesQueryResult = Apollo.QueryResult<MessageTemplatesQuery, MessageTemplatesQueryVariables>;
export const GetSignupMetadataDocument = gql`
    query getSignupMetadata($token: ID!) {
  signupMetadata(token: $token) {
    firstName
    lastName
    phone
    email
    companyName
    subscribeNewsletter
    accountId
  }
}
    `;

/**
 * __useGetSignupMetadataQuery__
 *
 * To run a query within a React component, call `useGetSignupMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignupMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignupMetadataQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetSignupMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetSignupMetadataQuery, GetSignupMetadataQueryVariables> & ({ variables: GetSignupMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignupMetadataQuery, GetSignupMetadataQueryVariables>(GetSignupMetadataDocument, options);
      }
export function useGetSignupMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignupMetadataQuery, GetSignupMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignupMetadataQuery, GetSignupMetadataQueryVariables>(GetSignupMetadataDocument, options);
        }
// @ts-ignore
export function useGetSignupMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSignupMetadataQuery, GetSignupMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<GetSignupMetadataQuery, GetSignupMetadataQueryVariables>;
export function useGetSignupMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSignupMetadataQuery, GetSignupMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<GetSignupMetadataQuery | undefined, GetSignupMetadataQueryVariables>;
export function useGetSignupMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSignupMetadataQuery, GetSignupMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSignupMetadataQuery, GetSignupMetadataQueryVariables>(GetSignupMetadataDocument, options);
        }
export type GetSignupMetadataQueryHookResult = ReturnType<typeof useGetSignupMetadataQuery>;
export type GetSignupMetadataLazyQueryHookResult = ReturnType<typeof useGetSignupMetadataLazyQuery>;
export type GetSignupMetadataSuspenseQueryHookResult = ReturnType<typeof useGetSignupMetadataSuspenseQuery>;
export type GetSignupMetadataQueryResult = Apollo.QueryResult<GetSignupMetadataQuery, GetSignupMetadataQueryVariables>;
export const GetCaInvoiceAccountsListDocument = gql`
    query getCaInvoiceAccountsList {
  me {
    account {
      id
      invoiceAccounts {
        id
        label
        flexDeferredCustomerId
      }
    }
  }
}
    `;

/**
 * __useGetCaInvoiceAccountsListQuery__
 *
 * To run a query within a React component, call `useGetCaInvoiceAccountsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaInvoiceAccountsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaInvoiceAccountsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCaInvoiceAccountsListQuery(baseOptions?: Apollo.QueryHookOptions<GetCaInvoiceAccountsListQuery, GetCaInvoiceAccountsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaInvoiceAccountsListQuery, GetCaInvoiceAccountsListQueryVariables>(GetCaInvoiceAccountsListDocument, options);
      }
export function useGetCaInvoiceAccountsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaInvoiceAccountsListQuery, GetCaInvoiceAccountsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaInvoiceAccountsListQuery, GetCaInvoiceAccountsListQueryVariables>(GetCaInvoiceAccountsListDocument, options);
        }
// @ts-ignore
export function useGetCaInvoiceAccountsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaInvoiceAccountsListQuery, GetCaInvoiceAccountsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaInvoiceAccountsListQuery, GetCaInvoiceAccountsListQueryVariables>;
export function useGetCaInvoiceAccountsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaInvoiceAccountsListQuery, GetCaInvoiceAccountsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaInvoiceAccountsListQuery | undefined, GetCaInvoiceAccountsListQueryVariables>;
export function useGetCaInvoiceAccountsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaInvoiceAccountsListQuery, GetCaInvoiceAccountsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaInvoiceAccountsListQuery, GetCaInvoiceAccountsListQueryVariables>(GetCaInvoiceAccountsListDocument, options);
        }
export type GetCaInvoiceAccountsListQueryHookResult = ReturnType<typeof useGetCaInvoiceAccountsListQuery>;
export type GetCaInvoiceAccountsListLazyQueryHookResult = ReturnType<typeof useGetCaInvoiceAccountsListLazyQuery>;
export type GetCaInvoiceAccountsListSuspenseQueryHookResult = ReturnType<typeof useGetCaInvoiceAccountsListSuspenseQuery>;
export type GetCaInvoiceAccountsListQueryResult = Apollo.QueryResult<GetCaInvoiceAccountsListQuery, GetCaInvoiceAccountsListQueryVariables>;
export const CustomerOrdersReportDocument = gql`
    query CustomerOrdersReport($input: CustomerOrdersReportInput, $period: TimePeriod!, $dataAggregation: DataAggregation!) {
  customerOrdersReport(input: $input) {
    aggregateByPeriod(period: $period, dataAggregation: $dataAggregation) {
      current {
        amount
        date
      }
      previous {
        amount
        date
      }
    }
    aggregateByUser {
      user
      spend
      orderCount
      averageOrderValue
      numberOfVendors
    }
    aggregateByVendor {
      vendor
      totalSpend
      orderCount
      averageOrderValue
    }
    aggregateByServiceType {
      serviceType
      spend
      orderCount
      percentage
    }
    aggregateByLocation {
      locationLabel
      spend
      orderCount
      percentage
    }
    aggregateByOwnership {
      category
      totalSpend
      orderCount
      averageOrderValue
    }
    aggregateByPostcode {
      postcode
      spend
      orderCount
    }
    aggregateByCity {
      city
      spend
      orderCount
    }
    totals {
      averageOrderValue
      percentageChange
      previousPeriodSpend
      serviceTypeAggregate {
        serviceType
        spend
        orderCount
        percentage
      }
      spendPerHead
      totalSpend
      avgPerOrderPerHead
    }
  }
}
    `;

/**
 * __useCustomerOrdersReportQuery__
 *
 * To run a query within a React component, call `useCustomerOrdersReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerOrdersReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerOrdersReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *      period: // value for 'period'
 *      dataAggregation: // value for 'dataAggregation'
 *   },
 * });
 */
export function useCustomerOrdersReportQuery(baseOptions: Apollo.QueryHookOptions<CustomerOrdersReportQuery, CustomerOrdersReportQueryVariables> & ({ variables: CustomerOrdersReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerOrdersReportQuery, CustomerOrdersReportQueryVariables>(CustomerOrdersReportDocument, options);
      }
export function useCustomerOrdersReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerOrdersReportQuery, CustomerOrdersReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerOrdersReportQuery, CustomerOrdersReportQueryVariables>(CustomerOrdersReportDocument, options);
        }
// @ts-ignore
export function useCustomerOrdersReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerOrdersReportQuery, CustomerOrdersReportQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerOrdersReportQuery, CustomerOrdersReportQueryVariables>;
export function useCustomerOrdersReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerOrdersReportQuery, CustomerOrdersReportQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerOrdersReportQuery | undefined, CustomerOrdersReportQueryVariables>;
export function useCustomerOrdersReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerOrdersReportQuery, CustomerOrdersReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerOrdersReportQuery, CustomerOrdersReportQueryVariables>(CustomerOrdersReportDocument, options);
        }
export type CustomerOrdersReportQueryHookResult = ReturnType<typeof useCustomerOrdersReportQuery>;
export type CustomerOrdersReportLazyQueryHookResult = ReturnType<typeof useCustomerOrdersReportLazyQuery>;
export type CustomerOrdersReportSuspenseQueryHookResult = ReturnType<typeof useCustomerOrdersReportSuspenseQuery>;
export type CustomerOrdersReportQueryResult = Apollo.QueryResult<CustomerOrdersReportQuery, CustomerOrdersReportQueryVariables>;
export const CustomerOrdersReportPagedDocument = gql`
    query CustomerOrdersReportPaged($customerOrdersReportInput: CustomerOrdersReportInput, $allOrdersWithPagingInput: AllOrdersWithPagingInput) {
  customerOrdersReport(input: $customerOrdersReportInput) {
    allOrdersWithPaging(allOrdersWithPagingInput: $allOrdersWithPagingInput) {
      items {
        ...CustomerOrdersAllTypeTable
      }
      pageInfo {
        offset
        limit
        count
        hasMore
      }
    }
  }
}
    ${CustomerOrdersAllTypeTableFragmentDoc}`;

/**
 * __useCustomerOrdersReportPagedQuery__
 *
 * To run a query within a React component, call `useCustomerOrdersReportPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerOrdersReportPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerOrdersReportPagedQuery({
 *   variables: {
 *      customerOrdersReportInput: // value for 'customerOrdersReportInput'
 *      allOrdersWithPagingInput: // value for 'allOrdersWithPagingInput'
 *   },
 * });
 */
export function useCustomerOrdersReportPagedQuery(baseOptions?: Apollo.QueryHookOptions<CustomerOrdersReportPagedQuery, CustomerOrdersReportPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerOrdersReportPagedQuery, CustomerOrdersReportPagedQueryVariables>(CustomerOrdersReportPagedDocument, options);
      }
export function useCustomerOrdersReportPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerOrdersReportPagedQuery, CustomerOrdersReportPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerOrdersReportPagedQuery, CustomerOrdersReportPagedQueryVariables>(CustomerOrdersReportPagedDocument, options);
        }
// @ts-ignore
export function useCustomerOrdersReportPagedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerOrdersReportPagedQuery, CustomerOrdersReportPagedQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerOrdersReportPagedQuery, CustomerOrdersReportPagedQueryVariables>;
export function useCustomerOrdersReportPagedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerOrdersReportPagedQuery, CustomerOrdersReportPagedQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerOrdersReportPagedQuery | undefined, CustomerOrdersReportPagedQueryVariables>;
export function useCustomerOrdersReportPagedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerOrdersReportPagedQuery, CustomerOrdersReportPagedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerOrdersReportPagedQuery, CustomerOrdersReportPagedQueryVariables>(CustomerOrdersReportPagedDocument, options);
        }
export type CustomerOrdersReportPagedQueryHookResult = ReturnType<typeof useCustomerOrdersReportPagedQuery>;
export type CustomerOrdersReportPagedLazyQueryHookResult = ReturnType<typeof useCustomerOrdersReportPagedLazyQuery>;
export type CustomerOrdersReportPagedSuspenseQueryHookResult = ReturnType<typeof useCustomerOrdersReportPagedSuspenseQuery>;
export type CustomerOrdersReportPagedQueryResult = Apollo.QueryResult<CustomerOrdersReportPagedQuery, CustomerOrdersReportPagedQueryVariables>;
export const GetOrdersReportDocument = gql`
    query GetOrdersReport($input: CustomerOrdersReportInput) {
  customerOrdersReport(input: $input) {
    allOrderTypesWithFlexData {
      order {
        invoiceAccountName
        orderNumber
        supplierName
        deliveryAddress
        deliveryDate
        deliveryTime
        contact
        headCount
        total
        subTotal
        orderType
        serviceType
        referenceFields {
          label
          value
        }
      }
      flexInvoiceNumber
    }
  }
}
    `;

/**
 * __useGetOrdersReportQuery__
 *
 * To run a query within a React component, call `useGetOrdersReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrdersReportQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersReportQuery, GetOrdersReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersReportQuery, GetOrdersReportQueryVariables>(GetOrdersReportDocument, options);
      }
export function useGetOrdersReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersReportQuery, GetOrdersReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersReportQuery, GetOrdersReportQueryVariables>(GetOrdersReportDocument, options);
        }
// @ts-ignore
export function useGetOrdersReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrdersReportQuery, GetOrdersReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersReportQuery, GetOrdersReportQueryVariables>;
export function useGetOrdersReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersReportQuery, GetOrdersReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersReportQuery | undefined, GetOrdersReportQueryVariables>;
export function useGetOrdersReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersReportQuery, GetOrdersReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersReportQuery, GetOrdersReportQueryVariables>(GetOrdersReportDocument, options);
        }
export type GetOrdersReportQueryHookResult = ReturnType<typeof useGetOrdersReportQuery>;
export type GetOrdersReportLazyQueryHookResult = ReturnType<typeof useGetOrdersReportLazyQuery>;
export type GetOrdersReportSuspenseQueryHookResult = ReturnType<typeof useGetOrdersReportSuspenseQuery>;
export type GetOrdersReportQueryResult = Apollo.QueryResult<GetOrdersReportQuery, GetOrdersReportQueryVariables>;
export const GetOrderItemsReportDocument = gql`
    query GetOrderItemsReport($input: CustomerOrdersReportInput) {
  customerOrdersReport(input: $input) {
    orderItemsCsv {
      url
    }
  }
}
    `;

/**
 * __useGetOrderItemsReportQuery__
 *
 * To run a query within a React component, call `useGetOrderItemsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderItemsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderItemsReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrderItemsReportQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderItemsReportQuery, GetOrderItemsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderItemsReportQuery, GetOrderItemsReportQueryVariables>(GetOrderItemsReportDocument, options);
      }
export function useGetOrderItemsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderItemsReportQuery, GetOrderItemsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderItemsReportQuery, GetOrderItemsReportQueryVariables>(GetOrderItemsReportDocument, options);
        }
// @ts-ignore
export function useGetOrderItemsReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderItemsReportQuery, GetOrderItemsReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderItemsReportQuery, GetOrderItemsReportQueryVariables>;
export function useGetOrderItemsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderItemsReportQuery, GetOrderItemsReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderItemsReportQuery | undefined, GetOrderItemsReportQueryVariables>;
export function useGetOrderItemsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderItemsReportQuery, GetOrderItemsReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderItemsReportQuery, GetOrderItemsReportQueryVariables>(GetOrderItemsReportDocument, options);
        }
export type GetOrderItemsReportQueryHookResult = ReturnType<typeof useGetOrderItemsReportQuery>;
export type GetOrderItemsReportLazyQueryHookResult = ReturnType<typeof useGetOrderItemsReportLazyQuery>;
export type GetOrderItemsReportSuspenseQueryHookResult = ReturnType<typeof useGetOrderItemsReportSuspenseQuery>;
export type GetOrderItemsReportQueryResult = Apollo.QueryResult<GetOrderItemsReportQuery, GetOrderItemsReportQueryVariables>;
export const GetAccountLocationsDocument = gql`
    query GetAccountLocations($accountId: ID!, $limit: Int, $offset: Int, $filters: AccountLocationFilters) {
  account(id: $accountId) {
    locationsPaged(limit: $limit, offset: $offset, filters: $filters) {
      rows {
        address {
          city
          postcode
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountLocationsQuery__
 *
 * To run a query within a React component, call `useGetAccountLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountLocationsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAccountLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetAccountLocationsQuery, GetAccountLocationsQueryVariables> & ({ variables: GetAccountLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountLocationsQuery, GetAccountLocationsQueryVariables>(GetAccountLocationsDocument, options);
      }
export function useGetAccountLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountLocationsQuery, GetAccountLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountLocationsQuery, GetAccountLocationsQueryVariables>(GetAccountLocationsDocument, options);
        }
// @ts-ignore
export function useGetAccountLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountLocationsQuery, GetAccountLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountLocationsQuery, GetAccountLocationsQueryVariables>;
export function useGetAccountLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountLocationsQuery, GetAccountLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountLocationsQuery | undefined, GetAccountLocationsQueryVariables>;
export function useGetAccountLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountLocationsQuery, GetAccountLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountLocationsQuery, GetAccountLocationsQueryVariables>(GetAccountLocationsDocument, options);
        }
export type GetAccountLocationsQueryHookResult = ReturnType<typeof useGetAccountLocationsQuery>;
export type GetAccountLocationsLazyQueryHookResult = ReturnType<typeof useGetAccountLocationsLazyQuery>;
export type GetAccountLocationsSuspenseQueryHookResult = ReturnType<typeof useGetAccountLocationsSuspenseQuery>;
export type GetAccountLocationsQueryResult = Apollo.QueryResult<GetAccountLocationsQuery, GetAccountLocationsQueryVariables>;
export const GetCaUsersListPageDataDocument = gql`
    query getCaUsersListPageData {
  me {
    account {
      id
      signUpCode
      onboardingLink
      ssoEnabled
      isCCActive
      isGMActive
    }
  }
}
    `;

/**
 * __useGetCaUsersListPageDataQuery__
 *
 * To run a query within a React component, call `useGetCaUsersListPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaUsersListPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaUsersListPageDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCaUsersListPageDataQuery(baseOptions?: Apollo.QueryHookOptions<GetCaUsersListPageDataQuery, GetCaUsersListPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaUsersListPageDataQuery, GetCaUsersListPageDataQueryVariables>(GetCaUsersListPageDataDocument, options);
      }
export function useGetCaUsersListPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaUsersListPageDataQuery, GetCaUsersListPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaUsersListPageDataQuery, GetCaUsersListPageDataQueryVariables>(GetCaUsersListPageDataDocument, options);
        }
// @ts-ignore
export function useGetCaUsersListPageDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaUsersListPageDataQuery, GetCaUsersListPageDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaUsersListPageDataQuery, GetCaUsersListPageDataQueryVariables>;
export function useGetCaUsersListPageDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaUsersListPageDataQuery, GetCaUsersListPageDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaUsersListPageDataQuery | undefined, GetCaUsersListPageDataQueryVariables>;
export function useGetCaUsersListPageDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaUsersListPageDataQuery, GetCaUsersListPageDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaUsersListPageDataQuery, GetCaUsersListPageDataQueryVariables>(GetCaUsersListPageDataDocument, options);
        }
export type GetCaUsersListPageDataQueryHookResult = ReturnType<typeof useGetCaUsersListPageDataQuery>;
export type GetCaUsersListPageDataLazyQueryHookResult = ReturnType<typeof useGetCaUsersListPageDataLazyQuery>;
export type GetCaUsersListPageDataSuspenseQueryHookResult = ReturnType<typeof useGetCaUsersListPageDataSuspenseQuery>;
export type GetCaUsersListPageDataQueryResult = Apollo.QueryResult<GetCaUsersListPageDataQuery, GetCaUsersListPageDataQueryVariables>;
export const GetUserAccountDataDocument = gql`
    query getUserAccountData {
  me {
    id
    firstName
    lastName
    email
    phone
    fullName
    role
    teamId
    invoiceApproved
    privacyAccepted
    contactPreferences {
      ...UserContactPreferences
    }
    languageSettings {
      locale
    }
    dietaryPreferences {
      ...UserDietaryPreferences
    }
    allergens {
      ...UserAllergens
    }
    autopilotSettings {
      enabled
      active
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
      userCanEdit
    }
    accountLocation {
      id
      label
      isCCActive
      isGmActive
      timezone
      address {
        label
        flatOrBuilding
        floorOrBuildingName
        street
        city
        postcode
        country
        latitude
        longitude
      }
    }
    nativeAppSettings {
      hasApp
    }
    account {
      id
      name
      isCCActive
      isGMActive
      topUpEnabled
      ssoEnabled
      autopilotEnabled
      currency
      managerName
      ccTeams {
        id
        name
        code
      }
      locations {
        id
        label
        isCCActive
        isGmActive
        address {
          label
          city
          postcode
          country
        }
      }
    }
  }
}
    ${UserContactPreferencesFragmentDoc}
${UserDietaryPreferencesFragmentDoc}
${UserAllergensFragmentDoc}`;

/**
 * __useGetUserAccountDataQuery__
 *
 * To run a query within a React component, call `useGetUserAccountDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccountDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccountDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAccountDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAccountDataQuery, GetUserAccountDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAccountDataQuery, GetUserAccountDataQueryVariables>(GetUserAccountDataDocument, options);
      }
export function useGetUserAccountDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAccountDataQuery, GetUserAccountDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAccountDataQuery, GetUserAccountDataQueryVariables>(GetUserAccountDataDocument, options);
        }
// @ts-ignore
export function useGetUserAccountDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserAccountDataQuery, GetUserAccountDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserAccountDataQuery, GetUserAccountDataQueryVariables>;
export function useGetUserAccountDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAccountDataQuery, GetUserAccountDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserAccountDataQuery | undefined, GetUserAccountDataQueryVariables>;
export function useGetUserAccountDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAccountDataQuery, GetUserAccountDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAccountDataQuery, GetUserAccountDataQueryVariables>(GetUserAccountDataDocument, options);
        }
export type GetUserAccountDataQueryHookResult = ReturnType<typeof useGetUserAccountDataQuery>;
export type GetUserAccountDataLazyQueryHookResult = ReturnType<typeof useGetUserAccountDataLazyQuery>;
export type GetUserAccountDataSuspenseQueryHookResult = ReturnType<typeof useGetUserAccountDataSuspenseQuery>;
export type GetUserAccountDataQueryResult = Apollo.QueryResult<GetUserAccountDataQuery, GetUserAccountDataQueryVariables>;
export const UpdateUserAllergensDocument = gql`
    mutation UpdateUserAllergens($id: ID!, $input: UpdateUserAllergensInput!) {
  updateUserAllergens(id: $id, input: $input) {
    celery
    cereals
    crustaceans
    eggs
    fish
    lupin
    milk
    molluscs
    mustard
    nuts
    peanuts
    sesame
    soybeans
    sulphur
  }
}
    `;
export type UpdateUserAllergensMutationFn = Apollo.MutationFunction<UpdateUserAllergensMutation, UpdateUserAllergensMutationVariables>;

/**
 * __useUpdateUserAllergensMutation__
 *
 * To run a mutation, you first call `useUpdateUserAllergensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAllergensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAllergensMutation, { data, loading, error }] = useUpdateUserAllergensMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAllergensMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAllergensMutation, UpdateUserAllergensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAllergensMutation, UpdateUserAllergensMutationVariables>(UpdateUserAllergensDocument, options);
      }
export type UpdateUserAllergensMutationHookResult = ReturnType<typeof useUpdateUserAllergensMutation>;
export type UpdateUserAllergensMutationResult = Apollo.MutationResult<UpdateUserAllergensMutation>;
export type UpdateUserAllergensMutationOptions = Apollo.BaseMutationOptions<UpdateUserAllergensMutation, UpdateUserAllergensMutationVariables>;
export const UpdateUserAutopilotSettingsDocument = gql`
    mutation UpdateUserAutopilotSettings($id: ID!, $input: UpdateUserAutopilotSettingsInput!) {
  updateUserAutopilotSettings(id: $id, input: $input) {
    enabled
    active
    monday
    tuesday
    wednesday
    thursday
    friday
    saturday
    sunday
    userCanEdit
  }
}
    `;
export type UpdateUserAutopilotSettingsMutationFn = Apollo.MutationFunction<UpdateUserAutopilotSettingsMutation, UpdateUserAutopilotSettingsMutationVariables>;

/**
 * __useUpdateUserAutopilotSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserAutopilotSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAutopilotSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAutopilotSettingsMutation, { data, loading, error }] = useUpdateUserAutopilotSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAutopilotSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAutopilotSettingsMutation, UpdateUserAutopilotSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAutopilotSettingsMutation, UpdateUserAutopilotSettingsMutationVariables>(UpdateUserAutopilotSettingsDocument, options);
      }
export type UpdateUserAutopilotSettingsMutationHookResult = ReturnType<typeof useUpdateUserAutopilotSettingsMutation>;
export type UpdateUserAutopilotSettingsMutationResult = Apollo.MutationResult<UpdateUserAutopilotSettingsMutation>;
export type UpdateUserAutopilotSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserAutopilotSettingsMutation, UpdateUserAutopilotSettingsMutationVariables>;
export const UpdateUserDietaryPreferencesDocument = gql`
    mutation UpdateUserDietaryPreferences($id: ID!, $input: UpdateUserDietaryPreferencesInput!) {
  updateUserDietaryPreferences(id: $id, input: $input) {
    vegan
    vegetarian
    halal
    kosher
    refinedSugar
  }
}
    `;
export type UpdateUserDietaryPreferencesMutationFn = Apollo.MutationFunction<UpdateUserDietaryPreferencesMutation, UpdateUserDietaryPreferencesMutationVariables>;

/**
 * __useUpdateUserDietaryPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserDietaryPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDietaryPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDietaryPreferencesMutation, { data, loading, error }] = useUpdateUserDietaryPreferencesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserDietaryPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDietaryPreferencesMutation, UpdateUserDietaryPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDietaryPreferencesMutation, UpdateUserDietaryPreferencesMutationVariables>(UpdateUserDietaryPreferencesDocument, options);
      }
export type UpdateUserDietaryPreferencesMutationHookResult = ReturnType<typeof useUpdateUserDietaryPreferencesMutation>;
export type UpdateUserDietaryPreferencesMutationResult = Apollo.MutationResult<UpdateUserDietaryPreferencesMutation>;
export type UpdateUserDietaryPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateUserDietaryPreferencesMutation, UpdateUserDietaryPreferencesMutationVariables>;
export const GetDashboardCcOrdersDataDocument = gql`
    query getDashboardCCOrdersData {
  me {
    id
    role
    account {
      id
      name
      userInterfaceSettings {
        hideCCPrices
      }
      locationsPaged(filters: {isCCActive: true}) {
        rows {
          id
          label
        }
      }
    }
  }
}
    `;

/**
 * __useGetDashboardCcOrdersDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardCcOrdersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardCcOrdersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardCcOrdersDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardCcOrdersDataQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardCcOrdersDataQuery, GetDashboardCcOrdersDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardCcOrdersDataQuery, GetDashboardCcOrdersDataQueryVariables>(GetDashboardCcOrdersDataDocument, options);
      }
export function useGetDashboardCcOrdersDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardCcOrdersDataQuery, GetDashboardCcOrdersDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardCcOrdersDataQuery, GetDashboardCcOrdersDataQueryVariables>(GetDashboardCcOrdersDataDocument, options);
        }
// @ts-ignore
export function useGetDashboardCcOrdersDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDashboardCcOrdersDataQuery, GetDashboardCcOrdersDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardCcOrdersDataQuery, GetDashboardCcOrdersDataQueryVariables>;
export function useGetDashboardCcOrdersDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardCcOrdersDataQuery, GetDashboardCcOrdersDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardCcOrdersDataQuery | undefined, GetDashboardCcOrdersDataQueryVariables>;
export function useGetDashboardCcOrdersDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardCcOrdersDataQuery, GetDashboardCcOrdersDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardCcOrdersDataQuery, GetDashboardCcOrdersDataQueryVariables>(GetDashboardCcOrdersDataDocument, options);
        }
export type GetDashboardCcOrdersDataQueryHookResult = ReturnType<typeof useGetDashboardCcOrdersDataQuery>;
export type GetDashboardCcOrdersDataLazyQueryHookResult = ReturnType<typeof useGetDashboardCcOrdersDataLazyQuery>;
export type GetDashboardCcOrdersDataSuspenseQueryHookResult = ReturnType<typeof useGetDashboardCcOrdersDataSuspenseQuery>;
export type GetDashboardCcOrdersDataQueryResult = Apollo.QueryResult<GetDashboardCcOrdersDataQuery, GetDashboardCcOrdersDataQueryVariables>;
export const CancelCcOrderItemDocument = gql`
    mutation CancelCCOrderItem($id: Int!) {
  deleteCCOrderItem(id: $id) {
    id
  }
}
    `;
export type CancelCcOrderItemMutationFn = Apollo.MutationFunction<CancelCcOrderItemMutation, CancelCcOrderItemMutationVariables>;

/**
 * __useCancelCcOrderItemMutation__
 *
 * To run a mutation, you first call `useCancelCcOrderItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCcOrderItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCcOrderItemMutation, { data, loading, error }] = useCancelCcOrderItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelCcOrderItemMutation(baseOptions?: Apollo.MutationHookOptions<CancelCcOrderItemMutation, CancelCcOrderItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCcOrderItemMutation, CancelCcOrderItemMutationVariables>(CancelCcOrderItemDocument, options);
      }
export type CancelCcOrderItemMutationHookResult = ReturnType<typeof useCancelCcOrderItemMutation>;
export type CancelCcOrderItemMutationResult = Apollo.MutationResult<CancelCcOrderItemMutation>;
export type CancelCcOrderItemMutationOptions = Apollo.BaseMutationOptions<CancelCcOrderItemMutation, CancelCcOrderItemMutationVariables>;
export const GetDashboardCanteenTeamsDocument = gql`
    query getDashboardCanteenTeams {
  me {
    account {
      id
      isCCActive
      onboardingLink
      signUpCode
      locationsPaged(filters: {isCCActive: true}) {
        rows {
          id
          label
          ccAvailabilities {
            rows {
              weekday
              meal
            }
          }
        }
      }
      ccTeams {
        id
        code
        name
        users {
          id
          fullName
          email
        }
      }
    }
  }
}
    `;

/**
 * __useGetDashboardCanteenTeamsQuery__
 *
 * To run a query within a React component, call `useGetDashboardCanteenTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardCanteenTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardCanteenTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardCanteenTeamsQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardCanteenTeamsQuery, GetDashboardCanteenTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardCanteenTeamsQuery, GetDashboardCanteenTeamsQueryVariables>(GetDashboardCanteenTeamsDocument, options);
      }
export function useGetDashboardCanteenTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardCanteenTeamsQuery, GetDashboardCanteenTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardCanteenTeamsQuery, GetDashboardCanteenTeamsQueryVariables>(GetDashboardCanteenTeamsDocument, options);
        }
// @ts-ignore
export function useGetDashboardCanteenTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDashboardCanteenTeamsQuery, GetDashboardCanteenTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardCanteenTeamsQuery, GetDashboardCanteenTeamsQueryVariables>;
export function useGetDashboardCanteenTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardCanteenTeamsQuery, GetDashboardCanteenTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardCanteenTeamsQuery | undefined, GetDashboardCanteenTeamsQueryVariables>;
export function useGetDashboardCanteenTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardCanteenTeamsQuery, GetDashboardCanteenTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardCanteenTeamsQuery, GetDashboardCanteenTeamsQueryVariables>(GetDashboardCanteenTeamsDocument, options);
        }
export type GetDashboardCanteenTeamsQueryHookResult = ReturnType<typeof useGetDashboardCanteenTeamsQuery>;
export type GetDashboardCanteenTeamsLazyQueryHookResult = ReturnType<typeof useGetDashboardCanteenTeamsLazyQuery>;
export type GetDashboardCanteenTeamsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardCanteenTeamsSuspenseQuery>;
export type GetDashboardCanteenTeamsQueryResult = Apollo.QueryResult<GetDashboardCanteenTeamsQuery, GetDashboardCanteenTeamsQueryVariables>;
export const GetTeamSubsidiesDocument = gql`
    query getTeamSubsidies($teamId: Int!) {
  ccTeamSubsidies(teamId: $teamId) {
    ...CcSubsidyFields
  }
}
    ${CcSubsidyFieldsFragmentDoc}`;

/**
 * __useGetTeamSubsidiesQuery__
 *
 * To run a query within a React component, call `useGetTeamSubsidiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamSubsidiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamSubsidiesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamSubsidiesQuery(baseOptions: Apollo.QueryHookOptions<GetTeamSubsidiesQuery, GetTeamSubsidiesQueryVariables> & ({ variables: GetTeamSubsidiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamSubsidiesQuery, GetTeamSubsidiesQueryVariables>(GetTeamSubsidiesDocument, options);
      }
export function useGetTeamSubsidiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamSubsidiesQuery, GetTeamSubsidiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamSubsidiesQuery, GetTeamSubsidiesQueryVariables>(GetTeamSubsidiesDocument, options);
        }
// @ts-ignore
export function useGetTeamSubsidiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamSubsidiesQuery, GetTeamSubsidiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTeamSubsidiesQuery, GetTeamSubsidiesQueryVariables>;
export function useGetTeamSubsidiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamSubsidiesQuery, GetTeamSubsidiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTeamSubsidiesQuery | undefined, GetTeamSubsidiesQueryVariables>;
export function useGetTeamSubsidiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamSubsidiesQuery, GetTeamSubsidiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamSubsidiesQuery, GetTeamSubsidiesQueryVariables>(GetTeamSubsidiesDocument, options);
        }
export type GetTeamSubsidiesQueryHookResult = ReturnType<typeof useGetTeamSubsidiesQuery>;
export type GetTeamSubsidiesLazyQueryHookResult = ReturnType<typeof useGetTeamSubsidiesLazyQuery>;
export type GetTeamSubsidiesSuspenseQueryHookResult = ReturnType<typeof useGetTeamSubsidiesSuspenseQuery>;
export type GetTeamSubsidiesQueryResult = Apollo.QueryResult<GetTeamSubsidiesQuery, GetTeamSubsidiesQueryVariables>;
export const SetTeamSubsidiesDocument = gql`
    mutation setTeamSubsidies($teamId: Int!, $subsidies: [SubsidyInput!]!) {
  setTeamSubsidies(teamId: $teamId, subsidies: $subsidies) {
    ...CcSubsidyFields
  }
}
    ${CcSubsidyFieldsFragmentDoc}`;
export type SetTeamSubsidiesMutationFn = Apollo.MutationFunction<SetTeamSubsidiesMutation, SetTeamSubsidiesMutationVariables>;

/**
 * __useSetTeamSubsidiesMutation__
 *
 * To run a mutation, you first call `useSetTeamSubsidiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeamSubsidiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeamSubsidiesMutation, { data, loading, error }] = useSetTeamSubsidiesMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      subsidies: // value for 'subsidies'
 *   },
 * });
 */
export function useSetTeamSubsidiesMutation(baseOptions?: Apollo.MutationHookOptions<SetTeamSubsidiesMutation, SetTeamSubsidiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeamSubsidiesMutation, SetTeamSubsidiesMutationVariables>(SetTeamSubsidiesDocument, options);
      }
export type SetTeamSubsidiesMutationHookResult = ReturnType<typeof useSetTeamSubsidiesMutation>;
export type SetTeamSubsidiesMutationResult = Apollo.MutationResult<SetTeamSubsidiesMutation>;
export type SetTeamSubsidiesMutationOptions = Apollo.BaseMutationOptions<SetTeamSubsidiesMutation, SetTeamSubsidiesMutationVariables>;
export const CreateCanteenTeamDocument = gql`
    mutation createCanteenTeam($accountId: Int!, $input: CreateCCTeamInput!) {
  createCCTeam(accountId: $accountId, input: $input) {
    id
    name
  }
}
    `;
export type CreateCanteenTeamMutationFn = Apollo.MutationFunction<CreateCanteenTeamMutation, CreateCanteenTeamMutationVariables>;

/**
 * __useCreateCanteenTeamMutation__
 *
 * To run a mutation, you first call `useCreateCanteenTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCanteenTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCanteenTeamMutation, { data, loading, error }] = useCreateCanteenTeamMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCanteenTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateCanteenTeamMutation, CreateCanteenTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCanteenTeamMutation, CreateCanteenTeamMutationVariables>(CreateCanteenTeamDocument, options);
      }
export type CreateCanteenTeamMutationHookResult = ReturnType<typeof useCreateCanteenTeamMutation>;
export type CreateCanteenTeamMutationResult = Apollo.MutationResult<CreateCanteenTeamMutation>;
export type CreateCanteenTeamMutationOptions = Apollo.BaseMutationOptions<CreateCanteenTeamMutation, CreateCanteenTeamMutationVariables>;
export const AssignCanteenTeamUserDocument = gql`
    mutation assignCanteenTeamUser($teamId: Int!, $userIds: [Int!]!) {
  assignUsersToTeam(teamId: $teamId, userIds: $userIds) {
    success
    message
  }
}
    `;
export type AssignCanteenTeamUserMutationFn = Apollo.MutationFunction<AssignCanteenTeamUserMutation, AssignCanteenTeamUserMutationVariables>;

/**
 * __useAssignCanteenTeamUserMutation__
 *
 * To run a mutation, you first call `useAssignCanteenTeamUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCanteenTeamUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCanteenTeamUserMutation, { data, loading, error }] = useAssignCanteenTeamUserMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useAssignCanteenTeamUserMutation(baseOptions?: Apollo.MutationHookOptions<AssignCanteenTeamUserMutation, AssignCanteenTeamUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCanteenTeamUserMutation, AssignCanteenTeamUserMutationVariables>(AssignCanteenTeamUserDocument, options);
      }
export type AssignCanteenTeamUserMutationHookResult = ReturnType<typeof useAssignCanteenTeamUserMutation>;
export type AssignCanteenTeamUserMutationResult = Apollo.MutationResult<AssignCanteenTeamUserMutation>;
export type AssignCanteenTeamUserMutationOptions = Apollo.BaseMutationOptions<AssignCanteenTeamUserMutation, AssignCanteenTeamUserMutationVariables>;
export const RemoveCanteenTeamUserDocument = gql`
    mutation removeCanteenTeamUser($userIds: [Int!]!) {
  assignUsersToTeam(teamId: null, userIds: $userIds) {
    success
    message
  }
}
    `;
export type RemoveCanteenTeamUserMutationFn = Apollo.MutationFunction<RemoveCanteenTeamUserMutation, RemoveCanteenTeamUserMutationVariables>;

/**
 * __useRemoveCanteenTeamUserMutation__
 *
 * To run a mutation, you first call `useRemoveCanteenTeamUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCanteenTeamUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCanteenTeamUserMutation, { data, loading, error }] = useRemoveCanteenTeamUserMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useRemoveCanteenTeamUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCanteenTeamUserMutation, RemoveCanteenTeamUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCanteenTeamUserMutation, RemoveCanteenTeamUserMutationVariables>(RemoveCanteenTeamUserDocument, options);
      }
export type RemoveCanteenTeamUserMutationHookResult = ReturnType<typeof useRemoveCanteenTeamUserMutation>;
export type RemoveCanteenTeamUserMutationResult = Apollo.MutationResult<RemoveCanteenTeamUserMutation>;
export type RemoveCanteenTeamUserMutationOptions = Apollo.BaseMutationOptions<RemoveCanteenTeamUserMutation, RemoveCanteenTeamUserMutationVariables>;
export const SearchCanteenTeamUsersDocument = gql`
    query searchCanteenTeamUsers($input: UserSearch!) {
  users(input: $input) {
    rows {
      id
      fullName
      email
      teamId
    }
  }
}
    `;

/**
 * __useSearchCanteenTeamUsersQuery__
 *
 * To run a query within a React component, call `useSearchCanteenTeamUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCanteenTeamUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCanteenTeamUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchCanteenTeamUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchCanteenTeamUsersQuery, SearchCanteenTeamUsersQueryVariables> & ({ variables: SearchCanteenTeamUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCanteenTeamUsersQuery, SearchCanteenTeamUsersQueryVariables>(SearchCanteenTeamUsersDocument, options);
      }
export function useSearchCanteenTeamUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCanteenTeamUsersQuery, SearchCanteenTeamUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCanteenTeamUsersQuery, SearchCanteenTeamUsersQueryVariables>(SearchCanteenTeamUsersDocument, options);
        }
// @ts-ignore
export function useSearchCanteenTeamUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchCanteenTeamUsersQuery, SearchCanteenTeamUsersQueryVariables>): Apollo.UseSuspenseQueryResult<SearchCanteenTeamUsersQuery, SearchCanteenTeamUsersQueryVariables>;
export function useSearchCanteenTeamUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCanteenTeamUsersQuery, SearchCanteenTeamUsersQueryVariables>): Apollo.UseSuspenseQueryResult<SearchCanteenTeamUsersQuery | undefined, SearchCanteenTeamUsersQueryVariables>;
export function useSearchCanteenTeamUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCanteenTeamUsersQuery, SearchCanteenTeamUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCanteenTeamUsersQuery, SearchCanteenTeamUsersQueryVariables>(SearchCanteenTeamUsersDocument, options);
        }
export type SearchCanteenTeamUsersQueryHookResult = ReturnType<typeof useSearchCanteenTeamUsersQuery>;
export type SearchCanteenTeamUsersLazyQueryHookResult = ReturnType<typeof useSearchCanteenTeamUsersLazyQuery>;
export type SearchCanteenTeamUsersSuspenseQueryHookResult = ReturnType<typeof useSearchCanteenTeamUsersSuspenseQuery>;
export type SearchCanteenTeamUsersQueryResult = Apollo.QueryResult<SearchCanteenTeamUsersQuery, SearchCanteenTeamUsersQueryVariables>;
export const UpdateCanteenTeamDocument = gql`
    mutation updateCanteenTeam($id: Int!, $input: UpdateCCTeamInput!) {
  updateCCTeam(id: $id, input: $input) {
    id
    name
    code
  }
}
    `;
export type UpdateCanteenTeamMutationFn = Apollo.MutationFunction<UpdateCanteenTeamMutation, UpdateCanteenTeamMutationVariables>;

/**
 * __useUpdateCanteenTeamMutation__
 *
 * To run a mutation, you first call `useUpdateCanteenTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCanteenTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCanteenTeamMutation, { data, loading, error }] = useUpdateCanteenTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCanteenTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCanteenTeamMutation, UpdateCanteenTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCanteenTeamMutation, UpdateCanteenTeamMutationVariables>(UpdateCanteenTeamDocument, options);
      }
export type UpdateCanteenTeamMutationHookResult = ReturnType<typeof useUpdateCanteenTeamMutation>;
export type UpdateCanteenTeamMutationResult = Apollo.MutationResult<UpdateCanteenTeamMutation>;
export type UpdateCanteenTeamMutationOptions = Apollo.BaseMutationOptions<UpdateCanteenTeamMutation, UpdateCanteenTeamMutationVariables>;
export const DeleteCanteenTeamDocument = gql`
    mutation deleteCanteenTeam($id: Int!) {
  deleteCCTeam(id: $id) {
    success
    message
  }
}
    `;
export type DeleteCanteenTeamMutationFn = Apollo.MutationFunction<DeleteCanteenTeamMutation, DeleteCanteenTeamMutationVariables>;

/**
 * __useDeleteCanteenTeamMutation__
 *
 * To run a mutation, you first call `useDeleteCanteenTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCanteenTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCanteenTeamMutation, { data, loading, error }] = useDeleteCanteenTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCanteenTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCanteenTeamMutation, DeleteCanteenTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCanteenTeamMutation, DeleteCanteenTeamMutationVariables>(DeleteCanteenTeamDocument, options);
      }
export type DeleteCanteenTeamMutationHookResult = ReturnType<typeof useDeleteCanteenTeamMutation>;
export type DeleteCanteenTeamMutationResult = Apollo.MutationResult<DeleteCanteenTeamMutation>;
export type DeleteCanteenTeamMutationOptions = Apollo.BaseMutationOptions<DeleteCanteenTeamMutation, DeleteCanteenTeamMutationVariables>;
export const DeleteAccountLocationDocument = gql`
    mutation DeleteAccountLocation($id: Int!) {
  deleteAccountLocation(id: $id) {
    success
    message
    location {
      id
      label
      deletedAt
    }
  }
}
    `;
export type DeleteAccountLocationMutationFn = Apollo.MutationFunction<DeleteAccountLocationMutation, DeleteAccountLocationMutationVariables>;

/**
 * __useDeleteAccountLocationMutation__
 *
 * To run a mutation, you first call `useDeleteAccountLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountLocationMutation, { data, loading, error }] = useDeleteAccountLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountLocationMutation, DeleteAccountLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountLocationMutation, DeleteAccountLocationMutationVariables>(DeleteAccountLocationDocument, options);
      }
export type DeleteAccountLocationMutationHookResult = ReturnType<typeof useDeleteAccountLocationMutation>;
export type DeleteAccountLocationMutationResult = Apollo.MutationResult<DeleteAccountLocationMutation>;
export type DeleteAccountLocationMutationOptions = Apollo.BaseMutationOptions<DeleteAccountLocationMutation, DeleteAccountLocationMutationVariables>;
export const CcConfirmationUpcomingMenusDocument = gql`
    query ccConfirmationUpcomingMenus {
  me {
    accountLocation {
      timezone
    }
    upcomingCcMenus {
      date
      lunch {
        ...CCMealServiceForConfirmation
      }
      dinner {
        ...CCMealServiceForConfirmation
      }
      breakfast {
        ...CCMealServiceForConfirmation
      }
    }
  }
}
    ${CcMealServiceForConfirmationFragmentDoc}`;

/**
 * __useCcConfirmationUpcomingMenusQuery__
 *
 * To run a query within a React component, call `useCcConfirmationUpcomingMenusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCcConfirmationUpcomingMenusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCcConfirmationUpcomingMenusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCcConfirmationUpcomingMenusQuery(baseOptions?: Apollo.QueryHookOptions<CcConfirmationUpcomingMenusQuery, CcConfirmationUpcomingMenusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CcConfirmationUpcomingMenusQuery, CcConfirmationUpcomingMenusQueryVariables>(CcConfirmationUpcomingMenusDocument, options);
      }
export function useCcConfirmationUpcomingMenusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CcConfirmationUpcomingMenusQuery, CcConfirmationUpcomingMenusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CcConfirmationUpcomingMenusQuery, CcConfirmationUpcomingMenusQueryVariables>(CcConfirmationUpcomingMenusDocument, options);
        }
// @ts-ignore
export function useCcConfirmationUpcomingMenusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CcConfirmationUpcomingMenusQuery, CcConfirmationUpcomingMenusQueryVariables>): Apollo.UseSuspenseQueryResult<CcConfirmationUpcomingMenusQuery, CcConfirmationUpcomingMenusQueryVariables>;
export function useCcConfirmationUpcomingMenusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CcConfirmationUpcomingMenusQuery, CcConfirmationUpcomingMenusQueryVariables>): Apollo.UseSuspenseQueryResult<CcConfirmationUpcomingMenusQuery | undefined, CcConfirmationUpcomingMenusQueryVariables>;
export function useCcConfirmationUpcomingMenusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CcConfirmationUpcomingMenusQuery, CcConfirmationUpcomingMenusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CcConfirmationUpcomingMenusQuery, CcConfirmationUpcomingMenusQueryVariables>(CcConfirmationUpcomingMenusDocument, options);
        }
export type CcConfirmationUpcomingMenusQueryHookResult = ReturnType<typeof useCcConfirmationUpcomingMenusQuery>;
export type CcConfirmationUpcomingMenusLazyQueryHookResult = ReturnType<typeof useCcConfirmationUpcomingMenusLazyQuery>;
export type CcConfirmationUpcomingMenusSuspenseQueryHookResult = ReturnType<typeof useCcConfirmationUpcomingMenusSuspenseQuery>;
export type CcConfirmationUpcomingMenusQueryResult = Apollo.QueryResult<CcConfirmationUpcomingMenusQuery, CcConfirmationUpcomingMenusQueryVariables>;
export const CcOrderByTransactionDocument = gql`
    query ccOrderByTransaction($transactionId: String!) {
  ccOrderByTransaction(transactionId: $transactionId) {
    reference
    date
    meal
    timeSlot {
      start
      end
    }
    address {
      line1
      line2
      city
      postcode
      location
    }
    subsidyCreditsUsed
    personalCreditsUsed
    subtotal
    total
    currency
    hidePrices
    itemsByVendor {
      vendor {
        id
        companyName
      }
      items {
        ...OrderConfirmationItemDetails
      }
      supplierOrder {
        id
        reference
        arrivalTime
        duration
      }
    }
  }
}
    ${OrderConfirmationItemDetailsFragmentDoc}`;

/**
 * __useCcOrderByTransactionQuery__
 *
 * To run a query within a React component, call `useCcOrderByTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCcOrderByTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCcOrderByTransactionQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useCcOrderByTransactionQuery(baseOptions: Apollo.QueryHookOptions<CcOrderByTransactionQuery, CcOrderByTransactionQueryVariables> & ({ variables: CcOrderByTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CcOrderByTransactionQuery, CcOrderByTransactionQueryVariables>(CcOrderByTransactionDocument, options);
      }
export function useCcOrderByTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CcOrderByTransactionQuery, CcOrderByTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CcOrderByTransactionQuery, CcOrderByTransactionQueryVariables>(CcOrderByTransactionDocument, options);
        }
// @ts-ignore
export function useCcOrderByTransactionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CcOrderByTransactionQuery, CcOrderByTransactionQueryVariables>): Apollo.UseSuspenseQueryResult<CcOrderByTransactionQuery, CcOrderByTransactionQueryVariables>;
export function useCcOrderByTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CcOrderByTransactionQuery, CcOrderByTransactionQueryVariables>): Apollo.UseSuspenseQueryResult<CcOrderByTransactionQuery | undefined, CcOrderByTransactionQueryVariables>;
export function useCcOrderByTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CcOrderByTransactionQuery, CcOrderByTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CcOrderByTransactionQuery, CcOrderByTransactionQueryVariables>(CcOrderByTransactionDocument, options);
        }
export type CcOrderByTransactionQueryHookResult = ReturnType<typeof useCcOrderByTransactionQuery>;
export type CcOrderByTransactionLazyQueryHookResult = ReturnType<typeof useCcOrderByTransactionLazyQuery>;
export type CcOrderByTransactionSuspenseQueryHookResult = ReturnType<typeof useCcOrderByTransactionSuspenseQuery>;
export type CcOrderByTransactionQueryResult = Apollo.QueryResult<CcOrderByTransactionQuery, CcOrderByTransactionQueryVariables>;
export const TrackingUserOrderInfoDocument = gql`
    query TrackingUserOrderInfo($date: DateTime!) {
  me {
    id
    groupedOrderItemsByDate(input: {date: $date}) {
      id
      orderItems {
        id
        transactionId
        name
        fullPrice
        qty
      }
      supplierOrder {
        id
        meal
        arrivalTime
        arrivalTimeEnd
        vendor {
          id
          companyName
          logo
          currency
        }
        vendorLocation {
          id
          lat
          lng
        }
        ccAccountLocationOrders {
          accountLocation {
            id
            label
            lat
            lng
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTrackingUserOrderInfoQuery__
 *
 * To run a query within a React component, call `useTrackingUserOrderInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackingUserOrderInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackingUserOrderInfoQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTrackingUserOrderInfoQuery(baseOptions: Apollo.QueryHookOptions<TrackingUserOrderInfoQuery, TrackingUserOrderInfoQueryVariables> & ({ variables: TrackingUserOrderInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackingUserOrderInfoQuery, TrackingUserOrderInfoQueryVariables>(TrackingUserOrderInfoDocument, options);
      }
export function useTrackingUserOrderInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackingUserOrderInfoQuery, TrackingUserOrderInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackingUserOrderInfoQuery, TrackingUserOrderInfoQueryVariables>(TrackingUserOrderInfoDocument, options);
        }
// @ts-ignore
export function useTrackingUserOrderInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrackingUserOrderInfoQuery, TrackingUserOrderInfoQueryVariables>): Apollo.UseSuspenseQueryResult<TrackingUserOrderInfoQuery, TrackingUserOrderInfoQueryVariables>;
export function useTrackingUserOrderInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrackingUserOrderInfoQuery, TrackingUserOrderInfoQueryVariables>): Apollo.UseSuspenseQueryResult<TrackingUserOrderInfoQuery | undefined, TrackingUserOrderInfoQueryVariables>;
export function useTrackingUserOrderInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrackingUserOrderInfoQuery, TrackingUserOrderInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrackingUserOrderInfoQuery, TrackingUserOrderInfoQueryVariables>(TrackingUserOrderInfoDocument, options);
        }
export type TrackingUserOrderInfoQueryHookResult = ReturnType<typeof useTrackingUserOrderInfoQuery>;
export type TrackingUserOrderInfoLazyQueryHookResult = ReturnType<typeof useTrackingUserOrderInfoLazyQuery>;
export type TrackingUserOrderInfoSuspenseQueryHookResult = ReturnType<typeof useTrackingUserOrderInfoSuspenseQuery>;
export type TrackingUserOrderInfoQueryResult = Apollo.QueryResult<TrackingUserOrderInfoQuery, TrackingUserOrderInfoQueryVariables>;
export const TrackingCaClusterOrdersDocument = gql`
    query TrackingCaClusterOrders($clusterId: ID!, $date: DateTime!) {
  ccCluster(input: {id: $clusterId}) {
    id
    name
    ccSupplierOrders(input: {date: $date, limit: 100}) {
      rows {
        id
        date
        arrivalTime
        arrivalTimeEnd
        vendor {
          id
          companyName
          logo
          currency
        }
        vendorLocation {
          id
          lat
          lng
        }
        ccAccountLocationOrders {
          accountLocation {
            id
            label
            lat
            lng
          }
        }
      }
      pageInfo {
        offset
        limit
        count
        hasMore
      }
    }
  }
}
    `;

/**
 * __useTrackingCaClusterOrdersQuery__
 *
 * To run a query within a React component, call `useTrackingCaClusterOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackingCaClusterOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackingCaClusterOrdersQuery({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTrackingCaClusterOrdersQuery(baseOptions: Apollo.QueryHookOptions<TrackingCaClusterOrdersQuery, TrackingCaClusterOrdersQueryVariables> & ({ variables: TrackingCaClusterOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackingCaClusterOrdersQuery, TrackingCaClusterOrdersQueryVariables>(TrackingCaClusterOrdersDocument, options);
      }
export function useTrackingCaClusterOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackingCaClusterOrdersQuery, TrackingCaClusterOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackingCaClusterOrdersQuery, TrackingCaClusterOrdersQueryVariables>(TrackingCaClusterOrdersDocument, options);
        }
// @ts-ignore
export function useTrackingCaClusterOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrackingCaClusterOrdersQuery, TrackingCaClusterOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<TrackingCaClusterOrdersQuery, TrackingCaClusterOrdersQueryVariables>;
export function useTrackingCaClusterOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrackingCaClusterOrdersQuery, TrackingCaClusterOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<TrackingCaClusterOrdersQuery | undefined, TrackingCaClusterOrdersQueryVariables>;
export function useTrackingCaClusterOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrackingCaClusterOrdersQuery, TrackingCaClusterOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrackingCaClusterOrdersQuery, TrackingCaClusterOrdersQueryVariables>(TrackingCaClusterOrdersDocument, options);
        }
export type TrackingCaClusterOrdersQueryHookResult = ReturnType<typeof useTrackingCaClusterOrdersQuery>;
export type TrackingCaClusterOrdersLazyQueryHookResult = ReturnType<typeof useTrackingCaClusterOrdersLazyQuery>;
export type TrackingCaClusterOrdersSuspenseQueryHookResult = ReturnType<typeof useTrackingCaClusterOrdersSuspenseQuery>;
export type TrackingCaClusterOrdersQueryResult = Apollo.QueryResult<TrackingCaClusterOrdersQuery, TrackingCaClusterOrdersQueryVariables>;
export const GetAccountsForSignupConfirmationDocument = gql`
    query getAccountsForSignupConfirmation($name: String!) {
  accounts(input: {name: $name, limit: 20}) {
    rows {
      id
      name
      isCCActive
    }
  }
}
    `;

/**
 * __useGetAccountsForSignupConfirmationQuery__
 *
 * To run a query within a React component, call `useGetAccountsForSignupConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsForSignupConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsForSignupConfirmationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAccountsForSignupConfirmationQuery(baseOptions: Apollo.QueryHookOptions<GetAccountsForSignupConfirmationQuery, GetAccountsForSignupConfirmationQueryVariables> & ({ variables: GetAccountsForSignupConfirmationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsForSignupConfirmationQuery, GetAccountsForSignupConfirmationQueryVariables>(GetAccountsForSignupConfirmationDocument, options);
      }
export function useGetAccountsForSignupConfirmationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsForSignupConfirmationQuery, GetAccountsForSignupConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsForSignupConfirmationQuery, GetAccountsForSignupConfirmationQueryVariables>(GetAccountsForSignupConfirmationDocument, options);
        }
// @ts-ignore
export function useGetAccountsForSignupConfirmationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountsForSignupConfirmationQuery, GetAccountsForSignupConfirmationQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountsForSignupConfirmationQuery, GetAccountsForSignupConfirmationQueryVariables>;
export function useGetAccountsForSignupConfirmationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountsForSignupConfirmationQuery, GetAccountsForSignupConfirmationQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountsForSignupConfirmationQuery | undefined, GetAccountsForSignupConfirmationQueryVariables>;
export function useGetAccountsForSignupConfirmationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountsForSignupConfirmationQuery, GetAccountsForSignupConfirmationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountsForSignupConfirmationQuery, GetAccountsForSignupConfirmationQueryVariables>(GetAccountsForSignupConfirmationDocument, options);
        }
export type GetAccountsForSignupConfirmationQueryHookResult = ReturnType<typeof useGetAccountsForSignupConfirmationQuery>;
export type GetAccountsForSignupConfirmationLazyQueryHookResult = ReturnType<typeof useGetAccountsForSignupConfirmationLazyQuery>;
export type GetAccountsForSignupConfirmationSuspenseQueryHookResult = ReturnType<typeof useGetAccountsForSignupConfirmationSuspenseQuery>;
export type GetAccountsForSignupConfirmationQueryResult = Apollo.QueryResult<GetAccountsForSignupConfirmationQuery, GetAccountsForSignupConfirmationQueryVariables>;
export const ResendSignupConfirmationDocument = gql`
    mutation resendSignupConfirmation($email: String!, $input: SignupConfirmationInput!) {
  resendSignupConfirmation(email: $email, input: $input)
}
    `;
export type ResendSignupConfirmationMutationFn = Apollo.MutationFunction<ResendSignupConfirmationMutation, ResendSignupConfirmationMutationVariables>;

/**
 * __useResendSignupConfirmationMutation__
 *
 * To run a mutation, you first call `useResendSignupConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendSignupConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendSignupConfirmationMutation, { data, loading, error }] = useResendSignupConfirmationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendSignupConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<ResendSignupConfirmationMutation, ResendSignupConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendSignupConfirmationMutation, ResendSignupConfirmationMutationVariables>(ResendSignupConfirmationDocument, options);
      }
export type ResendSignupConfirmationMutationHookResult = ReturnType<typeof useResendSignupConfirmationMutation>;
export type ResendSignupConfirmationMutationResult = Apollo.MutationResult<ResendSignupConfirmationMutation>;
export type ResendSignupConfirmationMutationOptions = Apollo.BaseMutationOptions<ResendSignupConfirmationMutation, ResendSignupConfirmationMutationVariables>;
export const GetUserForEditDocument = gql`
    query getUserForEdit($id: ID!, $accountId: Int) {
  user(id: $id, accountId: $accountId) {
    id
    firstName
    lastName
    email
    phone
    fullName
    role
    teamId
    invoiceApproved
    privacyAccepted
    contactPreferences {
      ...UserContactPreferences
    }
    languageSettings {
      locale
    }
    dietaryPreferences {
      ...UserDietaryPreferences
    }
    allergens {
      ...UserAllergens
    }
    autopilotSettings {
      enabled
      active
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
      userCanEdit
    }
    accountLocation {
      id
      label
      isCCActive
      isGmActive
      timezone
      address {
        label
        flatOrBuilding
        floorOrBuildingName
        street
        city
        postcode
        country
        latitude
        longitude
      }
    }
    nativeAppSettings {
      hasApp
    }
    accountSettings {
      costCentre
    }
    subsidySettings {
      unlimitedSubsidy
    }
    wallet {
      balance
    }
    account {
      id
      name
      isCCActive
      isGMActive
      topUpEnabled
      ssoEnabled
      autopilotEnabled
      invoiceApproved
      currency
      managerName
      userInterfaceSettings {
        hideCCPrices
      }
      ccTeams {
        id
        name
        code
      }
      locations {
        id
        label
        isCCActive
        isGmActive
        address {
          label
          city
          postcode
          country
        }
      }
    }
  }
}
    ${UserContactPreferencesFragmentDoc}
${UserDietaryPreferencesFragmentDoc}
${UserAllergensFragmentDoc}`;

/**
 * __useGetUserForEditQuery__
 *
 * To run a query within a React component, call `useGetUserForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetUserForEditQuery(baseOptions: Apollo.QueryHookOptions<GetUserForEditQuery, GetUserForEditQueryVariables> & ({ variables: GetUserForEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserForEditQuery, GetUserForEditQueryVariables>(GetUserForEditDocument, options);
      }
export function useGetUserForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserForEditQuery, GetUserForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserForEditQuery, GetUserForEditQueryVariables>(GetUserForEditDocument, options);
        }
// @ts-ignore
export function useGetUserForEditSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserForEditQuery, GetUserForEditQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserForEditQuery, GetUserForEditQueryVariables>;
export function useGetUserForEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserForEditQuery, GetUserForEditQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserForEditQuery | undefined, GetUserForEditQueryVariables>;
export function useGetUserForEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserForEditQuery, GetUserForEditQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserForEditQuery, GetUserForEditQueryVariables>(GetUserForEditDocument, options);
        }
export type GetUserForEditQueryHookResult = ReturnType<typeof useGetUserForEditQuery>;
export type GetUserForEditLazyQueryHookResult = ReturnType<typeof useGetUserForEditLazyQuery>;
export type GetUserForEditSuspenseQueryHookResult = ReturnType<typeof useGetUserForEditSuspenseQuery>;
export type GetUserForEditQueryResult = Apollo.QueryResult<GetUserForEditQuery, GetUserForEditQueryVariables>;
export const UpdateUserForEditDocument = gql`
    mutation UpdateUserForEdit($id: ID!, $input: UpdateUserInput!) {
  updateUser(id: $id, input: $input) {
    id
    firstName
    lastName
    fullName
    email
    privacyAccepted
    teamId
    phone
    accountLocation {
      id
      label
    }
    contactPreferences {
      ...UserContactPreferences
    }
    allergens {
      ...UserAllergens
    }
    dietaryPreferences {
      ...UserDietaryPreferences
    }
    accountSettings {
      costCentre
    }
  }
}
    ${UserContactPreferencesFragmentDoc}
${UserAllergensFragmentDoc}
${UserDietaryPreferencesFragmentDoc}`;
export type UpdateUserForEditMutationFn = Apollo.MutationFunction<UpdateUserForEditMutation, UpdateUserForEditMutationVariables>;

/**
 * __useUpdateUserForEditMutation__
 *
 * To run a mutation, you first call `useUpdateUserForEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserForEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserForEditMutation, { data, loading, error }] = useUpdateUserForEditMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserForEditMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserForEditMutation, UpdateUserForEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserForEditMutation, UpdateUserForEditMutationVariables>(UpdateUserForEditDocument, options);
      }
export type UpdateUserForEditMutationHookResult = ReturnType<typeof useUpdateUserForEditMutation>;
export type UpdateUserForEditMutationResult = Apollo.MutationResult<UpdateUserForEditMutation>;
export type UpdateUserForEditMutationOptions = Apollo.BaseMutationOptions<UpdateUserForEditMutation, UpdateUserForEditMutationVariables>;
export const GetAccountTeamsForUserCreateDocument = gql`
    query getAccountTeamsForUserCreate($accountId: ID!) {
  account(id: $accountId) {
    ccTeams {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAccountTeamsForUserCreateQuery__
 *
 * To run a query within a React component, call `useGetAccountTeamsForUserCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountTeamsForUserCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountTeamsForUserCreateQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountTeamsForUserCreateQuery(baseOptions: Apollo.QueryHookOptions<GetAccountTeamsForUserCreateQuery, GetAccountTeamsForUserCreateQueryVariables> & ({ variables: GetAccountTeamsForUserCreateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountTeamsForUserCreateQuery, GetAccountTeamsForUserCreateQueryVariables>(GetAccountTeamsForUserCreateDocument, options);
      }
export function useGetAccountTeamsForUserCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountTeamsForUserCreateQuery, GetAccountTeamsForUserCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountTeamsForUserCreateQuery, GetAccountTeamsForUserCreateQueryVariables>(GetAccountTeamsForUserCreateDocument, options);
        }
// @ts-ignore
export function useGetAccountTeamsForUserCreateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountTeamsForUserCreateQuery, GetAccountTeamsForUserCreateQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountTeamsForUserCreateQuery, GetAccountTeamsForUserCreateQueryVariables>;
export function useGetAccountTeamsForUserCreateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountTeamsForUserCreateQuery, GetAccountTeamsForUserCreateQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountTeamsForUserCreateQuery | undefined, GetAccountTeamsForUserCreateQueryVariables>;
export function useGetAccountTeamsForUserCreateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountTeamsForUserCreateQuery, GetAccountTeamsForUserCreateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountTeamsForUserCreateQuery, GetAccountTeamsForUserCreateQueryVariables>(GetAccountTeamsForUserCreateDocument, options);
        }
export type GetAccountTeamsForUserCreateQueryHookResult = ReturnType<typeof useGetAccountTeamsForUserCreateQuery>;
export type GetAccountTeamsForUserCreateLazyQueryHookResult = ReturnType<typeof useGetAccountTeamsForUserCreateLazyQuery>;
export type GetAccountTeamsForUserCreateSuspenseQueryHookResult = ReturnType<typeof useGetAccountTeamsForUserCreateSuspenseQuery>;
export type GetAccountTeamsForUserCreateQueryResult = Apollo.QueryResult<GetAccountTeamsForUserCreateQuery, GetAccountTeamsForUserCreateQueryVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const GetAccountLocationsForUserListDocument = gql`
    query getAccountLocationsForUserList($accountId: ID!) {
  account(id: $accountId) {
    locations {
      id
      label
    }
  }
}
    `;

/**
 * __useGetAccountLocationsForUserListQuery__
 *
 * To run a query within a React component, call `useGetAccountLocationsForUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountLocationsForUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountLocationsForUserListQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountLocationsForUserListQuery(baseOptions: Apollo.QueryHookOptions<GetAccountLocationsForUserListQuery, GetAccountLocationsForUserListQueryVariables> & ({ variables: GetAccountLocationsForUserListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountLocationsForUserListQuery, GetAccountLocationsForUserListQueryVariables>(GetAccountLocationsForUserListDocument, options);
      }
export function useGetAccountLocationsForUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountLocationsForUserListQuery, GetAccountLocationsForUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountLocationsForUserListQuery, GetAccountLocationsForUserListQueryVariables>(GetAccountLocationsForUserListDocument, options);
        }
// @ts-ignore
export function useGetAccountLocationsForUserListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountLocationsForUserListQuery, GetAccountLocationsForUserListQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountLocationsForUserListQuery, GetAccountLocationsForUserListQueryVariables>;
export function useGetAccountLocationsForUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountLocationsForUserListQuery, GetAccountLocationsForUserListQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountLocationsForUserListQuery | undefined, GetAccountLocationsForUserListQueryVariables>;
export function useGetAccountLocationsForUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountLocationsForUserListQuery, GetAccountLocationsForUserListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountLocationsForUserListQuery, GetAccountLocationsForUserListQueryVariables>(GetAccountLocationsForUserListDocument, options);
        }
export type GetAccountLocationsForUserListQueryHookResult = ReturnType<typeof useGetAccountLocationsForUserListQuery>;
export type GetAccountLocationsForUserListLazyQueryHookResult = ReturnType<typeof useGetAccountLocationsForUserListLazyQuery>;
export type GetAccountLocationsForUserListSuspenseQueryHookResult = ReturnType<typeof useGetAccountLocationsForUserListSuspenseQuery>;
export type GetAccountLocationsForUserListQueryResult = Apollo.QueryResult<GetAccountLocationsForUserListQuery, GetAccountLocationsForUserListQueryVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($userId: ID!) {
  deleteUser(id: $userId)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const RestoreUserDocument = gql`
    mutation restoreUser($userId: ID!) {
  restoreUser(id: $userId) {
    id
    deletedAt
  }
}
    `;
export type RestoreUserMutationFn = Apollo.MutationFunction<RestoreUserMutation, RestoreUserMutationVariables>;

/**
 * __useRestoreUserMutation__
 *
 * To run a mutation, you first call `useRestoreUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreUserMutation, { data, loading, error }] = useRestoreUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRestoreUserMutation(baseOptions?: Apollo.MutationHookOptions<RestoreUserMutation, RestoreUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreUserMutation, RestoreUserMutationVariables>(RestoreUserDocument, options);
      }
export type RestoreUserMutationHookResult = ReturnType<typeof useRestoreUserMutation>;
export type RestoreUserMutationResult = Apollo.MutationResult<RestoreUserMutation>;
export type RestoreUserMutationOptions = Apollo.BaseMutationOptions<RestoreUserMutation, RestoreUserMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const GetAccountDetailsDocument = gql`
    query getAccountDetails($accountId: ID!) {
  account(id: $accountId) {
    id
    name
    archivedAt
    archivedBy {
      fullName
    }
    isCCActive
    isGMActive
    napkinsCutlery
    autoSendMenu
    highRisk
    ssoEnabled
    autopilotEnabled
    topUpEnabled
    currency
    invoiceApproved
    primaryContacts {
      rows {
        id
        fullName
        phone
        email
      }
    }
    managerName
    onboardingLink
    notes
    code
    externalId
    signUpCode
    userInterfaceSettings {
      hideCCPrices
    }
    approvedSuppliers {
      supplierId
      supplierName
    }
  }
}
    `;

/**
 * __useGetAccountDetailsQuery__
 *
 * To run a query within a React component, call `useGetAccountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountDetailsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAccountDetailsQuery, GetAccountDetailsQueryVariables> & ({ variables: GetAccountDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>(GetAccountDetailsDocument, options);
      }
export function useGetAccountDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>(GetAccountDetailsDocument, options);
        }
// @ts-ignore
export function useGetAccountDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>;
export function useGetAccountDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountDetailsQuery | undefined, GetAccountDetailsQueryVariables>;
export function useGetAccountDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>(GetAccountDetailsDocument, options);
        }
export type GetAccountDetailsQueryHookResult = ReturnType<typeof useGetAccountDetailsQuery>;
export type GetAccountDetailsLazyQueryHookResult = ReturnType<typeof useGetAccountDetailsLazyQuery>;
export type GetAccountDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAccountDetailsSuspenseQuery>;
export type GetAccountDetailsQueryResult = Apollo.QueryResult<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>;
export const GetAccountPrivateSuppliersDocument = gql`
    query getAccountPrivateSuppliers($accountId: Int!) {
  accountPrivateSuppliers(id: $accountId) {
    suppliers {
      supplierId
      supplierName
    }
  }
}
    `;

/**
 * __useGetAccountPrivateSuppliersQuery__
 *
 * To run a query within a React component, call `useGetAccountPrivateSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountPrivateSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountPrivateSuppliersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountPrivateSuppliersQuery(baseOptions: Apollo.QueryHookOptions<GetAccountPrivateSuppliersQuery, GetAccountPrivateSuppliersQueryVariables> & ({ variables: GetAccountPrivateSuppliersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountPrivateSuppliersQuery, GetAccountPrivateSuppliersQueryVariables>(GetAccountPrivateSuppliersDocument, options);
      }
export function useGetAccountPrivateSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountPrivateSuppliersQuery, GetAccountPrivateSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountPrivateSuppliersQuery, GetAccountPrivateSuppliersQueryVariables>(GetAccountPrivateSuppliersDocument, options);
        }
// @ts-ignore
export function useGetAccountPrivateSuppliersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountPrivateSuppliersQuery, GetAccountPrivateSuppliersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountPrivateSuppliersQuery, GetAccountPrivateSuppliersQueryVariables>;
export function useGetAccountPrivateSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountPrivateSuppliersQuery, GetAccountPrivateSuppliersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountPrivateSuppliersQuery | undefined, GetAccountPrivateSuppliersQueryVariables>;
export function useGetAccountPrivateSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountPrivateSuppliersQuery, GetAccountPrivateSuppliersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountPrivateSuppliersQuery, GetAccountPrivateSuppliersQueryVariables>(GetAccountPrivateSuppliersDocument, options);
        }
export type GetAccountPrivateSuppliersQueryHookResult = ReturnType<typeof useGetAccountPrivateSuppliersQuery>;
export type GetAccountPrivateSuppliersLazyQueryHookResult = ReturnType<typeof useGetAccountPrivateSuppliersLazyQuery>;
export type GetAccountPrivateSuppliersSuspenseQueryHookResult = ReturnType<typeof useGetAccountPrivateSuppliersSuspenseQuery>;
export type GetAccountPrivateSuppliersQueryResult = Apollo.QueryResult<GetAccountPrivateSuppliersQuery, GetAccountPrivateSuppliersQueryVariables>;
export const AdminUpdateAccountDetailsDocument = gql`
    mutation adminUpdateAccountDetails($accountId: ID!, $input: UpdateAccountInput!) {
  updateAccount(id: $accountId, input: $input) {
    id
    name
    isCCActive
    isGMActive
    napkinsCutlery
    autoSendMenu
    highRisk
    ssoEnabled
    autopilotEnabled
    currency
    invoiceApproved
    topUpEnabled
    managerName
    onboardingLink
    notes
    code
    externalId
    signUpCode
    userInterfaceSettings {
      hideCCPrices
    }
  }
}
    `;
export type AdminUpdateAccountDetailsMutationFn = Apollo.MutationFunction<AdminUpdateAccountDetailsMutation, AdminUpdateAccountDetailsMutationVariables>;

/**
 * __useAdminUpdateAccountDetailsMutation__
 *
 * To run a mutation, you first call `useAdminUpdateAccountDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateAccountDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateAccountDetailsMutation, { data, loading, error }] = useAdminUpdateAccountDetailsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateAccountDetailsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateAccountDetailsMutation, AdminUpdateAccountDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateAccountDetailsMutation, AdminUpdateAccountDetailsMutationVariables>(AdminUpdateAccountDetailsDocument, options);
      }
export type AdminUpdateAccountDetailsMutationHookResult = ReturnType<typeof useAdminUpdateAccountDetailsMutation>;
export type AdminUpdateAccountDetailsMutationResult = Apollo.MutationResult<AdminUpdateAccountDetailsMutation>;
export type AdminUpdateAccountDetailsMutationOptions = Apollo.BaseMutationOptions<AdminUpdateAccountDetailsMutation, AdminUpdateAccountDetailsMutationVariables>;
export const AdminGetAccountLocationForEditDocument = gql`
    query adminGetAccountLocationForEdit($accountLocationId: ID!) {
  accountLocation(id: $accountLocationId) {
    id
    label
    isCCActive
    ccCluster {
      id
      name
    }
    phone
    address {
      street
      latitude
      longitude
      flatOrBuilding
      floorOrBuildingName
      country
      postcode
      city
    }
    what3words
    contactPreferences {
      dailyReminderDefaultOptIn
    }
    deliveryPreferences {
      deliveryInstructions
      preferredCourier
      packingInstructions
    }
    timezone
  }
}
    `;

/**
 * __useAdminGetAccountLocationForEditQuery__
 *
 * To run a query within a React component, call `useAdminGetAccountLocationForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetAccountLocationForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetAccountLocationForEditQuery({
 *   variables: {
 *      accountLocationId: // value for 'accountLocationId'
 *   },
 * });
 */
export function useAdminGetAccountLocationForEditQuery(baseOptions: Apollo.QueryHookOptions<AdminGetAccountLocationForEditQuery, AdminGetAccountLocationForEditQueryVariables> & ({ variables: AdminGetAccountLocationForEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetAccountLocationForEditQuery, AdminGetAccountLocationForEditQueryVariables>(AdminGetAccountLocationForEditDocument, options);
      }
export function useAdminGetAccountLocationForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetAccountLocationForEditQuery, AdminGetAccountLocationForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetAccountLocationForEditQuery, AdminGetAccountLocationForEditQueryVariables>(AdminGetAccountLocationForEditDocument, options);
        }
// @ts-ignore
export function useAdminGetAccountLocationForEditSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetAccountLocationForEditQuery, AdminGetAccountLocationForEditQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetAccountLocationForEditQuery, AdminGetAccountLocationForEditQueryVariables>;
export function useAdminGetAccountLocationForEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetAccountLocationForEditQuery, AdminGetAccountLocationForEditQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetAccountLocationForEditQuery | undefined, AdminGetAccountLocationForEditQueryVariables>;
export function useAdminGetAccountLocationForEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetAccountLocationForEditQuery, AdminGetAccountLocationForEditQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetAccountLocationForEditQuery, AdminGetAccountLocationForEditQueryVariables>(AdminGetAccountLocationForEditDocument, options);
        }
export type AdminGetAccountLocationForEditQueryHookResult = ReturnType<typeof useAdminGetAccountLocationForEditQuery>;
export type AdminGetAccountLocationForEditLazyQueryHookResult = ReturnType<typeof useAdminGetAccountLocationForEditLazyQuery>;
export type AdminGetAccountLocationForEditSuspenseQueryHookResult = ReturnType<typeof useAdminGetAccountLocationForEditSuspenseQuery>;
export type AdminGetAccountLocationForEditQueryResult = Apollo.QueryResult<AdminGetAccountLocationForEditQuery, AdminGetAccountLocationForEditQueryVariables>;
export const AdminUpdateAccountLocationDocument = gql`
    mutation adminUpdateAccountLocation($updateAccountId: ID!, $input: UpdateAccountLocationInput!) {
  updateAccount(id: $updateAccountId, input: {updateAccountLocation: $input}) {
    id
  }
}
    `;
export type AdminUpdateAccountLocationMutationFn = Apollo.MutationFunction<AdminUpdateAccountLocationMutation, AdminUpdateAccountLocationMutationVariables>;

/**
 * __useAdminUpdateAccountLocationMutation__
 *
 * To run a mutation, you first call `useAdminUpdateAccountLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateAccountLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateAccountLocationMutation, { data, loading, error }] = useAdminUpdateAccountLocationMutation({
 *   variables: {
 *      updateAccountId: // value for 'updateAccountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateAccountLocationMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateAccountLocationMutation, AdminUpdateAccountLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateAccountLocationMutation, AdminUpdateAccountLocationMutationVariables>(AdminUpdateAccountLocationDocument, options);
      }
export type AdminUpdateAccountLocationMutationHookResult = ReturnType<typeof useAdminUpdateAccountLocationMutation>;
export type AdminUpdateAccountLocationMutationResult = Apollo.MutationResult<AdminUpdateAccountLocationMutation>;
export type AdminUpdateAccountLocationMutationOptions = Apollo.BaseMutationOptions<AdminUpdateAccountLocationMutation, AdminUpdateAccountLocationMutationVariables>;
export const AdminCreateAccountLocationDocument = gql`
    mutation adminCreateAccountLocation($updateAccountId: ID!, $input: CreateAccountLocationInput!) {
  updateAccount(id: $updateAccountId, input: {createAccountLocation: $input}) {
    id
  }
}
    `;
export type AdminCreateAccountLocationMutationFn = Apollo.MutationFunction<AdminCreateAccountLocationMutation, AdminCreateAccountLocationMutationVariables>;

/**
 * __useAdminCreateAccountLocationMutation__
 *
 * To run a mutation, you first call `useAdminCreateAccountLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateAccountLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateAccountLocationMutation, { data, loading, error }] = useAdminCreateAccountLocationMutation({
 *   variables: {
 *      updateAccountId: // value for 'updateAccountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateAccountLocationMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateAccountLocationMutation, AdminCreateAccountLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateAccountLocationMutation, AdminCreateAccountLocationMutationVariables>(AdminCreateAccountLocationDocument, options);
      }
export type AdminCreateAccountLocationMutationHookResult = ReturnType<typeof useAdminCreateAccountLocationMutation>;
export type AdminCreateAccountLocationMutationResult = Apollo.MutationResult<AdminCreateAccountLocationMutation>;
export type AdminCreateAccountLocationMutationOptions = Apollo.BaseMutationOptions<AdminCreateAccountLocationMutation, AdminCreateAccountLocationMutationVariables>;
export const AdminCreateCcClusterDocument = gql`
    mutation adminCreateCCCluster($input: CreateCCClusterInput!) {
  createCCCluster(input: $input) {
    id
    name
  }
}
    `;
export type AdminCreateCcClusterMutationFn = Apollo.MutationFunction<AdminCreateCcClusterMutation, AdminCreateCcClusterMutationVariables>;

/**
 * __useAdminCreateCcClusterMutation__
 *
 * To run a mutation, you first call `useAdminCreateCcClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCcClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCcClusterMutation, { data, loading, error }] = useAdminCreateCcClusterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateCcClusterMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateCcClusterMutation, AdminCreateCcClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateCcClusterMutation, AdminCreateCcClusterMutationVariables>(AdminCreateCcClusterDocument, options);
      }
export type AdminCreateCcClusterMutationHookResult = ReturnType<typeof useAdminCreateCcClusterMutation>;
export type AdminCreateCcClusterMutationResult = Apollo.MutationResult<AdminCreateCcClusterMutation>;
export type AdminCreateCcClusterMutationOptions = Apollo.BaseMutationOptions<AdminCreateCcClusterMutation, AdminCreateCcClusterMutationVariables>;
export const AdminGetLocationsListForAccountDocument = gql`
    query adminGetLocationsListForAccount($accountId: ID!, $filters: AccountLocationFilters!, $limit: Int, $offset: Int) {
  account(id: $accountId) {
    locationsPaged(filters: $filters, offset: $offset, limit: $limit) {
      rows {
        id
        label
        address {
          flatOrBuilding
          floorOrBuildingName
          street
          postcode
          city
          country
        }
        isCCActive
        archivedAt
      }
      pageInfo {
        limit
        offset
        count
        hasMore
      }
    }
  }
}
    `;

/**
 * __useAdminGetLocationsListForAccountQuery__
 *
 * To run a query within a React component, call `useAdminGetLocationsListForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetLocationsListForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetLocationsListForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminGetLocationsListForAccountQuery(baseOptions: Apollo.QueryHookOptions<AdminGetLocationsListForAccountQuery, AdminGetLocationsListForAccountQueryVariables> & ({ variables: AdminGetLocationsListForAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetLocationsListForAccountQuery, AdminGetLocationsListForAccountQueryVariables>(AdminGetLocationsListForAccountDocument, options);
      }
export function useAdminGetLocationsListForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetLocationsListForAccountQuery, AdminGetLocationsListForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetLocationsListForAccountQuery, AdminGetLocationsListForAccountQueryVariables>(AdminGetLocationsListForAccountDocument, options);
        }
// @ts-ignore
export function useAdminGetLocationsListForAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetLocationsListForAccountQuery, AdminGetLocationsListForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetLocationsListForAccountQuery, AdminGetLocationsListForAccountQueryVariables>;
export function useAdminGetLocationsListForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetLocationsListForAccountQuery, AdminGetLocationsListForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetLocationsListForAccountQuery | undefined, AdminGetLocationsListForAccountQueryVariables>;
export function useAdminGetLocationsListForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetLocationsListForAccountQuery, AdminGetLocationsListForAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetLocationsListForAccountQuery, AdminGetLocationsListForAccountQueryVariables>(AdminGetLocationsListForAccountDocument, options);
        }
export type AdminGetLocationsListForAccountQueryHookResult = ReturnType<typeof useAdminGetLocationsListForAccountQuery>;
export type AdminGetLocationsListForAccountLazyQueryHookResult = ReturnType<typeof useAdminGetLocationsListForAccountLazyQuery>;
export type AdminGetLocationsListForAccountSuspenseQueryHookResult = ReturnType<typeof useAdminGetLocationsListForAccountSuspenseQuery>;
export type AdminGetLocationsListForAccountQueryResult = Apollo.QueryResult<AdminGetLocationsListForAccountQuery, AdminGetLocationsListForAccountQueryVariables>;
export const AdminSearchClustersForAccountLocationDocument = gql`
    query adminSearchClustersForAccountLocation($filters: CCClusterListFilters!) {
  ccClusters(filters: $filters, limit: 10) {
    rows {
      id
      name
      code
    }
  }
}
    `;

/**
 * __useAdminSearchClustersForAccountLocationQuery__
 *
 * To run a query within a React component, call `useAdminSearchClustersForAccountLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSearchClustersForAccountLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSearchClustersForAccountLocationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminSearchClustersForAccountLocationQuery(baseOptions: Apollo.QueryHookOptions<AdminSearchClustersForAccountLocationQuery, AdminSearchClustersForAccountLocationQueryVariables> & ({ variables: AdminSearchClustersForAccountLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSearchClustersForAccountLocationQuery, AdminSearchClustersForAccountLocationQueryVariables>(AdminSearchClustersForAccountLocationDocument, options);
      }
export function useAdminSearchClustersForAccountLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSearchClustersForAccountLocationQuery, AdminSearchClustersForAccountLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSearchClustersForAccountLocationQuery, AdminSearchClustersForAccountLocationQueryVariables>(AdminSearchClustersForAccountLocationDocument, options);
        }
// @ts-ignore
export function useAdminSearchClustersForAccountLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminSearchClustersForAccountLocationQuery, AdminSearchClustersForAccountLocationQueryVariables>): Apollo.UseSuspenseQueryResult<AdminSearchClustersForAccountLocationQuery, AdminSearchClustersForAccountLocationQueryVariables>;
export function useAdminSearchClustersForAccountLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminSearchClustersForAccountLocationQuery, AdminSearchClustersForAccountLocationQueryVariables>): Apollo.UseSuspenseQueryResult<AdminSearchClustersForAccountLocationQuery | undefined, AdminSearchClustersForAccountLocationQueryVariables>;
export function useAdminSearchClustersForAccountLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminSearchClustersForAccountLocationQuery, AdminSearchClustersForAccountLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSearchClustersForAccountLocationQuery, AdminSearchClustersForAccountLocationQueryVariables>(AdminSearchClustersForAccountLocationDocument, options);
        }
export type AdminSearchClustersForAccountLocationQueryHookResult = ReturnType<typeof useAdminSearchClustersForAccountLocationQuery>;
export type AdminSearchClustersForAccountLocationLazyQueryHookResult = ReturnType<typeof useAdminSearchClustersForAccountLocationLazyQuery>;
export type AdminSearchClustersForAccountLocationSuspenseQueryHookResult = ReturnType<typeof useAdminSearchClustersForAccountLocationSuspenseQuery>;
export type AdminSearchClustersForAccountLocationQueryResult = Apollo.QueryResult<AdminSearchClustersForAccountLocationQuery, AdminSearchClustersForAccountLocationQueryVariables>;
export const AdminDeleteAccountLocationDocument = gql`
    mutation adminDeleteAccountLocation($updateAccountId: ID!, $input: DeleteAccountLocationInput!) {
  updateAccount(id: $updateAccountId, input: {deleteAccountLocation: $input}) {
    id
  }
}
    `;
export type AdminDeleteAccountLocationMutationFn = Apollo.MutationFunction<AdminDeleteAccountLocationMutation, AdminDeleteAccountLocationMutationVariables>;

/**
 * __useAdminDeleteAccountLocationMutation__
 *
 * To run a mutation, you first call `useAdminDeleteAccountLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteAccountLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteAccountLocationMutation, { data, loading, error }] = useAdminDeleteAccountLocationMutation({
 *   variables: {
 *      updateAccountId: // value for 'updateAccountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDeleteAccountLocationMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteAccountLocationMutation, AdminDeleteAccountLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteAccountLocationMutation, AdminDeleteAccountLocationMutationVariables>(AdminDeleteAccountLocationDocument, options);
      }
export type AdminDeleteAccountLocationMutationHookResult = ReturnType<typeof useAdminDeleteAccountLocationMutation>;
export type AdminDeleteAccountLocationMutationResult = Apollo.MutationResult<AdminDeleteAccountLocationMutation>;
export type AdminDeleteAccountLocationMutationOptions = Apollo.BaseMutationOptions<AdminDeleteAccountLocationMutation, AdminDeleteAccountLocationMutationVariables>;
export const ArchiveAccountDocument = gql`
    mutation ArchiveAccount($accountId: ID!, $acknowledgeWarnings: Boolean) {
  archiveAccount(accountId: $accountId, acknowledgeWarnings: $acknowledgeWarnings) {
    account {
      id
      archivedAt
    }
    blockers {
      code
      message
      count
    }
    warnings {
      code
      message
      count
    }
  }
}
    `;
export type ArchiveAccountMutationFn = Apollo.MutationFunction<ArchiveAccountMutation, ArchiveAccountMutationVariables>;

/**
 * __useArchiveAccountMutation__
 *
 * To run a mutation, you first call `useArchiveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAccountMutation, { data, loading, error }] = useArchiveAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      acknowledgeWarnings: // value for 'acknowledgeWarnings'
 *   },
 * });
 */
export function useArchiveAccountMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveAccountMutation, ArchiveAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveAccountMutation, ArchiveAccountMutationVariables>(ArchiveAccountDocument, options);
      }
export type ArchiveAccountMutationHookResult = ReturnType<typeof useArchiveAccountMutation>;
export type ArchiveAccountMutationResult = Apollo.MutationResult<ArchiveAccountMutation>;
export type ArchiveAccountMutationOptions = Apollo.BaseMutationOptions<ArchiveAccountMutation, ArchiveAccountMutationVariables>;
export const AvailsOrderReferenceFieldsDocument = gql`
    query AvailsOrderReferenceFields($input: OrderReferenceFieldInput!) {
  orderReferenceFields(input: $input) {
    id
    referenceFieldId
    description
    fieldType
    isRequired
    label
    version
    options {
      id
      orderReferenceFieldId
      option
      orderPriority
    }
  }
}
    `;

/**
 * __useAvailsOrderReferenceFieldsQuery__
 *
 * To run a query within a React component, call `useAvailsOrderReferenceFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailsOrderReferenceFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailsOrderReferenceFieldsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAvailsOrderReferenceFieldsQuery(baseOptions: Apollo.QueryHookOptions<AvailsOrderReferenceFieldsQuery, AvailsOrderReferenceFieldsQueryVariables> & ({ variables: AvailsOrderReferenceFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailsOrderReferenceFieldsQuery, AvailsOrderReferenceFieldsQueryVariables>(AvailsOrderReferenceFieldsDocument, options);
      }
export function useAvailsOrderReferenceFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailsOrderReferenceFieldsQuery, AvailsOrderReferenceFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailsOrderReferenceFieldsQuery, AvailsOrderReferenceFieldsQueryVariables>(AvailsOrderReferenceFieldsDocument, options);
        }
// @ts-ignore
export function useAvailsOrderReferenceFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailsOrderReferenceFieldsQuery, AvailsOrderReferenceFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<AvailsOrderReferenceFieldsQuery, AvailsOrderReferenceFieldsQueryVariables>;
export function useAvailsOrderReferenceFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailsOrderReferenceFieldsQuery, AvailsOrderReferenceFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<AvailsOrderReferenceFieldsQuery | undefined, AvailsOrderReferenceFieldsQueryVariables>;
export function useAvailsOrderReferenceFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailsOrderReferenceFieldsQuery, AvailsOrderReferenceFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailsOrderReferenceFieldsQuery, AvailsOrderReferenceFieldsQueryVariables>(AvailsOrderReferenceFieldsDocument, options);
        }
export type AvailsOrderReferenceFieldsQueryHookResult = ReturnType<typeof useAvailsOrderReferenceFieldsQuery>;
export type AvailsOrderReferenceFieldsLazyQueryHookResult = ReturnType<typeof useAvailsOrderReferenceFieldsLazyQuery>;
export type AvailsOrderReferenceFieldsSuspenseQueryHookResult = ReturnType<typeof useAvailsOrderReferenceFieldsSuspenseQuery>;
export type AvailsOrderReferenceFieldsQueryResult = Apollo.QueryResult<AvailsOrderReferenceFieldsQuery, AvailsOrderReferenceFieldsQueryVariables>;
export const AvailsAccountLocationReferenceFieldsDocument = gql`
    query AvailsAccountLocationReferenceFields($accountLocationId: ID!, $input: AccountLocationReferenceFieldValueInput!) {
  accountLocation(id: $accountLocationId) {
    id
    accountLocationReferenceFieldValues(input: $input) {
      accountLocationReferenceFieldId
      orderReferenceFieldId
      description
      fieldType
      isRequired
      label
      value
      version
      options {
        id
        accountLocationReferenceFieldId
        option
        orderPriority
      }
    }
  }
}
    `;

/**
 * __useAvailsAccountLocationReferenceFieldsQuery__
 *
 * To run a query within a React component, call `useAvailsAccountLocationReferenceFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailsAccountLocationReferenceFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailsAccountLocationReferenceFieldsQuery({
 *   variables: {
 *      accountLocationId: // value for 'accountLocationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAvailsAccountLocationReferenceFieldsQuery(baseOptions: Apollo.QueryHookOptions<AvailsAccountLocationReferenceFieldsQuery, AvailsAccountLocationReferenceFieldsQueryVariables> & ({ variables: AvailsAccountLocationReferenceFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailsAccountLocationReferenceFieldsQuery, AvailsAccountLocationReferenceFieldsQueryVariables>(AvailsAccountLocationReferenceFieldsDocument, options);
      }
export function useAvailsAccountLocationReferenceFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailsAccountLocationReferenceFieldsQuery, AvailsAccountLocationReferenceFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailsAccountLocationReferenceFieldsQuery, AvailsAccountLocationReferenceFieldsQueryVariables>(AvailsAccountLocationReferenceFieldsDocument, options);
        }
// @ts-ignore
export function useAvailsAccountLocationReferenceFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailsAccountLocationReferenceFieldsQuery, AvailsAccountLocationReferenceFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<AvailsAccountLocationReferenceFieldsQuery, AvailsAccountLocationReferenceFieldsQueryVariables>;
export function useAvailsAccountLocationReferenceFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailsAccountLocationReferenceFieldsQuery, AvailsAccountLocationReferenceFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<AvailsAccountLocationReferenceFieldsQuery | undefined, AvailsAccountLocationReferenceFieldsQueryVariables>;
export function useAvailsAccountLocationReferenceFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailsAccountLocationReferenceFieldsQuery, AvailsAccountLocationReferenceFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailsAccountLocationReferenceFieldsQuery, AvailsAccountLocationReferenceFieldsQueryVariables>(AvailsAccountLocationReferenceFieldsDocument, options);
        }
export type AvailsAccountLocationReferenceFieldsQueryHookResult = ReturnType<typeof useAvailsAccountLocationReferenceFieldsQuery>;
export type AvailsAccountLocationReferenceFieldsLazyQueryHookResult = ReturnType<typeof useAvailsAccountLocationReferenceFieldsLazyQuery>;
export type AvailsAccountLocationReferenceFieldsSuspenseQueryHookResult = ReturnType<typeof useAvailsAccountLocationReferenceFieldsSuspenseQuery>;
export type AvailsAccountLocationReferenceFieldsQueryResult = Apollo.QueryResult<AvailsAccountLocationReferenceFieldsQuery, AvailsAccountLocationReferenceFieldsQueryVariables>;
export const UpdateAvailsAccountLocationReferenceFieldsDocument = gql`
    mutation UpdateAvailsAccountLocationReferenceFields($accountLocationId: Int!, $input: UpdateAccountLocationReferenceFieldsInput!) {
  updateAccountLocationReferenceFields(
    accountLocationId: $accountLocationId
    input: $input
  )
}
    `;
export type UpdateAvailsAccountLocationReferenceFieldsMutationFn = Apollo.MutationFunction<UpdateAvailsAccountLocationReferenceFieldsMutation, UpdateAvailsAccountLocationReferenceFieldsMutationVariables>;

/**
 * __useUpdateAvailsAccountLocationReferenceFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateAvailsAccountLocationReferenceFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvailsAccountLocationReferenceFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvailsAccountLocationReferenceFieldsMutation, { data, loading, error }] = useUpdateAvailsAccountLocationReferenceFieldsMutation({
 *   variables: {
 *      accountLocationId: // value for 'accountLocationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAvailsAccountLocationReferenceFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvailsAccountLocationReferenceFieldsMutation, UpdateAvailsAccountLocationReferenceFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvailsAccountLocationReferenceFieldsMutation, UpdateAvailsAccountLocationReferenceFieldsMutationVariables>(UpdateAvailsAccountLocationReferenceFieldsDocument, options);
      }
export type UpdateAvailsAccountLocationReferenceFieldsMutationHookResult = ReturnType<typeof useUpdateAvailsAccountLocationReferenceFieldsMutation>;
export type UpdateAvailsAccountLocationReferenceFieldsMutationResult = Apollo.MutationResult<UpdateAvailsAccountLocationReferenceFieldsMutation>;
export type UpdateAvailsAccountLocationReferenceFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateAvailsAccountLocationReferenceFieldsMutation, UpdateAvailsAccountLocationReferenceFieldsMutationVariables>;
export const AdminCreateAccountDocument = gql`
    mutation adminCreateAccount($input: CreateAccountInput!) {
  createAccount(input: $input) {
    id
  }
}
    `;
export type AdminCreateAccountMutationFn = Apollo.MutationFunction<AdminCreateAccountMutation, AdminCreateAccountMutationVariables>;

/**
 * __useAdminCreateAccountMutation__
 *
 * To run a mutation, you first call `useAdminCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateAccountMutation, { data, loading, error }] = useAdminCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateAccountMutation, AdminCreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateAccountMutation, AdminCreateAccountMutationVariables>(AdminCreateAccountDocument, options);
      }
export type AdminCreateAccountMutationHookResult = ReturnType<typeof useAdminCreateAccountMutation>;
export type AdminCreateAccountMutationResult = Apollo.MutationResult<AdminCreateAccountMutation>;
export type AdminCreateAccountMutationOptions = Apollo.BaseMutationOptions<AdminCreateAccountMutation, AdminCreateAccountMutationVariables>;
export const GetFinanceSettingsDocument = gql`
    query getFinanceSettings($accountId: ID!) {
  account(id: $accountId) {
    isCCActive
    currency
    financeSettings {
      allowMinTopUpCc
      contractDateFrom
      contractDateTo
      invoicingFormatGm
      paymentDueDaysAfterInvoice
      additionalBillingNotes
      chargeCreditCardFee
    }
  }
}
    `;

/**
 * __useGetFinanceSettingsQuery__
 *
 * To run a query within a React component, call `useGetFinanceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinanceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinanceSettingsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetFinanceSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetFinanceSettingsQuery, GetFinanceSettingsQueryVariables> & ({ variables: GetFinanceSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinanceSettingsQuery, GetFinanceSettingsQueryVariables>(GetFinanceSettingsDocument, options);
      }
export function useGetFinanceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinanceSettingsQuery, GetFinanceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinanceSettingsQuery, GetFinanceSettingsQueryVariables>(GetFinanceSettingsDocument, options);
        }
// @ts-ignore
export function useGetFinanceSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFinanceSettingsQuery, GetFinanceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetFinanceSettingsQuery, GetFinanceSettingsQueryVariables>;
export function useGetFinanceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFinanceSettingsQuery, GetFinanceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetFinanceSettingsQuery | undefined, GetFinanceSettingsQueryVariables>;
export function useGetFinanceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFinanceSettingsQuery, GetFinanceSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFinanceSettingsQuery, GetFinanceSettingsQueryVariables>(GetFinanceSettingsDocument, options);
        }
export type GetFinanceSettingsQueryHookResult = ReturnType<typeof useGetFinanceSettingsQuery>;
export type GetFinanceSettingsLazyQueryHookResult = ReturnType<typeof useGetFinanceSettingsLazyQuery>;
export type GetFinanceSettingsSuspenseQueryHookResult = ReturnType<typeof useGetFinanceSettingsSuspenseQuery>;
export type GetFinanceSettingsQueryResult = Apollo.QueryResult<GetFinanceSettingsQuery, GetFinanceSettingsQueryVariables>;
export const UpdateFinanceSettingsDocument = gql`
    mutation updateFinanceSettings($accountId: Int!, $input: UpdateAccountFinanceSettingsInput!) {
  updateAccountFinanceSettings(accountId: $accountId, input: $input) {
    allowMinTopUpCc
    contractDateFrom
    contractDateTo
    invoicingFormatGm
    paymentDueDaysAfterInvoice
    additionalBillingNotes
    chargeCreditCardFee
  }
}
    `;
export type UpdateFinanceSettingsMutationFn = Apollo.MutationFunction<UpdateFinanceSettingsMutation, UpdateFinanceSettingsMutationVariables>;

/**
 * __useUpdateFinanceSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFinanceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinanceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinanceSettingsMutation, { data, loading, error }] = useUpdateFinanceSettingsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFinanceSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinanceSettingsMutation, UpdateFinanceSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinanceSettingsMutation, UpdateFinanceSettingsMutationVariables>(UpdateFinanceSettingsDocument, options);
      }
export type UpdateFinanceSettingsMutationHookResult = ReturnType<typeof useUpdateFinanceSettingsMutation>;
export type UpdateFinanceSettingsMutationResult = Apollo.MutationResult<UpdateFinanceSettingsMutation>;
export type UpdateFinanceSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateFinanceSettingsMutation, UpdateFinanceSettingsMutationVariables>;
export const GenerateStripeSetupIntentOnFlexDocument = gql`
    mutation GenerateStripeSetupIntentOnFlex($invoiceAccountId: Int!) {
  generateStripeSetupIntentOnFlex(invoiceAccountId: $invoiceAccountId) {
    clientSecret
    customerSessionClientSecret
  }
}
    `;
export type GenerateStripeSetupIntentOnFlexMutationFn = Apollo.MutationFunction<GenerateStripeSetupIntentOnFlexMutation, GenerateStripeSetupIntentOnFlexMutationVariables>;

/**
 * __useGenerateStripeSetupIntentOnFlexMutation__
 *
 * To run a mutation, you first call `useGenerateStripeSetupIntentOnFlexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateStripeSetupIntentOnFlexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateStripeSetupIntentOnFlexMutation, { data, loading, error }] = useGenerateStripeSetupIntentOnFlexMutation({
 *   variables: {
 *      invoiceAccountId: // value for 'invoiceAccountId'
 *   },
 * });
 */
export function useGenerateStripeSetupIntentOnFlexMutation(baseOptions?: Apollo.MutationHookOptions<GenerateStripeSetupIntentOnFlexMutation, GenerateStripeSetupIntentOnFlexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateStripeSetupIntentOnFlexMutation, GenerateStripeSetupIntentOnFlexMutationVariables>(GenerateStripeSetupIntentOnFlexDocument, options);
      }
export type GenerateStripeSetupIntentOnFlexMutationHookResult = ReturnType<typeof useGenerateStripeSetupIntentOnFlexMutation>;
export type GenerateStripeSetupIntentOnFlexMutationResult = Apollo.MutationResult<GenerateStripeSetupIntentOnFlexMutation>;
export type GenerateStripeSetupIntentOnFlexMutationOptions = Apollo.BaseMutationOptions<GenerateStripeSetupIntentOnFlexMutation, GenerateStripeSetupIntentOnFlexMutationVariables>;
export const GetStripePublishableKeyDocument = gql`
    query GetStripePublishableKey($billingEntityCode: String!) {
  retrieveStripePublishableKey(billingEntityCode: $billingEntityCode)
}
    `;

/**
 * __useGetStripePublishableKeyQuery__
 *
 * To run a query within a React component, call `useGetStripePublishableKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripePublishableKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripePublishableKeyQuery({
 *   variables: {
 *      billingEntityCode: // value for 'billingEntityCode'
 *   },
 * });
 */
export function useGetStripePublishableKeyQuery(baseOptions: Apollo.QueryHookOptions<GetStripePublishableKeyQuery, GetStripePublishableKeyQueryVariables> & ({ variables: GetStripePublishableKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripePublishableKeyQuery, GetStripePublishableKeyQueryVariables>(GetStripePublishableKeyDocument, options);
      }
export function useGetStripePublishableKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripePublishableKeyQuery, GetStripePublishableKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripePublishableKeyQuery, GetStripePublishableKeyQueryVariables>(GetStripePublishableKeyDocument, options);
        }
// @ts-ignore
export function useGetStripePublishableKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStripePublishableKeyQuery, GetStripePublishableKeyQueryVariables>): Apollo.UseSuspenseQueryResult<GetStripePublishableKeyQuery, GetStripePublishableKeyQueryVariables>;
export function useGetStripePublishableKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStripePublishableKeyQuery, GetStripePublishableKeyQueryVariables>): Apollo.UseSuspenseQueryResult<GetStripePublishableKeyQuery | undefined, GetStripePublishableKeyQueryVariables>;
export function useGetStripePublishableKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStripePublishableKeyQuery, GetStripePublishableKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStripePublishableKeyQuery, GetStripePublishableKeyQueryVariables>(GetStripePublishableKeyDocument, options);
        }
export type GetStripePublishableKeyQueryHookResult = ReturnType<typeof useGetStripePublishableKeyQuery>;
export type GetStripePublishableKeyLazyQueryHookResult = ReturnType<typeof useGetStripePublishableKeyLazyQuery>;
export type GetStripePublishableKeySuspenseQueryHookResult = ReturnType<typeof useGetStripePublishableKeySuspenseQuery>;
export type GetStripePublishableKeyQueryResult = Apollo.QueryResult<GetStripePublishableKeyQuery, GetStripePublishableKeyQueryVariables>;
export const UpdateFlexInvoiceAccountDocument = gql`
    mutation updateFlexInvoiceAccount($id: ID!, $input: UpdateFlexInvoiceAccountInput!) {
  updateFlexInvoiceAccount(id: $id, input: $input) {
    ...FlexInvoiceAccount
  }
}
    ${FlexInvoiceAccountFragmentDoc}`;
export type UpdateFlexInvoiceAccountMutationFn = Apollo.MutationFunction<UpdateFlexInvoiceAccountMutation, UpdateFlexInvoiceAccountMutationVariables>;

/**
 * __useUpdateFlexInvoiceAccountMutation__
 *
 * To run a mutation, you first call `useUpdateFlexInvoiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFlexInvoiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFlexInvoiceAccountMutation, { data, loading, error }] = useUpdateFlexInvoiceAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFlexInvoiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFlexInvoiceAccountMutation, UpdateFlexInvoiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFlexInvoiceAccountMutation, UpdateFlexInvoiceAccountMutationVariables>(UpdateFlexInvoiceAccountDocument, options);
      }
export type UpdateFlexInvoiceAccountMutationHookResult = ReturnType<typeof useUpdateFlexInvoiceAccountMutation>;
export type UpdateFlexInvoiceAccountMutationResult = Apollo.MutationResult<UpdateFlexInvoiceAccountMutation>;
export type UpdateFlexInvoiceAccountMutationOptions = Apollo.BaseMutationOptions<UpdateFlexInvoiceAccountMutation, UpdateFlexInvoiceAccountMutationVariables>;
export const CreateFlexInvoiceAccountDocument = gql`
    mutation createFlexInvoiceAccount($input: CreateFlexInvoiceAccountInput!) {
  createFlexInvoiceAccount(input: $input) {
    ...FlexInvoiceAccount
  }
}
    ${FlexInvoiceAccountFragmentDoc}`;
export type CreateFlexInvoiceAccountMutationFn = Apollo.MutationFunction<CreateFlexInvoiceAccountMutation, CreateFlexInvoiceAccountMutationVariables>;

/**
 * __useCreateFlexInvoiceAccountMutation__
 *
 * To run a mutation, you first call `useCreateFlexInvoiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFlexInvoiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFlexInvoiceAccountMutation, { data, loading, error }] = useCreateFlexInvoiceAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFlexInvoiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateFlexInvoiceAccountMutation, CreateFlexInvoiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFlexInvoiceAccountMutation, CreateFlexInvoiceAccountMutationVariables>(CreateFlexInvoiceAccountDocument, options);
      }
export type CreateFlexInvoiceAccountMutationHookResult = ReturnType<typeof useCreateFlexInvoiceAccountMutation>;
export type CreateFlexInvoiceAccountMutationResult = Apollo.MutationResult<CreateFlexInvoiceAccountMutation>;
export type CreateFlexInvoiceAccountMutationOptions = Apollo.BaseMutationOptions<CreateFlexInvoiceAccountMutation, CreateFlexInvoiceAccountMutationVariables>;
export const DeleteFlexInvoiceAccountDocument = gql`
    mutation deleteFlexInvoiceAccount($id: ID!) {
  deleteFlexInvoiceAccount(id: $id)
}
    `;
export type DeleteFlexInvoiceAccountMutationFn = Apollo.MutationFunction<DeleteFlexInvoiceAccountMutation, DeleteFlexInvoiceAccountMutationVariables>;

/**
 * __useDeleteFlexInvoiceAccountMutation__
 *
 * To run a mutation, you first call `useDeleteFlexInvoiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFlexInvoiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFlexInvoiceAccountMutation, { data, loading, error }] = useDeleteFlexInvoiceAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFlexInvoiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFlexInvoiceAccountMutation, DeleteFlexInvoiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFlexInvoiceAccountMutation, DeleteFlexInvoiceAccountMutationVariables>(DeleteFlexInvoiceAccountDocument, options);
      }
export type DeleteFlexInvoiceAccountMutationHookResult = ReturnType<typeof useDeleteFlexInvoiceAccountMutation>;
export type DeleteFlexInvoiceAccountMutationResult = Apollo.MutationResult<DeleteFlexInvoiceAccountMutation>;
export type DeleteFlexInvoiceAccountMutationOptions = Apollo.BaseMutationOptions<DeleteFlexInvoiceAccountMutation, DeleteFlexInvoiceAccountMutationVariables>;
export const GetFlexInvoiceAccountsForAccountDocument = gql`
    query getFlexInvoiceAccountsForAccount($accountId: ID!) {
  account(id: $accountId) {
    flexInvoiceAccounts {
      ...FlexInvoiceAccount
    }
  }
}
    ${FlexInvoiceAccountFragmentDoc}`;

/**
 * __useGetFlexInvoiceAccountsForAccountQuery__
 *
 * To run a query within a React component, call `useGetFlexInvoiceAccountsForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlexInvoiceAccountsForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlexInvoiceAccountsForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetFlexInvoiceAccountsForAccountQuery(baseOptions: Apollo.QueryHookOptions<GetFlexInvoiceAccountsForAccountQuery, GetFlexInvoiceAccountsForAccountQueryVariables> & ({ variables: GetFlexInvoiceAccountsForAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFlexInvoiceAccountsForAccountQuery, GetFlexInvoiceAccountsForAccountQueryVariables>(GetFlexInvoiceAccountsForAccountDocument, options);
      }
export function useGetFlexInvoiceAccountsForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFlexInvoiceAccountsForAccountQuery, GetFlexInvoiceAccountsForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFlexInvoiceAccountsForAccountQuery, GetFlexInvoiceAccountsForAccountQueryVariables>(GetFlexInvoiceAccountsForAccountDocument, options);
        }
// @ts-ignore
export function useGetFlexInvoiceAccountsForAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFlexInvoiceAccountsForAccountQuery, GetFlexInvoiceAccountsForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetFlexInvoiceAccountsForAccountQuery, GetFlexInvoiceAccountsForAccountQueryVariables>;
export function useGetFlexInvoiceAccountsForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFlexInvoiceAccountsForAccountQuery, GetFlexInvoiceAccountsForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetFlexInvoiceAccountsForAccountQuery | undefined, GetFlexInvoiceAccountsForAccountQueryVariables>;
export function useGetFlexInvoiceAccountsForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFlexInvoiceAccountsForAccountQuery, GetFlexInvoiceAccountsForAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFlexInvoiceAccountsForAccountQuery, GetFlexInvoiceAccountsForAccountQueryVariables>(GetFlexInvoiceAccountsForAccountDocument, options);
        }
export type GetFlexInvoiceAccountsForAccountQueryHookResult = ReturnType<typeof useGetFlexInvoiceAccountsForAccountQuery>;
export type GetFlexInvoiceAccountsForAccountLazyQueryHookResult = ReturnType<typeof useGetFlexInvoiceAccountsForAccountLazyQuery>;
export type GetFlexInvoiceAccountsForAccountSuspenseQueryHookResult = ReturnType<typeof useGetFlexInvoiceAccountsForAccountSuspenseQuery>;
export type GetFlexInvoiceAccountsForAccountQueryResult = Apollo.QueryResult<GetFlexInvoiceAccountsForAccountQuery, GetFlexInvoiceAccountsForAccountQueryVariables>;
export const GetFlexInvoiceAccountDocument = gql`
    query getFlexInvoiceAccount($invoiceAccountId: ID!) {
  flexInvoiceAccount(id: $invoiceAccountId) {
    ...FlexInvoiceAccount
    isPaymentMethodSaved
    referenceFields {
      id
      label
      type
      description
      active
      required
    }
  }
}
    ${FlexInvoiceAccountFragmentDoc}`;

/**
 * __useGetFlexInvoiceAccountQuery__
 *
 * To run a query within a React component, call `useGetFlexInvoiceAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlexInvoiceAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlexInvoiceAccountQuery({
 *   variables: {
 *      invoiceAccountId: // value for 'invoiceAccountId'
 *   },
 * });
 */
export function useGetFlexInvoiceAccountQuery(baseOptions: Apollo.QueryHookOptions<GetFlexInvoiceAccountQuery, GetFlexInvoiceAccountQueryVariables> & ({ variables: GetFlexInvoiceAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFlexInvoiceAccountQuery, GetFlexInvoiceAccountQueryVariables>(GetFlexInvoiceAccountDocument, options);
      }
export function useGetFlexInvoiceAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFlexInvoiceAccountQuery, GetFlexInvoiceAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFlexInvoiceAccountQuery, GetFlexInvoiceAccountQueryVariables>(GetFlexInvoiceAccountDocument, options);
        }
// @ts-ignore
export function useGetFlexInvoiceAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFlexInvoiceAccountQuery, GetFlexInvoiceAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetFlexInvoiceAccountQuery, GetFlexInvoiceAccountQueryVariables>;
export function useGetFlexInvoiceAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFlexInvoiceAccountQuery, GetFlexInvoiceAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetFlexInvoiceAccountQuery | undefined, GetFlexInvoiceAccountQueryVariables>;
export function useGetFlexInvoiceAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFlexInvoiceAccountQuery, GetFlexInvoiceAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFlexInvoiceAccountQuery, GetFlexInvoiceAccountQueryVariables>(GetFlexInvoiceAccountDocument, options);
        }
export type GetFlexInvoiceAccountQueryHookResult = ReturnType<typeof useGetFlexInvoiceAccountQuery>;
export type GetFlexInvoiceAccountLazyQueryHookResult = ReturnType<typeof useGetFlexInvoiceAccountLazyQuery>;
export type GetFlexInvoiceAccountSuspenseQueryHookResult = ReturnType<typeof useGetFlexInvoiceAccountSuspenseQuery>;
export type GetFlexInvoiceAccountQueryResult = Apollo.QueryResult<GetFlexInvoiceAccountQuery, GetFlexInvoiceAccountQueryVariables>;
export const UpdateInvoiceAccountDocument = gql`
    mutation updateInvoiceAccount($id: ID!, $input: UpdateInvoiceAccountInput!) {
  updateInvoiceAccount(id: $id, input: $input) {
    ...InvoiceAccount
  }
}
    ${InvoiceAccountFragmentDoc}`;
export type UpdateInvoiceAccountMutationFn = Apollo.MutationFunction<UpdateInvoiceAccountMutation, UpdateInvoiceAccountMutationVariables>;

/**
 * __useUpdateInvoiceAccountMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceAccountMutation, { data, loading, error }] = useUpdateInvoiceAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceAccountMutation, UpdateInvoiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceAccountMutation, UpdateInvoiceAccountMutationVariables>(UpdateInvoiceAccountDocument, options);
      }
export type UpdateInvoiceAccountMutationHookResult = ReturnType<typeof useUpdateInvoiceAccountMutation>;
export type UpdateInvoiceAccountMutationResult = Apollo.MutationResult<UpdateInvoiceAccountMutation>;
export type UpdateInvoiceAccountMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceAccountMutation, UpdateInvoiceAccountMutationVariables>;
export const CreateInvoiceAccountDocument = gql`
    mutation createInvoiceAccount($input: CreateInvoiceAccountInput!) {
  createInvoiceAccount(input: $input) {
    ...InvoiceAccount
  }
}
    ${InvoiceAccountFragmentDoc}`;
export type CreateInvoiceAccountMutationFn = Apollo.MutationFunction<CreateInvoiceAccountMutation, CreateInvoiceAccountMutationVariables>;

/**
 * __useCreateInvoiceAccountMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceAccountMutation, { data, loading, error }] = useCreateInvoiceAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvoiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceAccountMutation, CreateInvoiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceAccountMutation, CreateInvoiceAccountMutationVariables>(CreateInvoiceAccountDocument, options);
      }
export type CreateInvoiceAccountMutationHookResult = ReturnType<typeof useCreateInvoiceAccountMutation>;
export type CreateInvoiceAccountMutationResult = Apollo.MutationResult<CreateInvoiceAccountMutation>;
export type CreateInvoiceAccountMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceAccountMutation, CreateInvoiceAccountMutationVariables>;
export const DeleteInvoiceAccountDocument = gql`
    mutation deleteInvoiceAccount($id: ID!) {
  deleteInvoiceAccount(id: $id)
}
    `;
export type DeleteInvoiceAccountMutationFn = Apollo.MutationFunction<DeleteInvoiceAccountMutation, DeleteInvoiceAccountMutationVariables>;

/**
 * __useDeleteInvoiceAccountMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceAccountMutation, { data, loading, error }] = useDeleteInvoiceAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInvoiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoiceAccountMutation, DeleteInvoiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvoiceAccountMutation, DeleteInvoiceAccountMutationVariables>(DeleteInvoiceAccountDocument, options);
      }
export type DeleteInvoiceAccountMutationHookResult = ReturnType<typeof useDeleteInvoiceAccountMutation>;
export type DeleteInvoiceAccountMutationResult = Apollo.MutationResult<DeleteInvoiceAccountMutation>;
export type DeleteInvoiceAccountMutationOptions = Apollo.BaseMutationOptions<DeleteInvoiceAccountMutation, DeleteInvoiceAccountMutationVariables>;
export const GetInvoiceAccountsForAccountDocument = gql`
    query getInvoiceAccountsForAccount($accountId: ID!) {
  account(id: $accountId) {
    invoiceAccounts {
      ...InvoiceAccount
    }
  }
}
    ${InvoiceAccountFragmentDoc}`;

/**
 * __useGetInvoiceAccountsForAccountQuery__
 *
 * To run a query within a React component, call `useGetInvoiceAccountsForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceAccountsForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceAccountsForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetInvoiceAccountsForAccountQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceAccountsForAccountQuery, GetInvoiceAccountsForAccountQueryVariables> & ({ variables: GetInvoiceAccountsForAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceAccountsForAccountQuery, GetInvoiceAccountsForAccountQueryVariables>(GetInvoiceAccountsForAccountDocument, options);
      }
export function useGetInvoiceAccountsForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceAccountsForAccountQuery, GetInvoiceAccountsForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceAccountsForAccountQuery, GetInvoiceAccountsForAccountQueryVariables>(GetInvoiceAccountsForAccountDocument, options);
        }
// @ts-ignore
export function useGetInvoiceAccountsForAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceAccountsForAccountQuery, GetInvoiceAccountsForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceAccountsForAccountQuery, GetInvoiceAccountsForAccountQueryVariables>;
export function useGetInvoiceAccountsForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceAccountsForAccountQuery, GetInvoiceAccountsForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceAccountsForAccountQuery | undefined, GetInvoiceAccountsForAccountQueryVariables>;
export function useGetInvoiceAccountsForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceAccountsForAccountQuery, GetInvoiceAccountsForAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceAccountsForAccountQuery, GetInvoiceAccountsForAccountQueryVariables>(GetInvoiceAccountsForAccountDocument, options);
        }
export type GetInvoiceAccountsForAccountQueryHookResult = ReturnType<typeof useGetInvoiceAccountsForAccountQuery>;
export type GetInvoiceAccountsForAccountLazyQueryHookResult = ReturnType<typeof useGetInvoiceAccountsForAccountLazyQuery>;
export type GetInvoiceAccountsForAccountSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceAccountsForAccountSuspenseQuery>;
export type GetInvoiceAccountsForAccountQueryResult = Apollo.QueryResult<GetInvoiceAccountsForAccountQuery, GetInvoiceAccountsForAccountQueryVariables>;
export const CreateReferenceFieldDocument = gql`
    mutation createReferenceField($invoiceAccountId: ID!, $input: CreateReferenceFieldInput!) {
  createReferenceField(invoiceAccountId: $invoiceAccountId, input: $input) {
    id
    label
    description
    type
    active
    required
    options {
      id
      referenceFieldId
      option
      orderPriority
    }
    isInvoiceSummaryField
  }
}
    `;
export type CreateReferenceFieldMutationFn = Apollo.MutationFunction<CreateReferenceFieldMutation, CreateReferenceFieldMutationVariables>;

/**
 * __useCreateReferenceFieldMutation__
 *
 * To run a mutation, you first call `useCreateReferenceFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReferenceFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReferenceFieldMutation, { data, loading, error }] = useCreateReferenceFieldMutation({
 *   variables: {
 *      invoiceAccountId: // value for 'invoiceAccountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReferenceFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateReferenceFieldMutation, CreateReferenceFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReferenceFieldMutation, CreateReferenceFieldMutationVariables>(CreateReferenceFieldDocument, options);
      }
export type CreateReferenceFieldMutationHookResult = ReturnType<typeof useCreateReferenceFieldMutation>;
export type CreateReferenceFieldMutationResult = Apollo.MutationResult<CreateReferenceFieldMutation>;
export type CreateReferenceFieldMutationOptions = Apollo.BaseMutationOptions<CreateReferenceFieldMutation, CreateReferenceFieldMutationVariables>;
export const UpdateReferenceFieldDocument = gql`
    mutation updateReferenceField($id: ID!, $input: UpdateReferenceFieldInput!) {
  updateReferenceField(id: $id, input: $input) {
    id
    label
    description
    type
    active
    required
    options {
      id
      referenceFieldId
      option
      orderPriority
    }
    isInvoiceSummaryField
  }
}
    `;
export type UpdateReferenceFieldMutationFn = Apollo.MutationFunction<UpdateReferenceFieldMutation, UpdateReferenceFieldMutationVariables>;

/**
 * __useUpdateReferenceFieldMutation__
 *
 * To run a mutation, you first call `useUpdateReferenceFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferenceFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferenceFieldMutation, { data, loading, error }] = useUpdateReferenceFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReferenceFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReferenceFieldMutation, UpdateReferenceFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReferenceFieldMutation, UpdateReferenceFieldMutationVariables>(UpdateReferenceFieldDocument, options);
      }
export type UpdateReferenceFieldMutationHookResult = ReturnType<typeof useUpdateReferenceFieldMutation>;
export type UpdateReferenceFieldMutationResult = Apollo.MutationResult<UpdateReferenceFieldMutation>;
export type UpdateReferenceFieldMutationOptions = Apollo.BaseMutationOptions<UpdateReferenceFieldMutation, UpdateReferenceFieldMutationVariables>;
export const DeleteReferenceFieldDocument = gql`
    mutation deleteReferenceField($id: ID!) {
  deleteReferenceField(id: $id)
}
    `;
export type DeleteReferenceFieldMutationFn = Apollo.MutationFunction<DeleteReferenceFieldMutation, DeleteReferenceFieldMutationVariables>;

/**
 * __useDeleteReferenceFieldMutation__
 *
 * To run a mutation, you first call `useDeleteReferenceFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReferenceFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReferenceFieldMutation, { data, loading, error }] = useDeleteReferenceFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReferenceFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReferenceFieldMutation, DeleteReferenceFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReferenceFieldMutation, DeleteReferenceFieldMutationVariables>(DeleteReferenceFieldDocument, options);
      }
export type DeleteReferenceFieldMutationHookResult = ReturnType<typeof useDeleteReferenceFieldMutation>;
export type DeleteReferenceFieldMutationResult = Apollo.MutationResult<DeleteReferenceFieldMutation>;
export type DeleteReferenceFieldMutationOptions = Apollo.BaseMutationOptions<DeleteReferenceFieldMutation, DeleteReferenceFieldMutationVariables>;
export const GetReferenceFieldsForInvoiceAccountDocument = gql`
    query getReferenceFieldsForInvoiceAccount($invoiceAccountId: ID!, $options: ReferenceFieldsOptionsInput) {
  referenceFields(invoiceAccountId: $invoiceAccountId, options: $options) {
    rows {
      id
      label
      type
      description
      active
      required
      options {
        id
        referenceFieldId
        option
        orderPriority
      }
      isInvoiceSummaryField
    }
  }
}
    `;

/**
 * __useGetReferenceFieldsForInvoiceAccountQuery__
 *
 * To run a query within a React component, call `useGetReferenceFieldsForInvoiceAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferenceFieldsForInvoiceAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferenceFieldsForInvoiceAccountQuery({
 *   variables: {
 *      invoiceAccountId: // value for 'invoiceAccountId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetReferenceFieldsForInvoiceAccountQuery(baseOptions: Apollo.QueryHookOptions<GetReferenceFieldsForInvoiceAccountQuery, GetReferenceFieldsForInvoiceAccountQueryVariables> & ({ variables: GetReferenceFieldsForInvoiceAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferenceFieldsForInvoiceAccountQuery, GetReferenceFieldsForInvoiceAccountQueryVariables>(GetReferenceFieldsForInvoiceAccountDocument, options);
      }
export function useGetReferenceFieldsForInvoiceAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferenceFieldsForInvoiceAccountQuery, GetReferenceFieldsForInvoiceAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferenceFieldsForInvoiceAccountQuery, GetReferenceFieldsForInvoiceAccountQueryVariables>(GetReferenceFieldsForInvoiceAccountDocument, options);
        }
// @ts-ignore
export function useGetReferenceFieldsForInvoiceAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReferenceFieldsForInvoiceAccountQuery, GetReferenceFieldsForInvoiceAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetReferenceFieldsForInvoiceAccountQuery, GetReferenceFieldsForInvoiceAccountQueryVariables>;
export function useGetReferenceFieldsForInvoiceAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferenceFieldsForInvoiceAccountQuery, GetReferenceFieldsForInvoiceAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetReferenceFieldsForInvoiceAccountQuery | undefined, GetReferenceFieldsForInvoiceAccountQueryVariables>;
export function useGetReferenceFieldsForInvoiceAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferenceFieldsForInvoiceAccountQuery, GetReferenceFieldsForInvoiceAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReferenceFieldsForInvoiceAccountQuery, GetReferenceFieldsForInvoiceAccountQueryVariables>(GetReferenceFieldsForInvoiceAccountDocument, options);
        }
export type GetReferenceFieldsForInvoiceAccountQueryHookResult = ReturnType<typeof useGetReferenceFieldsForInvoiceAccountQuery>;
export type GetReferenceFieldsForInvoiceAccountLazyQueryHookResult = ReturnType<typeof useGetReferenceFieldsForInvoiceAccountLazyQuery>;
export type GetReferenceFieldsForInvoiceAccountSuspenseQueryHookResult = ReturnType<typeof useGetReferenceFieldsForInvoiceAccountSuspenseQuery>;
export type GetReferenceFieldsForInvoiceAccountQueryResult = Apollo.QueryResult<GetReferenceFieldsForInvoiceAccountQuery, GetReferenceFieldsForInvoiceAccountQueryVariables>;
export const GetAllVatRegionsDocument = gql`
    query getAllVatRegions {
  vatRegions {
    code
    legacyId
    name
  }
}
    `;

/**
 * __useGetAllVatRegionsQuery__
 *
 * To run a query within a React component, call `useGetAllVatRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVatRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVatRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllVatRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllVatRegionsQuery, GetAllVatRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllVatRegionsQuery, GetAllVatRegionsQueryVariables>(GetAllVatRegionsDocument, options);
      }
export function useGetAllVatRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllVatRegionsQuery, GetAllVatRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllVatRegionsQuery, GetAllVatRegionsQueryVariables>(GetAllVatRegionsDocument, options);
        }
// @ts-ignore
export function useGetAllVatRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllVatRegionsQuery, GetAllVatRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllVatRegionsQuery, GetAllVatRegionsQueryVariables>;
export function useGetAllVatRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllVatRegionsQuery, GetAllVatRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllVatRegionsQuery | undefined, GetAllVatRegionsQueryVariables>;
export function useGetAllVatRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllVatRegionsQuery, GetAllVatRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllVatRegionsQuery, GetAllVatRegionsQueryVariables>(GetAllVatRegionsDocument, options);
        }
export type GetAllVatRegionsQueryHookResult = ReturnType<typeof useGetAllVatRegionsQuery>;
export type GetAllVatRegionsLazyQueryHookResult = ReturnType<typeof useGetAllVatRegionsLazyQuery>;
export type GetAllVatRegionsSuspenseQueryHookResult = ReturnType<typeof useGetAllVatRegionsSuspenseQuery>;
export type GetAllVatRegionsQueryResult = Apollo.QueryResult<GetAllVatRegionsQuery, GetAllVatRegionsQueryVariables>;
export const GetAccountFinanceSettingsDocument = gql`
    query getAccountFinanceSettings($accountId: ID!) {
  account(id: $accountId) {
    isCCActive
    currency
    financeSettings {
      allowMinTopUpCc
      budgetCodeCc
      budgetCodeGm
      contractDateFrom
      contractDateTo
      deliverySurchargeCc
      deliverySurchargeCcExTax
      invoicingFormatGm
      minOrderValueCc
      minOrderValueCcExTax
      minPlatformFeeCc
      minPlatformFeeGm
      orderValPercentPlatformFeeCc
      orderValPercentPlatformFeeGm
      paymentDueDaysAfterInvoice
      additionalBillingNotes
      isBudgetCodeMandatory
      minPlatformFeeCcMonthlyExTax
      orderValPercentEnterpriseDiscountGm
      feeAndDiscountNotesGm
      enterpriseCostPlusPricing
      minMonthlyCateringSpendExTax
    }
  }
}
    `;

/**
 * __useGetAccountFinanceSettingsQuery__
 *
 * To run a query within a React component, call `useGetAccountFinanceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountFinanceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountFinanceSettingsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountFinanceSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetAccountFinanceSettingsQuery, GetAccountFinanceSettingsQueryVariables> & ({ variables: GetAccountFinanceSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountFinanceSettingsQuery, GetAccountFinanceSettingsQueryVariables>(GetAccountFinanceSettingsDocument, options);
      }
export function useGetAccountFinanceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountFinanceSettingsQuery, GetAccountFinanceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountFinanceSettingsQuery, GetAccountFinanceSettingsQueryVariables>(GetAccountFinanceSettingsDocument, options);
        }
// @ts-ignore
export function useGetAccountFinanceSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountFinanceSettingsQuery, GetAccountFinanceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountFinanceSettingsQuery, GetAccountFinanceSettingsQueryVariables>;
export function useGetAccountFinanceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountFinanceSettingsQuery, GetAccountFinanceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountFinanceSettingsQuery | undefined, GetAccountFinanceSettingsQueryVariables>;
export function useGetAccountFinanceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountFinanceSettingsQuery, GetAccountFinanceSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountFinanceSettingsQuery, GetAccountFinanceSettingsQueryVariables>(GetAccountFinanceSettingsDocument, options);
        }
export type GetAccountFinanceSettingsQueryHookResult = ReturnType<typeof useGetAccountFinanceSettingsQuery>;
export type GetAccountFinanceSettingsLazyQueryHookResult = ReturnType<typeof useGetAccountFinanceSettingsLazyQuery>;
export type GetAccountFinanceSettingsSuspenseQueryHookResult = ReturnType<typeof useGetAccountFinanceSettingsSuspenseQuery>;
export type GetAccountFinanceSettingsQueryResult = Apollo.QueryResult<GetAccountFinanceSettingsQuery, GetAccountFinanceSettingsQueryVariables>;
export const UpdateAccountFinanceSettingsDocument = gql`
    mutation updateAccountFinanceSettings($accountId: Int!, $input: UpdateAccountFinanceSettingsInput!) {
  updateAccountFinanceSettings(accountId: $accountId, input: $input) {
    allowMinTopUpCc
    budgetCodeCc
    budgetCodeGm
    contractDateFrom
    contractDateTo
    deliverySurchargeCc
    deliverySurchargeCcExTax
    invoicingFormatGm
    minOrderValueCc
    minOrderValueCcExTax
    minPlatformFeeCc
    minPlatformFeeGm
    orderValPercentPlatformFeeCc
    orderValPercentPlatformFeeGm
    paymentDueDaysAfterInvoice
    additionalBillingNotes
    isBudgetCodeMandatory
    orderValPercentEnterpriseDiscountGm
    feeAndDiscountNotesGm
    enterpriseCostPlusPricing
    minMonthlyCateringSpendExTax
  }
}
    `;
export type UpdateAccountFinanceSettingsMutationFn = Apollo.MutationFunction<UpdateAccountFinanceSettingsMutation, UpdateAccountFinanceSettingsMutationVariables>;

/**
 * __useUpdateAccountFinanceSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountFinanceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountFinanceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountFinanceSettingsMutation, { data, loading, error }] = useUpdateAccountFinanceSettingsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountFinanceSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountFinanceSettingsMutation, UpdateAccountFinanceSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountFinanceSettingsMutation, UpdateAccountFinanceSettingsMutationVariables>(UpdateAccountFinanceSettingsDocument, options);
      }
export type UpdateAccountFinanceSettingsMutationHookResult = ReturnType<typeof useUpdateAccountFinanceSettingsMutation>;
export type UpdateAccountFinanceSettingsMutationResult = Apollo.MutationResult<UpdateAccountFinanceSettingsMutation>;
export type UpdateAccountFinanceSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateAccountFinanceSettingsMutation, UpdateAccountFinanceSettingsMutationVariables>;
export const FlexInvoiceCsvDocument = gql`
    query FlexInvoiceCSV($flexDeferredCustomerInvoiceId: ID!, $accountId: Int!) {
  flexInvoice(id: $flexDeferredCustomerInvoiceId, accountId: $accountId) {
    id
    csv
  }
}
    `;

/**
 * __useFlexInvoiceCsvQuery__
 *
 * To run a query within a React component, call `useFlexInvoiceCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlexInvoiceCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlexInvoiceCsvQuery({
 *   variables: {
 *      flexDeferredCustomerInvoiceId: // value for 'flexDeferredCustomerInvoiceId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useFlexInvoiceCsvQuery(baseOptions: Apollo.QueryHookOptions<FlexInvoiceCsvQuery, FlexInvoiceCsvQueryVariables> & ({ variables: FlexInvoiceCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlexInvoiceCsvQuery, FlexInvoiceCsvQueryVariables>(FlexInvoiceCsvDocument, options);
      }
export function useFlexInvoiceCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlexInvoiceCsvQuery, FlexInvoiceCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlexInvoiceCsvQuery, FlexInvoiceCsvQueryVariables>(FlexInvoiceCsvDocument, options);
        }
// @ts-ignore
export function useFlexInvoiceCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FlexInvoiceCsvQuery, FlexInvoiceCsvQueryVariables>): Apollo.UseSuspenseQueryResult<FlexInvoiceCsvQuery, FlexInvoiceCsvQueryVariables>;
export function useFlexInvoiceCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlexInvoiceCsvQuery, FlexInvoiceCsvQueryVariables>): Apollo.UseSuspenseQueryResult<FlexInvoiceCsvQuery | undefined, FlexInvoiceCsvQueryVariables>;
export function useFlexInvoiceCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlexInvoiceCsvQuery, FlexInvoiceCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FlexInvoiceCsvQuery, FlexInvoiceCsvQueryVariables>(FlexInvoiceCsvDocument, options);
        }
export type FlexInvoiceCsvQueryHookResult = ReturnType<typeof useFlexInvoiceCsvQuery>;
export type FlexInvoiceCsvLazyQueryHookResult = ReturnType<typeof useFlexInvoiceCsvLazyQuery>;
export type FlexInvoiceCsvSuspenseQueryHookResult = ReturnType<typeof useFlexInvoiceCsvSuspenseQuery>;
export type FlexInvoiceCsvQueryResult = Apollo.QueryResult<FlexInvoiceCsvQuery, FlexInvoiceCsvQueryVariables>;
export const GetLegacyFlexDeferredCustomersForAccountDocument = gql`
    query getLegacyFlexDeferredCustomersForAccount($accountId: ID!) {
  account(id: $accountId) {
    defaultFlexDeferredCustomerId
    invoiceAccounts {
      flexDeferredCustomerId
    }
  }
}
    `;

/**
 * __useGetLegacyFlexDeferredCustomersForAccountQuery__
 *
 * To run a query within a React component, call `useGetLegacyFlexDeferredCustomersForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLegacyFlexDeferredCustomersForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLegacyFlexDeferredCustomersForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetLegacyFlexDeferredCustomersForAccountQuery(baseOptions: Apollo.QueryHookOptions<GetLegacyFlexDeferredCustomersForAccountQuery, GetLegacyFlexDeferredCustomersForAccountQueryVariables> & ({ variables: GetLegacyFlexDeferredCustomersForAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLegacyFlexDeferredCustomersForAccountQuery, GetLegacyFlexDeferredCustomersForAccountQueryVariables>(GetLegacyFlexDeferredCustomersForAccountDocument, options);
      }
export function useGetLegacyFlexDeferredCustomersForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLegacyFlexDeferredCustomersForAccountQuery, GetLegacyFlexDeferredCustomersForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLegacyFlexDeferredCustomersForAccountQuery, GetLegacyFlexDeferredCustomersForAccountQueryVariables>(GetLegacyFlexDeferredCustomersForAccountDocument, options);
        }
// @ts-ignore
export function useGetLegacyFlexDeferredCustomersForAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLegacyFlexDeferredCustomersForAccountQuery, GetLegacyFlexDeferredCustomersForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetLegacyFlexDeferredCustomersForAccountQuery, GetLegacyFlexDeferredCustomersForAccountQueryVariables>;
export function useGetLegacyFlexDeferredCustomersForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLegacyFlexDeferredCustomersForAccountQuery, GetLegacyFlexDeferredCustomersForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetLegacyFlexDeferredCustomersForAccountQuery | undefined, GetLegacyFlexDeferredCustomersForAccountQueryVariables>;
export function useGetLegacyFlexDeferredCustomersForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLegacyFlexDeferredCustomersForAccountQuery, GetLegacyFlexDeferredCustomersForAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLegacyFlexDeferredCustomersForAccountQuery, GetLegacyFlexDeferredCustomersForAccountQueryVariables>(GetLegacyFlexDeferredCustomersForAccountDocument, options);
        }
export type GetLegacyFlexDeferredCustomersForAccountQueryHookResult = ReturnType<typeof useGetLegacyFlexDeferredCustomersForAccountQuery>;
export type GetLegacyFlexDeferredCustomersForAccountLazyQueryHookResult = ReturnType<typeof useGetLegacyFlexDeferredCustomersForAccountLazyQuery>;
export type GetLegacyFlexDeferredCustomersForAccountSuspenseQueryHookResult = ReturnType<typeof useGetLegacyFlexDeferredCustomersForAccountSuspenseQuery>;
export type GetLegacyFlexDeferredCustomersForAccountQueryResult = Apollo.QueryResult<GetLegacyFlexDeferredCustomersForAccountQuery, GetLegacyFlexDeferredCustomersForAccountQueryVariables>;
export const GetAccountCountryFlexDeferredCustomersForAccountDocument = gql`
    query getAccountCountryFlexDeferredCustomersForAccount($accountId: ID!) {
  account(id: $accountId) {
    accountCountryFlexMappings {
      country
      flexDeferredCustomerId
    }
    invoiceAccounts {
      flexDeferredCustomerId
    }
  }
}
    `;

/**
 * __useGetAccountCountryFlexDeferredCustomersForAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountCountryFlexDeferredCustomersForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountCountryFlexDeferredCustomersForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountCountryFlexDeferredCustomersForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountCountryFlexDeferredCustomersForAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountCountryFlexDeferredCustomersForAccountQuery, GetAccountCountryFlexDeferredCustomersForAccountQueryVariables> & ({ variables: GetAccountCountryFlexDeferredCustomersForAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountCountryFlexDeferredCustomersForAccountQuery, GetAccountCountryFlexDeferredCustomersForAccountQueryVariables>(GetAccountCountryFlexDeferredCustomersForAccountDocument, options);
      }
export function useGetAccountCountryFlexDeferredCustomersForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountCountryFlexDeferredCustomersForAccountQuery, GetAccountCountryFlexDeferredCustomersForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountCountryFlexDeferredCustomersForAccountQuery, GetAccountCountryFlexDeferredCustomersForAccountQueryVariables>(GetAccountCountryFlexDeferredCustomersForAccountDocument, options);
        }
// @ts-ignore
export function useGetAccountCountryFlexDeferredCustomersForAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountCountryFlexDeferredCustomersForAccountQuery, GetAccountCountryFlexDeferredCustomersForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountCountryFlexDeferredCustomersForAccountQuery, GetAccountCountryFlexDeferredCustomersForAccountQueryVariables>;
export function useGetAccountCountryFlexDeferredCustomersForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountCountryFlexDeferredCustomersForAccountQuery, GetAccountCountryFlexDeferredCustomersForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountCountryFlexDeferredCustomersForAccountQuery | undefined, GetAccountCountryFlexDeferredCustomersForAccountQueryVariables>;
export function useGetAccountCountryFlexDeferredCustomersForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountCountryFlexDeferredCustomersForAccountQuery, GetAccountCountryFlexDeferredCustomersForAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountCountryFlexDeferredCustomersForAccountQuery, GetAccountCountryFlexDeferredCustomersForAccountQueryVariables>(GetAccountCountryFlexDeferredCustomersForAccountDocument, options);
        }
export type GetAccountCountryFlexDeferredCustomersForAccountQueryHookResult = ReturnType<typeof useGetAccountCountryFlexDeferredCustomersForAccountQuery>;
export type GetAccountCountryFlexDeferredCustomersForAccountLazyQueryHookResult = ReturnType<typeof useGetAccountCountryFlexDeferredCustomersForAccountLazyQuery>;
export type GetAccountCountryFlexDeferredCustomersForAccountSuspenseQueryHookResult = ReturnType<typeof useGetAccountCountryFlexDeferredCustomersForAccountSuspenseQuery>;
export type GetAccountCountryFlexDeferredCustomersForAccountQueryResult = Apollo.QueryResult<GetAccountCountryFlexDeferredCustomersForAccountQuery, GetAccountCountryFlexDeferredCustomersForAccountQueryVariables>;
export const FlexInvoicesDocument = gql`
    query FlexInvoices($input: FlexInvoicesInput!) {
  flexInvoices(input: $input) {
    items {
      id
      accountName
      number
      total
      createdAt
      dueDate
      status
      country
    }
    pageInfo {
      count
      hasMore
      limit
      offset
    }
  }
}
    `;

/**
 * __useFlexInvoicesQuery__
 *
 * To run a query within a React component, call `useFlexInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlexInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlexInvoicesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFlexInvoicesQuery(baseOptions: Apollo.QueryHookOptions<FlexInvoicesQuery, FlexInvoicesQueryVariables> & ({ variables: FlexInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlexInvoicesQuery, FlexInvoicesQueryVariables>(FlexInvoicesDocument, options);
      }
export function useFlexInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlexInvoicesQuery, FlexInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlexInvoicesQuery, FlexInvoicesQueryVariables>(FlexInvoicesDocument, options);
        }
// @ts-ignore
export function useFlexInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FlexInvoicesQuery, FlexInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<FlexInvoicesQuery, FlexInvoicesQueryVariables>;
export function useFlexInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlexInvoicesQuery, FlexInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<FlexInvoicesQuery | undefined, FlexInvoicesQueryVariables>;
export function useFlexInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlexInvoicesQuery, FlexInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FlexInvoicesQuery, FlexInvoicesQueryVariables>(FlexInvoicesDocument, options);
        }
export type FlexInvoicesQueryHookResult = ReturnType<typeof useFlexInvoicesQuery>;
export type FlexInvoicesLazyQueryHookResult = ReturnType<typeof useFlexInvoicesLazyQuery>;
export type FlexInvoicesSuspenseQueryHookResult = ReturnType<typeof useFlexInvoicesSuspenseQuery>;
export type FlexInvoicesQueryResult = Apollo.QueryResult<FlexInvoicesQuery, FlexInvoicesQueryVariables>;
export const FlexInvoiceAllTypesDocument = gql`
    query FlexInvoiceAllTypes($flexInvoiceAllTypesInput: FlexInvoicesInput) {
  flexInvoiceAllTypes(input: $flexInvoiceAllTypesInput) {
    items {
      id
      flexInvoiceId
      invoiceType
      number
      createdAt
      entityName
      accountName
      accountBusinessNumber
      accountTaxNumber
      accountAddress
      accountContact
      dueDate
      total
      status
      csv
      timezone
      location
      country
      flexDeferredCustomerId
      instant
      assets {
        type
        link
      }
    }
    pageInfo {
      offset
      limit
      count
      hasMore
    }
  }
}
    `;

/**
 * __useFlexInvoiceAllTypesQuery__
 *
 * To run a query within a React component, call `useFlexInvoiceAllTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlexInvoiceAllTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlexInvoiceAllTypesQuery({
 *   variables: {
 *      flexInvoiceAllTypesInput: // value for 'flexInvoiceAllTypesInput'
 *   },
 * });
 */
export function useFlexInvoiceAllTypesQuery(baseOptions?: Apollo.QueryHookOptions<FlexInvoiceAllTypesQuery, FlexInvoiceAllTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlexInvoiceAllTypesQuery, FlexInvoiceAllTypesQueryVariables>(FlexInvoiceAllTypesDocument, options);
      }
export function useFlexInvoiceAllTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlexInvoiceAllTypesQuery, FlexInvoiceAllTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlexInvoiceAllTypesQuery, FlexInvoiceAllTypesQueryVariables>(FlexInvoiceAllTypesDocument, options);
        }
// @ts-ignore
export function useFlexInvoiceAllTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FlexInvoiceAllTypesQuery, FlexInvoiceAllTypesQueryVariables>): Apollo.UseSuspenseQueryResult<FlexInvoiceAllTypesQuery, FlexInvoiceAllTypesQueryVariables>;
export function useFlexInvoiceAllTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlexInvoiceAllTypesQuery, FlexInvoiceAllTypesQueryVariables>): Apollo.UseSuspenseQueryResult<FlexInvoiceAllTypesQuery | undefined, FlexInvoiceAllTypesQueryVariables>;
export function useFlexInvoiceAllTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlexInvoiceAllTypesQuery, FlexInvoiceAllTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FlexInvoiceAllTypesQuery, FlexInvoiceAllTypesQueryVariables>(FlexInvoiceAllTypesDocument, options);
        }
export type FlexInvoiceAllTypesQueryHookResult = ReturnType<typeof useFlexInvoiceAllTypesQuery>;
export type FlexInvoiceAllTypesLazyQueryHookResult = ReturnType<typeof useFlexInvoiceAllTypesLazyQuery>;
export type FlexInvoiceAllTypesSuspenseQueryHookResult = ReturnType<typeof useFlexInvoiceAllTypesSuspenseQuery>;
export type FlexInvoiceAllTypesQueryResult = Apollo.QueryResult<FlexInvoiceAllTypesQuery, FlexInvoiceAllTypesQueryVariables>;
export const GetOrdersForFlexInvoiceDocument = gql`
    query GetOrdersForFlexInvoice($input: InvoiceOrderInput) {
  invoiceOrders(input: $input) {
    items {
      id
      number
    }
  }
}
    `;

/**
 * __useGetOrdersForFlexInvoiceQuery__
 *
 * To run a query within a React component, call `useGetOrdersForFlexInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersForFlexInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersForFlexInvoiceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrdersForFlexInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersForFlexInvoiceQuery, GetOrdersForFlexInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersForFlexInvoiceQuery, GetOrdersForFlexInvoiceQueryVariables>(GetOrdersForFlexInvoiceDocument, options);
      }
export function useGetOrdersForFlexInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersForFlexInvoiceQuery, GetOrdersForFlexInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersForFlexInvoiceQuery, GetOrdersForFlexInvoiceQueryVariables>(GetOrdersForFlexInvoiceDocument, options);
        }
// @ts-ignore
export function useGetOrdersForFlexInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrdersForFlexInvoiceQuery, GetOrdersForFlexInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersForFlexInvoiceQuery, GetOrdersForFlexInvoiceQueryVariables>;
export function useGetOrdersForFlexInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersForFlexInvoiceQuery, GetOrdersForFlexInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersForFlexInvoiceQuery | undefined, GetOrdersForFlexInvoiceQueryVariables>;
export function useGetOrdersForFlexInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersForFlexInvoiceQuery, GetOrdersForFlexInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersForFlexInvoiceQuery, GetOrdersForFlexInvoiceQueryVariables>(GetOrdersForFlexInvoiceDocument, options);
        }
export type GetOrdersForFlexInvoiceQueryHookResult = ReturnType<typeof useGetOrdersForFlexInvoiceQuery>;
export type GetOrdersForFlexInvoiceLazyQueryHookResult = ReturnType<typeof useGetOrdersForFlexInvoiceLazyQuery>;
export type GetOrdersForFlexInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetOrdersForFlexInvoiceSuspenseQuery>;
export type GetOrdersForFlexInvoiceQueryResult = Apollo.QueryResult<GetOrdersForFlexInvoiceQuery, GetOrdersForFlexInvoiceQueryVariables>;
export const RemoveOrdersFromFlexInvoiceDocument = gql`
    mutation RemoveOrdersFromFlexInvoice($flexInvoiceId: ID!, $input: RemoveOrdersFromFlexInvoiceInput!) {
  removeOrdersFromFlexInvoice(id: $flexInvoiceId, input: $input)
}
    `;
export type RemoveOrdersFromFlexInvoiceMutationFn = Apollo.MutationFunction<RemoveOrdersFromFlexInvoiceMutation, RemoveOrdersFromFlexInvoiceMutationVariables>;

/**
 * __useRemoveOrdersFromFlexInvoiceMutation__
 *
 * To run a mutation, you first call `useRemoveOrdersFromFlexInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrdersFromFlexInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrdersFromFlexInvoiceMutation, { data, loading, error }] = useRemoveOrdersFromFlexInvoiceMutation({
 *   variables: {
 *      flexInvoiceId: // value for 'flexInvoiceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveOrdersFromFlexInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrdersFromFlexInvoiceMutation, RemoveOrdersFromFlexInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrdersFromFlexInvoiceMutation, RemoveOrdersFromFlexInvoiceMutationVariables>(RemoveOrdersFromFlexInvoiceDocument, options);
      }
export type RemoveOrdersFromFlexInvoiceMutationHookResult = ReturnType<typeof useRemoveOrdersFromFlexInvoiceMutation>;
export type RemoveOrdersFromFlexInvoiceMutationResult = Apollo.MutationResult<RemoveOrdersFromFlexInvoiceMutation>;
export type RemoveOrdersFromFlexInvoiceMutationOptions = Apollo.BaseMutationOptions<RemoveOrdersFromFlexInvoiceMutation, RemoveOrdersFromFlexInvoiceMutationVariables>;
export const SendFlexInvoiceByEmailDocument = gql`
    mutation SendFlexInvoiceByEmail($flexInvoiceId: ID!, $emailAddresses: [String!]!, $invoiceType: FlexInvoiceType) {
  sendFlexInvoiceByEmail(
    flexInvoiceId: $flexInvoiceId
    emailAddresses: $emailAddresses
    invoiceType: $invoiceType
  )
}
    `;
export type SendFlexInvoiceByEmailMutationFn = Apollo.MutationFunction<SendFlexInvoiceByEmailMutation, SendFlexInvoiceByEmailMutationVariables>;

/**
 * __useSendFlexInvoiceByEmailMutation__
 *
 * To run a mutation, you first call `useSendFlexInvoiceByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFlexInvoiceByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFlexInvoiceByEmailMutation, { data, loading, error }] = useSendFlexInvoiceByEmailMutation({
 *   variables: {
 *      flexInvoiceId: // value for 'flexInvoiceId'
 *      emailAddresses: // value for 'emailAddresses'
 *      invoiceType: // value for 'invoiceType'
 *   },
 * });
 */
export function useSendFlexInvoiceByEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendFlexInvoiceByEmailMutation, SendFlexInvoiceByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFlexInvoiceByEmailMutation, SendFlexInvoiceByEmailMutationVariables>(SendFlexInvoiceByEmailDocument, options);
      }
export type SendFlexInvoiceByEmailMutationHookResult = ReturnType<typeof useSendFlexInvoiceByEmailMutation>;
export type SendFlexInvoiceByEmailMutationResult = Apollo.MutationResult<SendFlexInvoiceByEmailMutation>;
export type SendFlexInvoiceByEmailMutationOptions = Apollo.BaseMutationOptions<SendFlexInvoiceByEmailMutation, SendFlexInvoiceByEmailMutationVariables>;
export const UpdateFlexInvoiceDetailsDocument = gql`
    mutation UpdateFlexInvoiceDetails($flexInvoiceId: ID!, $updates: UpdateFlexInvoiceDetailsInput!) {
  updateFlexInvoiceDetails(id: $flexInvoiceId, input: $updates)
}
    `;
export type UpdateFlexInvoiceDetailsMutationFn = Apollo.MutationFunction<UpdateFlexInvoiceDetailsMutation, UpdateFlexInvoiceDetailsMutationVariables>;

/**
 * __useUpdateFlexInvoiceDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateFlexInvoiceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFlexInvoiceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFlexInvoiceDetailsMutation, { data, loading, error }] = useUpdateFlexInvoiceDetailsMutation({
 *   variables: {
 *      flexInvoiceId: // value for 'flexInvoiceId'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateFlexInvoiceDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFlexInvoiceDetailsMutation, UpdateFlexInvoiceDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFlexInvoiceDetailsMutation, UpdateFlexInvoiceDetailsMutationVariables>(UpdateFlexInvoiceDetailsDocument, options);
      }
export type UpdateFlexInvoiceDetailsMutationHookResult = ReturnType<typeof useUpdateFlexInvoiceDetailsMutation>;
export type UpdateFlexInvoiceDetailsMutationResult = Apollo.MutationResult<UpdateFlexInvoiceDetailsMutation>;
export type UpdateFlexInvoiceDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateFlexInvoiceDetailsMutation, UpdateFlexInvoiceDetailsMutationVariables>;
export const GetAccountNameDocument = gql`
    query getAccountName($accountId: ID!) {
  account(id: $accountId) {
    id
    name
    isCCActive
    archivedAt
    archivedBy {
      fullName
    }
  }
}
    `;

/**
 * __useGetAccountNameQuery__
 *
 * To run a query within a React component, call `useGetAccountNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountNameQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountNameQuery(baseOptions: Apollo.QueryHookOptions<GetAccountNameQuery, GetAccountNameQueryVariables> & ({ variables: GetAccountNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountNameQuery, GetAccountNameQueryVariables>(GetAccountNameDocument, options);
      }
export function useGetAccountNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountNameQuery, GetAccountNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountNameQuery, GetAccountNameQueryVariables>(GetAccountNameDocument, options);
        }
// @ts-ignore
export function useGetAccountNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountNameQuery, GetAccountNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountNameQuery, GetAccountNameQueryVariables>;
export function useGetAccountNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountNameQuery, GetAccountNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountNameQuery | undefined, GetAccountNameQueryVariables>;
export function useGetAccountNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountNameQuery, GetAccountNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountNameQuery, GetAccountNameQueryVariables>(GetAccountNameDocument, options);
        }
export type GetAccountNameQueryHookResult = ReturnType<typeof useGetAccountNameQuery>;
export type GetAccountNameLazyQueryHookResult = ReturnType<typeof useGetAccountNameLazyQuery>;
export type GetAccountNameSuspenseQueryHookResult = ReturnType<typeof useGetAccountNameSuspenseQuery>;
export type GetAccountNameQueryResult = Apollo.QueryResult<GetAccountNameQuery, GetAccountNameQueryVariables>;
export const MarkFlexInvoicesAsPaidDocument = gql`
    mutation markFlexInvoicesAsPaid($input: MarkFlexInvoicesAsPaidInput!) {
  markFlexInvoicesAsPaid(input: $input) {
    batchId
    filename
    totalInvoices
    successCount
    failedCount
  }
}
    `;
export type MarkFlexInvoicesAsPaidMutationFn = Apollo.MutationFunction<MarkFlexInvoicesAsPaidMutation, MarkFlexInvoicesAsPaidMutationVariables>;

/**
 * __useMarkFlexInvoicesAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkFlexInvoicesAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFlexInvoicesAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFlexInvoicesAsPaidMutation, { data, loading, error }] = useMarkFlexInvoicesAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkFlexInvoicesAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkFlexInvoicesAsPaidMutation, MarkFlexInvoicesAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkFlexInvoicesAsPaidMutation, MarkFlexInvoicesAsPaidMutationVariables>(MarkFlexInvoicesAsPaidDocument, options);
      }
export type MarkFlexInvoicesAsPaidMutationHookResult = ReturnType<typeof useMarkFlexInvoicesAsPaidMutation>;
export type MarkFlexInvoicesAsPaidMutationResult = Apollo.MutationResult<MarkFlexInvoicesAsPaidMutation>;
export type MarkFlexInvoicesAsPaidMutationOptions = Apollo.BaseMutationOptions<MarkFlexInvoicesAsPaidMutation, MarkFlexInvoicesAsPaidMutationVariables>;
export const ConsolidateFlexInvoiceDocument = gql`
    mutation ConsolidateFlexInvoice($input: ConsolidateFlexInvoiceInput!) {
  consolidateFlexInvoice(input: $input) {
    customers {
      message
      status
    }
    suppliers {
      message
      status
    }
  }
}
    `;
export type ConsolidateFlexInvoiceMutationFn = Apollo.MutationFunction<ConsolidateFlexInvoiceMutation, ConsolidateFlexInvoiceMutationVariables>;

/**
 * __useConsolidateFlexInvoiceMutation__
 *
 * To run a mutation, you first call `useConsolidateFlexInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidateFlexInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidateFlexInvoiceMutation, { data, loading, error }] = useConsolidateFlexInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsolidateFlexInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ConsolidateFlexInvoiceMutation, ConsolidateFlexInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsolidateFlexInvoiceMutation, ConsolidateFlexInvoiceMutationVariables>(ConsolidateFlexInvoiceDocument, options);
      }
export type ConsolidateFlexInvoiceMutationHookResult = ReturnType<typeof useConsolidateFlexInvoiceMutation>;
export type ConsolidateFlexInvoiceMutationResult = Apollo.MutationResult<ConsolidateFlexInvoiceMutation>;
export type ConsolidateFlexInvoiceMutationOptions = Apollo.BaseMutationOptions<ConsolidateFlexInvoiceMutation, ConsolidateFlexInvoiceMutationVariables>;
export const LatestFlexConsolidationRunDocument = gql`
    query LatestFlexConsolidationRun($input: LatestFlexConsolidationRunInput!) {
  latestFlexConsolidationRun(input: $input) {
    hasRun
    status
    type
    completedAt
  }
}
    `;

/**
 * __useLatestFlexConsolidationRunQuery__
 *
 * To run a query within a React component, call `useLatestFlexConsolidationRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestFlexConsolidationRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestFlexConsolidationRunQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLatestFlexConsolidationRunQuery(baseOptions: Apollo.QueryHookOptions<LatestFlexConsolidationRunQuery, LatestFlexConsolidationRunQueryVariables> & ({ variables: LatestFlexConsolidationRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestFlexConsolidationRunQuery, LatestFlexConsolidationRunQueryVariables>(LatestFlexConsolidationRunDocument, options);
      }
export function useLatestFlexConsolidationRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestFlexConsolidationRunQuery, LatestFlexConsolidationRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestFlexConsolidationRunQuery, LatestFlexConsolidationRunQueryVariables>(LatestFlexConsolidationRunDocument, options);
        }
// @ts-ignore
export function useLatestFlexConsolidationRunSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LatestFlexConsolidationRunQuery, LatestFlexConsolidationRunQueryVariables>): Apollo.UseSuspenseQueryResult<LatestFlexConsolidationRunQuery, LatestFlexConsolidationRunQueryVariables>;
export function useLatestFlexConsolidationRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestFlexConsolidationRunQuery, LatestFlexConsolidationRunQueryVariables>): Apollo.UseSuspenseQueryResult<LatestFlexConsolidationRunQuery | undefined, LatestFlexConsolidationRunQueryVariables>;
export function useLatestFlexConsolidationRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestFlexConsolidationRunQuery, LatestFlexConsolidationRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LatestFlexConsolidationRunQuery, LatestFlexConsolidationRunQueryVariables>(LatestFlexConsolidationRunDocument, options);
        }
export type LatestFlexConsolidationRunQueryHookResult = ReturnType<typeof useLatestFlexConsolidationRunQuery>;
export type LatestFlexConsolidationRunLazyQueryHookResult = ReturnType<typeof useLatestFlexConsolidationRunLazyQuery>;
export type LatestFlexConsolidationRunSuspenseQueryHookResult = ReturnType<typeof useLatestFlexConsolidationRunSuspenseQuery>;
export type LatestFlexConsolidationRunQueryResult = Apollo.QueryResult<LatestFlexConsolidationRunQuery, LatestFlexConsolidationRunQueryVariables>;
export const SyncInvoiceOrderWithFlexDocument = gql`
    mutation SyncInvoiceOrderWithFlex($input: SyncInvoiceOrderWithFlex!) {
  syncInvoiceOrderWithFlex(input: $input) {
    message
    status
  }
}
    `;
export type SyncInvoiceOrderWithFlexMutationFn = Apollo.MutationFunction<SyncInvoiceOrderWithFlexMutation, SyncInvoiceOrderWithFlexMutationVariables>;

/**
 * __useSyncInvoiceOrderWithFlexMutation__
 *
 * To run a mutation, you first call `useSyncInvoiceOrderWithFlexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncInvoiceOrderWithFlexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncInvoiceOrderWithFlexMutation, { data, loading, error }] = useSyncInvoiceOrderWithFlexMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncInvoiceOrderWithFlexMutation(baseOptions?: Apollo.MutationHookOptions<SyncInvoiceOrderWithFlexMutation, SyncInvoiceOrderWithFlexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncInvoiceOrderWithFlexMutation, SyncInvoiceOrderWithFlexMutationVariables>(SyncInvoiceOrderWithFlexDocument, options);
      }
export type SyncInvoiceOrderWithFlexMutationHookResult = ReturnType<typeof useSyncInvoiceOrderWithFlexMutation>;
export type SyncInvoiceOrderWithFlexMutationResult = Apollo.MutationResult<SyncInvoiceOrderWithFlexMutation>;
export type SyncInvoiceOrderWithFlexMutationOptions = Apollo.BaseMutationOptions<SyncInvoiceOrderWithFlexMutation, SyncInvoiceOrderWithFlexMutationVariables>;
export const SearchFlexInvoiceDocument = gql`
    query searchFlexInvoice($flexInvoiceAllTypesInput: FlexInvoicesInput) {
  flexInvoiceAllTypes(input: $flexInvoiceAllTypesInput) {
    items {
      number
      accountId
    }
  }
}
    `;

/**
 * __useSearchFlexInvoiceQuery__
 *
 * To run a query within a React component, call `useSearchFlexInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFlexInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFlexInvoiceQuery({
 *   variables: {
 *      flexInvoiceAllTypesInput: // value for 'flexInvoiceAllTypesInput'
 *   },
 * });
 */
export function useSearchFlexInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<SearchFlexInvoiceQuery, SearchFlexInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFlexInvoiceQuery, SearchFlexInvoiceQueryVariables>(SearchFlexInvoiceDocument, options);
      }
export function useSearchFlexInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFlexInvoiceQuery, SearchFlexInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFlexInvoiceQuery, SearchFlexInvoiceQueryVariables>(SearchFlexInvoiceDocument, options);
        }
// @ts-ignore
export function useSearchFlexInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchFlexInvoiceQuery, SearchFlexInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<SearchFlexInvoiceQuery, SearchFlexInvoiceQueryVariables>;
export function useSearchFlexInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchFlexInvoiceQuery, SearchFlexInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<SearchFlexInvoiceQuery | undefined, SearchFlexInvoiceQueryVariables>;
export function useSearchFlexInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchFlexInvoiceQuery, SearchFlexInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchFlexInvoiceQuery, SearchFlexInvoiceQueryVariables>(SearchFlexInvoiceDocument, options);
        }
export type SearchFlexInvoiceQueryHookResult = ReturnType<typeof useSearchFlexInvoiceQuery>;
export type SearchFlexInvoiceLazyQueryHookResult = ReturnType<typeof useSearchFlexInvoiceLazyQuery>;
export type SearchFlexInvoiceSuspenseQueryHookResult = ReturnType<typeof useSearchFlexInvoiceSuspenseQuery>;
export type SearchFlexInvoiceQueryResult = Apollo.QueryResult<SearchFlexInvoiceQuery, SearchFlexInvoiceQueryVariables>;
export const SearchVendorFlexInvoiceDocument = gql`
    query searchVendorFlexInvoice($input: VendorFlexInvoicesInput!) {
  vendorFlexInvoiceAllTypes(input: $input) {
    items {
      number
      supplierId
    }
  }
}
    `;

/**
 * __useSearchVendorFlexInvoiceQuery__
 *
 * To run a query within a React component, call `useSearchVendorFlexInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVendorFlexInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVendorFlexInvoiceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchVendorFlexInvoiceQuery(baseOptions: Apollo.QueryHookOptions<SearchVendorFlexInvoiceQuery, SearchVendorFlexInvoiceQueryVariables> & ({ variables: SearchVendorFlexInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchVendorFlexInvoiceQuery, SearchVendorFlexInvoiceQueryVariables>(SearchVendorFlexInvoiceDocument, options);
      }
export function useSearchVendorFlexInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchVendorFlexInvoiceQuery, SearchVendorFlexInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchVendorFlexInvoiceQuery, SearchVendorFlexInvoiceQueryVariables>(SearchVendorFlexInvoiceDocument, options);
        }
// @ts-ignore
export function useSearchVendorFlexInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchVendorFlexInvoiceQuery, SearchVendorFlexInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<SearchVendorFlexInvoiceQuery, SearchVendorFlexInvoiceQueryVariables>;
export function useSearchVendorFlexInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchVendorFlexInvoiceQuery, SearchVendorFlexInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<SearchVendorFlexInvoiceQuery | undefined, SearchVendorFlexInvoiceQueryVariables>;
export function useSearchVendorFlexInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchVendorFlexInvoiceQuery, SearchVendorFlexInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchVendorFlexInvoiceQuery, SearchVendorFlexInvoiceQueryVariables>(SearchVendorFlexInvoiceDocument, options);
        }
export type SearchVendorFlexInvoiceQueryHookResult = ReturnType<typeof useSearchVendorFlexInvoiceQuery>;
export type SearchVendorFlexInvoiceLazyQueryHookResult = ReturnType<typeof useSearchVendorFlexInvoiceLazyQuery>;
export type SearchVendorFlexInvoiceSuspenseQueryHookResult = ReturnType<typeof useSearchVendorFlexInvoiceSuspenseQuery>;
export type SearchVendorFlexInvoiceQueryResult = Apollo.QueryResult<SearchVendorFlexInvoiceQuery, SearchVendorFlexInvoiceQueryVariables>;
export const SummaryFlexReportCsvDocument = gql`
    query SummaryFlexReportCSV($input: SummaryFlexReportCSVInput!) {
  summaryFlexReportCSV(input: $input)
}
    `;

/**
 * __useSummaryFlexReportCsvQuery__
 *
 * To run a query within a React component, call `useSummaryFlexReportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryFlexReportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryFlexReportCsvQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSummaryFlexReportCsvQuery(baseOptions: Apollo.QueryHookOptions<SummaryFlexReportCsvQuery, SummaryFlexReportCsvQueryVariables> & ({ variables: SummaryFlexReportCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummaryFlexReportCsvQuery, SummaryFlexReportCsvQueryVariables>(SummaryFlexReportCsvDocument, options);
      }
export function useSummaryFlexReportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummaryFlexReportCsvQuery, SummaryFlexReportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummaryFlexReportCsvQuery, SummaryFlexReportCsvQueryVariables>(SummaryFlexReportCsvDocument, options);
        }
// @ts-ignore
export function useSummaryFlexReportCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SummaryFlexReportCsvQuery, SummaryFlexReportCsvQueryVariables>): Apollo.UseSuspenseQueryResult<SummaryFlexReportCsvQuery, SummaryFlexReportCsvQueryVariables>;
export function useSummaryFlexReportCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummaryFlexReportCsvQuery, SummaryFlexReportCsvQueryVariables>): Apollo.UseSuspenseQueryResult<SummaryFlexReportCsvQuery | undefined, SummaryFlexReportCsvQueryVariables>;
export function useSummaryFlexReportCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummaryFlexReportCsvQuery, SummaryFlexReportCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummaryFlexReportCsvQuery, SummaryFlexReportCsvQueryVariables>(SummaryFlexReportCsvDocument, options);
        }
export type SummaryFlexReportCsvQueryHookResult = ReturnType<typeof useSummaryFlexReportCsvQuery>;
export type SummaryFlexReportCsvLazyQueryHookResult = ReturnType<typeof useSummaryFlexReportCsvLazyQuery>;
export type SummaryFlexReportCsvSuspenseQueryHookResult = ReturnType<typeof useSummaryFlexReportCsvSuspenseQuery>;
export type SummaryFlexReportCsvQueryResult = Apollo.QueryResult<SummaryFlexReportCsvQuery, SummaryFlexReportCsvQueryVariables>;
export const OrdersReportDocument = gql`
    query OrdersReport($input: OrdersReportInput!) {
  ordersReport(input: $input) {
    CC {
      customerOrders {
        orderId
        flexDeferredCustomerOrderId
      }
      supplierOrders {
        orderId
        flexDeferredSupplierOrderId
      }
    }
    GM {
      customerOrders {
        orderId
        flexDeferredCustomerOrderId
      }
      supplierOrders {
        orderId
        flexDeferredSupplierOrderId
      }
    }
  }
}
    `;

/**
 * __useOrdersReportQuery__
 *
 * To run a query within a React component, call `useOrdersReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrdersReportQuery(baseOptions: Apollo.QueryHookOptions<OrdersReportQuery, OrdersReportQueryVariables> & ({ variables: OrdersReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersReportQuery, OrdersReportQueryVariables>(OrdersReportDocument, options);
      }
export function useOrdersReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersReportQuery, OrdersReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersReportQuery, OrdersReportQueryVariables>(OrdersReportDocument, options);
        }
// @ts-ignore
export function useOrdersReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrdersReportQuery, OrdersReportQueryVariables>): Apollo.UseSuspenseQueryResult<OrdersReportQuery, OrdersReportQueryVariables>;
export function useOrdersReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersReportQuery, OrdersReportQueryVariables>): Apollo.UseSuspenseQueryResult<OrdersReportQuery | undefined, OrdersReportQueryVariables>;
export function useOrdersReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersReportQuery, OrdersReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrdersReportQuery, OrdersReportQueryVariables>(OrdersReportDocument, options);
        }
export type OrdersReportQueryHookResult = ReturnType<typeof useOrdersReportQuery>;
export type OrdersReportLazyQueryHookResult = ReturnType<typeof useOrdersReportLazyQuery>;
export type OrdersReportSuspenseQueryHookResult = ReturnType<typeof useOrdersReportSuspenseQuery>;
export type OrdersReportQueryResult = Apollo.QueryResult<OrdersReportQuery, OrdersReportQueryVariables>;
export const GetAllAccountsDocument = gql`
    query GetAllAccounts($input: AccountSearch!) {
  accounts(input: $input) {
    pageInfo {
      count
    }
    rows {
      ...AdminAccountRow
    }
  }
}
    ${AdminAccountRowFragmentDoc}`;

/**
 * __useGetAllAccountsQuery__
 *
 * To run a query within a React component, call `useGetAllAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAccountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetAllAccountsQuery, GetAllAccountsQueryVariables> & ({ variables: GetAllAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAccountsQuery, GetAllAccountsQueryVariables>(GetAllAccountsDocument, options);
      }
export function useGetAllAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAccountsQuery, GetAllAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAccountsQuery, GetAllAccountsQueryVariables>(GetAllAccountsDocument, options);
        }
// @ts-ignore
export function useGetAllAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAccountsQuery, GetAllAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAccountsQuery, GetAllAccountsQueryVariables>;
export function useGetAllAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAccountsQuery, GetAllAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAccountsQuery | undefined, GetAllAccountsQueryVariables>;
export function useGetAllAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAccountsQuery, GetAllAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAccountsQuery, GetAllAccountsQueryVariables>(GetAllAccountsDocument, options);
        }
export type GetAllAccountsQueryHookResult = ReturnType<typeof useGetAllAccountsQuery>;
export type GetAllAccountsLazyQueryHookResult = ReturnType<typeof useGetAllAccountsLazyQuery>;
export type GetAllAccountsSuspenseQueryHookResult = ReturnType<typeof useGetAllAccountsSuspenseQuery>;
export type GetAllAccountsQueryResult = Apollo.QueryResult<GetAllAccountsQuery, GetAllAccountsQueryVariables>;
export const GetAllAccountsWithSummaryDocument = gql`
    query GetAllAccountsWithSummary($input: AccountSearch!, $ordersInput: CustomerOrdersReportForAccountInput!) {
  accounts(input: $input) {
    pageInfo {
      count
    }
    rows {
      ...AdminAccountRow
      customerOrdersSummary(input: $ordersInput) {
        ...CustomerOrdersSummaryValueInsights
      }
    }
  }
}
    ${AdminAccountRowFragmentDoc}
${CustomerOrdersSummaryValueInsightsFragmentDoc}`;

/**
 * __useGetAllAccountsWithSummaryQuery__
 *
 * To run a query within a React component, call `useGetAllAccountsWithSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAccountsWithSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAccountsWithSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      ordersInput: // value for 'ordersInput'
 *   },
 * });
 */
export function useGetAllAccountsWithSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAllAccountsWithSummaryQuery, GetAllAccountsWithSummaryQueryVariables> & ({ variables: GetAllAccountsWithSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAccountsWithSummaryQuery, GetAllAccountsWithSummaryQueryVariables>(GetAllAccountsWithSummaryDocument, options);
      }
export function useGetAllAccountsWithSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAccountsWithSummaryQuery, GetAllAccountsWithSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAccountsWithSummaryQuery, GetAllAccountsWithSummaryQueryVariables>(GetAllAccountsWithSummaryDocument, options);
        }
// @ts-ignore
export function useGetAllAccountsWithSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAccountsWithSummaryQuery, GetAllAccountsWithSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAccountsWithSummaryQuery, GetAllAccountsWithSummaryQueryVariables>;
export function useGetAllAccountsWithSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAccountsWithSummaryQuery, GetAllAccountsWithSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAccountsWithSummaryQuery | undefined, GetAllAccountsWithSummaryQueryVariables>;
export function useGetAllAccountsWithSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAccountsWithSummaryQuery, GetAllAccountsWithSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAccountsWithSummaryQuery, GetAllAccountsWithSummaryQueryVariables>(GetAllAccountsWithSummaryDocument, options);
        }
export type GetAllAccountsWithSummaryQueryHookResult = ReturnType<typeof useGetAllAccountsWithSummaryQuery>;
export type GetAllAccountsWithSummaryLazyQueryHookResult = ReturnType<typeof useGetAllAccountsWithSummaryLazyQuery>;
export type GetAllAccountsWithSummarySuspenseQueryHookResult = ReturnType<typeof useGetAllAccountsWithSummarySuspenseQuery>;
export type GetAllAccountsWithSummaryQueryResult = Apollo.QueryResult<GetAllAccountsWithSummaryQuery, GetAllAccountsWithSummaryQueryVariables>;
export const GetAllAdminsDocument = gql`
    query GetAllAdmins($input: AdminSearch, $limit: Int, $offset: Int) {
  admins(input: $input, limit: $limit, offset: $offset) {
    pageInfo {
      count
    }
    rows {
      id
      feedrUserId
      fullName
      email
      roles
      countryFlags
    }
  }
}
    `;

/**
 * __useGetAllAdminsQuery__
 *
 * To run a query within a React component, call `useGetAllAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAdminsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAllAdminsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAdminsQuery, GetAllAdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAdminsQuery, GetAllAdminsQueryVariables>(GetAllAdminsDocument, options);
      }
export function useGetAllAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAdminsQuery, GetAllAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAdminsQuery, GetAllAdminsQueryVariables>(GetAllAdminsDocument, options);
        }
// @ts-ignore
export function useGetAllAdminsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAdminsQuery, GetAllAdminsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAdminsQuery, GetAllAdminsQueryVariables>;
export function useGetAllAdminsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAdminsQuery, GetAllAdminsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAdminsQuery | undefined, GetAllAdminsQueryVariables>;
export function useGetAllAdminsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAdminsQuery, GetAllAdminsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAdminsQuery, GetAllAdminsQueryVariables>(GetAllAdminsDocument, options);
        }
export type GetAllAdminsQueryHookResult = ReturnType<typeof useGetAllAdminsQuery>;
export type GetAllAdminsLazyQueryHookResult = ReturnType<typeof useGetAllAdminsLazyQuery>;
export type GetAllAdminsSuspenseQueryHookResult = ReturnType<typeof useGetAllAdminsSuspenseQuery>;
export type GetAllAdminsQueryResult = Apollo.QueryResult<GetAllAdminsQuery, GetAllAdminsQueryVariables>;
export const AdminGetStandingOrdersDocument = gql`
    query adminGetStandingOrders($input: StandingOrdersInput!) {
  standingOrders(input: $input) {
    _id
  }
}
    `;

/**
 * __useAdminGetStandingOrdersQuery__
 *
 * To run a query within a React component, call `useAdminGetStandingOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetStandingOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetStandingOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminGetStandingOrdersQuery(baseOptions: Apollo.QueryHookOptions<AdminGetStandingOrdersQuery, AdminGetStandingOrdersQueryVariables> & ({ variables: AdminGetStandingOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetStandingOrdersQuery, AdminGetStandingOrdersQueryVariables>(AdminGetStandingOrdersDocument, options);
      }
export function useAdminGetStandingOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetStandingOrdersQuery, AdminGetStandingOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetStandingOrdersQuery, AdminGetStandingOrdersQueryVariables>(AdminGetStandingOrdersDocument, options);
        }
// @ts-ignore
export function useAdminGetStandingOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetStandingOrdersQuery, AdminGetStandingOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetStandingOrdersQuery, AdminGetStandingOrdersQueryVariables>;
export function useAdminGetStandingOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetStandingOrdersQuery, AdminGetStandingOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetStandingOrdersQuery | undefined, AdminGetStandingOrdersQueryVariables>;
export function useAdminGetStandingOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetStandingOrdersQuery, AdminGetStandingOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetStandingOrdersQuery, AdminGetStandingOrdersQueryVariables>(AdminGetStandingOrdersDocument, options);
        }
export type AdminGetStandingOrdersQueryHookResult = ReturnType<typeof useAdminGetStandingOrdersQuery>;
export type AdminGetStandingOrdersLazyQueryHookResult = ReturnType<typeof useAdminGetStandingOrdersLazyQuery>;
export type AdminGetStandingOrdersSuspenseQueryHookResult = ReturnType<typeof useAdminGetStandingOrdersSuspenseQuery>;
export type AdminGetStandingOrdersQueryResult = Apollo.QueryResult<AdminGetStandingOrdersQuery, AdminGetStandingOrdersQueryVariables>;
export const GetAllVendorsDocument = gql`
    query GetAllVendors($filters: VendorListFilters, $limit: Int, $offset: Int, $orderBy: VendorsOrderByInput) {
  vendorsList(
    filters: $filters
    limit: $limit
    offset: $offset
    orderBy: $orderBy
  ) {
    pageInfo {
      count
    }
    rows {
      ...AdminVendorRow
    }
  }
}
    ${AdminVendorRowFragmentDoc}`;

/**
 * __useGetAllVendorsQuery__
 *
 * To run a query within a React component, call `useGetAllVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVendorsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetAllVendorsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllVendorsQuery, GetAllVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllVendorsQuery, GetAllVendorsQueryVariables>(GetAllVendorsDocument, options);
      }
export function useGetAllVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllVendorsQuery, GetAllVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllVendorsQuery, GetAllVendorsQueryVariables>(GetAllVendorsDocument, options);
        }
// @ts-ignore
export function useGetAllVendorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllVendorsQuery, GetAllVendorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllVendorsQuery, GetAllVendorsQueryVariables>;
export function useGetAllVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllVendorsQuery, GetAllVendorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllVendorsQuery | undefined, GetAllVendorsQueryVariables>;
export function useGetAllVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllVendorsQuery, GetAllVendorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllVendorsQuery, GetAllVendorsQueryVariables>(GetAllVendorsDocument, options);
        }
export type GetAllVendorsQueryHookResult = ReturnType<typeof useGetAllVendorsQuery>;
export type GetAllVendorsLazyQueryHookResult = ReturnType<typeof useGetAllVendorsLazyQuery>;
export type GetAllVendorsSuspenseQueryHookResult = ReturnType<typeof useGetAllVendorsSuspenseQuery>;
export type GetAllVendorsQueryResult = Apollo.QueryResult<GetAllVendorsQuery, GetAllVendorsQueryVariables>;
export const GetAllVendorsWithSummaryDocument = gql`
    query GetAllVendorsWithSummary($filters: VendorListFilters, $limit: Int, $offset: Int, $orderBy: VendorsOrderByInput, $vendorStatementsInput: ListVendorStatementsInput!) {
  vendorsList(
    filters: $filters
    limit: $limit
    offset: $offset
    orderBy: $orderBy
  ) {
    pageInfo {
      count
    }
    rows {
      ...AdminVendorRow
      vendorStatementsSummary(input: $vendorStatementsInput) {
        ...VendorStatementsSummaryValueInsights
      }
    }
  }
}
    ${AdminVendorRowFragmentDoc}
${VendorStatementsSummaryValueInsightsFragmentDoc}`;

/**
 * __useGetAllVendorsWithSummaryQuery__
 *
 * To run a query within a React component, call `useGetAllVendorsWithSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVendorsWithSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVendorsWithSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      vendorStatementsInput: // value for 'vendorStatementsInput'
 *   },
 * });
 */
export function useGetAllVendorsWithSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAllVendorsWithSummaryQuery, GetAllVendorsWithSummaryQueryVariables> & ({ variables: GetAllVendorsWithSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllVendorsWithSummaryQuery, GetAllVendorsWithSummaryQueryVariables>(GetAllVendorsWithSummaryDocument, options);
      }
export function useGetAllVendorsWithSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllVendorsWithSummaryQuery, GetAllVendorsWithSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllVendorsWithSummaryQuery, GetAllVendorsWithSummaryQueryVariables>(GetAllVendorsWithSummaryDocument, options);
        }
// @ts-ignore
export function useGetAllVendorsWithSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllVendorsWithSummaryQuery, GetAllVendorsWithSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllVendorsWithSummaryQuery, GetAllVendorsWithSummaryQueryVariables>;
export function useGetAllVendorsWithSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllVendorsWithSummaryQuery, GetAllVendorsWithSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllVendorsWithSummaryQuery | undefined, GetAllVendorsWithSummaryQueryVariables>;
export function useGetAllVendorsWithSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllVendorsWithSummaryQuery, GetAllVendorsWithSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllVendorsWithSummaryQuery, GetAllVendorsWithSummaryQueryVariables>(GetAllVendorsWithSummaryDocument, options);
        }
export type GetAllVendorsWithSummaryQueryHookResult = ReturnType<typeof useGetAllVendorsWithSummaryQuery>;
export type GetAllVendorsWithSummaryLazyQueryHookResult = ReturnType<typeof useGetAllVendorsWithSummaryLazyQuery>;
export type GetAllVendorsWithSummarySuspenseQueryHookResult = ReturnType<typeof useGetAllVendorsWithSummarySuspenseQuery>;
export type GetAllVendorsWithSummaryQueryResult = Apollo.QueryResult<GetAllVendorsWithSummaryQuery, GetAllVendorsWithSummaryQueryVariables>;
export const GetAllUsersDocument = gql`
    query getAllUsers($limit: Int, $offset: Int, $input: UserSearch) {
  users(limit: $limit, offset: $offset, input: $input) {
    pageInfo {
      count
      hasMore
    }
    rows {
      email
      firstName
      lastName
      phone
      id
      role
      deletedAt
      languageSettings {
        locale
      }
      account {
        id
        name
        ssoEnabled
        onboardingLink
        autopilotEnabled
        archivedAt
      }
      accountLocation {
        label
      }
      autopilotSettings {
        enabled
      }
      flexDeferredCustomerId
    }
  }
}
    `;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
      }
export function useGetAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
// @ts-ignore
export function useGetAllUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export function useGetAllUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllUsersQuery | undefined, GetAllUsersQueryVariables>;
export function useGetAllUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllUsersSuspenseQuery>;
export type GetAllUsersQueryResult = Apollo.QueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const MenuDebugGetAccountDataDocument = gql`
    query menuDebugGetAccountData($accountId: ID!) {
  account(id: $accountId) {
    id
    name
    locations {
      id
      label
      timezone
      isCCActive
      ccAvailabilities {
        rows {
          id
          weekday
          meal
          arrivalTime
        }
      }
    }
  }
}
    `;

/**
 * __useMenuDebugGetAccountDataQuery__
 *
 * To run a query within a React component, call `useMenuDebugGetAccountDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuDebugGetAccountDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuDebugGetAccountDataQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useMenuDebugGetAccountDataQuery(baseOptions: Apollo.QueryHookOptions<MenuDebugGetAccountDataQuery, MenuDebugGetAccountDataQueryVariables> & ({ variables: MenuDebugGetAccountDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuDebugGetAccountDataQuery, MenuDebugGetAccountDataQueryVariables>(MenuDebugGetAccountDataDocument, options);
      }
export function useMenuDebugGetAccountDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuDebugGetAccountDataQuery, MenuDebugGetAccountDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuDebugGetAccountDataQuery, MenuDebugGetAccountDataQueryVariables>(MenuDebugGetAccountDataDocument, options);
        }
// @ts-ignore
export function useMenuDebugGetAccountDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MenuDebugGetAccountDataQuery, MenuDebugGetAccountDataQueryVariables>): Apollo.UseSuspenseQueryResult<MenuDebugGetAccountDataQuery, MenuDebugGetAccountDataQueryVariables>;
export function useMenuDebugGetAccountDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuDebugGetAccountDataQuery, MenuDebugGetAccountDataQueryVariables>): Apollo.UseSuspenseQueryResult<MenuDebugGetAccountDataQuery | undefined, MenuDebugGetAccountDataQueryVariables>;
export function useMenuDebugGetAccountDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuDebugGetAccountDataQuery, MenuDebugGetAccountDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MenuDebugGetAccountDataQuery, MenuDebugGetAccountDataQueryVariables>(MenuDebugGetAccountDataDocument, options);
        }
export type MenuDebugGetAccountDataQueryHookResult = ReturnType<typeof useMenuDebugGetAccountDataQuery>;
export type MenuDebugGetAccountDataLazyQueryHookResult = ReturnType<typeof useMenuDebugGetAccountDataLazyQuery>;
export type MenuDebugGetAccountDataSuspenseQueryHookResult = ReturnType<typeof useMenuDebugGetAccountDataSuspenseQuery>;
export type MenuDebugGetAccountDataQueryResult = Apollo.QueryResult<MenuDebugGetAccountDataQuery, MenuDebugGetAccountDataQueryVariables>;
export const MenuDebugVendorSearchDocument = gql`
    query menuDebugVendorSearch($name: String!) {
  vendors(filters: {name: $name}) {
    rows {
      companyName
      id
    }
  }
}
    `;

/**
 * __useMenuDebugVendorSearchQuery__
 *
 * To run a query within a React component, call `useMenuDebugVendorSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuDebugVendorSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuDebugVendorSearchQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useMenuDebugVendorSearchQuery(baseOptions: Apollo.QueryHookOptions<MenuDebugVendorSearchQuery, MenuDebugVendorSearchQueryVariables> & ({ variables: MenuDebugVendorSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuDebugVendorSearchQuery, MenuDebugVendorSearchQueryVariables>(MenuDebugVendorSearchDocument, options);
      }
export function useMenuDebugVendorSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuDebugVendorSearchQuery, MenuDebugVendorSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuDebugVendorSearchQuery, MenuDebugVendorSearchQueryVariables>(MenuDebugVendorSearchDocument, options);
        }
// @ts-ignore
export function useMenuDebugVendorSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MenuDebugVendorSearchQuery, MenuDebugVendorSearchQueryVariables>): Apollo.UseSuspenseQueryResult<MenuDebugVendorSearchQuery, MenuDebugVendorSearchQueryVariables>;
export function useMenuDebugVendorSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuDebugVendorSearchQuery, MenuDebugVendorSearchQueryVariables>): Apollo.UseSuspenseQueryResult<MenuDebugVendorSearchQuery | undefined, MenuDebugVendorSearchQueryVariables>;
export function useMenuDebugVendorSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuDebugVendorSearchQuery, MenuDebugVendorSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MenuDebugVendorSearchQuery, MenuDebugVendorSearchQueryVariables>(MenuDebugVendorSearchDocument, options);
        }
export type MenuDebugVendorSearchQueryHookResult = ReturnType<typeof useMenuDebugVendorSearchQuery>;
export type MenuDebugVendorSearchLazyQueryHookResult = ReturnType<typeof useMenuDebugVendorSearchLazyQuery>;
export type MenuDebugVendorSearchSuspenseQueryHookResult = ReturnType<typeof useMenuDebugVendorSearchSuspenseQuery>;
export type MenuDebugVendorSearchQueryResult = Apollo.QueryResult<MenuDebugVendorSearchQuery, MenuDebugVendorSearchQueryVariables>;
export const MenuDebugGetVendorDocument = gql`
    query menuDebugGetVendor($vendorId: ID!) {
  vendor(id: $vendorId) {
    id
    companyName
  }
}
    `;

/**
 * __useMenuDebugGetVendorQuery__
 *
 * To run a query within a React component, call `useMenuDebugGetVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuDebugGetVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuDebugGetVendorQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useMenuDebugGetVendorQuery(baseOptions: Apollo.QueryHookOptions<MenuDebugGetVendorQuery, MenuDebugGetVendorQueryVariables> & ({ variables: MenuDebugGetVendorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuDebugGetVendorQuery, MenuDebugGetVendorQueryVariables>(MenuDebugGetVendorDocument, options);
      }
export function useMenuDebugGetVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuDebugGetVendorQuery, MenuDebugGetVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuDebugGetVendorQuery, MenuDebugGetVendorQueryVariables>(MenuDebugGetVendorDocument, options);
        }
// @ts-ignore
export function useMenuDebugGetVendorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MenuDebugGetVendorQuery, MenuDebugGetVendorQueryVariables>): Apollo.UseSuspenseQueryResult<MenuDebugGetVendorQuery, MenuDebugGetVendorQueryVariables>;
export function useMenuDebugGetVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuDebugGetVendorQuery, MenuDebugGetVendorQueryVariables>): Apollo.UseSuspenseQueryResult<MenuDebugGetVendorQuery | undefined, MenuDebugGetVendorQueryVariables>;
export function useMenuDebugGetVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuDebugGetVendorQuery, MenuDebugGetVendorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MenuDebugGetVendorQuery, MenuDebugGetVendorQueryVariables>(MenuDebugGetVendorDocument, options);
        }
export type MenuDebugGetVendorQueryHookResult = ReturnType<typeof useMenuDebugGetVendorQuery>;
export type MenuDebugGetVendorLazyQueryHookResult = ReturnType<typeof useMenuDebugGetVendorLazyQuery>;
export type MenuDebugGetVendorSuspenseQueryHookResult = ReturnType<typeof useMenuDebugGetVendorSuspenseQuery>;
export type MenuDebugGetVendorQueryResult = Apollo.QueryResult<MenuDebugGetVendorQuery, MenuDebugGetVendorQueryVariables>;
export const GetMenuDebugResultsDocument = gql`
    query getMenuDebugResults($input: CCMenuDebugInput!) {
  ccMenuDebug(input: $input) {
    description
    id
    isSuccessful
    ... on CCMenuDebugTestCCSupplierOrder {
      ...CCMenuDebugTestCCSupplierOrder
    }
    ... on CCMenuDebugTestClusterAssignment {
      ...CCMenuDebugTestClusterAssignment
    }
    ... on CCMenuDebugTestAllocations {
      ...CCMenuDebugTestAllocations
    }
    ... on CCMenuDebugTestAvailabilities {
      ...CCMenuDebugTestAvailabilities
    }
  }
}
    ${CcMenuDebugTestCcSupplierOrderFragmentDoc}
${CcMenuDebugTestClusterAssignmentFragmentDoc}
${CcMenuDebugTestAllocationsFragmentDoc}
${CcMenuDebugTestAvailabilitiesFragmentDoc}`;

/**
 * __useGetMenuDebugResultsQuery__
 *
 * To run a query within a React component, call `useGetMenuDebugResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuDebugResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuDebugResultsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMenuDebugResultsQuery(baseOptions: Apollo.QueryHookOptions<GetMenuDebugResultsQuery, GetMenuDebugResultsQueryVariables> & ({ variables: GetMenuDebugResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuDebugResultsQuery, GetMenuDebugResultsQueryVariables>(GetMenuDebugResultsDocument, options);
      }
export function useGetMenuDebugResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuDebugResultsQuery, GetMenuDebugResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuDebugResultsQuery, GetMenuDebugResultsQueryVariables>(GetMenuDebugResultsDocument, options);
        }
// @ts-ignore
export function useGetMenuDebugResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMenuDebugResultsQuery, GetMenuDebugResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMenuDebugResultsQuery, GetMenuDebugResultsQueryVariables>;
export function useGetMenuDebugResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuDebugResultsQuery, GetMenuDebugResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMenuDebugResultsQuery | undefined, GetMenuDebugResultsQueryVariables>;
export function useGetMenuDebugResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuDebugResultsQuery, GetMenuDebugResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuDebugResultsQuery, GetMenuDebugResultsQueryVariables>(GetMenuDebugResultsDocument, options);
        }
export type GetMenuDebugResultsQueryHookResult = ReturnType<typeof useGetMenuDebugResultsQuery>;
export type GetMenuDebugResultsLazyQueryHookResult = ReturnType<typeof useGetMenuDebugResultsLazyQuery>;
export type GetMenuDebugResultsSuspenseQueryHookResult = ReturnType<typeof useGetMenuDebugResultsSuspenseQuery>;
export type GetMenuDebugResultsQueryResult = Apollo.QueryResult<GetMenuDebugResultsQuery, GetMenuDebugResultsQueryVariables>;
export const AdminGetVendorFinanceDataDocument = gql`
    query adminGetVendorFinanceData($vendorId: ID!) {
  vatRegions {
    id
    legacyId
    name
  }
  vendor(id: $vendorId) {
    id
    contacts {
      id
      fullName
    }
    markupSettings {
      defaultMarkupPercentage
    }
    financeSettings {
      id
      accountName
      billingCity
      billingCountry
      billingPostcode
      reducedCommissionRate
      standardCommissionRate
      billingLine1
      billingLine2
      financeContact {
        email
        fullName
        id
      }
      vatRegion {
        id
        legacyId
      }
      sortCode
      bsbNumber
      branchCode
      accountNumber
      bankName
      notes
      vatNumber
      isVatRegistered
      paymentMadeDaysAfterStatementEnd
      businessNumber
      bankCode
    }
  }
}
    `;

/**
 * __useAdminGetVendorFinanceDataQuery__
 *
 * To run a query within a React component, call `useAdminGetVendorFinanceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetVendorFinanceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetVendorFinanceDataQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useAdminGetVendorFinanceDataQuery(baseOptions: Apollo.QueryHookOptions<AdminGetVendorFinanceDataQuery, AdminGetVendorFinanceDataQueryVariables> & ({ variables: AdminGetVendorFinanceDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetVendorFinanceDataQuery, AdminGetVendorFinanceDataQueryVariables>(AdminGetVendorFinanceDataDocument, options);
      }
export function useAdminGetVendorFinanceDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetVendorFinanceDataQuery, AdminGetVendorFinanceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetVendorFinanceDataQuery, AdminGetVendorFinanceDataQueryVariables>(AdminGetVendorFinanceDataDocument, options);
        }
// @ts-ignore
export function useAdminGetVendorFinanceDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetVendorFinanceDataQuery, AdminGetVendorFinanceDataQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetVendorFinanceDataQuery, AdminGetVendorFinanceDataQueryVariables>;
export function useAdminGetVendorFinanceDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetVendorFinanceDataQuery, AdminGetVendorFinanceDataQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetVendorFinanceDataQuery | undefined, AdminGetVendorFinanceDataQueryVariables>;
export function useAdminGetVendorFinanceDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetVendorFinanceDataQuery, AdminGetVendorFinanceDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetVendorFinanceDataQuery, AdminGetVendorFinanceDataQueryVariables>(AdminGetVendorFinanceDataDocument, options);
        }
export type AdminGetVendorFinanceDataQueryHookResult = ReturnType<typeof useAdminGetVendorFinanceDataQuery>;
export type AdminGetVendorFinanceDataLazyQueryHookResult = ReturnType<typeof useAdminGetVendorFinanceDataLazyQuery>;
export type AdminGetVendorFinanceDataSuspenseQueryHookResult = ReturnType<typeof useAdminGetVendorFinanceDataSuspenseQuery>;
export type AdminGetVendorFinanceDataQueryResult = Apollo.QueryResult<AdminGetVendorFinanceDataQuery, AdminGetVendorFinanceDataQueryVariables>;
export const AdminGetVendorFlexFinanceDataDocument = gql`
    query adminGetVendorFlexFinanceData($vendorId: ID!) {
  vatRegions {
    id
    legacyId
    name
  }
  vendor(id: $vendorId) {
    id
    currency
    contacts {
      id
      fullName
      email
    }
    markupSettings {
      defaultMarkupPercentage
    }
    flexFinanceSettings {
      id
      flexDeferredSupplierId
      reducedCommissionRate
      standardCommissionRate
      chargeCommissionOnDeliveryFees
      addressCity
      addressCountry
      addressPostcode
      addressLine1
      addressLine2
      financeContact {
        id
        email
        fullName
      }
      contactFirstName
      contactLastName
      contactEmailAddress
      additionalEmails
      vatRegion {
        id
        legacyId
      }
      accountName
      bankName
      accountNumber
      sortCode
      bsbNumber
      branchCode
      bankCode
      isVatRegistered
      entityName
      entityNumber
      entityRegion
      entityTaxNumber
      notes
      paymentTerms
      autoInvoice
      invoiceLocationsSeparately
    }
  }
}
    `;

/**
 * __useAdminGetVendorFlexFinanceDataQuery__
 *
 * To run a query within a React component, call `useAdminGetVendorFlexFinanceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetVendorFlexFinanceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetVendorFlexFinanceDataQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useAdminGetVendorFlexFinanceDataQuery(baseOptions: Apollo.QueryHookOptions<AdminGetVendorFlexFinanceDataQuery, AdminGetVendorFlexFinanceDataQueryVariables> & ({ variables: AdminGetVendorFlexFinanceDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetVendorFlexFinanceDataQuery, AdminGetVendorFlexFinanceDataQueryVariables>(AdminGetVendorFlexFinanceDataDocument, options);
      }
export function useAdminGetVendorFlexFinanceDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetVendorFlexFinanceDataQuery, AdminGetVendorFlexFinanceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetVendorFlexFinanceDataQuery, AdminGetVendorFlexFinanceDataQueryVariables>(AdminGetVendorFlexFinanceDataDocument, options);
        }
// @ts-ignore
export function useAdminGetVendorFlexFinanceDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetVendorFlexFinanceDataQuery, AdminGetVendorFlexFinanceDataQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetVendorFlexFinanceDataQuery, AdminGetVendorFlexFinanceDataQueryVariables>;
export function useAdminGetVendorFlexFinanceDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetVendorFlexFinanceDataQuery, AdminGetVendorFlexFinanceDataQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetVendorFlexFinanceDataQuery | undefined, AdminGetVendorFlexFinanceDataQueryVariables>;
export function useAdminGetVendorFlexFinanceDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetVendorFlexFinanceDataQuery, AdminGetVendorFlexFinanceDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetVendorFlexFinanceDataQuery, AdminGetVendorFlexFinanceDataQueryVariables>(AdminGetVendorFlexFinanceDataDocument, options);
        }
export type AdminGetVendorFlexFinanceDataQueryHookResult = ReturnType<typeof useAdminGetVendorFlexFinanceDataQuery>;
export type AdminGetVendorFlexFinanceDataLazyQueryHookResult = ReturnType<typeof useAdminGetVendorFlexFinanceDataLazyQuery>;
export type AdminGetVendorFlexFinanceDataSuspenseQueryHookResult = ReturnType<typeof useAdminGetVendorFlexFinanceDataSuspenseQuery>;
export type AdminGetVendorFlexFinanceDataQueryResult = Apollo.QueryResult<AdminGetVendorFlexFinanceDataQuery, AdminGetVendorFlexFinanceDataQueryVariables>;
export const AdminUpdateVendorFinanceWithMarkupSettingsDocument = gql`
    mutation adminUpdateVendorFinanceWithMarkupSettings($vendorId: ID!, $financeSettingsInput: UpdateVendorFinanceSettingsInput!, $markupSettingsInput: UpdateVendorMarkupSettingsInput!) {
  updateVendor(
    id: $vendorId
    input: {financeSettings: $financeSettingsInput, markupSettings: $markupSettingsInput}
  ) {
    id
    financeSettings {
      id
    }
  }
}
    `;
export type AdminUpdateVendorFinanceWithMarkupSettingsMutationFn = Apollo.MutationFunction<AdminUpdateVendorFinanceWithMarkupSettingsMutation, AdminUpdateVendorFinanceWithMarkupSettingsMutationVariables>;

/**
 * __useAdminUpdateVendorFinanceWithMarkupSettingsMutation__
 *
 * To run a mutation, you first call `useAdminUpdateVendorFinanceWithMarkupSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateVendorFinanceWithMarkupSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateVendorFinanceWithMarkupSettingsMutation, { data, loading, error }] = useAdminUpdateVendorFinanceWithMarkupSettingsMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      financeSettingsInput: // value for 'financeSettingsInput'
 *      markupSettingsInput: // value for 'markupSettingsInput'
 *   },
 * });
 */
export function useAdminUpdateVendorFinanceWithMarkupSettingsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateVendorFinanceWithMarkupSettingsMutation, AdminUpdateVendorFinanceWithMarkupSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateVendorFinanceWithMarkupSettingsMutation, AdminUpdateVendorFinanceWithMarkupSettingsMutationVariables>(AdminUpdateVendorFinanceWithMarkupSettingsDocument, options);
      }
export type AdminUpdateVendorFinanceWithMarkupSettingsMutationHookResult = ReturnType<typeof useAdminUpdateVendorFinanceWithMarkupSettingsMutation>;
export type AdminUpdateVendorFinanceWithMarkupSettingsMutationResult = Apollo.MutationResult<AdminUpdateVendorFinanceWithMarkupSettingsMutation>;
export type AdminUpdateVendorFinanceWithMarkupSettingsMutationOptions = Apollo.BaseMutationOptions<AdminUpdateVendorFinanceWithMarkupSettingsMutation, AdminUpdateVendorFinanceWithMarkupSettingsMutationVariables>;
export const AdminUpdateVendorFlexFinanceWithMarkupSettingsDocument = gql`
    mutation adminUpdateVendorFlexFinanceWithMarkupSettings($vendorId: ID!, $financeSettingsInput: UpdateVendorFlexFinanceSettingsInput!, $markupSettingsInput: UpdateVendorMarkupSettingsInput!, $currency: Currency) {
  updateVendor(
    id: $vendorId
    input: {flexFinanceSettings: $financeSettingsInput, markupSettings: $markupSettingsInput, currency: $currency}
  ) {
    id
    financeSettings {
      id
    }
  }
}
    `;
export type AdminUpdateVendorFlexFinanceWithMarkupSettingsMutationFn = Apollo.MutationFunction<AdminUpdateVendorFlexFinanceWithMarkupSettingsMutation, AdminUpdateVendorFlexFinanceWithMarkupSettingsMutationVariables>;

/**
 * __useAdminUpdateVendorFlexFinanceWithMarkupSettingsMutation__
 *
 * To run a mutation, you first call `useAdminUpdateVendorFlexFinanceWithMarkupSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateVendorFlexFinanceWithMarkupSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateVendorFlexFinanceWithMarkupSettingsMutation, { data, loading, error }] = useAdminUpdateVendorFlexFinanceWithMarkupSettingsMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      financeSettingsInput: // value for 'financeSettingsInput'
 *      markupSettingsInput: // value for 'markupSettingsInput'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useAdminUpdateVendorFlexFinanceWithMarkupSettingsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateVendorFlexFinanceWithMarkupSettingsMutation, AdminUpdateVendorFlexFinanceWithMarkupSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateVendorFlexFinanceWithMarkupSettingsMutation, AdminUpdateVendorFlexFinanceWithMarkupSettingsMutationVariables>(AdminUpdateVendorFlexFinanceWithMarkupSettingsDocument, options);
      }
export type AdminUpdateVendorFlexFinanceWithMarkupSettingsMutationHookResult = ReturnType<typeof useAdminUpdateVendorFlexFinanceWithMarkupSettingsMutation>;
export type AdminUpdateVendorFlexFinanceWithMarkupSettingsMutationResult = Apollo.MutationResult<AdminUpdateVendorFlexFinanceWithMarkupSettingsMutation>;
export type AdminUpdateVendorFlexFinanceWithMarkupSettingsMutationOptions = Apollo.BaseMutationOptions<AdminUpdateVendorFlexFinanceWithMarkupSettingsMutation, AdminUpdateVendorFlexFinanceWithMarkupSettingsMutationVariables>;
export const GetBillingFieldsDocument = gql`
    query GetBillingFields($input: BillingFieldsInput!) {
  billingFields(input: $input)
}
    `;

/**
 * __useGetBillingFieldsQuery__
 *
 * To run a query within a React component, call `useGetBillingFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingFieldsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBillingFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetBillingFieldsQuery, GetBillingFieldsQueryVariables> & ({ variables: GetBillingFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingFieldsQuery, GetBillingFieldsQueryVariables>(GetBillingFieldsDocument, options);
      }
export function useGetBillingFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingFieldsQuery, GetBillingFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingFieldsQuery, GetBillingFieldsQueryVariables>(GetBillingFieldsDocument, options);
        }
// @ts-ignore
export function useGetBillingFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBillingFieldsQuery, GetBillingFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBillingFieldsQuery, GetBillingFieldsQueryVariables>;
export function useGetBillingFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBillingFieldsQuery, GetBillingFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBillingFieldsQuery | undefined, GetBillingFieldsQueryVariables>;
export function useGetBillingFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBillingFieldsQuery, GetBillingFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBillingFieldsQuery, GetBillingFieldsQueryVariables>(GetBillingFieldsDocument, options);
        }
export type GetBillingFieldsQueryHookResult = ReturnType<typeof useGetBillingFieldsQuery>;
export type GetBillingFieldsLazyQueryHookResult = ReturnType<typeof useGetBillingFieldsLazyQuery>;
export type GetBillingFieldsSuspenseQueryHookResult = ReturnType<typeof useGetBillingFieldsSuspenseQuery>;
export type GetBillingFieldsQueryResult = Apollo.QueryResult<GetBillingFieldsQuery, GetBillingFieldsQueryVariables>;
export const GetVendorFlexInvoiceCsvDocument = gql`
    query GetVendorFlexInvoiceCSV($invoiceId: ID!, $invoiceType: FlexInvoiceType!) {
  vendorFlexInvoiceCSV(invoiceId: $invoiceId, invoiceType: $invoiceType)
}
    `;

/**
 * __useGetVendorFlexInvoiceCsvQuery__
 *
 * To run a query within a React component, call `useGetVendorFlexInvoiceCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorFlexInvoiceCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorFlexInvoiceCsvQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      invoiceType: // value for 'invoiceType'
 *   },
 * });
 */
export function useGetVendorFlexInvoiceCsvQuery(baseOptions: Apollo.QueryHookOptions<GetVendorFlexInvoiceCsvQuery, GetVendorFlexInvoiceCsvQueryVariables> & ({ variables: GetVendorFlexInvoiceCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorFlexInvoiceCsvQuery, GetVendorFlexInvoiceCsvQueryVariables>(GetVendorFlexInvoiceCsvDocument, options);
      }
export function useGetVendorFlexInvoiceCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorFlexInvoiceCsvQuery, GetVendorFlexInvoiceCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorFlexInvoiceCsvQuery, GetVendorFlexInvoiceCsvQueryVariables>(GetVendorFlexInvoiceCsvDocument, options);
        }
// @ts-ignore
export function useGetVendorFlexInvoiceCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorFlexInvoiceCsvQuery, GetVendorFlexInvoiceCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorFlexInvoiceCsvQuery, GetVendorFlexInvoiceCsvQueryVariables>;
export function useGetVendorFlexInvoiceCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorFlexInvoiceCsvQuery, GetVendorFlexInvoiceCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorFlexInvoiceCsvQuery | undefined, GetVendorFlexInvoiceCsvQueryVariables>;
export function useGetVendorFlexInvoiceCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorFlexInvoiceCsvQuery, GetVendorFlexInvoiceCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorFlexInvoiceCsvQuery, GetVendorFlexInvoiceCsvQueryVariables>(GetVendorFlexInvoiceCsvDocument, options);
        }
export type GetVendorFlexInvoiceCsvQueryHookResult = ReturnType<typeof useGetVendorFlexInvoiceCsvQuery>;
export type GetVendorFlexInvoiceCsvLazyQueryHookResult = ReturnType<typeof useGetVendorFlexInvoiceCsvLazyQuery>;
export type GetVendorFlexInvoiceCsvSuspenseQueryHookResult = ReturnType<typeof useGetVendorFlexInvoiceCsvSuspenseQuery>;
export type GetVendorFlexInvoiceCsvQueryResult = Apollo.QueryResult<GetVendorFlexInvoiceCsvQuery, GetVendorFlexInvoiceCsvQueryVariables>;
export const VendorFlexInvoicesDocument = gql`
    query VendorFlexInvoices($input: VendorFlexInvoicesInput!) {
  vendorFlexInvoices(input: $input) {
    items {
      id
      accountName
      number
      total
      createdAt
      dueDate
      status
    }
    pageInfo {
      count
      hasMore
      limit
      offset
    }
  }
}
    `;

/**
 * __useVendorFlexInvoicesQuery__
 *
 * To run a query within a React component, call `useVendorFlexInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorFlexInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorFlexInvoicesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVendorFlexInvoicesQuery(baseOptions: Apollo.QueryHookOptions<VendorFlexInvoicesQuery, VendorFlexInvoicesQueryVariables> & ({ variables: VendorFlexInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorFlexInvoicesQuery, VendorFlexInvoicesQueryVariables>(VendorFlexInvoicesDocument, options);
      }
export function useVendorFlexInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorFlexInvoicesQuery, VendorFlexInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorFlexInvoicesQuery, VendorFlexInvoicesQueryVariables>(VendorFlexInvoicesDocument, options);
        }
// @ts-ignore
export function useVendorFlexInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VendorFlexInvoicesQuery, VendorFlexInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<VendorFlexInvoicesQuery, VendorFlexInvoicesQueryVariables>;
export function useVendorFlexInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorFlexInvoicesQuery, VendorFlexInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<VendorFlexInvoicesQuery | undefined, VendorFlexInvoicesQueryVariables>;
export function useVendorFlexInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorFlexInvoicesQuery, VendorFlexInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VendorFlexInvoicesQuery, VendorFlexInvoicesQueryVariables>(VendorFlexInvoicesDocument, options);
        }
export type VendorFlexInvoicesQueryHookResult = ReturnType<typeof useVendorFlexInvoicesQuery>;
export type VendorFlexInvoicesLazyQueryHookResult = ReturnType<typeof useVendorFlexInvoicesLazyQuery>;
export type VendorFlexInvoicesSuspenseQueryHookResult = ReturnType<typeof useVendorFlexInvoicesSuspenseQuery>;
export type VendorFlexInvoicesQueryResult = Apollo.QueryResult<VendorFlexInvoicesQuery, VendorFlexInvoicesQueryVariables>;
export const VendorFlexInvoiceAllTypesDocument = gql`
    query VendorFlexInvoiceAllTypes($input: VendorFlexInvoicesInput) {
  vendorFlexInvoiceAllTypes(input: $input) {
    items {
      id
      invoiceType
      number
      createdAt
      accountName
      entityName
      total
      dueDate
      status
      csv
      timezone
      location
      vendorId
      assets {
        type
        link
      }
      accountBusinessNumber
      accountTaxNumber
      accountContact
      accountAddress
      accountBankDetails
    }
    pageInfo {
      count
      hasMore
      limit
      offset
    }
  }
}
    `;

/**
 * __useVendorFlexInvoiceAllTypesQuery__
 *
 * To run a query within a React component, call `useVendorFlexInvoiceAllTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorFlexInvoiceAllTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorFlexInvoiceAllTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVendorFlexInvoiceAllTypesQuery(baseOptions?: Apollo.QueryHookOptions<VendorFlexInvoiceAllTypesQuery, VendorFlexInvoiceAllTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorFlexInvoiceAllTypesQuery, VendorFlexInvoiceAllTypesQueryVariables>(VendorFlexInvoiceAllTypesDocument, options);
      }
export function useVendorFlexInvoiceAllTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorFlexInvoiceAllTypesQuery, VendorFlexInvoiceAllTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorFlexInvoiceAllTypesQuery, VendorFlexInvoiceAllTypesQueryVariables>(VendorFlexInvoiceAllTypesDocument, options);
        }
// @ts-ignore
export function useVendorFlexInvoiceAllTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VendorFlexInvoiceAllTypesQuery, VendorFlexInvoiceAllTypesQueryVariables>): Apollo.UseSuspenseQueryResult<VendorFlexInvoiceAllTypesQuery, VendorFlexInvoiceAllTypesQueryVariables>;
export function useVendorFlexInvoiceAllTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorFlexInvoiceAllTypesQuery, VendorFlexInvoiceAllTypesQueryVariables>): Apollo.UseSuspenseQueryResult<VendorFlexInvoiceAllTypesQuery | undefined, VendorFlexInvoiceAllTypesQueryVariables>;
export function useVendorFlexInvoiceAllTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorFlexInvoiceAllTypesQuery, VendorFlexInvoiceAllTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VendorFlexInvoiceAllTypesQuery, VendorFlexInvoiceAllTypesQueryVariables>(VendorFlexInvoiceAllTypesDocument, options);
        }
export type VendorFlexInvoiceAllTypesQueryHookResult = ReturnType<typeof useVendorFlexInvoiceAllTypesQuery>;
export type VendorFlexInvoiceAllTypesLazyQueryHookResult = ReturnType<typeof useVendorFlexInvoiceAllTypesLazyQuery>;
export type VendorFlexInvoiceAllTypesSuspenseQueryHookResult = ReturnType<typeof useVendorFlexInvoiceAllTypesSuspenseQuery>;
export type VendorFlexInvoiceAllTypesQueryResult = Apollo.QueryResult<VendorFlexInvoiceAllTypesQuery, VendorFlexInvoiceAllTypesQueryVariables>;
export const GetOrdersForVendorFlexInvoiceDocument = gql`
    query GetOrdersForVendorFlexInvoice($input: VendorInvoiceOrderInput) {
  vendorInvoiceOrders(input: $input) {
    items {
      id
      number
    }
  }
}
    `;

/**
 * __useGetOrdersForVendorFlexInvoiceQuery__
 *
 * To run a query within a React component, call `useGetOrdersForVendorFlexInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersForVendorFlexInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersForVendorFlexInvoiceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrdersForVendorFlexInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersForVendorFlexInvoiceQuery, GetOrdersForVendorFlexInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersForVendorFlexInvoiceQuery, GetOrdersForVendorFlexInvoiceQueryVariables>(GetOrdersForVendorFlexInvoiceDocument, options);
      }
export function useGetOrdersForVendorFlexInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersForVendorFlexInvoiceQuery, GetOrdersForVendorFlexInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersForVendorFlexInvoiceQuery, GetOrdersForVendorFlexInvoiceQueryVariables>(GetOrdersForVendorFlexInvoiceDocument, options);
        }
// @ts-ignore
export function useGetOrdersForVendorFlexInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrdersForVendorFlexInvoiceQuery, GetOrdersForVendorFlexInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersForVendorFlexInvoiceQuery, GetOrdersForVendorFlexInvoiceQueryVariables>;
export function useGetOrdersForVendorFlexInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersForVendorFlexInvoiceQuery, GetOrdersForVendorFlexInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersForVendorFlexInvoiceQuery | undefined, GetOrdersForVendorFlexInvoiceQueryVariables>;
export function useGetOrdersForVendorFlexInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersForVendorFlexInvoiceQuery, GetOrdersForVendorFlexInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersForVendorFlexInvoiceQuery, GetOrdersForVendorFlexInvoiceQueryVariables>(GetOrdersForVendorFlexInvoiceDocument, options);
        }
export type GetOrdersForVendorFlexInvoiceQueryHookResult = ReturnType<typeof useGetOrdersForVendorFlexInvoiceQuery>;
export type GetOrdersForVendorFlexInvoiceLazyQueryHookResult = ReturnType<typeof useGetOrdersForVendorFlexInvoiceLazyQuery>;
export type GetOrdersForVendorFlexInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetOrdersForVendorFlexInvoiceSuspenseQuery>;
export type GetOrdersForVendorFlexInvoiceQueryResult = Apollo.QueryResult<GetOrdersForVendorFlexInvoiceQuery, GetOrdersForVendorFlexInvoiceQueryVariables>;
export const RemoveOrdersFromVendorFlexInvoiceDocument = gql`
    mutation RemoveOrdersFromVendorFlexInvoice($vendorFlexInvoiceId: ID!, $input: RemoveOrdersFromVendorFlexInvoiceInput!) {
  removeOrdersFromVendorFlexInvoice(id: $vendorFlexInvoiceId, input: $input)
}
    `;
export type RemoveOrdersFromVendorFlexInvoiceMutationFn = Apollo.MutationFunction<RemoveOrdersFromVendorFlexInvoiceMutation, RemoveOrdersFromVendorFlexInvoiceMutationVariables>;

/**
 * __useRemoveOrdersFromVendorFlexInvoiceMutation__
 *
 * To run a mutation, you first call `useRemoveOrdersFromVendorFlexInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrdersFromVendorFlexInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrdersFromVendorFlexInvoiceMutation, { data, loading, error }] = useRemoveOrdersFromVendorFlexInvoiceMutation({
 *   variables: {
 *      vendorFlexInvoiceId: // value for 'vendorFlexInvoiceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveOrdersFromVendorFlexInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrdersFromVendorFlexInvoiceMutation, RemoveOrdersFromVendorFlexInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrdersFromVendorFlexInvoiceMutation, RemoveOrdersFromVendorFlexInvoiceMutationVariables>(RemoveOrdersFromVendorFlexInvoiceDocument, options);
      }
export type RemoveOrdersFromVendorFlexInvoiceMutationHookResult = ReturnType<typeof useRemoveOrdersFromVendorFlexInvoiceMutation>;
export type RemoveOrdersFromVendorFlexInvoiceMutationResult = Apollo.MutationResult<RemoveOrdersFromVendorFlexInvoiceMutation>;
export type RemoveOrdersFromVendorFlexInvoiceMutationOptions = Apollo.BaseMutationOptions<RemoveOrdersFromVendorFlexInvoiceMutation, RemoveOrdersFromVendorFlexInvoiceMutationVariables>;
export const SendVendorFlexInvoiceByEmailDocument = gql`
    mutation SendVendorFlexInvoiceByEmail($vendorFlexInvoiceId: ID!, $emailAddresses: [String!]!, $invoiceType: FlexInvoiceType) {
  sendVendorFlexInvoiceByEmail(
    vendorFlexInvoiceId: $vendorFlexInvoiceId
    emailAddresses: $emailAddresses
    invoiceType: $invoiceType
  )
}
    `;
export type SendVendorFlexInvoiceByEmailMutationFn = Apollo.MutationFunction<SendVendorFlexInvoiceByEmailMutation, SendVendorFlexInvoiceByEmailMutationVariables>;

/**
 * __useSendVendorFlexInvoiceByEmailMutation__
 *
 * To run a mutation, you first call `useSendVendorFlexInvoiceByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVendorFlexInvoiceByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVendorFlexInvoiceByEmailMutation, { data, loading, error }] = useSendVendorFlexInvoiceByEmailMutation({
 *   variables: {
 *      vendorFlexInvoiceId: // value for 'vendorFlexInvoiceId'
 *      emailAddresses: // value for 'emailAddresses'
 *      invoiceType: // value for 'invoiceType'
 *   },
 * });
 */
export function useSendVendorFlexInvoiceByEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendVendorFlexInvoiceByEmailMutation, SendVendorFlexInvoiceByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVendorFlexInvoiceByEmailMutation, SendVendorFlexInvoiceByEmailMutationVariables>(SendVendorFlexInvoiceByEmailDocument, options);
      }
export type SendVendorFlexInvoiceByEmailMutationHookResult = ReturnType<typeof useSendVendorFlexInvoiceByEmailMutation>;
export type SendVendorFlexInvoiceByEmailMutationResult = Apollo.MutationResult<SendVendorFlexInvoiceByEmailMutation>;
export type SendVendorFlexInvoiceByEmailMutationOptions = Apollo.BaseMutationOptions<SendVendorFlexInvoiceByEmailMutation, SendVendorFlexInvoiceByEmailMutationVariables>;
export const UpdateVendorFlexInvoiceDetailsDocument = gql`
    mutation UpdateVendorFlexInvoiceDetails($vendorFlexInvoiceId: ID!, $updates: UpdateVendorFlexInvoiceDetailsInput!) {
  updateVendorFlexInvoiceDetails(id: $vendorFlexInvoiceId, input: $updates)
}
    `;
export type UpdateVendorFlexInvoiceDetailsMutationFn = Apollo.MutationFunction<UpdateVendorFlexInvoiceDetailsMutation, UpdateVendorFlexInvoiceDetailsMutationVariables>;

/**
 * __useUpdateVendorFlexInvoiceDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateVendorFlexInvoiceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorFlexInvoiceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorFlexInvoiceDetailsMutation, { data, loading, error }] = useUpdateVendorFlexInvoiceDetailsMutation({
 *   variables: {
 *      vendorFlexInvoiceId: // value for 'vendorFlexInvoiceId'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateVendorFlexInvoiceDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorFlexInvoiceDetailsMutation, UpdateVendorFlexInvoiceDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVendorFlexInvoiceDetailsMutation, UpdateVendorFlexInvoiceDetailsMutationVariables>(UpdateVendorFlexInvoiceDetailsDocument, options);
      }
export type UpdateVendorFlexInvoiceDetailsMutationHookResult = ReturnType<typeof useUpdateVendorFlexInvoiceDetailsMutation>;
export type UpdateVendorFlexInvoiceDetailsMutationResult = Apollo.MutationResult<UpdateVendorFlexInvoiceDetailsMutation>;
export type UpdateVendorFlexInvoiceDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateVendorFlexInvoiceDetailsMutation, UpdateVendorFlexInvoiceDetailsMutationVariables>;
export const GetVendorDetailsDocument = gql`
    query getVendorDetails($vendorId: ID!) {
  vendor(id: $vendorId) {
    id
    companyName
    currency
    fullName
    isDraft
    sourcing
    logo
    locations {
      country
    }
    flexFinanceSettings {
      flexDeferredSupplierId
    }
    contacts {
      id
    }
  }
}
    `;

/**
 * __useGetVendorDetailsQuery__
 *
 * To run a query within a React component, call `useGetVendorDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorDetailsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useGetVendorDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetVendorDetailsQuery, GetVendorDetailsQueryVariables> & ({ variables: GetVendorDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorDetailsQuery, GetVendorDetailsQueryVariables>(GetVendorDetailsDocument, options);
      }
export function useGetVendorDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorDetailsQuery, GetVendorDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorDetailsQuery, GetVendorDetailsQueryVariables>(GetVendorDetailsDocument, options);
        }
// @ts-ignore
export function useGetVendorDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorDetailsQuery, GetVendorDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorDetailsQuery, GetVendorDetailsQueryVariables>;
export function useGetVendorDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorDetailsQuery, GetVendorDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorDetailsQuery | undefined, GetVendorDetailsQueryVariables>;
export function useGetVendorDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorDetailsQuery, GetVendorDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorDetailsQuery, GetVendorDetailsQueryVariables>(GetVendorDetailsDocument, options);
        }
export type GetVendorDetailsQueryHookResult = ReturnType<typeof useGetVendorDetailsQuery>;
export type GetVendorDetailsLazyQueryHookResult = ReturnType<typeof useGetVendorDetailsLazyQuery>;
export type GetVendorDetailsSuspenseQueryHookResult = ReturnType<typeof useGetVendorDetailsSuspenseQuery>;
export type GetVendorDetailsQueryResult = Apollo.QueryResult<GetVendorDetailsQuery, GetVendorDetailsQueryVariables>;
export const GetVendorNameDocument = gql`
    query getVendorName($vendorId: ID!) {
  vendor(id: $vendorId) {
    id
    companyName
  }
}
    `;

/**
 * __useGetVendorNameQuery__
 *
 * To run a query within a React component, call `useGetVendorNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorNameQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useGetVendorNameQuery(baseOptions: Apollo.QueryHookOptions<GetVendorNameQuery, GetVendorNameQueryVariables> & ({ variables: GetVendorNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorNameQuery, GetVendorNameQueryVariables>(GetVendorNameDocument, options);
      }
export function useGetVendorNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorNameQuery, GetVendorNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorNameQuery, GetVendorNameQueryVariables>(GetVendorNameDocument, options);
        }
// @ts-ignore
export function useGetVendorNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorNameQuery, GetVendorNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorNameQuery, GetVendorNameQueryVariables>;
export function useGetVendorNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorNameQuery, GetVendorNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorNameQuery | undefined, GetVendorNameQueryVariables>;
export function useGetVendorNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorNameQuery, GetVendorNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorNameQuery, GetVendorNameQueryVariables>(GetVendorNameDocument, options);
        }
export type GetVendorNameQueryHookResult = ReturnType<typeof useGetVendorNameQuery>;
export type GetVendorNameLazyQueryHookResult = ReturnType<typeof useGetVendorNameLazyQuery>;
export type GetVendorNameSuspenseQueryHookResult = ReturnType<typeof useGetVendorNameSuspenseQuery>;
export type GetVendorNameQueryResult = Apollo.QueryResult<GetVendorNameQuery, GetVendorNameQueryVariables>;
export const GetMeDocument = gql`
    query getMe {
  me {
    id
    email
    firstName
    lastName
    fullName
    intercomUserHash
    account {
      ccTeams {
        code
        name
        id
      }
      locations {
        id
        isCCActive
        label
        address {
          flatOrBuilding
          floorOrBuildingName
          street
          city
          postcode
          country
        }
      }
      id
      name
      managerName
    }
    accountLocation {
      id
    }
    isAdmin
    isUser
    isVendor
    teamId
    legacyAdminId
    role
    invoiceApproved
    marketingOptIn
    languageSettings {
      locale
    }
    vendor {
      companyName
      id
    }
    hasPreviousGmOrders
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
// @ts-ignore
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeQuery, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeQuery | undefined, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<typeof useGetMeSuspenseQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetSsoSettingsByCompanyCodeDocument = gql`
    query GetSsoSettingsByCompanyCode($companyCode: String!, $tenantId: String) {
  ssoSettingsByCompanyCode(companyCode: $companyCode, tenantId: $tenantId) {
    enabled
    code
    id
  }
}
    `;

/**
 * __useGetSsoSettingsByCompanyCodeQuery__
 *
 * To run a query within a React component, call `useGetSsoSettingsByCompanyCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsoSettingsByCompanyCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsoSettingsByCompanyCodeQuery({
 *   variables: {
 *      companyCode: // value for 'companyCode'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetSsoSettingsByCompanyCodeQuery(baseOptions: Apollo.QueryHookOptions<GetSsoSettingsByCompanyCodeQuery, GetSsoSettingsByCompanyCodeQueryVariables> & ({ variables: GetSsoSettingsByCompanyCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSsoSettingsByCompanyCodeQuery, GetSsoSettingsByCompanyCodeQueryVariables>(GetSsoSettingsByCompanyCodeDocument, options);
      }
export function useGetSsoSettingsByCompanyCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSsoSettingsByCompanyCodeQuery, GetSsoSettingsByCompanyCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSsoSettingsByCompanyCodeQuery, GetSsoSettingsByCompanyCodeQueryVariables>(GetSsoSettingsByCompanyCodeDocument, options);
        }
// @ts-ignore
export function useGetSsoSettingsByCompanyCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSsoSettingsByCompanyCodeQuery, GetSsoSettingsByCompanyCodeQueryVariables>): Apollo.UseSuspenseQueryResult<GetSsoSettingsByCompanyCodeQuery, GetSsoSettingsByCompanyCodeQueryVariables>;
export function useGetSsoSettingsByCompanyCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSsoSettingsByCompanyCodeQuery, GetSsoSettingsByCompanyCodeQueryVariables>): Apollo.UseSuspenseQueryResult<GetSsoSettingsByCompanyCodeQuery | undefined, GetSsoSettingsByCompanyCodeQueryVariables>;
export function useGetSsoSettingsByCompanyCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSsoSettingsByCompanyCodeQuery, GetSsoSettingsByCompanyCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSsoSettingsByCompanyCodeQuery, GetSsoSettingsByCompanyCodeQueryVariables>(GetSsoSettingsByCompanyCodeDocument, options);
        }
export type GetSsoSettingsByCompanyCodeQueryHookResult = ReturnType<typeof useGetSsoSettingsByCompanyCodeQuery>;
export type GetSsoSettingsByCompanyCodeLazyQueryHookResult = ReturnType<typeof useGetSsoSettingsByCompanyCodeLazyQuery>;
export type GetSsoSettingsByCompanyCodeSuspenseQueryHookResult = ReturnType<typeof useGetSsoSettingsByCompanyCodeSuspenseQuery>;
export type GetSsoSettingsByCompanyCodeQueryResult = Apollo.QueryResult<GetSsoSettingsByCompanyCodeQuery, GetSsoSettingsByCompanyCodeQueryVariables>;
export const HomeRealmDiscoveryDocument = gql`
    query HomeRealmDiscovery($domain: String!, $email: String, $tenantId: String) {
  allSsoSettingsByDomain(domain: $domain, email: $email, tenantId: $tenantId) {
    name
    enabled
    code
    codeOverride
  }
}
    `;

/**
 * __useHomeRealmDiscoveryQuery__
 *
 * To run a query within a React component, call `useHomeRealmDiscoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRealmDiscoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRealmDiscoveryQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      email: // value for 'email'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useHomeRealmDiscoveryQuery(baseOptions: Apollo.QueryHookOptions<HomeRealmDiscoveryQuery, HomeRealmDiscoveryQueryVariables> & ({ variables: HomeRealmDiscoveryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeRealmDiscoveryQuery, HomeRealmDiscoveryQueryVariables>(HomeRealmDiscoveryDocument, options);
      }
export function useHomeRealmDiscoveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeRealmDiscoveryQuery, HomeRealmDiscoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeRealmDiscoveryQuery, HomeRealmDiscoveryQueryVariables>(HomeRealmDiscoveryDocument, options);
        }
// @ts-ignore
export function useHomeRealmDiscoverySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRealmDiscoveryQuery, HomeRealmDiscoveryQueryVariables>): Apollo.UseSuspenseQueryResult<HomeRealmDiscoveryQuery, HomeRealmDiscoveryQueryVariables>;
export function useHomeRealmDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeRealmDiscoveryQuery, HomeRealmDiscoveryQueryVariables>): Apollo.UseSuspenseQueryResult<HomeRealmDiscoveryQuery | undefined, HomeRealmDiscoveryQueryVariables>;
export function useHomeRealmDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeRealmDiscoveryQuery, HomeRealmDiscoveryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeRealmDiscoveryQuery, HomeRealmDiscoveryQueryVariables>(HomeRealmDiscoveryDocument, options);
        }
export type HomeRealmDiscoveryQueryHookResult = ReturnType<typeof useHomeRealmDiscoveryQuery>;
export type HomeRealmDiscoveryLazyQueryHookResult = ReturnType<typeof useHomeRealmDiscoveryLazyQuery>;
export type HomeRealmDiscoverySuspenseQueryHookResult = ReturnType<typeof useHomeRealmDiscoverySuspenseQuery>;
export type HomeRealmDiscoveryQueryResult = Apollo.QueryResult<HomeRealmDiscoveryQuery, HomeRealmDiscoveryQueryVariables>;
export const UpdateMeDocument = gql`
    mutation UpdateMe($userPayload: UpdateUserInput!) {
  updateMe(userPayload: $userPayload) {
    id
    firstName
    lastName
    fullName
    privacyAccepted
    teamId
    phone
    accountLocation {
      id
      label
    }
    contactPreferences {
      ...UserContactPreferences
    }
    allergens {
      ...UserAllergens
    }
    dietaryPreferences {
      ...UserDietaryPreferences
    }
  }
}
    ${UserContactPreferencesFragmentDoc}
${UserAllergensFragmentDoc}
${UserDietaryPreferencesFragmentDoc}`;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      userPayload: // value for 'userPayload'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const GetAdminCanteenTeamsDocument = gql`
    query getAdminCanteenTeams($accountId: ID!) {
  account(id: $accountId) {
    id
    isCCActive
    onboardingLink
    signUpCode
    locationsPaged(filters: {isCCActive: true}) {
      rows {
        id
        label
        ccAvailabilities {
          rows {
            weekday
            meal
          }
        }
      }
    }
    ccTeams {
      id
      code
      name
      users {
        id
        fullName
        email
      }
    }
  }
}
    `;

/**
 * __useGetAdminCanteenTeamsQuery__
 *
 * To run a query within a React component, call `useGetAdminCanteenTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminCanteenTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminCanteenTeamsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAdminCanteenTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetAdminCanteenTeamsQuery, GetAdminCanteenTeamsQueryVariables> & ({ variables: GetAdminCanteenTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminCanteenTeamsQuery, GetAdminCanteenTeamsQueryVariables>(GetAdminCanteenTeamsDocument, options);
      }
export function useGetAdminCanteenTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminCanteenTeamsQuery, GetAdminCanteenTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminCanteenTeamsQuery, GetAdminCanteenTeamsQueryVariables>(GetAdminCanteenTeamsDocument, options);
        }
// @ts-ignore
export function useGetAdminCanteenTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminCanteenTeamsQuery, GetAdminCanteenTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminCanteenTeamsQuery, GetAdminCanteenTeamsQueryVariables>;
export function useGetAdminCanteenTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminCanteenTeamsQuery, GetAdminCanteenTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminCanteenTeamsQuery | undefined, GetAdminCanteenTeamsQueryVariables>;
export function useGetAdminCanteenTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminCanteenTeamsQuery, GetAdminCanteenTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminCanteenTeamsQuery, GetAdminCanteenTeamsQueryVariables>(GetAdminCanteenTeamsDocument, options);
        }
export type GetAdminCanteenTeamsQueryHookResult = ReturnType<typeof useGetAdminCanteenTeamsQuery>;
export type GetAdminCanteenTeamsLazyQueryHookResult = ReturnType<typeof useGetAdminCanteenTeamsLazyQuery>;
export type GetAdminCanteenTeamsSuspenseQueryHookResult = ReturnType<typeof useGetAdminCanteenTeamsSuspenseQuery>;
export type GetAdminCanteenTeamsQueryResult = Apollo.QueryResult<GetAdminCanteenTeamsQuery, GetAdminCanteenTeamsQueryVariables>;
export const AuthGmDocument = gql`
    query authGm {
  me {
    id
    firstName
    lastName
    email
    role
    invoiceApproved
    privacyAccepted
    accountLocation {
      id
      isGmActive
      address {
        country
      }
    }
    account {
      ...AuthAccount
    }
  }
  ghosterUser {
    id
  }
}
    ${AuthAccountFragmentDoc}`;

/**
 * __useAuthGmQuery__
 *
 * To run a query within a React component, call `useAuthGmQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthGmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthGmQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthGmQuery(baseOptions?: Apollo.QueryHookOptions<AuthGmQuery, AuthGmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthGmQuery, AuthGmQueryVariables>(AuthGmDocument, options);
      }
export function useAuthGmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthGmQuery, AuthGmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthGmQuery, AuthGmQueryVariables>(AuthGmDocument, options);
        }
// @ts-ignore
export function useAuthGmSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthGmQuery, AuthGmQueryVariables>): Apollo.UseSuspenseQueryResult<AuthGmQuery, AuthGmQueryVariables>;
export function useAuthGmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthGmQuery, AuthGmQueryVariables>): Apollo.UseSuspenseQueryResult<AuthGmQuery | undefined, AuthGmQueryVariables>;
export function useAuthGmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthGmQuery, AuthGmQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthGmQuery, AuthGmQueryVariables>(AuthGmDocument, options);
        }
export type AuthGmQueryHookResult = ReturnType<typeof useAuthGmQuery>;
export type AuthGmLazyQueryHookResult = ReturnType<typeof useAuthGmLazyQuery>;
export type AuthGmSuspenseQueryHookResult = ReturnType<typeof useAuthGmSuspenseQuery>;
export type AuthGmQueryResult = Apollo.QueryResult<AuthGmQuery, AuthGmQueryVariables>;
export const UpdateMeGmDocument = gql`
    mutation updateMeGm($userPayload: UpdateUserInput!) {
  updateMe(userPayload: $userPayload) {
    id
    privacyAccepted
  }
}
    `;
export type UpdateMeGmMutationFn = Apollo.MutationFunction<UpdateMeGmMutation, UpdateMeGmMutationVariables>;

/**
 * __useUpdateMeGmMutation__
 *
 * To run a mutation, you first call `useUpdateMeGmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeGmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeGmMutation, { data, loading, error }] = useUpdateMeGmMutation({
 *   variables: {
 *      userPayload: // value for 'userPayload'
 *   },
 * });
 */
export function useUpdateMeGmMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeGmMutation, UpdateMeGmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeGmMutation, UpdateMeGmMutationVariables>(UpdateMeGmDocument, options);
      }
export type UpdateMeGmMutationHookResult = ReturnType<typeof useUpdateMeGmMutation>;
export type UpdateMeGmMutationResult = Apollo.MutationResult<UpdateMeGmMutation>;
export type UpdateMeGmMutationOptions = Apollo.BaseMutationOptions<UpdateMeGmMutation, UpdateMeGmMutationVariables>;
export const CreateOrUpdateMyFavouriteDocument = gql`
    mutation CreateOrUpdateMyFavourite($input: CreateOrUpdateMyFavouriteInput!) {
  createOrUpdateMyFavourite(input: $input)
}
    `;
export type CreateOrUpdateMyFavouriteMutationFn = Apollo.MutationFunction<CreateOrUpdateMyFavouriteMutation, CreateOrUpdateMyFavouriteMutationVariables>;

/**
 * __useCreateOrUpdateMyFavouriteMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateMyFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateMyFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateMyFavouriteMutation, { data, loading, error }] = useCreateOrUpdateMyFavouriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateMyFavouriteMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateMyFavouriteMutation, CreateOrUpdateMyFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateMyFavouriteMutation, CreateOrUpdateMyFavouriteMutationVariables>(CreateOrUpdateMyFavouriteDocument, options);
      }
export type CreateOrUpdateMyFavouriteMutationHookResult = ReturnType<typeof useCreateOrUpdateMyFavouriteMutation>;
export type CreateOrUpdateMyFavouriteMutationResult = Apollo.MutationResult<CreateOrUpdateMyFavouriteMutation>;
export type CreateOrUpdateMyFavouriteMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateMyFavouriteMutation, CreateOrUpdateMyFavouriteMutationVariables>;
export const GetCheckoutBasketDocument = gql`
    query getCheckoutBasket($id: ID!) {
  basket: gmBasket(id: $id) {
    ...CheckoutBasket
  }
}
    ${CheckoutBasketFragmentDoc}`;

/**
 * __useGetCheckoutBasketQuery__
 *
 * To run a query within a React component, call `useGetCheckoutBasketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckoutBasketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckoutBasketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCheckoutBasketQuery(baseOptions: Apollo.QueryHookOptions<GetCheckoutBasketQuery, GetCheckoutBasketQueryVariables> & ({ variables: GetCheckoutBasketQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckoutBasketQuery, GetCheckoutBasketQueryVariables>(GetCheckoutBasketDocument, options);
      }
export function useGetCheckoutBasketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckoutBasketQuery, GetCheckoutBasketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckoutBasketQuery, GetCheckoutBasketQueryVariables>(GetCheckoutBasketDocument, options);
        }
// @ts-ignore
export function useGetCheckoutBasketSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCheckoutBasketQuery, GetCheckoutBasketQueryVariables>): Apollo.UseSuspenseQueryResult<GetCheckoutBasketQuery, GetCheckoutBasketQueryVariables>;
export function useGetCheckoutBasketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCheckoutBasketQuery, GetCheckoutBasketQueryVariables>): Apollo.UseSuspenseQueryResult<GetCheckoutBasketQuery | undefined, GetCheckoutBasketQueryVariables>;
export function useGetCheckoutBasketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCheckoutBasketQuery, GetCheckoutBasketQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCheckoutBasketQuery, GetCheckoutBasketQueryVariables>(GetCheckoutBasketDocument, options);
        }
export type GetCheckoutBasketQueryHookResult = ReturnType<typeof useGetCheckoutBasketQuery>;
export type GetCheckoutBasketLazyQueryHookResult = ReturnType<typeof useGetCheckoutBasketLazyQuery>;
export type GetCheckoutBasketSuspenseQueryHookResult = ReturnType<typeof useGetCheckoutBasketSuspenseQuery>;
export type GetCheckoutBasketQueryResult = Apollo.QueryResult<GetCheckoutBasketQuery, GetCheckoutBasketQueryVariables>;
export const GetTenantGuestInvoiceAccountsDocument = gql`
    query getTenantGuestInvoiceAccounts($id: ID!) {
  account(id: $id) {
    invoiceApproved
    invoiceAccounts {
      ...InvoiceAccount
    }
  }
}
    ${InvoiceAccountFragmentDoc}`;

/**
 * __useGetTenantGuestInvoiceAccountsQuery__
 *
 * To run a query within a React component, call `useGetTenantGuestInvoiceAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantGuestInvoiceAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantGuestInvoiceAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTenantGuestInvoiceAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetTenantGuestInvoiceAccountsQuery, GetTenantGuestInvoiceAccountsQueryVariables> & ({ variables: GetTenantGuestInvoiceAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantGuestInvoiceAccountsQuery, GetTenantGuestInvoiceAccountsQueryVariables>(GetTenantGuestInvoiceAccountsDocument, options);
      }
export function useGetTenantGuestInvoiceAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantGuestInvoiceAccountsQuery, GetTenantGuestInvoiceAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantGuestInvoiceAccountsQuery, GetTenantGuestInvoiceAccountsQueryVariables>(GetTenantGuestInvoiceAccountsDocument, options);
        }
// @ts-ignore
export function useGetTenantGuestInvoiceAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTenantGuestInvoiceAccountsQuery, GetTenantGuestInvoiceAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantGuestInvoiceAccountsQuery, GetTenantGuestInvoiceAccountsQueryVariables>;
export function useGetTenantGuestInvoiceAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantGuestInvoiceAccountsQuery, GetTenantGuestInvoiceAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantGuestInvoiceAccountsQuery | undefined, GetTenantGuestInvoiceAccountsQueryVariables>;
export function useGetTenantGuestInvoiceAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantGuestInvoiceAccountsQuery, GetTenantGuestInvoiceAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantGuestInvoiceAccountsQuery, GetTenantGuestInvoiceAccountsQueryVariables>(GetTenantGuestInvoiceAccountsDocument, options);
        }
export type GetTenantGuestInvoiceAccountsQueryHookResult = ReturnType<typeof useGetTenantGuestInvoiceAccountsQuery>;
export type GetTenantGuestInvoiceAccountsLazyQueryHookResult = ReturnType<typeof useGetTenantGuestInvoiceAccountsLazyQuery>;
export type GetTenantGuestInvoiceAccountsSuspenseQueryHookResult = ReturnType<typeof useGetTenantGuestInvoiceAccountsSuspenseQuery>;
export type GetTenantGuestInvoiceAccountsQueryResult = Apollo.QueryResult<GetTenantGuestInvoiceAccountsQuery, GetTenantGuestInvoiceAccountsQueryVariables>;
export const UpdateCheckoutBasketDocument = gql`
    mutation updateCheckoutBasket($basketId: ID!, $basketPayload: UpdateGmBasketInput!) {
  basket: updateGmBasket(basketId: $basketId, basketPayload: $basketPayload) {
    ...CheckoutBasket
  }
}
    ${CheckoutBasketFragmentDoc}`;
export type UpdateCheckoutBasketMutationFn = Apollo.MutationFunction<UpdateCheckoutBasketMutation, UpdateCheckoutBasketMutationVariables>;

/**
 * __useUpdateCheckoutBasketMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutBasketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutBasketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutBasketMutation, { data, loading, error }] = useUpdateCheckoutBasketMutation({
 *   variables: {
 *      basketId: // value for 'basketId'
 *      basketPayload: // value for 'basketPayload'
 *   },
 * });
 */
export function useUpdateCheckoutBasketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckoutBasketMutation, UpdateCheckoutBasketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckoutBasketMutation, UpdateCheckoutBasketMutationVariables>(UpdateCheckoutBasketDocument, options);
      }
export type UpdateCheckoutBasketMutationHookResult = ReturnType<typeof useUpdateCheckoutBasketMutation>;
export type UpdateCheckoutBasketMutationResult = Apollo.MutationResult<UpdateCheckoutBasketMutation>;
export type UpdateCheckoutBasketMutationOptions = Apollo.BaseMutationOptions<UpdateCheckoutBasketMutation, UpdateCheckoutBasketMutationVariables>;
export const CheckoutDocument = gql`
    mutation checkout($basketId: ID!, $paymentMethod: PaymentMethod!, $proposedTotalIncTax: Int) {
  checkout: checkout(
    basketId: $basketId
    paymentMethod: $paymentMethod
    proposedTotalIncTax: $proposedTotalIncTax
  ) {
    ... on GmCheckoutErrors {
      errors {
        message
        code
      }
    }
    ... on PayByCardResponse {
      authToken
    }
    ... on PayByInvoiceResponse {
      orderId
    }
    ... on PayByTransferResponse {
      orderId
    }
  }
}
    `;
export type CheckoutMutationFn = Apollo.MutationFunction<CheckoutMutation, CheckoutMutationVariables>;

/**
 * __useCheckoutMutation__
 *
 * To run a mutation, you first call `useCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutMutation, { data, loading, error }] = useCheckoutMutation({
 *   variables: {
 *      basketId: // value for 'basketId'
 *      paymentMethod: // value for 'paymentMethod'
 *      proposedTotalIncTax: // value for 'proposedTotalIncTax'
 *   },
 * });
 */
export function useCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutMutation, CheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutMutation, CheckoutMutationVariables>(CheckoutDocument, options);
      }
export type CheckoutMutationHookResult = ReturnType<typeof useCheckoutMutation>;
export type CheckoutMutationResult = Apollo.MutationResult<CheckoutMutation>;
export type CheckoutMutationOptions = Apollo.BaseMutationOptions<CheckoutMutation, CheckoutMutationVariables>;
export const AssignBasketToGuestDocument = gql`
    mutation assignBasketToGuest($basketId: ID!, $input: AssignBasketToGuestInput!) {
  assignBasketToGuest(basketId: $basketId, input: $input) {
    ...CheckoutBasket
  }
}
    ${CheckoutBasketFragmentDoc}`;
export type AssignBasketToGuestMutationFn = Apollo.MutationFunction<AssignBasketToGuestMutation, AssignBasketToGuestMutationVariables>;

/**
 * __useAssignBasketToGuestMutation__
 *
 * To run a mutation, you first call `useAssignBasketToGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignBasketToGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignBasketToGuestMutation, { data, loading, error }] = useAssignBasketToGuestMutation({
 *   variables: {
 *      basketId: // value for 'basketId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignBasketToGuestMutation(baseOptions?: Apollo.MutationHookOptions<AssignBasketToGuestMutation, AssignBasketToGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignBasketToGuestMutation, AssignBasketToGuestMutationVariables>(AssignBasketToGuestDocument, options);
      }
export type AssignBasketToGuestMutationHookResult = ReturnType<typeof useAssignBasketToGuestMutation>;
export type AssignBasketToGuestMutationResult = Apollo.MutationResult<AssignBasketToGuestMutation>;
export type AssignBasketToGuestMutationOptions = Apollo.BaseMutationOptions<AssignBasketToGuestMutation, AssignBasketToGuestMutationVariables>;
export const LookupAddressDocument = gql`
    query lookupAddress($query: String!, $countries: [CountryCode!], $useGoogle: Boolean, $allowAnyCity: Boolean = false, $locale: String) {
  lookupAddress(
    query: $query
    countries: $countries
    useGoogle: $useGoogle
    allowAnyCity: $allowAnyCity
    locale: $locale
  ) {
    locations {
      relevance
      address {
        __typename
        label
        flatOrBuilding
        floorOrBuildingName
        street
        postcode
        city
        country
        latitude
        longitude
        timezoneId
      }
      context {
        region
      }
    }
  }
}
    `;

/**
 * __useLookupAddressQuery__
 *
 * To run a query within a React component, call `useLookupAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupAddressQuery({
 *   variables: {
 *      query: // value for 'query'
 *      countries: // value for 'countries'
 *      useGoogle: // value for 'useGoogle'
 *      allowAnyCity: // value for 'allowAnyCity'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useLookupAddressQuery(baseOptions: Apollo.QueryHookOptions<LookupAddressQuery, LookupAddressQueryVariables> & ({ variables: LookupAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookupAddressQuery, LookupAddressQueryVariables>(LookupAddressDocument, options);
      }
export function useLookupAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookupAddressQuery, LookupAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookupAddressQuery, LookupAddressQueryVariables>(LookupAddressDocument, options);
        }
// @ts-ignore
export function useLookupAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LookupAddressQuery, LookupAddressQueryVariables>): Apollo.UseSuspenseQueryResult<LookupAddressQuery, LookupAddressQueryVariables>;
export function useLookupAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LookupAddressQuery, LookupAddressQueryVariables>): Apollo.UseSuspenseQueryResult<LookupAddressQuery | undefined, LookupAddressQueryVariables>;
export function useLookupAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LookupAddressQuery, LookupAddressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LookupAddressQuery, LookupAddressQueryVariables>(LookupAddressDocument, options);
        }
export type LookupAddressQueryHookResult = ReturnType<typeof useLookupAddressQuery>;
export type LookupAddressLazyQueryHookResult = ReturnType<typeof useLookupAddressLazyQuery>;
export type LookupAddressSuspenseQueryHookResult = ReturnType<typeof useLookupAddressSuspenseQuery>;
export type LookupAddressQueryResult = Apollo.QueryResult<LookupAddressQuery, LookupAddressQueryVariables>;
export const GetVendorDocument = gql`
    query getVendor($permalink: String!, $maxRating: Int, $tenantId: String!) {
  vendor: vendorByPermalink(permalink: $permalink, tenantId: $tenantId) {
    ...MenuVendor
    ratingScaled: rating(input: {maxRating: $maxRating})
  }
}
    ${MenuVendorFragmentDoc}`;

/**
 * __useGetVendorQuery__
 *
 * To run a query within a React component, call `useGetVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorQuery({
 *   variables: {
 *      permalink: // value for 'permalink'
 *      maxRating: // value for 'maxRating'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetVendorQuery(baseOptions: Apollo.QueryHookOptions<GetVendorQuery, GetVendorQueryVariables> & ({ variables: GetVendorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument, options);
      }
export function useGetVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorQuery, GetVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument, options);
        }
// @ts-ignore
export function useGetVendorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorQuery, GetVendorQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorQuery, GetVendorQueryVariables>;
export function useGetVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorQuery, GetVendorQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorQuery | undefined, GetVendorQueryVariables>;
export function useGetVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorQuery, GetVendorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument, options);
        }
export type GetVendorQueryHookResult = ReturnType<typeof useGetVendorQuery>;
export type GetVendorLazyQueryHookResult = ReturnType<typeof useGetVendorLazyQuery>;
export type GetVendorSuspenseQueryHookResult = ReturnType<typeof useGetVendorSuspenseQuery>;
export type GetVendorQueryResult = Apollo.QueryResult<GetVendorQuery, GetVendorQueryVariables>;
export const GetVendorAvailabilityDocument = gql`
    query getVendorAvailability($vendorId: ID!, $filters: GmMenuItemFilters, $limit: Int = 100, $offset: Int = 0, $sorting: GmMenuItemSortingOptions) {
  availability: gmAvailabilityByVendorId(vendorId: $vendorId) {
    ...MenuAvailabilityWithItemsPaged
  }
}
    ${MenuAvailabilityWithItemsPagedFragmentDoc}`;

/**
 * __useGetVendorAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetVendorAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorAvailabilityQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetVendorAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GetVendorAvailabilityQuery, GetVendorAvailabilityQueryVariables> & ({ variables: GetVendorAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorAvailabilityQuery, GetVendorAvailabilityQueryVariables>(GetVendorAvailabilityDocument, options);
      }
export function useGetVendorAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorAvailabilityQuery, GetVendorAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorAvailabilityQuery, GetVendorAvailabilityQueryVariables>(GetVendorAvailabilityDocument, options);
        }
// @ts-ignore
export function useGetVendorAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorAvailabilityQuery, GetVendorAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorAvailabilityQuery, GetVendorAvailabilityQueryVariables>;
export function useGetVendorAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorAvailabilityQuery, GetVendorAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorAvailabilityQuery | undefined, GetVendorAvailabilityQueryVariables>;
export function useGetVendorAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorAvailabilityQuery, GetVendorAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorAvailabilityQuery, GetVendorAvailabilityQueryVariables>(GetVendorAvailabilityDocument, options);
        }
export type GetVendorAvailabilityQueryHookResult = ReturnType<typeof useGetVendorAvailabilityQuery>;
export type GetVendorAvailabilityLazyQueryHookResult = ReturnType<typeof useGetVendorAvailabilityLazyQuery>;
export type GetVendorAvailabilitySuspenseQueryHookResult = ReturnType<typeof useGetVendorAvailabilitySuspenseQuery>;
export type GetVendorAvailabilityQueryResult = Apollo.QueryResult<GetVendorAvailabilityQuery, GetVendorAvailabilityQueryVariables>;
export const GetVendorAvailabilityListDocument = gql`
    query getVendorAvailabilityList($vendorId: ID!, $filters: GmMenuItemFilters, $limit: Int = 100, $offset: Int = 0, $sorting: GmMenuItemSortingOptions) {
  availability: gmAvailabilityByVendorId(vendorId: $vendorId) {
    ...MenuAvailabilityWithItemsPagedList
  }
}
    ${MenuAvailabilityWithItemsPagedListFragmentDoc}`;

/**
 * __useGetVendorAvailabilityListQuery__
 *
 * To run a query within a React component, call `useGetVendorAvailabilityListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorAvailabilityListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorAvailabilityListQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetVendorAvailabilityListQuery(baseOptions: Apollo.QueryHookOptions<GetVendorAvailabilityListQuery, GetVendorAvailabilityListQueryVariables> & ({ variables: GetVendorAvailabilityListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorAvailabilityListQuery, GetVendorAvailabilityListQueryVariables>(GetVendorAvailabilityListDocument, options);
      }
export function useGetVendorAvailabilityListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorAvailabilityListQuery, GetVendorAvailabilityListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorAvailabilityListQuery, GetVendorAvailabilityListQueryVariables>(GetVendorAvailabilityListDocument, options);
        }
// @ts-ignore
export function useGetVendorAvailabilityListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorAvailabilityListQuery, GetVendorAvailabilityListQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorAvailabilityListQuery, GetVendorAvailabilityListQueryVariables>;
export function useGetVendorAvailabilityListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorAvailabilityListQuery, GetVendorAvailabilityListQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorAvailabilityListQuery | undefined, GetVendorAvailabilityListQueryVariables>;
export function useGetVendorAvailabilityListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorAvailabilityListQuery, GetVendorAvailabilityListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorAvailabilityListQuery, GetVendorAvailabilityListQueryVariables>(GetVendorAvailabilityListDocument, options);
        }
export type GetVendorAvailabilityListQueryHookResult = ReturnType<typeof useGetVendorAvailabilityListQuery>;
export type GetVendorAvailabilityListLazyQueryHookResult = ReturnType<typeof useGetVendorAvailabilityListLazyQuery>;
export type GetVendorAvailabilityListSuspenseQueryHookResult = ReturnType<typeof useGetVendorAvailabilityListSuspenseQuery>;
export type GetVendorAvailabilityListQueryResult = Apollo.QueryResult<GetVendorAvailabilityListQuery, GetVendorAvailabilityListQueryVariables>;
export const GetLiveMenuItemDocument = gql`
    query getLiveMenuItem($id: ID!) {
  liveMenuItem(id: $id) {
    ...MenuItem
  }
}
    ${MenuItemFragmentDoc}`;

/**
 * __useGetLiveMenuItemQuery__
 *
 * To run a query within a React component, call `useGetLiveMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveMenuItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLiveMenuItemQuery(baseOptions: Apollo.QueryHookOptions<GetLiveMenuItemQuery, GetLiveMenuItemQueryVariables> & ({ variables: GetLiveMenuItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiveMenuItemQuery, GetLiveMenuItemQueryVariables>(GetLiveMenuItemDocument, options);
      }
export function useGetLiveMenuItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiveMenuItemQuery, GetLiveMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiveMenuItemQuery, GetLiveMenuItemQueryVariables>(GetLiveMenuItemDocument, options);
        }
// @ts-ignore
export function useGetLiveMenuItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLiveMenuItemQuery, GetLiveMenuItemQueryVariables>): Apollo.UseSuspenseQueryResult<GetLiveMenuItemQuery, GetLiveMenuItemQueryVariables>;
export function useGetLiveMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLiveMenuItemQuery, GetLiveMenuItemQueryVariables>): Apollo.UseSuspenseQueryResult<GetLiveMenuItemQuery | undefined, GetLiveMenuItemQueryVariables>;
export function useGetLiveMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLiveMenuItemQuery, GetLiveMenuItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLiveMenuItemQuery, GetLiveMenuItemQueryVariables>(GetLiveMenuItemDocument, options);
        }
export type GetLiveMenuItemQueryHookResult = ReturnType<typeof useGetLiveMenuItemQuery>;
export type GetLiveMenuItemLazyQueryHookResult = ReturnType<typeof useGetLiveMenuItemLazyQuery>;
export type GetLiveMenuItemSuspenseQueryHookResult = ReturnType<typeof useGetLiveMenuItemSuspenseQuery>;
export type GetLiveMenuItemQueryResult = Apollo.QueryResult<GetLiveMenuItemQuery, GetLiveMenuItemQueryVariables>;
export const GetDraftMenuItemDocument = gql`
    query getDraftMenuItem($id: ID!) {
  draftMenuItem(id: $id) {
    ...MenuItem
  }
}
    ${MenuItemFragmentDoc}`;

/**
 * __useGetDraftMenuItemQuery__
 *
 * To run a query within a React component, call `useGetDraftMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftMenuItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDraftMenuItemQuery(baseOptions: Apollo.QueryHookOptions<GetDraftMenuItemQuery, GetDraftMenuItemQueryVariables> & ({ variables: GetDraftMenuItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDraftMenuItemQuery, GetDraftMenuItemQueryVariables>(GetDraftMenuItemDocument, options);
      }
export function useGetDraftMenuItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDraftMenuItemQuery, GetDraftMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDraftMenuItemQuery, GetDraftMenuItemQueryVariables>(GetDraftMenuItemDocument, options);
        }
// @ts-ignore
export function useGetDraftMenuItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDraftMenuItemQuery, GetDraftMenuItemQueryVariables>): Apollo.UseSuspenseQueryResult<GetDraftMenuItemQuery, GetDraftMenuItemQueryVariables>;
export function useGetDraftMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDraftMenuItemQuery, GetDraftMenuItemQueryVariables>): Apollo.UseSuspenseQueryResult<GetDraftMenuItemQuery | undefined, GetDraftMenuItemQueryVariables>;
export function useGetDraftMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDraftMenuItemQuery, GetDraftMenuItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDraftMenuItemQuery, GetDraftMenuItemQueryVariables>(GetDraftMenuItemDocument, options);
        }
export type GetDraftMenuItemQueryHookResult = ReturnType<typeof useGetDraftMenuItemQuery>;
export type GetDraftMenuItemLazyQueryHookResult = ReturnType<typeof useGetDraftMenuItemLazyQuery>;
export type GetDraftMenuItemSuspenseQueryHookResult = ReturnType<typeof useGetDraftMenuItemSuspenseQuery>;
export type GetDraftMenuItemQueryResult = Apollo.QueryResult<GetDraftMenuItemQuery, GetDraftMenuItemQueryVariables>;
export const TagsDocument = gql`
    query tags($filters: VendorTagsFilters, $limit: Int, $offset: Int, $orderBy: String) {
  tags(filters: $filters, limit: $limit, offset: $offset, orderBy: $orderBy) {
    rows {
      id
      label
      name
      groupId
    }
    pageInfo {
      hasMore
    }
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
// @ts-ignore
export function useTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>): Apollo.UseSuspenseQueryResult<TagsQuery, TagsQueryVariables>;
export function useTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>): Apollo.UseSuspenseQueryResult<TagsQuery | undefined, TagsQueryVariables>;
export function useTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsSuspenseQueryHookResult = ReturnType<typeof useTagsSuspenseQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const GetVendorsInRangeLocationsDocument = gql`
    query GetVendorsInRangeLocations($vendorId: ID!, $lat: Float!, $lng: Float!, $serviceType: ServiceType!, $countryCode: String, $dateTime: VendorListDateSearchInput) {
  vendor(id: $vendorId) {
    inRangeLocations(
      lat: $lat
      lng: $lng
      serviceType: $serviceType
      countryCode: $countryCode
      dateTime: $dateTime
    ) {
      ...MenuVendorLocation
      deliveryRegions(
        input: {location: {lat: $lat, lng: $lng}, serviceType: $serviceType}
      ) {
        id
        ...MenuVendorLocationDeliveryRegion
      }
    }
  }
}
    ${MenuVendorLocationFragmentDoc}
${MenuVendorLocationDeliveryRegionFragmentDoc}`;

/**
 * __useGetVendorsInRangeLocationsQuery__
 *
 * To run a query within a React component, call `useGetVendorsInRangeLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorsInRangeLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorsInRangeLocationsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *      serviceType: // value for 'serviceType'
 *      countryCode: // value for 'countryCode'
 *      dateTime: // value for 'dateTime'
 *   },
 * });
 */
export function useGetVendorsInRangeLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetVendorsInRangeLocationsQuery, GetVendorsInRangeLocationsQueryVariables> & ({ variables: GetVendorsInRangeLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorsInRangeLocationsQuery, GetVendorsInRangeLocationsQueryVariables>(GetVendorsInRangeLocationsDocument, options);
      }
export function useGetVendorsInRangeLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorsInRangeLocationsQuery, GetVendorsInRangeLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorsInRangeLocationsQuery, GetVendorsInRangeLocationsQueryVariables>(GetVendorsInRangeLocationsDocument, options);
        }
// @ts-ignore
export function useGetVendorsInRangeLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorsInRangeLocationsQuery, GetVendorsInRangeLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorsInRangeLocationsQuery, GetVendorsInRangeLocationsQueryVariables>;
export function useGetVendorsInRangeLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorsInRangeLocationsQuery, GetVendorsInRangeLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorsInRangeLocationsQuery | undefined, GetVendorsInRangeLocationsQueryVariables>;
export function useGetVendorsInRangeLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorsInRangeLocationsQuery, GetVendorsInRangeLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorsInRangeLocationsQuery, GetVendorsInRangeLocationsQueryVariables>(GetVendorsInRangeLocationsDocument, options);
        }
export type GetVendorsInRangeLocationsQueryHookResult = ReturnType<typeof useGetVendorsInRangeLocationsQuery>;
export type GetVendorsInRangeLocationsLazyQueryHookResult = ReturnType<typeof useGetVendorsInRangeLocationsLazyQuery>;
export type GetVendorsInRangeLocationsSuspenseQueryHookResult = ReturnType<typeof useGetVendorsInRangeLocationsSuspenseQuery>;
export type GetVendorsInRangeLocationsQueryResult = Apollo.QueryResult<GetVendorsInRangeLocationsQuery, GetVendorsInRangeLocationsQueryVariables>;
export const EmmaFormResponseGetVendorLocationsDocument = gql`
    query emmaFormResponseGetVendorLocations($vendorId: ID!) {
  vendor(id: $vendorId) {
    companyName
    locations {
      id
      isDefault
    }
  }
}
    `;

/**
 * __useEmmaFormResponseGetVendorLocationsQuery__
 *
 * To run a query within a React component, call `useEmmaFormResponseGetVendorLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmmaFormResponseGetVendorLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmmaFormResponseGetVendorLocationsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useEmmaFormResponseGetVendorLocationsQuery(baseOptions: Apollo.QueryHookOptions<EmmaFormResponseGetVendorLocationsQuery, EmmaFormResponseGetVendorLocationsQueryVariables> & ({ variables: EmmaFormResponseGetVendorLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmmaFormResponseGetVendorLocationsQuery, EmmaFormResponseGetVendorLocationsQueryVariables>(EmmaFormResponseGetVendorLocationsDocument, options);
      }
export function useEmmaFormResponseGetVendorLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmmaFormResponseGetVendorLocationsQuery, EmmaFormResponseGetVendorLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmmaFormResponseGetVendorLocationsQuery, EmmaFormResponseGetVendorLocationsQueryVariables>(EmmaFormResponseGetVendorLocationsDocument, options);
        }
// @ts-ignore
export function useEmmaFormResponseGetVendorLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmmaFormResponseGetVendorLocationsQuery, EmmaFormResponseGetVendorLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<EmmaFormResponseGetVendorLocationsQuery, EmmaFormResponseGetVendorLocationsQueryVariables>;
export function useEmmaFormResponseGetVendorLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmmaFormResponseGetVendorLocationsQuery, EmmaFormResponseGetVendorLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<EmmaFormResponseGetVendorLocationsQuery | undefined, EmmaFormResponseGetVendorLocationsQueryVariables>;
export function useEmmaFormResponseGetVendorLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmmaFormResponseGetVendorLocationsQuery, EmmaFormResponseGetVendorLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmmaFormResponseGetVendorLocationsQuery, EmmaFormResponseGetVendorLocationsQueryVariables>(EmmaFormResponseGetVendorLocationsDocument, options);
        }
export type EmmaFormResponseGetVendorLocationsQueryHookResult = ReturnType<typeof useEmmaFormResponseGetVendorLocationsQuery>;
export type EmmaFormResponseGetVendorLocationsLazyQueryHookResult = ReturnType<typeof useEmmaFormResponseGetVendorLocationsLazyQuery>;
export type EmmaFormResponseGetVendorLocationsSuspenseQueryHookResult = ReturnType<typeof useEmmaFormResponseGetVendorLocationsSuspenseQuery>;
export type EmmaFormResponseGetVendorLocationsQueryResult = Apollo.QueryResult<EmmaFormResponseGetVendorLocationsQuery, EmmaFormResponseGetVendorLocationsQueryVariables>;
export const VerifyCouponDocument = gql`
    query verifyCoupon($input: VerifyCouponInput!) {
  verifyCoupon(input: $input) {
    id
    code
    discountPercentage
    discountNumeric
  }
}
    `;

/**
 * __useVerifyCouponQuery__
 *
 * To run a query within a React component, call `useVerifyCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyCouponQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyCouponQuery(baseOptions: Apollo.QueryHookOptions<VerifyCouponQuery, VerifyCouponQueryVariables> & ({ variables: VerifyCouponQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyCouponQuery, VerifyCouponQueryVariables>(VerifyCouponDocument, options);
      }
export function useVerifyCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyCouponQuery, VerifyCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyCouponQuery, VerifyCouponQueryVariables>(VerifyCouponDocument, options);
        }
// @ts-ignore
export function useVerifyCouponSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VerifyCouponQuery, VerifyCouponQueryVariables>): Apollo.UseSuspenseQueryResult<VerifyCouponQuery, VerifyCouponQueryVariables>;
export function useVerifyCouponSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerifyCouponQuery, VerifyCouponQueryVariables>): Apollo.UseSuspenseQueryResult<VerifyCouponQuery | undefined, VerifyCouponQueryVariables>;
export function useVerifyCouponSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerifyCouponQuery, VerifyCouponQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerifyCouponQuery, VerifyCouponQueryVariables>(VerifyCouponDocument, options);
        }
export type VerifyCouponQueryHookResult = ReturnType<typeof useVerifyCouponQuery>;
export type VerifyCouponLazyQueryHookResult = ReturnType<typeof useVerifyCouponLazyQuery>;
export type VerifyCouponSuspenseQueryHookResult = ReturnType<typeof useVerifyCouponSuspenseQuery>;
export type VerifyCouponQueryResult = Apollo.QueryResult<VerifyCouponQuery, VerifyCouponQueryVariables>;
export const GetPastOrdersForReorderDocument = gql`
    query getPastOrdersForReorder($filters: GmOrdersFilters!, $limit: Int!, $offset: Int!, $sortBy: GmOrdersSortBy!) {
  gmOrders(filters: $filters, sortBy: $sortBy, limit: $limit, offset: $offset) {
    pageInfo {
      count
    }
    data {
      id
      orderId
      customName
      deliveryDate
      currentStatus {
        name
      }
      vendor {
        id
      }
      orderItems {
        items {
          id
          name
          qty
          servings
          subtotalExTax
          note
          liveMenuItem {
            _id
            name
          }
          orderItemOptions {
            id
            name
            qty
            optionCategoryId
            optionReference
            liveMenuItem {
              _id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPastOrdersForReorderQuery__
 *
 * To run a query within a React component, call `useGetPastOrdersForReorderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPastOrdersForReorderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPastOrdersForReorderQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetPastOrdersForReorderQuery(baseOptions: Apollo.QueryHookOptions<GetPastOrdersForReorderQuery, GetPastOrdersForReorderQueryVariables> & ({ variables: GetPastOrdersForReorderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPastOrdersForReorderQuery, GetPastOrdersForReorderQueryVariables>(GetPastOrdersForReorderDocument, options);
      }
export function useGetPastOrdersForReorderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPastOrdersForReorderQuery, GetPastOrdersForReorderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPastOrdersForReorderQuery, GetPastOrdersForReorderQueryVariables>(GetPastOrdersForReorderDocument, options);
        }
// @ts-ignore
export function useGetPastOrdersForReorderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPastOrdersForReorderQuery, GetPastOrdersForReorderQueryVariables>): Apollo.UseSuspenseQueryResult<GetPastOrdersForReorderQuery, GetPastOrdersForReorderQueryVariables>;
export function useGetPastOrdersForReorderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPastOrdersForReorderQuery, GetPastOrdersForReorderQueryVariables>): Apollo.UseSuspenseQueryResult<GetPastOrdersForReorderQuery | undefined, GetPastOrdersForReorderQueryVariables>;
export function useGetPastOrdersForReorderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPastOrdersForReorderQuery, GetPastOrdersForReorderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPastOrdersForReorderQuery, GetPastOrdersForReorderQueryVariables>(GetPastOrdersForReorderDocument, options);
        }
export type GetPastOrdersForReorderQueryHookResult = ReturnType<typeof useGetPastOrdersForReorderQuery>;
export type GetPastOrdersForReorderLazyQueryHookResult = ReturnType<typeof useGetPastOrdersForReorderLazyQuery>;
export type GetPastOrdersForReorderSuspenseQueryHookResult = ReturnType<typeof useGetPastOrdersForReorderSuspenseQuery>;
export type GetPastOrdersForReorderQueryResult = Apollo.QueryResult<GetPastOrdersForReorderQuery, GetPastOrdersForReorderQueryVariables>;
export const AddItemToBasketDocument = gql`
    mutation addItemToBasket($basketId: ID!, $itemPayload: BasketItemInput!, $isStandingOrderTemplate: Boolean, $editSessionId: ID) {
  basket: addItemToGmBasket(
    basketId: $basketId
    itemPayload: $itemPayload
    isStandingOrderTemplate: $isStandingOrderTemplate
    editSessionId: $editSessionId
  ) {
    ...Basket
  }
}
    ${BasketFragmentDoc}`;
export type AddItemToBasketMutationFn = Apollo.MutationFunction<AddItemToBasketMutation, AddItemToBasketMutationVariables>;

/**
 * __useAddItemToBasketMutation__
 *
 * To run a mutation, you first call `useAddItemToBasketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemToBasketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemToBasketMutation, { data, loading, error }] = useAddItemToBasketMutation({
 *   variables: {
 *      basketId: // value for 'basketId'
 *      itemPayload: // value for 'itemPayload'
 *      isStandingOrderTemplate: // value for 'isStandingOrderTemplate'
 *      editSessionId: // value for 'editSessionId'
 *   },
 * });
 */
export function useAddItemToBasketMutation(baseOptions?: Apollo.MutationHookOptions<AddItemToBasketMutation, AddItemToBasketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemToBasketMutation, AddItemToBasketMutationVariables>(AddItemToBasketDocument, options);
      }
export type AddItemToBasketMutationHookResult = ReturnType<typeof useAddItemToBasketMutation>;
export type AddItemToBasketMutationResult = Apollo.MutationResult<AddItemToBasketMutation>;
export type AddItemToBasketMutationOptions = Apollo.BaseMutationOptions<AddItemToBasketMutation, AddItemToBasketMutationVariables>;
export const CreateBasketDocument = gql`
    mutation createBasket($availabilityId: ID!, $basketPayload: CreateGmBasketInput!) {
  basket: createGmBasket(
    availabilityId: $availabilityId
    basketPayload: $basketPayload
  ) {
    ...Basket
  }
}
    ${BasketFragmentDoc}`;
export type CreateBasketMutationFn = Apollo.MutationFunction<CreateBasketMutation, CreateBasketMutationVariables>;

/**
 * __useCreateBasketMutation__
 *
 * To run a mutation, you first call `useCreateBasketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBasketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBasketMutation, { data, loading, error }] = useCreateBasketMutation({
 *   variables: {
 *      availabilityId: // value for 'availabilityId'
 *      basketPayload: // value for 'basketPayload'
 *   },
 * });
 */
export function useCreateBasketMutation(baseOptions?: Apollo.MutationHookOptions<CreateBasketMutation, CreateBasketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBasketMutation, CreateBasketMutationVariables>(CreateBasketDocument, options);
      }
export type CreateBasketMutationHookResult = ReturnType<typeof useCreateBasketMutation>;
export type CreateBasketMutationResult = Apollo.MutationResult<CreateBasketMutation>;
export type CreateBasketMutationOptions = Apollo.BaseMutationOptions<CreateBasketMutation, CreateBasketMutationVariables>;
export const GetBasketDocument = gql`
    query getBasket($id: ID!) {
  basket: gmBasket(id: $id) {
    ...Basket
  }
}
    ${BasketFragmentDoc}`;

/**
 * __useGetBasketQuery__
 *
 * To run a query within a React component, call `useGetBasketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBasketQuery(baseOptions: Apollo.QueryHookOptions<GetBasketQuery, GetBasketQueryVariables> & ({ variables: GetBasketQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasketQuery, GetBasketQueryVariables>(GetBasketDocument, options);
      }
export function useGetBasketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasketQuery, GetBasketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasketQuery, GetBasketQueryVariables>(GetBasketDocument, options);
        }
// @ts-ignore
export function useGetBasketSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBasketQuery, GetBasketQueryVariables>): Apollo.UseSuspenseQueryResult<GetBasketQuery, GetBasketQueryVariables>;
export function useGetBasketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBasketQuery, GetBasketQueryVariables>): Apollo.UseSuspenseQueryResult<GetBasketQuery | undefined, GetBasketQueryVariables>;
export function useGetBasketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBasketQuery, GetBasketQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBasketQuery, GetBasketQueryVariables>(GetBasketDocument, options);
        }
export type GetBasketQueryHookResult = ReturnType<typeof useGetBasketQuery>;
export type GetBasketLazyQueryHookResult = ReturnType<typeof useGetBasketLazyQuery>;
export type GetBasketSuspenseQueryHookResult = ReturnType<typeof useGetBasketSuspenseQuery>;
export type GetBasketQueryResult = Apollo.QueryResult<GetBasketQuery, GetBasketQueryVariables>;
export const GetStandingOrderDocument = gql`
    query getStandingOrder($standingOrderId: ID) {
  standingOrder(id: $standingOrderId) {
    _id
    ...GmMenuStandingOrderData
    standingOrderTemplate {
      ...Basket
    }
  }
}
    ${GmMenuStandingOrderDataFragmentDoc}
${BasketFragmentDoc}`;

/**
 * __useGetStandingOrderQuery__
 *
 * To run a query within a React component, call `useGetStandingOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandingOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandingOrderQuery({
 *   variables: {
 *      standingOrderId: // value for 'standingOrderId'
 *   },
 * });
 */
export function useGetStandingOrderQuery(baseOptions?: Apollo.QueryHookOptions<GetStandingOrderQuery, GetStandingOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandingOrderQuery, GetStandingOrderQueryVariables>(GetStandingOrderDocument, options);
      }
export function useGetStandingOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStandingOrderQuery, GetStandingOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandingOrderQuery, GetStandingOrderQueryVariables>(GetStandingOrderDocument, options);
        }
// @ts-ignore
export function useGetStandingOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStandingOrderQuery, GetStandingOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStandingOrderQuery, GetStandingOrderQueryVariables>;
export function useGetStandingOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStandingOrderQuery, GetStandingOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStandingOrderQuery | undefined, GetStandingOrderQueryVariables>;
export function useGetStandingOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStandingOrderQuery, GetStandingOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStandingOrderQuery, GetStandingOrderQueryVariables>(GetStandingOrderDocument, options);
        }
export type GetStandingOrderQueryHookResult = ReturnType<typeof useGetStandingOrderQuery>;
export type GetStandingOrderLazyQueryHookResult = ReturnType<typeof useGetStandingOrderLazyQuery>;
export type GetStandingOrderSuspenseQueryHookResult = ReturnType<typeof useGetStandingOrderSuspenseQuery>;
export type GetStandingOrderQueryResult = Apollo.QueryResult<GetStandingOrderQuery, GetStandingOrderQueryVariables>;
export const RemoveItemFromBasketDocument = gql`
    mutation removeItemFromBasket($basketId: ID!, $itemReference: String!, $isStandingOrderTemplate: Boolean, $editSessionId: ID) {
  basket: removeItemFromGmBasket(
    basketId: $basketId
    itemReference: $itemReference
    isStandingOrderTemplate: $isStandingOrderTemplate
    editSessionId: $editSessionId
  ) {
    ...Basket
  }
}
    ${BasketFragmentDoc}`;
export type RemoveItemFromBasketMutationFn = Apollo.MutationFunction<RemoveItemFromBasketMutation, RemoveItemFromBasketMutationVariables>;

/**
 * __useRemoveItemFromBasketMutation__
 *
 * To run a mutation, you first call `useRemoveItemFromBasketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemFromBasketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemFromBasketMutation, { data, loading, error }] = useRemoveItemFromBasketMutation({
 *   variables: {
 *      basketId: // value for 'basketId'
 *      itemReference: // value for 'itemReference'
 *      isStandingOrderTemplate: // value for 'isStandingOrderTemplate'
 *      editSessionId: // value for 'editSessionId'
 *   },
 * });
 */
export function useRemoveItemFromBasketMutation(baseOptions?: Apollo.MutationHookOptions<RemoveItemFromBasketMutation, RemoveItemFromBasketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveItemFromBasketMutation, RemoveItemFromBasketMutationVariables>(RemoveItemFromBasketDocument, options);
      }
export type RemoveItemFromBasketMutationHookResult = ReturnType<typeof useRemoveItemFromBasketMutation>;
export type RemoveItemFromBasketMutationResult = Apollo.MutationResult<RemoveItemFromBasketMutation>;
export type RemoveItemFromBasketMutationOptions = Apollo.BaseMutationOptions<RemoveItemFromBasketMutation, RemoveItemFromBasketMutationVariables>;
export const SaveStandingOrderChangesDocument = gql`
    mutation saveStandingOrderChanges($basketId: ID!, $editSessionId: ID!) {
  basket: applyEditSessionChangesToBasket(
    basketId: $basketId
    editSessionId: $editSessionId
  ) {
    ...Basket
  }
}
    ${BasketFragmentDoc}`;
export type SaveStandingOrderChangesMutationFn = Apollo.MutationFunction<SaveStandingOrderChangesMutation, SaveStandingOrderChangesMutationVariables>;

/**
 * __useSaveStandingOrderChangesMutation__
 *
 * To run a mutation, you first call `useSaveStandingOrderChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveStandingOrderChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveStandingOrderChangesMutation, { data, loading, error }] = useSaveStandingOrderChangesMutation({
 *   variables: {
 *      basketId: // value for 'basketId'
 *      editSessionId: // value for 'editSessionId'
 *   },
 * });
 */
export function useSaveStandingOrderChangesMutation(baseOptions?: Apollo.MutationHookOptions<SaveStandingOrderChangesMutation, SaveStandingOrderChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveStandingOrderChangesMutation, SaveStandingOrderChangesMutationVariables>(SaveStandingOrderChangesDocument, options);
      }
export type SaveStandingOrderChangesMutationHookResult = ReturnType<typeof useSaveStandingOrderChangesMutation>;
export type SaveStandingOrderChangesMutationResult = Apollo.MutationResult<SaveStandingOrderChangesMutation>;
export type SaveStandingOrderChangesMutationOptions = Apollo.BaseMutationOptions<SaveStandingOrderChangesMutation, SaveStandingOrderChangesMutationVariables>;
export const UpdateBasketDocument = gql`
    mutation updateBasket($basketId: ID!, $basketPayload: UpdateGmBasketInput!) {
  basket: updateGmBasket(basketId: $basketId, basketPayload: $basketPayload) {
    ...Basket
  }
}
    ${BasketFragmentDoc}`;
export type UpdateBasketMutationFn = Apollo.MutationFunction<UpdateBasketMutation, UpdateBasketMutationVariables>;

/**
 * __useUpdateBasketMutation__
 *
 * To run a mutation, you first call `useUpdateBasketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBasketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBasketMutation, { data, loading, error }] = useUpdateBasketMutation({
 *   variables: {
 *      basketId: // value for 'basketId'
 *      basketPayload: // value for 'basketPayload'
 *   },
 * });
 */
export function useUpdateBasketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBasketMutation, UpdateBasketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBasketMutation, UpdateBasketMutationVariables>(UpdateBasketDocument, options);
      }
export type UpdateBasketMutationHookResult = ReturnType<typeof useUpdateBasketMutation>;
export type UpdateBasketMutationResult = Apollo.MutationResult<UpdateBasketMutation>;
export type UpdateBasketMutationOptions = Apollo.BaseMutationOptions<UpdateBasketMutation, UpdateBasketMutationVariables>;
export const UpdateItemInBasketDocument = gql`
    mutation updateItemInBasket($basketId: ID!, $itemReference: String!, $itemPayload: UpdateBasketItemInput!, $isStandingOrderTemplate: Boolean, $editSessionId: ID) {
  basket: updateItemInGmBasket(
    basketId: $basketId
    itemReference: $itemReference
    itemPayload: $itemPayload
    isStandingOrderTemplate: $isStandingOrderTemplate
    editSessionId: $editSessionId
  ) {
    ...Basket
  }
}
    ${BasketFragmentDoc}`;
export type UpdateItemInBasketMutationFn = Apollo.MutationFunction<UpdateItemInBasketMutation, UpdateItemInBasketMutationVariables>;

/**
 * __useUpdateItemInBasketMutation__
 *
 * To run a mutation, you first call `useUpdateItemInBasketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemInBasketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemInBasketMutation, { data, loading, error }] = useUpdateItemInBasketMutation({
 *   variables: {
 *      basketId: // value for 'basketId'
 *      itemReference: // value for 'itemReference'
 *      itemPayload: // value for 'itemPayload'
 *      isStandingOrderTemplate: // value for 'isStandingOrderTemplate'
 *      editSessionId: // value for 'editSessionId'
 *   },
 * });
 */
export function useUpdateItemInBasketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemInBasketMutation, UpdateItemInBasketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemInBasketMutation, UpdateItemInBasketMutationVariables>(UpdateItemInBasketDocument, options);
      }
export type UpdateItemInBasketMutationHookResult = ReturnType<typeof useUpdateItemInBasketMutation>;
export type UpdateItemInBasketMutationResult = Apollo.MutationResult<UpdateItemInBasketMutation>;
export type UpdateItemInBasketMutationOptions = Apollo.BaseMutationOptions<UpdateItemInBasketMutation, UpdateItemInBasketMutationVariables>;
export const UpdateItemQtyInGmBasketDocument = gql`
    mutation updateItemQtyInGmBasket($basketId: ID!, $itemReference: String!, $qty: Int!, $isStandingOrderTemplate: Boolean, $editSessionId: ID) {
  basket: updateItemQtyInGmBasket(
    basketId: $basketId
    itemReference: $itemReference
    qty: $qty
    isStandingOrderTemplate: $isStandingOrderTemplate
    editSessionId: $editSessionId
  ) {
    ...Basket
  }
}
    ${BasketFragmentDoc}`;
export type UpdateItemQtyInGmBasketMutationFn = Apollo.MutationFunction<UpdateItemQtyInGmBasketMutation, UpdateItemQtyInGmBasketMutationVariables>;

/**
 * __useUpdateItemQtyInGmBasketMutation__
 *
 * To run a mutation, you first call `useUpdateItemQtyInGmBasketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemQtyInGmBasketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemQtyInGmBasketMutation, { data, loading, error }] = useUpdateItemQtyInGmBasketMutation({
 *   variables: {
 *      basketId: // value for 'basketId'
 *      itemReference: // value for 'itemReference'
 *      qty: // value for 'qty'
 *      isStandingOrderTemplate: // value for 'isStandingOrderTemplate'
 *      editSessionId: // value for 'editSessionId'
 *   },
 * });
 */
export function useUpdateItemQtyInGmBasketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemQtyInGmBasketMutation, UpdateItemQtyInGmBasketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemQtyInGmBasketMutation, UpdateItemQtyInGmBasketMutationVariables>(UpdateItemQtyInGmBasketDocument, options);
      }
export type UpdateItemQtyInGmBasketMutationHookResult = ReturnType<typeof useUpdateItemQtyInGmBasketMutation>;
export type UpdateItemQtyInGmBasketMutationResult = Apollo.MutationResult<UpdateItemQtyInGmBasketMutation>;
export type UpdateItemQtyInGmBasketMutationOptions = Apollo.BaseMutationOptions<UpdateItemQtyInGmBasketMutation, UpdateItemQtyInGmBasketMutationVariables>;
export const UpdateReferenceFieldInBasketDocument = gql`
    mutation UpdateReferenceFieldInBasket($basketId: ID!, $orderReferenceFieldId: Int!, $value: String!, $locale: String) {
  updateReferenceFieldInBasket(
    basketId: $basketId
    orderReferenceFieldId: $orderReferenceFieldId
    value: $value
    locale: $locale
  ) {
    ...CheckoutBasket
  }
}
    ${CheckoutBasketFragmentDoc}`;
export type UpdateReferenceFieldInBasketMutationFn = Apollo.MutationFunction<UpdateReferenceFieldInBasketMutation, UpdateReferenceFieldInBasketMutationVariables>;

/**
 * __useUpdateReferenceFieldInBasketMutation__
 *
 * To run a mutation, you first call `useUpdateReferenceFieldInBasketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferenceFieldInBasketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferenceFieldInBasketMutation, { data, loading, error }] = useUpdateReferenceFieldInBasketMutation({
 *   variables: {
 *      basketId: // value for 'basketId'
 *      orderReferenceFieldId: // value for 'orderReferenceFieldId'
 *      value: // value for 'value'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useUpdateReferenceFieldInBasketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReferenceFieldInBasketMutation, UpdateReferenceFieldInBasketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReferenceFieldInBasketMutation, UpdateReferenceFieldInBasketMutationVariables>(UpdateReferenceFieldInBasketDocument, options);
      }
export type UpdateReferenceFieldInBasketMutationHookResult = ReturnType<typeof useUpdateReferenceFieldInBasketMutation>;
export type UpdateReferenceFieldInBasketMutationResult = Apollo.MutationResult<UpdateReferenceFieldInBasketMutation>;
export type UpdateReferenceFieldInBasketMutationOptions = Apollo.BaseMutationOptions<UpdateReferenceFieldInBasketMutation, UpdateReferenceFieldInBasketMutationVariables>;
export const TrackCheckoutStartedDocument = gql`
    mutation TrackCheckoutStarted($basketId: ID!) {
  trackCheckoutStarted(basketId: $basketId)
}
    `;
export type TrackCheckoutStartedMutationFn = Apollo.MutationFunction<TrackCheckoutStartedMutation, TrackCheckoutStartedMutationVariables>;

/**
 * __useTrackCheckoutStartedMutation__
 *
 * To run a mutation, you first call `useTrackCheckoutStartedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackCheckoutStartedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackCheckoutStartedMutation, { data, loading, error }] = useTrackCheckoutStartedMutation({
 *   variables: {
 *      basketId: // value for 'basketId'
 *   },
 * });
 */
export function useTrackCheckoutStartedMutation(baseOptions?: Apollo.MutationHookOptions<TrackCheckoutStartedMutation, TrackCheckoutStartedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackCheckoutStartedMutation, TrackCheckoutStartedMutationVariables>(TrackCheckoutStartedDocument, options);
      }
export type TrackCheckoutStartedMutationHookResult = ReturnType<typeof useTrackCheckoutStartedMutation>;
export type TrackCheckoutStartedMutationResult = Apollo.MutationResult<TrackCheckoutStartedMutation>;
export type TrackCheckoutStartedMutationOptions = Apollo.BaseMutationOptions<TrackCheckoutStartedMutation, TrackCheckoutStartedMutationVariables>;
export const CreateFlexInvoiceDocument = gql`
    mutation CreateFlexInvoice($input: CreateFlexInvoiceInput!) {
  createFlexInvoice(input: $input)
}
    `;
export type CreateFlexInvoiceMutationFn = Apollo.MutationFunction<CreateFlexInvoiceMutation, CreateFlexInvoiceMutationVariables>;

/**
 * __useCreateFlexInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateFlexInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFlexInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFlexInvoiceMutation, { data, loading, error }] = useCreateFlexInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFlexInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateFlexInvoiceMutation, CreateFlexInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFlexInvoiceMutation, CreateFlexInvoiceMutationVariables>(CreateFlexInvoiceDocument, options);
      }
export type CreateFlexInvoiceMutationHookResult = ReturnType<typeof useCreateFlexInvoiceMutation>;
export type CreateFlexInvoiceMutationResult = Apollo.MutationResult<CreateFlexInvoiceMutation>;
export type CreateFlexInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateFlexInvoiceMutation, CreateFlexInvoiceMutationVariables>;
export const AccountsDocument = gql`
    query Accounts($input: AccountSearch!) {
  accounts(input: $input) {
    rows {
      id
      name
      notes
      locations(includeDeleted: false) {
        id
        label
        timezone
      }
      invoiceAccounts {
        id
        label
        flexDeferredCustomerId
        country
        vatRegionId
      }
    }
  }
}
    `;

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountsQuery(baseOptions: Apollo.QueryHookOptions<AccountsQuery, AccountsQueryVariables> & ({ variables: AccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
      }
export function useAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
        }
// @ts-ignore
export function useAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountsQuery, AccountsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountsQuery, AccountsQueryVariables>;
export function useAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountsQuery, AccountsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountsQuery | undefined, AccountsQueryVariables>;
export function useAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
        }
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<typeof useAccountsLazyQuery>;
export type AccountsSuspenseQueryHookResult = ReturnType<typeof useAccountsSuspenseQuery>;
export type AccountsQueryResult = Apollo.QueryResult<AccountsQuery, AccountsQueryVariables>;
export const InvoiceOrdersDocument = gql`
    query InvoiceOrders($input: InvoiceOrderInput) {
  invoiceOrders(input: $input) {
    items {
      id
      deliveryDate
      deliveryTimezone
      number
      contact
      supplier
      shippingAddress
      total
      budgetCode
      customerName
      referenceFields {
        label
        value
      }
    }
    pageInfo {
      count
      limit
      offset
    }
  }
}
    `;

/**
 * __useInvoiceOrdersQuery__
 *
 * To run a query within a React component, call `useInvoiceOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceOrdersQuery(baseOptions?: Apollo.QueryHookOptions<InvoiceOrdersQuery, InvoiceOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceOrdersQuery, InvoiceOrdersQueryVariables>(InvoiceOrdersDocument, options);
      }
export function useInvoiceOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceOrdersQuery, InvoiceOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceOrdersQuery, InvoiceOrdersQueryVariables>(InvoiceOrdersDocument, options);
        }
// @ts-ignore
export function useInvoiceOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceOrdersQuery, InvoiceOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<InvoiceOrdersQuery, InvoiceOrdersQueryVariables>;
export function useInvoiceOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoiceOrdersQuery, InvoiceOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<InvoiceOrdersQuery | undefined, InvoiceOrdersQueryVariables>;
export function useInvoiceOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoiceOrdersQuery, InvoiceOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoiceOrdersQuery, InvoiceOrdersQueryVariables>(InvoiceOrdersDocument, options);
        }
export type InvoiceOrdersQueryHookResult = ReturnType<typeof useInvoiceOrdersQuery>;
export type InvoiceOrdersLazyQueryHookResult = ReturnType<typeof useInvoiceOrdersLazyQuery>;
export type InvoiceOrdersSuspenseQueryHookResult = ReturnType<typeof useInvoiceOrdersSuspenseQuery>;
export type InvoiceOrdersQueryResult = Apollo.QueryResult<InvoiceOrdersQuery, InvoiceOrdersQueryVariables>;
export const CreateVendorFlexInvoiceDocument = gql`
    mutation CreateVendorFlexInvoice($input: CreateVendorFlexInvoiceInput!) {
  createVendorFlexInvoice(input: $input)
}
    `;
export type CreateVendorFlexInvoiceMutationFn = Apollo.MutationFunction<CreateVendorFlexInvoiceMutation, CreateVendorFlexInvoiceMutationVariables>;

/**
 * __useCreateVendorFlexInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateVendorFlexInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorFlexInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorFlexInvoiceMutation, { data, loading, error }] = useCreateVendorFlexInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVendorFlexInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateVendorFlexInvoiceMutation, CreateVendorFlexInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVendorFlexInvoiceMutation, CreateVendorFlexInvoiceMutationVariables>(CreateVendorFlexInvoiceDocument, options);
      }
export type CreateVendorFlexInvoiceMutationHookResult = ReturnType<typeof useCreateVendorFlexInvoiceMutation>;
export type CreateVendorFlexInvoiceMutationResult = Apollo.MutationResult<CreateVendorFlexInvoiceMutation>;
export type CreateVendorFlexInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateVendorFlexInvoiceMutation, CreateVendorFlexInvoiceMutationVariables>;
export const VendorInvoiceOrdersDocument = gql`
    query VendorInvoiceOrders($input: VendorInvoiceOrderInput) {
  vendorInvoiceOrders(input: $input) {
    items {
      id
      deliveryDate
      deliveryTimezone
      number
      contact
      total
      supplier
      shippingAddress
    }
    pageInfo {
      count
      limit
      offset
    }
  }
}
    `;

/**
 * __useVendorInvoiceOrdersQuery__
 *
 * To run a query within a React component, call `useVendorInvoiceOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorInvoiceOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorInvoiceOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVendorInvoiceOrdersQuery(baseOptions?: Apollo.QueryHookOptions<VendorInvoiceOrdersQuery, VendorInvoiceOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorInvoiceOrdersQuery, VendorInvoiceOrdersQueryVariables>(VendorInvoiceOrdersDocument, options);
      }
export function useVendorInvoiceOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorInvoiceOrdersQuery, VendorInvoiceOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorInvoiceOrdersQuery, VendorInvoiceOrdersQueryVariables>(VendorInvoiceOrdersDocument, options);
        }
// @ts-ignore
export function useVendorInvoiceOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VendorInvoiceOrdersQuery, VendorInvoiceOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<VendorInvoiceOrdersQuery, VendorInvoiceOrdersQueryVariables>;
export function useVendorInvoiceOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorInvoiceOrdersQuery, VendorInvoiceOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<VendorInvoiceOrdersQuery | undefined, VendorInvoiceOrdersQueryVariables>;
export function useVendorInvoiceOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorInvoiceOrdersQuery, VendorInvoiceOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VendorInvoiceOrdersQuery, VendorInvoiceOrdersQueryVariables>(VendorInvoiceOrdersDocument, options);
        }
export type VendorInvoiceOrdersQueryHookResult = ReturnType<typeof useVendorInvoiceOrdersQuery>;
export type VendorInvoiceOrdersLazyQueryHookResult = ReturnType<typeof useVendorInvoiceOrdersLazyQuery>;
export type VendorInvoiceOrdersSuspenseQueryHookResult = ReturnType<typeof useVendorInvoiceOrdersSuspenseQuery>;
export type VendorInvoiceOrdersQueryResult = Apollo.QueryResult<VendorInvoiceOrdersQuery, VendorInvoiceOrdersQueryVariables>;
export const SearchVendorsDocument = gql`
    query SearchVendors($name: String, $tenantId: String, $countryCode: String) {
  vendors(filters: {name: $name, tenantId: $tenantId, countryCode: $countryCode}) {
    rows {
      id
      companyName
      locations {
        id
        label
        country
      }
    }
  }
}
    `;

/**
 * __useSearchVendorsQuery__
 *
 * To run a query within a React component, call `useSearchVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVendorsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      tenantId: // value for 'tenantId'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useSearchVendorsQuery(baseOptions?: Apollo.QueryHookOptions<SearchVendorsQuery, SearchVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchVendorsQuery, SearchVendorsQueryVariables>(SearchVendorsDocument, options);
      }
export function useSearchVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchVendorsQuery, SearchVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchVendorsQuery, SearchVendorsQueryVariables>(SearchVendorsDocument, options);
        }
// @ts-ignore
export function useSearchVendorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchVendorsQuery, SearchVendorsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchVendorsQuery, SearchVendorsQueryVariables>;
export function useSearchVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchVendorsQuery, SearchVendorsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchVendorsQuery | undefined, SearchVendorsQueryVariables>;
export function useSearchVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchVendorsQuery, SearchVendorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchVendorsQuery, SearchVendorsQueryVariables>(SearchVendorsDocument, options);
        }
export type SearchVendorsQueryHookResult = ReturnType<typeof useSearchVendorsQuery>;
export type SearchVendorsLazyQueryHookResult = ReturnType<typeof useSearchVendorsLazyQuery>;
export type SearchVendorsSuspenseQueryHookResult = ReturnType<typeof useSearchVendorsSuspenseQuery>;
export type SearchVendorsQueryResult = Apollo.QueryResult<SearchVendorsQuery, SearchVendorsQueryVariables>;
export const GetVendorWithFlexFinanceSettingsDocument = gql`
    query GetVendorWithFlexFinanceSettings($id: ID!) {
  vendor(id: $id) {
    id
    companyName
    flexFinanceSettings {
      flexDeferredSupplierId
    }
  }
}
    `;

/**
 * __useGetVendorWithFlexFinanceSettingsQuery__
 *
 * To run a query within a React component, call `useGetVendorWithFlexFinanceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorWithFlexFinanceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorWithFlexFinanceSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVendorWithFlexFinanceSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetVendorWithFlexFinanceSettingsQuery, GetVendorWithFlexFinanceSettingsQueryVariables> & ({ variables: GetVendorWithFlexFinanceSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorWithFlexFinanceSettingsQuery, GetVendorWithFlexFinanceSettingsQueryVariables>(GetVendorWithFlexFinanceSettingsDocument, options);
      }
export function useGetVendorWithFlexFinanceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorWithFlexFinanceSettingsQuery, GetVendorWithFlexFinanceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorWithFlexFinanceSettingsQuery, GetVendorWithFlexFinanceSettingsQueryVariables>(GetVendorWithFlexFinanceSettingsDocument, options);
        }
// @ts-ignore
export function useGetVendorWithFlexFinanceSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorWithFlexFinanceSettingsQuery, GetVendorWithFlexFinanceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorWithFlexFinanceSettingsQuery, GetVendorWithFlexFinanceSettingsQueryVariables>;
export function useGetVendorWithFlexFinanceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorWithFlexFinanceSettingsQuery, GetVendorWithFlexFinanceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorWithFlexFinanceSettingsQuery | undefined, GetVendorWithFlexFinanceSettingsQueryVariables>;
export function useGetVendorWithFlexFinanceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorWithFlexFinanceSettingsQuery, GetVendorWithFlexFinanceSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorWithFlexFinanceSettingsQuery, GetVendorWithFlexFinanceSettingsQueryVariables>(GetVendorWithFlexFinanceSettingsDocument, options);
        }
export type GetVendorWithFlexFinanceSettingsQueryHookResult = ReturnType<typeof useGetVendorWithFlexFinanceSettingsQuery>;
export type GetVendorWithFlexFinanceSettingsLazyQueryHookResult = ReturnType<typeof useGetVendorWithFlexFinanceSettingsLazyQuery>;
export type GetVendorWithFlexFinanceSettingsSuspenseQueryHookResult = ReturnType<typeof useGetVendorWithFlexFinanceSettingsSuspenseQuery>;
export type GetVendorWithFlexFinanceSettingsQueryResult = Apollo.QueryResult<GetVendorWithFlexFinanceSettingsQuery, GetVendorWithFlexFinanceSettingsQueryVariables>;
export const CheckForGeneratedCcInvoiceDocument = gql`
    query CheckForGeneratedCcInvoice($invoiceId: ID!) {
  invoice(id: $invoiceId) {
    id
  }
}
    `;

/**
 * __useCheckForGeneratedCcInvoiceQuery__
 *
 * To run a query within a React component, call `useCheckForGeneratedCcInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckForGeneratedCcInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckForGeneratedCcInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useCheckForGeneratedCcInvoiceQuery(baseOptions: Apollo.QueryHookOptions<CheckForGeneratedCcInvoiceQuery, CheckForGeneratedCcInvoiceQueryVariables> & ({ variables: CheckForGeneratedCcInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckForGeneratedCcInvoiceQuery, CheckForGeneratedCcInvoiceQueryVariables>(CheckForGeneratedCcInvoiceDocument, options);
      }
export function useCheckForGeneratedCcInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckForGeneratedCcInvoiceQuery, CheckForGeneratedCcInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckForGeneratedCcInvoiceQuery, CheckForGeneratedCcInvoiceQueryVariables>(CheckForGeneratedCcInvoiceDocument, options);
        }
// @ts-ignore
export function useCheckForGeneratedCcInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckForGeneratedCcInvoiceQuery, CheckForGeneratedCcInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<CheckForGeneratedCcInvoiceQuery, CheckForGeneratedCcInvoiceQueryVariables>;
export function useCheckForGeneratedCcInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckForGeneratedCcInvoiceQuery, CheckForGeneratedCcInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<CheckForGeneratedCcInvoiceQuery | undefined, CheckForGeneratedCcInvoiceQueryVariables>;
export function useCheckForGeneratedCcInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckForGeneratedCcInvoiceQuery, CheckForGeneratedCcInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckForGeneratedCcInvoiceQuery, CheckForGeneratedCcInvoiceQueryVariables>(CheckForGeneratedCcInvoiceDocument, options);
        }
export type CheckForGeneratedCcInvoiceQueryHookResult = ReturnType<typeof useCheckForGeneratedCcInvoiceQuery>;
export type CheckForGeneratedCcInvoiceLazyQueryHookResult = ReturnType<typeof useCheckForGeneratedCcInvoiceLazyQuery>;
export type CheckForGeneratedCcInvoiceSuspenseQueryHookResult = ReturnType<typeof useCheckForGeneratedCcInvoiceSuspenseQuery>;
export type CheckForGeneratedCcInvoiceQueryResult = Apollo.QueryResult<CheckForGeneratedCcInvoiceQuery, CheckForGeneratedCcInvoiceQueryVariables>;
export const CheckForGeneratedVendorStatementDocument = gql`
    query CheckForGeneratedVendorStatement($statementId: ID!) {
  vendorStatement(id: $statementId) {
    id
  }
}
    `;

/**
 * __useCheckForGeneratedVendorStatementQuery__
 *
 * To run a query within a React component, call `useCheckForGeneratedVendorStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckForGeneratedVendorStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckForGeneratedVendorStatementQuery({
 *   variables: {
 *      statementId: // value for 'statementId'
 *   },
 * });
 */
export function useCheckForGeneratedVendorStatementQuery(baseOptions: Apollo.QueryHookOptions<CheckForGeneratedVendorStatementQuery, CheckForGeneratedVendorStatementQueryVariables> & ({ variables: CheckForGeneratedVendorStatementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckForGeneratedVendorStatementQuery, CheckForGeneratedVendorStatementQueryVariables>(CheckForGeneratedVendorStatementDocument, options);
      }
export function useCheckForGeneratedVendorStatementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckForGeneratedVendorStatementQuery, CheckForGeneratedVendorStatementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckForGeneratedVendorStatementQuery, CheckForGeneratedVendorStatementQueryVariables>(CheckForGeneratedVendorStatementDocument, options);
        }
// @ts-ignore
export function useCheckForGeneratedVendorStatementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckForGeneratedVendorStatementQuery, CheckForGeneratedVendorStatementQueryVariables>): Apollo.UseSuspenseQueryResult<CheckForGeneratedVendorStatementQuery, CheckForGeneratedVendorStatementQueryVariables>;
export function useCheckForGeneratedVendorStatementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckForGeneratedVendorStatementQuery, CheckForGeneratedVendorStatementQueryVariables>): Apollo.UseSuspenseQueryResult<CheckForGeneratedVendorStatementQuery | undefined, CheckForGeneratedVendorStatementQueryVariables>;
export function useCheckForGeneratedVendorStatementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckForGeneratedVendorStatementQuery, CheckForGeneratedVendorStatementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckForGeneratedVendorStatementQuery, CheckForGeneratedVendorStatementQueryVariables>(CheckForGeneratedVendorStatementDocument, options);
        }
export type CheckForGeneratedVendorStatementQueryHookResult = ReturnType<typeof useCheckForGeneratedVendorStatementQuery>;
export type CheckForGeneratedVendorStatementLazyQueryHookResult = ReturnType<typeof useCheckForGeneratedVendorStatementLazyQuery>;
export type CheckForGeneratedVendorStatementSuspenseQueryHookResult = ReturnType<typeof useCheckForGeneratedVendorStatementSuspenseQuery>;
export type CheckForGeneratedVendorStatementQueryResult = Apollo.QueryResult<CheckForGeneratedVendorStatementQuery, CheckForGeneratedVendorStatementQueryVariables>;
export const GetInvoicePdfDocument = gql`
    query GetInvoicePDF($invoiceId: ID!) {
  invoice(id: $invoiceId) {
    id
    type
    overviewPdf: asset(input: {type: "overview"}) {
      type
      url
    }
    detailedPdf: asset(input: {type: "detailed"}) {
      type
      url
    }
    csv: asset(input: {type: "csv"}) {
      type
      url
    }
  }
}
    `;

/**
 * __useGetInvoicePdfQuery__
 *
 * To run a query within a React component, call `useGetInvoicePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePdfQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoicePdfQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePdfQuery, GetInvoicePdfQueryVariables> & ({ variables: GetInvoicePdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>(GetInvoicePdfDocument, options);
      }
export function useGetInvoicePdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>(GetInvoicePdfDocument, options);
        }
// @ts-ignore
export function useGetInvoicePdfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>;
export function useGetInvoicePdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoicePdfQuery | undefined, GetInvoicePdfQueryVariables>;
export function useGetInvoicePdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>(GetInvoicePdfDocument, options);
        }
export type GetInvoicePdfQueryHookResult = ReturnType<typeof useGetInvoicePdfQuery>;
export type GetInvoicePdfLazyQueryHookResult = ReturnType<typeof useGetInvoicePdfLazyQuery>;
export type GetInvoicePdfSuspenseQueryHookResult = ReturnType<typeof useGetInvoicePdfSuspenseQuery>;
export type GetInvoicePdfQueryResult = Apollo.QueryResult<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>;
export const GetVendorStatementPdfDocument = gql`
    query GetVendorStatementPDF($vendorStatementId: ID!) {
  vendorStatement(id: $vendorStatementId) {
    id
    overviewPdf: asset(input: {type: "overview"}) {
      type
      url
    }
    detailedPdf: asset(input: {type: "detailed"}) {
      type
      url
    }
  }
}
    `;

/**
 * __useGetVendorStatementPdfQuery__
 *
 * To run a query within a React component, call `useGetVendorStatementPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorStatementPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorStatementPdfQuery({
 *   variables: {
 *      vendorStatementId: // value for 'vendorStatementId'
 *   },
 * });
 */
export function useGetVendorStatementPdfQuery(baseOptions: Apollo.QueryHookOptions<GetVendorStatementPdfQuery, GetVendorStatementPdfQueryVariables> & ({ variables: GetVendorStatementPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorStatementPdfQuery, GetVendorStatementPdfQueryVariables>(GetVendorStatementPdfDocument, options);
      }
export function useGetVendorStatementPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorStatementPdfQuery, GetVendorStatementPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorStatementPdfQuery, GetVendorStatementPdfQueryVariables>(GetVendorStatementPdfDocument, options);
        }
// @ts-ignore
export function useGetVendorStatementPdfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorStatementPdfQuery, GetVendorStatementPdfQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorStatementPdfQuery, GetVendorStatementPdfQueryVariables>;
export function useGetVendorStatementPdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorStatementPdfQuery, GetVendorStatementPdfQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorStatementPdfQuery | undefined, GetVendorStatementPdfQueryVariables>;
export function useGetVendorStatementPdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorStatementPdfQuery, GetVendorStatementPdfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorStatementPdfQuery, GetVendorStatementPdfQueryVariables>(GetVendorStatementPdfDocument, options);
        }
export type GetVendorStatementPdfQueryHookResult = ReturnType<typeof useGetVendorStatementPdfQuery>;
export type GetVendorStatementPdfLazyQueryHookResult = ReturnType<typeof useGetVendorStatementPdfLazyQuery>;
export type GetVendorStatementPdfSuspenseQueryHookResult = ReturnType<typeof useGetVendorStatementPdfSuspenseQuery>;
export type GetVendorStatementPdfQueryResult = Apollo.QueryResult<GetVendorStatementPdfQuery, GetVendorStatementPdfQueryVariables>;
export const GetCcInvoiceDocument = gql`
    query GetCCInvoice($invoiceId: ID!, $supplierOrderBreakdownLimit: Int!, $supplierOrderBreakdownOffset: Int!, $additionalItemsLimit: Int!, $additionalItemsOffset: Int!) {
  invoice(id: $invoiceId) {
    ...CcInvoice
  }
}
    ${CcInvoiceFragmentDoc}`;

/**
 * __useGetCcInvoiceQuery__
 *
 * To run a query within a React component, call `useGetCcInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCcInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCcInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      supplierOrderBreakdownLimit: // value for 'supplierOrderBreakdownLimit'
 *      supplierOrderBreakdownOffset: // value for 'supplierOrderBreakdownOffset'
 *      additionalItemsLimit: // value for 'additionalItemsLimit'
 *      additionalItemsOffset: // value for 'additionalItemsOffset'
 *   },
 * });
 */
export function useGetCcInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetCcInvoiceQuery, GetCcInvoiceQueryVariables> & ({ variables: GetCcInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCcInvoiceQuery, GetCcInvoiceQueryVariables>(GetCcInvoiceDocument, options);
      }
export function useGetCcInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCcInvoiceQuery, GetCcInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCcInvoiceQuery, GetCcInvoiceQueryVariables>(GetCcInvoiceDocument, options);
        }
// @ts-ignore
export function useGetCcInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCcInvoiceQuery, GetCcInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<GetCcInvoiceQuery, GetCcInvoiceQueryVariables>;
export function useGetCcInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCcInvoiceQuery, GetCcInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<GetCcInvoiceQuery | undefined, GetCcInvoiceQueryVariables>;
export function useGetCcInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCcInvoiceQuery, GetCcInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCcInvoiceQuery, GetCcInvoiceQueryVariables>(GetCcInvoiceDocument, options);
        }
export type GetCcInvoiceQueryHookResult = ReturnType<typeof useGetCcInvoiceQuery>;
export type GetCcInvoiceLazyQueryHookResult = ReturnType<typeof useGetCcInvoiceLazyQuery>;
export type GetCcInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetCcInvoiceSuspenseQuery>;
export type GetCcInvoiceQueryResult = Apollo.QueryResult<GetCcInvoiceQuery, GetCcInvoiceQueryVariables>;
export const RemoveInvoiceItemDocument = gql`
    mutation RemoveInvoiceItem($invoiceItemId: ID!) {
  removeInvoiceItem(id: $invoiceItemId)
}
    `;
export type RemoveInvoiceItemMutationFn = Apollo.MutationFunction<RemoveInvoiceItemMutation, RemoveInvoiceItemMutationVariables>;

/**
 * __useRemoveInvoiceItemMutation__
 *
 * To run a mutation, you first call `useRemoveInvoiceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInvoiceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInvoiceItemMutation, { data, loading, error }] = useRemoveInvoiceItemMutation({
 *   variables: {
 *      invoiceItemId: // value for 'invoiceItemId'
 *   },
 * });
 */
export function useRemoveInvoiceItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInvoiceItemMutation, RemoveInvoiceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInvoiceItemMutation, RemoveInvoiceItemMutationVariables>(RemoveInvoiceItemDocument, options);
      }
export type RemoveInvoiceItemMutationHookResult = ReturnType<typeof useRemoveInvoiceItemMutation>;
export type RemoveInvoiceItemMutationResult = Apollo.MutationResult<RemoveInvoiceItemMutation>;
export type RemoveInvoiceItemMutationOptions = Apollo.BaseMutationOptions<RemoveInvoiceItemMutation, RemoveInvoiceItemMutationVariables>;
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($id: ID!, $input: UpdateInvoiceInput!) {
  updateInvoice(id: $id, input: $input) {
    id
    dueDate
    budgetCode
    billingDetails {
      address {
        line1
        line2
        city
        postcode
        country
      }
      contact {
        firstName
        lastName
        email
      }
    }
  }
}
    `;
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
      }
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const AddInvoiceItemDocument = gql`
    mutation AddInvoiceItem($invoiceId: ID!, $input: InvoiceItemInput!) {
  addInvoiceItem(invoiceId: $invoiceId, input: $input) {
    date
    description
    quantity
    unitPrice
    vatRate
  }
}
    `;
export type AddInvoiceItemMutationFn = Apollo.MutationFunction<AddInvoiceItemMutation, AddInvoiceItemMutationVariables>;

/**
 * __useAddInvoiceItemMutation__
 *
 * To run a mutation, you first call `useAddInvoiceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInvoiceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInvoiceItemMutation, { data, loading, error }] = useAddInvoiceItemMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInvoiceItemMutation(baseOptions?: Apollo.MutationHookOptions<AddInvoiceItemMutation, AddInvoiceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInvoiceItemMutation, AddInvoiceItemMutationVariables>(AddInvoiceItemDocument, options);
      }
export type AddInvoiceItemMutationHookResult = ReturnType<typeof useAddInvoiceItemMutation>;
export type AddInvoiceItemMutationResult = Apollo.MutationResult<AddInvoiceItemMutation>;
export type AddInvoiceItemMutationOptions = Apollo.BaseMutationOptions<AddInvoiceItemMutation, AddInvoiceItemMutationVariables>;
export const GetGmInvoiceDocument = gql`
    query GetGMInvoice($invoiceId: ID!, $supplierOrderBreakdownLimit: Int!, $supplierOrderBreakdownOffset: Int!, $checkDelivery: Boolean) {
  invoice(id: $invoiceId) {
    ...GmInvoice
  }
}
    ${GmInvoiceFragmentDoc}`;

/**
 * __useGetGmInvoiceQuery__
 *
 * To run a query within a React component, call `useGetGmInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGmInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGmInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      supplierOrderBreakdownLimit: // value for 'supplierOrderBreakdownLimit'
 *      supplierOrderBreakdownOffset: // value for 'supplierOrderBreakdownOffset'
 *      checkDelivery: // value for 'checkDelivery'
 *   },
 * });
 */
export function useGetGmInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetGmInvoiceQuery, GetGmInvoiceQueryVariables> & ({ variables: GetGmInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGmInvoiceQuery, GetGmInvoiceQueryVariables>(GetGmInvoiceDocument, options);
      }
export function useGetGmInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGmInvoiceQuery, GetGmInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGmInvoiceQuery, GetGmInvoiceQueryVariables>(GetGmInvoiceDocument, options);
        }
// @ts-ignore
export function useGetGmInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGmInvoiceQuery, GetGmInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<GetGmInvoiceQuery, GetGmInvoiceQueryVariables>;
export function useGetGmInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGmInvoiceQuery, GetGmInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<GetGmInvoiceQuery | undefined, GetGmInvoiceQueryVariables>;
export function useGetGmInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGmInvoiceQuery, GetGmInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGmInvoiceQuery, GetGmInvoiceQueryVariables>(GetGmInvoiceDocument, options);
        }
export type GetGmInvoiceQueryHookResult = ReturnType<typeof useGetGmInvoiceQuery>;
export type GetGmInvoiceLazyQueryHookResult = ReturnType<typeof useGetGmInvoiceLazyQuery>;
export type GetGmInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetGmInvoiceSuspenseQuery>;
export type GetGmInvoiceQueryResult = Apollo.QueryResult<GetGmInvoiceQuery, GetGmInvoiceQueryVariables>;
export const GetVendorStatementDocument = gql`
    query GetVendorStatement($id: ID!, $appArea: AppArea = admin, $withOrderBreakdownItems: Boolean = false, $withCustomerBillingDetails: Boolean = false, $withTaxInvoiceId: Boolean = false, $withOrderHref: Boolean = false) {
  vendorStatement(id: $id) {
    ...VendorStatementSingle
  }
}
    ${VendorStatementSingleFragmentDoc}`;

/**
 * __useGetVendorStatementQuery__
 *
 * To run a query within a React component, call `useGetVendorStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorStatementQuery({
 *   variables: {
 *      id: // value for 'id'
 *      appArea: // value for 'appArea'
 *      withOrderBreakdownItems: // value for 'withOrderBreakdownItems'
 *      withCustomerBillingDetails: // value for 'withCustomerBillingDetails'
 *      withTaxInvoiceId: // value for 'withTaxInvoiceId'
 *      withOrderHref: // value for 'withOrderHref'
 *   },
 * });
 */
export function useGetVendorStatementQuery(baseOptions: Apollo.QueryHookOptions<GetVendorStatementQuery, GetVendorStatementQueryVariables> & ({ variables: GetVendorStatementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorStatementQuery, GetVendorStatementQueryVariables>(GetVendorStatementDocument, options);
      }
export function useGetVendorStatementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorStatementQuery, GetVendorStatementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorStatementQuery, GetVendorStatementQueryVariables>(GetVendorStatementDocument, options);
        }
// @ts-ignore
export function useGetVendorStatementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorStatementQuery, GetVendorStatementQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorStatementQuery, GetVendorStatementQueryVariables>;
export function useGetVendorStatementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorStatementQuery, GetVendorStatementQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorStatementQuery | undefined, GetVendorStatementQueryVariables>;
export function useGetVendorStatementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorStatementQuery, GetVendorStatementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorStatementQuery, GetVendorStatementQueryVariables>(GetVendorStatementDocument, options);
        }
export type GetVendorStatementQueryHookResult = ReturnType<typeof useGetVendorStatementQuery>;
export type GetVendorStatementLazyQueryHookResult = ReturnType<typeof useGetVendorStatementLazyQuery>;
export type GetVendorStatementSuspenseQueryHookResult = ReturnType<typeof useGetVendorStatementSuspenseQuery>;
export type GetVendorStatementQueryResult = Apollo.QueryResult<GetVendorStatementQuery, GetVendorStatementQueryVariables>;
export const AddVendorStatementItemDocument = gql`
    mutation AddVendorStatementItem($vendorStatementId: ID!, $input: InvoiceItemInput!) {
  addVendorStatementItem(vendorStatementId: $vendorStatementId, input: $input) {
    date
    description
    quantity
    unitPrice
    vatRate
  }
}
    `;
export type AddVendorStatementItemMutationFn = Apollo.MutationFunction<AddVendorStatementItemMutation, AddVendorStatementItemMutationVariables>;

/**
 * __useAddVendorStatementItemMutation__
 *
 * To run a mutation, you first call `useAddVendorStatementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVendorStatementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVendorStatementItemMutation, { data, loading, error }] = useAddVendorStatementItemMutation({
 *   variables: {
 *      vendorStatementId: // value for 'vendorStatementId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVendorStatementItemMutation(baseOptions?: Apollo.MutationHookOptions<AddVendorStatementItemMutation, AddVendorStatementItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVendorStatementItemMutation, AddVendorStatementItemMutationVariables>(AddVendorStatementItemDocument, options);
      }
export type AddVendorStatementItemMutationHookResult = ReturnType<typeof useAddVendorStatementItemMutation>;
export type AddVendorStatementItemMutationResult = Apollo.MutationResult<AddVendorStatementItemMutation>;
export type AddVendorStatementItemMutationOptions = Apollo.BaseMutationOptions<AddVendorStatementItemMutation, AddVendorStatementItemMutationVariables>;
export const RemoveVendorStatementItemDocument = gql`
    mutation RemoveVendorStatementItem($itemId: ID!) {
  removeVendorStatementItem(id: $itemId)
}
    `;
export type RemoveVendorStatementItemMutationFn = Apollo.MutationFunction<RemoveVendorStatementItemMutation, RemoveVendorStatementItemMutationVariables>;

/**
 * __useRemoveVendorStatementItemMutation__
 *
 * To run a mutation, you first call `useRemoveVendorStatementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVendorStatementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVendorStatementItemMutation, { data, loading, error }] = useRemoveVendorStatementItemMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useRemoveVendorStatementItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveVendorStatementItemMutation, RemoveVendorStatementItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveVendorStatementItemMutation, RemoveVendorStatementItemMutationVariables>(RemoveVendorStatementItemDocument, options);
      }
export type RemoveVendorStatementItemMutationHookResult = ReturnType<typeof useRemoveVendorStatementItemMutation>;
export type RemoveVendorStatementItemMutationResult = Apollo.MutationResult<RemoveVendorStatementItemMutation>;
export type RemoveVendorStatementItemMutationOptions = Apollo.BaseMutationOptions<RemoveVendorStatementItemMutation, RemoveVendorStatementItemMutationVariables>;
export const AuthDocument = gql`
    query auth {
  me {
    id
    isAdmin
    isUser
    isVendor
    role
    account {
      id
    }
  }
}
    `;

/**
 * __useAuthQuery__
 *
 * To run a query within a React component, call `useAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthQuery(baseOptions?: Apollo.QueryHookOptions<AuthQuery, AuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthQuery, AuthQueryVariables>(AuthDocument, options);
      }
export function useAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthQuery, AuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthQuery, AuthQueryVariables>(AuthDocument, options);
        }
// @ts-ignore
export function useAuthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthQuery, AuthQueryVariables>): Apollo.UseSuspenseQueryResult<AuthQuery, AuthQueryVariables>;
export function useAuthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthQuery, AuthQueryVariables>): Apollo.UseSuspenseQueryResult<AuthQuery | undefined, AuthQueryVariables>;
export function useAuthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthQuery, AuthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthQuery, AuthQueryVariables>(AuthDocument, options);
        }
export type AuthQueryHookResult = ReturnType<typeof useAuthQuery>;
export type AuthLazyQueryHookResult = ReturnType<typeof useAuthLazyQuery>;
export type AuthSuspenseQueryHookResult = ReturnType<typeof useAuthSuspenseQuery>;
export type AuthQueryResult = Apollo.QueryResult<AuthQuery, AuthQueryVariables>;
export const GetFinanceSettingsForAccountDocument = gql`
    query getFinanceSettingsForAccount($accountId: ID!) {
  account(id: $accountId) {
    isCCActive
    currency
    financeSettings {
      allowMinTopUpCc
      budgetCodeCc
      budgetCodeGm
      contractDateFrom
      contractDateTo
      deliverySurchargeCc
      invoicingFormatGm
      minOrderValueCc
      minPlatformFeeCc
      minPlatformFeeGm
      orderValPercentPlatformFeeCc
      orderValPercentPlatformFeeGm
      paymentDueDaysAfterInvoice
      isBudgetCodeMandatory
      additionalBillingNotes
      minPlatformFeeCcMonthlyExTax
    }
  }
}
    `;

/**
 * __useGetFinanceSettingsForAccountQuery__
 *
 * To run a query within a React component, call `useGetFinanceSettingsForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinanceSettingsForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinanceSettingsForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetFinanceSettingsForAccountQuery(baseOptions: Apollo.QueryHookOptions<GetFinanceSettingsForAccountQuery, GetFinanceSettingsForAccountQueryVariables> & ({ variables: GetFinanceSettingsForAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinanceSettingsForAccountQuery, GetFinanceSettingsForAccountQueryVariables>(GetFinanceSettingsForAccountDocument, options);
      }
export function useGetFinanceSettingsForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinanceSettingsForAccountQuery, GetFinanceSettingsForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinanceSettingsForAccountQuery, GetFinanceSettingsForAccountQueryVariables>(GetFinanceSettingsForAccountDocument, options);
        }
// @ts-ignore
export function useGetFinanceSettingsForAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFinanceSettingsForAccountQuery, GetFinanceSettingsForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetFinanceSettingsForAccountQuery, GetFinanceSettingsForAccountQueryVariables>;
export function useGetFinanceSettingsForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFinanceSettingsForAccountQuery, GetFinanceSettingsForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetFinanceSettingsForAccountQuery | undefined, GetFinanceSettingsForAccountQueryVariables>;
export function useGetFinanceSettingsForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFinanceSettingsForAccountQuery, GetFinanceSettingsForAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFinanceSettingsForAccountQuery, GetFinanceSettingsForAccountQueryVariables>(GetFinanceSettingsForAccountDocument, options);
        }
export type GetFinanceSettingsForAccountQueryHookResult = ReturnType<typeof useGetFinanceSettingsForAccountQuery>;
export type GetFinanceSettingsForAccountLazyQueryHookResult = ReturnType<typeof useGetFinanceSettingsForAccountLazyQuery>;
export type GetFinanceSettingsForAccountSuspenseQueryHookResult = ReturnType<typeof useGetFinanceSettingsForAccountSuspenseQuery>;
export type GetFinanceSettingsForAccountQueryResult = Apollo.QueryResult<GetFinanceSettingsForAccountQuery, GetFinanceSettingsForAccountQueryVariables>;
export const GetGmBasketsForAccountDashboardCalendarDocument = gql`
    query getGmBasketsForAccountDashboardCalendar($limit: Int, $offset: Int, $filters: GmBasketFiltersInput) {
  me {
    account {
      gmBaskets(limit: $limit, offset: $offset, filters: $filters) {
        rows {
          ...AccountDashboardCalendarGmBasket
        }
        pageInfo {
          count
        }
      }
    }
  }
}
    ${AccountDashboardCalendarGmBasketFragmentDoc}`;

/**
 * __useGetGmBasketsForAccountDashboardCalendarQuery__
 *
 * To run a query within a React component, call `useGetGmBasketsForAccountDashboardCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGmBasketsForAccountDashboardCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGmBasketsForAccountDashboardCalendarQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetGmBasketsForAccountDashboardCalendarQuery(baseOptions?: Apollo.QueryHookOptions<GetGmBasketsForAccountDashboardCalendarQuery, GetGmBasketsForAccountDashboardCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGmBasketsForAccountDashboardCalendarQuery, GetGmBasketsForAccountDashboardCalendarQueryVariables>(GetGmBasketsForAccountDashboardCalendarDocument, options);
      }
export function useGetGmBasketsForAccountDashboardCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGmBasketsForAccountDashboardCalendarQuery, GetGmBasketsForAccountDashboardCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGmBasketsForAccountDashboardCalendarQuery, GetGmBasketsForAccountDashboardCalendarQueryVariables>(GetGmBasketsForAccountDashboardCalendarDocument, options);
        }
// @ts-ignore
export function useGetGmBasketsForAccountDashboardCalendarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGmBasketsForAccountDashboardCalendarQuery, GetGmBasketsForAccountDashboardCalendarQueryVariables>): Apollo.UseSuspenseQueryResult<GetGmBasketsForAccountDashboardCalendarQuery, GetGmBasketsForAccountDashboardCalendarQueryVariables>;
export function useGetGmBasketsForAccountDashboardCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGmBasketsForAccountDashboardCalendarQuery, GetGmBasketsForAccountDashboardCalendarQueryVariables>): Apollo.UseSuspenseQueryResult<GetGmBasketsForAccountDashboardCalendarQuery | undefined, GetGmBasketsForAccountDashboardCalendarQueryVariables>;
export function useGetGmBasketsForAccountDashboardCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGmBasketsForAccountDashboardCalendarQuery, GetGmBasketsForAccountDashboardCalendarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGmBasketsForAccountDashboardCalendarQuery, GetGmBasketsForAccountDashboardCalendarQueryVariables>(GetGmBasketsForAccountDashboardCalendarDocument, options);
        }
export type GetGmBasketsForAccountDashboardCalendarQueryHookResult = ReturnType<typeof useGetGmBasketsForAccountDashboardCalendarQuery>;
export type GetGmBasketsForAccountDashboardCalendarLazyQueryHookResult = ReturnType<typeof useGetGmBasketsForAccountDashboardCalendarLazyQuery>;
export type GetGmBasketsForAccountDashboardCalendarSuspenseQueryHookResult = ReturnType<typeof useGetGmBasketsForAccountDashboardCalendarSuspenseQuery>;
export type GetGmBasketsForAccountDashboardCalendarQueryResult = Apollo.QueryResult<GetGmBasketsForAccountDashboardCalendarQuery, GetGmBasketsForAccountDashboardCalendarQueryVariables>;
export const SupplierDraftMenuItemsOrOptionsDocument = gql`
    query supplierDraftMenuItemsOrOptions($supplierId: ID!, $limit: Int, $offset: Int, $filters: MenuItemFiltersInput, $getItems: Boolean!) {
  vendor(id: $supplierId) {
    id
    options: draftMenuOptions(limit: $limit, offset: $offset, filters: $filters) @skip(if: $getItems) {
      pageInfo {
        limit
        offset
        count
        hasMore
      }
      items {
        ...DraftMenuItemFields
      }
    }
    items: draftMenuItems(limit: $limit, offset: $offset, filters: $filters) @include(if: $getItems) {
      pageInfo {
        limit
        offset
        count
        hasMore
      }
      items {
        ...DraftMenuItemFields
        options {
          _id
          position
          minQty
          optionType
          name
          items {
            _id
            position
            price
            priceExTax
            legacyItemId
            item {
              ...DraftMenuItemFields
            }
          }
        }
      }
    }
  }
}
    ${DraftMenuItemFieldsFragmentDoc}`;

/**
 * __useSupplierDraftMenuItemsOrOptionsQuery__
 *
 * To run a query within a React component, call `useSupplierDraftMenuItemsOrOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierDraftMenuItemsOrOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierDraftMenuItemsOrOptionsQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      getItems: // value for 'getItems'
 *   },
 * });
 */
export function useSupplierDraftMenuItemsOrOptionsQuery(baseOptions: Apollo.QueryHookOptions<SupplierDraftMenuItemsOrOptionsQuery, SupplierDraftMenuItemsOrOptionsQueryVariables> & ({ variables: SupplierDraftMenuItemsOrOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierDraftMenuItemsOrOptionsQuery, SupplierDraftMenuItemsOrOptionsQueryVariables>(SupplierDraftMenuItemsOrOptionsDocument, options);
      }
export function useSupplierDraftMenuItemsOrOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierDraftMenuItemsOrOptionsQuery, SupplierDraftMenuItemsOrOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierDraftMenuItemsOrOptionsQuery, SupplierDraftMenuItemsOrOptionsQueryVariables>(SupplierDraftMenuItemsOrOptionsDocument, options);
        }
// @ts-ignore
export function useSupplierDraftMenuItemsOrOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupplierDraftMenuItemsOrOptionsQuery, SupplierDraftMenuItemsOrOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SupplierDraftMenuItemsOrOptionsQuery, SupplierDraftMenuItemsOrOptionsQueryVariables>;
export function useSupplierDraftMenuItemsOrOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierDraftMenuItemsOrOptionsQuery, SupplierDraftMenuItemsOrOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SupplierDraftMenuItemsOrOptionsQuery | undefined, SupplierDraftMenuItemsOrOptionsQueryVariables>;
export function useSupplierDraftMenuItemsOrOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierDraftMenuItemsOrOptionsQuery, SupplierDraftMenuItemsOrOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplierDraftMenuItemsOrOptionsQuery, SupplierDraftMenuItemsOrOptionsQueryVariables>(SupplierDraftMenuItemsOrOptionsDocument, options);
        }
export type SupplierDraftMenuItemsOrOptionsQueryHookResult = ReturnType<typeof useSupplierDraftMenuItemsOrOptionsQuery>;
export type SupplierDraftMenuItemsOrOptionsLazyQueryHookResult = ReturnType<typeof useSupplierDraftMenuItemsOrOptionsLazyQuery>;
export type SupplierDraftMenuItemsOrOptionsSuspenseQueryHookResult = ReturnType<typeof useSupplierDraftMenuItemsOrOptionsSuspenseQuery>;
export type SupplierDraftMenuItemsOrOptionsQueryResult = Apollo.QueryResult<SupplierDraftMenuItemsOrOptionsQuery, SupplierDraftMenuItemsOrOptionsQueryVariables>;
export const SupplierLiveMenuItemsDocument = gql`
    query supplierLiveMenuItems($supplierId: ID!, $itemsLimit: Int, $itemsOffset: Int, $optionsLimit: Int, $optionsOffset: Int, $filters: MenuItemFiltersInput) {
  vendor(id: $supplierId) {
    id
    liveMenuOptions(limit: $optionsLimit, offset: $optionsOffset, filters: $filters) {
      pageInfo {
        limit
        offset
        count
        hasMore
      }
      items {
        ...SupplierLiveMenuItem
      }
    }
    liveMenuItems(limit: $itemsLimit, offset: $itemsOffset, filters: $filters) {
      pageInfo {
        limit
        offset
        count
        hasMore
      }
      items {
        ...SupplierLiveMenuItem
      }
    }
  }
}
    ${SupplierLiveMenuItemFragmentDoc}`;

/**
 * __useSupplierLiveMenuItemsQuery__
 *
 * To run a query within a React component, call `useSupplierLiveMenuItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierLiveMenuItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierLiveMenuItemsQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *      itemsLimit: // value for 'itemsLimit'
 *      itemsOffset: // value for 'itemsOffset'
 *      optionsLimit: // value for 'optionsLimit'
 *      optionsOffset: // value for 'optionsOffset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSupplierLiveMenuItemsQuery(baseOptions: Apollo.QueryHookOptions<SupplierLiveMenuItemsQuery, SupplierLiveMenuItemsQueryVariables> & ({ variables: SupplierLiveMenuItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierLiveMenuItemsQuery, SupplierLiveMenuItemsQueryVariables>(SupplierLiveMenuItemsDocument, options);
      }
export function useSupplierLiveMenuItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierLiveMenuItemsQuery, SupplierLiveMenuItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierLiveMenuItemsQuery, SupplierLiveMenuItemsQueryVariables>(SupplierLiveMenuItemsDocument, options);
        }
// @ts-ignore
export function useSupplierLiveMenuItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupplierLiveMenuItemsQuery, SupplierLiveMenuItemsQueryVariables>): Apollo.UseSuspenseQueryResult<SupplierLiveMenuItemsQuery, SupplierLiveMenuItemsQueryVariables>;
export function useSupplierLiveMenuItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierLiveMenuItemsQuery, SupplierLiveMenuItemsQueryVariables>): Apollo.UseSuspenseQueryResult<SupplierLiveMenuItemsQuery | undefined, SupplierLiveMenuItemsQueryVariables>;
export function useSupplierLiveMenuItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierLiveMenuItemsQuery, SupplierLiveMenuItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplierLiveMenuItemsQuery, SupplierLiveMenuItemsQueryVariables>(SupplierLiveMenuItemsDocument, options);
        }
export type SupplierLiveMenuItemsQueryHookResult = ReturnType<typeof useSupplierLiveMenuItemsQuery>;
export type SupplierLiveMenuItemsLazyQueryHookResult = ReturnType<typeof useSupplierLiveMenuItemsLazyQuery>;
export type SupplierLiveMenuItemsSuspenseQueryHookResult = ReturnType<typeof useSupplierLiveMenuItemsSuspenseQuery>;
export type SupplierLiveMenuItemsQueryResult = Apollo.QueryResult<SupplierLiveMenuItemsQuery, SupplierLiveMenuItemsQueryVariables>;
export const SupplierLiveMenuItemsOrOptionsDocument = gql`
    query supplierLiveMenuItemsOrOptions($supplierId: ID!, $limit: Int, $offset: Int, $filters: MenuItemFiltersInput, $language: Language, $getItems: Boolean!, $getGroups: Boolean!) {
  vendor(id: $supplierId) {
    id
    options: liveMenuOptions(limit: $limit, offset: $offset, filters: $filters) @skip(if: $getItems) {
      pageInfo {
        limit
        offset
        count
        hasMore
      }
      items {
        ...SupplierLiveMenuItem
      }
    }
    items: liveMenuItems(
      limit: $limit
      offset: $offset
      filters: $filters
      language: $language
    ) @include(if: $getItems) {
      pageInfo {
        limit
        offset
        count
        hasMore
      }
      items {
        ...SupplierLiveMenuItem
      }
    }
    menuItemGroups @include(if: $getGroups) {
      pageInfo {
        count
      }
      groups {
        id
        name
      }
    }
  }
}
    ${SupplierLiveMenuItemFragmentDoc}`;

/**
 * __useSupplierLiveMenuItemsOrOptionsQuery__
 *
 * To run a query within a React component, call `useSupplierLiveMenuItemsOrOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierLiveMenuItemsOrOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierLiveMenuItemsOrOptionsQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      language: // value for 'language'
 *      getItems: // value for 'getItems'
 *      getGroups: // value for 'getGroups'
 *   },
 * });
 */
export function useSupplierLiveMenuItemsOrOptionsQuery(baseOptions: Apollo.QueryHookOptions<SupplierLiveMenuItemsOrOptionsQuery, SupplierLiveMenuItemsOrOptionsQueryVariables> & ({ variables: SupplierLiveMenuItemsOrOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierLiveMenuItemsOrOptionsQuery, SupplierLiveMenuItemsOrOptionsQueryVariables>(SupplierLiveMenuItemsOrOptionsDocument, options);
      }
export function useSupplierLiveMenuItemsOrOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierLiveMenuItemsOrOptionsQuery, SupplierLiveMenuItemsOrOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierLiveMenuItemsOrOptionsQuery, SupplierLiveMenuItemsOrOptionsQueryVariables>(SupplierLiveMenuItemsOrOptionsDocument, options);
        }
// @ts-ignore
export function useSupplierLiveMenuItemsOrOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupplierLiveMenuItemsOrOptionsQuery, SupplierLiveMenuItemsOrOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SupplierLiveMenuItemsOrOptionsQuery, SupplierLiveMenuItemsOrOptionsQueryVariables>;
export function useSupplierLiveMenuItemsOrOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierLiveMenuItemsOrOptionsQuery, SupplierLiveMenuItemsOrOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SupplierLiveMenuItemsOrOptionsQuery | undefined, SupplierLiveMenuItemsOrOptionsQueryVariables>;
export function useSupplierLiveMenuItemsOrOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierLiveMenuItemsOrOptionsQuery, SupplierLiveMenuItemsOrOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplierLiveMenuItemsOrOptionsQuery, SupplierLiveMenuItemsOrOptionsQueryVariables>(SupplierLiveMenuItemsOrOptionsDocument, options);
        }
export type SupplierLiveMenuItemsOrOptionsQueryHookResult = ReturnType<typeof useSupplierLiveMenuItemsOrOptionsQuery>;
export type SupplierLiveMenuItemsOrOptionsLazyQueryHookResult = ReturnType<typeof useSupplierLiveMenuItemsOrOptionsLazyQuery>;
export type SupplierLiveMenuItemsOrOptionsSuspenseQueryHookResult = ReturnType<typeof useSupplierLiveMenuItemsOrOptionsSuspenseQuery>;
export type SupplierLiveMenuItemsOrOptionsQueryResult = Apollo.QueryResult<SupplierLiveMenuItemsOrOptionsQuery, SupplierLiveMenuItemsOrOptionsQueryVariables>;
export const UpdateFinanceSettingsForAccountDocument = gql`
    mutation updateFinanceSettingsForAccount($accountId: Int!, $input: UpdateAccountFinanceSettingsInput!) {
  updateAccountFinanceSettings(accountId: $accountId, input: $input) {
    allowMinTopUpCc
    budgetCodeCc
    budgetCodeGm
    contractDateFrom
    contractDateTo
    deliverySurchargeCc
    invoicingFormatGm
    minOrderValueCc
    minPlatformFeeCc
    minPlatformFeeGm
    orderValPercentPlatformFeeCc
    orderValPercentPlatformFeeGm
    paymentDueDaysAfterInvoice
  }
}
    `;
export type UpdateFinanceSettingsForAccountMutationFn = Apollo.MutationFunction<UpdateFinanceSettingsForAccountMutation, UpdateFinanceSettingsForAccountMutationVariables>;

/**
 * __useUpdateFinanceSettingsForAccountMutation__
 *
 * To run a mutation, you first call `useUpdateFinanceSettingsForAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinanceSettingsForAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinanceSettingsForAccountMutation, { data, loading, error }] = useUpdateFinanceSettingsForAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFinanceSettingsForAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinanceSettingsForAccountMutation, UpdateFinanceSettingsForAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinanceSettingsForAccountMutation, UpdateFinanceSettingsForAccountMutationVariables>(UpdateFinanceSettingsForAccountDocument, options);
      }
export type UpdateFinanceSettingsForAccountMutationHookResult = ReturnType<typeof useUpdateFinanceSettingsForAccountMutation>;
export type UpdateFinanceSettingsForAccountMutationResult = Apollo.MutationResult<UpdateFinanceSettingsForAccountMutation>;
export type UpdateFinanceSettingsForAccountMutationOptions = Apollo.BaseMutationOptions<UpdateFinanceSettingsForAccountMutation, UpdateFinanceSettingsForAccountMutationVariables>;
export const VatBandsForVendorDocument = gql`
    query vatBandsForVendor($vendorId: ID!) {
  vendor(id: $vendorId) {
    financeSettings {
      vatRegion {
        legacyId
        vatBands {
          id
          legacyId
          name
          rate
          menuItemEligible
          invoiceItemEligible
        }
      }
    }
  }
}
    `;

/**
 * __useVatBandsForVendorQuery__
 *
 * To run a query within a React component, call `useVatBandsForVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useVatBandsForVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVatBandsForVendorQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useVatBandsForVendorQuery(baseOptions: Apollo.QueryHookOptions<VatBandsForVendorQuery, VatBandsForVendorQueryVariables> & ({ variables: VatBandsForVendorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VatBandsForVendorQuery, VatBandsForVendorQueryVariables>(VatBandsForVendorDocument, options);
      }
export function useVatBandsForVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VatBandsForVendorQuery, VatBandsForVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VatBandsForVendorQuery, VatBandsForVendorQueryVariables>(VatBandsForVendorDocument, options);
        }
// @ts-ignore
export function useVatBandsForVendorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VatBandsForVendorQuery, VatBandsForVendorQueryVariables>): Apollo.UseSuspenseQueryResult<VatBandsForVendorQuery, VatBandsForVendorQueryVariables>;
export function useVatBandsForVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VatBandsForVendorQuery, VatBandsForVendorQueryVariables>): Apollo.UseSuspenseQueryResult<VatBandsForVendorQuery | undefined, VatBandsForVendorQueryVariables>;
export function useVatBandsForVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VatBandsForVendorQuery, VatBandsForVendorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VatBandsForVendorQuery, VatBandsForVendorQueryVariables>(VatBandsForVendorDocument, options);
        }
export type VatBandsForVendorQueryHookResult = ReturnType<typeof useVatBandsForVendorQuery>;
export type VatBandsForVendorLazyQueryHookResult = ReturnType<typeof useVatBandsForVendorLazyQuery>;
export type VatBandsForVendorSuspenseQueryHookResult = ReturnType<typeof useVatBandsForVendorSuspenseQuery>;
export type VatBandsForVendorQueryResult = Apollo.QueryResult<VatBandsForVendorQuery, VatBandsForVendorQueryVariables>;
export const VpAuthDocument = gql`
    query vpAuth {
  me {
    email
    isVendor
    isAdmin
    role
    id
    firstName
    lastName
    vendor {
      id
      currency
    }
  }
}
    `;

/**
 * __useVpAuthQuery__
 *
 * To run a query within a React component, call `useVpAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useVpAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVpAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function useVpAuthQuery(baseOptions?: Apollo.QueryHookOptions<VpAuthQuery, VpAuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VpAuthQuery, VpAuthQueryVariables>(VpAuthDocument, options);
      }
export function useVpAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VpAuthQuery, VpAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VpAuthQuery, VpAuthQueryVariables>(VpAuthDocument, options);
        }
// @ts-ignore
export function useVpAuthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VpAuthQuery, VpAuthQueryVariables>): Apollo.UseSuspenseQueryResult<VpAuthQuery, VpAuthQueryVariables>;
export function useVpAuthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VpAuthQuery, VpAuthQueryVariables>): Apollo.UseSuspenseQueryResult<VpAuthQuery | undefined, VpAuthQueryVariables>;
export function useVpAuthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VpAuthQuery, VpAuthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VpAuthQuery, VpAuthQueryVariables>(VpAuthDocument, options);
        }
export type VpAuthQueryHookResult = ReturnType<typeof useVpAuthQuery>;
export type VpAuthLazyQueryHookResult = ReturnType<typeof useVpAuthLazyQuery>;
export type VpAuthSuspenseQueryHookResult = ReturnType<typeof useVpAuthSuspenseQuery>;
export type VpAuthQueryResult = Apollo.QueryResult<VpAuthQuery, VpAuthQueryVariables>;
export const GetAllSupportedTimezonesCitiesAndCountriesDocument = gql`
    query getAllSupportedTimezonesCitiesAndCountries {
  timezones {
    code
    countryCode
    label
  }
  countries {
    code
    name
    currency
    languages
  }
  cities {
    code
    name
    countryCode
  }
}
    `;

/**
 * __useGetAllSupportedTimezonesCitiesAndCountriesQuery__
 *
 * To run a query within a React component, call `useGetAllSupportedTimezonesCitiesAndCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSupportedTimezonesCitiesAndCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSupportedTimezonesCitiesAndCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSupportedTimezonesCitiesAndCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSupportedTimezonesCitiesAndCountriesQuery, GetAllSupportedTimezonesCitiesAndCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSupportedTimezonesCitiesAndCountriesQuery, GetAllSupportedTimezonesCitiesAndCountriesQueryVariables>(GetAllSupportedTimezonesCitiesAndCountriesDocument, options);
      }
export function useGetAllSupportedTimezonesCitiesAndCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSupportedTimezonesCitiesAndCountriesQuery, GetAllSupportedTimezonesCitiesAndCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSupportedTimezonesCitiesAndCountriesQuery, GetAllSupportedTimezonesCitiesAndCountriesQueryVariables>(GetAllSupportedTimezonesCitiesAndCountriesDocument, options);
        }
// @ts-ignore
export function useGetAllSupportedTimezonesCitiesAndCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllSupportedTimezonesCitiesAndCountriesQuery, GetAllSupportedTimezonesCitiesAndCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllSupportedTimezonesCitiesAndCountriesQuery, GetAllSupportedTimezonesCitiesAndCountriesQueryVariables>;
export function useGetAllSupportedTimezonesCitiesAndCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSupportedTimezonesCitiesAndCountriesQuery, GetAllSupportedTimezonesCitiesAndCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllSupportedTimezonesCitiesAndCountriesQuery | undefined, GetAllSupportedTimezonesCitiesAndCountriesQueryVariables>;
export function useGetAllSupportedTimezonesCitiesAndCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSupportedTimezonesCitiesAndCountriesQuery, GetAllSupportedTimezonesCitiesAndCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSupportedTimezonesCitiesAndCountriesQuery, GetAllSupportedTimezonesCitiesAndCountriesQueryVariables>(GetAllSupportedTimezonesCitiesAndCountriesDocument, options);
        }
export type GetAllSupportedTimezonesCitiesAndCountriesQueryHookResult = ReturnType<typeof useGetAllSupportedTimezonesCitiesAndCountriesQuery>;
export type GetAllSupportedTimezonesCitiesAndCountriesLazyQueryHookResult = ReturnType<typeof useGetAllSupportedTimezonesCitiesAndCountriesLazyQuery>;
export type GetAllSupportedTimezonesCitiesAndCountriesSuspenseQueryHookResult = ReturnType<typeof useGetAllSupportedTimezonesCitiesAndCountriesSuspenseQuery>;
export type GetAllSupportedTimezonesCitiesAndCountriesQueryResult = Apollo.QueryResult<GetAllSupportedTimezonesCitiesAndCountriesQuery, GetAllSupportedTimezonesCitiesAndCountriesQueryVariables>;
export const VendorLocationCountriesDocument = gql`
    query vendorLocationCountries($vendorId: ID!) {
  vendor(id: $vendorId) {
    locations {
      country
    }
  }
}
    `;

/**
 * __useVendorLocationCountriesQuery__
 *
 * To run a query within a React component, call `useVendorLocationCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorLocationCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorLocationCountriesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useVendorLocationCountriesQuery(baseOptions: Apollo.QueryHookOptions<VendorLocationCountriesQuery, VendorLocationCountriesQueryVariables> & ({ variables: VendorLocationCountriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorLocationCountriesQuery, VendorLocationCountriesQueryVariables>(VendorLocationCountriesDocument, options);
      }
export function useVendorLocationCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorLocationCountriesQuery, VendorLocationCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorLocationCountriesQuery, VendorLocationCountriesQueryVariables>(VendorLocationCountriesDocument, options);
        }
// @ts-ignore
export function useVendorLocationCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VendorLocationCountriesQuery, VendorLocationCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<VendorLocationCountriesQuery, VendorLocationCountriesQueryVariables>;
export function useVendorLocationCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorLocationCountriesQuery, VendorLocationCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<VendorLocationCountriesQuery | undefined, VendorLocationCountriesQueryVariables>;
export function useVendorLocationCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorLocationCountriesQuery, VendorLocationCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VendorLocationCountriesQuery, VendorLocationCountriesQueryVariables>(VendorLocationCountriesDocument, options);
        }
export type VendorLocationCountriesQueryHookResult = ReturnType<typeof useVendorLocationCountriesQuery>;
export type VendorLocationCountriesLazyQueryHookResult = ReturnType<typeof useVendorLocationCountriesLazyQuery>;
export type VendorLocationCountriesSuspenseQueryHookResult = ReturnType<typeof useVendorLocationCountriesSuspenseQuery>;
export type VendorLocationCountriesQueryResult = Apollo.QueryResult<VendorLocationCountriesQuery, VendorLocationCountriesQueryVariables>;
export const PageInitDocument = gql`
    query PageInit {
  me {
    id
    email
    firstName
    lastName
    role
    isAdmin
    isVendor
    isUser
    intercomUserHash
    privacyAccepted
    account {
      id
      name
      isCCActive
      isGMActive
    }
    accountLocation {
      id
    }
    teamId
    legacyAdminId
    fullName
    invoiceApproved
    languageSettings {
      locale
    }
    vendor {
      companyName
      id
    }
  }
  ghosterUser {
    id
  }
}
    `;

/**
 * __usePageInitQuery__
 *
 * To run a query within a React component, call `usePageInitQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageInitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageInitQuery({
 *   variables: {
 *   },
 * });
 */
export function usePageInitQuery(baseOptions?: Apollo.QueryHookOptions<PageInitQuery, PageInitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageInitQuery, PageInitQueryVariables>(PageInitDocument, options);
      }
export function usePageInitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageInitQuery, PageInitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageInitQuery, PageInitQueryVariables>(PageInitDocument, options);
        }
// @ts-ignore
export function usePageInitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageInitQuery, PageInitQueryVariables>): Apollo.UseSuspenseQueryResult<PageInitQuery, PageInitQueryVariables>;
export function usePageInitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageInitQuery, PageInitQueryVariables>): Apollo.UseSuspenseQueryResult<PageInitQuery | undefined, PageInitQueryVariables>;
export function usePageInitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageInitQuery, PageInitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageInitQuery, PageInitQueryVariables>(PageInitDocument, options);
        }
export type PageInitQueryHookResult = ReturnType<typeof usePageInitQuery>;
export type PageInitLazyQueryHookResult = ReturnType<typeof usePageInitLazyQuery>;
export type PageInitSuspenseQueryHookResult = ReturnType<typeof usePageInitSuspenseQuery>;
export type PageInitQueryResult = Apollo.QueryResult<PageInitQuery, PageInitQueryVariables>;
export const SyncMenuItemPricesDocument = gql`
    mutation syncMenuItemPrices($input: SyncMenuItemPricesInput!) {
  syncMenuItemPrices(input: $input) {
    syncJobId
  }
}
    `;
export type SyncMenuItemPricesMutationFn = Apollo.MutationFunction<SyncMenuItemPricesMutation, SyncMenuItemPricesMutationVariables>;

/**
 * __useSyncMenuItemPricesMutation__
 *
 * To run a mutation, you first call `useSyncMenuItemPricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncMenuItemPricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncMenuItemPricesMutation, { data, loading, error }] = useSyncMenuItemPricesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncMenuItemPricesMutation(baseOptions?: Apollo.MutationHookOptions<SyncMenuItemPricesMutation, SyncMenuItemPricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncMenuItemPricesMutation, SyncMenuItemPricesMutationVariables>(SyncMenuItemPricesDocument, options);
      }
export type SyncMenuItemPricesMutationHookResult = ReturnType<typeof useSyncMenuItemPricesMutation>;
export type SyncMenuItemPricesMutationResult = Apollo.MutationResult<SyncMenuItemPricesMutation>;
export type SyncMenuItemPricesMutationOptions = Apollo.BaseMutationOptions<SyncMenuItemPricesMutation, SyncMenuItemPricesMutationVariables>;
export const GetMenuItemPriceSyncStatusDocument = gql`
    query getMenuItemPriceSyncStatus($input: MenuItemPriceSyncStatusInput!) {
  menuItemPriceSyncStatus(input: $input) {
    status
    syncJobId
    batchesCompleted
    estimatedItemsCompleted
    startTime
    finishTime
  }
}
    `;

/**
 * __useGetMenuItemPriceSyncStatusQuery__
 *
 * To run a query within a React component, call `useGetMenuItemPriceSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuItemPriceSyncStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuItemPriceSyncStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMenuItemPriceSyncStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMenuItemPriceSyncStatusQuery, GetMenuItemPriceSyncStatusQueryVariables> & ({ variables: GetMenuItemPriceSyncStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuItemPriceSyncStatusQuery, GetMenuItemPriceSyncStatusQueryVariables>(GetMenuItemPriceSyncStatusDocument, options);
      }
export function useGetMenuItemPriceSyncStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuItemPriceSyncStatusQuery, GetMenuItemPriceSyncStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuItemPriceSyncStatusQuery, GetMenuItemPriceSyncStatusQueryVariables>(GetMenuItemPriceSyncStatusDocument, options);
        }
// @ts-ignore
export function useGetMenuItemPriceSyncStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMenuItemPriceSyncStatusQuery, GetMenuItemPriceSyncStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetMenuItemPriceSyncStatusQuery, GetMenuItemPriceSyncStatusQueryVariables>;
export function useGetMenuItemPriceSyncStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuItemPriceSyncStatusQuery, GetMenuItemPriceSyncStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetMenuItemPriceSyncStatusQuery | undefined, GetMenuItemPriceSyncStatusQueryVariables>;
export function useGetMenuItemPriceSyncStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuItemPriceSyncStatusQuery, GetMenuItemPriceSyncStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuItemPriceSyncStatusQuery, GetMenuItemPriceSyncStatusQueryVariables>(GetMenuItemPriceSyncStatusDocument, options);
        }
export type GetMenuItemPriceSyncStatusQueryHookResult = ReturnType<typeof useGetMenuItemPriceSyncStatusQuery>;
export type GetMenuItemPriceSyncStatusLazyQueryHookResult = ReturnType<typeof useGetMenuItemPriceSyncStatusLazyQuery>;
export type GetMenuItemPriceSyncStatusSuspenseQueryHookResult = ReturnType<typeof useGetMenuItemPriceSyncStatusSuspenseQuery>;
export type GetMenuItemPriceSyncStatusQueryResult = Apollo.QueryResult<GetMenuItemPriceSyncStatusQuery, GetMenuItemPriceSyncStatusQueryVariables>;
export const GetCustomerFlexInvoiceCsvDocument = gql`
    query GetCustomerFlexInvoiceCSV($invoiceId: ID!, $invoiceType: FlexInvoiceType!) {
  customerFlexInvoiceCSV(invoiceId: $invoiceId, invoiceType: $invoiceType)
}
    `;

/**
 * __useGetCustomerFlexInvoiceCsvQuery__
 *
 * To run a query within a React component, call `useGetCustomerFlexInvoiceCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerFlexInvoiceCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerFlexInvoiceCsvQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      invoiceType: // value for 'invoiceType'
 *   },
 * });
 */
export function useGetCustomerFlexInvoiceCsvQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerFlexInvoiceCsvQuery, GetCustomerFlexInvoiceCsvQueryVariables> & ({ variables: GetCustomerFlexInvoiceCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerFlexInvoiceCsvQuery, GetCustomerFlexInvoiceCsvQueryVariables>(GetCustomerFlexInvoiceCsvDocument, options);
      }
export function useGetCustomerFlexInvoiceCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerFlexInvoiceCsvQuery, GetCustomerFlexInvoiceCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerFlexInvoiceCsvQuery, GetCustomerFlexInvoiceCsvQueryVariables>(GetCustomerFlexInvoiceCsvDocument, options);
        }
// @ts-ignore
export function useGetCustomerFlexInvoiceCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerFlexInvoiceCsvQuery, GetCustomerFlexInvoiceCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerFlexInvoiceCsvQuery, GetCustomerFlexInvoiceCsvQueryVariables>;
export function useGetCustomerFlexInvoiceCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerFlexInvoiceCsvQuery, GetCustomerFlexInvoiceCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerFlexInvoiceCsvQuery | undefined, GetCustomerFlexInvoiceCsvQueryVariables>;
export function useGetCustomerFlexInvoiceCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerFlexInvoiceCsvQuery, GetCustomerFlexInvoiceCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerFlexInvoiceCsvQuery, GetCustomerFlexInvoiceCsvQueryVariables>(GetCustomerFlexInvoiceCsvDocument, options);
        }
export type GetCustomerFlexInvoiceCsvQueryHookResult = ReturnType<typeof useGetCustomerFlexInvoiceCsvQuery>;
export type GetCustomerFlexInvoiceCsvLazyQueryHookResult = ReturnType<typeof useGetCustomerFlexInvoiceCsvLazyQuery>;
export type GetCustomerFlexInvoiceCsvSuspenseQueryHookResult = ReturnType<typeof useGetCustomerFlexInvoiceCsvSuspenseQuery>;
export type GetCustomerFlexInvoiceCsvQueryResult = Apollo.QueryResult<GetCustomerFlexInvoiceCsvQuery, GetCustomerFlexInvoiceCsvQueryVariables>;
export const ListInvoicesDocument = gql`
    query ListInvoices($input: ListInvoicesInput) {
  invoices(input: $input) {
    items {
      ...ListInvoicesInvoiceCC
      ...ListInvoicesInvoiceGM
    }
    pageInfo {
      count
      limit
      offset
    }
  }
}
    ${ListInvoicesInvoiceCcFragmentDoc}
${ListInvoicesInvoiceGmFragmentDoc}`;

/**
 * __useListInvoicesQuery__
 *
 * To run a query within a React component, call `useListInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInvoicesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<ListInvoicesQuery, ListInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInvoicesQuery, ListInvoicesQueryVariables>(ListInvoicesDocument, options);
      }
export function useListInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInvoicesQuery, ListInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInvoicesQuery, ListInvoicesQueryVariables>(ListInvoicesDocument, options);
        }
// @ts-ignore
export function useListInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListInvoicesQuery, ListInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<ListInvoicesQuery, ListInvoicesQueryVariables>;
export function useListInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInvoicesQuery, ListInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<ListInvoicesQuery | undefined, ListInvoicesQueryVariables>;
export function useListInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInvoicesQuery, ListInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInvoicesQuery, ListInvoicesQueryVariables>(ListInvoicesDocument, options);
        }
export type ListInvoicesQueryHookResult = ReturnType<typeof useListInvoicesQuery>;
export type ListInvoicesLazyQueryHookResult = ReturnType<typeof useListInvoicesLazyQuery>;
export type ListInvoicesSuspenseQueryHookResult = ReturnType<typeof useListInvoicesSuspenseQuery>;
export type ListInvoicesQueryResult = Apollo.QueryResult<ListInvoicesQuery, ListInvoicesQueryVariables>;
export const ListInvoicesWithFlexDocument = gql`
    query ListInvoicesWithFlex($input: ListInvoicesInput, $accountId: Int!, $deferredCustomerIds: [ID!]) {
  invoicesCombined(
    input: $input
    accountId: $accountId
    deferredCustomerIds: $deferredCustomerIds
  ) {
    items {
      ...ListInvoicesInvoiceCC
      ...ListInvoicesInvoiceGM
      ...ListInvoicesInvoiceFlexAllTypes
    }
    pageInfo {
      count
      limit
      offset
    }
  }
}
    ${ListInvoicesInvoiceCcFragmentDoc}
${ListInvoicesInvoiceGmFragmentDoc}
${ListInvoicesInvoiceFlexAllTypesFragmentDoc}`;

/**
 * __useListInvoicesWithFlexQuery__
 *
 * To run a query within a React component, call `useListInvoicesWithFlexQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInvoicesWithFlexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInvoicesWithFlexQuery({
 *   variables: {
 *      input: // value for 'input'
 *      accountId: // value for 'accountId'
 *      deferredCustomerIds: // value for 'deferredCustomerIds'
 *   },
 * });
 */
export function useListInvoicesWithFlexQuery(baseOptions: Apollo.QueryHookOptions<ListInvoicesWithFlexQuery, ListInvoicesWithFlexQueryVariables> & ({ variables: ListInvoicesWithFlexQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInvoicesWithFlexQuery, ListInvoicesWithFlexQueryVariables>(ListInvoicesWithFlexDocument, options);
      }
export function useListInvoicesWithFlexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInvoicesWithFlexQuery, ListInvoicesWithFlexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInvoicesWithFlexQuery, ListInvoicesWithFlexQueryVariables>(ListInvoicesWithFlexDocument, options);
        }
// @ts-ignore
export function useListInvoicesWithFlexSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListInvoicesWithFlexQuery, ListInvoicesWithFlexQueryVariables>): Apollo.UseSuspenseQueryResult<ListInvoicesWithFlexQuery, ListInvoicesWithFlexQueryVariables>;
export function useListInvoicesWithFlexSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInvoicesWithFlexQuery, ListInvoicesWithFlexQueryVariables>): Apollo.UseSuspenseQueryResult<ListInvoicesWithFlexQuery | undefined, ListInvoicesWithFlexQueryVariables>;
export function useListInvoicesWithFlexSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInvoicesWithFlexQuery, ListInvoicesWithFlexQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInvoicesWithFlexQuery, ListInvoicesWithFlexQueryVariables>(ListInvoicesWithFlexDocument, options);
        }
export type ListInvoicesWithFlexQueryHookResult = ReturnType<typeof useListInvoicesWithFlexQuery>;
export type ListInvoicesWithFlexLazyQueryHookResult = ReturnType<typeof useListInvoicesWithFlexLazyQuery>;
export type ListInvoicesWithFlexSuspenseQueryHookResult = ReturnType<typeof useListInvoicesWithFlexSuspenseQuery>;
export type ListInvoicesWithFlexQueryResult = Apollo.QueryResult<ListInvoicesWithFlexQuery, ListInvoicesWithFlexQueryVariables>;
export const ListVendorStatementsDocument = gql`
    query ListVendorStatements($input: ListVendorStatementsInput) {
  vendorStatements(input: $input) {
    items {
      ...ListVendorStatementsItems
    }
    pageInfo {
      count
      limit
      offset
    }
  }
}
    ${ListVendorStatementsItemsFragmentDoc}`;

/**
 * __useListVendorStatementsQuery__
 *
 * To run a query within a React component, call `useListVendorStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListVendorStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListVendorStatementsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListVendorStatementsQuery(baseOptions?: Apollo.QueryHookOptions<ListVendorStatementsQuery, ListVendorStatementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListVendorStatementsQuery, ListVendorStatementsQueryVariables>(ListVendorStatementsDocument, options);
      }
export function useListVendorStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListVendorStatementsQuery, ListVendorStatementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListVendorStatementsQuery, ListVendorStatementsQueryVariables>(ListVendorStatementsDocument, options);
        }
// @ts-ignore
export function useListVendorStatementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListVendorStatementsQuery, ListVendorStatementsQueryVariables>): Apollo.UseSuspenseQueryResult<ListVendorStatementsQuery, ListVendorStatementsQueryVariables>;
export function useListVendorStatementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListVendorStatementsQuery, ListVendorStatementsQueryVariables>): Apollo.UseSuspenseQueryResult<ListVendorStatementsQuery | undefined, ListVendorStatementsQueryVariables>;
export function useListVendorStatementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListVendorStatementsQuery, ListVendorStatementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListVendorStatementsQuery, ListVendorStatementsQueryVariables>(ListVendorStatementsDocument, options);
        }
export type ListVendorStatementsQueryHookResult = ReturnType<typeof useListVendorStatementsQuery>;
export type ListVendorStatementsLazyQueryHookResult = ReturnType<typeof useListVendorStatementsLazyQuery>;
export type ListVendorStatementsSuspenseQueryHookResult = ReturnType<typeof useListVendorStatementsSuspenseQuery>;
export type ListVendorStatementsQueryResult = Apollo.QueryResult<ListVendorStatementsQuery, ListVendorStatementsQueryVariables>;
export const ListVendorStatementsWithFlexDocument = gql`
    query ListVendorStatementsWithFlex($input: ListVendorStatementsInput, $countryCode: String!, $deferredSupplierId: String) {
  vendorStatementsCombined(
    input: $input
    countryCode: $countryCode
    deferredSupplierId: $deferredSupplierId
  ) {
    items {
      ...ListVendorStatementsItems
      ...ListVendorFlexInvoiceAllTypesItems
    }
    pageInfo {
      count
      limit
      offset
    }
  }
}
    ${ListVendorStatementsItemsFragmentDoc}
${ListVendorFlexInvoiceAllTypesItemsFragmentDoc}`;

/**
 * __useListVendorStatementsWithFlexQuery__
 *
 * To run a query within a React component, call `useListVendorStatementsWithFlexQuery` and pass it any options that fit your needs.
 * When your component renders, `useListVendorStatementsWithFlexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListVendorStatementsWithFlexQuery({
 *   variables: {
 *      input: // value for 'input'
 *      countryCode: // value for 'countryCode'
 *      deferredSupplierId: // value for 'deferredSupplierId'
 *   },
 * });
 */
export function useListVendorStatementsWithFlexQuery(baseOptions: Apollo.QueryHookOptions<ListVendorStatementsWithFlexQuery, ListVendorStatementsWithFlexQueryVariables> & ({ variables: ListVendorStatementsWithFlexQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListVendorStatementsWithFlexQuery, ListVendorStatementsWithFlexQueryVariables>(ListVendorStatementsWithFlexDocument, options);
      }
export function useListVendorStatementsWithFlexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListVendorStatementsWithFlexQuery, ListVendorStatementsWithFlexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListVendorStatementsWithFlexQuery, ListVendorStatementsWithFlexQueryVariables>(ListVendorStatementsWithFlexDocument, options);
        }
// @ts-ignore
export function useListVendorStatementsWithFlexSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListVendorStatementsWithFlexQuery, ListVendorStatementsWithFlexQueryVariables>): Apollo.UseSuspenseQueryResult<ListVendorStatementsWithFlexQuery, ListVendorStatementsWithFlexQueryVariables>;
export function useListVendorStatementsWithFlexSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListVendorStatementsWithFlexQuery, ListVendorStatementsWithFlexQueryVariables>): Apollo.UseSuspenseQueryResult<ListVendorStatementsWithFlexQuery | undefined, ListVendorStatementsWithFlexQueryVariables>;
export function useListVendorStatementsWithFlexSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListVendorStatementsWithFlexQuery, ListVendorStatementsWithFlexQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListVendorStatementsWithFlexQuery, ListVendorStatementsWithFlexQueryVariables>(ListVendorStatementsWithFlexDocument, options);
        }
export type ListVendorStatementsWithFlexQueryHookResult = ReturnType<typeof useListVendorStatementsWithFlexQuery>;
export type ListVendorStatementsWithFlexLazyQueryHookResult = ReturnType<typeof useListVendorStatementsWithFlexLazyQuery>;
export type ListVendorStatementsWithFlexSuspenseQueryHookResult = ReturnType<typeof useListVendorStatementsWithFlexSuspenseQuery>;
export type ListVendorStatementsWithFlexQueryResult = Apollo.QueryResult<ListVendorStatementsWithFlexQuery, ListVendorStatementsWithFlexQueryVariables>;
export const InitiatePaymentDocument = gql`
    mutation initiatePayment($id: ID!) {
  initiateInvoiceCardPayment(id: $id) {
    authToken
  }
}
    `;
export type InitiatePaymentMutationFn = Apollo.MutationFunction<InitiatePaymentMutation, InitiatePaymentMutationVariables>;

/**
 * __useInitiatePaymentMutation__
 *
 * To run a mutation, you first call `useInitiatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiatePaymentMutation, { data, loading, error }] = useInitiatePaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitiatePaymentMutation, InitiatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiatePaymentMutation, InitiatePaymentMutationVariables>(InitiatePaymentDocument, options);
      }
export type InitiatePaymentMutationHookResult = ReturnType<typeof useInitiatePaymentMutation>;
export type InitiatePaymentMutationResult = Apollo.MutationResult<InitiatePaymentMutation>;
export type InitiatePaymentMutationOptions = Apollo.BaseMutationOptions<InitiatePaymentMutation, InitiatePaymentMutationVariables>;
export const GetPaymentDocument = gql`
    query getPayment($authToken: JWT!) {
  payment(authToken: $authToken) {
    ...Payment
  }
  paymentAuthToken(authToken: $authToken) {
    expiryTimestamp
  }
}
    ${PaymentFragmentDoc}`;

/**
 * __useGetPaymentQuery__
 *
 * To run a query within a React component, call `useGetPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentQuery({
 *   variables: {
 *      authToken: // value for 'authToken'
 *   },
 * });
 */
export function useGetPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables> & ({ variables: GetPaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
      }
export function useGetPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
// @ts-ignore
export function useGetPaymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentQuery, GetPaymentQueryVariables>;
export function useGetPaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentQuery | undefined, GetPaymentQueryVariables>;
export function useGetPaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
export type GetPaymentQueryHookResult = ReturnType<typeof useGetPaymentQuery>;
export type GetPaymentLazyQueryHookResult = ReturnType<typeof useGetPaymentLazyQuery>;
export type GetPaymentSuspenseQueryHookResult = ReturnType<typeof useGetPaymentSuspenseQuery>;
export type GetPaymentQueryResult = Apollo.QueryResult<GetPaymentQuery, GetPaymentQueryVariables>;
export const StartPaymentDocument = gql`
    mutation startPayment($input: StartPaymentInput!) {
  startPayment(input: $input) {
    stripeClientSecret
    customerId
    ephemeralKey
  }
}
    `;
export type StartPaymentMutationFn = Apollo.MutationFunction<StartPaymentMutation, StartPaymentMutationVariables>;

/**
 * __useStartPaymentMutation__
 *
 * To run a mutation, you first call `useStartPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPaymentMutation, { data, loading, error }] = useStartPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartPaymentMutation(baseOptions?: Apollo.MutationHookOptions<StartPaymentMutation, StartPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPaymentMutation, StartPaymentMutationVariables>(StartPaymentDocument, options);
      }
export type StartPaymentMutationHookResult = ReturnType<typeof useStartPaymentMutation>;
export type StartPaymentMutationResult = Apollo.MutationResult<StartPaymentMutation>;
export type StartPaymentMutationOptions = Apollo.BaseMutationOptions<StartPaymentMutation, StartPaymentMutationVariables>;
export const AllVendorsDocument = gql`
    query AllVendors($limit: Int, $offset: Int, $tenantId: String) {
  vendors(
    limit: $limit
    offset: $offset
    filters: {isDraft: false, isGMActive: true, minimumOneActiveService: true, tenantId: $tenantId}
  ) {
    rows {
      id
      permalink
      locations {
        country
      }
    }
    pageInfo {
      count
    }
  }
}
    `;

/**
 * __useAllVendorsQuery__
 *
 * To run a query within a React component, call `useAllVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVendorsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useAllVendorsQuery(baseOptions?: Apollo.QueryHookOptions<AllVendorsQuery, AllVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVendorsQuery, AllVendorsQueryVariables>(AllVendorsDocument, options);
      }
export function useAllVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVendorsQuery, AllVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVendorsQuery, AllVendorsQueryVariables>(AllVendorsDocument, options);
        }
// @ts-ignore
export function useAllVendorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllVendorsQuery, AllVendorsQueryVariables>): Apollo.UseSuspenseQueryResult<AllVendorsQuery, AllVendorsQueryVariables>;
export function useAllVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllVendorsQuery, AllVendorsQueryVariables>): Apollo.UseSuspenseQueryResult<AllVendorsQuery | undefined, AllVendorsQueryVariables>;
export function useAllVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllVendorsQuery, AllVendorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllVendorsQuery, AllVendorsQueryVariables>(AllVendorsDocument, options);
        }
export type AllVendorsQueryHookResult = ReturnType<typeof useAllVendorsQuery>;
export type AllVendorsLazyQueryHookResult = ReturnType<typeof useAllVendorsLazyQuery>;
export type AllVendorsSuspenseQueryHookResult = ReturnType<typeof useAllVendorsSuspenseQuery>;
export type AllVendorsQueryResult = Apollo.QueryResult<AllVendorsQuery, AllVendorsQueryVariables>;
export const GetVendorPermalinkByIdDocument = gql`
    query getVendorPermalinkById($vendorId: ID!) {
  vendor(id: $vendorId) {
    permalink
    locations(isGMActive: true) {
      country
    }
  }
}
    `;

/**
 * __useGetVendorPermalinkByIdQuery__
 *
 * To run a query within a React component, call `useGetVendorPermalinkByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorPermalinkByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorPermalinkByIdQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useGetVendorPermalinkByIdQuery(baseOptions: Apollo.QueryHookOptions<GetVendorPermalinkByIdQuery, GetVendorPermalinkByIdQueryVariables> & ({ variables: GetVendorPermalinkByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorPermalinkByIdQuery, GetVendorPermalinkByIdQueryVariables>(GetVendorPermalinkByIdDocument, options);
      }
export function useGetVendorPermalinkByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorPermalinkByIdQuery, GetVendorPermalinkByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorPermalinkByIdQuery, GetVendorPermalinkByIdQueryVariables>(GetVendorPermalinkByIdDocument, options);
        }
// @ts-ignore
export function useGetVendorPermalinkByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorPermalinkByIdQuery, GetVendorPermalinkByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorPermalinkByIdQuery, GetVendorPermalinkByIdQueryVariables>;
export function useGetVendorPermalinkByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorPermalinkByIdQuery, GetVendorPermalinkByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorPermalinkByIdQuery | undefined, GetVendorPermalinkByIdQueryVariables>;
export function useGetVendorPermalinkByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorPermalinkByIdQuery, GetVendorPermalinkByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorPermalinkByIdQuery, GetVendorPermalinkByIdQueryVariables>(GetVendorPermalinkByIdDocument, options);
        }
export type GetVendorPermalinkByIdQueryHookResult = ReturnType<typeof useGetVendorPermalinkByIdQuery>;
export type GetVendorPermalinkByIdLazyQueryHookResult = ReturnType<typeof useGetVendorPermalinkByIdLazyQuery>;
export type GetVendorPermalinkByIdSuspenseQueryHookResult = ReturnType<typeof useGetVendorPermalinkByIdSuspenseQuery>;
export type GetVendorPermalinkByIdQueryResult = Apollo.QueryResult<GetVendorPermalinkByIdQuery, GetVendorPermalinkByIdQueryVariables>;
export const GetVendorPermalinkByPermalinkDocument = gql`
    query getVendorPermalinkByPermalink($permalink: String!, $tenantId: String!) {
  vendorByPermalink(permalink: $permalink, tenantId: $tenantId) {
    permalink
    locations(isGMActive: true) {
      country
    }
  }
}
    `;

/**
 * __useGetVendorPermalinkByPermalinkQuery__
 *
 * To run a query within a React component, call `useGetVendorPermalinkByPermalinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorPermalinkByPermalinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorPermalinkByPermalinkQuery({
 *   variables: {
 *      permalink: // value for 'permalink'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetVendorPermalinkByPermalinkQuery(baseOptions: Apollo.QueryHookOptions<GetVendorPermalinkByPermalinkQuery, GetVendorPermalinkByPermalinkQueryVariables> & ({ variables: GetVendorPermalinkByPermalinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorPermalinkByPermalinkQuery, GetVendorPermalinkByPermalinkQueryVariables>(GetVendorPermalinkByPermalinkDocument, options);
      }
export function useGetVendorPermalinkByPermalinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorPermalinkByPermalinkQuery, GetVendorPermalinkByPermalinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorPermalinkByPermalinkQuery, GetVendorPermalinkByPermalinkQueryVariables>(GetVendorPermalinkByPermalinkDocument, options);
        }
// @ts-ignore
export function useGetVendorPermalinkByPermalinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorPermalinkByPermalinkQuery, GetVendorPermalinkByPermalinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorPermalinkByPermalinkQuery, GetVendorPermalinkByPermalinkQueryVariables>;
export function useGetVendorPermalinkByPermalinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorPermalinkByPermalinkQuery, GetVendorPermalinkByPermalinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorPermalinkByPermalinkQuery | undefined, GetVendorPermalinkByPermalinkQueryVariables>;
export function useGetVendorPermalinkByPermalinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorPermalinkByPermalinkQuery, GetVendorPermalinkByPermalinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorPermalinkByPermalinkQuery, GetVendorPermalinkByPermalinkQueryVariables>(GetVendorPermalinkByPermalinkDocument, options);
        }
export type GetVendorPermalinkByPermalinkQueryHookResult = ReturnType<typeof useGetVendorPermalinkByPermalinkQuery>;
export type GetVendorPermalinkByPermalinkLazyQueryHookResult = ReturnType<typeof useGetVendorPermalinkByPermalinkLazyQuery>;
export type GetVendorPermalinkByPermalinkSuspenseQueryHookResult = ReturnType<typeof useGetVendorPermalinkByPermalinkSuspenseQuery>;
export type GetVendorPermalinkByPermalinkQueryResult = Apollo.QueryResult<GetVendorPermalinkByPermalinkQuery, GetVendorPermalinkByPermalinkQueryVariables>;
export type AccountKeySpecifier = ('accountCountryFlexMappings' | 'approvedSuppliers' | 'archivedAt' | 'archivedBy' | 'archivedByAdminId' | 'autoSendMenu' | 'autopilotEnabled' | 'ccMealVendors' | 'ccOrders' | 'ccSubsidies' | 'ccTeams' | 'ccUserOrders' | 'code' | 'currency' | 'customerOrdersReport' | 'customerOrdersSummary' | 'defaultFlexDeferredCustomerId' | 'domains' | 'externalId' | 'financeSettings' | 'flexInvoiceAccounts' | 'gmBaskets' | 'highRisk' | 'id' | 'invoiceAccounts' | 'invoiceApproved' | 'isCCActive' | 'isGMActive' | 'locations' | 'locationsPaged' | 'manager' | 'managerId' | 'managerName' | 'name' | 'napkinsCutlery' | 'notes' | 'onboardingLink' | 'onboardingStatus' | 'primaryContacts' | 'quoteCollections' | 'signUpCode' | 'ssoConfig' | 'ssoEnabled' | 'tenantId' | 'topUpEnabled' | 'userInterfaceSettings' | 'users' | AccountKeySpecifier)[];
export type AccountFieldPolicy = {
	accountCountryFlexMappings?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedSuppliers?: FieldPolicy<any> | FieldReadFunction<any>,
	archivedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	archivedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	archivedByAdminId?: FieldPolicy<any> | FieldReadFunction<any>,
	autoSendMenu?: FieldPolicy<any> | FieldReadFunction<any>,
	autopilotEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	ccMealVendors?: FieldPolicy<any> | FieldReadFunction<any>,
	ccOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	ccSubsidies?: FieldPolicy<any> | FieldReadFunction<any>,
	ccTeams?: FieldPolicy<any> | FieldReadFunction<any>,
	ccUserOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	customerOrdersReport?: FieldPolicy<any> | FieldReadFunction<any>,
	customerOrdersSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultFlexDeferredCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	domains?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	financeSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	flexInvoiceAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	gmBaskets?: FieldPolicy<any> | FieldReadFunction<any>,
	highRisk?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	isCCActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isGMActive?: FieldPolicy<any> | FieldReadFunction<any>,
	locations?: FieldPolicy<any> | FieldReadFunction<any>,
	locationsPaged?: FieldPolicy<any> | FieldReadFunction<any>,
	manager?: FieldPolicy<any> | FieldReadFunction<any>,
	managerId?: FieldPolicy<any> | FieldReadFunction<any>,
	managerName?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	napkinsCutlery?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingLink?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryContacts?: FieldPolicy<any> | FieldReadFunction<any>,
	quoteCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	signUpCode?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	topUpEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	userInterfaceSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountCountryFlexMappingKeySpecifier = ('accountId' | 'country' | 'flexDeferredCustomerId' | AccountCountryFlexMappingKeySpecifier)[];
export type AccountCountryFlexMappingFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	flexDeferredCustomerId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountFinanceSettingsKeySpecifier = ('accountId' | 'additionalBillingNotes' | 'allowMinTopUpCc' | 'budgetCodeCc' | 'budgetCodeGm' | 'chargeCreditCardFee' | 'contractDateFrom' | 'contractDateTo' | 'deliverySurchargeCc' | 'deliverySurchargeCcExTax' | 'enterpriseCostPlusPricing' | 'feeAndDiscountNotesGm' | 'id' | 'invoicingFormatGm' | 'isBudgetCodeMandatory' | 'minMonthlyCateringSpendExTax' | 'minOrderValueCc' | 'minOrderValueCcExTax' | 'minPlatformFeeCc' | 'minPlatformFeeCcExTax' | 'minPlatformFeeCcMonthlyExTax' | 'minPlatformFeeGm' | 'orderValPercentEnterpriseDiscountGm' | 'orderValPercentPlatformFeeCc' | 'orderValPercentPlatformFeeGm' | 'paymentDueDaysAfterInvoice' | AccountFinanceSettingsKeySpecifier)[];
export type AccountFinanceSettingsFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalBillingNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	allowMinTopUpCc?: FieldPolicy<any> | FieldReadFunction<any>,
	budgetCodeCc?: FieldPolicy<any> | FieldReadFunction<any>,
	budgetCodeGm?: FieldPolicy<any> | FieldReadFunction<any>,
	chargeCreditCardFee?: FieldPolicy<any> | FieldReadFunction<any>,
	contractDateFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	contractDateTo?: FieldPolicy<any> | FieldReadFunction<any>,
	deliverySurchargeCc?: FieldPolicy<any> | FieldReadFunction<any>,
	deliverySurchargeCcExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	enterpriseCostPlusPricing?: FieldPolicy<any> | FieldReadFunction<any>,
	feeAndDiscountNotesGm?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicingFormatGm?: FieldPolicy<any> | FieldReadFunction<any>,
	isBudgetCodeMandatory?: FieldPolicy<any> | FieldReadFunction<any>,
	minMonthlyCateringSpendExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	minOrderValueCc?: FieldPolicy<any> | FieldReadFunction<any>,
	minOrderValueCcExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	minPlatformFeeCc?: FieldPolicy<any> | FieldReadFunction<any>,
	minPlatformFeeCcExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	minPlatformFeeCcMonthlyExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	minPlatformFeeGm?: FieldPolicy<any> | FieldReadFunction<any>,
	orderValPercentEnterpriseDiscountGm?: FieldPolicy<any> | FieldReadFunction<any>,
	orderValPercentPlatformFeeCc?: FieldPolicy<any> | FieldReadFunction<any>,
	orderValPercentPlatformFeeGm?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentDueDaysAfterInvoice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountIdentityProviderAttributeMappingKeySpecifier = ('samlAttribute' | 'userPoolAttribute' | AccountIdentityProviderAttributeMappingKeySpecifier)[];
export type AccountIdentityProviderAttributeMappingFieldPolicy = {
	samlAttribute?: FieldPolicy<any> | FieldReadFunction<any>,
	userPoolAttribute?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountLocationKeySpecifier = ('account' | 'accountLocationReferenceFieldValues' | 'address' | 'archivedAt' | 'archivedBy' | 'archivedByAdminId' | 'assets' | 'breakfastClose' | 'budget' | 'ccAvailabilities' | 'ccCluster' | 'ccMealTimeslots' | 'ccMenu' | 'ccOrderItems' | 'ccServiceLaunchSentAt' | 'ccServiceSettings' | 'ccSubsidies' | 'clusterId' | 'contactPreferences' | 'createdAt' | 'deletedAt' | 'deliveryPreferences' | 'dinnerClose' | 'id' | 'instructions' | 'isBillingAddress' | 'isCCActive' | 'isGmActive' | 'label' | 'lat' | 'lng' | 'lunchClose' | 'menuCoverageTolerance' | 'optOutMenuAutomation' | 'phone' | 'timezone' | 'updatedAt' | 'vendorPreferences' | 'what3words' | AccountLocationKeySpecifier)[];
export type AccountLocationFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationReferenceFieldValues?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	archivedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	archivedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	archivedByAdminId?: FieldPolicy<any> | FieldReadFunction<any>,
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	breakfastClose?: FieldPolicy<any> | FieldReadFunction<any>,
	budget?: FieldPolicy<any> | FieldReadFunction<any>,
	ccAvailabilities?: FieldPolicy<any> | FieldReadFunction<any>,
	ccCluster?: FieldPolicy<any> | FieldReadFunction<any>,
	ccMealTimeslots?: FieldPolicy<any> | FieldReadFunction<any>,
	ccMenu?: FieldPolicy<any> | FieldReadFunction<any>,
	ccOrderItems?: FieldPolicy<any> | FieldReadFunction<any>,
	ccServiceLaunchSentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ccServiceSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	ccSubsidies?: FieldPolicy<any> | FieldReadFunction<any>,
	clusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	contactPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	dinnerClose?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	instructions?: FieldPolicy<any> | FieldReadFunction<any>,
	isBillingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	isCCActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isGmActive?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	lng?: FieldPolicy<any> | FieldReadFunction<any>,
	lunchClose?: FieldPolicy<any> | FieldReadFunction<any>,
	menuCoverageTolerance?: FieldPolicy<any> | FieldReadFunction<any>,
	optOutMenuAutomation?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	what3words?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountLocationAssetKeySpecifier = ('generatedAt' | 'type' | 'url' | AccountLocationAssetKeySpecifier)[];
export type AccountLocationAssetFieldPolicy = {
	generatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountLocationCanteenServieSettingsKeySpecifier = ('breakfastSingleVendorOrder' | 'dinnerSingleVendorOrder' | 'lunchSingleVendorOrder' | AccountLocationCanteenServieSettingsKeySpecifier)[];
export type AccountLocationCanteenServieSettingsFieldPolicy = {
	breakfastSingleVendorOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	dinnerSingleVendorOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	lunchSingleVendorOrder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountLocationContactPreferencesKeySpecifier = ('dailyReminderDefaultOptIn' | AccountLocationContactPreferencesKeySpecifier)[];
export type AccountLocationContactPreferencesFieldPolicy = {
	dailyReminderDefaultOptIn?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountLocationDeliveryPreferencesKeySpecifier = ('deliveryInstructions' | 'packingInstructions' | 'preferredCourier' | AccountLocationDeliveryPreferencesKeySpecifier)[];
export type AccountLocationDeliveryPreferencesFieldPolicy = {
	deliveryInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	packingInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	preferredCourier?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountLocationReferenceFieldValueKeySpecifier = ('accountLocationReferenceFieldId' | 'description' | 'fieldType' | 'isRequired' | 'label' | 'options' | 'orderReferenceFieldId' | 'value' | 'version' | AccountLocationReferenceFieldValueKeySpecifier)[];
export type AccountLocationReferenceFieldValueFieldPolicy = {
	accountLocationReferenceFieldId?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldType?: FieldPolicy<any> | FieldReadFunction<any>,
	isRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	orderReferenceFieldId?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountLocationReferenceFieldValueOptionKeySpecifier = ('accountLocationReferenceFieldId' | 'id' | 'option' | 'orderPriority' | AccountLocationReferenceFieldValueOptionKeySpecifier)[];
export type AccountLocationReferenceFieldValueOptionFieldPolicy = {
	accountLocationReferenceFieldId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	option?: FieldPolicy<any> | FieldReadFunction<any>,
	orderPriority?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountLocationsPagedKeySpecifier = ('pageInfo' | 'rows' | AccountLocationsPagedKeySpecifier)[];
export type AccountLocationsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountPrivateSuppliersKeySpecifier = ('suppliers' | AccountPrivateSuppliersKeySpecifier)[];
export type AccountPrivateSuppliersFieldPolicy = {
	suppliers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountSsoConfigKeySpecifier = ('attributeMapping' | AccountSsoConfigKeySpecifier)[];
export type AccountSsoConfigFieldPolicy = {
	attributeMapping?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountUserInterfaceSettingsKeySpecifier = ('accountId' | 'hideCCPrices' | 'id' | AccountUserInterfaceSettingsKeySpecifier)[];
export type AccountUserInterfaceSettingsFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	hideCCPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountsPagedKeySpecifier = ('pageInfo' | 'rows' | AccountsPagedKeySpecifier)[];
export type AccountsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressKeySpecifier = ('city' | 'country' | 'flatOrBuilding' | 'floorOrBuildingName' | 'label' | 'latitude' | 'longitude' | 'postcode' | 'street' | 'timezoneId' | AddressKeySpecifier)[];
export type AddressFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	flatOrBuilding?: FieldPolicy<any> | FieldReadFunction<any>,
	floorOrBuildingName?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>,
	timezoneId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressComponentKeySpecifier = ('long_name' | 'short_name' | 'types' | AddressComponentKeySpecifier)[];
export type AddressComponentFieldPolicy = {
	long_name?: FieldPolicy<any> | FieldReadFunction<any>,
	short_name?: FieldPolicy<any> | FieldReadFunction<any>,
	types?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressLocationKeySpecifier = ('address' | 'context' | 'id' | 'relevance' | AddressLocationKeySpecifier)[];
export type AddressLocationFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	context?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	relevance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminKeySpecifier = ('countryFlags' | 'email' | 'feedrUserId' | 'firstName' | 'fullName' | 'id' | 'languageSettings' | 'lastName' | 'phone' | 'roles' | 'tenant' | AdminKeySpecifier)[];
export type AdminFieldPolicy = {
	countryFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	feedrUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	languageSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminLanguageSettingsKeySpecifier = ('locale' | AdminLanguageSettingsKeySpecifier)[];
export type AdminLanguageSettingsFieldPolicy = {
	locale?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminsPagedKeySpecifier = ('pageInfo' | 'rows' | AdminsPagedKeySpecifier)[];
export type AdminsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AggregateByPeriodKeySpecifier = ('amount' | 'date' | AggregateByPeriodKeySpecifier)[];
export type AggregateByPeriodFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertKeySpecifier = ('destinations' | 'eventName' | 'filters' | 'id' | 'name' | AlertKeySpecifier)[];
export type AlertFieldPolicy = {
	destinations?: FieldPolicy<any> | FieldReadFunction<any>,
	eventName?: FieldPolicy<any> | FieldReadFunction<any>,
	filters?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertDestinationsKeySpecifier = ('email' | 'slack' | AlertDestinationsKeySpecifier)[];
export type AlertDestinationsFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	slack?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertEmailDestinationKeySpecifier = ('addresses' | 'enabled' | AlertEmailDestinationKeySpecifier)[];
export type AlertEmailDestinationFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertFilterBaseKeySpecifier = ('field' | AlertFilterBaseKeySpecifier)[];
export type AlertFilterBaseFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertFilterBooleanKeySpecifier = ('field' | 'type' | 'value' | AlertFilterBooleanKeySpecifier)[];
export type AlertFilterBooleanFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertFilterNumberKeySpecifier = ('condition' | 'field' | 'type' | 'valueInt' | AlertFilterNumberKeySpecifier)[];
export type AlertFilterNumberFieldPolicy = {
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	valueInt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertFilterStringKeySpecifier = ('field' | 'type' | 'values' | AlertFilterStringKeySpecifier)[];
export type AlertFilterStringFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertSlackDestinationKeySpecifier = ('channels' | 'enabled' | AlertSlackDestinationKeySpecifier)[];
export type AlertSlackDestinationFieldPolicy = {
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertTenantConfigKeySpecifier = ('slackEnabled' | AlertTenantConfigKeySpecifier)[];
export type AlertTenantConfigFieldPolicy = {
	slackEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertTypeKeySpecifier = ('description' | 'eventName' | 'filters' | 'name' | AlertTypeKeySpecifier)[];
export type AlertTypeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	eventName?: FieldPolicy<any> | FieldReadFunction<any>,
	filters?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertTypeFilterAccountKeySpecifier = ('field' | 'name' | 'type' | AlertTypeFilterAccountKeySpecifier)[];
export type AlertTypeFilterAccountFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertTypeFilterBaseKeySpecifier = ('field' | 'name' | AlertTypeFilterBaseKeySpecifier)[];
export type AlertTypeFilterBaseFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertTypeFilterBooleanKeySpecifier = ('field' | 'name' | 'type' | AlertTypeFilterBooleanKeySpecifier)[];
export type AlertTypeFilterBooleanFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertTypeFilterCountryKeySpecifier = ('field' | 'name' | 'type' | AlertTypeFilterCountryKeySpecifier)[];
export type AlertTypeFilterCountryFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertTypeFilterDropdownKeySpecifier = ('field' | 'name' | 'options' | 'type' | AlertTypeFilterDropdownKeySpecifier)[];
export type AlertTypeFilterDropdownFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertTypeFilterNumberKeySpecifier = ('condition' | 'field' | 'name' | 'type' | AlertTypeFilterNumberKeySpecifier)[];
export type AlertTypeFilterNumberFieldPolicy = {
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertTypeFilterStringKeySpecifier = ('field' | 'name' | 'type' | AlertTypeFilterStringKeySpecifier)[];
export type AlertTypeFilterStringFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertTypeFilterSupplierKeySpecifier = ('field' | 'name' | 'type' | AlertTypeFilterSupplierKeySpecifier)[];
export type AlertTypeFilterSupplierFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertsPagedKeySpecifier = ('pageInfo' | 'rows' | AlertsPagedKeySpecifier)[];
export type AlertsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AllergenAuditKeySpecifier = ('action' | 'actor' | 'actorName' | 'createdAt' | AllergenAuditKeySpecifier)[];
export type AllergenAuditFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	actor?: FieldPolicy<any> | FieldReadFunction<any>,
	actorName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AllergenAuditSummaryKeySpecifier = ('latestAdmin' | 'latestVendor' | 'rows' | AllergenAuditSummaryKeySpecifier)[];
export type AllergenAuditSummaryFieldPolicy = {
	latestAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	latestVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AllergenAuditSummaryRowKeySpecifier = ('actor' | 'actorName' | 'createdAt' | 'kind' | 'status' | 'superseded' | AllergenAuditSummaryRowKeySpecifier)[];
export type AllergenAuditSummaryRowFieldPolicy = {
	actor?: FieldPolicy<any> | FieldReadFunction<any>,
	actorName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	superseded?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AllergenStatKeySpecifier = ('allergen' | 'count' | AllergenStatKeySpecifier)[];
export type AllergenStatFieldPolicy = {
	allergen?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ApplyNewReferenceFieldsToCCSupplierOrderResultKeySpecifier = ('accountLocationIds' | 'ccSupplierOrder' | 'invoiceAccountId' | 'invoiceAccountLabel' | ApplyNewReferenceFieldsToCCSupplierOrderResultKeySpecifier)[];
export type ApplyNewReferenceFieldsToCCSupplierOrderResultFieldPolicy = {
	accountLocationIds?: FieldPolicy<any> | FieldReadFunction<any>,
	ccSupplierOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceAccountLabel?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ApprovedSupplierKeySpecifier = ('supplierId' | 'supplierName' | ApprovedSupplierKeySpecifier)[];
export type ApprovedSupplierFieldPolicy = {
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ArchiveAccountPayloadKeySpecifier = ('account' | 'blockers' | 'warnings' | ArchiveAccountPayloadKeySpecifier)[];
export type ArchiveAccountPayloadFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	blockers?: FieldPolicy<any> | FieldReadFunction<any>,
	warnings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ArchiveBlockerKeySpecifier = ('code' | 'count' | 'message' | ArchiveBlockerKeySpecifier)[];
export type ArchiveBlockerFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ArchiveWarningKeySpecifier = ('code' | 'count' | 'message' | ArchiveWarningKeySpecifier)[];
export type ArchiveWarningFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssetKeySpecifier = ('type' | 'url' | AssetKeySpecifier)[];
export type AssetFieldPolicy = {
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignUsersToTeamResultKeySpecifier = ('message' | 'success' | AssignUsersToTeamResultKeySpecifier)[];
export type AssignUsersToTeamResultFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AvailabilitiesAccountKeySpecifier = ('data' | 'id' | 'manager' | 'name' | AvailabilitiesAccountKeySpecifier)[];
export type AvailabilitiesAccountFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	manager?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AvailabilitiesVendorKeySpecifier = ('contact' | 'contactId' | 'id' | 'imageUrl' | 'location' | 'locationId' | 'name' | 'url' | AvailabilitiesVendorKeySpecifier)[];
export type AvailabilitiesVendorFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contactId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BankAccountDataKeySpecifier = ('accountName' | 'accountNumber' | 'accountType' | 'bankAddress' | 'bankName' | 'bic' | 'bsb' | 'currency' | 'iban' | 'sortCode' | BankAccountDataKeySpecifier)[];
export type BankAccountDataFieldPolicy = {
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	accountType?: FieldPolicy<any> | FieldReadFunction<any>,
	bankAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	bankName?: FieldPolicy<any> | FieldReadFunction<any>,
	bic?: FieldPolicy<any> | FieldReadFunction<any>,
	bsb?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	iban?: FieldPolicy<any> | FieldReadFunction<any>,
	sortCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BasketFeeBreakdownKeySpecifier = ('taxRate' | 'taxValue' | 'total' | 'totalExTax' | BasketFeeBreakdownKeySpecifier)[];
export type BasketFeeBreakdownFieldPolicy = {
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExTax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BasketItemKeySpecifier = ('acknowledgedAt' | 'addedByName' | 'addedByUserId' | 'id' | 'item' | 'itemReference' | 'note' | 'options' | 'qty' | BasketItemKeySpecifier)[];
export type BasketItemFieldPolicy = {
	acknowledgedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	addedByName?: FieldPolicy<any> | FieldReadFunction<any>,
	addedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	itemReference?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BasketItemOptionKeySpecifier = ('category' | 'item' | 'optionItem' | 'qty' | BasketItemOptionKeySpecifier)[];
export type BasketItemOptionFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	optionItem?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BasketSubtotalBreakdownKeySpecifier = ('subtotal' | 'subtotalExTax' | 'taxRateTotalBreakdown' | 'taxValue' | BasketSubtotalBreakdownKeySpecifier)[];
export type BasketSubtotalBreakdownFieldPolicy = {
	subtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotalExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRateTotalBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BasketTaxRateTotalKeySpecifier = ('itemValue' | 'rate' | 'taxValue' | BasketTaxRateTotalKeySpecifier)[];
export type BasketTaxRateTotalFieldPolicy = {
	itemValue?: FieldPolicy<any> | FieldReadFunction<any>,
	rate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BillingAddressKeySpecifier = ('alias' | 'city' | 'country' | 'line1' | 'line2' | 'postcode' | BillingAddressKeySpecifier)[];
export type BillingAddressFieldPolicy = {
	alias?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	line1?: FieldPolicy<any> | FieldReadFunction<any>,
	line2?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BillingContactKeySpecifier = ('email' | 'firstName' | 'lastName' | 'locale' | 'tenantId' | BillingContactKeySpecifier)[];
export type BillingContactFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BillingDetailsKeySpecifier = ('address' | 'contact' | 'vatNumber' | BillingDetailsKeySpecifier)[];
export type BillingDetailsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	vatNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BillingEntityKeySpecifier = ('address' | 'bankAccountData' | 'businessNumber' | 'code' | 'companyNumber' | 'countryCode' | 'email' | 'id' | 'name' | 'phone' | 'taxNumber' | 'tenantId' | 'vatNumber' | 'vatRegion' | 'vatRegionId' | BillingEntityKeySpecifier)[];
export type BillingEntityFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	bankAccountData?: FieldPolicy<any> | FieldReadFunction<any>,
	businessNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	companyNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	taxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	vatNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlockedMenuItemDeletionKeySpecifier = ('id' | 'linkedItemNames' | 'name' | 'reason' | BlockedMenuItemDeletionKeySpecifier)[];
export type BlockedMenuItemDeletionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedItemNames?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkMenuItemMutationResponseKeySpecifier = ('failedIds' | 'successfulIds' | BulkMenuItemMutationResponseKeySpecifier)[];
export type BulkMenuItemMutationResponseFieldPolicy = {
	failedIds?: FieldPolicy<any> | FieldReadFunction<any>,
	successfulIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCAccountKeySpecifier = ('id' | 'name' | CCAccountKeySpecifier)[];
export type CCAccountFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCAccountLocationKeySpecifier = ('address' | 'id' | 'timezone' | CCAccountLocationKeySpecifier)[];
export type CCAccountLocationFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCAccountLocationOrderKeySpecifier = ('accountLocation' | 'id' | CCAccountLocationOrderKeySpecifier)[];
export type CCAccountLocationOrderFieldPolicy = {
	accountLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCAccountOrderKeySpecifier = ('accountLocation' | 'date' | 'id' | 'isClosed' | 'items' | 'meal' | 'orderOpeningTime' | 'publishedVendors' | CCAccountOrderKeySpecifier)[];
export type CCAccountOrderFieldPolicy = {
	accountLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isClosed?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	orderOpeningTime?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedVendors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCAccountOrdersPagedKeySpecifier = ('orders' | 'pageInfo' | CCAccountOrdersPagedKeySpecifier)[];
export type CCAccountOrdersPagedFieldPolicy = {
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCAvailabilitiesPagedKeySpecifier = ('pageInfo' | 'rows' | CCAvailabilitiesPagedKeySpecifier)[];
export type CCAvailabilitiesPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCAvailabilityKeySpecifier = ('accountLocationId' | 'arrivalTime' | 'avgOrders' | 'clusterId' | 'createdAt' | 'deletedAt' | 'duration' | 'id' | 'maxOrders' | 'meal' | 'minOrders' | 'updatedAt' | 'vendorQty' | 'weekday' | CCAvailabilityKeySpecifier)[];
export type CCAvailabilityFieldPolicy = {
	accountLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	arrivalTime?: FieldPolicy<any> | FieldReadFunction<any>,
	avgOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	clusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	minOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorQty?: FieldPolicy<any> | FieldReadFunction<any>,
	weekday?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCClusterKeySpecifier = ('accountLocations' | 'ccSupplierOrders' | 'code' | 'id' | 'name' | CCClusterKeySpecifier)[];
export type CCClusterFieldPolicy = {
	accountLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	ccSupplierOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCClustersPagedKeySpecifier = ('pageInfo' | 'rows' | CCClustersPagedKeySpecifier)[];
export type CCClustersPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCDateMealServiceDataKeySpecifier = ('breakfast' | 'date' | 'dinner' | 'lunch' | CCDateMealServiceDataKeySpecifier)[];
export type CCDateMealServiceDataFieldPolicy = {
	breakfast?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	dinner?: FieldPolicy<any> | FieldReadFunction<any>,
	lunch?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCInvoiceKeySpecifier = ('account' | 'accountLocation' | 'additionalItemsTaxInvoiceNumber' | 'additionalTotal' | 'additionalTotalExVat' | 'additionalTotalVat' | 'additionalVatSummary' | 'amountDue' | 'amountPaid' | 'asset' | 'assets' | 'billingDetails' | 'billingEntity' | 'budgetCode' | 'canApprove' | 'canCancel' | 'canPay' | 'currency' | 'dueDate' | 'friendlyId' | 'id' | 'isAlreadyApproved' | 'issueDate' | 'items' | 'mealsDonated' | 'overdue' | 'paymentHistory' | 'paymentStatus' | 'periodEnd' | 'periodStart' | 'status' | 'supplierOrderBreakdown' | 'total' | 'totalExVat' | 'totalQuantity' | 'totalVat' | 'type' | 'vatRegion' | 'vatSummary' | CCInvoiceKeySpecifier)[];
export type CCInvoiceFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalItemsTaxInvoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalTotalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalTotalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalVatSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	amountDue?: FieldPolicy<any> | FieldReadFunction<any>,
	amountPaid?: FieldPolicy<any> | FieldReadFunction<any>,
	asset?: FieldPolicy<any> | FieldReadFunction<any>,
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	billingDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	billingEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	budgetCode?: FieldPolicy<any> | FieldReadFunction<any>,
	canApprove?: FieldPolicy<any> | FieldReadFunction<any>,
	canCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	canPay?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	friendlyId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAlreadyApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	issueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	mealsDonated?: FieldPolicy<any> | FieldReadFunction<any>,
	overdue?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	periodEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	periodStart?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierOrderBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	vatSummary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMealServiceKeySpecifier = ('availableSubsidy' | 'closeTime' | 'id' | 'meal' | 'menuIsPublished' | 'openTime' | 'orderAgainItems' | 'orderedItems' | 'timeslots' | CCMealServiceKeySpecifier)[];
export type CCMealServiceFieldPolicy = {
	availableSubsidy?: FieldPolicy<any> | FieldReadFunction<any>,
	closeTime?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	menuIsPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	openTime?: FieldPolicy<any> | FieldReadFunction<any>,
	orderAgainItems?: FieldPolicy<any> | FieldReadFunction<any>,
	orderedItems?: FieldPolicy<any> | FieldReadFunction<any>,
	timeslots?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMealServiceOrderedItemsKeySpecifier = ('items' | 'orderPlaced' | CCMealServiceOrderedItemsKeySpecifier)[];
export type CCMealServiceOrderedItemsFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	orderPlaced?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMealServiceTimeslotKeySpecifier = ('endTime' | 'id' | 'isPostOrdersCloseTime' | 'isPreOrdersOpenTime' | 'orderedItems' | 'ordersAreOpen' | 'ordersCloseTime' | 'ordersOpenTime' | 'startTime' | 'vendorMenus' | CCMealServiceTimeslotKeySpecifier)[];
export type CCMealServiceTimeslotFieldPolicy = {
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPostOrdersCloseTime?: FieldPolicy<any> | FieldReadFunction<any>,
	isPreOrdersOpenTime?: FieldPolicy<any> | FieldReadFunction<any>,
	orderedItems?: FieldPolicy<any> | FieldReadFunction<any>,
	ordersAreOpen?: FieldPolicy<any> | FieldReadFunction<any>,
	ordersCloseTime?: FieldPolicy<any> | FieldReadFunction<any>,
	ordersOpenTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorMenus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMealTimeslotKeySpecifier = ('endTime' | 'ordersAreOpen' | 'ordersCloseTime' | 'ordersOpenTime' | 'startTime' | CCMealTimeslotKeySpecifier)[];
export type CCMealTimeslotFieldPolicy = {
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	ordersAreOpen?: FieldPolicy<any> | FieldReadFunction<any>,
	ordersCloseTime?: FieldPolicy<any> | FieldReadFunction<any>,
	ordersOpenTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMealVendorKeySpecifier = ('arrivalTime' | 'arrivalTimeEnd' | 'id' | 'vendor' | CCMealVendorKeySpecifier)[];
export type CCMealVendorFieldPolicy = {
	arrivalTime?: FieldPolicy<any> | FieldReadFunction<any>,
	arrivalTimeEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMenuDebugResponseKeySpecifier = ('results' | CCMenuDebugResponseKeySpecifier)[];
export type CCMenuDebugResponseFieldPolicy = {
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMenuDebugTestKeySpecifier = ('description' | 'id' | 'isSuccessful' | CCMenuDebugTestKeySpecifier)[];
export type CCMenuDebugTestFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSuccessful?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMenuDebugTestAllocationsKeySpecifier = ('ccSubmenuAllocations' | 'description' | 'id' | 'isSuccessful' | CCMenuDebugTestAllocationsKeySpecifier)[];
export type CCMenuDebugTestAllocationsFieldPolicy = {
	ccSubmenuAllocations?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSuccessful?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMenuDebugTestAvailabilitiesKeySpecifier = ('ccAvailabilities' | 'description' | 'id' | 'isSuccessful' | CCMenuDebugTestAvailabilitiesKeySpecifier)[];
export type CCMenuDebugTestAvailabilitiesFieldPolicy = {
	ccAvailabilities?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSuccessful?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMenuDebugTestCCSupplierOrderKeySpecifier = ('ccSupplierOrders' | 'description' | 'id' | 'isSuccessful' | CCMenuDebugTestCCSupplierOrderKeySpecifier)[];
export type CCMenuDebugTestCCSupplierOrderFieldPolicy = {
	ccSupplierOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSuccessful?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMenuDebugTestClusterAssignmentKeySpecifier = ('ccCluster' | 'description' | 'id' | 'isSuccessful' | CCMenuDebugTestClusterAssignmentKeySpecifier)[];
export type CCMenuDebugTestClusterAssignmentFieldPolicy = {
	ccCluster?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSuccessful?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMenuItemKeySpecifier = ('id' | 'liveMenuItem' | 'liveVariation' | 'minimumPurchasablePrice' | 'quantityRemaining' | 'submenuId' | 'vendorLocationId' | CCMenuItemKeySpecifier)[];
export type CCMenuItemFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	liveMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	liveVariation?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumPurchasablePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityRemaining?: FieldPolicy<any> | FieldReadFunction<any>,
	submenuId?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorLocationId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCMenuQueryResultKeySpecifier = ('date' | 'id' | 'mealServiceData' | CCMenuQueryResultKeySpecifier)[];
export type CCMenuQueryResultFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mealServiceData?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCOrderAddressKeySpecifier = ('city' | 'instructions' | 'lat' | 'line1' | 'line2' | 'line3' | 'lng' | 'location' | 'phone' | 'postcode' | 'what3words' | CCOrderAddressKeySpecifier)[];
export type CCOrderAddressFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	instructions?: FieldPolicy<any> | FieldReadFunction<any>,
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	line1?: FieldPolicy<any> | FieldReadFunction<any>,
	line2?: FieldPolicy<any> | FieldReadFunction<any>,
	line3?: FieldPolicy<any> | FieldReadFunction<any>,
	lng?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	what3words?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCOrderAgainItemKeySpecifier = ('averageRating' | 'itemReference' | 'menuItemVariation' | 'orderCount' | 'submenuId' | 'vendor' | 'vendorLocation' | CCOrderAgainItemKeySpecifier)[];
export type CCOrderAgainItemFieldPolicy = {
	averageRating?: FieldPolicy<any> | FieldReadFunction<any>,
	itemReference?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemVariation?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	submenuId?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorLocation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCOrderConfirmationKeySpecifier = ('address' | 'currency' | 'date' | 'hidePrices' | 'items' | 'itemsByVendor' | 'meal' | 'personalCreditsUsed' | 'reference' | 'subsidyCreditsUsed' | 'subtotal' | 'timeSlot' | 'total' | CCOrderConfirmationKeySpecifier)[];
export type CCOrderConfirmationFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	hidePrices?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	itemsByVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	personalCreditsUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidyCreditsUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	timeSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCOrderItemKeySpecifier = ('accountLocation' | 'accountLocationId' | 'allergen_celery' | 'allergen_cereals' | 'allergen_crustaceans' | 'allergen_eggs' | 'allergen_fish' | 'allergen_lupin' | 'allergen_milk' | 'allergen_molluscs' | 'allergen_mustard' | 'allergen_nuts' | 'allergen_peanuts' | 'allergen_sesame' | 'allergen_soybeans' | 'allergen_sulphur' | 'allergens' | 'amountSubsidised' | 'availableItemReferences' | 'availableItems' | 'canCancel' | 'category' | 'ccSupplierOrder' | 'chargeVendorRefund' | 'commissionRate' | 'costCentre' | 'creditRefund' | 'cuisine' | 'date' | 'description' | 'dietaries' | 'dietary_halal' | 'dietary_kosher' | 'dietary_refined_sugar' | 'dietary_vegan' | 'dietary_vegetarian' | 'feedback' | 'fullPrice' | 'id' | 'isCollected' | 'itemReference' | 'liveMenuItem' | 'meal' | 'mealDealId' | 'mealType' | 'name' | 'notes' | 'options' | 'originalUnitPrice' | 'price' | 'promotionId' | 'promotionType' | 'promotionValue' | 'qty' | 'ratedAt' | 'rating' | 'showOnMenu' | 'subAllergens' | 'sub_allergen_cereals_barley' | 'sub_allergen_cereals_kamut' | 'sub_allergen_cereals_oats' | 'sub_allergen_cereals_rye' | 'sub_allergen_cereals_wheat' | 'sub_allergen_nuts_almonds' | 'sub_allergen_nuts_brazil' | 'sub_allergen_nuts_cashew' | 'sub_allergen_nuts_hazelnuts' | 'sub_allergen_nuts_macadamia' | 'sub_allergen_nuts_pecan' | 'sub_allergen_nuts_pistachio' | 'sub_allergen_nuts_walnuts' | 'subsidyQtyInclusive' | 'subsidyRefund' | 'supplierUnitPrice' | 'supplierUnitPriceExTax' | 'transactionId' | 'type' | 'unitPrice' | 'user' | 'userId' | 'vat' | 'vendor' | CCOrderItemKeySpecifier)[];
export type CCOrderItemFieldPolicy = {
	accountLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_celery?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_cereals?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_crustaceans?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_eggs?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_fish?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_lupin?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_milk?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_molluscs?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_mustard?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_nuts?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_peanuts?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_sesame?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_soybeans?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_sulphur?: FieldPolicy<any> | FieldReadFunction<any>,
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	amountSubsidised?: FieldPolicy<any> | FieldReadFunction<any>,
	availableItemReferences?: FieldPolicy<any> | FieldReadFunction<any>,
	availableItems?: FieldPolicy<any> | FieldReadFunction<any>,
	canCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	ccSupplierOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	chargeVendorRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	commissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	costCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	creditRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	cuisine?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	dietaries?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_halal?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_kosher?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_refined_sugar?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_vegan?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_vegetarian?: FieldPolicy<any> | FieldReadFunction<any>,
	feedback?: FieldPolicy<any> | FieldReadFunction<any>,
	fullPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCollected?: FieldPolicy<any> | FieldReadFunction<any>,
	itemReference?: FieldPolicy<any> | FieldReadFunction<any>,
	liveMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	mealDealId?: FieldPolicy<any> | FieldReadFunction<any>,
	mealType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	originalUnitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionId?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionType?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionValue?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	ratedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	rating?: FieldPolicy<any> | FieldReadFunction<any>,
	showOnMenu?: FieldPolicy<any> | FieldReadFunction<any>,
	subAllergens?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_cereals_barley?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_cereals_kamut?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_cereals_oats?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_cereals_rye?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_cereals_wheat?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_almonds?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_brazil?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_cashew?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_hazelnuts?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_macadamia?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_pecan?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_pistachio?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_walnuts?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidyQtyInclusive?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidyRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierUnitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierUnitPriceExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>,
	vat?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCOrderItemOptionKeySpecifier = ('allergen_celery' | 'allergen_cereals' | 'allergen_crustaceans' | 'allergen_eggs' | 'allergen_fish' | 'allergen_lupin' | 'allergen_milk' | 'allergen_molluscs' | 'allergen_mustard' | 'allergen_nuts' | 'allergen_peanuts' | 'allergen_sesame' | 'allergen_soybeans' | 'allergen_sulphur' | 'allergens' | 'category' | 'commissionRate' | 'description' | 'dietaries' | 'dietary_halal' | 'dietary_kosher' | 'dietary_refined_sugar' | 'dietary_vegan' | 'dietary_vegetarian' | 'id' | 'liveMenuItem' | 'name' | 'position' | 'price' | 'qty' | 'subAllergens' | 'sub_allergen_cereals_barley' | 'sub_allergen_cereals_kamut' | 'sub_allergen_cereals_oats' | 'sub_allergen_cereals_rye' | 'sub_allergen_cereals_wheat' | 'sub_allergen_nuts_almonds' | 'sub_allergen_nuts_brazil' | 'sub_allergen_nuts_cashew' | 'sub_allergen_nuts_hazelnuts' | 'sub_allergen_nuts_macadamia' | 'sub_allergen_nuts_pecan' | 'sub_allergen_nuts_pistachio' | 'sub_allergen_nuts_walnuts' | 'supplierUnitPrice' | 'supplierUnitPriceExTax' | 'unitPrice' | 'vat' | CCOrderItemOptionKeySpecifier)[];
export type CCOrderItemOptionFieldPolicy = {
	allergen_celery?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_cereals?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_crustaceans?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_eggs?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_fish?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_lupin?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_milk?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_molluscs?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_mustard?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_nuts?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_peanuts?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_sesame?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_soybeans?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_sulphur?: FieldPolicy<any> | FieldReadFunction<any>,
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	commissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	dietaries?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_halal?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_kosher?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_refined_sugar?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_vegan?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_vegetarian?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	liveMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	subAllergens?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_cereals_barley?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_cereals_kamut?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_cereals_oats?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_cereals_rye?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_cereals_wheat?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_almonds?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_brazil?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_cashew?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_hazelnuts?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_macadamia?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_pecan?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_pistachio?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts_walnuts?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierUnitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierUnitPriceExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	vat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCOrderItemOptionsKeySpecifier = ('items' | CCOrderItemOptionsKeySpecifier)[];
export type CCOrderItemOptionsFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCOrderItemsPagedKeySpecifier = ('pageInfo' | 'rows' | CCOrderItemsPagedKeySpecifier)[];
export type CCOrderItemsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCOrderPrintPdfResponseKeySpecifier = ('url' | CCOrderPrintPdfResponseKeySpecifier)[];
export type CCOrderPrintPdfResponseFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCOrderProgressResponseKeySpecifier = ('continuationUri' | 'detail' | 'initiationId' | 'paymentId' | 'paymentToken' | 'status' | 'transactionId' | CCOrderProgressResponseKeySpecifier)[];
export type CCOrderProgressResponseFieldPolicy = {
	continuationUri?: FieldPolicy<any> | FieldReadFunction<any>,
	detail?: FieldPolicy<any> | FieldReadFunction<any>,
	initiationId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentToken?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCOrderReminderNotificationKeySpecifier = ('accountId' | 'accountLocationIdArray' | 'createdAt' | 'cutOffTime' | 'date' | 'id' | 'meal' | 'notificationStatus' | 'sendTime' | 'timezone' | 'type' | 'updatedAt' | 'vendors' | CCOrderReminderNotificationKeySpecifier)[];
export type CCOrderReminderNotificationFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationIdArray?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	cutOffTime?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	sendTime?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	vendors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCOrderReminderNotificationVendorKeySpecifier = ('id' | 'imageUrl' | 'keywords' | 'name' | 'quote' | CCOrderReminderNotificationVendorKeySpecifier)[];
export type CCOrderReminderNotificationVendorFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	keywords?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	quote?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCOrderTimeSlotKeySpecifier = ('end' | 'start' | CCOrderTimeSlotKeySpecifier)[];
export type CCOrderTimeSlotFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSubmenuKeySpecifier = ('copiable' | 'createdAt' | 'description' | 'id' | 'isActive' | 'isUsedLive' | 'items' | 'liveAllocations' | 'locationCapacities' | 'maxCapacity' | 'name' | 'publicName' | 'statistics' | 'tenantId' | 'updatedAt' | 'vendor' | 'visibleToClient' | CCSubmenuKeySpecifier)[];
export type CCSubmenuFieldPolicy = {
	copiable?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isUsedLive?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	liveAllocations?: FieldPolicy<any> | FieldReadFunction<any>,
	locationCapacities?: FieldPolicy<any> | FieldReadFunction<any>,
	maxCapacity?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publicName?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleToClient?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSubmenuAllocationKeySpecifier = ('ccCluster' | 'date' | 'id' | 'meal' | 'submenuId' | 'vendorLocation' | CCSubmenuAllocationKeySpecifier)[];
export type CCSubmenuAllocationFieldPolicy = {
	ccCluster?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	submenuId?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorLocation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSubmenuItemKeySpecifier = ('ccVariationId' | 'coreItem' | 'deletedCoreItem' | 'id' | 'itemCoreId' | 'menuItemVariation' | 'position' | 'submenu' | CCSubmenuItemKeySpecifier)[];
export type CCSubmenuItemFieldPolicy = {
	ccVariationId?: FieldPolicy<any> | FieldReadFunction<any>,
	coreItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedCoreItem?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCoreId?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemVariation?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	submenu?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSubmenuItemStatisticsKeySpecifier = ('count' | 'maxPrice' | 'minPrice' | CCSubmenuItemStatisticsKeySpecifier)[];
export type CCSubmenuItemStatisticsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	maxPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSubmenuItemsKeySpecifier = ('data' | 'submenuId' | CCSubmenuItemsKeySpecifier)[];
export type CCSubmenuItemsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	submenuId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSubmenuLocationCapacityKeySpecifier = ('maxCapacity' | 'vendorLocation' | CCSubmenuLocationCapacityKeySpecifier)[];
export type CCSubmenuLocationCapacityFieldPolicy = {
	maxCapacity?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorLocation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSubmenuStatisticsKeySpecifier = ('drinks' | 'mains' | 'sides' | CCSubmenuStatisticsKeySpecifier)[];
export type CCSubmenuStatisticsFieldPolicy = {
	drinks?: FieldPolicy<any> | FieldReadFunction<any>,
	mains?: FieldPolicy<any> | FieldReadFunction<any>,
	sides?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSubmenusPagedKeySpecifier = ('pageInfo' | 'rows' | CCSubmenusPagedKeySpecifier)[];
export type CCSubmenusPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSubsidyKeySpecifier = ('accountLocationId' | 'createdAt' | 'deletedAt' | 'id' | 'meal' | 'subsidy' | 'teamId' | 'type' | 'updatedAt' | 'weekday' | CCSubsidyKeySpecifier)[];
export type CCSubsidyFieldPolicy = {
	accountLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidy?: FieldPolicy<any> | FieldReadFunction<any>,
	teamId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	weekday?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSupplierOrderKeySpecifier = ('account' | 'accountId' | 'arrivalTime' | 'arrivalTimeEnd' | 'autoSendTime' | 'bookingStatus' | 'ccAccountLocationOrders' | 'ccCluster' | 'ccOrderItems' | 'ccSupplierOrderReferenceFieldValues' | 'clusterId' | 'confirmed' | 'cutOffTime' | 'date' | 'duration' | 'highRisk' | 'id' | 'isCollection' | 'latestProgressStatus' | 'maxOrders' | 'meal' | 'menuId' | 'minOrders' | 'minutesLate' | 'notes' | 'orderTotalBreakdown' | 'pickupTime' | 'primaryContact' | 'reference' | 'refunds' | 'supplierId' | 'supplierLocationId' | 'thermalBoxes' | 'transport' | 'vendor' | 'vendorCharges' | 'vendorLocation' | CCSupplierOrderKeySpecifier)[];
export type CCSupplierOrderFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	arrivalTime?: FieldPolicy<any> | FieldReadFunction<any>,
	arrivalTimeEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	autoSendTime?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	ccAccountLocationOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	ccCluster?: FieldPolicy<any> | FieldReadFunction<any>,
	ccOrderItems?: FieldPolicy<any> | FieldReadFunction<any>,
	ccSupplierOrderReferenceFieldValues?: FieldPolicy<any> | FieldReadFunction<any>,
	clusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	cutOffTime?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	highRisk?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	latestProgressStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	maxOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	menuId?: FieldPolicy<any> | FieldReadFunction<any>,
	minOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	minutesLate?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	orderTotalBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	pickupTime?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryContact?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	thermalBoxes?: FieldPolicy<any> | FieldReadFunction<any>,
	transport?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorLocation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSupplierOrderBreakdownKeySpecifier = ('accountLocationOrderId' | 'arrivalTime' | 'date' | 'items' | 'meal' | 'quantity' | 'supplierAddress' | 'supplierName' | 'supplierVatNumber' | 'taxInvoiceNumber' | 'total' | 'totalExVat' | 'totalVat' | 'vatSummary' | CCSupplierOrderBreakdownKeySpecifier)[];
export type CCSupplierOrderBreakdownFieldPolicy = {
	accountLocationOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	arrivalTime?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierName?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierVatNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	taxInvoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	vatSummary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSupplierOrderBreakdownPagedKeySpecifier = ('orders' | 'pageInfo' | 'vatSummary' | CCSupplierOrderBreakdownPagedKeySpecifier)[];
export type CCSupplierOrderBreakdownPagedFieldPolicy = {
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	vatSummary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSupplierOrderBreakdownVatKeySpecifier = ('quantity' | 'total' | 'totalExVat' | 'totalVat' | 'vatRate' | CCSupplierOrderBreakdownVatKeySpecifier)[];
export type CCSupplierOrderBreakdownVatFieldPolicy = {
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSupplierOrderContactKeySpecifier = ('email' | 'name' | 'phone' | CCSupplierOrderContactKeySpecifier)[];
export type CCSupplierOrderContactFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSupplierOrderPagedKeySpecifier = ('pageInfo' | 'rows' | CCSupplierOrderPagedKeySpecifier)[];
export type CCSupplierOrderPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSupplierOrderReferenceFieldOptionKeySpecifier = ('id' | 'option' | 'orderPriority' | 'orderReferenceFieldId' | CCSupplierOrderReferenceFieldOptionKeySpecifier)[];
export type CCSupplierOrderReferenceFieldOptionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	option?: FieldPolicy<any> | FieldReadFunction<any>,
	orderPriority?: FieldPolicy<any> | FieldReadFunction<any>,
	orderReferenceFieldId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSupplierOrderReferenceFieldValueKeySpecifier = ('ccSupplierOrderReferenceFieldId' | 'description' | 'fieldType' | 'isRequired' | 'label' | 'options' | 'orderReferenceFieldId' | 'value' | 'version' | CCSupplierOrderReferenceFieldValueKeySpecifier)[];
export type CCSupplierOrderReferenceFieldValueFieldPolicy = {
	ccSupplierOrderReferenceFieldId?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldType?: FieldPolicy<any> | FieldReadFunction<any>,
	isRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	orderReferenceFieldId?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCSupplierOrderStatusKeySpecifier = ('id' | 'status' | 'timestamp' | CCSupplierOrderStatusKeySpecifier)[];
export type CCSupplierOrderStatusFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCTeamKeySpecifier = ('accountId' | 'code' | 'createdAt' | 'deletedAt' | 'id' | 'name' | 'subsidies' | 'updatedAt' | 'users' | CCTeamKeySpecifier)[];
export type CCTeamFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidies?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCTransactionKeySpecifier = ('amount' | 'createdAt' | 'currency' | 'date' | 'description' | 'id' | 'meal' | 'transactionId' | 'type' | 'updatedAt' | 'userId' | CCTransactionKeySpecifier)[];
export type CCTransactionFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCTransactionsPagedKeySpecifier = ('pageInfo' | 'rows' | CCTransactionsPagedKeySpecifier)[];
export type CCTransactionsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCUserOrderKeySpecifier = ('accountLocation' | 'date' | 'id' | 'isClosed' | 'items' | 'meal' | 'orderOpeningTime' | 'user' | CCUserOrderKeySpecifier)[];
export type CCUserOrderFieldPolicy = {
	accountLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isClosed?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	orderOpeningTime?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCUserOrdersPagedKeySpecifier = ('orders' | 'pageInfo' | CCUserOrdersPagedKeySpecifier)[];
export type CCUserOrdersPagedFieldPolicy = {
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCVendorMenuKeySpecifier = ('id' | 'menuItems' | 'vendor' | CCVendorMenuKeySpecifier)[];
export type CCVendorMenuFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItems?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCVendorMenuItemsKeySpecifier = ('cacheKey' | 'cacheKeys' | 'id' | 'items' | 'pageInfo' | 'stats' | CCVendorMenuItemsKeySpecifier)[];
export type CCVendorMenuItemsFieldPolicy = {
	cacheKey?: FieldPolicy<any> | FieldReadFunction<any>,
	cacheKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	stats?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CCVendorMenuItemsStatsKeySpecifier = ('allergens' | 'cacheKey' | 'dietaries' | 'id' | CCVendorMenuItemsStatsKeySpecifier)[];
export type CCVendorMenuItemsStatsFieldPolicy = {
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	cacheKey?: FieldPolicy<any> | FieldReadFunction<any>,
	dietaries?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaterdeskApiAccountAccessKeySpecifier = ('accountContactId' | 'accountId' | CaterdeskApiAccountAccessKeySpecifier)[];
export type CaterdeskApiAccountAccessFieldPolicy = {
	accountContactId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaterdeskApiScopeKeySpecifier = ('access' | 'createdAt' | 'deletedAt' | 'id' | 'resourcePathPattern' | 'scope' | 'updatedAt' | CaterdeskApiScopeKeySpecifier)[];
export type CaterdeskApiScopeFieldPolicy = {
	access?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	resourcePathPattern?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaterdeskApiScopeResponseKeySpecifier = ('caterdeskApiScopes' | CaterdeskApiScopeResponseKeySpecifier)[];
export type CaterdeskApiScopeResponseFieldPolicy = {
	caterdeskApiScopes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaterdeskApiSetPasswordResponseKeySpecifier = ('password' | CaterdeskApiSetPasswordResponseKeySpecifier)[];
export type CaterdeskApiSetPasswordResponseFieldPolicy = {
	password?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaterdeskApiUserKeySpecifier = ('accounts' | 'createdAt' | 'deletedAt' | 'details' | 'email' | 'id' | 'isActive' | 'passwordUpdatedAt' | 'roles' | 'scopes' | 'tenantAdminId' | 'tenantId' | 'updatedAt' | 'vendors' | CaterdeskApiUserKeySpecifier)[];
export type CaterdeskApiUserFieldPolicy = {
	accounts?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	passwordUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	scopes?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminId?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	vendors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaterdeskApiUserResponseKeySpecifier = ('user' | CaterdeskApiUserResponseKeySpecifier)[];
export type CaterdeskApiUserResponseFieldPolicy = {
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaterdeskApiUserScopeKeySpecifier = ('access' | 'scope' | CaterdeskApiUserScopeKeySpecifier)[];
export type CaterdeskApiUserScopeFieldPolicy = {
	access?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaterdeskApiUsersPagedKeySpecifier = ('pageInfo' | 'rows' | CaterdeskApiUsersPagedKeySpecifier)[];
export type CaterdeskApiUsersPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaterdeskApiVendorAccessKeySpecifier = ('vendorContactId' | 'vendorId' | CaterdeskApiVendorAccessKeySpecifier)[];
export type CaterdeskApiVendorAccessFieldPolicy = {
	vendorContactId?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CateringMenuCompositionKeySpecifier = ('activeItems' | 'addOns' | 'categoryCount' | 'draftItems' | 'inReviewItems' | 'inactiveItems' | 'items' | 'totalItems' | 'vendorId' | CateringMenuCompositionKeySpecifier)[];
export type CateringMenuCompositionFieldPolicy = {
	activeItems?: FieldPolicy<any> | FieldReadFunction<any>,
	addOns?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryCount?: FieldPolicy<any> | FieldReadFunction<any>,
	draftItems?: FieldPolicy<any> | FieldReadFunction<any>,
	inReviewItems?: FieldPolicy<any> | FieldReadFunction<any>,
	inactiveItems?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	totalItems?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcOrderTaxBreakdownKeySpecifier = ('taxRateTotals' | 'taxValue' | 'totalExTax' | 'totalIncTax' | CcOrderTaxBreakdownKeySpecifier)[];
export type CcOrderTaxBreakdownFieldPolicy = {
	taxRateTotals?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalIncTax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcOrderTaxRateTotalKeySpecifier = ('rate' | 'taxValue' | 'totalExTax' | 'totalIncTax' | CcOrderTaxRateTotalKeySpecifier)[];
export type CcOrderTaxRateTotalFieldPolicy = {
	rate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalIncTax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcWeeklyReminderEligibleSiteKeySpecifier = ('accountId' | 'accountLocationId' | 'recipientCount' | CcWeeklyReminderEligibleSiteKeySpecifier)[];
export type CcWeeklyReminderEligibleSiteFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcWeeklyReminderEmailOutcomeKeySpecifier = ('accountId' | 'accountLocationId' | 'auditId' | 'batchRunId' | 'createdAt' | 'dispatchJobId' | 'error' | 'firstName' | 'lastName' | 'locale' | 'outcome' | 'tenantId' | 'userEmail' | CcWeeklyReminderEmailOutcomeKeySpecifier)[];
export type CcWeeklyReminderEmailOutcomeFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	auditId?: FieldPolicy<any> | FieldReadFunction<any>,
	batchRunId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dispatchJobId?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	outcome?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	userEmail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcWeeklyReminderExcludedLocationKeySpecifier = ('accountId' | 'accountLocationId' | 'batchRunId' | 'reason' | 'recipientCount' | 'timezone' | CcWeeklyReminderExcludedLocationKeySpecifier)[];
export type CcWeeklyReminderExcludedLocationFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	batchRunId?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientCount?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcWeeklyReminderLocationDeliveryKeySpecifier = ('accountId' | 'accountLocationId' | 'batchRunId' | 'emailFailedCount' | 'emailSentCount' | 'pushFailedCount' | 'pushSentCount' | CcWeeklyReminderLocationDeliveryKeySpecifier)[];
export type CcWeeklyReminderLocationDeliveryFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	batchRunId?: FieldPolicy<any> | FieldReadFunction<any>,
	emailFailedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	emailSentCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pushFailedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pushSentCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcWeeklyReminderLocationFailureKeySpecifier = ('accountId' | 'accountLocationId' | 'batchRunId' | 'error' | 'phase' | 'serviceDates' | CcWeeklyReminderLocationFailureKeySpecifier)[];
export type CcWeeklyReminderLocationFailureFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	batchRunId?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	phase?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceDates?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcWeeklyReminderMenuLoadFailureKeySpecifier = ('accountId' | 'accountLocationId' | 'batchRunId' | 'error' | 'recipientCount' | CcWeeklyReminderMenuLoadFailureKeySpecifier)[];
export type CcWeeklyReminderMenuLoadFailureFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	batchRunId?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcWeeklyReminderPushOutcomeKeySpecifier = ('accountId' | 'accountLocationId' | 'auditId' | 'batchRunId' | 'createdAt' | 'dispatchJobId' | 'error' | 'firstName' | 'lastName' | 'outcome' | 'tenantId' | 'userEmail' | CcWeeklyReminderPushOutcomeKeySpecifier)[];
export type CcWeeklyReminderPushOutcomeFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	auditId?: FieldPolicy<any> | FieldReadFunction<any>,
	batchRunId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dispatchJobId?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	outcome?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	userEmail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcWeeklyReminderReadyLocationKeySpecifier = ('accountId' | 'accountLocationId' | 'allocationCount' | 'batchRunId' | 'emailRecipientCount' | 'pushRecipientCount' | 'recipientCount' | 'timezone' | CcWeeklyReminderReadyLocationKeySpecifier)[];
export type CcWeeklyReminderReadyLocationFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	allocationCount?: FieldPolicy<any> | FieldReadFunction<any>,
	batchRunId?: FieldPolicy<any> | FieldReadFunction<any>,
	emailRecipientCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pushRecipientCount?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientCount?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcWeeklyReminderReportKeySpecifier = ('emailOutcomes' | 'emailOutcomesTruncated' | 'outcomeRowsLimit' | 'pushOutcomes' | 'pushOutcomesTruncated' | 'queryWindowEnd' | 'queryWindowStart' | 'runs' | 'summary' | 'tenantId' | CcWeeklyReminderReportKeySpecifier)[];
export type CcWeeklyReminderReportFieldPolicy = {
	emailOutcomes?: FieldPolicy<any> | FieldReadFunction<any>,
	emailOutcomesTruncated?: FieldPolicy<any> | FieldReadFunction<any>,
	outcomeRowsLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	pushOutcomes?: FieldPolicy<any> | FieldReadFunction<any>,
	pushOutcomesTruncated?: FieldPolicy<any> | FieldReadFunction<any>,
	queryWindowEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	queryWindowStart?: FieldPolicy<any> | FieldReadFunction<any>,
	runs?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcWeeklyReminderRunKeySpecifier = ('batchRunId' | 'dispatchedLocationCount' | 'dispatchedRecipientsCount' | 'eligibleLocationCount' | 'eligibleRecipientCount' | 'eligibleSites' | 'emailBatchesFailedCount' | 'emailBatchesSentCount' | 'emailRecipientsFailedCount' | 'emailRecipientsSentCount' | 'excludedLocations' | 'finishedAt' | 'locationDeliveries' | 'locationFailureCount' | 'locationFailures' | 'menuLoadFailureCount' | 'menuLoadFailures' | 'noAllocationsLocationCount' | 'noAllocationsRecipientsCount' | 'pushFailedCount' | 'pushSentCount' | 'readyLocations' | 'startedAt' | 'trigger' | CcWeeklyReminderRunKeySpecifier)[];
export type CcWeeklyReminderRunFieldPolicy = {
	batchRunId?: FieldPolicy<any> | FieldReadFunction<any>,
	dispatchedLocationCount?: FieldPolicy<any> | FieldReadFunction<any>,
	dispatchedRecipientsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibleLocationCount?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibleRecipientCount?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibleSites?: FieldPolicy<any> | FieldReadFunction<any>,
	emailBatchesFailedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	emailBatchesSentCount?: FieldPolicy<any> | FieldReadFunction<any>,
	emailRecipientsFailedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	emailRecipientsSentCount?: FieldPolicy<any> | FieldReadFunction<any>,
	excludedLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	finishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	locationDeliveries?: FieldPolicy<any> | FieldReadFunction<any>,
	locationFailureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	locationFailures?: FieldPolicy<any> | FieldReadFunction<any>,
	menuLoadFailureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	menuLoadFailures?: FieldPolicy<any> | FieldReadFunction<any>,
	noAllocationsLocationCount?: FieldPolicy<any> | FieldReadFunction<any>,
	noAllocationsRecipientsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pushFailedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pushSentCount?: FieldPolicy<any> | FieldReadFunction<any>,
	readyLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	startedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	trigger?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcWeeklyReminderSummaryKeySpecifier = ('dispatchedLocationCount' | 'dispatchedRecipientsCount' | 'eligibleLocationCount' | 'eligibleRecipientCount' | 'emailBatchesFailedCount' | 'emailBatchesSentCount' | 'emailRecipientsFailedCount' | 'emailRecipientsSentCount' | 'locationFailureCount' | 'menuLoadFailureCount' | 'noAllocationsRecipientsCount' | 'pushFailedCount' | 'pushSentCount' | 'runCount' | CcWeeklyReminderSummaryKeySpecifier)[];
export type CcWeeklyReminderSummaryFieldPolicy = {
	dispatchedLocationCount?: FieldPolicy<any> | FieldReadFunction<any>,
	dispatchedRecipientsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibleLocationCount?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibleRecipientCount?: FieldPolicy<any> | FieldReadFunction<any>,
	emailBatchesFailedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	emailBatchesSentCount?: FieldPolicy<any> | FieldReadFunction<any>,
	emailRecipientsFailedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	emailRecipientsSentCount?: FieldPolicy<any> | FieldReadFunction<any>,
	locationFailureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	menuLoadFailureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	noAllocationsRecipientsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pushFailedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pushSentCount?: FieldPolicy<any> | FieldReadFunction<any>,
	runCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CityKeySpecifier = ('code' | 'countryCode' | 'name' | CityKeySpecifier)[];
export type CityFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClosestItemKeySpecifier = ('id' | 'minutes' | ClosestItemKeySpecifier)[];
export type ClosestItemFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	minutes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClosestMatchingSupplierLocationsResponseKeySpecifier = ('inside' | 'notFound' | 'outside' | ClosestMatchingSupplierLocationsResponseKeySpecifier)[];
export type ClosestMatchingSupplierLocationsResponseFieldPolicy = {
	inside?: FieldPolicy<any> | FieldReadFunction<any>,
	notFound?: FieldPolicy<any> | FieldReadFunction<any>,
	outside?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConsolidateFlexInvoiceResultKeySpecifier = ('customers' | 'suppliers' | ConsolidateFlexInvoiceResultKeySpecifier)[];
export type ConsolidateFlexInvoiceResultFieldPolicy = {
	customers?: FieldPolicy<any> | FieldReadFunction<any>,
	suppliers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConsolidateFlexInvoiceResultCustomerKeySpecifier = ('message' | 'status' | ConsolidateFlexInvoiceResultCustomerKeySpecifier)[];
export type ConsolidateFlexInvoiceResultCustomerFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConsolidateFlexInvoiceResultSupplierKeySpecifier = ('message' | 'status' | ConsolidateFlexInvoiceResultSupplierKeySpecifier)[];
export type ConsolidateFlexInvoiceResultSupplierFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountryKeySpecifier = ('aliases' | 'code' | 'currency' | 'defaultLanguage' | 'flagImageUri' | 'id' | 'languages' | 'locales' | 'name' | 'requiredTaxFields' | CountryKeySpecifier)[];
export type CountryFieldPolicy = {
	aliases?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultLanguage?: FieldPolicy<any> | FieldReadFunction<any>,
	flagImageUri?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	languages?: FieldPolicy<any> | FieldReadFunction<any>,
	locales?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	requiredTaxFields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CouponKeySpecifier = ('accountId' | 'code' | 'discountNumeric' | 'discountPercentage' | 'id' | 'maxUses' | 'maxUsesPerUser' | 'minOrder' | 'supplierId' | 'uses' | 'validFrom' | 'validUntil' | CouponKeySpecifier)[];
export type CouponFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	discountNumeric?: FieldPolicy<any> | FieldReadFunction<any>,
	discountPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUses?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUsesPerUser?: FieldPolicy<any> | FieldReadFunction<any>,
	minOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	uses?: FieldPolicy<any> | FieldReadFunction<any>,
	validFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	validUntil?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CouponUsesPerUserKeySpecifier = ('coupon' | 'id' | 'user' | 'usesPerUser' | CouponUsesPerUserKeySpecifier)[];
export type CouponUsesPerUserFieldPolicy = {
	coupon?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	usesPerUser?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CouponsPagedKeySpecifier = ('pageInfo' | 'rows' | CouponsPagedKeySpecifier)[];
export type CouponsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreditCardFeeFlagKeySpecifier = ('countryCode' | 'enabled' | CreditCardFeeFlagKeySpecifier)[];
export type CreditCardFeeFlagFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreditTransactionKeySpecifier = ('amount' | 'createdAt' | 'currency' | 'description' | 'id' | 'newBalance' | 'transactionId' | 'type' | 'updatedAt' | 'userId' | CreditTransactionKeySpecifier)[];
export type CreditTransactionFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	newBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreditTransactionsPagedKeySpecifier = ('pageInfo' | 'rows' | CreditTransactionsPagedKeySpecifier)[];
export type CreditTransactionsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrderAmountAggregateKeySpecifier = ('current' | 'previous' | CustomerOrderAmountAggregateKeySpecifier)[];
export type CustomerOrderAmountAggregateFieldPolicy = {
	current?: FieldPolicy<any> | FieldReadFunction<any>,
	previous?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrderCityAggregateKeySpecifier = ('city' | 'orderCount' | 'spend' | CustomerOrderCityAggregateKeySpecifier)[];
export type CustomerOrderCityAggregateFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrderItemKeySpecifier = ('category' | 'label' | 'quantity' | 'subTotal' | 'taxPercentage' | 'total' | 'totalTax' | 'unitPrice' | CustomerOrderItemKeySpecifier)[];
export type CustomerOrderItemFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	subTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	taxPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalTax?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrderLocationAggregateKeySpecifier = ('locationLabel' | 'orderCount' | 'percentage' | 'spend' | CustomerOrderLocationAggregateKeySpecifier)[];
export type CustomerOrderLocationAggregateFieldPolicy = {
	locationLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrderOwnershipAggregateKeySpecifier = ('averageOrderValue' | 'category' | 'orderCount' | 'totalSpend' | CustomerOrderOwnershipAggregateKeySpecifier)[];
export type CustomerOrderOwnershipAggregateFieldPolicy = {
	averageOrderValue?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSpend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrderPostcodeAggregateKeySpecifier = ('orderCount' | 'postcode' | 'spend' | CustomerOrderPostcodeAggregateKeySpecifier)[];
export type CustomerOrderPostcodeAggregateFieldPolicy = {
	orderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrderResultKeySpecifier = ('flexDeferredCustomerOrderId' | 'orderId' | CustomerOrderResultKeySpecifier)[];
export type CustomerOrderResultFieldPolicy = {
	flexDeferredCustomerOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrderServiceTypeAggregateKeySpecifier = ('orderCount' | 'percentage' | 'serviceType' | 'spend' | CustomerOrderServiceTypeAggregateKeySpecifier)[];
export type CustomerOrderServiceTypeAggregateFieldPolicy = {
	orderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceType?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrderTotalsKeySpecifier = ('averageOrderValue' | 'avgPerOrderPerHead' | 'percentageChange' | 'previousPeriodSpend' | 'serviceTypeAggregate' | 'spendPerHead' | 'totalSpend' | CustomerOrderTotalsKeySpecifier)[];
export type CustomerOrderTotalsFieldPolicy = {
	averageOrderValue?: FieldPolicy<any> | FieldReadFunction<any>,
	avgPerOrderPerHead?: FieldPolicy<any> | FieldReadFunction<any>,
	percentageChange?: FieldPolicy<any> | FieldReadFunction<any>,
	previousPeriodSpend?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceTypeAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	spendPerHead?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSpend?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrderUserAggregateKeySpecifier = ('averageOrderValue' | 'numberOfVendors' | 'orderCount' | 'spend' | 'user' | CustomerOrderUserAggregateKeySpecifier)[];
export type CustomerOrderUserAggregateFieldPolicy = {
	averageOrderValue?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfVendors?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	spend?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrderVendorAggregateKeySpecifier = ('averageOrderValue' | 'orderCount' | 'totalSpend' | 'vendor' | CustomerOrderVendorAggregateKeySpecifier)[];
export type CustomerOrderVendorAggregateFieldPolicy = {
	averageOrderValue?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSpend?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrdersAllTypeKeySpecifier = ('contact' | 'deliveryAddress' | 'deliveryCity' | 'deliveryDate' | 'deliveryPostcode' | 'deliveryTime' | 'flexDeferredCustomerOrderId' | 'headCount' | 'invoiceAccountName' | 'locationLabel' | 'orderItems' | 'orderNumber' | 'orderType' | 'referenceFields' | 'serviceType' | 'subTotal' | 'supplierName' | 'supplierTags' | 'timezone' | 'total' | CustomerOrdersAllTypeKeySpecifier)[];
export type CustomerOrdersAllTypeFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryCity?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryPostcode?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryTime?: FieldPolicy<any> | FieldReadFunction<any>,
	flexDeferredCustomerOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	headCount?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceAccountName?: FieldPolicy<any> | FieldReadFunction<any>,
	locationLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	orderItems?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	orderType?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFields?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceType?: FieldPolicy<any> | FieldReadFunction<any>,
	subTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierName?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierTags?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrdersAllTypePagedKeySpecifier = ('items' | 'pageInfo' | CustomerOrdersAllTypePagedKeySpecifier)[];
export type CustomerOrdersAllTypePagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrdersAllTypeWithFlexDataKeySpecifier = ('flexInvoiceNumber' | 'order' | CustomerOrdersAllTypeWithFlexDataKeySpecifier)[];
export type CustomerOrdersAllTypeWithFlexDataFieldPolicy = {
	flexInvoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrdersReportKeySpecifier = ('aggregateByCity' | 'aggregateByLocation' | 'aggregateByOrderType' | 'aggregateByOwnership' | 'aggregateByPeriod' | 'aggregateByPostcode' | 'aggregateByServiceType' | 'aggregateByUser' | 'aggregateByVendor' | 'allOrderTypesWithFlexData' | 'allOrders' | 'allOrdersWithPaging' | 'orderItemsCsv' | 'totals' | CustomerOrdersReportKeySpecifier)[];
export type CustomerOrdersReportFieldPolicy = {
	aggregateByCity?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateByLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateByOrderType?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateByOwnership?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateByPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateByPostcode?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateByServiceType?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateByUser?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateByVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	allOrderTypesWithFlexData?: FieldPolicy<any> | FieldReadFunction<any>,
	allOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	allOrdersWithPaging?: FieldPolicy<any> | FieldReadFunction<any>,
	orderItemsCsv?: FieldPolicy<any> | FieldReadFunction<any>,
	totals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerOrdersSummaryKeySpecifier = ('orderTypeTotals' | 'totalSpend' | 'weeklyTotals' | CustomerOrdersSummaryKeySpecifier)[];
export type CustomerOrdersSummaryFieldPolicy = {
	orderTypeTotals?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSpend?: FieldPolicy<any> | FieldReadFunction<any>,
	weeklyTotals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerPriceItemKeySpecifier = ('customerPriceType' | 'isCustomerFinalPrice' | 'price' | 'priceExTax' | 'priceTaxValue' | CustomerPriceItemKeySpecifier)[];
export type CustomerPriceItemFieldPolicy = {
	customerPriceType?: FieldPolicy<any> | FieldReadFunction<any>,
	isCustomerFinalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceTaxValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteAccountLocationResultKeySpecifier = ('location' | 'message' | 'success' | DeleteAccountLocationResultKeySpecifier)[];
export type DeleteAccountLocationResultFieldPolicy = {
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCCTeamResultKeySpecifier = ('message' | 'success' | DeleteCCTeamResultKeySpecifier)[];
export type DeleteCCTeamResultFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteMenuItemsResponseKeySpecifier = ('blocked' | 'deletedIds' | DeleteMenuItemsResponseKeySpecifier)[];
export type DeleteMenuItemsResponseFieldPolicy = {
	blocked?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryDocketPdfResponseKeySpecifier = ('url' | DeliveryDocketPdfResponseKeySpecifier)[];
export type DeliveryDocketPdfResponseFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryFeeKeySpecifier = ('tax' | 'taxRate' | 'total' | 'totalExTax' | DeliveryFeeKeySpecifier)[];
export type DeliveryFeeFieldPolicy = {
	tax?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExTax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryPartnerKeySpecifier = ('active' | 'id' | 'name' | 'vehicles' | DeliveryPartnerKeySpecifier)[];
export type DeliveryPartnerFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryRegionKeySpecifier = ('deliveryFee' | 'id' | 'minOrderValue' | 'minOrderValueExTax' | 'name' | 'orderPosition' | 'polygonCoordinates' | 'regionType' | 'serviceTimes' | 'serviceType' | 'value' | 'vendorLocationId' | DeliveryRegionKeySpecifier)[];
export type DeliveryRegionFieldPolicy = {
	deliveryFee?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	minOrderValue?: FieldPolicy<any> | FieldReadFunction<any>,
	minOrderValueExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	orderPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	polygonCoordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	regionType?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceTimes?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceType?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorLocationId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DietaryStatKeySpecifier = ('count' | 'dietary' | DietaryStatKeySpecifier)[];
export type DietaryStatFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaAlgorithmResponseKeySpecifier = ('baskets' | 'briefing' | 'createdAt' | 'formResponseId' | 'id' | 'itemGroups' | 'numberOfPeople' | 'recipe' | 'status' | 'subtotal' | 'supplier' | 'test' | EmmaAlgorithmResponseKeySpecifier)[];
export type EmmaAlgorithmResponseFieldPolicy = {
	baskets?: FieldPolicy<any> | FieldReadFunction<any>,
	briefing?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	formResponseId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfPeople?: FieldPolicy<any> | FieldReadFunction<any>,
	recipe?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>,
	test?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaAlgorithmResponsePagedKeySpecifier = ('pageInfo' | 'rows' | EmmaAlgorithmResponsePagedKeySpecifier)[];
export type EmmaAlgorithmResponsePagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaAllergensMatchKeySpecifier = ('dairy' | 'gluten' | 'nuts' | EmmaAllergensMatchKeySpecifier)[];
export type EmmaAllergensMatchFieldPolicy = {
	dairy?: FieldPolicy<any> | FieldReadFunction<any>,
	gluten?: FieldPolicy<any> | FieldReadFunction<any>,
	nuts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaAutomationKeySpecifier = ('createdAt' | 'enabled' | 'followUpEmailDelay' | 'id' | 'maxNumberOfQuotesToSend' | 'messageTemplateId' | 'name' | 'sendFollowUpEmail' | 'tenantId' | 'triggers' | EmmaAutomationKeySpecifier)[];
export type EmmaAutomationFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	followUpEmailDelay?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxNumberOfQuotesToSend?: FieldPolicy<any> | FieldReadFunction<any>,
	messageTemplateId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sendFollowUpEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	triggers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaAutomationTrackingKeySpecifier = ('emmaAutomationId' | 'quoteReminderSentAt' | 'quoteSentAt' | EmmaAutomationTrackingKeySpecifier)[];
export type EmmaAutomationTrackingFieldPolicy = {
	emmaAutomationId?: FieldPolicy<any> | FieldReadFunction<any>,
	quoteReminderSentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	quoteSentAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaAutomationTriggerPriceKeySpecifier = ('max' | 'min' | EmmaAutomationTriggerPriceKeySpecifier)[];
export type EmmaAutomationTriggerPriceFieldPolicy = {
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaAutomationTriggersKeySpecifier = ('occasions' | 'price' | EmmaAutomationTriggersKeySpecifier)[];
export type EmmaAutomationTriggersFieldPolicy = {
	occasions?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaBasketKeySpecifier = ('createdAt' | 'friendlyId' | 'id' | 'status' | EmmaBasketKeySpecifier)[];
export type EmmaBasketFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	friendlyId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaBriefingAllergensKeySpecifier = ('dairy' | 'gluten' | 'nuts' | EmmaBriefingAllergensKeySpecifier)[];
export type EmmaBriefingAllergensFieldPolicy = {
	dairy?: FieldPolicy<any> | FieldReadFunction<any>,
	gluten?: FieldPolicy<any> | FieldReadFunction<any>,
	nuts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaBriefingBudgetKeySpecifier = ('type' | 'value' | EmmaBriefingBudgetKeySpecifier)[];
export type EmmaBriefingBudgetFieldPolicy = {
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaBriefingDietariesKeySpecifier = ('halal' | 'vegan' | 'vegetarian' | EmmaBriefingDietariesKeySpecifier)[];
export type EmmaBriefingDietariesFieldPolicy = {
	halal?: FieldPolicy<any> | FieldReadFunction<any>,
	vegan?: FieldPolicy<any> | FieldReadFunction<any>,
	vegetarian?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaBriefingTypeKeySpecifier = ('allergens' | 'budget' | 'dietaryPreferences' | 'headcount' | 'occasion' | EmmaBriefingTypeKeySpecifier)[];
export type EmmaBriefingTypeFieldPolicy = {
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	budget?: FieldPolicy<any> | FieldReadFunction<any>,
	dietaryPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	headcount?: FieldPolicy<any> | FieldReadFunction<any>,
	occasion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaCategoriseItemResponseKeySpecifier = ('category' | 'occasions' | EmmaCategoriseItemResponseKeySpecifier)[];
export type EmmaCategoriseItemResponseFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	occasions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaCategoryKeySpecifier = ('active' | 'id' | 'name' | 'occasions' | 'tasteProfile' | 'value' | EmmaCategoryKeySpecifier)[];
export type EmmaCategoryFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	occasions?: FieldPolicy<any> | FieldReadFunction<any>,
	tasteProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaCoveringAllergensKeySpecifier = ('allergen' | 'quantity' | EmmaCoveringAllergensKeySpecifier)[];
export type EmmaCoveringAllergensFieldPolicy = {
	allergen?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaCoveringDietariesKeySpecifier = ('dietary' | 'quantity' | EmmaCoveringDietariesKeySpecifier)[];
export type EmmaCoveringDietariesFieldPolicy = {
	dietary?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaDietariesMatchKeySpecifier = ('halal' | 'vegan' | 'vegetarian' | EmmaDietariesMatchKeySpecifier)[];
export type EmmaDietariesMatchFieldPolicy = {
	halal?: FieldPolicy<any> | FieldReadFunction<any>,
	vegan?: FieldPolicy<any> | FieldReadFunction<any>,
	vegetarian?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaFormAddressKeySpecifier = ('city' | 'country' | 'flatOrBuilding' | 'floorOrBuildingName' | 'latitude' | 'longitude' | 'postcode' | 'street' | EmmaFormAddressKeySpecifier)[];
export type EmmaFormAddressFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	flatOrBuilding?: FieldPolicy<any> | FieldReadFunction<any>,
	floorOrBuildingName?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaFormAllergenKeySpecifier = ('dairy' | 'gluten' | EmmaFormAllergenKeySpecifier)[];
export type EmmaFormAllergenFieldPolicy = {
	dairy?: FieldPolicy<any> | FieldReadFunction<any>,
	gluten?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaFormContactKeySpecifier = ('address' | 'companyName' | 'email' | 'firstName' | 'lastName' | 'locale' | 'phoneNumber' | EmmaFormContactKeySpecifier)[];
export type EmmaFormContactFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	companyName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaFormDietaryRequirementKeySpecifier = ('halal' | 'vegan' | 'vegetarian' | EmmaFormDietaryRequirementKeySpecifier)[];
export type EmmaFormDietaryRequirementFieldPolicy = {
	halal?: FieldPolicy<any> | FieldReadFunction<any>,
	vegan?: FieldPolicy<any> | FieldReadFunction<any>,
	vegetarian?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaFormResponseKeySpecifier = ('additionalDetails' | 'adminAssigned' | 'algorithmResults' | 'algorithmResultsPaged' | 'allergens' | 'budget' | 'budgetType' | 'contact' | 'createdAt' | 'date' | 'dietaryRequirements' | 'disableAutomation' | 'drinks' | 'equipment' | 'eventStyle' | 'foodServiceTime' | 'hasAllergenOrDietaryRequirement' | 'headcount' | 'id' | 'isRunning' | 'occasion' | 'occasionSubTypes' | 'onsiteFacilities' | 'requirements' | 'serviceStyle' | 'servingType' | 'staffServiceTime' | 'status' | 'subscribeToUpdates' | 'tenantId' | 'time' | 'unassignedBaskets' | EmmaFormResponseKeySpecifier)[];
export type EmmaFormResponseFieldPolicy = {
	additionalDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	adminAssigned?: FieldPolicy<any> | FieldReadFunction<any>,
	algorithmResults?: FieldPolicy<any> | FieldReadFunction<any>,
	algorithmResultsPaged?: FieldPolicy<any> | FieldReadFunction<any>,
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	budget?: FieldPolicy<any> | FieldReadFunction<any>,
	budgetType?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	dietaryRequirements?: FieldPolicy<any> | FieldReadFunction<any>,
	disableAutomation?: FieldPolicy<any> | FieldReadFunction<any>,
	drinks?: FieldPolicy<any> | FieldReadFunction<any>,
	equipment?: FieldPolicy<any> | FieldReadFunction<any>,
	eventStyle?: FieldPolicy<any> | FieldReadFunction<any>,
	foodServiceTime?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAllergenOrDietaryRequirement?: FieldPolicy<any> | FieldReadFunction<any>,
	headcount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isRunning?: FieldPolicy<any> | FieldReadFunction<any>,
	occasion?: FieldPolicy<any> | FieldReadFunction<any>,
	occasionSubTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	onsiteFacilities?: FieldPolicy<any> | FieldReadFunction<any>,
	requirements?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceStyle?: FieldPolicy<any> | FieldReadFunction<any>,
	servingType?: FieldPolicy<any> | FieldReadFunction<any>,
	staffServiceTime?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subscribeToUpdates?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	time?: FieldPolicy<any> | FieldReadFunction<any>,
	unassignedBaskets?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaFormResponseAdminUserKeySpecifier = ('id' | 'name' | EmmaFormResponseAdminUserKeySpecifier)[];
export type EmmaFormResponseAdminUserFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaFormResponsePagedKeySpecifier = ('items' | 'pageInfo' | EmmaFormResponsePagedKeySpecifier)[];
export type EmmaFormResponsePagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaFormSubmissionResponseKeySpecifier = ('id' | 'message' | 'success' | EmmaFormSubmissionResponseKeySpecifier)[];
export type EmmaFormSubmissionResponseFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaItemGroupKeySpecifier = ('displayOrder' | 'items' | 'name' | 'rank' | EmmaItemGroupKeySpecifier)[];
export type EmmaItemGroupFieldPolicy = {
	displayOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	rank?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaItemLevelMatchingKeySpecifier = ('allergens' | 'dietaries' | EmmaItemLevelMatchingKeySpecifier)[];
export type EmmaItemLevelMatchingFieldPolicy = {
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	dietaries?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaMenuItemTypeKeySpecifier = ('adjustedWeight' | 'allergens' | 'coveringAllergens' | 'coveringDietaries' | 'dietaries' | 'disabledAllergens' | 'disabledDietaries' | 'fullServings' | 'groupId' | 'id' | 'isMasterItem' | 'item' | 'itemLevel' | 'itemName' | 'itemRank' | 'itemType' | 'occasionRanking' | 'piecesPerItem' | 'quantity' | 'ranking' | 'serving' | 'tasteProfile' | 'weight' | EmmaMenuItemTypeKeySpecifier)[];
export type EmmaMenuItemTypeFieldPolicy = {
	adjustedWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	coveringAllergens?: FieldPolicy<any> | FieldReadFunction<any>,
	coveringDietaries?: FieldPolicy<any> | FieldReadFunction<any>,
	dietaries?: FieldPolicy<any> | FieldReadFunction<any>,
	disabledAllergens?: FieldPolicy<any> | FieldReadFunction<any>,
	disabledDietaries?: FieldPolicy<any> | FieldReadFunction<any>,
	fullServings?: FieldPolicy<any> | FieldReadFunction<any>,
	groupId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isMasterItem?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	itemLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemRank?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	occasionRanking?: FieldPolicy<any> | FieldReadFunction<any>,
	piecesPerItem?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	ranking?: FieldPolicy<any> | FieldReadFunction<any>,
	serving?: FieldPolicy<any> | FieldReadFunction<any>,
	tasteProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaOccasionKeySpecifier = ('activeFrom' | 'activeTo' | 'code' | 'createdAt' | 'deletedAt' | 'description' | 'id' | 'imageUrl' | 'isActive' | 'name' | 'position' | 'tenantId' | 'updatedAt' | EmmaOccasionKeySpecifier)[];
export type EmmaOccasionFieldPolicy = {
	activeFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	activeTo?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaOccasionRankingKeySpecifier = ('afternoonTeaRanking' | 'afternoonTeaWeight' | 'breakfastRanking' | 'breakfastWeight' | 'fingerFoodRanking' | 'fingerFoodWeight' | 'lunchColdRanking' | 'lunchColdWeight' | 'lunchHotRanking' | 'lunchHotWeight' | 'lunchRanking' | 'lunchWeight' | 'morningTeaRanking' | 'morningTeaWeight' | 'ranking' | 'weight' | EmmaOccasionRankingKeySpecifier)[];
export type EmmaOccasionRankingFieldPolicy = {
	afternoonTeaRanking?: FieldPolicy<any> | FieldReadFunction<any>,
	afternoonTeaWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	breakfastRanking?: FieldPolicy<any> | FieldReadFunction<any>,
	breakfastWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	fingerFoodRanking?: FieldPolicy<any> | FieldReadFunction<any>,
	fingerFoodWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	lunchColdRanking?: FieldPolicy<any> | FieldReadFunction<any>,
	lunchColdWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	lunchHotRanking?: FieldPolicy<any> | FieldReadFunction<any>,
	lunchHotWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	lunchRanking?: FieldPolicy<any> | FieldReadFunction<any>,
	lunchWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	morningTeaRanking?: FieldPolicy<any> | FieldReadFunction<any>,
	morningTeaWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	ranking?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaRecipeKeySpecifier = ('active' | 'groups' | 'hasTasteProfile' | 'id' | 'name' | 'occasion' | 'tasteProfile' | EmmaRecipeKeySpecifier)[];
export type EmmaRecipeFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	hasTasteProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	occasion?: FieldPolicy<any> | FieldReadFunction<any>,
	tasteProfile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaRecipeGroupKeySpecifier = ('name' | 'quantity' | EmmaRecipeGroupKeySpecifier)[];
export type EmmaRecipeGroupFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmmaTestDataKeySpecifier = ('name' | 'version' | EmmaTestDataKeySpecifier)[];
export type EmmaTestDataFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FilterStatTagKeySpecifier = ('count' | 'id' | 'label' | 'name' | 'position' | FilterStatTagKeySpecifier)[];
export type FilterStatTagFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FlagImageUriKeySpecifier = ('rectangle' | 'square' | FlagImageUriKeySpecifier)[];
export type FlagImageUriFieldPolicy = {
	rectangle?: FieldPolicy<any> | FieldReadFunction<any>,
	square?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FlexConsolidationRunStatusKeySpecifier = ('completedAt' | 'hasRun' | 'status' | 'type' | FlexConsolidationRunStatusKeySpecifier)[];
export type FlexConsolidationRunStatusFieldPolicy = {
	completedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	hasRun?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FlexInvoiceKeySpecifier = ('accountName' | 'country' | 'createdAt' | 'csv' | 'dueDate' | 'id' | 'location' | 'number' | 'status' | 'timezone' | 'total' | FlexInvoiceKeySpecifier)[];
export type FlexInvoiceFieldPolicy = {
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	csv?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FlexInvoiceAccountKeySpecifier = ('accountId' | 'addressCity' | 'addressCountry' | 'addressLine1' | 'addressLine2' | 'addressPostcode' | 'autoInvoice' | 'autoPay' | 'chargeCreditCardFee' | 'contactFirstName' | 'contactLastName' | 'contactPhoneNumber' | 'emailAddresses' | 'entityNumber' | 'entityRegion' | 'entityTaxNumber' | 'flexDeferredCustomerId' | 'id' | 'invoiceByPantryOrder' | 'invoiceByStandingOrder' | 'invoiceConsolidationFrequency' | 'invoiceConsolidationType' | 'invoicePerContact' | 'invoicePerOrderRecipientType' | 'invoicePerReferenceField' | 'invoicePerType' | 'isDefault' | 'isPaymentMethodSaved' | 'locale' | 'name' | 'paymentTerms' | 'primaryEmail' | 'referenceFieldLabelsForInvoice' | 'referenceFields' | 'standingOrderInvoicingRules' | 'tenantId' | 'timezone' | 'vatRegionId' | FlexInvoiceAccountKeySpecifier)[];
export type FlexInvoiceAccountFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	addressCity?: FieldPolicy<any> | FieldReadFunction<any>,
	addressCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	addressLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	addressLine2?: FieldPolicy<any> | FieldReadFunction<any>,
	addressPostcode?: FieldPolicy<any> | FieldReadFunction<any>,
	autoInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	autoPay?: FieldPolicy<any> | FieldReadFunction<any>,
	chargeCreditCardFee?: FieldPolicy<any> | FieldReadFunction<any>,
	contactFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	contactLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	contactPhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	emailAddresses?: FieldPolicy<any> | FieldReadFunction<any>,
	entityNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	entityRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	entityTaxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	flexDeferredCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceByPantryOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceByStandingOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceConsolidationFrequency?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceConsolidationType?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicePerContact?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicePerOrderRecipientType?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicePerReferenceField?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicePerType?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	isPaymentMethodSaved?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentTerms?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFieldLabelsForInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFields?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOrderInvoicingRules?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FlexInvoiceAllTypesKeySpecifier = ('accountAddress' | 'accountBusinessNumber' | 'accountContact' | 'accountId' | 'accountName' | 'accountTaxNumber' | 'assets' | 'country' | 'createdAt' | 'csv' | 'dueDate' | 'entityName' | 'flexDeferredCustomerId' | 'flexInvoiceId' | 'id' | 'instant' | 'invoiceType' | 'location' | 'number' | 'status' | 'timezone' | 'total' | FlexInvoiceAllTypesKeySpecifier)[];
export type FlexInvoiceAllTypesFieldPolicy = {
	accountAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	accountBusinessNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	accountContact?: FieldPolicy<any> | FieldReadFunction<any>,
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	accountTaxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	csv?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	entityName?: FieldPolicy<any> | FieldReadFunction<any>,
	flexDeferredCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	flexInvoiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	instant?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceType?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FlexInvoiceAllTypesPagedKeySpecifier = ('items' | 'pageInfo' | FlexInvoiceAllTypesPagedKeySpecifier)[];
export type FlexInvoiceAllTypesPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FlexInvoiceAssetKeySpecifier = ('link' | 'type' | FlexInvoiceAssetKeySpecifier)[];
export type FlexInvoiceAssetFieldPolicy = {
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FlexInvoicesPagedKeySpecifier = ('items' | 'pageInfo' | FlexInvoicesPagedKeySpecifier)[];
export type FlexInvoicesPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FlexInvoicingClientKeySpecifier = ('clientId' | 'countryCode' | 'shortCode' | FlexInvoicingClientKeySpecifier)[];
export type FlexInvoicingClientFieldPolicy = {
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	shortCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FlexInvoicingFlagsKeySpecifier = ('countryCode' | 'enabled' | FlexInvoicingFlagsKeySpecifier)[];
export type FlexInvoicingFlagsFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FlexInvoicingPaymentSettingsKeySpecifier = ('billingEntityCode' | 'chargeCreditCardFee' | 'countryCode' | 'enableInvoicePaymentByCard' | FlexInvoicingPaymentSettingsKeySpecifier)[];
export type FlexInvoicingPaymentSettingsFieldPolicy = {
	billingEntityCode?: FieldPolicy<any> | FieldReadFunction<any>,
	chargeCreditCardFee?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	enableInvoicePaymentByCard?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GLCodeServiceTypeOverrideKeySpecifier = ('customerGLCode' | 'serviceType' | 'vendorGLCode' | GLCodeServiceTypeOverrideKeySpecifier)[];
export type GLCodeServiceTypeOverrideFieldPolicy = {
	customerGLCode?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceType?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorGLCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GLCodesKeySpecifier = ('customerGLCode' | 'id' | 'itemId' | 'itemType' | 'serviceTypeOverrides' | 'vendorGLCode' | GLCodesKeySpecifier)[];
export type GLCodesFieldPolicy = {
	customerGLCode?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceTypeOverrides?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorGLCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GMAccountKeySpecifier = ('id' | 'name' | GMAccountKeySpecifier)[];
export type GMAccountFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GMAccountLocationKeySpecifier = ('address' | 'id' | 'timezone' | GMAccountLocationKeySpecifier)[];
export type GMAccountLocationFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GMInvoiceKeySpecifier = ('account' | 'accountLocation' | 'additionalTotal' | 'additionalTotalExVat' | 'additionalTotalVat' | 'additionalVatSummary' | 'amountDue' | 'amountPaid' | 'asset' | 'assets' | 'billingDetails' | 'billingEntity' | 'budgetCode' | 'canApprove' | 'canCancel' | 'canPay' | 'canRecreate' | 'currency' | 'dueDate' | 'foodSalesDiscountPercent' | 'friendlyId' | 'id' | 'isAlreadyApproved' | 'isInvoiceAccount' | 'issueDate' | 'items' | 'mealsDonated' | 'overdue' | 'paymentHistory' | 'paymentStatus' | 'periodEnd' | 'periodStart' | 'status' | 'supplierOrderBreakdown' | 'total' | 'totalExVat' | 'totalQuantity' | 'totalVat' | 'type' | 'vatRegion' | 'vatSummary' | 'vendorOwnDelivery' | GMInvoiceKeySpecifier)[];
export type GMInvoiceFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalTotalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalTotalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalVatSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	amountDue?: FieldPolicy<any> | FieldReadFunction<any>,
	amountPaid?: FieldPolicy<any> | FieldReadFunction<any>,
	asset?: FieldPolicy<any> | FieldReadFunction<any>,
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	billingDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	billingEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	budgetCode?: FieldPolicy<any> | FieldReadFunction<any>,
	canApprove?: FieldPolicy<any> | FieldReadFunction<any>,
	canCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	canPay?: FieldPolicy<any> | FieldReadFunction<any>,
	canRecreate?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	foodSalesDiscountPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	friendlyId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAlreadyApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	isInvoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	issueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	mealsDonated?: FieldPolicy<any> | FieldReadFunction<any>,
	overdue?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	periodEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	periodStart?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierOrderBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	vatSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorOwnDelivery?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GMServiceAddonsKeySpecifier = ('napkins' | 'plates' | 'service' | GMServiceAddonsKeySpecifier)[];
export type GMServiceAddonsFieldPolicy = {
	napkins?: FieldPolicy<any> | FieldReadFunction<any>,
	plates?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GMServiceNotesKeySpecifier = ('account' | 'cart' | 'vendor' | GMServiceNotesKeySpecifier)[];
export type GMServiceNotesFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	cart?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GMServiceOptionsKeySpecifier = ('addons' | 'budgetCode' | 'format' | 'isHighRisk' | 'notes' | 'rep' | 'thermalBox' | GMServiceOptionsKeySpecifier)[];
export type GMServiceOptionsFieldPolicy = {
	addons?: FieldPolicy<any> | FieldReadFunction<any>,
	budgetCode?: FieldPolicy<any> | FieldReadFunction<any>,
	format?: FieldPolicy<any> | FieldReadFunction<any>,
	isHighRisk?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	rep?: FieldPolicy<any> | FieldReadFunction<any>,
	thermalBox?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GMSupplierOrderBreakdownKeySpecifier = ('arrivalTime' | 'date' | 'friendlyOrderId' | 'items' | 'orderId' | 'quantity' | 'supplierAddress' | 'supplierName' | 'supplierVatNumber' | 'taxInvoiceNumber' | 'total' | 'totalExVat' | 'totalVat' | 'vatSummary' | GMSupplierOrderBreakdownKeySpecifier)[];
export type GMSupplierOrderBreakdownFieldPolicy = {
	arrivalTime?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	friendlyOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierName?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierVatNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	taxInvoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	vatSummary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GMSupplierOrderBreakdownPagedKeySpecifier = ('orders' | 'pageInfo' | 'vatSummary' | GMSupplierOrderBreakdownPagedKeySpecifier)[];
export type GMSupplierOrderBreakdownPagedFieldPolicy = {
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	vatSummary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GMSupplierOrderBreakdownVatKeySpecifier = ('quantity' | 'total' | 'totalExVat' | 'totalVat' | 'vatRate' | GMSupplierOrderBreakdownVatKeySpecifier)[];
export type GMSupplierOrderBreakdownVatFieldPolicy = {
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GeocodeContextKeySpecifier = ('country' | 'district' | 'locality' | 'neighborhood' | 'place' | 'postcode' | 'region' | GeocodeContextKeySpecifier)[];
export type GeocodeContextFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	district?: FieldPolicy<any> | FieldReadFunction<any>,
	locality?: FieldPolicy<any> | FieldReadFunction<any>,
	neighborhood?: FieldPolicy<any> | FieldReadFunction<any>,
	place?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmAvailabilityKeySpecifier = ('id' | 'items' | 'itemsPaged' | 'itemsPagedv2' | 'myBaskets' | 'myLastBasket' | 'vendorId' | GmAvailabilityKeySpecifier)[];
export type GmAvailabilityFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	itemsPaged?: FieldPolicy<any> | FieldReadFunction<any>,
	itemsPagedv2?: FieldPolicy<any> | FieldReadFunction<any>,
	myBaskets?: FieldPolicy<any> | FieldReadFunction<any>,
	myLastBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmBasketKeySpecifier = ('allergens' | 'availabilityId' | 'basketTotalBreakdown' | 'checkoutRestrictions' | 'contributors' | 'coupon' | 'couponId' | 'createdAt' | 'customItems' | 'customName' | 'deliveryFee' | 'deliveryFeeBreakdown' | 'discountBreakdown' | 'duplicated' | 'editSessionId' | 'fees' | 'friendlyId' | 'hasEnterpriseDiscount' | 'id' | 'isCateringTeamOrder' | 'isGroupOrder' | 'itemCount' | 'items' | 'logistics' | 'margin' | 'options' | 'orderNotes' | 'orderNotesUpdatedAt' | 'productFee' | 'productFeeBreakdown' | 'quoteCollection' | 'settings' | 'subtotal' | 'subtotalBreakdown' | 'thermalBoxFeeBreakdown' | 'updatedAt' | 'user' | 'userId' | 'utmData' | 'vendor' | GmBasketKeySpecifier)[];
export type GmBasketFieldPolicy = {
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	availabilityId?: FieldPolicy<any> | FieldReadFunction<any>,
	basketTotalBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutRestrictions?: FieldPolicy<any> | FieldReadFunction<any>,
	contributors?: FieldPolicy<any> | FieldReadFunction<any>,
	coupon?: FieldPolicy<any> | FieldReadFunction<any>,
	couponId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	customItems?: FieldPolicy<any> | FieldReadFunction<any>,
	customName?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryFee?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryFeeBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	discountBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicated?: FieldPolicy<any> | FieldReadFunction<any>,
	editSessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	friendlyId?: FieldPolicy<any> | FieldReadFunction<any>,
	hasEnterpriseDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCateringTeamOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	isGroupOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	logistics?: FieldPolicy<any> | FieldReadFunction<any>,
	margin?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNotesUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	productFee?: FieldPolicy<any> | FieldReadFunction<any>,
	productFeeBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	quoteCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotalBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	thermalBoxFeeBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>,
	utmData?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmBasketCheckoutRestrictionsKeySpecifier = ('companyAdminOnly' | GmBasketCheckoutRestrictionsKeySpecifier)[];
export type GmBasketCheckoutRestrictionsFieldPolicy = {
	companyAdminOnly?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmBasketContributorKeySpecifier = ('name' | 'userId' | GmBasketContributorKeySpecifier)[];
export type GmBasketContributorFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmBasketCustomItemKeySpecifier = ('commissionRate' | 'customerPriceExTax' | 'customerPriceIncTax' | 'description' | 'id' | 'name' | 'notes' | 'quantity' | 'taxRate' | 'vendorPriceExTax' | 'vendorPriceExTaxExCom' | GmBasketCustomItemKeySpecifier)[];
export type GmBasketCustomItemFieldPolicy = {
	commissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	customerPriceExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	customerPriceIncTax?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorPriceExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorPriceExTaxExCom?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmBasketPagedKeySpecifier = ('pageInfo' | 'rows' | GmBasketPagedKeySpecifier)[];
export type GmBasketPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmCheckoutErrorsKeySpecifier = ('errors' | GmCheckoutErrorsKeySpecifier)[];
export type GmCheckoutErrorsFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmIssueKeySpecifier = ('accountId' | 'id' | 'note' | 'orderId' | 'reason' | 'refunds' | 'severity' | 'type' | 'vendorCharges' | 'vendorId' | GmIssueKeySpecifier)[];
export type GmIssueFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds?: FieldPolicy<any> | FieldReadFunction<any>,
	severity?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmIssuesPagedKeySpecifier = ('data' | GmIssuesPagedKeySpecifier)[];
export type GmIssuesPagedFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmItemSearchResultKeySpecifier = ('permalink' | 'rank' | 'reason' | 'supplierId' | 'supplierName' | GmItemSearchResultKeySpecifier)[];
export type GmItemSearchResultFieldPolicy = {
	permalink?: FieldPolicy<any> | FieldReadFunction<any>,
	rank?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmMenuCategoryKeySpecifier = ('id' | 'name' | 'position' | GmMenuCategoryKeySpecifier)[];
export type GmMenuCategoryFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmMenuItemStatKeySpecifier = ('id' | 'label' | 'name' | 'value' | GmMenuItemStatKeySpecifier)[];
export type GmMenuItemStatFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmMenuItemStatsKeySpecifier = ('allergens' | 'categories' | 'dietaries' | GmMenuItemStatsKeySpecifier)[];
export type GmMenuItemStatsFieldPolicy = {
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	dietaries?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmMenuItemsKeySpecifier = ('cacheKeys' | 'items' | 'pageInfo' | 'stats' | GmMenuItemsKeySpecifier)[];
export type GmMenuItemsFieldPolicy = {
	cacheKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	stats?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderKeySpecifier = ('account' | 'accountLocation' | 'addons' | 'allergens' | 'basketId' | 'budgetCode' | 'coupon' | 'currentStatus' | 'customName' | 'customerRefundBreakdown' | 'deliveryDate' | 'deliveryFinish' | 'deliveryInstructions' | 'deliveryStart' | 'deliveryTimeSlot' | 'discountBreakdown' | 'fees' | 'format' | 'hasEnterpriseDiscount' | 'headCount' | 'id' | 'invoiceAccount' | 'invoicingData' | 'isCateringTeamOrder' | 'isFirstOrderForUser' | 'isGroupOrder' | 'isHighRisk' | 'issues' | 'logistics' | 'margin' | 'meetingRoom' | 'notes' | 'orderId' | 'orderItems' | 'orderNotes' | 'orderNotesUpdatedAt' | 'orderTotalBreakdown' | 'orderType' | 'paymentInstructions' | 'paymentMethod' | 'placedBy' | 'ratedAt' | 'referenceFieldValues' | 'rep' | 'standingOrder' | 'subtotalExTax' | 'tenantId' | 'thermalBox' | 'user' | 'userEditCutOffTime' | 'vendor' | 'vendorChargeBreakdown' | 'vendorContact' | 'vendorLocation' | 'vendorPickupTime' | 'version' | GmOrderKeySpecifier)[];
export type GmOrderFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	addons?: FieldPolicy<any> | FieldReadFunction<any>,
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	basketId?: FieldPolicy<any> | FieldReadFunction<any>,
	budgetCode?: FieldPolicy<any> | FieldReadFunction<any>,
	coupon?: FieldPolicy<any> | FieldReadFunction<any>,
	currentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	customName?: FieldPolicy<any> | FieldReadFunction<any>,
	customerRefundBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryFinish?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryStart?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryTimeSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	discountBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	format?: FieldPolicy<any> | FieldReadFunction<any>,
	hasEnterpriseDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	headCount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicingData?: FieldPolicy<any> | FieldReadFunction<any>,
	isCateringTeamOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	isFirstOrderForUser?: FieldPolicy<any> | FieldReadFunction<any>,
	isGroupOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	isHighRisk?: FieldPolicy<any> | FieldReadFunction<any>,
	issues?: FieldPolicy<any> | FieldReadFunction<any>,
	logistics?: FieldPolicy<any> | FieldReadFunction<any>,
	margin?: FieldPolicy<any> | FieldReadFunction<any>,
	meetingRoom?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	orderItems?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNotesUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	orderTotalBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	orderType?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	placedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	ratedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFieldValues?: FieldPolicy<any> | FieldReadFunction<any>,
	rep?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotalExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	thermalBox?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userEditCutOffTime?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorChargeBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorContact?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorPickupTime?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderBankAccountDataKeySpecifier = ('bankName' | 'bic' | 'iban' | GmOrderBankAccountDataKeySpecifier)[];
export type GmOrderBankAccountDataFieldPolicy = {
	bankName?: FieldPolicy<any> | FieldReadFunction<any>,
	bic?: FieldPolicy<any> | FieldReadFunction<any>,
	iban?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderFeeBreakdownKeySpecifier = ('calculatedByPercentage' | 'code' | 'description' | 'isCustom' | 'taxRate' | 'taxValue' | 'total' | 'totalExTax' | GmOrderFeeBreakdownKeySpecifier)[];
export type GmOrderFeeBreakdownFieldPolicy = {
	calculatedByPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	isCustom?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExTax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderInvoicingDataKeySpecifier = ('deferredCustomerInvoiceNumber' | 'flexDeferredCustomerOrderId' | 'flexDeferredSupplierOrderId' | GmOrderInvoicingDataKeySpecifier)[];
export type GmOrderInvoicingDataFieldPolicy = {
	deferredCustomerInvoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	flexDeferredCustomerOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	flexDeferredSupplierOrderId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderItemKeySpecifier = ('addedBy' | 'addedByUserId' | 'commissionRate' | 'createdAt' | 'deletedAt' | 'description' | 'descriptionLong' | 'id' | 'isCustom' | 'liveMenuItem' | 'name' | 'note' | 'orderId' | 'orderItemOptions' | 'pendingEditConfirmation' | 'price' | 'priceExTax' | 'priceTaxValue' | 'priceVendor' | 'priceVendorExTax' | 'priceVendorExTaxExCom' | 'priceVendorTaxValue' | 'qty' | 'quantityAdjustable' | 'servings' | 'subtotal' | 'subtotalExTax' | 'subtotalTaxValue' | 'taxRate' | 'updatedAt' | GmOrderItemKeySpecifier)[];
export type GmOrderItemFieldPolicy = {
	addedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	addedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	commissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionLong?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCustom?: FieldPolicy<any> | FieldReadFunction<any>,
	liveMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	orderItemOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingEditConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceTaxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	priceVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	priceVendorExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceVendorExTaxExCom?: FieldPolicy<any> | FieldReadFunction<any>,
	priceVendorTaxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityAdjustable?: FieldPolicy<any> | FieldReadFunction<any>,
	servings?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotalExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotalTaxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderItemOptionKeySpecifier = ('category' | 'createdAt' | 'deletedAt' | 'id' | 'liveMenuItem' | 'name' | 'optionCategoryId' | 'optionReference' | 'optionType' | 'orderId' | 'orderItemId' | 'price' | 'priceExTax' | 'priceTaxValue' | 'priceVendor' | 'priceVendorExTax' | 'priceVendorExTaxExCom' | 'qty' | 'subtotal' | 'subtotalExTax' | 'subtotalTaxValue' | 'taxRate' | 'updatedAt' | GmOrderItemOptionKeySpecifier)[];
export type GmOrderItemOptionFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	liveMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	optionCategoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	optionReference?: FieldPolicy<any> | FieldReadFunction<any>,
	optionType?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	orderItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceTaxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	priceVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	priceVendorExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceVendorExTaxExCom?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotalExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotalTaxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderItemsKeySpecifier = ('items' | GmOrderItemsKeySpecifier)[];
export type GmOrderItemsFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderLiteKeySpecifier = ('accountId' | 'accountLocationCity' | 'accountLocationCountry' | 'accountLocationLine1' | 'accountLocationLine2' | 'accountLocationLine3' | 'accountLocationPostalCode' | 'accountName' | 'deliveryDate' | 'deliveryTimeSlot' | 'headCount' | 'id' | 'isCateringTeamOrder' | 'isFirstOrderForUser' | 'isGroupOrder' | 'orderId' | 'orderTotal' | 'paymentMethod' | 'placedAsGuest' | 'tenantName' | 'userEditCutoffTime' | 'userEmail' | 'userId' | 'userName' | 'vendorCurrency' | 'vendorId' | 'vendorIsPantry' | 'vendorName' | GmOrderLiteKeySpecifier)[];
export type GmOrderLiteFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationCity?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationLine2?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationLine3?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocationPostalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryTimeSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	headCount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCateringTeamOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	isFirstOrderForUser?: FieldPolicy<any> | FieldReadFunction<any>,
	isGroupOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	orderTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	placedAsGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantName?: FieldPolicy<any> | FieldReadFunction<any>,
	userEditCutoffTime?: FieldPolicy<any> | FieldReadFunction<any>,
	userEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>,
	userName?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorIsPantry?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderPagedKeySpecifier = ('data' | 'pageInfo' | GmOrderPagedKeySpecifier)[];
export type GmOrderPagedFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderPaymentInstructionsKeySpecifier = ('bankAccountData' | GmOrderPaymentInstructionsKeySpecifier)[];
export type GmOrderPaymentInstructionsFieldPolicy = {
	bankAccountData?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderPdfResponseKeySpecifier = ('url' | GmOrderPdfResponseKeySpecifier)[];
export type GmOrderPdfResponseFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderStatusKeySpecifier = ('cancellationNote' | 'cancellationReason' | 'cancelledByName' | 'name' | 'timestamp' | GmOrderStatusKeySpecifier)[];
export type GmOrderStatusFieldPolicy = {
	cancellationNote?: FieldPolicy<any> | FieldReadFunction<any>,
	cancellationReason?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelledByName?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderTaxBreakdownKeySpecifier = ('taxRateTotals' | 'taxValue' | 'totalExTax' | 'totalIncTax' | GmOrderTaxBreakdownKeySpecifier)[];
export type GmOrderTaxBreakdownFieldPolicy = {
	taxRateTotals?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalIncTax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmOrderTaxRateTotalKeySpecifier = ('rate' | 'taxValue' | 'totalExTax' | 'totalIncTax' | GmOrderTaxRateTotalKeySpecifier)[];
export type GmOrderTaxRateTotalFieldPolicy = {
	rate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalIncTax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmReferenceFieldOptionKeySpecifier = ('id' | 'option' | 'orderPriority' | 'orderReferenceFieldId' | GmReferenceFieldOptionKeySpecifier)[];
export type GmReferenceFieldOptionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	option?: FieldPolicy<any> | FieldReadFunction<any>,
	orderPriority?: FieldPolicy<any> | FieldReadFunction<any>,
	orderReferenceFieldId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmReferenceFieldValueKeySpecifier = ('description' | 'error' | 'fieldType' | 'isRequired' | 'label' | 'options' | 'orderReferenceFieldId' | 'referenceFieldId' | 'referenceFieldValueId' | 'value' | 'version' | GmReferenceFieldValueKeySpecifier)[];
export type GmReferenceFieldValueFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldType?: FieldPolicy<any> | FieldReadFunction<any>,
	isRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	orderReferenceFieldId?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFieldId?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFieldValueId?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmRefundKeySpecifier = ('accountId' | 'fixedAmount' | 'id' | 'notes' | 'orderId' | 'percentage' | 'readOnly' | 'reason' | 'taxRate' | GmRefundKeySpecifier)[];
export type GmRefundFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	fixedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>,
	readOnly?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmServiceLogisticsKeySpecifier = ('customDeliveryFee' | 'deliveryBy' | 'internalNote' | 'transport' | GmServiceLogisticsKeySpecifier)[];
export type GmServiceLogisticsFieldPolicy = {
	customDeliveryFee?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryBy?: FieldPolicy<any> | FieldReadFunction<any>,
	internalNote?: FieldPolicy<any> | FieldReadFunction<any>,
	transport?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmServiceSettingsKeySpecifier = ('account' | 'additionalCorrespondents' | 'billingAddress' | 'billingAddressId' | 'billingAddressSameAsDelivery' | 'customProductFeePercentage' | 'deliveryDate' | 'deliveryInstructions' | 'deliveryTimeSlot' | 'emmaAlgorithmResponseId' | 'emmaAutomationTracking' | 'emmaFormResponseId' | 'feedrAdminApproved' | 'feedrCreated' | 'headCount' | 'invoiceAccount' | 'invoiceAccountId' | 'isGuestBasket' | 'location' | 'meetingRoom' | 'orderType' | 'paymentMethod' | 'placedBy' | 'placedByManuallyEdited' | 'referenceFieldValues' | 'tenantId' | 'vendor' | 'vendorPickupTime' | GmServiceSettingsKeySpecifier)[];
export type GmServiceSettingsFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalCorrespondents?: FieldPolicy<any> | FieldReadFunction<any>,
	billingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	billingAddressId?: FieldPolicy<any> | FieldReadFunction<any>,
	billingAddressSameAsDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	customProductFeePercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryTimeSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaAlgorithmResponseId?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaAutomationTracking?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaFormResponseId?: FieldPolicy<any> | FieldReadFunction<any>,
	feedrAdminApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	feedrCreated?: FieldPolicy<any> | FieldReadFunction<any>,
	headCount?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	isGuestBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	meetingRoom?: FieldPolicy<any> | FieldReadFunction<any>,
	orderType?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	placedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	placedByManuallyEdited?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFieldValues?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorPickupTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmValidationErrorKeySpecifier = ('code' | 'message' | GmValidationErrorKeySpecifier)[];
export type GmValidationErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GmVendorChargeKeySpecifier = ('fixedAmount' | 'id' | 'notes' | 'orderId' | 'percentage' | 'reason' | 'taxRate' | 'vendorId' | GmVendorChargeKeySpecifier)[];
export type GmVendorChargeFieldPolicy = {
	fixedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GoogleGeocodeKeySpecifier = ('address_components' | 'formatted_address' | 'geometry' | 'place_id' | 'types' | GoogleGeocodeKeySpecifier)[];
export type GoogleGeocodeFieldPolicy = {
	address_components?: FieldPolicy<any> | FieldReadFunction<any>,
	formatted_address?: FieldPolicy<any> | FieldReadFunction<any>,
	geometry?: FieldPolicy<any> | FieldReadFunction<any>,
	place_id?: FieldPolicy<any> | FieldReadFunction<any>,
	types?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GoogleGeometryKeySpecifier = ('location' | 'viewport' | GoogleGeometryKeySpecifier)[];
export type GoogleGeometryFieldPolicy = {
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	viewport?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupedCCOrderItemKeySpecifier = ('id' | 'orderItems' | 'supplierOrder' | GroupedCCOrderItemKeySpecifier)[];
export type GroupedCCOrderItemFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	orderItems?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierOrder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupedCCOrderItemsByVendorKeySpecifier = ('items' | 'supplierOrder' | 'vendor' | GroupedCCOrderItemsByVendorKeySpecifier)[];
export type GroupedCCOrderItemsByVendorFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeadCountRangesKeySpecifier = ('less50' | 'less100' | 'less500' | 'less1000' | 'more1000' | HeadCountRangesKeySpecifier)[];
export type HeadCountRangesFieldPolicy = {
	less50?: FieldPolicy<any> | FieldReadFunction<any>,
	less100?: FieldPolicy<any> | FieldReadFunction<any>,
	less500?: FieldPolicy<any> | FieldReadFunction<any>,
	less1000?: FieldPolicy<any> | FieldReadFunction<any>,
	more1000?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InitiateCCOrderResponseKeySpecifier = ('progressId' | InitiateCCOrderResponseKeySpecifier)[];
export type InitiateCCOrderResponseFieldPolicy = {
	progressId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InitiateInvoiceCardPaymentResultKeySpecifier = ('authToken' | InitiateInvoiceCardPaymentResultKeySpecifier)[];
export type InitiateInvoiceCardPaymentResultFieldPolicy = {
	authToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InitiatePaymentResultKeySpecifier = ('authToken' | 'payment' | InitiatePaymentResultKeySpecifier)[];
export type InitiatePaymentResultFieldPolicy = {
	authToken?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceKeySpecifier = ('additionalTotal' | 'additionalTotalExVat' | 'additionalTotalVat' | 'additionalVatSummary' | 'amountDue' | 'amountPaid' | 'asset' | 'assets' | 'billingDetails' | 'billingEntity' | 'budgetCode' | 'canApprove' | 'canCancel' | 'canPay' | 'currency' | 'dueDate' | 'friendlyId' | 'id' | 'isAlreadyApproved' | 'issueDate' | 'items' | 'overdue' | 'paymentHistory' | 'paymentStatus' | 'periodEnd' | 'periodStart' | 'status' | 'total' | 'totalExVat' | 'totalQuantity' | 'totalVat' | 'type' | 'vatRegion' | 'vatSummary' | InvoiceKeySpecifier)[];
export type InvoiceFieldPolicy = {
	additionalTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalTotalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalTotalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalVatSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	amountDue?: FieldPolicy<any> | FieldReadFunction<any>,
	amountPaid?: FieldPolicy<any> | FieldReadFunction<any>,
	asset?: FieldPolicy<any> | FieldReadFunction<any>,
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	billingDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	billingEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	budgetCode?: FieldPolicy<any> | FieldReadFunction<any>,
	canApprove?: FieldPolicy<any> | FieldReadFunction<any>,
	canCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	canPay?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	friendlyId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAlreadyApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	issueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	overdue?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	periodEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	periodStart?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	vatSummary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceAccountKeySpecifier = ('accountId' | 'additionalEmails' | 'approved' | 'autoInvoice' | 'autoPay' | 'businessNumber' | 'city' | 'country' | 'email' | 'firstName' | 'flexDeferredCustomerId' | 'id' | 'invoiceByPantryOrder' | 'invoiceByStandingOrder' | 'invoiceConsolidationFrequency' | 'invoiceConsolidationType' | 'invoicePerContact' | 'invoicePerOrderRecipientType' | 'invoicePerReferenceField' | 'invoicePerType' | 'isDefault' | 'label' | 'lastName' | 'line1' | 'line2' | 'locale' | 'orderReferenceFields' | 'phone' | 'postcode' | 'referenceFieldLabelsForInvoice' | 'standingOrderInvoicingRules' | 'vat' | 'vatRegion' | 'vatRegionId' | InvoiceAccountKeySpecifier)[];
export type InvoiceAccountFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	approved?: FieldPolicy<any> | FieldReadFunction<any>,
	autoInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	autoPay?: FieldPolicy<any> | FieldReadFunction<any>,
	businessNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	flexDeferredCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceByPantryOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceByStandingOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceConsolidationFrequency?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceConsolidationType?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicePerContact?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicePerOrderRecipientType?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicePerReferenceField?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicePerType?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	line1?: FieldPolicy<any> | FieldReadFunction<any>,
	line2?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	orderReferenceFields?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFieldLabelsForInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOrderInvoicingRules?: FieldPolicy<any> | FieldReadFunction<any>,
	vat?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceItemKeySpecifier = ('additional' | 'date' | 'description' | 'id' | 'isPromotionItem' | 'optionId' | 'quantity' | 'total' | 'totalExVat' | 'totalVat' | 'unitDiscount' | 'unitPrice' | 'vatRate' | InvoiceItemKeySpecifier)[];
export type InvoiceItemFieldPolicy = {
	additional?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPromotionItem?: FieldPolicy<any> | FieldReadFunction<any>,
	optionId?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceItemsPagedKeySpecifier = ('items' | 'pageInfo' | InvoiceItemsPagedKeySpecifier)[];
export type InvoiceItemsPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceOrderKeySpecifier = ('budgetCode' | 'contact' | 'customerName' | 'deferredCustomerInvoiceId' | 'deferredCustomerInvoiceNumber' | 'deliveryDate' | 'deliveryTimezone' | 'id' | 'number' | 'referenceFields' | 'shippingAddress' | 'supplier' | 'total' | InvoiceOrderKeySpecifier)[];
export type InvoiceOrderFieldPolicy = {
	budgetCode?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	customerName?: FieldPolicy<any> | FieldReadFunction<any>,
	deferredCustomerInvoiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	deferredCustomerInvoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryTimezone?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFields?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceOrderLineItemKeySpecifier = ('commission' | 'commissionType' | 'glCode' | 'label' | 'price' | 'quantity' | 'taxPercentage' | InvoiceOrderLineItemKeySpecifier)[];
export type InvoiceOrderLineItemFieldPolicy = {
	commission?: FieldPolicy<any> | FieldReadFunction<any>,
	commissionType?: FieldPolicy<any> | FieldReadFunction<any>,
	glCode?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	taxPercentage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceOrderReferenceFieldKeySpecifier = ('label' | 'value' | InvoiceOrderReferenceFieldKeySpecifier)[];
export type InvoiceOrderReferenceFieldFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceOrdersPagedKeySpecifier = ('items' | 'pageInfo' | InvoiceOrdersPagedKeySpecifier)[];
export type InvoiceOrdersPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoicesCombinedPagedKeySpecifier = ('items' | 'pageInfo' | InvoicesCombinedPagedKeySpecifier)[];
export type InvoicesCombinedPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoicesPagedKeySpecifier = ('items' | 'pageInfo' | InvoicesPagedKeySpecifier)[];
export type InvoicesPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemSearchMatchingItemKeySpecifier = ('id' | 'name' | ItemSearchMatchingItemKeySpecifier)[];
export type ItemSearchMatchingItemFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemSearchMetadataKeySpecifier = ('items' | 'rank' | 'reason' | ItemSearchMetadataKeySpecifier)[];
export type ItemSearchMetadataFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	rank?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LanguageDataKeySpecifier = ('code' | 'label' | LanguageDataKeySpecifier)[];
export type LanguageDataFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LineItemKeySpecifier = ('amount' | 'name' | LineItemKeySpecifier)[];
export type LineItemFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationKeySpecifier = ('lat' | 'lng' | LocationKeySpecifier)[];
export type LocationFieldPolicy = {
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	lng?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LookupAddressResponseKeySpecifier = ('locations' | 'queryResponse' | LookupAddressResponseKeySpecifier)[];
export type LookupAddressResponseFieldPolicy = {
	locations?: FieldPolicy<any> | FieldReadFunction<any>,
	queryResponse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarginKeySpecifier = ('percentage' | 'value' | MarginKeySpecifier)[];
export type MarginFieldPolicy = {
	percentage?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarkFlexInvoicesAsPaidResultKeySpecifier = ('batchId' | 'failedCount' | 'filename' | 'successCount' | 'totalInvoices' | MarkFlexInvoicesAsPaidResultKeySpecifier)[];
export type MarkFlexInvoicesAsPaidResultFieldPolicy = {
	batchId?: FieldPolicy<any> | FieldReadFunction<any>,
	failedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	successCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalInvoices?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarketplaceBandingKeySpecifier = ('message' | 'status' | MarketplaceBandingKeySpecifier)[];
export type MarketplaceBandingFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MealTypesKeySpecifier = ('breakfast' | 'dinner' | 'lunch' | MealTypesKeySpecifier)[];
export type MealTypesFieldPolicy = {
	breakfast?: FieldPolicy<any> | FieldReadFunction<any>,
	dinner?: FieldPolicy<any> | FieldReadFunction<any>,
	lunch?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuCsvDownloadKeySpecifier = ('csvData' | 'itemCount' | MenuCsvDownloadKeySpecifier)[];
export type MenuCsvDownloadFieldPolicy = {
	csvData?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemKeySpecifier = ('_id' | 'activeFrom' | 'activeTo' | 'alacalcFetchedAt' | 'alacalcId' | 'allergenAudit' | 'allergenAuditSummary' | 'allergen_celery' | 'allergen_cereals' | 'allergen_crustaceans' | 'allergen_eggs' | 'allergen_fish' | 'allergen_lupin' | 'allergen_milk' | 'allergen_molluscs' | 'allergen_mustard' | 'allergen_none' | 'allergen_nuts' | 'allergen_peanuts' | 'allergen_sesame' | 'allergen_soybeans' | 'allergen_sulphur' | 'allergens' | 'associatedStandingOrders' | 'category' | 'centegraProductId' | 'createdAt' | 'cuisineTag' | 'customerPriceItems' | 'deleted' | 'deletedAt' | 'description' | 'dietaries' | 'dietary_halal' | 'dietary_highprotein' | 'dietary_kosher' | 'dietary_low_carbon' | 'dietary_lowcarb' | 'dietary_non_hfss' | 'dietary_pescatarian' | 'dietary_powerplant' | 'dietary_refined_sugar' | 'dietary_vegan' | 'dietary_vegetarian' | 'dietary_verylow_carbon' | 'futureGmOrders' | 'group' | 'image' | 'inReview' | 'ingredients' | 'isActive' | 'isCombo' | 'isHot' | 'isMenuItem' | 'isModifierOnly' | 'isOption' | 'isOptionFor' | 'isVAT' | 'kitchenStation' | 'legacyId' | 'locked' | 'lockedTimestamp' | 'macros_carbs' | 'macros_fat' | 'macros_fibre' | 'macros_kcal' | 'macros_kj' | 'macros_monounsaturates' | 'macros_polyunsaturates' | 'macros_protein' | 'macros_salt' | 'macros_saturates' | 'macros_sugar' | 'markupRate' | 'mealTag' | 'meta' | 'migratedAt' | 'name' | 'occasions' | 'options' | 'price' | 'priceCustomerFacing' | 'priceCustomerFacingExTax' | 'priceExTax' | 'proteins' | 'publishedTimestamp' | 'reducedCommissionRate' | 'requestDeleteTimestamp' | 'requestToDelete' | 'sentForApprovalTimestamp' | 'shortDescription' | 'standardCommissionRate' | 'subAllergens' | 'sub_allergen_cereals' | 'sub_allergen_nuts' | 'suitability' | 'supplierExternalId' | 'supplierId' | 'taxRate' | 'taxValue' | 'translations' | 'unlockedTimestamp' | 'updatedAt' | 'variations' | 'vatBand' | 'vatBandId' | 'vendor' | MenuItemKeySpecifier)[];
export type MenuItemFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	activeFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	activeTo?: FieldPolicy<any> | FieldReadFunction<any>,
	alacalcFetchedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	alacalcId?: FieldPolicy<any> | FieldReadFunction<any>,
	allergenAudit?: FieldPolicy<any> | FieldReadFunction<any>,
	allergenAuditSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_celery?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_cereals?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_crustaceans?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_eggs?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_fish?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_lupin?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_milk?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_molluscs?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_mustard?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_none?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_nuts?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_peanuts?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_sesame?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_soybeans?: FieldPolicy<any> | FieldReadFunction<any>,
	allergen_sulphur?: FieldPolicy<any> | FieldReadFunction<any>,
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	associatedStandingOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	centegraProductId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	cuisineTag?: FieldPolicy<any> | FieldReadFunction<any>,
	customerPriceItems?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	dietaries?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_halal?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_highprotein?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_kosher?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_low_carbon?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_lowcarb?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_non_hfss?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_pescatarian?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_powerplant?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_refined_sugar?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_vegan?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_vegetarian?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary_verylow_carbon?: FieldPolicy<any> | FieldReadFunction<any>,
	futureGmOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	inReview?: FieldPolicy<any> | FieldReadFunction<any>,
	ingredients?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isCombo?: FieldPolicy<any> | FieldReadFunction<any>,
	isHot?: FieldPolicy<any> | FieldReadFunction<any>,
	isMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	isModifierOnly?: FieldPolicy<any> | FieldReadFunction<any>,
	isOption?: FieldPolicy<any> | FieldReadFunction<any>,
	isOptionFor?: FieldPolicy<any> | FieldReadFunction<any>,
	isVAT?: FieldPolicy<any> | FieldReadFunction<any>,
	kitchenStation?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyId?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	lockedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	macros_carbs?: FieldPolicy<any> | FieldReadFunction<any>,
	macros_fat?: FieldPolicy<any> | FieldReadFunction<any>,
	macros_fibre?: FieldPolicy<any> | FieldReadFunction<any>,
	macros_kcal?: FieldPolicy<any> | FieldReadFunction<any>,
	macros_kj?: FieldPolicy<any> | FieldReadFunction<any>,
	macros_monounsaturates?: FieldPolicy<any> | FieldReadFunction<any>,
	macros_polyunsaturates?: FieldPolicy<any> | FieldReadFunction<any>,
	macros_protein?: FieldPolicy<any> | FieldReadFunction<any>,
	macros_salt?: FieldPolicy<any> | FieldReadFunction<any>,
	macros_saturates?: FieldPolicy<any> | FieldReadFunction<any>,
	macros_sugar?: FieldPolicy<any> | FieldReadFunction<any>,
	markupRate?: FieldPolicy<any> | FieldReadFunction<any>,
	mealTag?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	migratedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	occasions?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceCustomerFacing?: FieldPolicy<any> | FieldReadFunction<any>,
	priceCustomerFacingExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	proteins?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	reducedCommissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	requestDeleteTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	requestToDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	sentForApprovalTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	standardCommissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	subAllergens?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_cereals?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_allergen_nuts?: FieldPolicy<any> | FieldReadFunction<any>,
	suitability?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierExternalId?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	translations?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	variations?: FieldPolicy<any> | FieldReadFunction<any>,
	vatBand?: FieldPolicy<any> | FieldReadFunction<any>,
	vatBandId?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemCategoryKeySpecifier = ('id' | 'items' | 'name' | 'value' | MenuItemCategoryKeySpecifier)[];
export type MenuItemCategoryFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemGroupKeySpecifier = ('allItemsReviewed' | 'category' | 'id' | 'name' | 'occasions' | 'rank' | 'sizes' | 'suitability' | 'weight' | MenuItemGroupKeySpecifier)[];
export type MenuItemGroupFieldPolicy = {
	allItemsReviewed?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	occasions?: FieldPolicy<any> | FieldReadFunction<any>,
	rank?: FieldPolicy<any> | FieldReadFunction<any>,
	sizes?: FieldPolicy<any> | FieldReadFunction<any>,
	suitability?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemGroupSizeKeySpecifier = ('id' | 'liveGmVariations' | 'minQty' | 'name' | 'packaging' | 'servings' | MenuItemGroupSizeKeySpecifier)[];
export type MenuItemGroupSizeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	liveGmVariations?: FieldPolicy<any> | FieldReadFunction<any>,
	minQty?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging?: FieldPolicy<any> | FieldReadFunction<any>,
	servings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemGroupsPagedKeySpecifier = ('groups' | 'pageInfo' | MenuItemGroupsPagedKeySpecifier)[];
export type MenuItemGroupsPagedFieldPolicy = {
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemIncDeletedKeySpecifier = ('_id' | 'item' | MenuItemIncDeletedKeySpecifier)[];
export type MenuItemIncDeletedFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemMetaKeySpecifier = ('categoryConfidence' | 'categoryReviewed' | MenuItemMetaKeySpecifier)[];
export type MenuItemMetaFieldPolicy = {
	categoryConfidence?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryReviewed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemOptionsKeySpecifier = ('_id' | 'categoryType' | 'items' | 'maxQty' | 'minQty' | 'name' | 'optionType' | 'position' | 'printExtraLabel' | 'qtyPerPerson' | MenuItemOptionsKeySpecifier)[];
export type MenuItemOptionsFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryType?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	maxQty?: FieldPolicy<any> | FieldReadFunction<any>,
	minQty?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	optionType?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	printExtraLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	qtyPerPerson?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemPagedKeySpecifier = ('pageInfo' | 'rows' | MenuItemPagedKeySpecifier)[];
export type MenuItemPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemPriceSyncStatusResponseKeySpecifier = ('batchesCompleted' | 'estimatedItemsCompleted' | 'finishTime' | 'startTime' | 'status' | 'syncJobId' | MenuItemPriceSyncStatusResponseKeySpecifier)[];
export type MenuItemPriceSyncStatusResponseFieldPolicy = {
	batchesCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedItemsCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	finishTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	syncJobId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemStatisticsKeySpecifier = ('count' | 'maxPrice' | 'minPrice' | MenuItemStatisticsKeySpecifier)[];
export type MenuItemStatisticsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	maxPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemSuitabilityOccasionKeySpecifier = ('occasion' | 'rank' | 'weight' | MenuItemSuitabilityOccasionKeySpecifier)[];
export type MenuItemSuitabilityOccasionFieldPolicy = {
	occasion?: FieldPolicy<any> | FieldReadFunction<any>,
	rank?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemVariationKeySpecifier = ('_id' | 'avgRating' | 'categoryId' | 'categoryIdArray' | 'coreLiveItem' | 'customerPriceItems' | 'dailyStock' | 'deleted' | 'discountPrice' | 'feedrDiscountPrice' | 'futureCcOrders' | 'group' | 'internalAdminOnly' | 'internalName' | 'isActive' | 'isBreakfast' | 'isCombo' | 'isDinner' | 'isLunch' | 'isPricePerHead' | 'isPrivate' | 'isPromo' | 'isSampleBreakfast' | 'isSampleDinner' | 'isSampleLunch' | 'markupRate' | 'markupValue' | 'minQty' | 'name' | 'orderLimit' | 'packaging' | 'piecesPerItem' | 'popularity' | 'position' | 'price' | 'priceCustomerFacing' | 'priceCustomerFacingExTax' | 'priceExTax' | 'privateAccessAccountIdArray' | 'privateAccessAccounts' | 'reducedCommissionRate' | 'reducedCommissionValue' | 'servings' | 'standardCommissionRate' | 'standardCommissionValue' | 'taxRate' | 'taxValue' | 'taxValueCustomerFacing' | 'type' | 'varType' | MenuItemVariationKeySpecifier)[];
export type MenuItemVariationFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	avgRating?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryIdArray?: FieldPolicy<any> | FieldReadFunction<any>,
	coreLiveItem?: FieldPolicy<any> | FieldReadFunction<any>,
	customerPriceItems?: FieldPolicy<any> | FieldReadFunction<any>,
	dailyStock?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	discountPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	feedrDiscountPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	futureCcOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	internalAdminOnly?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isBreakfast?: FieldPolicy<any> | FieldReadFunction<any>,
	isCombo?: FieldPolicy<any> | FieldReadFunction<any>,
	isDinner?: FieldPolicy<any> | FieldReadFunction<any>,
	isLunch?: FieldPolicy<any> | FieldReadFunction<any>,
	isPricePerHead?: FieldPolicy<any> | FieldReadFunction<any>,
	isPrivate?: FieldPolicy<any> | FieldReadFunction<any>,
	isPromo?: FieldPolicy<any> | FieldReadFunction<any>,
	isSampleBreakfast?: FieldPolicy<any> | FieldReadFunction<any>,
	isSampleDinner?: FieldPolicy<any> | FieldReadFunction<any>,
	isSampleLunch?: FieldPolicy<any> | FieldReadFunction<any>,
	markupRate?: FieldPolicy<any> | FieldReadFunction<any>,
	markupValue?: FieldPolicy<any> | FieldReadFunction<any>,
	minQty?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging?: FieldPolicy<any> | FieldReadFunction<any>,
	piecesPerItem?: FieldPolicy<any> | FieldReadFunction<any>,
	popularity?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceCustomerFacing?: FieldPolicy<any> | FieldReadFunction<any>,
	priceCustomerFacingExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	privateAccessAccountIdArray?: FieldPolicy<any> | FieldReadFunction<any>,
	privateAccessAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	reducedCommissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	reducedCommissionValue?: FieldPolicy<any> | FieldReadFunction<any>,
	servings?: FieldPolicy<any> | FieldReadFunction<any>,
	standardCommissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	standardCommissionValue?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValueCustomerFacing?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	varType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemsPagedKeySpecifier = ('items' | 'pageInfo' | MenuItemsPagedKeySpecifier)[];
export type MenuItemsPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuStatisticsKeySpecifier = ('activeCcItems' | 'activeGmItems' | 'activeItems' | 'allMenuItemCount' | 'allergenBreakdown' | 'dietaryBreakdown' | 'drinks' | 'inDraft' | 'inReview' | 'inactiveCcItems' | 'lastPublished' | 'mains' | 'missingFoodGoals' | 'missingImages' | 'missingNutrional' | 'publishedMenuItemCount' | 'sides' | 'totalItems' | 'vendorId' | MenuStatisticsKeySpecifier)[];
export type MenuStatisticsFieldPolicy = {
	activeCcItems?: FieldPolicy<any> | FieldReadFunction<any>,
	activeGmItems?: FieldPolicy<any> | FieldReadFunction<any>,
	activeItems?: FieldPolicy<any> | FieldReadFunction<any>,
	allMenuItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	allergenBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	dietaryBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	drinks?: FieldPolicy<any> | FieldReadFunction<any>,
	inDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	inReview?: FieldPolicy<any> | FieldReadFunction<any>,
	inactiveCcItems?: FieldPolicy<any> | FieldReadFunction<any>,
	lastPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	mains?: FieldPolicy<any> | FieldReadFunction<any>,
	missingFoodGoals?: FieldPolicy<any> | FieldReadFunction<any>,
	missingImages?: FieldPolicy<any> | FieldReadFunction<any>,
	missingNutrional?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedMenuItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	sides?: FieldPolicy<any> | FieldReadFunction<any>,
	totalItems?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageTemplateKeySpecifier = ('body' | 'createdAt' | 'deletedAt' | 'dynamicMessageTemplateType' | 'id' | 'isDynamic' | 'name' | 'tenantId' | 'updatedAt' | MessageTemplateKeySpecifier)[];
export type MessageTemplateFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dynamicMessageTemplateType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDynamic?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageTemplatePagedKeySpecifier = ('pageInfo' | 'rows' | MessageTemplatePagedKeySpecifier)[];
export type MessageTemplatePagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ModifierCategoryKeySpecifier = ('_id' | 'draftItems' | 'liveItems' | 'maxQty' | 'minQty' | 'name' | 'optionType' | 'qtyPerPerson' | 'vendorId' | ModifierCategoryKeySpecifier)[];
export type ModifierCategoryFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	draftItems?: FieldPolicy<any> | FieldReadFunction<any>,
	liveItems?: FieldPolicy<any> | FieldReadFunction<any>,
	maxQty?: FieldPolicy<any> | FieldReadFunction<any>,
	minQty?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	optionType?: FieldPolicy<any> | FieldReadFunction<any>,
	qtyPerPerson?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ModifierCategoryMutationPayloadKeySpecifier = ('id' | ModifierCategoryMutationPayloadKeySpecifier)[];
export type ModifierCategoryMutationPayloadFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoveInvoiceAccountResponseKeySpecifier = ('count' | MoveInvoiceAccountResponseKeySpecifier)[];
export type MoveInvoiceAccountResponseFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('activateFleetConnection' | 'activatePlatformAlert' | 'addInvoiceItem' | 'addInvoicePayment' | 'addItemToGmBasket' | 'addTenantContactRegion' | 'addVendorStatementItem' | 'adjustQuantityEmmaAlgorithmResponses' | 'adminDecreaseUserCredits' | 'adminIncreaseUserCredits' | 'applyCreditCardFee' | 'applyEditSessionChangesToBasket' | 'applyNewReferenceFieldsToBasket' | 'applyNewReferenceFieldsToCCSupplierOrder' | 'applyNewReferenceFieldsToOrder' | 'applyNewReferenceFieldsToStandingOrderTemplate' | 'approveInvoice' | 'approveVendorStatement' | 'archiveAccount' | 'assignBasketToGuest' | 'assignUsersToTeam' | 'bulkCreateStandingOrders' | 'cancelGmOrder' | 'cancelInvoice' | 'cancelVendorStatement' | 'checkout' | 'clearEmmaMenuItemGroup' | 'confirmGmOrder' | 'consolidateFlexInvoice' | 'createAccount' | 'createAccountCountryFlexMapping' | 'createAccountIdentityProvider' | 'createAlert' | 'createBillingEntity' | 'createCCCluster' | 'createCCLaunchServicePdf' | 'createCCOrderForUser' | 'createCCOrderPrintPdf' | 'createCCSubmenu' | 'createCCTeam' | 'createCaterdeskApiUser' | 'createCcOrderReminderNotification' | 'createDeliveryDocketPdf' | 'createDeliveryRegion' | 'createEmmaAutomation' | 'createEmmaOccasion' | 'createEmmaRecipe' | 'createFlexInvoice' | 'createFlexInvoiceAccount' | 'createGmBasket' | 'createGmInvoices' | 'createGmIssue' | 'createGmOrderFromBasket' | 'createGmOrderPdf' | 'createInvoiceAccount' | 'createMenuItem' | 'createMenuItemGroup' | 'createOneGmInvoice' | 'createOrUpdateMyFavourite' | 'createPlatformAlert' | 'createQuoteCollection' | 'createReferenceField' | 'createRefund' | 'createStandingOrder' | 'createTenant' | 'createUser' | 'createVendorCharge' | 'createVendorFlexInvoice' | 'createVendorTag' | 'deactivateFleetConnection' | 'deactivatePlatformAlert' | 'deleteAccountLocation' | 'deleteAdmin' | 'deleteAlert' | 'deleteBillingEntity' | 'deleteCCCluster' | 'deleteCCOrderItem' | 'deleteCCSubmenu' | 'deleteCCTeam' | 'deleteDeliveryRegion' | 'deleteEmmaAutomation' | 'deleteEmmaFormResponse' | 'deleteEmmaOccasion' | 'deleteEmmaRecipe' | 'deleteFeedrUser' | 'deleteFlexInvoiceAccount' | 'deleteGmBasket' | 'deleteGmIssue' | 'deleteGmMenuCategories' | 'deleteInvoiceAccount' | 'deleteMenuItem' | 'deleteMenuItemGroup' | 'deleteMenuItems' | 'deletePlatformAlert' | 'deleteQuoteCollection' | 'deleteReferenceField' | 'deleteRefund' | 'deleteStandingOrder' | 'deleteSupplierContact' | 'deleteUser' | 'deleteVendorCharge' | 'duplicateGmBasket' | 'duplicateMenuItem' | 'emmaCategoriseItem' | 'forcePlaceGmOrder' | 'forceRunStandingOrderGeneration' | 'forgotPassword' | 'generateSlackAlertingOAuthUrl' | 'generateStripeSetupIntentOnFlex' | 'generateTenantImageUploadUrl' | 'incrementLiveMenuItemPopularities' | 'initiateCCOrder' | 'initiateInvoiceCardPayment' | 'initiatePayment' | 'invoicingSendEmailToAssociatedContacts' | 'markFlexInvoicesAsPaid' | 'moveInvoiceAccount' | 'prepareEmptyBasketFromQuoteRequest' | 'publishInReviewMenuItems' | 'rateCCOrderItem' | 'rateGmOrder' | 'recreateInvoice' | 'redeployFrontends' | 'refundPayment' | 'regenerateEmmaAlgorithmResponses' | 'removeFlexInvoiceOrder' | 'removeInvoiceItem' | 'removeItemFromGmBasket' | 'removeOrdersFromFlexInvoice' | 'removeOrdersFromVendorFlexInvoice' | 'removeVendorStatementItem' | 'resendSignupConfirmation' | 'restoreDeletedAccountLocation' | 'restoreDeletedInvoiceAccount' | 'restoreMenuItem' | 'restoreUser' | 'reviewCCOrderItem' | 'sendCCLaunchServiceEmail' | 'sendCcOrderReminderNotification' | 'sendFlexInvoiceByEmail' | 'sendGmMultiQuotes' | 'sendGmQuote' | 'sendInstantGmOrderToFlex' | 'sendVendorFlexInvoiceByEmail' | 'setMyCaterdeskApiUserPassword' | 'setPasswordCaterdeskApiUser' | 'setTeamSubsidies' | 'setUserForGuestGmBaskets' | 'signUp' | 'startPayment' | 'submitEmmaForm' | 'syncGMOrderToExternal' | 'syncInstantGMOrderWithFlex' | 'syncInvoiceOrderWithFlex' | 'syncMenuItemPrices' | 'trackCheckoutStarted' | 'unlockAllMenuItemsForVendor' | 'unsubscribeUserFromEmailNotification' | 'updateAccount' | 'updateAccountFinanceSettings' | 'updateAccountIdentityProvider' | 'updateAccountLocationReferenceFields' | 'updateAccountLocationVendorPreferences' | 'updateAdminUser' | 'updateAlert' | 'updateBillingEntity' | 'updateCCCluster' | 'updateCCSubmenu' | 'updateCCSupplierOrderReferenceFieldValues' | 'updateCCSupplierOrderStatus' | 'updateCCTeam' | 'updateCaterdeskApiUser' | 'updateDeliveryRegion' | 'updateEmmaAutomation' | 'updateEmmaFormResponse' | 'updateEmmaFormResponseAdminAssigned' | 'updateEmmaOccasion' | 'updateEmmaRecipe' | 'updateFlexInvoiceAccount' | 'updateFlexInvoiceDetails' | 'updateFlexInvoicingPaymentSettings' | 'updateGmBasket' | 'updateGmOrder' | 'updateGmOrderStatus' | 'updateInvoice' | 'updateInvoiceAccount' | 'updateItemInGmBasket' | 'updateItemQtyInGmBasket' | 'updateMe' | 'updateMenuItem' | 'updateMenuItemGroup' | 'updateMenuItemGroups' | 'updateMenuItems' | 'updateMultipleVendorTags' | 'updatePlatformAlert' | 'updateReferenceField' | 'updateReferenceFieldInBasket' | 'updateStandingOrder' | 'updateStandingOrderTemplate' | 'updateTenant' | 'updateUser' | 'updateUserAllergens' | 'updateUserAutopilotSettings' | 'updateUserDietaryPreferences' | 'updateVendor' | 'updateVendorFlexInvoiceDetails' | 'upsertEmmaMenuItemGroup' | 'upsertGmMenuCategories' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	activateFleetConnection?: FieldPolicy<any> | FieldReadFunction<any>,
	activatePlatformAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	addInvoiceItem?: FieldPolicy<any> | FieldReadFunction<any>,
	addInvoicePayment?: FieldPolicy<any> | FieldReadFunction<any>,
	addItemToGmBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	addTenantContactRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	addVendorStatementItem?: FieldPolicy<any> | FieldReadFunction<any>,
	adjustQuantityEmmaAlgorithmResponses?: FieldPolicy<any> | FieldReadFunction<any>,
	adminDecreaseUserCredits?: FieldPolicy<any> | FieldReadFunction<any>,
	adminIncreaseUserCredits?: FieldPolicy<any> | FieldReadFunction<any>,
	applyCreditCardFee?: FieldPolicy<any> | FieldReadFunction<any>,
	applyEditSessionChangesToBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	applyNewReferenceFieldsToBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	applyNewReferenceFieldsToCCSupplierOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	applyNewReferenceFieldsToOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	applyNewReferenceFieldsToStandingOrderTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	approveInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	approveVendorStatement?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	assignBasketToGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	assignUsersToTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	bulkCreateStandingOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelGmOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelVendorStatement?: FieldPolicy<any> | FieldReadFunction<any>,
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	clearEmmaMenuItemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmGmOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	consolidateFlexInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	createAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	createAccountCountryFlexMapping?: FieldPolicy<any> | FieldReadFunction<any>,
	createAccountIdentityProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	createAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	createBillingEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	createCCCluster?: FieldPolicy<any> | FieldReadFunction<any>,
	createCCLaunchServicePdf?: FieldPolicy<any> | FieldReadFunction<any>,
	createCCOrderForUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createCCOrderPrintPdf?: FieldPolicy<any> | FieldReadFunction<any>,
	createCCSubmenu?: FieldPolicy<any> | FieldReadFunction<any>,
	createCCTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	createCaterdeskApiUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createCcOrderReminderNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	createDeliveryDocketPdf?: FieldPolicy<any> | FieldReadFunction<any>,
	createDeliveryRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	createEmmaAutomation?: FieldPolicy<any> | FieldReadFunction<any>,
	createEmmaOccasion?: FieldPolicy<any> | FieldReadFunction<any>,
	createEmmaRecipe?: FieldPolicy<any> | FieldReadFunction<any>,
	createFlexInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	createFlexInvoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	createGmBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	createGmInvoices?: FieldPolicy<any> | FieldReadFunction<any>,
	createGmIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	createGmOrderFromBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	createGmOrderPdf?: FieldPolicy<any> | FieldReadFunction<any>,
	createInvoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	createMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createMenuItemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	createOneGmInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	createOrUpdateMyFavourite?: FieldPolicy<any> | FieldReadFunction<any>,
	createPlatformAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	createQuoteCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	createReferenceField?: FieldPolicy<any> | FieldReadFunction<any>,
	createRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	createStandingOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createTenant?: FieldPolicy<any> | FieldReadFunction<any>,
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createVendorCharge?: FieldPolicy<any> | FieldReadFunction<any>,
	createVendorFlexInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	createVendorTag?: FieldPolicy<any> | FieldReadFunction<any>,
	deactivateFleetConnection?: FieldPolicy<any> | FieldReadFunction<any>,
	deactivatePlatformAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAccountLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBillingEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCCCluster?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCCOrderItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCCSubmenu?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCCTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDeliveryRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmmaAutomation?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmmaFormResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmmaOccasion?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmmaRecipe?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFeedrUser?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFlexInvoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteGmBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteGmIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteGmMenuCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteInvoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMenuItemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMenuItems?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePlatformAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteQuoteCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteReferenceField?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteStandingOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSupplierContact?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVendorCharge?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicateGmBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicateMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaCategoriseItem?: FieldPolicy<any> | FieldReadFunction<any>,
	forcePlaceGmOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	forceRunStandingOrderGeneration?: FieldPolicy<any> | FieldReadFunction<any>,
	forgotPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	generateSlackAlertingOAuthUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	generateStripeSetupIntentOnFlex?: FieldPolicy<any> | FieldReadFunction<any>,
	generateTenantImageUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	incrementLiveMenuItemPopularities?: FieldPolicy<any> | FieldReadFunction<any>,
	initiateCCOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	initiateInvoiceCardPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	initiatePayment?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicingSendEmailToAssociatedContacts?: FieldPolicy<any> | FieldReadFunction<any>,
	markFlexInvoicesAsPaid?: FieldPolicy<any> | FieldReadFunction<any>,
	moveInvoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	prepareEmptyBasketFromQuoteRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	publishInReviewMenuItems?: FieldPolicy<any> | FieldReadFunction<any>,
	rateCCOrderItem?: FieldPolicy<any> | FieldReadFunction<any>,
	rateGmOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	recreateInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	redeployFrontends?: FieldPolicy<any> | FieldReadFunction<any>,
	refundPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	regenerateEmmaAlgorithmResponses?: FieldPolicy<any> | FieldReadFunction<any>,
	removeFlexInvoiceOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	removeInvoiceItem?: FieldPolicy<any> | FieldReadFunction<any>,
	removeItemFromGmBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	removeOrdersFromFlexInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	removeOrdersFromVendorFlexInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	removeVendorStatementItem?: FieldPolicy<any> | FieldReadFunction<any>,
	resendSignupConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreDeletedAccountLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreDeletedInvoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreUser?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewCCOrderItem?: FieldPolicy<any> | FieldReadFunction<any>,
	sendCCLaunchServiceEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendCcOrderReminderNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	sendFlexInvoiceByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendGmMultiQuotes?: FieldPolicy<any> | FieldReadFunction<any>,
	sendGmQuote?: FieldPolicy<any> | FieldReadFunction<any>,
	sendInstantGmOrderToFlex?: FieldPolicy<any> | FieldReadFunction<any>,
	sendVendorFlexInvoiceByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	setMyCaterdeskApiUserPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	setPasswordCaterdeskApiUser?: FieldPolicy<any> | FieldReadFunction<any>,
	setTeamSubsidies?: FieldPolicy<any> | FieldReadFunction<any>,
	setUserForGuestGmBaskets?: FieldPolicy<any> | FieldReadFunction<any>,
	signUp?: FieldPolicy<any> | FieldReadFunction<any>,
	startPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	submitEmmaForm?: FieldPolicy<any> | FieldReadFunction<any>,
	syncGMOrderToExternal?: FieldPolicy<any> | FieldReadFunction<any>,
	syncInstantGMOrderWithFlex?: FieldPolicy<any> | FieldReadFunction<any>,
	syncInvoiceOrderWithFlex?: FieldPolicy<any> | FieldReadFunction<any>,
	syncMenuItemPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	trackCheckoutStarted?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockAllMenuItemsForVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	unsubscribeUserFromEmailNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAccountFinanceSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAccountIdentityProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAccountLocationReferenceFields?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAccountLocationVendorPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAdminUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBillingEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCCCluster?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCCSubmenu?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCCSupplierOrderReferenceFieldValues?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCCSupplierOrderStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCCTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCaterdeskApiUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDeliveryRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEmmaAutomation?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEmmaFormResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEmmaFormResponseAdminAssigned?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEmmaOccasion?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEmmaRecipe?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFlexInvoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFlexInvoiceDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFlexInvoicingPaymentSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	updateGmBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	updateGmOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	updateGmOrderStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updateInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	updateInvoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	updateItemInGmBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	updateItemQtyInGmBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMe?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMenuItemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMenuItemGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMenuItems?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMultipleVendorTags?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePlatformAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	updateReferenceField?: FieldPolicy<any> | FieldReadFunction<any>,
	updateReferenceFieldInBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	updateStandingOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	updateStandingOrderTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTenant?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserAllergens?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserAutopilotSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserDietaryPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVendorFlexInvoiceDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertEmmaMenuItemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertGmMenuCategories?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MyCaterdeskApiEntityAccessKeySpecifier = ('id' | 'name' | MyCaterdeskApiEntityAccessKeySpecifier)[];
export type MyCaterdeskApiEntityAccessFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MyCaterdeskApiUserKeySpecifier = ('accounts' | 'email' | 'id' | 'isActive' | 'roles' | 'scopes' | 'tenantWideAccess' | 'vendors' | MyCaterdeskApiUserKeySpecifier)[];
export type MyCaterdeskApiUserFieldPolicy = {
	accounts?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	scopes?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantWideAccess?: FieldPolicy<any> | FieldReadFunction<any>,
	vendors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavLinkKeySpecifier = ('href' | 'ssgPage' | 'title' | NavLinkKeySpecifier)[];
export type NavLinkFieldPolicy = {
	href?: FieldPolicy<any> | FieldReadFunction<any>,
	ssgPage?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NewAccountLocationKeySpecifier = ('address' | 'label' | NewAccountLocationKeySpecifier)[];
export type NewAccountLocationFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NewUserSignupResponseKeySpecifier = ('resetPasswordEmailSent' | 'success' | NewUserSignupResponseKeySpecifier)[];
export type NewUserSignupResponseFieldPolicy = {
	resetPasswordEmailSent?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationEventEmailKeySpecifier = ('attachments' | 'canPreview' | 'contentHtml' | 'email' | 'hasAttachments' | 'id' | 'sentAt' | 'status' | 'subject' | NotificationEventEmailKeySpecifier)[];
export type NotificationEventEmailFieldPolicy = {
	attachments?: FieldPolicy<any> | FieldReadFunction<any>,
	canPreview?: FieldPolicy<any> | FieldReadFunction<any>,
	contentHtml?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAttachments?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationEventEmailAttachmentKeySpecifier = ('contentType' | 'fileName' | 'presignedUrl' | NotificationEventEmailAttachmentKeySpecifier)[];
export type NotificationEventEmailAttachmentFieldPolicy = {
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	presignedUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationEventPushKeySpecifier = ('body' | 'email' | 'id' | 'sentAt' | 'status' | 'title' | NotificationEventPushKeySpecifier)[];
export type NotificationEventPushFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OccasionDayMonthKeySpecifier = ('day' | 'month' | OccasionDayMonthKeySpecifier)[];
export type OccasionDayMonthFieldPolicy = {
	day?: FieldPolicy<any> | FieldReadFunction<any>,
	month?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OptionItemKeySpecifier = ('_id' | 'customerPriceItems' | 'item' | 'legacyItemId' | 'markupRate' | 'markupValue' | 'position' | 'price' | 'priceCustomerFacing' | 'priceCustomerFacingExTax' | 'priceExTax' | 'reducedCommissionRate' | 'reducedCommissionValue' | 'standardCommissionRate' | 'standardCommissionValue' | 'taxRate' | 'taxValue' | 'taxValueCustomerFacing' | OptionItemKeySpecifier)[];
export type OptionItemFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	customerPriceItems?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	markupRate?: FieldPolicy<any> | FieldReadFunction<any>,
	markupValue?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceCustomerFacing?: FieldPolicy<any> | FieldReadFunction<any>,
	priceCustomerFacingExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	reducedCommissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	reducedCommissionValue?: FieldPolicy<any> | FieldReadFunction<any>,
	standardCommissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	standardCommissionValue?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	taxValueCustomerFacing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderDeliveryUpdateKeySpecifier = ('deliveryStatus' | 'driver' | 'etaDropoff' | 'etaPickup' | 'feedrOrderId' | OrderDeliveryUpdateKeySpecifier)[];
export type OrderDeliveryUpdateFieldPolicy = {
	deliveryStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	driver?: FieldPolicy<any> | FieldReadFunction<any>,
	etaDropoff?: FieldPolicy<any> | FieldReadFunction<any>,
	etaPickup?: FieldPolicy<any> | FieldReadFunction<any>,
	feedrOrderId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderDeliveryUpdateDriverKeySpecifier = ('location' | OrderDeliveryUpdateDriverKeySpecifier)[];
export type OrderDeliveryUpdateDriverFieldPolicy = {
	location?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderDeliveryUpdateDriverLocationKeySpecifier = ('lat' | 'long' | OrderDeliveryUpdateDriverLocationKeySpecifier)[];
export type OrderDeliveryUpdateDriverLocationFieldPolicy = {
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	long?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderReferenceFieldKeySpecifier = ('description' | 'fieldType' | 'id' | 'isRequired' | 'label' | 'options' | 'referenceFieldId' | 'version' | OrderReferenceFieldKeySpecifier)[];
export type OrderReferenceFieldFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFieldId?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderReferenceFieldOptionKeySpecifier = ('id' | 'option' | 'orderPriority' | 'orderReferenceFieldId' | OrderReferenceFieldOptionKeySpecifier)[];
export type OrderReferenceFieldOptionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	option?: FieldPolicy<any> | FieldReadFunction<any>,
	orderPriority?: FieldPolicy<any> | FieldReadFunction<any>,
	orderReferenceFieldId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderReferenceFieldResolvedValueKeySpecifier = ('label' | 'value' | OrderReferenceFieldResolvedValueKeySpecifier)[];
export type OrderReferenceFieldResolvedValueFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderSupplierTagKeySpecifier = ('label' | 'name' | OrderSupplierTagKeySpecifier)[];
export type OrderSupplierTagFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderTypeAmountKeySpecifier = ('amount' | 'orderType' | OrderTypeAmountKeySpecifier)[];
export type OrderTypeAmountFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	orderType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrdersReportResultKeySpecifier = ('CC' | 'GM' | OrdersReportResultKeySpecifier)[];
export type OrdersReportResultFieldPolicy = {
	CC?: FieldPolicy<any> | FieldReadFunction<any>,
	GM?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrdersReportResultCCKeySpecifier = ('customerOrders' | 'supplierOrders' | OrdersReportResultCCKeySpecifier)[];
export type OrdersReportResultCCFieldPolicy = {
	customerOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierOrders?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrdersReportResultGMKeySpecifier = ('customerOrders' | 'supplierOrders' | OrdersReportResultGMKeySpecifier)[];
export type OrdersReportResultGMFieldPolicy = {
	customerOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierOrders?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoKeySpecifier = ('count' | 'hasMore' | 'limit' | 'offset' | PageInfoKeySpecifier)[];
export type PageInfoFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	hasMore?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayByCardResponseKeySpecifier = ('authToken' | PayByCardResponseKeySpecifier)[];
export type PayByCardResponseFieldPolicy = {
	authToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayByInvoiceResponseKeySpecifier = ('orderId' | PayByInvoiceResponseKeySpecifier)[];
export type PayByInvoiceResponseFieldPolicy = {
	orderId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayByTransferResponseKeySpecifier = ('orderId' | PayByTransferResponseKeySpecifier)[];
export type PayByTransferResponseFieldPolicy = {
	orderId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentKeySpecifier = ('billingEntityCode' | 'currency' | 'descriptions' | 'hold' | 'id' | 'lineItems' | 'productIdentifier' | 'productType' | 'stripePublishableKey' | 'successRedirectUrl' | 'total' | 'user' | PaymentKeySpecifier)[];
export type PaymentFieldPolicy = {
	billingEntityCode?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	hold?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItems?: FieldPolicy<any> | FieldReadFunction<any>,
	productIdentifier?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePublishableKey?: FieldPolicy<any> | FieldReadFunction<any>,
	successRedirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentAuthTokenKeySpecifier = ('expiryTimestamp' | PaymentAuthTokenKeySpecifier)[];
export type PaymentAuthTokenFieldPolicy = {
	expiryTimestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentCardKeySpecifier = ('brand' | 'lastFourDigits' | 'stripeId' | PaymentCardKeySpecifier)[];
export type PaymentCardFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	lastFourDigits?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentHistoryKeySpecifier = ('amount' | 'date' | 'source' | PaymentHistoryKeySpecifier)[];
export type PaymentHistoryFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlatformAlertKeySpecifier = ('countryCodes' | 'createdAt' | 'description' | 'id' | 'isActive' | 'message' | 'portals' | 'severity' | 'targetAccountIds' | 'targetUserIds' | 'targetVendorIds' | 'title' | 'updatedAt' | PlatformAlertKeySpecifier)[];
export type PlatformAlertFieldPolicy = {
	countryCodes?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	portals?: FieldPolicy<any> | FieldReadFunction<any>,
	severity?: FieldPolicy<any> | FieldReadFunction<any>,
	targetAccountIds?: FieldPolicy<any> | FieldReadFunction<any>,
	targetUserIds?: FieldPolicy<any> | FieldReadFunction<any>,
	targetVendorIds?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlatformAlertConnectionKeySpecifier = ('items' | 'pageInfo' | 'totalCount' | PlatformAlertConnectionKeySpecifier)[];
export type PlatformAlertConnectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlatformAlertPageInfoKeySpecifier = ('hasNextPage' | 'hasPreviousPage' | 'page' | 'pageSize' | 'totalPages' | PlatformAlertPageInfoKeySpecifier)[];
export type PlatformAlertPageInfoFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSize?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PopularItemKeySpecifier = ('accountCount' | 'itemReference' | 'orderCount' | 'rank' | PopularItemKeySpecifier)[];
export type PopularItemFieldPolicy = {
	accountCount?: FieldPolicy<any> | FieldReadFunction<any>,
	itemReference?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	rank?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PriceLevelsKeySpecifier = ('one' | 'three' | 'two' | PriceLevelsKeySpecifier)[];
export type PriceLevelsFieldPolicy = {
	one?: FieldPolicy<any> | FieldReadFunction<any>,
	three?: FieldPolicy<any> | FieldReadFunction<any>,
	two?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrivateSupplierKeySpecifier = ('supplierId' | 'supplierName' | PrivateSupplierKeySpecifier)[];
export type PrivateSupplierFieldPolicy = {
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProposedGmOrderTotalsKeySpecifier = ('discountBreakdown' | 'fees' | 'hasEnterpriseDiscount' | 'id' | 'minimumOrderValue' | 'orderPlacementCutOffTime' | 'orderTotalBreakdown' | 'subtotalExTax' | ProposedGmOrderTotalsKeySpecifier)[];
export type ProposedGmOrderTotalsFieldPolicy = {
	discountBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	hasEnterpriseDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumOrderValue?: FieldPolicy<any> | FieldReadFunction<any>,
	orderPlacementCutOffTime?: FieldPolicy<any> | FieldReadFunction<any>,
	orderTotalBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotalExTax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublishAllMenuItemPayloadKeySpecifier = ('failedIds' | 'success' | PublishAllMenuItemPayloadKeySpecifier)[];
export type PublishAllMenuItemPayloadFieldPolicy = {
	failedIds?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublishMenuItemPayloadKeySpecifier = ('id' | 'publishedTimestamp' | 'updatedAt' | PublishMenuItemPayloadKeySpecifier)[];
export type PublishMenuItemPayloadFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('account' | 'accountLocation' | 'accountPrivateSuppliers' | 'accounts' | 'activePlatformAlertForUser' | 'adminUserCreditTransactions' | 'admins' | 'alertTenantConfig' | 'alertTypes' | 'alerts' | 'allSsoSettingsByDomain' | 'availableDeliveryPartners' | 'billingEntities' | 'billingFields' | 'calculateVatForItem' | 'caterdeskApiScopes' | 'caterdeskApiUser' | 'caterdeskApiUsers' | 'ccCluster' | 'ccClusters' | 'ccMenuDebug' | 'ccOrderByTransaction' | 'ccOrderItem' | 'ccOrderProgress' | 'ccOrderReminderNotification' | 'ccSubmenu' | 'ccSubmenus' | 'ccSupplierOrder' | 'ccSupplierOrders' | 'ccTeam' | 'ccTeamSubsidies' | 'ccTeams' | 'ccVendorMenusDebug' | 'ccWeeklyReminderReport' | 'cities' | 'closestMatchingSupplierLocations' | 'countries' | 'coupons' | 'customerFlexInvoiceCSV' | 'customerFlexInvoicePDF' | 'customerOrdersReport' | 'customerOrdersSummary' | 'deliveryPartner' | 'deliveryPartners' | 'deliveryRegion' | 'draftMenuItem' | 'emmaAutomation' | 'emmaAutomations' | 'emmaCategories' | 'emmaFormResponse' | 'emmaFormResponses' | 'emmaOccasions' | 'emmaRecipes' | 'findCoupon' | 'flexInvoice' | 'flexInvoiceAccount' | 'flexInvoiceAllTypes' | 'flexInvoices' | 'getGeocode' | 'ghosterUser' | 'gmAvailabilityById' | 'gmAvailabilityByVendorId' | 'gmBasket' | 'gmBaskets' | 'gmIssues' | 'gmItemSearch' | 'gmOrder' | 'gmOrderLite' | 'gmOrders' | 'internalAdminTenantLinks' | 'invoice' | 'invoiceAccount' | 'invoiceCombined' | 'invoiceOrders' | 'invoices' | 'invoicesCombined' | 'isSendGridDomainValid' | 'languages' | 'latestActivePlatformAlert' | 'latestFlexConsolidationRun' | 'liveMenuItem' | 'liveMenuItems' | 'lookupAddress' | 'me' | 'menuItemCategories' | 'menuItemGroup' | 'menuItemPriceSyncStatus' | 'messageTemplates' | 'myCaterdeskApiUsers' | 'myVendorLocations' | 'notificationHistory' | 'orderDeliveryUpdates' | 'orderReferenceFields' | 'ordersReport' | 'payment' | 'paymentAuthToken' | 'platformAlert' | 'platformAlerts' | 'proposedGmOrderTotals' | 'quoteCollection' | 'quoteCollections' | 'referenceFields' | 'retrieveStripePublishableKey' | 'reviewsServiceStatus' | 'sendgridIpPools' | 'serviceVatBand' | 'signupMetadata' | 'ssoSettingsByCompanyCode' | 'ssoSettingsByDomain' | 'standingOrder' | 'standingOrderPlacementProgressRecords' | 'standingOrderTemplate' | 'standingOrders' | 'standingOrdersPage' | 'standingOrdersWithMenuItem' | 'stripeCustomerSession' | 'summaryFlexReportCSV' | 'syncedInvoiceOrders' | 'tags' | 'tempEmmaRandomUnreviewedItem' | 'tenant' | 'tenants' | 'timezoneForLatLng' | 'timezones' | 'topRatedGmVendors' | 'user' | 'userCreditTransactions' | 'users' | 'vatBand' | 'vatBands' | 'vatRegion' | 'vatRegions' | 'vendor' | 'vendorByPermalink' | 'vendorCategoryItems' | 'vendorContacts' | 'vendorFlexInvoice' | 'vendorFlexInvoiceAllTypes' | 'vendorFlexInvoiceCSV' | 'vendorFlexInvoicePDF' | 'vendorFlexInvoices' | 'vendorHighlightsForLocation' | 'vendorInvoiceOrders' | 'vendorLocation' | 'vendorMenuCategories' | 'vendorRating' | 'vendorStatement' | 'vendorStatementCombined' | 'vendorStatements' | 'vendorStatementsCombined' | 'vendorStatementsSummary' | 'vendors' | 'vendorsForHighlightCategoryForLocation' | 'vendorsInRangeLocations' | 'vendorsList' | 'vendorsTags' | 'verifyCoupon' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	accountPrivateSuppliers?: FieldPolicy<any> | FieldReadFunction<any>,
	accounts?: FieldPolicy<any> | FieldReadFunction<any>,
	activePlatformAlertForUser?: FieldPolicy<any> | FieldReadFunction<any>,
	adminUserCreditTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	admins?: FieldPolicy<any> | FieldReadFunction<any>,
	alertTenantConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	alertTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	alerts?: FieldPolicy<any> | FieldReadFunction<any>,
	allSsoSettingsByDomain?: FieldPolicy<any> | FieldReadFunction<any>,
	availableDeliveryPartners?: FieldPolicy<any> | FieldReadFunction<any>,
	billingEntities?: FieldPolicy<any> | FieldReadFunction<any>,
	billingFields?: FieldPolicy<any> | FieldReadFunction<any>,
	calculateVatForItem?: FieldPolicy<any> | FieldReadFunction<any>,
	caterdeskApiScopes?: FieldPolicy<any> | FieldReadFunction<any>,
	caterdeskApiUser?: FieldPolicy<any> | FieldReadFunction<any>,
	caterdeskApiUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	ccCluster?: FieldPolicy<any> | FieldReadFunction<any>,
	ccClusters?: FieldPolicy<any> | FieldReadFunction<any>,
	ccMenuDebug?: FieldPolicy<any> | FieldReadFunction<any>,
	ccOrderByTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	ccOrderItem?: FieldPolicy<any> | FieldReadFunction<any>,
	ccOrderProgress?: FieldPolicy<any> | FieldReadFunction<any>,
	ccOrderReminderNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	ccSubmenu?: FieldPolicy<any> | FieldReadFunction<any>,
	ccSubmenus?: FieldPolicy<any> | FieldReadFunction<any>,
	ccSupplierOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	ccSupplierOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	ccTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	ccTeamSubsidies?: FieldPolicy<any> | FieldReadFunction<any>,
	ccTeams?: FieldPolicy<any> | FieldReadFunction<any>,
	ccVendorMenusDebug?: FieldPolicy<any> | FieldReadFunction<any>,
	ccWeeklyReminderReport?: FieldPolicy<any> | FieldReadFunction<any>,
	cities?: FieldPolicy<any> | FieldReadFunction<any>,
	closestMatchingSupplierLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	coupons?: FieldPolicy<any> | FieldReadFunction<any>,
	customerFlexInvoiceCSV?: FieldPolicy<any> | FieldReadFunction<any>,
	customerFlexInvoicePDF?: FieldPolicy<any> | FieldReadFunction<any>,
	customerOrdersReport?: FieldPolicy<any> | FieldReadFunction<any>,
	customerOrdersSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryPartner?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryPartners?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	draftMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaAutomation?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaAutomations?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaFormResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaFormResponses?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaOccasions?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaRecipes?: FieldPolicy<any> | FieldReadFunction<any>,
	findCoupon?: FieldPolicy<any> | FieldReadFunction<any>,
	flexInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	flexInvoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	flexInvoiceAllTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	flexInvoices?: FieldPolicy<any> | FieldReadFunction<any>,
	getGeocode?: FieldPolicy<any> | FieldReadFunction<any>,
	ghosterUser?: FieldPolicy<any> | FieldReadFunction<any>,
	gmAvailabilityById?: FieldPolicy<any> | FieldReadFunction<any>,
	gmAvailabilityByVendorId?: FieldPolicy<any> | FieldReadFunction<any>,
	gmBasket?: FieldPolicy<any> | FieldReadFunction<any>,
	gmBaskets?: FieldPolicy<any> | FieldReadFunction<any>,
	gmIssues?: FieldPolicy<any> | FieldReadFunction<any>,
	gmItemSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	gmOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	gmOrderLite?: FieldPolicy<any> | FieldReadFunction<any>,
	gmOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	internalAdminTenantLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceCombined?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	invoices?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicesCombined?: FieldPolicy<any> | FieldReadFunction<any>,
	isSendGridDomainValid?: FieldPolicy<any> | FieldReadFunction<any>,
	languages?: FieldPolicy<any> | FieldReadFunction<any>,
	latestActivePlatformAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	latestFlexConsolidationRun?: FieldPolicy<any> | FieldReadFunction<any>,
	liveMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	liveMenuItems?: FieldPolicy<any> | FieldReadFunction<any>,
	lookupAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	me?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemPriceSyncStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	messageTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	myCaterdeskApiUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	myVendorLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	orderDeliveryUpdates?: FieldPolicy<any> | FieldReadFunction<any>,
	orderReferenceFields?: FieldPolicy<any> | FieldReadFunction<any>,
	ordersReport?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentAuthToken?: FieldPolicy<any> | FieldReadFunction<any>,
	platformAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	platformAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedGmOrderTotals?: FieldPolicy<any> | FieldReadFunction<any>,
	quoteCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	quoteCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFields?: FieldPolicy<any> | FieldReadFunction<any>,
	retrieveStripePublishableKey?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewsServiceStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	sendgridIpPools?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceVatBand?: FieldPolicy<any> | FieldReadFunction<any>,
	signupMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoSettingsByCompanyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoSettingsByDomain?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOrderPlacementProgressRecords?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOrderTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOrdersPage?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOrdersWithMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerSession?: FieldPolicy<any> | FieldReadFunction<any>,
	summaryFlexReportCSV?: FieldPolicy<any> | FieldReadFunction<any>,
	syncedInvoiceOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	tempEmmaRandomUnreviewedItem?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenants?: FieldPolicy<any> | FieldReadFunction<any>,
	timezoneForLatLng?: FieldPolicy<any> | FieldReadFunction<any>,
	timezones?: FieldPolicy<any> | FieldReadFunction<any>,
	topRatedGmVendors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userCreditTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	vatBand?: FieldPolicy<any> | FieldReadFunction<any>,
	vatBands?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegions?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorByPermalink?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorCategoryItems?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorContacts?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorFlexInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorFlexInvoiceAllTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorFlexInvoiceCSV?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorFlexInvoicePDF?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorFlexInvoices?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorHighlightsForLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorInvoiceOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorMenuCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorRating?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorStatement?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorStatementCombined?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorStatements?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorStatementsCombined?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorStatementsSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	vendors?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorsForHighlightCategoryForLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorsInRangeLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorsList?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorsTags?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyCoupon?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuoteCollectionKeySpecifier = ('account' | 'baskets' | 'createdAt' | 'deletedAt' | 'emmaAutomationId' | 'id' | 'name' | 'tenantId' | 'updatedAt' | QuoteCollectionKeySpecifier)[];
export type QuoteCollectionFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	baskets?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaAutomationId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuoteCollectionPagedKeySpecifier = ('pageInfo' | 'rows' | QuoteCollectionPagedKeySpecifier)[];
export type QuoteCollectionPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuoteRequestBasketKeySpecifier = ('settings' | 'user' | QuoteRequestBasketKeySpecifier)[];
export type QuoteRequestBasketFieldPolicy = {
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuoteRequestBasketSettingsKeySpecifier = ('account' | 'invoiceAccount' | 'location' | QuoteRequestBasketSettingsKeySpecifier)[];
export type QuoteRequestBasketSettingsFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuoteRequestBasketUserKeySpecifier = ('email' | 'fullName' | 'id' | 'phone' | QuoteRequestBasketUserKeySpecifier)[];
export type QuoteRequestBasketUserFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReferenceFieldKeySpecifier = ('active' | 'description' | 'id' | 'isInvoiceSummaryField' | 'label' | 'options' | 'required' | 'type' | ReferenceFieldKeySpecifier)[];
export type ReferenceFieldFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isInvoiceSummaryField?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReferenceFieldOptionKeySpecifier = ('id' | 'option' | 'orderPriority' | 'referenceFieldId' | ReferenceFieldOptionKeySpecifier)[];
export type ReferenceFieldOptionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	option?: FieldPolicy<any> | FieldReadFunction<any>,
	orderPriority?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFieldId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReferenceFieldsPagedKeySpecifier = ('rows' | ReferenceFieldsPagedKeySpecifier)[];
export type ReferenceFieldsPagedFieldPolicy = {
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefundKeySpecifier = ('accountId' | 'ccSupplierOrderId' | 'fixedAmount' | 'id' | 'percentage' | 'reason' | 'taxRate' | RefundKeySpecifier)[];
export type RefundFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	ccSupplierOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	fixedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefundResultKeySpecifier = ('amount' | 'id' | 'message' | RefundResultKeySpecifier)[];
export type RefundResultFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendGridDomainStatusKeySpecifier = ('isValid' | 'message' | SendGridDomainStatusKeySpecifier)[];
export type SendGridDomainStatusFieldPolicy = {
	isValid?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendGridIpPoolKeySpecifier = ('name' | SendGridIpPoolKeySpecifier)[];
export type SendGridIpPoolFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendInstantGmOrderToFlexResultKeySpecifier = ('status' | SendInstantGmOrderToFlexResultKeySpecifier)[];
export type SendInstantGmOrderToFlexResultFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServiceTimeKeySpecifier = ('endTime' | 'id' | 'mealType' | 'startTime' | 'weekdays' | ServiceTimeKeySpecifier)[];
export type ServiceTimeFieldPolicy = {
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mealType?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	weekdays?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SetupIntentKeySpecifier = ('clientSecret' | 'customerSessionClientSecret' | SetupIntentKeySpecifier)[];
export type SetupIntentFieldPolicy = {
	clientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	customerSessionClientSecret?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SignupMetadataKeySpecifier = ('accountId' | 'companyName' | 'email' | 'firstName' | 'lastName' | 'phone' | 'subscribeNewsletter' | SignupMetadataKeySpecifier)[];
export type SignupMetadataFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	companyName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	subscribeNewsletter?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoSettingsKeySpecifier = ('code' | 'codeOverride' | 'enabled' | 'id' | 'name' | SsoSettingsKeySpecifier)[];
export type SsoSettingsFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	codeOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandingOrderKeySpecifier = ('_id' | 'activeFrom' | 'activeUntil' | 'basketId' | 'communications' | 'daysOfOccurrence' | 'friendlyId' | 'name' | 'nextDeliveryDate' | 'nthOfMonthOccurrence' | 'pausedFrom' | 'pausedUntil' | 'recurrence' | 'standingOrderTemplate' | 'templateId' | 'templateSettings' | StandingOrderKeySpecifier)[];
export type StandingOrderFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	activeFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	activeUntil?: FieldPolicy<any> | FieldReadFunction<any>,
	basketId?: FieldPolicy<any> | FieldReadFunction<any>,
	communications?: FieldPolicy<any> | FieldReadFunction<any>,
	daysOfOccurrence?: FieldPolicy<any> | FieldReadFunction<any>,
	friendlyId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nextDeliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	nthOfMonthOccurrence?: FieldPolicy<any> | FieldReadFunction<any>,
	pausedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	pausedUntil?: FieldPolicy<any> | FieldReadFunction<any>,
	recurrence?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOrderTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	templateId?: FieldPolicy<any> | FieldReadFunction<any>,
	templateSettings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandingOrderInvoicingRulesKeySpecifier = ('applyStandingOrderInvoicingRules' | 'autoInvoice' | 'consolidateInvoice' | 'invoiceConsolidationFrequency' | 'invoiceEmailRecipientType' | 'referenceFieldLabelsForStandingOrderInvoice' | 'splitByContact' | 'splitByReferenceFields' | StandingOrderInvoicingRulesKeySpecifier)[];
export type StandingOrderInvoicingRulesFieldPolicy = {
	applyStandingOrderInvoicingRules?: FieldPolicy<any> | FieldReadFunction<any>,
	autoInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	consolidateInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceConsolidationFrequency?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceEmailRecipientType?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceFieldLabelsForStandingOrderInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	splitByContact?: FieldPolicy<any> | FieldReadFunction<any>,
	splitByReferenceFields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandingOrderPlacementProgressDataKeySpecifier = ('message' | 'time' | StandingOrderPlacementProgressDataKeySpecifier)[];
export type StandingOrderPlacementProgressDataFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	time?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandingOrderPlacementProgressRecordKeySpecifier = ('associatedOrders' | 'forDeliveryOn' | 'id' | 'progressData' | 'runTime' | 'standingOrder' | 'status' | StandingOrderPlacementProgressRecordKeySpecifier)[];
export type StandingOrderPlacementProgressRecordFieldPolicy = {
	associatedOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	forDeliveryOn?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	progressData?: FieldPolicy<any> | FieldReadFunction<any>,
	runTime?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandingOrderPlacementProgressRecordsPagedKeySpecifier = ('data' | 'pageInfo' | StandingOrderPlacementProgressRecordsPagedKeySpecifier)[];
export type StandingOrderPlacementProgressRecordsPagedFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandingOrdersPageKeySpecifier = ('pageInfo' | 'standingOrders' | StandingOrdersPageKeySpecifier)[];
export type StandingOrdersPageFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOrders?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StartPaymentResultKeySpecifier = ('customerId' | 'ephemeralKey' | 'stripeClientSecret' | StartPaymentResultKeySpecifier)[];
export type StartPaymentResultFieldPolicy = {
	customerId?: FieldPolicy<any> | FieldReadFunction<any>,
	ephemeralKey?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeClientSecret?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StripeKeySpecifier = ('countryCode' | 'fees' | StripeKeySpecifier)[];
export type StripeFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StripeCustomerSessionKeySpecifier = ('clientSecret' | 'customerId' | 'ephemeralKey' | StripeCustomerSessionKeySpecifier)[];
export type StripeCustomerSessionFieldPolicy = {
	clientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	customerId?: FieldPolicy<any> | FieldReadFunction<any>,
	ephemeralKey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StripeFeesKeySpecifier = ('fixedAmount' | 'percentage' | StripeFeesKeySpecifier)[];
export type StripeFeesFieldPolicy = {
	fixedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StripeProcessingFeesKeySpecifier = ('domestic' | 'international' | StripeProcessingFeesKeySpecifier)[];
export type StripeProcessingFeesFieldPolicy = {
	domestic?: FieldPolicy<any> | FieldReadFunction<any>,
	international?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubAllergenCerealsKeySpecifier = ('barley' | 'kamut' | 'oats' | 'rye' | 'wheat' | SubAllergenCerealsKeySpecifier)[];
export type SubAllergenCerealsFieldPolicy = {
	barley?: FieldPolicy<any> | FieldReadFunction<any>,
	kamut?: FieldPolicy<any> | FieldReadFunction<any>,
	oats?: FieldPolicy<any> | FieldReadFunction<any>,
	rye?: FieldPolicy<any> | FieldReadFunction<any>,
	wheat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubAllergenNutsKeySpecifier = ('almonds' | 'brazil' | 'cashew' | 'hazelnuts' | 'macadamia' | 'pecan' | 'pistachio' | 'walnuts' | SubAllergenNutsKeySpecifier)[];
export type SubAllergenNutsFieldPolicy = {
	almonds?: FieldPolicy<any> | FieldReadFunction<any>,
	brazil?: FieldPolicy<any> | FieldReadFunction<any>,
	cashew?: FieldPolicy<any> | FieldReadFunction<any>,
	hazelnuts?: FieldPolicy<any> | FieldReadFunction<any>,
	macadamia?: FieldPolicy<any> | FieldReadFunction<any>,
	pecan?: FieldPolicy<any> | FieldReadFunction<any>,
	pistachio?: FieldPolicy<any> | FieldReadFunction<any>,
	walnuts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubAllergensKeySpecifier = ('cereals' | 'nuts' | SubAllergensKeySpecifier)[];
export type SubAllergensFieldPolicy = {
	cereals?: FieldPolicy<any> | FieldReadFunction<any>,
	nuts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SupplierExternalIdOutputKeySpecifier = ('catalogueId' | 'catalogueSectionId' | 'itemId' | 'variantId' | SupplierExternalIdOutputKeySpecifier)[];
export type SupplierExternalIdOutputFieldPolicy = {
	catalogueId?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogueSectionId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	variantId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SupplierOrderResultKeySpecifier = ('flexDeferredSupplierOrderId' | 'orderId' | SupplierOrderResultKeySpecifier)[];
export type SupplierOrderResultFieldPolicy = {
	flexDeferredSupplierOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SyncInvoiceOrderResultKeySpecifier = ('message' | 'status' | SyncInvoiceOrderResultKeySpecifier)[];
export type SyncInvoiceOrderResultFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SyncMenuItemPricesResponseKeySpecifier = ('syncJobId' | SyncMenuItemPricesResponseKeySpecifier)[];
export type SyncMenuItemPricesResponseFieldPolicy = {
	syncJobId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SyncedInvoiceOrdersResultKeySpecifier = ('clientId' | 'contact' | 'countryCode' | 'customerName' | 'deferredCustomerId' | 'deferredSupplierId' | 'deliveryDate' | 'deliveryTimezone' | 'instant' | 'lineItems' | 'number' | 'orderFor' | 'orderType' | 'placedBy' | 'shippingAddress' | 'shortCode' | 'supplier' | 'tenantId' | SyncedInvoiceOrdersResultKeySpecifier)[];
export type SyncedInvoiceOrdersResultFieldPolicy = {
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	customerName?: FieldPolicy<any> | FieldReadFunction<any>,
	deferredCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	deferredSupplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryTimezone?: FieldPolicy<any> | FieldReadFunction<any>,
	instant?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItems?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	orderFor?: FieldPolicy<any> | FieldReadFunction<any>,
	orderType?: FieldPolicy<any> | FieldReadFunction<any>,
	placedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	shortCode?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagsPagedKeySpecifier = ('pageInfo' | 'rows' | TagsPagedKeySpecifier)[];
export type TagsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateSettingsKeySpecifier = ('vendor' | TemplateSettingsKeySpecifier)[];
export type TemplateSettingsFieldPolicy = {
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantKeySpecifier = ('accounting' | 'activePlatformAlerts' | 'billingEntities' | 'clientVercelProjectId' | 'cognitoConfiguration' | 'contact' | 'contentSecurityPolicy' | 'countries' | 'defaultLocale' | 'domain' | 'features' | 'flexInvoicingFlags' | 'flexInvoicingPaymentSettings' | 'guestAccountData' | 'id' | 'integrations' | 'internalAdminLinks' | 'isSingleVendor' | 'latestActivePlatformAlert' | 'marketing' | 'mobileApp' | 'name' | 'payments' | 'permissions' | 'platformAlert' | 'platformAlerts' | 'slackAlertingConfigured' | 'transportTypes' | 'uriRestrictedAccessRules' | 'vercelProjectId' | TenantKeySpecifier)[];
export type TenantFieldPolicy = {
	accounting?: FieldPolicy<any> | FieldReadFunction<any>,
	activePlatformAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	billingEntities?: FieldPolicy<any> | FieldReadFunction<any>,
	clientVercelProjectId?: FieldPolicy<any> | FieldReadFunction<any>,
	cognitoConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contentSecurityPolicy?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultLocale?: FieldPolicy<any> | FieldReadFunction<any>,
	domain?: FieldPolicy<any> | FieldReadFunction<any>,
	features?: FieldPolicy<any> | FieldReadFunction<any>,
	flexInvoicingFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	flexInvoicingPaymentSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	guestAccountData?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	integrations?: FieldPolicy<any> | FieldReadFunction<any>,
	internalAdminLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	isSingleVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	latestActivePlatformAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	marketing?: FieldPolicy<any> | FieldReadFunction<any>,
	mobileApp?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	payments?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	platformAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	platformAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	slackAlertingConfigured?: FieldPolicy<any> | FieldReadFunction<any>,
	transportTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	uriRestrictedAccessRules?: FieldPolicy<any> | FieldReadFunction<any>,
	vercelProjectId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantAccountingKeySpecifier = ('regions' | TenantAccountingKeySpecifier)[];
export type TenantAccountingFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantAccountingRegionsKeySpecifier = ('countryCode' | 'glCodes' | TenantAccountingRegionsKeySpecifier)[];
export type TenantAccountingRegionsFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	glCodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantCateringAllergenTooltipKeySpecifier = ('visibility' | TenantCateringAllergenTooltipKeySpecifier)[];
export type TenantCateringAllergenTooltipFieldPolicy = {
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantCateringCouponsKeySpecifier = ('visibility' | TenantCateringCouponsKeySpecifier)[];
export type TenantCateringCouponsFieldPolicy = {
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantCateringFiltersKeySpecifier = ('allergens' | 'dietary' | TenantCateringFiltersKeySpecifier)[];
export type TenantCateringFiltersFieldPolicy = {
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	dietary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantCognitoConfigurationKeySpecifier = ('userPoolClientId' | 'userPoolDomain' | 'userPoolId' | TenantCognitoConfigurationKeySpecifier)[];
export type TenantCognitoConfigurationFieldPolicy = {
	userPoolClientId?: FieldPolicy<any> | FieldReadFunction<any>,
	userPoolDomain?: FieldPolicy<any> | FieldReadFunction<any>,
	userPoolId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantContactKeySpecifier = ('regions' | TenantContactKeySpecifier)[];
export type TenantContactFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantContactRegionsKeySpecifier = ('countryCode' | 'email' | 'phone' | TenantContactRegionsKeySpecifier)[];
export type TenantContactRegionsFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantContactRegionsEmailKeySpecifier = ('default' | 'sales' | 'support' | 'vendors' | TenantContactRegionsEmailKeySpecifier)[];
export type TenantContactRegionsEmailFieldPolicy = {
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	sales?: FieldPolicy<any> | FieldReadFunction<any>,
	support?: FieldPolicy<any> | FieldReadFunction<any>,
	vendors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantContactRegionsPhoneKeySpecifier = ('default' | 'sales' | 'support' | 'vendors' | TenantContactRegionsPhoneKeySpecifier)[];
export type TenantContactRegionsPhoneFieldPolicy = {
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	sales?: FieldPolicy<any> | FieldReadFunction<any>,
	support?: FieldPolicy<any> | FieldReadFunction<any>,
	vendors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantContentSecurityPolicyKeySpecifier = ('connectSrc' | 'fontSrc' | 'frameSrc' | 'imgSrc' | 'mediaSrc' | 'scriptSrc' | 'styleSrc' | TenantContentSecurityPolicyKeySpecifier)[];
export type TenantContentSecurityPolicyFieldPolicy = {
	connectSrc?: FieldPolicy<any> | FieldReadFunction<any>,
	fontSrc?: FieldPolicy<any> | FieldReadFunction<any>,
	frameSrc?: FieldPolicy<any> | FieldReadFunction<any>,
	imgSrc?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaSrc?: FieldPolicy<any> | FieldReadFunction<any>,
	scriptSrc?: FieldPolicy<any> | FieldReadFunction<any>,
	styleSrc?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantEmailDisclaimerTextKeySpecifier = ('disclaimerText' | 'locale' | TenantEmailDisclaimerTextKeySpecifier)[];
export type TenantEmailDisclaimerTextFieldPolicy = {
	disclaimerText?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesKeySpecifier = ('calendarTopPicks' | 'canCancelCateringInvoiceOrders' | 'cateringAllergenTooltip' | 'cateringCoupons' | 'cateringFilters' | 'cateringGroupOrdering' | 'cateringTeamOrder' | 'ccShowTimeslotWindow' | 'ccTopupAmounts' | 'charityMeals' | 'emma' | 'gmDeliveryTimeslots' | 'gmExpressCheckout' | 'gmHideDeliveryWindow' | 'gmShowFullAddress' | 'menuItemAllergenAudit' | 'prerenderMarketplaceMenu' | 'printLabels' | 'serviceOptions' | 'vendorHelpCentre' | TenantFeaturesKeySpecifier)[];
export type TenantFeaturesFieldPolicy = {
	calendarTopPicks?: FieldPolicy<any> | FieldReadFunction<any>,
	canCancelCateringInvoiceOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	cateringAllergenTooltip?: FieldPolicy<any> | FieldReadFunction<any>,
	cateringCoupons?: FieldPolicy<any> | FieldReadFunction<any>,
	cateringFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	cateringGroupOrdering?: FieldPolicy<any> | FieldReadFunction<any>,
	cateringTeamOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	ccShowTimeslotWindow?: FieldPolicy<any> | FieldReadFunction<any>,
	ccTopupAmounts?: FieldPolicy<any> | FieldReadFunction<any>,
	charityMeals?: FieldPolicy<any> | FieldReadFunction<any>,
	emma?: FieldPolicy<any> | FieldReadFunction<any>,
	gmDeliveryTimeslots?: FieldPolicy<any> | FieldReadFunction<any>,
	gmExpressCheckout?: FieldPolicy<any> | FieldReadFunction<any>,
	gmHideDeliveryWindow?: FieldPolicy<any> | FieldReadFunction<any>,
	gmShowFullAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemAllergenAudit?: FieldPolicy<any> | FieldReadFunction<any>,
	prerenderMarketplaceMenu?: FieldPolicy<any> | FieldReadFunction<any>,
	printLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorHelpCentre?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesCalendarTopPicksKeySpecifier = ('visibility' | TenantFeaturesCalendarTopPicksKeySpecifier)[];
export type TenantFeaturesCalendarTopPicksFieldPolicy = {
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesCateringGroupOrderingKeySpecifier = ('visibility' | TenantFeaturesCateringGroupOrderingKeySpecifier)[];
export type TenantFeaturesCateringGroupOrderingFieldPolicy = {
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesCateringGroupOrderingVisibilityKeySpecifier = ('regions' | TenantFeaturesCateringGroupOrderingVisibilityKeySpecifier)[];
export type TenantFeaturesCateringGroupOrderingVisibilityFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesCateringTeamOrderKeySpecifier = ('visibility' | TenantFeaturesCateringTeamOrderKeySpecifier)[];
export type TenantFeaturesCateringTeamOrderFieldPolicy = {
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesCateringTeamOrderVisibilityKeySpecifier = ('regions' | TenantFeaturesCateringTeamOrderVisibilityKeySpecifier)[];
export type TenantFeaturesCateringTeamOrderVisibilityFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesCcShowTimeslotWindowKeySpecifier = ('visibility' | TenantFeaturesCcShowTimeslotWindowKeySpecifier)[];
export type TenantFeaturesCcShowTimeslotWindowFieldPolicy = {
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesCcTopupAmountsKeySpecifier = ('highestTopup' | 'minimumTopup' | 'topupValues' | TenantFeaturesCcTopupAmountsKeySpecifier)[];
export type TenantFeaturesCcTopupAmountsFieldPolicy = {
	highestTopup?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumTopup?: FieldPolicy<any> | FieldReadFunction<any>,
	topupValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesCharityMealsKeySpecifier = ('visibility' | TenantFeaturesCharityMealsKeySpecifier)[];
export type TenantFeaturesCharityMealsFieldPolicy = {
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesCharityMealsVisibilityKeySpecifier = ('regions' | TenantFeaturesCharityMealsVisibilityKeySpecifier)[];
export type TenantFeaturesCharityMealsVisibilityFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesEmmaKeySpecifier = ('bccAddresses' | 'defaultSupplierId' | 'fromAddress' | 'regionSpecificRules' | 'showSubscribeToUpdatesCheckbox' | 'supplierSpecificRules' | 'visibility' | TenantFeaturesEmmaKeySpecifier)[];
export type TenantFeaturesEmmaFieldPolicy = {
	bccAddresses?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultSupplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	fromAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	regionSpecificRules?: FieldPolicy<any> | FieldReadFunction<any>,
	showSubscribeToUpdatesCheckbox?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierSpecificRules?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesEmmaRegionSpecificRulesKeySpecifier = ('countryCode' | 'occasionItemTimeRestraints' | TenantFeaturesEmmaRegionSpecificRulesKeySpecifier)[];
export type TenantFeaturesEmmaRegionSpecificRulesFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	occasionItemTimeRestraints?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesEmmaSupplierSpecificRulesKeySpecifier = ('allowedSupplierIds' | 'forceAllowedSuppliers' | 'prohibitedSupplierIds' | TenantFeaturesEmmaSupplierSpecificRulesKeySpecifier)[];
export type TenantFeaturesEmmaSupplierSpecificRulesFieldPolicy = {
	allowedSupplierIds?: FieldPolicy<any> | FieldReadFunction<any>,
	forceAllowedSuppliers?: FieldPolicy<any> | FieldReadFunction<any>,
	prohibitedSupplierIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesGmDeliveryTimeslotsKeySpecifier = ('end' | 'start' | TenantFeaturesGmDeliveryTimeslotsKeySpecifier)[];
export type TenantFeaturesGmDeliveryTimeslotsFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesGmHideDeliveryWindowKeySpecifier = ('visibility' | TenantFeaturesGmHideDeliveryWindowKeySpecifier)[];
export type TenantFeaturesGmHideDeliveryWindowFieldPolicy = {
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesGmShowFullAddressKeySpecifier = ('visibility' | TenantFeaturesGmShowFullAddressKeySpecifier)[];
export type TenantFeaturesGmShowFullAddressFieldPolicy = {
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesGmShowFullAddressVisibilityKeySpecifier = ('regions' | TenantFeaturesGmShowFullAddressVisibilityKeySpecifier)[];
export type TenantFeaturesGmShowFullAddressVisibilityFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesMenuItemAllergenAuditKeySpecifier = ('enabled' | TenantFeaturesMenuItemAllergenAuditKeySpecifier)[];
export type TenantFeaturesMenuItemAllergenAuditFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesPreRenderMarketplaceMenuKeySpecifier = ('permalinks' | TenantFeaturesPreRenderMarketplaceMenuKeySpecifier)[];
export type TenantFeaturesPreRenderMarketplaceMenuFieldPolicy = {
	permalinks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantFeaturesVendorHelpCentreKeySpecifier = ('link' | TenantFeaturesVendorHelpCentreKeySpecifier)[];
export type TenantFeaturesVendorHelpCentreFieldPolicy = {
	link?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantGmExpressCheckoutKeySpecifier = ('visibility' | TenantGmExpressCheckoutKeySpecifier)[];
export type TenantGmExpressCheckoutFieldPolicy = {
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantGuestAccountKeySpecifier = ('guestInvoiceAccountId' | 'id' | 'locale' | TenantGuestAccountKeySpecifier)[];
export type TenantGuestAccountFieldPolicy = {
	guestInvoiceAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantImageUploadKeySpecifier = ('fullUrl' | 'presignedUrl' | TenantImageUploadKeySpecifier)[];
export type TenantImageUploadFieldPolicy = {
	fullUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	presignedUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsKeySpecifier = ('acteol' | 'bingAds' | 'flexInvoicingClients' | 'googleTagManager' | 'hotjar' | 'intercom' | 'linkedIn' | 'oneTrust' | 'orkestro' | 'posthog' | 'segment' | 'svix' | 'vanillaBlue' | 'zendesk' | TenantIntegrationsKeySpecifier)[];
export type TenantIntegrationsFieldPolicy = {
	acteol?: FieldPolicy<any> | FieldReadFunction<any>,
	bingAds?: FieldPolicy<any> | FieldReadFunction<any>,
	flexInvoicingClients?: FieldPolicy<any> | FieldReadFunction<any>,
	googleTagManager?: FieldPolicy<any> | FieldReadFunction<any>,
	hotjar?: FieldPolicy<any> | FieldReadFunction<any>,
	intercom?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedIn?: FieldPolicy<any> | FieldReadFunction<any>,
	oneTrust?: FieldPolicy<any> | FieldReadFunction<any>,
	orkestro?: FieldPolicy<any> | FieldReadFunction<any>,
	posthog?: FieldPolicy<any> | FieldReadFunction<any>,
	segment?: FieldPolicy<any> | FieldReadFunction<any>,
	svix?: FieldPolicy<any> | FieldReadFunction<any>,
	vanillaBlue?: FieldPolicy<any> | FieldReadFunction<any>,
	zendesk?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsActeolKeySpecifier = ('enabled' | TenantIntegrationsActeolKeySpecifier)[];
export type TenantIntegrationsActeolFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsBingAdsKeySpecifier = ('tagId' | TenantIntegrationsBingAdsKeySpecifier)[];
export type TenantIntegrationsBingAdsFieldPolicy = {
	tagId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsGoogleTagManagerKeySpecifier = ('containerId' | TenantIntegrationsGoogleTagManagerKeySpecifier)[];
export type TenantIntegrationsGoogleTagManagerFieldPolicy = {
	containerId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsHotjarKeySpecifier = ('regions' | TenantIntegrationsHotjarKeySpecifier)[];
export type TenantIntegrationsHotjarFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsHotjarRegionsKeySpecifier = ('countryCode' | 'id' | TenantIntegrationsHotjarRegionsKeySpecifier)[];
export type TenantIntegrationsHotjarRegionsFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsIntercomKeySpecifier = ('regions' | TenantIntegrationsIntercomKeySpecifier)[];
export type TenantIntegrationsIntercomFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsIntercomRegionsKeySpecifier = ('countryCode' | 'id' | TenantIntegrationsIntercomRegionsKeySpecifier)[];
export type TenantIntegrationsIntercomRegionsFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsLinkedInKeySpecifier = ('pid' | TenantIntegrationsLinkedInKeySpecifier)[];
export type TenantIntegrationsLinkedInFieldPolicy = {
	pid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsOneTrustKeySpecifier = ('id' | TenantIntegrationsOneTrustKeySpecifier)[];
export type TenantIntegrationsOneTrustFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsOrkestroKeySpecifier = ('enabled' | 'regions' | TenantIntegrationsOrkestroKeySpecifier)[];
export type TenantIntegrationsOrkestroFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsOrkestroRegionsKeySpecifier = ('countryCode' | 'key' | TenantIntegrationsOrkestroRegionsKeySpecifier)[];
export type TenantIntegrationsOrkestroRegionsFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsPosthogKeySpecifier = ('apiHost' | 'apiKey' | TenantIntegrationsPosthogKeySpecifier)[];
export type TenantIntegrationsPosthogFieldPolicy = {
	apiHost?: FieldPolicy<any> | FieldReadFunction<any>,
	apiKey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsSegmentKeySpecifier = ('clientWriteKey' | 'writeKey' | TenantIntegrationsSegmentKeySpecifier)[];
export type TenantIntegrationsSegmentFieldPolicy = {
	clientWriteKey?: FieldPolicy<any> | FieldReadFunction<any>,
	writeKey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsSvixKeySpecifier = ('appId' | 'appPortalUrls' | TenantIntegrationsSvixKeySpecifier)[];
export type TenantIntegrationsSvixFieldPolicy = {
	appId?: FieldPolicy<any> | FieldReadFunction<any>,
	appPortalUrls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsVanillaBlueKeySpecifier = ('regions' | TenantIntegrationsVanillaBlueKeySpecifier)[];
export type TenantIntegrationsVanillaBlueFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsVanillaBlueRegionsKeySpecifier = ('accountId' | 'accountName' | 'countryCode' | 'key' | 'supplierId' | 'url' | TenantIntegrationsVanillaBlueRegionsKeySpecifier)[];
export type TenantIntegrationsVanillaBlueRegionsFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsZendeskKeySpecifier = ('regions' | TenantIntegrationsZendeskKeySpecifier)[];
export type TenantIntegrationsZendeskFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantIntegrationsZendeskRegionsKeySpecifier = ('countryCode' | 'id' | TenantIntegrationsZendeskRegionsKeySpecifier)[];
export type TenantIntegrationsZendeskRegionsFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantInternalAdminLinkKeySpecifier = ('label' | 'url' | TenantInternalAdminLinkKeySpecifier)[];
export type TenantInternalAdminLinkFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMarketingKeySpecifier = ('assets' | 'email' | 'links' | 'logos' | 'navLinks' | 'pages' | 'sitemaps' | 'theme' | TenantMarketingKeySpecifier)[];
export type TenantMarketingFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>,
	logos?: FieldPolicy<any> | FieldReadFunction<any>,
	navLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>,
	sitemaps?: FieldPolicy<any> | FieldReadFunction<any>,
	theme?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMarketingAssetsKeySpecifier = ('authBackgroundImage' | 'marketplaceHeaderImages' | 'orderConfirmationImage' | 'placeholder' | TenantMarketingAssetsKeySpecifier)[];
export type TenantMarketingAssetsFieldPolicy = {
	authBackgroundImage?: FieldPolicy<any> | FieldReadFunction<any>,
	marketplaceHeaderImages?: FieldPolicy<any> | FieldReadFunction<any>,
	orderConfirmationImage?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMarketingEmailKeySpecifier = ('bannerUrl' | 'bannerUrlAlt' | 'bannerUrlAlt1' | 'emailDisclaimerText' | 'fromAddress' | 'ipPoolName' | 'logoUrl' | TenantMarketingEmailKeySpecifier)[];
export type TenantMarketingEmailFieldPolicy = {
	bannerUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerUrlAlt?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerUrlAlt1?: FieldPolicy<any> | FieldReadFunction<any>,
	emailDisclaimerText?: FieldPolicy<any> | FieldReadFunction<any>,
	fromAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	ipPoolName?: FieldPolicy<any> | FieldReadFunction<any>,
	logoUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMarketingLinkKeySpecifier = ('blog' | 'countryCode' | 'emailUs' | 'facebook' | 'faq' | 'instagram' | 'linkedin' | 'liveChat' | 'privacy' | 'requestAQuote' | 'terms' | 'twitter' | TenantMarketingLinkKeySpecifier)[];
export type TenantMarketingLinkFieldPolicy = {
	blog?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	emailUs?: FieldPolicy<any> | FieldReadFunction<any>,
	facebook?: FieldPolicy<any> | FieldReadFunction<any>,
	faq?: FieldPolicy<any> | FieldReadFunction<any>,
	instagram?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedin?: FieldPolicy<any> | FieldReadFunction<any>,
	liveChat?: FieldPolicy<any> | FieldReadFunction<any>,
	privacy?: FieldPolicy<any> | FieldReadFunction<any>,
	requestAQuote?: FieldPolicy<any> | FieldReadFunction<any>,
	terms?: FieldPolicy<any> | FieldReadFunction<any>,
	twitter?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMarketingLogosKeySpecifier = ('default' | 'favicon' | 'loadingIndicator' | 'rainbow' | 'white' | TenantMarketingLogosKeySpecifier)[];
export type TenantMarketingLogosFieldPolicy = {
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	favicon?: FieldPolicy<any> | FieldReadFunction<any>,
	loadingIndicator?: FieldPolicy<any> | FieldReadFunction<any>,
	rainbow?: FieldPolicy<any> | FieldReadFunction<any>,
	white?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMarketingPageRegionsKeySpecifier = ('code' | 'url' | TenantMarketingPageRegionsKeySpecifier)[];
export type TenantMarketingPageRegionsFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMarketingPagesKeySpecifier = ('regions' | 'rootUrl' | 'shouldIndex' | TenantMarketingPagesKeySpecifier)[];
export type TenantMarketingPagesFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	rootUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	shouldIndex?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMarketingSitemapsKeySpecifier = ('forceReplaceHostname' | 'name' | 'url' | TenantMarketingSitemapsKeySpecifier)[];
export type TenantMarketingSitemapsFieldPolicy = {
	forceReplaceHostname?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMarketingThemeKeySpecifier = ('palette' | TenantMarketingThemeKeySpecifier)[];
export type TenantMarketingThemeFieldPolicy = {
	palette?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMarketingThemePaletteKeySpecifier = ('background' | 'common' | 'error' | 'info' | 'inverted' | 'primary' | 'secondary' | 'success' | 'text' | 'warning' | TenantMarketingThemePaletteKeySpecifier)[];
export type TenantMarketingThemePaletteFieldPolicy = {
	background?: FieldPolicy<any> | FieldReadFunction<any>,
	common?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>,
	inverted?: FieldPolicy<any> | FieldReadFunction<any>,
	primary?: FieldPolicy<any> | FieldReadFunction<any>,
	secondary?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	warning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMobileAppKeySpecifier = ('appleAppStoreId' | 'bundleId' | 'canteenAppStoreUrl' | 'canteenPlayStoreUrl' | 'easProjectId' | 'enabled' | 'firebaseProjectId' | 'icon' | 'integrations' | 'merchantId' | 'name' | 'schemes' | 'slug' | TenantMobileAppKeySpecifier)[];
export type TenantMobileAppFieldPolicy = {
	appleAppStoreId?: FieldPolicy<any> | FieldReadFunction<any>,
	bundleId?: FieldPolicy<any> | FieldReadFunction<any>,
	canteenAppStoreUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	canteenPlayStoreUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	easProjectId?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseProjectId?: FieldPolicy<any> | FieldReadFunction<any>,
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	integrations?: FieldPolicy<any> | FieldReadFunction<any>,
	merchantId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	schemes?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMobileAppIntegrationsKeySpecifier = ('zendesk' | TenantMobileAppIntegrationsKeySpecifier)[];
export type TenantMobileAppIntegrationsFieldPolicy = {
	zendesk?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMobileAppIntegrationsZendeskKeySpecifier = ('regions' | TenantMobileAppIntegrationsZendeskKeySpecifier)[];
export type TenantMobileAppIntegrationsZendeskFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantMobileAppIntegrationsZendeskRegionsKeySpecifier = ('androidChannelKey' | 'countryCode' | 'iosChannelKey' | TenantMobileAppIntegrationsZendeskRegionsKeySpecifier)[];
export type TenantMobileAppIntegrationsZendeskRegionsFieldPolicy = {
	androidChannelKey?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	iosChannelKey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantNavigationLinkKeySpecifier = ('href' | 'subLinks' | 'title' | TenantNavigationLinkKeySpecifier)[];
export type TenantNavigationLinkFieldPolicy = {
	href?: FieldPolicy<any> | FieldReadFunction<any>,
	subLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantNavigationSubLinkKeySpecifier = ('description' | 'href' | 'links' | 'sameTab' | 'ssgPage' | 'title' | 'type' | TenantNavigationSubLinkKeySpecifier)[];
export type TenantNavigationSubLinkFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	href?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>,
	sameTab?: FieldPolicy<any> | FieldReadFunction<any>,
	ssgPage?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantPaletteColorBackgroundKeySpecifier = ('default' | 'paper' | TenantPaletteColorBackgroundKeySpecifier)[];
export type TenantPaletteColorBackgroundFieldPolicy = {
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	paper?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantPaletteColorCommonKeySpecifier = ('black' | 'white' | TenantPaletteColorCommonKeySpecifier)[];
export type TenantPaletteColorCommonFieldPolicy = {
	black?: FieldPolicy<any> | FieldReadFunction<any>,
	white?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantPaletteColorOptionsKeySpecifier = ('contrastText' | 'dark' | 'light' | 'main' | TenantPaletteColorOptionsKeySpecifier)[];
export type TenantPaletteColorOptionsFieldPolicy = {
	contrastText?: FieldPolicy<any> | FieldReadFunction<any>,
	dark?: FieldPolicy<any> | FieldReadFunction<any>,
	light?: FieldPolicy<any> | FieldReadFunction<any>,
	main?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantPaletteColorTextKeySpecifier = ('disabled' | 'primary' | 'secondary' | TenantPaletteColorTextKeySpecifier)[];
export type TenantPaletteColorTextFieldPolicy = {
	disabled?: FieldPolicy<any> | FieldReadFunction<any>,
	primary?: FieldPolicy<any> | FieldReadFunction<any>,
	secondary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantPaymentsKeySpecifier = ('chargeCreditCardFee' | 'creditCardFeeFlags' | 'stripe' | TenantPaymentsKeySpecifier)[];
export type TenantPaymentsFieldPolicy = {
	chargeCreditCardFee?: FieldPolicy<any> | FieldReadFunction<any>,
	creditCardFeeFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	stripe?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantPermissionsKeySpecifier = ('allowCreditCardPayments' | 'allowTransferPayments' | 'allowUserSignIn' | 'autoPopulatePlacedBy' | 'createVendors' | 'guestCheckoutByInvoiceAccountGm' | TenantPermissionsKeySpecifier)[];
export type TenantPermissionsFieldPolicy = {
	allowCreditCardPayments?: FieldPolicy<any> | FieldReadFunction<any>,
	allowTransferPayments?: FieldPolicy<any> | FieldReadFunction<any>,
	allowUserSignIn?: FieldPolicy<any> | FieldReadFunction<any>,
	autoPopulatePlacedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createVendors?: FieldPolicy<any> | FieldReadFunction<any>,
	guestCheckoutByInvoiceAccountGm?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantPrintLabelsKeySpecifier = ('CC' | 'GM' | TenantPrintLabelsKeySpecifier)[];
export type TenantPrintLabelsFieldPolicy = {
	CC?: FieldPolicy<any> | FieldReadFunction<any>,
	GM?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantPrintLabelsOptionsKeySpecifier = ('VPA4' | 'VPDymo' | 'VPPackage' | 'VPSummary' | TenantPrintLabelsOptionsKeySpecifier)[];
export type TenantPrintLabelsOptionsFieldPolicy = {
	VPA4?: FieldPolicy<any> | FieldReadFunction<any>,
	VPDymo?: FieldPolicy<any> | FieldReadFunction<any>,
	VPPackage?: FieldPolicy<any> | FieldReadFunction<any>,
	VPSummary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantServiceOptionsKeySpecifier = ('cutleryExtras' | 'staffServices' | 'visibility' | TenantServiceOptionsKeySpecifier)[];
export type TenantServiceOptionsFieldPolicy = {
	cutleryExtras?: FieldPolicy<any> | FieldReadFunction<any>,
	staffServices?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantServiceOptionsVisibilityKeySpecifier = ('visibility' | TenantServiceOptionsVisibilityKeySpecifier)[];
export type TenantServiceOptionsVisibilityFieldPolicy = {
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantTransportTypeKeySpecifier = ('name' | 'value' | TenantTransportTypeKeySpecifier)[];
export type TenantTransportTypeFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantTransportTypesKeySpecifier = ('regions' | TenantTransportTypesKeySpecifier)[];
export type TenantTransportTypesFieldPolicy = {
	regions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantTransportTypesRegionKeySpecifier = ('countryCode' | 'types' | TenantTransportTypesRegionKeySpecifier)[];
export type TenantTransportTypesRegionFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	types?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantsPagedKeySpecifier = ('pageInfo' | 'rows' | TenantsPagedKeySpecifier)[];
export type TenantsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TimeRangeKeySpecifier = ('end' | 'start' | TimeRangeKeySpecifier)[];
export type TimeRangeFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TimezoneKeySpecifier = ('code' | 'countryCode' | 'label' | TimezoneKeySpecifier)[];
export type TimezoneFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TranslationKeySpecifier = ('key' | 'language' | 'value' | TranslationKeySpecifier)[];
export type TranslationFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UriRestrictedAccessRulesKeySpecifier = ('redirectUri' | 'uri' | UriRestrictedAccessRulesKeySpecifier)[];
export type UriRestrictedAccessRulesFieldPolicy = {
	redirectUri?: FieldPolicy<any> | FieldReadFunction<any>,
	uri?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('account' | 'accountLocation' | 'accountSettings' | 'allergens' | 'autopilotSettings' | 'ccItemsAwaitingReview' | 'ccMenu' | 'ccOrders' | 'contactPreferences' | 'deletedAt' | 'dietaryPreferences' | 'email' | 'firstName' | 'flexDeferredCustomerId' | 'fullName' | 'gmBaskets' | 'groupedOrderItemsByDate' | 'hasPlacedCcOrderViaMobile' | 'hasPreviousGmOrders' | 'hasSelectedPreferredLocation' | 'id' | 'intercomUserHash' | 'invoiceApproved' | 'isAdmin' | 'isUser' | 'isVendor' | 'languageSettings' | 'lastName' | 'legacyAdminId' | 'marketingOptIn' | 'modules' | 'nativeAppSettings' | 'notificationHistory' | 'onboardingSettings' | 'phone' | 'privacyAccepted' | 'role' | 'savedCard' | 'subsidySettings' | 'teamId' | 'tenant' | 'upcomingCcMenus' | 'upcomingCcMenusFromOrders' | 'vendor' | 'wallet' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	accountLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	accountSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	allergens?: FieldPolicy<any> | FieldReadFunction<any>,
	autopilotSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	ccItemsAwaitingReview?: FieldPolicy<any> | FieldReadFunction<any>,
	ccMenu?: FieldPolicy<any> | FieldReadFunction<any>,
	ccOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	contactPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dietaryPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	flexDeferredCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	gmBaskets?: FieldPolicy<any> | FieldReadFunction<any>,
	groupedOrderItemsByDate?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPlacedCcOrderViaMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousGmOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	hasSelectedPreferredLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intercomUserHash?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	isAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	isUser?: FieldPolicy<any> | FieldReadFunction<any>,
	isVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	languageSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyAdminId?: FieldPolicy<any> | FieldReadFunction<any>,
	marketingOptIn?: FieldPolicy<any> | FieldReadFunction<any>,
	modules?: FieldPolicy<any> | FieldReadFunction<any>,
	nativeAppSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	privacyAccepted?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	savedCard?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidySettings?: FieldPolicy<any> | FieldReadFunction<any>,
	teamId?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	upcomingCcMenus?: FieldPolicy<any> | FieldReadFunction<any>,
	upcomingCcMenusFromOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	wallet?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserAccountSettingsKeySpecifier = ('costCentre' | UserAccountSettingsKeySpecifier)[];
export type UserAccountSettingsFieldPolicy = {
	costCentre?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserAllergensKeySpecifier = ('celery' | 'cereals' | 'crustaceans' | 'eggs' | 'fish' | 'lupin' | 'milk' | 'molluscs' | 'mustard' | 'nuts' | 'peanuts' | 'sesame' | 'soybeans' | 'sulphur' | UserAllergensKeySpecifier)[];
export type UserAllergensFieldPolicy = {
	celery?: FieldPolicy<any> | FieldReadFunction<any>,
	cereals?: FieldPolicy<any> | FieldReadFunction<any>,
	crustaceans?: FieldPolicy<any> | FieldReadFunction<any>,
	eggs?: FieldPolicy<any> | FieldReadFunction<any>,
	fish?: FieldPolicy<any> | FieldReadFunction<any>,
	lupin?: FieldPolicy<any> | FieldReadFunction<any>,
	milk?: FieldPolicy<any> | FieldReadFunction<any>,
	molluscs?: FieldPolicy<any> | FieldReadFunction<any>,
	mustard?: FieldPolicy<any> | FieldReadFunction<any>,
	nuts?: FieldPolicy<any> | FieldReadFunction<any>,
	peanuts?: FieldPolicy<any> | FieldReadFunction<any>,
	sesame?: FieldPolicy<any> | FieldReadFunction<any>,
	soybeans?: FieldPolicy<any> | FieldReadFunction<any>,
	sulphur?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserAutopilotSettingsKeySpecifier = ('active' | 'enabled' | 'friday' | 'monday' | 'saturday' | 'sunday' | 'thursday' | 'tuesday' | 'userCanEdit' | 'wednesday' | UserAutopilotSettingsKeySpecifier)[];
export type UserAutopilotSettingsFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	friday?: FieldPolicy<any> | FieldReadFunction<any>,
	monday?: FieldPolicy<any> | FieldReadFunction<any>,
	saturday?: FieldPolicy<any> | FieldReadFunction<any>,
	sunday?: FieldPolicy<any> | FieldReadFunction<any>,
	thursday?: FieldPolicy<any> | FieldReadFunction<any>,
	tuesday?: FieldPolicy<any> | FieldReadFunction<any>,
	userCanEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	wednesday?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserContactPreferencesKeySpecifier = ('isAccountPrimaryContact' | 'notificationPreference' | 'remindersDeliveries' | 'remindersSubsidised' | 'remindersUnsubsidised' | 'remindersWeekly' | UserContactPreferencesKeySpecifier)[];
export type UserContactPreferencesFieldPolicy = {
	isAccountPrimaryContact?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	remindersDeliveries?: FieldPolicy<any> | FieldReadFunction<any>,
	remindersSubsidised?: FieldPolicy<any> | FieldReadFunction<any>,
	remindersUnsubsidised?: FieldPolicy<any> | FieldReadFunction<any>,
	remindersWeekly?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserDietaryPreferencesKeySpecifier = ('halal' | 'kosher' | 'refinedSugar' | 'vegan' | 'vegetarian' | UserDietaryPreferencesKeySpecifier)[];
export type UserDietaryPreferencesFieldPolicy = {
	halal?: FieldPolicy<any> | FieldReadFunction<any>,
	kosher?: FieldPolicy<any> | FieldReadFunction<any>,
	refinedSugar?: FieldPolicy<any> | FieldReadFunction<any>,
	vegan?: FieldPolicy<any> | FieldReadFunction<any>,
	vegetarian?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserLanguageSettingsKeySpecifier = ('locale' | UserLanguageSettingsKeySpecifier)[];
export type UserLanguageSettingsFieldPolicy = {
	locale?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserNativeAppSettingsKeySpecifier = ('hasApp' | UserNativeAppSettingsKeySpecifier)[];
export type UserNativeAppSettingsFieldPolicy = {
	hasApp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserNotificationHistoryPagedKeySpecifier = ('items' | 'pageInfo' | UserNotificationHistoryPagedKeySpecifier)[];
export type UserNotificationHistoryPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserOnboardingSettingsKeySpecifier = ('ccAppPromoDismissed' | 'ccOnboarded' | UserOnboardingSettingsKeySpecifier)[];
export type UserOnboardingSettingsFieldPolicy = {
	ccAppPromoDismissed?: FieldPolicy<any> | FieldReadFunction<any>,
	ccOnboarded?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserSubsidySettingsKeySpecifier = ('unlimitedSubsidy' | 'userId' | UserSubsidySettingsKeySpecifier)[];
export type UserSubsidySettingsFieldPolicy = {
	unlimitedSubsidy?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserWalletKeySpecifier = ('balance' | UserWalletKeySpecifier)[];
export type UserWalletFieldPolicy = {
	balance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPagedKeySpecifier = ('pageInfo' | 'rows' | UsersPagedKeySpecifier)[];
export type UsersPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UtmTrackingDataKeySpecifier = ('campaign' | 'medium' | 'source' | UtmTrackingDataKeySpecifier)[];
export type UtmTrackingDataFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	medium?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VatBandKeySpecifier = ('id' | 'invoiceItemEligible' | 'legacyId' | 'menuItemEligible' | 'name' | 'rate' | 'vatRegion' | VatBandKeySpecifier)[];
export type VatBandFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceItemEligible?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyId?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemEligible?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	rate?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VatCalculationResultKeySpecifier = ('legacyVatBandId' | 'totalExVat' | 'totalIncVat' | 'totalVat' | 'vatBandId' | 'vatRate' | VatCalculationResultKeySpecifier)[];
export type VatCalculationResultFieldPolicy = {
	legacyVatBandId?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalIncVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	vatBandId?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VatRegionKeySpecifier = ('businessNumberIdentifierName' | 'code' | 'id' | 'legacyId' | 'name' | 'taxAcronym' | 'vatBands' | VatRegionKeySpecifier)[];
export type VatRegionFieldPolicy = {
	businessNumberIdentifierName?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	taxAcronym?: FieldPolicy<any> | FieldReadFunction<any>,
	vatBands?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VatSummaryKeySpecifier = ('total' | 'totalExVat' | 'totalVat' | 'vatBandId' | 'vatRate' | VatSummaryKeySpecifier)[];
export type VatSummaryFieldPolicy = {
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	vatBandId?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorKeySpecifier = ('accountIdsWithPrivateItemAccess' | 'breakfastCutOff' | 'categories' | 'cateringComposition' | 'ccRating' | 'ccTotalRatings' | 'companyName' | 'contacts' | 'currency' | 'descriptionFull' | 'descriptionShort' | 'dinnerCutOff' | 'draftMenuItem' | 'draftMenuItems' | 'draftMenuOptions' | 'emmaSuitability' | 'externalUrlData' | 'financeSettings' | 'flexFinanceSettings' | 'fullName' | 'gmAvailability' | 'gmCategories' | 'gmRating' | 'gmTotalRatings' | 'groupCode' | 'guidePrice' | 'hasCeramics' | 'hasLabels' | 'id' | 'images' | 'inRangeLocations' | 'integrationSettings' | 'isActive' | 'isApprovedSupplier' | 'isCCActive' | 'isClickAndCollectActive' | 'isDailyMenuReady' | 'isDraft' | 'isEmmaDiscoverable' | 'isGMActive' | 'isGMDiscoverable' | 'isHomeDeliveryActive' | 'isMyFavourite' | 'isPantry' | 'itemSearchMetadata' | 'keywords' | 'labelPreferences' | 'liveMenuItem' | 'liveMenuItems' | 'liveMenuLastUpdatedAt' | 'liveMenuOptions' | 'locations' | 'logo' | 'lunchCutOff' | 'markupSettings' | 'menuCsvDownload' | 'menuItemGroups' | 'menuMigrated' | 'metaDescription' | 'metaTitle' | 'modifierCategories' | 'modifierCategory' | 'permalink' | 'popularItems' | 'prefix' | 'priceLevel' | 'quote' | 'quoteAuthor' | 'rating' | 'ratingCalculatedAt' | 'scheduleSent' | 'sourcing' | 'statistics' | 'tags' | 'tips' | 'topRatedMenuItems' | 'totalRatings' | 'translations' | 'updatedAt' | 'vatNumber' | 'vendorStatements' | 'vendorStatementsSummary' | VendorKeySpecifier)[];
export type VendorFieldPolicy = {
	accountIdsWithPrivateItemAccess?: FieldPolicy<any> | FieldReadFunction<any>,
	breakfastCutOff?: FieldPolicy<any> | FieldReadFunction<any>,
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	cateringComposition?: FieldPolicy<any> | FieldReadFunction<any>,
	ccRating?: FieldPolicy<any> | FieldReadFunction<any>,
	ccTotalRatings?: FieldPolicy<any> | FieldReadFunction<any>,
	companyName?: FieldPolicy<any> | FieldReadFunction<any>,
	contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionFull?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionShort?: FieldPolicy<any> | FieldReadFunction<any>,
	dinnerCutOff?: FieldPolicy<any> | FieldReadFunction<any>,
	draftMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	draftMenuItems?: FieldPolicy<any> | FieldReadFunction<any>,
	draftMenuOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	emmaSuitability?: FieldPolicy<any> | FieldReadFunction<any>,
	externalUrlData?: FieldPolicy<any> | FieldReadFunction<any>,
	financeSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	flexFinanceSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	gmAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	gmCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	gmRating?: FieldPolicy<any> | FieldReadFunction<any>,
	gmTotalRatings?: FieldPolicy<any> | FieldReadFunction<any>,
	groupCode?: FieldPolicy<any> | FieldReadFunction<any>,
	guidePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	hasCeramics?: FieldPolicy<any> | FieldReadFunction<any>,
	hasLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	inRangeLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	integrationSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isApprovedSupplier?: FieldPolicy<any> | FieldReadFunction<any>,
	isCCActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isClickAndCollectActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDailyMenuReady?: FieldPolicy<any> | FieldReadFunction<any>,
	isDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	isEmmaDiscoverable?: FieldPolicy<any> | FieldReadFunction<any>,
	isGMActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isGMDiscoverable?: FieldPolicy<any> | FieldReadFunction<any>,
	isHomeDeliveryActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isMyFavourite?: FieldPolicy<any> | FieldReadFunction<any>,
	isPantry?: FieldPolicy<any> | FieldReadFunction<any>,
	itemSearchMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	keywords?: FieldPolicy<any> | FieldReadFunction<any>,
	labelPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	liveMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	liveMenuItems?: FieldPolicy<any> | FieldReadFunction<any>,
	liveMenuLastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	liveMenuOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	locations?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	lunchCutOff?: FieldPolicy<any> | FieldReadFunction<any>,
	markupSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	menuCsvDownload?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	menuMigrated?: FieldPolicy<any> | FieldReadFunction<any>,
	metaDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	metaTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	modifierCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	modifierCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	permalink?: FieldPolicy<any> | FieldReadFunction<any>,
	popularItems?: FieldPolicy<any> | FieldReadFunction<any>,
	prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	priceLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	quote?: FieldPolicy<any> | FieldReadFunction<any>,
	quoteAuthor?: FieldPolicy<any> | FieldReadFunction<any>,
	rating?: FieldPolicy<any> | FieldReadFunction<any>,
	ratingCalculatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleSent?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcing?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	tips?: FieldPolicy<any> | FieldReadFunction<any>,
	topRatedMenuItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRatings?: FieldPolicy<any> | FieldReadFunction<any>,
	translations?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	vatNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorStatements?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorStatementsSummary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorCategoryKeySpecifier = ('id' | 'name' | 'position' | VendorCategoryKeySpecifier)[];
export type VendorCategoryFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorCategoryItemsPageKeySpecifier = ('categoryId' | 'items' | 'pageInfo' | VendorCategoryItemsPageKeySpecifier)[];
export type VendorCategoryItemsPageFieldPolicy = {
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorChargeKeySpecifier = ('ccSupplierOrderId' | 'fixedAmount' | 'id' | 'percentage' | 'reason' | 'taxRate' | 'vendorId' | VendorChargeKeySpecifier)[];
export type VendorChargeFieldPolicy = {
	ccSupplierOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	fixedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorContactKeySpecifier = ('contactTypes' | 'email' | 'fullName' | 'id' | 'locale' | 'phone' | 'tenantId' | 'vendor' | VendorContactKeySpecifier)[];
export type VendorContactFieldPolicy = {
	contactTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorContactsPagedKeySpecifier = ('pageInfo' | 'rows' | VendorContactsPagedKeySpecifier)[];
export type VendorContactsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorEmmaSuitabilityKeySpecifier = ('marketplaceBanding' | 'occasionScores' | 'overallScore' | 'totalLiveItems' | VendorEmmaSuitabilityKeySpecifier)[];
export type VendorEmmaSuitabilityFieldPolicy = {
	marketplaceBanding?: FieldPolicy<any> | FieldReadFunction<any>,
	occasionScores?: FieldPolicy<any> | FieldReadFunction<any>,
	overallScore?: FieldPolicy<any> | FieldReadFunction<any>,
	totalLiveItems?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorExternalUrlKeySpecifier = ('copy' | 'id' | 'tags' | 'url' | VendorExternalUrlKeySpecifier)[];
export type VendorExternalUrlFieldPolicy = {
	copy?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorExternalUrlDataKeySpecifier = ('data' | VendorExternalUrlDataKeySpecifier)[];
export type VendorExternalUrlDataFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorExternalUrlTagsKeySpecifier = ('data' | VendorExternalUrlTagsKeySpecifier)[];
export type VendorExternalUrlTagsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorFinanceSettingsKeySpecifier = ('accountName' | 'accountNumber' | 'bankCode' | 'bankName' | 'billingCity' | 'billingCountry' | 'billingLine1' | 'billingLine2' | 'billingPostcode' | 'branchCode' | 'bsbNumber' | 'businessNumber' | 'financeContact' | 'id' | 'isVatRegistered' | 'notes' | 'paymentMadeDaysAfterStatementEnd' | 'reducedCommissionRate' | 'sortCode' | 'standardCommissionRate' | 'vatNumber' | 'vatRegion' | VendorFinanceSettingsKeySpecifier)[];
export type VendorFinanceSettingsFieldPolicy = {
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	bankCode?: FieldPolicy<any> | FieldReadFunction<any>,
	bankName?: FieldPolicy<any> | FieldReadFunction<any>,
	billingCity?: FieldPolicy<any> | FieldReadFunction<any>,
	billingCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	billingLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	billingLine2?: FieldPolicy<any> | FieldReadFunction<any>,
	billingPostcode?: FieldPolicy<any> | FieldReadFunction<any>,
	branchCode?: FieldPolicy<any> | FieldReadFunction<any>,
	bsbNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	businessNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	financeContact?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isVatRegistered?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMadeDaysAfterStatementEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	reducedCommissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	sortCode?: FieldPolicy<any> | FieldReadFunction<any>,
	standardCommissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	vatNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorFlexFinanceSettingsKeySpecifier = ('accountName' | 'accountNumber' | 'additionalEmails' | 'addressCity' | 'addressCountry' | 'addressLine1' | 'addressLine2' | 'addressPostcode' | 'autoInvoice' | 'bankCode' | 'bankName' | 'branchCode' | 'bsbNumber' | 'chargeCommissionOnDeliveryFees' | 'contactEmailAddress' | 'contactFirstName' | 'contactLastName' | 'entityName' | 'entityNumber' | 'entityRegion' | 'entityTaxNumber' | 'financeContact' | 'flexDeferredSupplierId' | 'id' | 'invoiceLocationsSeparately' | 'isVatRegistered' | 'markUpRate' | 'notes' | 'paymentTerms' | 'reducedCommissionRate' | 'sortCode' | 'standardCommissionRate' | 'vatRegion' | VendorFlexFinanceSettingsKeySpecifier)[];
export type VendorFlexFinanceSettingsFieldPolicy = {
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	addressCity?: FieldPolicy<any> | FieldReadFunction<any>,
	addressCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	addressLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	addressLine2?: FieldPolicy<any> | FieldReadFunction<any>,
	addressPostcode?: FieldPolicy<any> | FieldReadFunction<any>,
	autoInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	bankCode?: FieldPolicy<any> | FieldReadFunction<any>,
	bankName?: FieldPolicy<any> | FieldReadFunction<any>,
	branchCode?: FieldPolicy<any> | FieldReadFunction<any>,
	bsbNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	chargeCommissionOnDeliveryFees?: FieldPolicy<any> | FieldReadFunction<any>,
	contactEmailAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	contactFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	contactLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	entityName?: FieldPolicy<any> | FieldReadFunction<any>,
	entityNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	entityRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	entityTaxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	financeContact?: FieldPolicy<any> | FieldReadFunction<any>,
	flexDeferredSupplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceLocationsSeparately?: FieldPolicy<any> | FieldReadFunction<any>,
	isVatRegistered?: FieldPolicy<any> | FieldReadFunction<any>,
	markUpRate?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentTerms?: FieldPolicy<any> | FieldReadFunction<any>,
	reducedCommissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	sortCode?: FieldPolicy<any> | FieldReadFunction<any>,
	standardCommissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorFlexInvoiceKeySpecifier = ('accountName' | 'createdAt' | 'csv' | 'dueDate' | 'id' | 'location' | 'number' | 'status' | 'timezone' | 'total' | 'vendorId' | VendorFlexInvoiceKeySpecifier)[];
export type VendorFlexInvoiceFieldPolicy = {
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	csv?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorFlexInvoiceAllTypesKeySpecifier = ('accountAddress' | 'accountBankDetails' | 'accountBusinessNumber' | 'accountContact' | 'accountName' | 'accountTaxNumber' | 'assets' | 'createdAt' | 'csv' | 'dueDate' | 'entityBankDetails' | 'entityName' | 'flexDeferredSupplierId' | 'id' | 'invoiceType' | 'location' | 'number' | 'status' | 'supplierId' | 'timezone' | 'total' | 'vendorId' | VendorFlexInvoiceAllTypesKeySpecifier)[];
export type VendorFlexInvoiceAllTypesFieldPolicy = {
	accountAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	accountBankDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	accountBusinessNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	accountContact?: FieldPolicy<any> | FieldReadFunction<any>,
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	accountTaxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	csv?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	entityBankDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	entityName?: FieldPolicy<any> | FieldReadFunction<any>,
	flexDeferredSupplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceType?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorFlexInvoiceAllTypesPagedKeySpecifier = ('items' | 'pageInfo' | VendorFlexInvoiceAllTypesPagedKeySpecifier)[];
export type VendorFlexInvoiceAllTypesPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorFlexInvoicesPagedKeySpecifier = ('items' | 'pageInfo' | VendorFlexInvoicesPagedKeySpecifier)[];
export type VendorFlexInvoicesPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorHighlightCategoriesForLocationKeySpecifier = ('highlightCategories' | 'pageInfo' | VendorHighlightCategoriesForLocationKeySpecifier)[];
export type VendorHighlightCategoriesForLocationFieldPolicy = {
	highlightCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorHighlightCategoryKeySpecifier = ('id' | 'label' | 'name' | 'vendors' | VendorHighlightCategoryKeySpecifier)[];
export type VendorHighlightCategoryFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	vendors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorHighlightCategoryVendorsPagedKeySpecifier = ('pageInfo' | 'vendors' | VendorHighlightCategoryVendorsPagedKeySpecifier)[];
export type VendorHighlightCategoryVendorsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	vendors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorImageKeySpecifier = ('alt' | 'id' | 'isActive' | 'name' | 'position' | 'secureUrl' | 'supplierId' | 'type' | 'url' | VendorImageKeySpecifier)[];
export type VendorImageFieldPolicy = {
	alt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	secureUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorInRangeLocationsKeySpecifier = ('locations' | 'vendorId' | VendorInRangeLocationsKeySpecifier)[];
export type VendorInRangeLocationsFieldPolicy = {
	locations?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorIntegrationSettingsKeySpecifier = ('centegraRequired' | VendorIntegrationSettingsKeySpecifier)[];
export type VendorIntegrationSettingsFieldPolicy = {
	centegraRequired?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorInvoiceOrderKeySpecifier = ('contact' | 'deferredSupplierInvoiceId' | 'deferredSupplierInvoiceNumber' | 'deliveryDate' | 'deliveryTimezone' | 'id' | 'number' | 'shippingAddress' | 'supplier' | 'supplierLocation' | 'total' | VendorInvoiceOrderKeySpecifier)[];
export type VendorInvoiceOrderFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	deferredSupplierInvoiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	deferredSupplierInvoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryTimezone?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorInvoiceOrdersPagedKeySpecifier = ('items' | 'pageInfo' | VendorInvoiceOrdersPagedKeySpecifier)[];
export type VendorInvoiceOrdersPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorLocationKeySpecifier = ('city' | 'closingDates' | 'contacts' | 'country' | 'deliveryRegions' | 'details' | 'email' | 'id' | 'instructions' | 'isDefault' | 'label' | 'lat' | 'line1' | 'line2' | 'line3' | 'lng' | 'note' | 'openingTimes' | 'phone' | 'pickupWaitTime' | 'postcode' | 'preferredCourier' | 'serviceTimes' | 'supplierId' | 'timezone' | 'vendor' | 'what3words' | VendorLocationKeySpecifier)[];
export type VendorLocationFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	closingDates?: FieldPolicy<any> | FieldReadFunction<any>,
	contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryRegions?: FieldPolicy<any> | FieldReadFunction<any>,
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	instructions?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	line1?: FieldPolicy<any> | FieldReadFunction<any>,
	line2?: FieldPolicy<any> | FieldReadFunction<any>,
	line3?: FieldPolicy<any> | FieldReadFunction<any>,
	lng?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	openingTimes?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	pickupWaitTime?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	preferredCourier?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceTimes?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	what3words?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorLocationClosingDateKeySpecifier = ('closedDates' | 'closedWeekdays' | VendorLocationClosingDateKeySpecifier)[];
export type VendorLocationClosingDateFieldPolicy = {
	closedDates?: FieldPolicy<any> | FieldReadFunction<any>,
	closedWeekdays?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorLocationDetailsKeySpecifier = ('ccBreakfastCutOff' | 'ccDinnerCutOff' | 'ccLunchCutOff' | 'ccMaxDistanceMinutes' | 'ccWeekMaxOrderSize' | 'ccWeekMaxOrdersPerDay' | 'ccWeekendMaxOrderSize' | 'ccWeekendMaxOrdersPerDay' | 'effectiveMinimumNoticePeriod' | 'gmAllowCountryWideDelivery' | 'gmLargeOrderNoticePeriod' | 'gmLargeOrderThreshold' | 'gmMaxDistanceMinutes' | 'gmMaxOrder' | 'gmMinNoticePeriod' | 'gmMinOrder' | 'gmPackagingIndividual' | 'gmPackagingSharing' | 'id' | 'isCCActive' | 'isClickAndCollectActive' | 'isGMActive' | 'isHomeDeliveryActive' | 'minOrderValue' | 'minOrderValueExTax' | 'ownDelivery' | 'ownDeliveryMethodAny' | 'ownDeliveryMethodWalking' | 'supplierId' | 'supplierLocationId' | VendorLocationDetailsKeySpecifier)[];
export type VendorLocationDetailsFieldPolicy = {
	ccBreakfastCutOff?: FieldPolicy<any> | FieldReadFunction<any>,
	ccDinnerCutOff?: FieldPolicy<any> | FieldReadFunction<any>,
	ccLunchCutOff?: FieldPolicy<any> | FieldReadFunction<any>,
	ccMaxDistanceMinutes?: FieldPolicy<any> | FieldReadFunction<any>,
	ccWeekMaxOrderSize?: FieldPolicy<any> | FieldReadFunction<any>,
	ccWeekMaxOrdersPerDay?: FieldPolicy<any> | FieldReadFunction<any>,
	ccWeekendMaxOrderSize?: FieldPolicy<any> | FieldReadFunction<any>,
	ccWeekendMaxOrdersPerDay?: FieldPolicy<any> | FieldReadFunction<any>,
	effectiveMinimumNoticePeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	gmAllowCountryWideDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	gmLargeOrderNoticePeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	gmLargeOrderThreshold?: FieldPolicy<any> | FieldReadFunction<any>,
	gmMaxDistanceMinutes?: FieldPolicy<any> | FieldReadFunction<any>,
	gmMaxOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	gmMinNoticePeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	gmMinOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	gmPackagingIndividual?: FieldPolicy<any> | FieldReadFunction<any>,
	gmPackagingSharing?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCCActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isClickAndCollectActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isGMActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isHomeDeliveryActive?: FieldPolicy<any> | FieldReadFunction<any>,
	minOrderValue?: FieldPolicy<any> | FieldReadFunction<any>,
	minOrderValueExTax?: FieldPolicy<any> | FieldReadFunction<any>,
	ownDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	ownDeliveryMethodAny?: FieldPolicy<any> | FieldReadFunction<any>,
	ownDeliveryMethodWalking?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierLocationId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorLocationOpeningTimeKeySpecifier = ('endTime' | 'id' | 'startTime' | 'supplierLocationId' | 'weekdays' | VendorLocationOpeningTimeKeySpecifier)[];
export type VendorLocationOpeningTimeFieldPolicy = {
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	weekdays?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorLocationServiceTimeKeySpecifier = ('endTime' | 'id' | 'mealType' | 'startTime' | 'supplierLocationId' | 'weekdays' | VendorLocationServiceTimeKeySpecifier)[];
export type VendorLocationServiceTimeFieldPolicy = {
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mealType?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	weekdays?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorMarkupSettingsKeySpecifier = ('defaultMarkupPercentage' | VendorMarkupSettingsKeySpecifier)[];
export type VendorMarkupSettingsFieldPolicy = {
	defaultMarkupPercentage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorMenuCategoryKeySpecifier = ('description' | 'hasMoreItems' | 'heroAssets' | 'id' | 'isEmpty' | 'isFeatured' | 'itemCount' | 'name' | 'position' | VendorMenuCategoryKeySpecifier)[];
export type VendorMenuCategoryFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	hasMoreItems?: FieldPolicy<any> | FieldReadFunction<any>,
	heroAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isEmpty?: FieldPolicy<any> | FieldReadFunction<any>,
	isFeatured?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorMenuCategoryConnectionKeySpecifier = ('pageInfo' | 'rows' | VendorMenuCategoryConnectionKeySpecifier)[];
export type VendorMenuCategoryConnectionFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorMenuCategoryHeroAssetKeySpecifier = ('altText' | 'type' | 'url' | VendorMenuCategoryHeroAssetKeySpecifier)[];
export type VendorMenuCategoryHeroAssetFieldPolicy = {
	altText?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorMenuCategoryPageInfoKeySpecifier = ('count' | 'limit' | 'offset' | VendorMenuCategoryPageInfoKeySpecifier)[];
export type VendorMenuCategoryPageInfoFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorMenuItemStatKeySpecifier = ('id' | 'label' | 'name' | 'value' | VendorMenuItemStatKeySpecifier)[];
export type VendorMenuItemStatFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorMenuItemsPageInfoKeySpecifier = ('count' | 'hasMore' | 'limit' | 'nextOffset' | 'offset' | VendorMenuItemsPageInfoKeySpecifier)[];
export type VendorMenuItemsPageInfoFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	hasMore?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	nextOffset?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorOccasionSuitabilityScoreKeySpecifier = ('occasion' | 'percentage' | 'suitableItems' | 'totalItems' | VendorOccasionSuitabilityScoreKeySpecifier)[];
export type VendorOccasionSuitabilityScoreFieldPolicy = {
	occasion?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>,
	suitableItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalItems?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorPreferenceKeySpecifier = ('blacklisted' | 'preferred' | 'vendor' | 'vendorId' | VendorPreferenceKeySpecifier)[];
export type VendorPreferenceFieldPolicy = {
	blacklisted?: FieldPolicy<any> | FieldReadFunction<any>,
	preferred?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorRatingDataKeySpecifier = ('maxRating' | 'periodEnd' | 'periodStart' | 'rating' | 'totalReviewsInPeriod' | VendorRatingDataKeySpecifier)[];
export type VendorRatingDataFieldPolicy = {
	maxRating?: FieldPolicy<any> | FieldReadFunction<any>,
	periodEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	periodStart?: FieldPolicy<any> | FieldReadFunction<any>,
	rating?: FieldPolicy<any> | FieldReadFunction<any>,
	totalReviewsInPeriod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorSearchStatsKeySpecifier = ('bestForTags' | 'cuisineTags' | 'dietaryTags' | 'diversityOfOwnershipTags' | 'headCount' | 'keyDatesTags' | 'mealType' | 'occasionTags' | 'priceLevel' | VendorSearchStatsKeySpecifier)[];
export type VendorSearchStatsFieldPolicy = {
	bestForTags?: FieldPolicy<any> | FieldReadFunction<any>,
	cuisineTags?: FieldPolicy<any> | FieldReadFunction<any>,
	dietaryTags?: FieldPolicy<any> | FieldReadFunction<any>,
	diversityOfOwnershipTags?: FieldPolicy<any> | FieldReadFunction<any>,
	headCount?: FieldPolicy<any> | FieldReadFunction<any>,
	keyDatesTags?: FieldPolicy<any> | FieldReadFunction<any>,
	mealType?: FieldPolicy<any> | FieldReadFunction<any>,
	occasionTags?: FieldPolicy<any> | FieldReadFunction<any>,
	priceLevel?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorStatementKeySpecifier = ('additionalTotal' | 'additionalTotalExVat' | 'additionalTotalVat' | 'amountPaid' | 'asset' | 'assets' | 'billingDetails' | 'billingEntity' | 'canApprove' | 'canCancel' | 'commissions' | 'currency' | 'feeSummary' | 'friendlyId' | 'id' | 'isAlreadyApproved' | 'issueDate' | 'paidDate' | 'paymentStatus' | 'periodEnd' | 'periodStart' | 'reseller' | 'serviceOrderBreakdown' | 'serviceOriginalOrderBreakdown' | 'serviceTotals' | 'status' | 'summary' | 'total' | 'totalExVat' | 'totalVat' | 'vatRegion' | 'vendorLocationName' | 'vendorLocationTimezone' | 'vendorName' | VendorStatementKeySpecifier)[];
export type VendorStatementFieldPolicy = {
	additionalTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalTotalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalTotalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	amountPaid?: FieldPolicy<any> | FieldReadFunction<any>,
	asset?: FieldPolicy<any> | FieldReadFunction<any>,
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	billingDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	billingEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	canApprove?: FieldPolicy<any> | FieldReadFunction<any>,
	canCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	commissions?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	feeSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	friendlyId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAlreadyApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	issueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	paidDate?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	periodEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	periodStart?: FieldPolicy<any> | FieldReadFunction<any>,
	reseller?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOrderBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOriginalOrderBreakdown?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceTotals?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorLocationName?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorLocationTimezone?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorStatementBillingContactKeySpecifier = ('email' | 'fullName' | 'locale' | 'tenantId' | VendorStatementBillingContactKeySpecifier)[];
export type VendorStatementBillingContactFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorStatementBillingDetailsKeySpecifier = ('address' | 'contact' | VendorStatementBillingDetailsKeySpecifier)[];
export type VendorStatementBillingDetailsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorStatementCommissionKeySpecifier = ('commissionRate' | 'description' | 'editible' | 'id' | 'serviceType' | 'total' | 'totalExVat' | 'totalVat' | 'vatRate' | VendorStatementCommissionKeySpecifier)[];
export type VendorStatementCommissionFieldPolicy = {
	commissionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	editible?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceType?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorStatementFeeSummaryKeySpecifier = ('items' | 'total' | 'totalExVat' | 'totalVat' | VendorStatementFeeSummaryKeySpecifier)[];
export type VendorStatementFeeSummaryFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorStatementOrderBreakdownItemKeySpecifier = ('billingDetails' | 'date' | 'discount' | 'friendlyOrderId' | 'invoiceId' | 'items' | 'orderHref' | 'orderId' | 'quantity' | 'taxInvoiceId' | 'total' | 'totalExVat' | 'totalVat' | VendorStatementOrderBreakdownItemKeySpecifier)[];
export type VendorStatementOrderBreakdownItemFieldPolicy = {
	billingDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	friendlyOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	orderHref?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	taxInvoiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorStatementServiceOrderBreakdownKeySpecifier = ('CC' | 'GM' | VendorStatementServiceOrderBreakdownKeySpecifier)[];
export type VendorStatementServiceOrderBreakdownFieldPolicy = {
	CC?: FieldPolicy<any> | FieldReadFunction<any>,
	GM?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorStatementServiceTotalsKeySpecifier = ('ccTotal' | 'ccTotalExVat' | 'ccTotalQuantity' | 'ccTotalVat' | 'gmTotal' | 'gmTotalExVat' | 'gmTotalQuantity' | 'gmTotalVat' | VendorStatementServiceTotalsKeySpecifier)[];
export type VendorStatementServiceTotalsFieldPolicy = {
	ccTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	ccTotalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	ccTotalQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	ccTotalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	gmTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	gmTotalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	gmTotalQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	gmTotalVat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorStatementSummaryItemKeySpecifier = ('description' | 'editible' | 'id' | 'quantity' | 'serviceType' | 'subTotalExVat' | 'total' | 'totalExVat' | 'totalVat' | 'vatRate' | VendorStatementSummaryItemKeySpecifier)[];
export type VendorStatementSummaryItemFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	editible?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceType?: FieldPolicy<any> | FieldReadFunction<any>,
	subTotalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalExVat?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVat?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorStatementsCombinedPagedKeySpecifier = ('items' | 'pageInfo' | VendorStatementsCombinedPagedKeySpecifier)[];
export type VendorStatementsCombinedPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorStatementsPagedKeySpecifier = ('items' | 'pageInfo' | VendorStatementsPagedKeySpecifier)[];
export type VendorStatementsPagedFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorStatementsSummaryKeySpecifier = ('orderTypeTotals' | 'totalAmount' | 'weeklyTotals' | VendorStatementsSummaryKeySpecifier)[];
export type VendorStatementsSummaryFieldPolicy = {
	orderTypeTotals?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	weeklyTotals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorSuitabilityScoreKeySpecifier = ('percentage' | 'suitableItems' | 'totalItems' | VendorSuitabilityScoreKeySpecifier)[];
export type VendorSuitabilityScoreFieldPolicy = {
	percentage?: FieldPolicy<any> | FieldReadFunction<any>,
	suitableItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalItems?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorTagKeySpecifier = ('color' | 'countryAssignments' | 'groupId' | 'groupLabel' | 'groupName' | 'id' | 'image' | 'label' | 'name' | 'permalink' | 'position' | 'type' | VendorTagKeySpecifier)[];
export type VendorTagFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	countryAssignments?: FieldPolicy<any> | FieldReadFunction<any>,
	groupId?: FieldPolicy<any> | FieldReadFunction<any>,
	groupLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	groupName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	permalink?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorTagCountryAssignmentKeySpecifier = ('countryCode' | 'isPublicFilterGm' | 'position' | VendorTagCountryAssignmentKeySpecifier)[];
export type VendorTagCountryAssignmentFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublicFilterGm?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorsListPagedKeySpecifier = ('pageInfo' | 'rows' | VendorsListPagedKeySpecifier)[];
export type VendorsListPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorsPagedKeySpecifier = ('pageInfo' | 'rows' | 'stats' | VendorsPagedKeySpecifier)[];
export type VendorsPagedFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>,
	stats?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ViewportKeySpecifier = ('northeast' | 'southwest' | ViewportKeySpecifier)[];
export type ViewportFieldPolicy = {
	northeast?: FieldPolicy<any> | FieldReadFunction<any>,
	southwest?: FieldPolicy<any> | FieldReadFunction<any>
};
export type occasionItemTimeRestraintsKeySpecifier = ('breakfast' | 'dinner' | 'lunch' | 'occasion' | occasionItemTimeRestraintsKeySpecifier)[];
export type occasionItemTimeRestraintsFieldPolicy = {
	breakfast?: FieldPolicy<any> | FieldReadFunction<any>,
	dinner?: FieldPolicy<any> | FieldReadFunction<any>,
	lunch?: FieldPolicy<any> | FieldReadFunction<any>,
	occasion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type orderItemsCsvResultKeySpecifier = ('url' | orderItemsCsvResultKeySpecifier)[];
export type orderItemsCsvResultFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	Account?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountKeySpecifier | (() => undefined | AccountKeySpecifier),
		fields?: AccountFieldPolicy,
	},
	AccountCountryFlexMapping?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountCountryFlexMappingKeySpecifier | (() => undefined | AccountCountryFlexMappingKeySpecifier),
		fields?: AccountCountryFlexMappingFieldPolicy,
	},
	AccountFinanceSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountFinanceSettingsKeySpecifier | (() => undefined | AccountFinanceSettingsKeySpecifier),
		fields?: AccountFinanceSettingsFieldPolicy,
	},
	AccountIdentityProviderAttributeMapping?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountIdentityProviderAttributeMappingKeySpecifier | (() => undefined | AccountIdentityProviderAttributeMappingKeySpecifier),
		fields?: AccountIdentityProviderAttributeMappingFieldPolicy,
	},
	AccountLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountLocationKeySpecifier | (() => undefined | AccountLocationKeySpecifier),
		fields?: AccountLocationFieldPolicy,
	},
	AccountLocationAsset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountLocationAssetKeySpecifier | (() => undefined | AccountLocationAssetKeySpecifier),
		fields?: AccountLocationAssetFieldPolicy,
	},
	AccountLocationCanteenServieSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountLocationCanteenServieSettingsKeySpecifier | (() => undefined | AccountLocationCanteenServieSettingsKeySpecifier),
		fields?: AccountLocationCanteenServieSettingsFieldPolicy,
	},
	AccountLocationContactPreferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountLocationContactPreferencesKeySpecifier | (() => undefined | AccountLocationContactPreferencesKeySpecifier),
		fields?: AccountLocationContactPreferencesFieldPolicy,
	},
	AccountLocationDeliveryPreferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountLocationDeliveryPreferencesKeySpecifier | (() => undefined | AccountLocationDeliveryPreferencesKeySpecifier),
		fields?: AccountLocationDeliveryPreferencesFieldPolicy,
	},
	AccountLocationReferenceFieldValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountLocationReferenceFieldValueKeySpecifier | (() => undefined | AccountLocationReferenceFieldValueKeySpecifier),
		fields?: AccountLocationReferenceFieldValueFieldPolicy,
	},
	AccountLocationReferenceFieldValueOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountLocationReferenceFieldValueOptionKeySpecifier | (() => undefined | AccountLocationReferenceFieldValueOptionKeySpecifier),
		fields?: AccountLocationReferenceFieldValueOptionFieldPolicy,
	},
	AccountLocationsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountLocationsPagedKeySpecifier | (() => undefined | AccountLocationsPagedKeySpecifier),
		fields?: AccountLocationsPagedFieldPolicy,
	},
	AccountPrivateSuppliers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountPrivateSuppliersKeySpecifier | (() => undefined | AccountPrivateSuppliersKeySpecifier),
		fields?: AccountPrivateSuppliersFieldPolicy,
	},
	AccountSsoConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountSsoConfigKeySpecifier | (() => undefined | AccountSsoConfigKeySpecifier),
		fields?: AccountSsoConfigFieldPolicy,
	},
	AccountUserInterfaceSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountUserInterfaceSettingsKeySpecifier | (() => undefined | AccountUserInterfaceSettingsKeySpecifier),
		fields?: AccountUserInterfaceSettingsFieldPolicy,
	},
	AccountsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountsPagedKeySpecifier | (() => undefined | AccountsPagedKeySpecifier),
		fields?: AccountsPagedFieldPolicy,
	},
	Address?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressKeySpecifier | (() => undefined | AddressKeySpecifier),
		fields?: AddressFieldPolicy,
	},
	AddressComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressComponentKeySpecifier | (() => undefined | AddressComponentKeySpecifier),
		fields?: AddressComponentFieldPolicy,
	},
	AddressLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressLocationKeySpecifier | (() => undefined | AddressLocationKeySpecifier),
		fields?: AddressLocationFieldPolicy,
	},
	Admin?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminKeySpecifier | (() => undefined | AdminKeySpecifier),
		fields?: AdminFieldPolicy,
	},
	AdminLanguageSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminLanguageSettingsKeySpecifier | (() => undefined | AdminLanguageSettingsKeySpecifier),
		fields?: AdminLanguageSettingsFieldPolicy,
	},
	AdminsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminsPagedKeySpecifier | (() => undefined | AdminsPagedKeySpecifier),
		fields?: AdminsPagedFieldPolicy,
	},
	AggregateByPeriod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AggregateByPeriodKeySpecifier | (() => undefined | AggregateByPeriodKeySpecifier),
		fields?: AggregateByPeriodFieldPolicy,
	},
	Alert?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertKeySpecifier | (() => undefined | AlertKeySpecifier),
		fields?: AlertFieldPolicy,
	},
	AlertDestinations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertDestinationsKeySpecifier | (() => undefined | AlertDestinationsKeySpecifier),
		fields?: AlertDestinationsFieldPolicy,
	},
	AlertEmailDestination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertEmailDestinationKeySpecifier | (() => undefined | AlertEmailDestinationKeySpecifier),
		fields?: AlertEmailDestinationFieldPolicy,
	},
	AlertFilterBase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertFilterBaseKeySpecifier | (() => undefined | AlertFilterBaseKeySpecifier),
		fields?: AlertFilterBaseFieldPolicy,
	},
	AlertFilterBoolean?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertFilterBooleanKeySpecifier | (() => undefined | AlertFilterBooleanKeySpecifier),
		fields?: AlertFilterBooleanFieldPolicy,
	},
	AlertFilterNumber?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertFilterNumberKeySpecifier | (() => undefined | AlertFilterNumberKeySpecifier),
		fields?: AlertFilterNumberFieldPolicy,
	},
	AlertFilterString?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertFilterStringKeySpecifier | (() => undefined | AlertFilterStringKeySpecifier),
		fields?: AlertFilterStringFieldPolicy,
	},
	AlertSlackDestination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertSlackDestinationKeySpecifier | (() => undefined | AlertSlackDestinationKeySpecifier),
		fields?: AlertSlackDestinationFieldPolicy,
	},
	AlertTenantConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertTenantConfigKeySpecifier | (() => undefined | AlertTenantConfigKeySpecifier),
		fields?: AlertTenantConfigFieldPolicy,
	},
	AlertType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertTypeKeySpecifier | (() => undefined | AlertTypeKeySpecifier),
		fields?: AlertTypeFieldPolicy,
	},
	AlertTypeFilterAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertTypeFilterAccountKeySpecifier | (() => undefined | AlertTypeFilterAccountKeySpecifier),
		fields?: AlertTypeFilterAccountFieldPolicy,
	},
	AlertTypeFilterBase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertTypeFilterBaseKeySpecifier | (() => undefined | AlertTypeFilterBaseKeySpecifier),
		fields?: AlertTypeFilterBaseFieldPolicy,
	},
	AlertTypeFilterBoolean?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertTypeFilterBooleanKeySpecifier | (() => undefined | AlertTypeFilterBooleanKeySpecifier),
		fields?: AlertTypeFilterBooleanFieldPolicy,
	},
	AlertTypeFilterCountry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertTypeFilterCountryKeySpecifier | (() => undefined | AlertTypeFilterCountryKeySpecifier),
		fields?: AlertTypeFilterCountryFieldPolicy,
	},
	AlertTypeFilterDropdown?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertTypeFilterDropdownKeySpecifier | (() => undefined | AlertTypeFilterDropdownKeySpecifier),
		fields?: AlertTypeFilterDropdownFieldPolicy,
	},
	AlertTypeFilterNumber?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertTypeFilterNumberKeySpecifier | (() => undefined | AlertTypeFilterNumberKeySpecifier),
		fields?: AlertTypeFilterNumberFieldPolicy,
	},
	AlertTypeFilterString?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertTypeFilterStringKeySpecifier | (() => undefined | AlertTypeFilterStringKeySpecifier),
		fields?: AlertTypeFilterStringFieldPolicy,
	},
	AlertTypeFilterSupplier?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertTypeFilterSupplierKeySpecifier | (() => undefined | AlertTypeFilterSupplierKeySpecifier),
		fields?: AlertTypeFilterSupplierFieldPolicy,
	},
	AlertsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertsPagedKeySpecifier | (() => undefined | AlertsPagedKeySpecifier),
		fields?: AlertsPagedFieldPolicy,
	},
	AllergenAudit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AllergenAuditKeySpecifier | (() => undefined | AllergenAuditKeySpecifier),
		fields?: AllergenAuditFieldPolicy,
	},
	AllergenAuditSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AllergenAuditSummaryKeySpecifier | (() => undefined | AllergenAuditSummaryKeySpecifier),
		fields?: AllergenAuditSummaryFieldPolicy,
	},
	AllergenAuditSummaryRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AllergenAuditSummaryRowKeySpecifier | (() => undefined | AllergenAuditSummaryRowKeySpecifier),
		fields?: AllergenAuditSummaryRowFieldPolicy,
	},
	AllergenStat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AllergenStatKeySpecifier | (() => undefined | AllergenStatKeySpecifier),
		fields?: AllergenStatFieldPolicy,
	},
	ApplyNewReferenceFieldsToCCSupplierOrderResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ApplyNewReferenceFieldsToCCSupplierOrderResultKeySpecifier | (() => undefined | ApplyNewReferenceFieldsToCCSupplierOrderResultKeySpecifier),
		fields?: ApplyNewReferenceFieldsToCCSupplierOrderResultFieldPolicy,
	},
	ApprovedSupplier?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ApprovedSupplierKeySpecifier | (() => undefined | ApprovedSupplierKeySpecifier),
		fields?: ApprovedSupplierFieldPolicy,
	},
	ArchiveAccountPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ArchiveAccountPayloadKeySpecifier | (() => undefined | ArchiveAccountPayloadKeySpecifier),
		fields?: ArchiveAccountPayloadFieldPolicy,
	},
	ArchiveBlocker?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ArchiveBlockerKeySpecifier | (() => undefined | ArchiveBlockerKeySpecifier),
		fields?: ArchiveBlockerFieldPolicy,
	},
	ArchiveWarning?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ArchiveWarningKeySpecifier | (() => undefined | ArchiveWarningKeySpecifier),
		fields?: ArchiveWarningFieldPolicy,
	},
	Asset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssetKeySpecifier | (() => undefined | AssetKeySpecifier),
		fields?: AssetFieldPolicy,
	},
	AssignUsersToTeamResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignUsersToTeamResultKeySpecifier | (() => undefined | AssignUsersToTeamResultKeySpecifier),
		fields?: AssignUsersToTeamResultFieldPolicy,
	},
	AvailabilitiesAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AvailabilitiesAccountKeySpecifier | (() => undefined | AvailabilitiesAccountKeySpecifier),
		fields?: AvailabilitiesAccountFieldPolicy,
	},
	AvailabilitiesVendor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AvailabilitiesVendorKeySpecifier | (() => undefined | AvailabilitiesVendorKeySpecifier),
		fields?: AvailabilitiesVendorFieldPolicy,
	},
	BankAccountData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BankAccountDataKeySpecifier | (() => undefined | BankAccountDataKeySpecifier),
		fields?: BankAccountDataFieldPolicy,
	},
	BasketFeeBreakdown?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BasketFeeBreakdownKeySpecifier | (() => undefined | BasketFeeBreakdownKeySpecifier),
		fields?: BasketFeeBreakdownFieldPolicy,
	},
	BasketItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BasketItemKeySpecifier | (() => undefined | BasketItemKeySpecifier),
		fields?: BasketItemFieldPolicy,
	},
	BasketItemOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BasketItemOptionKeySpecifier | (() => undefined | BasketItemOptionKeySpecifier),
		fields?: BasketItemOptionFieldPolicy,
	},
	BasketSubtotalBreakdown?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BasketSubtotalBreakdownKeySpecifier | (() => undefined | BasketSubtotalBreakdownKeySpecifier),
		fields?: BasketSubtotalBreakdownFieldPolicy,
	},
	BasketTaxRateTotal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BasketTaxRateTotalKeySpecifier | (() => undefined | BasketTaxRateTotalKeySpecifier),
		fields?: BasketTaxRateTotalFieldPolicy,
	},
	BillingAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BillingAddressKeySpecifier | (() => undefined | BillingAddressKeySpecifier),
		fields?: BillingAddressFieldPolicy,
	},
	BillingContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BillingContactKeySpecifier | (() => undefined | BillingContactKeySpecifier),
		fields?: BillingContactFieldPolicy,
	},
	BillingDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BillingDetailsKeySpecifier | (() => undefined | BillingDetailsKeySpecifier),
		fields?: BillingDetailsFieldPolicy,
	},
	BillingEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BillingEntityKeySpecifier | (() => undefined | BillingEntityKeySpecifier),
		fields?: BillingEntityFieldPolicy,
	},
	BlockedMenuItemDeletion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlockedMenuItemDeletionKeySpecifier | (() => undefined | BlockedMenuItemDeletionKeySpecifier),
		fields?: BlockedMenuItemDeletionFieldPolicy,
	},
	BulkMenuItemMutationResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkMenuItemMutationResponseKeySpecifier | (() => undefined | BulkMenuItemMutationResponseKeySpecifier),
		fields?: BulkMenuItemMutationResponseFieldPolicy,
	},
	CCAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCAccountKeySpecifier | (() => undefined | CCAccountKeySpecifier),
		fields?: CCAccountFieldPolicy,
	},
	CCAccountLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCAccountLocationKeySpecifier | (() => undefined | CCAccountLocationKeySpecifier),
		fields?: CCAccountLocationFieldPolicy,
	},
	CCAccountLocationOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCAccountLocationOrderKeySpecifier | (() => undefined | CCAccountLocationOrderKeySpecifier),
		fields?: CCAccountLocationOrderFieldPolicy,
	},
	CCAccountOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCAccountOrderKeySpecifier | (() => undefined | CCAccountOrderKeySpecifier),
		fields?: CCAccountOrderFieldPolicy,
	},
	CCAccountOrdersPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCAccountOrdersPagedKeySpecifier | (() => undefined | CCAccountOrdersPagedKeySpecifier),
		fields?: CCAccountOrdersPagedFieldPolicy,
	},
	CCAvailabilitiesPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCAvailabilitiesPagedKeySpecifier | (() => undefined | CCAvailabilitiesPagedKeySpecifier),
		fields?: CCAvailabilitiesPagedFieldPolicy,
	},
	CCAvailability?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCAvailabilityKeySpecifier | (() => undefined | CCAvailabilityKeySpecifier),
		fields?: CCAvailabilityFieldPolicy,
	},
	CCCluster?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCClusterKeySpecifier | (() => undefined | CCClusterKeySpecifier),
		fields?: CCClusterFieldPolicy,
	},
	CCClustersPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCClustersPagedKeySpecifier | (() => undefined | CCClustersPagedKeySpecifier),
		fields?: CCClustersPagedFieldPolicy,
	},
	CCDateMealServiceData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCDateMealServiceDataKeySpecifier | (() => undefined | CCDateMealServiceDataKeySpecifier),
		fields?: CCDateMealServiceDataFieldPolicy,
	},
	CCInvoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCInvoiceKeySpecifier | (() => undefined | CCInvoiceKeySpecifier),
		fields?: CCInvoiceFieldPolicy,
	},
	CCMealService?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMealServiceKeySpecifier | (() => undefined | CCMealServiceKeySpecifier),
		fields?: CCMealServiceFieldPolicy,
	},
	CCMealServiceOrderedItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMealServiceOrderedItemsKeySpecifier | (() => undefined | CCMealServiceOrderedItemsKeySpecifier),
		fields?: CCMealServiceOrderedItemsFieldPolicy,
	},
	CCMealServiceTimeslot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMealServiceTimeslotKeySpecifier | (() => undefined | CCMealServiceTimeslotKeySpecifier),
		fields?: CCMealServiceTimeslotFieldPolicy,
	},
	CCMealTimeslot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMealTimeslotKeySpecifier | (() => undefined | CCMealTimeslotKeySpecifier),
		fields?: CCMealTimeslotFieldPolicy,
	},
	CCMealVendor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMealVendorKeySpecifier | (() => undefined | CCMealVendorKeySpecifier),
		fields?: CCMealVendorFieldPolicy,
	},
	CCMenuDebugResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMenuDebugResponseKeySpecifier | (() => undefined | CCMenuDebugResponseKeySpecifier),
		fields?: CCMenuDebugResponseFieldPolicy,
	},
	CCMenuDebugTest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMenuDebugTestKeySpecifier | (() => undefined | CCMenuDebugTestKeySpecifier),
		fields?: CCMenuDebugTestFieldPolicy,
	},
	CCMenuDebugTestAllocations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMenuDebugTestAllocationsKeySpecifier | (() => undefined | CCMenuDebugTestAllocationsKeySpecifier),
		fields?: CCMenuDebugTestAllocationsFieldPolicy,
	},
	CCMenuDebugTestAvailabilities?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMenuDebugTestAvailabilitiesKeySpecifier | (() => undefined | CCMenuDebugTestAvailabilitiesKeySpecifier),
		fields?: CCMenuDebugTestAvailabilitiesFieldPolicy,
	},
	CCMenuDebugTestCCSupplierOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMenuDebugTestCCSupplierOrderKeySpecifier | (() => undefined | CCMenuDebugTestCCSupplierOrderKeySpecifier),
		fields?: CCMenuDebugTestCCSupplierOrderFieldPolicy,
	},
	CCMenuDebugTestClusterAssignment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMenuDebugTestClusterAssignmentKeySpecifier | (() => undefined | CCMenuDebugTestClusterAssignmentKeySpecifier),
		fields?: CCMenuDebugTestClusterAssignmentFieldPolicy,
	},
	CCMenuItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMenuItemKeySpecifier | (() => undefined | CCMenuItemKeySpecifier),
		fields?: CCMenuItemFieldPolicy,
	},
	CCMenuQueryResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCMenuQueryResultKeySpecifier | (() => undefined | CCMenuQueryResultKeySpecifier),
		fields?: CCMenuQueryResultFieldPolicy,
	},
	CCOrderAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCOrderAddressKeySpecifier | (() => undefined | CCOrderAddressKeySpecifier),
		fields?: CCOrderAddressFieldPolicy,
	},
	CCOrderAgainItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCOrderAgainItemKeySpecifier | (() => undefined | CCOrderAgainItemKeySpecifier),
		fields?: CCOrderAgainItemFieldPolicy,
	},
	CCOrderConfirmation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCOrderConfirmationKeySpecifier | (() => undefined | CCOrderConfirmationKeySpecifier),
		fields?: CCOrderConfirmationFieldPolicy,
	},
	CCOrderItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCOrderItemKeySpecifier | (() => undefined | CCOrderItemKeySpecifier),
		fields?: CCOrderItemFieldPolicy,
	},
	CCOrderItemOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCOrderItemOptionKeySpecifier | (() => undefined | CCOrderItemOptionKeySpecifier),
		fields?: CCOrderItemOptionFieldPolicy,
	},
	CCOrderItemOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCOrderItemOptionsKeySpecifier | (() => undefined | CCOrderItemOptionsKeySpecifier),
		fields?: CCOrderItemOptionsFieldPolicy,
	},
	CCOrderItemsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCOrderItemsPagedKeySpecifier | (() => undefined | CCOrderItemsPagedKeySpecifier),
		fields?: CCOrderItemsPagedFieldPolicy,
	},
	CCOrderPrintPdfResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCOrderPrintPdfResponseKeySpecifier | (() => undefined | CCOrderPrintPdfResponseKeySpecifier),
		fields?: CCOrderPrintPdfResponseFieldPolicy,
	},
	CCOrderProgressResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCOrderProgressResponseKeySpecifier | (() => undefined | CCOrderProgressResponseKeySpecifier),
		fields?: CCOrderProgressResponseFieldPolicy,
	},
	CCOrderReminderNotification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCOrderReminderNotificationKeySpecifier | (() => undefined | CCOrderReminderNotificationKeySpecifier),
		fields?: CCOrderReminderNotificationFieldPolicy,
	},
	CCOrderReminderNotificationVendor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCOrderReminderNotificationVendorKeySpecifier | (() => undefined | CCOrderReminderNotificationVendorKeySpecifier),
		fields?: CCOrderReminderNotificationVendorFieldPolicy,
	},
	CCOrderTimeSlot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCOrderTimeSlotKeySpecifier | (() => undefined | CCOrderTimeSlotKeySpecifier),
		fields?: CCOrderTimeSlotFieldPolicy,
	},
	CCSubmenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSubmenuKeySpecifier | (() => undefined | CCSubmenuKeySpecifier),
		fields?: CCSubmenuFieldPolicy,
	},
	CCSubmenuAllocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSubmenuAllocationKeySpecifier | (() => undefined | CCSubmenuAllocationKeySpecifier),
		fields?: CCSubmenuAllocationFieldPolicy,
	},
	CCSubmenuItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSubmenuItemKeySpecifier | (() => undefined | CCSubmenuItemKeySpecifier),
		fields?: CCSubmenuItemFieldPolicy,
	},
	CCSubmenuItemStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSubmenuItemStatisticsKeySpecifier | (() => undefined | CCSubmenuItemStatisticsKeySpecifier),
		fields?: CCSubmenuItemStatisticsFieldPolicy,
	},
	CCSubmenuItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSubmenuItemsKeySpecifier | (() => undefined | CCSubmenuItemsKeySpecifier),
		fields?: CCSubmenuItemsFieldPolicy,
	},
	CCSubmenuLocationCapacity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSubmenuLocationCapacityKeySpecifier | (() => undefined | CCSubmenuLocationCapacityKeySpecifier),
		fields?: CCSubmenuLocationCapacityFieldPolicy,
	},
	CCSubmenuStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSubmenuStatisticsKeySpecifier | (() => undefined | CCSubmenuStatisticsKeySpecifier),
		fields?: CCSubmenuStatisticsFieldPolicy,
	},
	CCSubmenusPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSubmenusPagedKeySpecifier | (() => undefined | CCSubmenusPagedKeySpecifier),
		fields?: CCSubmenusPagedFieldPolicy,
	},
	CCSubsidy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSubsidyKeySpecifier | (() => undefined | CCSubsidyKeySpecifier),
		fields?: CCSubsidyFieldPolicy,
	},
	CCSupplierOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSupplierOrderKeySpecifier | (() => undefined | CCSupplierOrderKeySpecifier),
		fields?: CCSupplierOrderFieldPolicy,
	},
	CCSupplierOrderBreakdown?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSupplierOrderBreakdownKeySpecifier | (() => undefined | CCSupplierOrderBreakdownKeySpecifier),
		fields?: CCSupplierOrderBreakdownFieldPolicy,
	},
	CCSupplierOrderBreakdownPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSupplierOrderBreakdownPagedKeySpecifier | (() => undefined | CCSupplierOrderBreakdownPagedKeySpecifier),
		fields?: CCSupplierOrderBreakdownPagedFieldPolicy,
	},
	CCSupplierOrderBreakdownVat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSupplierOrderBreakdownVatKeySpecifier | (() => undefined | CCSupplierOrderBreakdownVatKeySpecifier),
		fields?: CCSupplierOrderBreakdownVatFieldPolicy,
	},
	CCSupplierOrderContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSupplierOrderContactKeySpecifier | (() => undefined | CCSupplierOrderContactKeySpecifier),
		fields?: CCSupplierOrderContactFieldPolicy,
	},
	CCSupplierOrderPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSupplierOrderPagedKeySpecifier | (() => undefined | CCSupplierOrderPagedKeySpecifier),
		fields?: CCSupplierOrderPagedFieldPolicy,
	},
	CCSupplierOrderReferenceFieldOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSupplierOrderReferenceFieldOptionKeySpecifier | (() => undefined | CCSupplierOrderReferenceFieldOptionKeySpecifier),
		fields?: CCSupplierOrderReferenceFieldOptionFieldPolicy,
	},
	CCSupplierOrderReferenceFieldValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSupplierOrderReferenceFieldValueKeySpecifier | (() => undefined | CCSupplierOrderReferenceFieldValueKeySpecifier),
		fields?: CCSupplierOrderReferenceFieldValueFieldPolicy,
	},
	CCSupplierOrderStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCSupplierOrderStatusKeySpecifier | (() => undefined | CCSupplierOrderStatusKeySpecifier),
		fields?: CCSupplierOrderStatusFieldPolicy,
	},
	CCTeam?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCTeamKeySpecifier | (() => undefined | CCTeamKeySpecifier),
		fields?: CCTeamFieldPolicy,
	},
	CCTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCTransactionKeySpecifier | (() => undefined | CCTransactionKeySpecifier),
		fields?: CCTransactionFieldPolicy,
	},
	CCTransactionsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCTransactionsPagedKeySpecifier | (() => undefined | CCTransactionsPagedKeySpecifier),
		fields?: CCTransactionsPagedFieldPolicy,
	},
	CCUserOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCUserOrderKeySpecifier | (() => undefined | CCUserOrderKeySpecifier),
		fields?: CCUserOrderFieldPolicy,
	},
	CCUserOrdersPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCUserOrdersPagedKeySpecifier | (() => undefined | CCUserOrdersPagedKeySpecifier),
		fields?: CCUserOrdersPagedFieldPolicy,
	},
	CCVendorMenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCVendorMenuKeySpecifier | (() => undefined | CCVendorMenuKeySpecifier),
		fields?: CCVendorMenuFieldPolicy,
	},
	CCVendorMenuItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCVendorMenuItemsKeySpecifier | (() => undefined | CCVendorMenuItemsKeySpecifier),
		fields?: CCVendorMenuItemsFieldPolicy,
	},
	CCVendorMenuItemsStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CCVendorMenuItemsStatsKeySpecifier | (() => undefined | CCVendorMenuItemsStatsKeySpecifier),
		fields?: CCVendorMenuItemsStatsFieldPolicy,
	},
	CaterdeskApiAccountAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaterdeskApiAccountAccessKeySpecifier | (() => undefined | CaterdeskApiAccountAccessKeySpecifier),
		fields?: CaterdeskApiAccountAccessFieldPolicy,
	},
	CaterdeskApiScope?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaterdeskApiScopeKeySpecifier | (() => undefined | CaterdeskApiScopeKeySpecifier),
		fields?: CaterdeskApiScopeFieldPolicy,
	},
	CaterdeskApiScopeResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaterdeskApiScopeResponseKeySpecifier | (() => undefined | CaterdeskApiScopeResponseKeySpecifier),
		fields?: CaterdeskApiScopeResponseFieldPolicy,
	},
	CaterdeskApiSetPasswordResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaterdeskApiSetPasswordResponseKeySpecifier | (() => undefined | CaterdeskApiSetPasswordResponseKeySpecifier),
		fields?: CaterdeskApiSetPasswordResponseFieldPolicy,
	},
	CaterdeskApiUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaterdeskApiUserKeySpecifier | (() => undefined | CaterdeskApiUserKeySpecifier),
		fields?: CaterdeskApiUserFieldPolicy,
	},
	CaterdeskApiUserResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaterdeskApiUserResponseKeySpecifier | (() => undefined | CaterdeskApiUserResponseKeySpecifier),
		fields?: CaterdeskApiUserResponseFieldPolicy,
	},
	CaterdeskApiUserScope?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaterdeskApiUserScopeKeySpecifier | (() => undefined | CaterdeskApiUserScopeKeySpecifier),
		fields?: CaterdeskApiUserScopeFieldPolicy,
	},
	CaterdeskApiUsersPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaterdeskApiUsersPagedKeySpecifier | (() => undefined | CaterdeskApiUsersPagedKeySpecifier),
		fields?: CaterdeskApiUsersPagedFieldPolicy,
	},
	CaterdeskApiVendorAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaterdeskApiVendorAccessKeySpecifier | (() => undefined | CaterdeskApiVendorAccessKeySpecifier),
		fields?: CaterdeskApiVendorAccessFieldPolicy,
	},
	CateringMenuComposition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CateringMenuCompositionKeySpecifier | (() => undefined | CateringMenuCompositionKeySpecifier),
		fields?: CateringMenuCompositionFieldPolicy,
	},
	CcOrderTaxBreakdown?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcOrderTaxBreakdownKeySpecifier | (() => undefined | CcOrderTaxBreakdownKeySpecifier),
		fields?: CcOrderTaxBreakdownFieldPolicy,
	},
	CcOrderTaxRateTotal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcOrderTaxRateTotalKeySpecifier | (() => undefined | CcOrderTaxRateTotalKeySpecifier),
		fields?: CcOrderTaxRateTotalFieldPolicy,
	},
	CcWeeklyReminderEligibleSite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcWeeklyReminderEligibleSiteKeySpecifier | (() => undefined | CcWeeklyReminderEligibleSiteKeySpecifier),
		fields?: CcWeeklyReminderEligibleSiteFieldPolicy,
	},
	CcWeeklyReminderEmailOutcome?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcWeeklyReminderEmailOutcomeKeySpecifier | (() => undefined | CcWeeklyReminderEmailOutcomeKeySpecifier),
		fields?: CcWeeklyReminderEmailOutcomeFieldPolicy,
	},
	CcWeeklyReminderExcludedLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcWeeklyReminderExcludedLocationKeySpecifier | (() => undefined | CcWeeklyReminderExcludedLocationKeySpecifier),
		fields?: CcWeeklyReminderExcludedLocationFieldPolicy,
	},
	CcWeeklyReminderLocationDelivery?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcWeeklyReminderLocationDeliveryKeySpecifier | (() => undefined | CcWeeklyReminderLocationDeliveryKeySpecifier),
		fields?: CcWeeklyReminderLocationDeliveryFieldPolicy,
	},
	CcWeeklyReminderLocationFailure?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcWeeklyReminderLocationFailureKeySpecifier | (() => undefined | CcWeeklyReminderLocationFailureKeySpecifier),
		fields?: CcWeeklyReminderLocationFailureFieldPolicy,
	},
	CcWeeklyReminderMenuLoadFailure?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcWeeklyReminderMenuLoadFailureKeySpecifier | (() => undefined | CcWeeklyReminderMenuLoadFailureKeySpecifier),
		fields?: CcWeeklyReminderMenuLoadFailureFieldPolicy,
	},
	CcWeeklyReminderPushOutcome?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcWeeklyReminderPushOutcomeKeySpecifier | (() => undefined | CcWeeklyReminderPushOutcomeKeySpecifier),
		fields?: CcWeeklyReminderPushOutcomeFieldPolicy,
	},
	CcWeeklyReminderReadyLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcWeeklyReminderReadyLocationKeySpecifier | (() => undefined | CcWeeklyReminderReadyLocationKeySpecifier),
		fields?: CcWeeklyReminderReadyLocationFieldPolicy,
	},
	CcWeeklyReminderReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcWeeklyReminderReportKeySpecifier | (() => undefined | CcWeeklyReminderReportKeySpecifier),
		fields?: CcWeeklyReminderReportFieldPolicy,
	},
	CcWeeklyReminderRun?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcWeeklyReminderRunKeySpecifier | (() => undefined | CcWeeklyReminderRunKeySpecifier),
		fields?: CcWeeklyReminderRunFieldPolicy,
	},
	CcWeeklyReminderSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcWeeklyReminderSummaryKeySpecifier | (() => undefined | CcWeeklyReminderSummaryKeySpecifier),
		fields?: CcWeeklyReminderSummaryFieldPolicy,
	},
	City?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CityKeySpecifier | (() => undefined | CityKeySpecifier),
		fields?: CityFieldPolicy,
	},
	ClosestItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClosestItemKeySpecifier | (() => undefined | ClosestItemKeySpecifier),
		fields?: ClosestItemFieldPolicy,
	},
	ClosestMatchingSupplierLocationsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClosestMatchingSupplierLocationsResponseKeySpecifier | (() => undefined | ClosestMatchingSupplierLocationsResponseKeySpecifier),
		fields?: ClosestMatchingSupplierLocationsResponseFieldPolicy,
	},
	ConsolidateFlexInvoiceResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConsolidateFlexInvoiceResultKeySpecifier | (() => undefined | ConsolidateFlexInvoiceResultKeySpecifier),
		fields?: ConsolidateFlexInvoiceResultFieldPolicy,
	},
	ConsolidateFlexInvoiceResultCustomer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConsolidateFlexInvoiceResultCustomerKeySpecifier | (() => undefined | ConsolidateFlexInvoiceResultCustomerKeySpecifier),
		fields?: ConsolidateFlexInvoiceResultCustomerFieldPolicy,
	},
	ConsolidateFlexInvoiceResultSupplier?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConsolidateFlexInvoiceResultSupplierKeySpecifier | (() => undefined | ConsolidateFlexInvoiceResultSupplierKeySpecifier),
		fields?: ConsolidateFlexInvoiceResultSupplierFieldPolicy,
	},
	Country?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountryKeySpecifier | (() => undefined | CountryKeySpecifier),
		fields?: CountryFieldPolicy,
	},
	Coupon?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CouponKeySpecifier | (() => undefined | CouponKeySpecifier),
		fields?: CouponFieldPolicy,
	},
	CouponUsesPerUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CouponUsesPerUserKeySpecifier | (() => undefined | CouponUsesPerUserKeySpecifier),
		fields?: CouponUsesPerUserFieldPolicy,
	},
	CouponsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CouponsPagedKeySpecifier | (() => undefined | CouponsPagedKeySpecifier),
		fields?: CouponsPagedFieldPolicy,
	},
	CreditCardFeeFlag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreditCardFeeFlagKeySpecifier | (() => undefined | CreditCardFeeFlagKeySpecifier),
		fields?: CreditCardFeeFlagFieldPolicy,
	},
	CreditTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreditTransactionKeySpecifier | (() => undefined | CreditTransactionKeySpecifier),
		fields?: CreditTransactionFieldPolicy,
	},
	CreditTransactionsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreditTransactionsPagedKeySpecifier | (() => undefined | CreditTransactionsPagedKeySpecifier),
		fields?: CreditTransactionsPagedFieldPolicy,
	},
	CustomerOrderAmountAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrderAmountAggregateKeySpecifier | (() => undefined | CustomerOrderAmountAggregateKeySpecifier),
		fields?: CustomerOrderAmountAggregateFieldPolicy,
	},
	CustomerOrderCityAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrderCityAggregateKeySpecifier | (() => undefined | CustomerOrderCityAggregateKeySpecifier),
		fields?: CustomerOrderCityAggregateFieldPolicy,
	},
	CustomerOrderItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrderItemKeySpecifier | (() => undefined | CustomerOrderItemKeySpecifier),
		fields?: CustomerOrderItemFieldPolicy,
	},
	CustomerOrderLocationAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrderLocationAggregateKeySpecifier | (() => undefined | CustomerOrderLocationAggregateKeySpecifier),
		fields?: CustomerOrderLocationAggregateFieldPolicy,
	},
	CustomerOrderOwnershipAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrderOwnershipAggregateKeySpecifier | (() => undefined | CustomerOrderOwnershipAggregateKeySpecifier),
		fields?: CustomerOrderOwnershipAggregateFieldPolicy,
	},
	CustomerOrderPostcodeAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrderPostcodeAggregateKeySpecifier | (() => undefined | CustomerOrderPostcodeAggregateKeySpecifier),
		fields?: CustomerOrderPostcodeAggregateFieldPolicy,
	},
	CustomerOrderResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrderResultKeySpecifier | (() => undefined | CustomerOrderResultKeySpecifier),
		fields?: CustomerOrderResultFieldPolicy,
	},
	CustomerOrderServiceTypeAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrderServiceTypeAggregateKeySpecifier | (() => undefined | CustomerOrderServiceTypeAggregateKeySpecifier),
		fields?: CustomerOrderServiceTypeAggregateFieldPolicy,
	},
	CustomerOrderTotals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrderTotalsKeySpecifier | (() => undefined | CustomerOrderTotalsKeySpecifier),
		fields?: CustomerOrderTotalsFieldPolicy,
	},
	CustomerOrderUserAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrderUserAggregateKeySpecifier | (() => undefined | CustomerOrderUserAggregateKeySpecifier),
		fields?: CustomerOrderUserAggregateFieldPolicy,
	},
	CustomerOrderVendorAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrderVendorAggregateKeySpecifier | (() => undefined | CustomerOrderVendorAggregateKeySpecifier),
		fields?: CustomerOrderVendorAggregateFieldPolicy,
	},
	CustomerOrdersAllType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrdersAllTypeKeySpecifier | (() => undefined | CustomerOrdersAllTypeKeySpecifier),
		fields?: CustomerOrdersAllTypeFieldPolicy,
	},
	CustomerOrdersAllTypePaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrdersAllTypePagedKeySpecifier | (() => undefined | CustomerOrdersAllTypePagedKeySpecifier),
		fields?: CustomerOrdersAllTypePagedFieldPolicy,
	},
	CustomerOrdersAllTypeWithFlexData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrdersAllTypeWithFlexDataKeySpecifier | (() => undefined | CustomerOrdersAllTypeWithFlexDataKeySpecifier),
		fields?: CustomerOrdersAllTypeWithFlexDataFieldPolicy,
	},
	CustomerOrdersReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrdersReportKeySpecifier | (() => undefined | CustomerOrdersReportKeySpecifier),
		fields?: CustomerOrdersReportFieldPolicy,
	},
	CustomerOrdersSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerOrdersSummaryKeySpecifier | (() => undefined | CustomerOrdersSummaryKeySpecifier),
		fields?: CustomerOrdersSummaryFieldPolicy,
	},
	CustomerPriceItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerPriceItemKeySpecifier | (() => undefined | CustomerPriceItemKeySpecifier),
		fields?: CustomerPriceItemFieldPolicy,
	},
	DeleteAccountLocationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteAccountLocationResultKeySpecifier | (() => undefined | DeleteAccountLocationResultKeySpecifier),
		fields?: DeleteAccountLocationResultFieldPolicy,
	},
	DeleteCCTeamResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCCTeamResultKeySpecifier | (() => undefined | DeleteCCTeamResultKeySpecifier),
		fields?: DeleteCCTeamResultFieldPolicy,
	},
	DeleteMenuItemsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteMenuItemsResponseKeySpecifier | (() => undefined | DeleteMenuItemsResponseKeySpecifier),
		fields?: DeleteMenuItemsResponseFieldPolicy,
	},
	DeliveryDocketPdfResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryDocketPdfResponseKeySpecifier | (() => undefined | DeliveryDocketPdfResponseKeySpecifier),
		fields?: DeliveryDocketPdfResponseFieldPolicy,
	},
	DeliveryFee?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryFeeKeySpecifier | (() => undefined | DeliveryFeeKeySpecifier),
		fields?: DeliveryFeeFieldPolicy,
	},
	DeliveryPartner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryPartnerKeySpecifier | (() => undefined | DeliveryPartnerKeySpecifier),
		fields?: DeliveryPartnerFieldPolicy,
	},
	DeliveryRegion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryRegionKeySpecifier | (() => undefined | DeliveryRegionKeySpecifier),
		fields?: DeliveryRegionFieldPolicy,
	},
	DietaryStat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DietaryStatKeySpecifier | (() => undefined | DietaryStatKeySpecifier),
		fields?: DietaryStatFieldPolicy,
	},
	EmmaAlgorithmResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaAlgorithmResponseKeySpecifier | (() => undefined | EmmaAlgorithmResponseKeySpecifier),
		fields?: EmmaAlgorithmResponseFieldPolicy,
	},
	EmmaAlgorithmResponsePaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaAlgorithmResponsePagedKeySpecifier | (() => undefined | EmmaAlgorithmResponsePagedKeySpecifier),
		fields?: EmmaAlgorithmResponsePagedFieldPolicy,
	},
	EmmaAllergensMatch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaAllergensMatchKeySpecifier | (() => undefined | EmmaAllergensMatchKeySpecifier),
		fields?: EmmaAllergensMatchFieldPolicy,
	},
	EmmaAutomation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaAutomationKeySpecifier | (() => undefined | EmmaAutomationKeySpecifier),
		fields?: EmmaAutomationFieldPolicy,
	},
	EmmaAutomationTracking?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaAutomationTrackingKeySpecifier | (() => undefined | EmmaAutomationTrackingKeySpecifier),
		fields?: EmmaAutomationTrackingFieldPolicy,
	},
	EmmaAutomationTriggerPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaAutomationTriggerPriceKeySpecifier | (() => undefined | EmmaAutomationTriggerPriceKeySpecifier),
		fields?: EmmaAutomationTriggerPriceFieldPolicy,
	},
	EmmaAutomationTriggers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaAutomationTriggersKeySpecifier | (() => undefined | EmmaAutomationTriggersKeySpecifier),
		fields?: EmmaAutomationTriggersFieldPolicy,
	},
	EmmaBasket?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaBasketKeySpecifier | (() => undefined | EmmaBasketKeySpecifier),
		fields?: EmmaBasketFieldPolicy,
	},
	EmmaBriefingAllergens?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaBriefingAllergensKeySpecifier | (() => undefined | EmmaBriefingAllergensKeySpecifier),
		fields?: EmmaBriefingAllergensFieldPolicy,
	},
	EmmaBriefingBudget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaBriefingBudgetKeySpecifier | (() => undefined | EmmaBriefingBudgetKeySpecifier),
		fields?: EmmaBriefingBudgetFieldPolicy,
	},
	EmmaBriefingDietaries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaBriefingDietariesKeySpecifier | (() => undefined | EmmaBriefingDietariesKeySpecifier),
		fields?: EmmaBriefingDietariesFieldPolicy,
	},
	EmmaBriefingType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaBriefingTypeKeySpecifier | (() => undefined | EmmaBriefingTypeKeySpecifier),
		fields?: EmmaBriefingTypeFieldPolicy,
	},
	EmmaCategoriseItemResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaCategoriseItemResponseKeySpecifier | (() => undefined | EmmaCategoriseItemResponseKeySpecifier),
		fields?: EmmaCategoriseItemResponseFieldPolicy,
	},
	EmmaCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaCategoryKeySpecifier | (() => undefined | EmmaCategoryKeySpecifier),
		fields?: EmmaCategoryFieldPolicy,
	},
	EmmaCoveringAllergens?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaCoveringAllergensKeySpecifier | (() => undefined | EmmaCoveringAllergensKeySpecifier),
		fields?: EmmaCoveringAllergensFieldPolicy,
	},
	EmmaCoveringDietaries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaCoveringDietariesKeySpecifier | (() => undefined | EmmaCoveringDietariesKeySpecifier),
		fields?: EmmaCoveringDietariesFieldPolicy,
	},
	EmmaDietariesMatch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaDietariesMatchKeySpecifier | (() => undefined | EmmaDietariesMatchKeySpecifier),
		fields?: EmmaDietariesMatchFieldPolicy,
	},
	EmmaFormAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaFormAddressKeySpecifier | (() => undefined | EmmaFormAddressKeySpecifier),
		fields?: EmmaFormAddressFieldPolicy,
	},
	EmmaFormAllergen?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaFormAllergenKeySpecifier | (() => undefined | EmmaFormAllergenKeySpecifier),
		fields?: EmmaFormAllergenFieldPolicy,
	},
	EmmaFormContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaFormContactKeySpecifier | (() => undefined | EmmaFormContactKeySpecifier),
		fields?: EmmaFormContactFieldPolicy,
	},
	EmmaFormDietaryRequirement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaFormDietaryRequirementKeySpecifier | (() => undefined | EmmaFormDietaryRequirementKeySpecifier),
		fields?: EmmaFormDietaryRequirementFieldPolicy,
	},
	EmmaFormResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaFormResponseKeySpecifier | (() => undefined | EmmaFormResponseKeySpecifier),
		fields?: EmmaFormResponseFieldPolicy,
	},
	EmmaFormResponseAdminUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaFormResponseAdminUserKeySpecifier | (() => undefined | EmmaFormResponseAdminUserKeySpecifier),
		fields?: EmmaFormResponseAdminUserFieldPolicy,
	},
	EmmaFormResponsePaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaFormResponsePagedKeySpecifier | (() => undefined | EmmaFormResponsePagedKeySpecifier),
		fields?: EmmaFormResponsePagedFieldPolicy,
	},
	EmmaFormSubmissionResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaFormSubmissionResponseKeySpecifier | (() => undefined | EmmaFormSubmissionResponseKeySpecifier),
		fields?: EmmaFormSubmissionResponseFieldPolicy,
	},
	EmmaItemGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaItemGroupKeySpecifier | (() => undefined | EmmaItemGroupKeySpecifier),
		fields?: EmmaItemGroupFieldPolicy,
	},
	EmmaItemLevelMatching?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaItemLevelMatchingKeySpecifier | (() => undefined | EmmaItemLevelMatchingKeySpecifier),
		fields?: EmmaItemLevelMatchingFieldPolicy,
	},
	EmmaMenuItemType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaMenuItemTypeKeySpecifier | (() => undefined | EmmaMenuItemTypeKeySpecifier),
		fields?: EmmaMenuItemTypeFieldPolicy,
	},
	EmmaOccasion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaOccasionKeySpecifier | (() => undefined | EmmaOccasionKeySpecifier),
		fields?: EmmaOccasionFieldPolicy,
	},
	EmmaOccasionRanking?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaOccasionRankingKeySpecifier | (() => undefined | EmmaOccasionRankingKeySpecifier),
		fields?: EmmaOccasionRankingFieldPolicy,
	},
	EmmaRecipe?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaRecipeKeySpecifier | (() => undefined | EmmaRecipeKeySpecifier),
		fields?: EmmaRecipeFieldPolicy,
	},
	EmmaRecipeGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaRecipeGroupKeySpecifier | (() => undefined | EmmaRecipeGroupKeySpecifier),
		fields?: EmmaRecipeGroupFieldPolicy,
	},
	EmmaTestData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmmaTestDataKeySpecifier | (() => undefined | EmmaTestDataKeySpecifier),
		fields?: EmmaTestDataFieldPolicy,
	},
	FilterStatTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FilterStatTagKeySpecifier | (() => undefined | FilterStatTagKeySpecifier),
		fields?: FilterStatTagFieldPolicy,
	},
	FlagImageUri?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FlagImageUriKeySpecifier | (() => undefined | FlagImageUriKeySpecifier),
		fields?: FlagImageUriFieldPolicy,
	},
	FlexConsolidationRunStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FlexConsolidationRunStatusKeySpecifier | (() => undefined | FlexConsolidationRunStatusKeySpecifier),
		fields?: FlexConsolidationRunStatusFieldPolicy,
	},
	FlexInvoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FlexInvoiceKeySpecifier | (() => undefined | FlexInvoiceKeySpecifier),
		fields?: FlexInvoiceFieldPolicy,
	},
	FlexInvoiceAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FlexInvoiceAccountKeySpecifier | (() => undefined | FlexInvoiceAccountKeySpecifier),
		fields?: FlexInvoiceAccountFieldPolicy,
	},
	FlexInvoiceAllTypes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FlexInvoiceAllTypesKeySpecifier | (() => undefined | FlexInvoiceAllTypesKeySpecifier),
		fields?: FlexInvoiceAllTypesFieldPolicy,
	},
	FlexInvoiceAllTypesPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FlexInvoiceAllTypesPagedKeySpecifier | (() => undefined | FlexInvoiceAllTypesPagedKeySpecifier),
		fields?: FlexInvoiceAllTypesPagedFieldPolicy,
	},
	FlexInvoiceAsset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FlexInvoiceAssetKeySpecifier | (() => undefined | FlexInvoiceAssetKeySpecifier),
		fields?: FlexInvoiceAssetFieldPolicy,
	},
	FlexInvoicesPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FlexInvoicesPagedKeySpecifier | (() => undefined | FlexInvoicesPagedKeySpecifier),
		fields?: FlexInvoicesPagedFieldPolicy,
	},
	FlexInvoicingClient?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FlexInvoicingClientKeySpecifier | (() => undefined | FlexInvoicingClientKeySpecifier),
		fields?: FlexInvoicingClientFieldPolicy,
	},
	FlexInvoicingFlags?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FlexInvoicingFlagsKeySpecifier | (() => undefined | FlexInvoicingFlagsKeySpecifier),
		fields?: FlexInvoicingFlagsFieldPolicy,
	},
	FlexInvoicingPaymentSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FlexInvoicingPaymentSettingsKeySpecifier | (() => undefined | FlexInvoicingPaymentSettingsKeySpecifier),
		fields?: FlexInvoicingPaymentSettingsFieldPolicy,
	},
	GLCodeServiceTypeOverride?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GLCodeServiceTypeOverrideKeySpecifier | (() => undefined | GLCodeServiceTypeOverrideKeySpecifier),
		fields?: GLCodeServiceTypeOverrideFieldPolicy,
	},
	GLCodes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GLCodesKeySpecifier | (() => undefined | GLCodesKeySpecifier),
		fields?: GLCodesFieldPolicy,
	},
	GMAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GMAccountKeySpecifier | (() => undefined | GMAccountKeySpecifier),
		fields?: GMAccountFieldPolicy,
	},
	GMAccountLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GMAccountLocationKeySpecifier | (() => undefined | GMAccountLocationKeySpecifier),
		fields?: GMAccountLocationFieldPolicy,
	},
	GMInvoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GMInvoiceKeySpecifier | (() => undefined | GMInvoiceKeySpecifier),
		fields?: GMInvoiceFieldPolicy,
	},
	GMServiceAddons?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GMServiceAddonsKeySpecifier | (() => undefined | GMServiceAddonsKeySpecifier),
		fields?: GMServiceAddonsFieldPolicy,
	},
	GMServiceNotes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GMServiceNotesKeySpecifier | (() => undefined | GMServiceNotesKeySpecifier),
		fields?: GMServiceNotesFieldPolicy,
	},
	GMServiceOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GMServiceOptionsKeySpecifier | (() => undefined | GMServiceOptionsKeySpecifier),
		fields?: GMServiceOptionsFieldPolicy,
	},
	GMSupplierOrderBreakdown?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GMSupplierOrderBreakdownKeySpecifier | (() => undefined | GMSupplierOrderBreakdownKeySpecifier),
		fields?: GMSupplierOrderBreakdownFieldPolicy,
	},
	GMSupplierOrderBreakdownPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GMSupplierOrderBreakdownPagedKeySpecifier | (() => undefined | GMSupplierOrderBreakdownPagedKeySpecifier),
		fields?: GMSupplierOrderBreakdownPagedFieldPolicy,
	},
	GMSupplierOrderBreakdownVat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GMSupplierOrderBreakdownVatKeySpecifier | (() => undefined | GMSupplierOrderBreakdownVatKeySpecifier),
		fields?: GMSupplierOrderBreakdownVatFieldPolicy,
	},
	GeocodeContext?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GeocodeContextKeySpecifier | (() => undefined | GeocodeContextKeySpecifier),
		fields?: GeocodeContextFieldPolicy,
	},
	GmAvailability?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmAvailabilityKeySpecifier | (() => undefined | GmAvailabilityKeySpecifier),
		fields?: GmAvailabilityFieldPolicy,
	},
	GmBasket?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmBasketKeySpecifier | (() => undefined | GmBasketKeySpecifier),
		fields?: GmBasketFieldPolicy,
	},
	GmBasketCheckoutRestrictions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmBasketCheckoutRestrictionsKeySpecifier | (() => undefined | GmBasketCheckoutRestrictionsKeySpecifier),
		fields?: GmBasketCheckoutRestrictionsFieldPolicy,
	},
	GmBasketContributor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmBasketContributorKeySpecifier | (() => undefined | GmBasketContributorKeySpecifier),
		fields?: GmBasketContributorFieldPolicy,
	},
	GmBasketCustomItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmBasketCustomItemKeySpecifier | (() => undefined | GmBasketCustomItemKeySpecifier),
		fields?: GmBasketCustomItemFieldPolicy,
	},
	GmBasketPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmBasketPagedKeySpecifier | (() => undefined | GmBasketPagedKeySpecifier),
		fields?: GmBasketPagedFieldPolicy,
	},
	GmCheckoutErrors?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmCheckoutErrorsKeySpecifier | (() => undefined | GmCheckoutErrorsKeySpecifier),
		fields?: GmCheckoutErrorsFieldPolicy,
	},
	GmIssue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmIssueKeySpecifier | (() => undefined | GmIssueKeySpecifier),
		fields?: GmIssueFieldPolicy,
	},
	GmIssuesPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmIssuesPagedKeySpecifier | (() => undefined | GmIssuesPagedKeySpecifier),
		fields?: GmIssuesPagedFieldPolicy,
	},
	GmItemSearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmItemSearchResultKeySpecifier | (() => undefined | GmItemSearchResultKeySpecifier),
		fields?: GmItemSearchResultFieldPolicy,
	},
	GmMenuCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmMenuCategoryKeySpecifier | (() => undefined | GmMenuCategoryKeySpecifier),
		fields?: GmMenuCategoryFieldPolicy,
	},
	GmMenuItemStat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmMenuItemStatKeySpecifier | (() => undefined | GmMenuItemStatKeySpecifier),
		fields?: GmMenuItemStatFieldPolicy,
	},
	GmMenuItemStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmMenuItemStatsKeySpecifier | (() => undefined | GmMenuItemStatsKeySpecifier),
		fields?: GmMenuItemStatsFieldPolicy,
	},
	GmMenuItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmMenuItemsKeySpecifier | (() => undefined | GmMenuItemsKeySpecifier),
		fields?: GmMenuItemsFieldPolicy,
	},
	GmOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderKeySpecifier | (() => undefined | GmOrderKeySpecifier),
		fields?: GmOrderFieldPolicy,
	},
	GmOrderBankAccountData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderBankAccountDataKeySpecifier | (() => undefined | GmOrderBankAccountDataKeySpecifier),
		fields?: GmOrderBankAccountDataFieldPolicy,
	},
	GmOrderFeeBreakdown?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderFeeBreakdownKeySpecifier | (() => undefined | GmOrderFeeBreakdownKeySpecifier),
		fields?: GmOrderFeeBreakdownFieldPolicy,
	},
	GmOrderInvoicingData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderInvoicingDataKeySpecifier | (() => undefined | GmOrderInvoicingDataKeySpecifier),
		fields?: GmOrderInvoicingDataFieldPolicy,
	},
	GmOrderItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderItemKeySpecifier | (() => undefined | GmOrderItemKeySpecifier),
		fields?: GmOrderItemFieldPolicy,
	},
	GmOrderItemOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderItemOptionKeySpecifier | (() => undefined | GmOrderItemOptionKeySpecifier),
		fields?: GmOrderItemOptionFieldPolicy,
	},
	GmOrderItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderItemsKeySpecifier | (() => undefined | GmOrderItemsKeySpecifier),
		fields?: GmOrderItemsFieldPolicy,
	},
	GmOrderLite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderLiteKeySpecifier | (() => undefined | GmOrderLiteKeySpecifier),
		fields?: GmOrderLiteFieldPolicy,
	},
	GmOrderPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderPagedKeySpecifier | (() => undefined | GmOrderPagedKeySpecifier),
		fields?: GmOrderPagedFieldPolicy,
	},
	GmOrderPaymentInstructions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderPaymentInstructionsKeySpecifier | (() => undefined | GmOrderPaymentInstructionsKeySpecifier),
		fields?: GmOrderPaymentInstructionsFieldPolicy,
	},
	GmOrderPdfResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderPdfResponseKeySpecifier | (() => undefined | GmOrderPdfResponseKeySpecifier),
		fields?: GmOrderPdfResponseFieldPolicy,
	},
	GmOrderStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderStatusKeySpecifier | (() => undefined | GmOrderStatusKeySpecifier),
		fields?: GmOrderStatusFieldPolicy,
	},
	GmOrderTaxBreakdown?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderTaxBreakdownKeySpecifier | (() => undefined | GmOrderTaxBreakdownKeySpecifier),
		fields?: GmOrderTaxBreakdownFieldPolicy,
	},
	GmOrderTaxRateTotal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmOrderTaxRateTotalKeySpecifier | (() => undefined | GmOrderTaxRateTotalKeySpecifier),
		fields?: GmOrderTaxRateTotalFieldPolicy,
	},
	GmReferenceFieldOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmReferenceFieldOptionKeySpecifier | (() => undefined | GmReferenceFieldOptionKeySpecifier),
		fields?: GmReferenceFieldOptionFieldPolicy,
	},
	GmReferenceFieldValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmReferenceFieldValueKeySpecifier | (() => undefined | GmReferenceFieldValueKeySpecifier),
		fields?: GmReferenceFieldValueFieldPolicy,
	},
	GmRefund?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmRefundKeySpecifier | (() => undefined | GmRefundKeySpecifier),
		fields?: GmRefundFieldPolicy,
	},
	GmServiceLogistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmServiceLogisticsKeySpecifier | (() => undefined | GmServiceLogisticsKeySpecifier),
		fields?: GmServiceLogisticsFieldPolicy,
	},
	GmServiceSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmServiceSettingsKeySpecifier | (() => undefined | GmServiceSettingsKeySpecifier),
		fields?: GmServiceSettingsFieldPolicy,
	},
	GmValidationError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmValidationErrorKeySpecifier | (() => undefined | GmValidationErrorKeySpecifier),
		fields?: GmValidationErrorFieldPolicy,
	},
	GmVendorCharge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GmVendorChargeKeySpecifier | (() => undefined | GmVendorChargeKeySpecifier),
		fields?: GmVendorChargeFieldPolicy,
	},
	GoogleGeocode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GoogleGeocodeKeySpecifier | (() => undefined | GoogleGeocodeKeySpecifier),
		fields?: GoogleGeocodeFieldPolicy,
	},
	GoogleGeometry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GoogleGeometryKeySpecifier | (() => undefined | GoogleGeometryKeySpecifier),
		fields?: GoogleGeometryFieldPolicy,
	},
	GroupedCCOrderItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupedCCOrderItemKeySpecifier | (() => undefined | GroupedCCOrderItemKeySpecifier),
		fields?: GroupedCCOrderItemFieldPolicy,
	},
	GroupedCCOrderItemsByVendor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupedCCOrderItemsByVendorKeySpecifier | (() => undefined | GroupedCCOrderItemsByVendorKeySpecifier),
		fields?: GroupedCCOrderItemsByVendorFieldPolicy,
	},
	HeadCountRanges?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeadCountRangesKeySpecifier | (() => undefined | HeadCountRangesKeySpecifier),
		fields?: HeadCountRangesFieldPolicy,
	},
	InitiateCCOrderResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InitiateCCOrderResponseKeySpecifier | (() => undefined | InitiateCCOrderResponseKeySpecifier),
		fields?: InitiateCCOrderResponseFieldPolicy,
	},
	InitiateInvoiceCardPaymentResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InitiateInvoiceCardPaymentResultKeySpecifier | (() => undefined | InitiateInvoiceCardPaymentResultKeySpecifier),
		fields?: InitiateInvoiceCardPaymentResultFieldPolicy,
	},
	InitiatePaymentResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InitiatePaymentResultKeySpecifier | (() => undefined | InitiatePaymentResultKeySpecifier),
		fields?: InitiatePaymentResultFieldPolicy,
	},
	Invoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceKeySpecifier | (() => undefined | InvoiceKeySpecifier),
		fields?: InvoiceFieldPolicy,
	},
	InvoiceAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceAccountKeySpecifier | (() => undefined | InvoiceAccountKeySpecifier),
		fields?: InvoiceAccountFieldPolicy,
	},
	InvoiceItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceItemKeySpecifier | (() => undefined | InvoiceItemKeySpecifier),
		fields?: InvoiceItemFieldPolicy,
	},
	InvoiceItemsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceItemsPagedKeySpecifier | (() => undefined | InvoiceItemsPagedKeySpecifier),
		fields?: InvoiceItemsPagedFieldPolicy,
	},
	InvoiceOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceOrderKeySpecifier | (() => undefined | InvoiceOrderKeySpecifier),
		fields?: InvoiceOrderFieldPolicy,
	},
	InvoiceOrderLineItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceOrderLineItemKeySpecifier | (() => undefined | InvoiceOrderLineItemKeySpecifier),
		fields?: InvoiceOrderLineItemFieldPolicy,
	},
	InvoiceOrderReferenceField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceOrderReferenceFieldKeySpecifier | (() => undefined | InvoiceOrderReferenceFieldKeySpecifier),
		fields?: InvoiceOrderReferenceFieldFieldPolicy,
	},
	InvoiceOrdersPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceOrdersPagedKeySpecifier | (() => undefined | InvoiceOrdersPagedKeySpecifier),
		fields?: InvoiceOrdersPagedFieldPolicy,
	},
	InvoicesCombinedPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoicesCombinedPagedKeySpecifier | (() => undefined | InvoicesCombinedPagedKeySpecifier),
		fields?: InvoicesCombinedPagedFieldPolicy,
	},
	InvoicesPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoicesPagedKeySpecifier | (() => undefined | InvoicesPagedKeySpecifier),
		fields?: InvoicesPagedFieldPolicy,
	},
	ItemSearchMatchingItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemSearchMatchingItemKeySpecifier | (() => undefined | ItemSearchMatchingItemKeySpecifier),
		fields?: ItemSearchMatchingItemFieldPolicy,
	},
	ItemSearchMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemSearchMetadataKeySpecifier | (() => undefined | ItemSearchMetadataKeySpecifier),
		fields?: ItemSearchMetadataFieldPolicy,
	},
	LanguageData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LanguageDataKeySpecifier | (() => undefined | LanguageDataKeySpecifier),
		fields?: LanguageDataFieldPolicy,
	},
	LineItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LineItemKeySpecifier | (() => undefined | LineItemKeySpecifier),
		fields?: LineItemFieldPolicy,
	},
	Location?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationKeySpecifier | (() => undefined | LocationKeySpecifier),
		fields?: LocationFieldPolicy,
	},
	LookupAddressResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LookupAddressResponseKeySpecifier | (() => undefined | LookupAddressResponseKeySpecifier),
		fields?: LookupAddressResponseFieldPolicy,
	},
	Margin?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarginKeySpecifier | (() => undefined | MarginKeySpecifier),
		fields?: MarginFieldPolicy,
	},
	MarkFlexInvoicesAsPaidResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarkFlexInvoicesAsPaidResultKeySpecifier | (() => undefined | MarkFlexInvoicesAsPaidResultKeySpecifier),
		fields?: MarkFlexInvoicesAsPaidResultFieldPolicy,
	},
	MarketplaceBanding?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarketplaceBandingKeySpecifier | (() => undefined | MarketplaceBandingKeySpecifier),
		fields?: MarketplaceBandingFieldPolicy,
	},
	MealTypes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MealTypesKeySpecifier | (() => undefined | MealTypesKeySpecifier),
		fields?: MealTypesFieldPolicy,
	},
	MenuCsvDownload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuCsvDownloadKeySpecifier | (() => undefined | MenuCsvDownloadKeySpecifier),
		fields?: MenuCsvDownloadFieldPolicy,
	},
	MenuItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemKeySpecifier | (() => undefined | MenuItemKeySpecifier),
		fields?: MenuItemFieldPolicy,
	},
	MenuItemCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemCategoryKeySpecifier | (() => undefined | MenuItemCategoryKeySpecifier),
		fields?: MenuItemCategoryFieldPolicy,
	},
	MenuItemGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemGroupKeySpecifier | (() => undefined | MenuItemGroupKeySpecifier),
		fields?: MenuItemGroupFieldPolicy,
	},
	MenuItemGroupSize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemGroupSizeKeySpecifier | (() => undefined | MenuItemGroupSizeKeySpecifier),
		fields?: MenuItemGroupSizeFieldPolicy,
	},
	MenuItemGroupsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemGroupsPagedKeySpecifier | (() => undefined | MenuItemGroupsPagedKeySpecifier),
		fields?: MenuItemGroupsPagedFieldPolicy,
	},
	MenuItemIncDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemIncDeletedKeySpecifier | (() => undefined | MenuItemIncDeletedKeySpecifier),
		fields?: MenuItemIncDeletedFieldPolicy,
	},
	MenuItemMeta?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemMetaKeySpecifier | (() => undefined | MenuItemMetaKeySpecifier),
		fields?: MenuItemMetaFieldPolicy,
	},
	MenuItemOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemOptionsKeySpecifier | (() => undefined | MenuItemOptionsKeySpecifier),
		fields?: MenuItemOptionsFieldPolicy,
	},
	MenuItemPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemPagedKeySpecifier | (() => undefined | MenuItemPagedKeySpecifier),
		fields?: MenuItemPagedFieldPolicy,
	},
	MenuItemPriceSyncStatusResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemPriceSyncStatusResponseKeySpecifier | (() => undefined | MenuItemPriceSyncStatusResponseKeySpecifier),
		fields?: MenuItemPriceSyncStatusResponseFieldPolicy,
	},
	MenuItemStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemStatisticsKeySpecifier | (() => undefined | MenuItemStatisticsKeySpecifier),
		fields?: MenuItemStatisticsFieldPolicy,
	},
	MenuItemSuitabilityOccasion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemSuitabilityOccasionKeySpecifier | (() => undefined | MenuItemSuitabilityOccasionKeySpecifier),
		fields?: MenuItemSuitabilityOccasionFieldPolicy,
	},
	MenuItemVariation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemVariationKeySpecifier | (() => undefined | MenuItemVariationKeySpecifier),
		fields?: MenuItemVariationFieldPolicy,
	},
	MenuItemsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemsPagedKeySpecifier | (() => undefined | MenuItemsPagedKeySpecifier),
		fields?: MenuItemsPagedFieldPolicy,
	},
	MenuStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuStatisticsKeySpecifier | (() => undefined | MenuStatisticsKeySpecifier),
		fields?: MenuStatisticsFieldPolicy,
	},
	MessageTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageTemplateKeySpecifier | (() => undefined | MessageTemplateKeySpecifier),
		fields?: MessageTemplateFieldPolicy,
	},
	MessageTemplatePaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageTemplatePagedKeySpecifier | (() => undefined | MessageTemplatePagedKeySpecifier),
		fields?: MessageTemplatePagedFieldPolicy,
	},
	ModifierCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ModifierCategoryKeySpecifier | (() => undefined | ModifierCategoryKeySpecifier),
		fields?: ModifierCategoryFieldPolicy,
	},
	ModifierCategoryMutationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ModifierCategoryMutationPayloadKeySpecifier | (() => undefined | ModifierCategoryMutationPayloadKeySpecifier),
		fields?: ModifierCategoryMutationPayloadFieldPolicy,
	},
	MoveInvoiceAccountResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoveInvoiceAccountResponseKeySpecifier | (() => undefined | MoveInvoiceAccountResponseKeySpecifier),
		fields?: MoveInvoiceAccountResponseFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	MyCaterdeskApiEntityAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MyCaterdeskApiEntityAccessKeySpecifier | (() => undefined | MyCaterdeskApiEntityAccessKeySpecifier),
		fields?: MyCaterdeskApiEntityAccessFieldPolicy,
	},
	MyCaterdeskApiUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MyCaterdeskApiUserKeySpecifier | (() => undefined | MyCaterdeskApiUserKeySpecifier),
		fields?: MyCaterdeskApiUserFieldPolicy,
	},
	NavLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavLinkKeySpecifier | (() => undefined | NavLinkKeySpecifier),
		fields?: NavLinkFieldPolicy,
	},
	NewAccountLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NewAccountLocationKeySpecifier | (() => undefined | NewAccountLocationKeySpecifier),
		fields?: NewAccountLocationFieldPolicy,
	},
	NewUserSignupResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NewUserSignupResponseKeySpecifier | (() => undefined | NewUserSignupResponseKeySpecifier),
		fields?: NewUserSignupResponseFieldPolicy,
	},
	NotificationEventEmail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationEventEmailKeySpecifier | (() => undefined | NotificationEventEmailKeySpecifier),
		fields?: NotificationEventEmailFieldPolicy,
	},
	NotificationEventEmailAttachment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationEventEmailAttachmentKeySpecifier | (() => undefined | NotificationEventEmailAttachmentKeySpecifier),
		fields?: NotificationEventEmailAttachmentFieldPolicy,
	},
	NotificationEventPush?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationEventPushKeySpecifier | (() => undefined | NotificationEventPushKeySpecifier),
		fields?: NotificationEventPushFieldPolicy,
	},
	OccasionDayMonth?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OccasionDayMonthKeySpecifier | (() => undefined | OccasionDayMonthKeySpecifier),
		fields?: OccasionDayMonthFieldPolicy,
	},
	OptionItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OptionItemKeySpecifier | (() => undefined | OptionItemKeySpecifier),
		fields?: OptionItemFieldPolicy,
	},
	OrderDeliveryUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderDeliveryUpdateKeySpecifier | (() => undefined | OrderDeliveryUpdateKeySpecifier),
		fields?: OrderDeliveryUpdateFieldPolicy,
	},
	OrderDeliveryUpdateDriver?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderDeliveryUpdateDriverKeySpecifier | (() => undefined | OrderDeliveryUpdateDriverKeySpecifier),
		fields?: OrderDeliveryUpdateDriverFieldPolicy,
	},
	OrderDeliveryUpdateDriverLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderDeliveryUpdateDriverLocationKeySpecifier | (() => undefined | OrderDeliveryUpdateDriverLocationKeySpecifier),
		fields?: OrderDeliveryUpdateDriverLocationFieldPolicy,
	},
	OrderReferenceField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderReferenceFieldKeySpecifier | (() => undefined | OrderReferenceFieldKeySpecifier),
		fields?: OrderReferenceFieldFieldPolicy,
	},
	OrderReferenceFieldOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderReferenceFieldOptionKeySpecifier | (() => undefined | OrderReferenceFieldOptionKeySpecifier),
		fields?: OrderReferenceFieldOptionFieldPolicy,
	},
	OrderReferenceFieldResolvedValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderReferenceFieldResolvedValueKeySpecifier | (() => undefined | OrderReferenceFieldResolvedValueKeySpecifier),
		fields?: OrderReferenceFieldResolvedValueFieldPolicy,
	},
	OrderSupplierTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderSupplierTagKeySpecifier | (() => undefined | OrderSupplierTagKeySpecifier),
		fields?: OrderSupplierTagFieldPolicy,
	},
	OrderTypeAmount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderTypeAmountKeySpecifier | (() => undefined | OrderTypeAmountKeySpecifier),
		fields?: OrderTypeAmountFieldPolicy,
	},
	OrdersReportResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrdersReportResultKeySpecifier | (() => undefined | OrdersReportResultKeySpecifier),
		fields?: OrdersReportResultFieldPolicy,
	},
	OrdersReportResultCC?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrdersReportResultCCKeySpecifier | (() => undefined | OrdersReportResultCCKeySpecifier),
		fields?: OrdersReportResultCCFieldPolicy,
	},
	OrdersReportResultGM?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrdersReportResultGMKeySpecifier | (() => undefined | OrdersReportResultGMKeySpecifier),
		fields?: OrdersReportResultGMFieldPolicy,
	},
	PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier),
		fields?: PageInfoFieldPolicy,
	},
	PayByCardResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayByCardResponseKeySpecifier | (() => undefined | PayByCardResponseKeySpecifier),
		fields?: PayByCardResponseFieldPolicy,
	},
	PayByInvoiceResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayByInvoiceResponseKeySpecifier | (() => undefined | PayByInvoiceResponseKeySpecifier),
		fields?: PayByInvoiceResponseFieldPolicy,
	},
	PayByTransferResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayByTransferResponseKeySpecifier | (() => undefined | PayByTransferResponseKeySpecifier),
		fields?: PayByTransferResponseFieldPolicy,
	},
	Payment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentKeySpecifier | (() => undefined | PaymentKeySpecifier),
		fields?: PaymentFieldPolicy,
	},
	PaymentAuthToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentAuthTokenKeySpecifier | (() => undefined | PaymentAuthTokenKeySpecifier),
		fields?: PaymentAuthTokenFieldPolicy,
	},
	PaymentCard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentCardKeySpecifier | (() => undefined | PaymentCardKeySpecifier),
		fields?: PaymentCardFieldPolicy,
	},
	PaymentHistory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentHistoryKeySpecifier | (() => undefined | PaymentHistoryKeySpecifier),
		fields?: PaymentHistoryFieldPolicy,
	},
	PlatformAlert?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlatformAlertKeySpecifier | (() => undefined | PlatformAlertKeySpecifier),
		fields?: PlatformAlertFieldPolicy,
	},
	PlatformAlertConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlatformAlertConnectionKeySpecifier | (() => undefined | PlatformAlertConnectionKeySpecifier),
		fields?: PlatformAlertConnectionFieldPolicy,
	},
	PlatformAlertPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlatformAlertPageInfoKeySpecifier | (() => undefined | PlatformAlertPageInfoKeySpecifier),
		fields?: PlatformAlertPageInfoFieldPolicy,
	},
	PopularItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PopularItemKeySpecifier | (() => undefined | PopularItemKeySpecifier),
		fields?: PopularItemFieldPolicy,
	},
	PriceLevels?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PriceLevelsKeySpecifier | (() => undefined | PriceLevelsKeySpecifier),
		fields?: PriceLevelsFieldPolicy,
	},
	PrivateSupplier?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrivateSupplierKeySpecifier | (() => undefined | PrivateSupplierKeySpecifier),
		fields?: PrivateSupplierFieldPolicy,
	},
	ProposedGmOrderTotals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProposedGmOrderTotalsKeySpecifier | (() => undefined | ProposedGmOrderTotalsKeySpecifier),
		fields?: ProposedGmOrderTotalsFieldPolicy,
	},
	PublishAllMenuItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublishAllMenuItemPayloadKeySpecifier | (() => undefined | PublishAllMenuItemPayloadKeySpecifier),
		fields?: PublishAllMenuItemPayloadFieldPolicy,
	},
	PublishMenuItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublishMenuItemPayloadKeySpecifier | (() => undefined | PublishMenuItemPayloadKeySpecifier),
		fields?: PublishMenuItemPayloadFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	QuoteCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuoteCollectionKeySpecifier | (() => undefined | QuoteCollectionKeySpecifier),
		fields?: QuoteCollectionFieldPolicy,
	},
	QuoteCollectionPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuoteCollectionPagedKeySpecifier | (() => undefined | QuoteCollectionPagedKeySpecifier),
		fields?: QuoteCollectionPagedFieldPolicy,
	},
	QuoteRequestBasket?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuoteRequestBasketKeySpecifier | (() => undefined | QuoteRequestBasketKeySpecifier),
		fields?: QuoteRequestBasketFieldPolicy,
	},
	QuoteRequestBasketSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuoteRequestBasketSettingsKeySpecifier | (() => undefined | QuoteRequestBasketSettingsKeySpecifier),
		fields?: QuoteRequestBasketSettingsFieldPolicy,
	},
	QuoteRequestBasketUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuoteRequestBasketUserKeySpecifier | (() => undefined | QuoteRequestBasketUserKeySpecifier),
		fields?: QuoteRequestBasketUserFieldPolicy,
	},
	ReferenceField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReferenceFieldKeySpecifier | (() => undefined | ReferenceFieldKeySpecifier),
		fields?: ReferenceFieldFieldPolicy,
	},
	ReferenceFieldOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReferenceFieldOptionKeySpecifier | (() => undefined | ReferenceFieldOptionKeySpecifier),
		fields?: ReferenceFieldOptionFieldPolicy,
	},
	ReferenceFieldsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReferenceFieldsPagedKeySpecifier | (() => undefined | ReferenceFieldsPagedKeySpecifier),
		fields?: ReferenceFieldsPagedFieldPolicy,
	},
	Refund?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefundKeySpecifier | (() => undefined | RefundKeySpecifier),
		fields?: RefundFieldPolicy,
	},
	RefundResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefundResultKeySpecifier | (() => undefined | RefundResultKeySpecifier),
		fields?: RefundResultFieldPolicy,
	},
	SendGridDomainStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendGridDomainStatusKeySpecifier | (() => undefined | SendGridDomainStatusKeySpecifier),
		fields?: SendGridDomainStatusFieldPolicy,
	},
	SendGridIpPool?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendGridIpPoolKeySpecifier | (() => undefined | SendGridIpPoolKeySpecifier),
		fields?: SendGridIpPoolFieldPolicy,
	},
	SendInstantGmOrderToFlexResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendInstantGmOrderToFlexResultKeySpecifier | (() => undefined | SendInstantGmOrderToFlexResultKeySpecifier),
		fields?: SendInstantGmOrderToFlexResultFieldPolicy,
	},
	ServiceTime?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServiceTimeKeySpecifier | (() => undefined | ServiceTimeKeySpecifier),
		fields?: ServiceTimeFieldPolicy,
	},
	SetupIntent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SetupIntentKeySpecifier | (() => undefined | SetupIntentKeySpecifier),
		fields?: SetupIntentFieldPolicy,
	},
	SignupMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SignupMetadataKeySpecifier | (() => undefined | SignupMetadataKeySpecifier),
		fields?: SignupMetadataFieldPolicy,
	},
	SsoSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoSettingsKeySpecifier | (() => undefined | SsoSettingsKeySpecifier),
		fields?: SsoSettingsFieldPolicy,
	},
	StandingOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandingOrderKeySpecifier | (() => undefined | StandingOrderKeySpecifier),
		fields?: StandingOrderFieldPolicy,
	},
	StandingOrderInvoicingRules?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandingOrderInvoicingRulesKeySpecifier | (() => undefined | StandingOrderInvoicingRulesKeySpecifier),
		fields?: StandingOrderInvoicingRulesFieldPolicy,
	},
	StandingOrderPlacementProgressData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandingOrderPlacementProgressDataKeySpecifier | (() => undefined | StandingOrderPlacementProgressDataKeySpecifier),
		fields?: StandingOrderPlacementProgressDataFieldPolicy,
	},
	StandingOrderPlacementProgressRecord?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandingOrderPlacementProgressRecordKeySpecifier | (() => undefined | StandingOrderPlacementProgressRecordKeySpecifier),
		fields?: StandingOrderPlacementProgressRecordFieldPolicy,
	},
	StandingOrderPlacementProgressRecordsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandingOrderPlacementProgressRecordsPagedKeySpecifier | (() => undefined | StandingOrderPlacementProgressRecordsPagedKeySpecifier),
		fields?: StandingOrderPlacementProgressRecordsPagedFieldPolicy,
	},
	StandingOrdersPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandingOrdersPageKeySpecifier | (() => undefined | StandingOrdersPageKeySpecifier),
		fields?: StandingOrdersPageFieldPolicy,
	},
	StartPaymentResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StartPaymentResultKeySpecifier | (() => undefined | StartPaymentResultKeySpecifier),
		fields?: StartPaymentResultFieldPolicy,
	},
	Stripe?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StripeKeySpecifier | (() => undefined | StripeKeySpecifier),
		fields?: StripeFieldPolicy,
	},
	StripeCustomerSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StripeCustomerSessionKeySpecifier | (() => undefined | StripeCustomerSessionKeySpecifier),
		fields?: StripeCustomerSessionFieldPolicy,
	},
	StripeFees?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StripeFeesKeySpecifier | (() => undefined | StripeFeesKeySpecifier),
		fields?: StripeFeesFieldPolicy,
	},
	StripeProcessingFees?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StripeProcessingFeesKeySpecifier | (() => undefined | StripeProcessingFeesKeySpecifier),
		fields?: StripeProcessingFeesFieldPolicy,
	},
	SubAllergenCereals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubAllergenCerealsKeySpecifier | (() => undefined | SubAllergenCerealsKeySpecifier),
		fields?: SubAllergenCerealsFieldPolicy,
	},
	SubAllergenNuts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubAllergenNutsKeySpecifier | (() => undefined | SubAllergenNutsKeySpecifier),
		fields?: SubAllergenNutsFieldPolicy,
	},
	SubAllergens?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubAllergensKeySpecifier | (() => undefined | SubAllergensKeySpecifier),
		fields?: SubAllergensFieldPolicy,
	},
	SupplierExternalIdOutput?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SupplierExternalIdOutputKeySpecifier | (() => undefined | SupplierExternalIdOutputKeySpecifier),
		fields?: SupplierExternalIdOutputFieldPolicy,
	},
	SupplierOrderResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SupplierOrderResultKeySpecifier | (() => undefined | SupplierOrderResultKeySpecifier),
		fields?: SupplierOrderResultFieldPolicy,
	},
	SyncInvoiceOrderResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SyncInvoiceOrderResultKeySpecifier | (() => undefined | SyncInvoiceOrderResultKeySpecifier),
		fields?: SyncInvoiceOrderResultFieldPolicy,
	},
	SyncMenuItemPricesResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SyncMenuItemPricesResponseKeySpecifier | (() => undefined | SyncMenuItemPricesResponseKeySpecifier),
		fields?: SyncMenuItemPricesResponseFieldPolicy,
	},
	SyncedInvoiceOrdersResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SyncedInvoiceOrdersResultKeySpecifier | (() => undefined | SyncedInvoiceOrdersResultKeySpecifier),
		fields?: SyncedInvoiceOrdersResultFieldPolicy,
	},
	TagsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagsPagedKeySpecifier | (() => undefined | TagsPagedKeySpecifier),
		fields?: TagsPagedFieldPolicy,
	},
	TemplateSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateSettingsKeySpecifier | (() => undefined | TemplateSettingsKeySpecifier),
		fields?: TemplateSettingsFieldPolicy,
	},
	Tenant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantKeySpecifier | (() => undefined | TenantKeySpecifier),
		fields?: TenantFieldPolicy,
	},
	TenantAccounting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantAccountingKeySpecifier | (() => undefined | TenantAccountingKeySpecifier),
		fields?: TenantAccountingFieldPolicy,
	},
	TenantAccountingRegions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantAccountingRegionsKeySpecifier | (() => undefined | TenantAccountingRegionsKeySpecifier),
		fields?: TenantAccountingRegionsFieldPolicy,
	},
	TenantCateringAllergenTooltip?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantCateringAllergenTooltipKeySpecifier | (() => undefined | TenantCateringAllergenTooltipKeySpecifier),
		fields?: TenantCateringAllergenTooltipFieldPolicy,
	},
	TenantCateringCoupons?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantCateringCouponsKeySpecifier | (() => undefined | TenantCateringCouponsKeySpecifier),
		fields?: TenantCateringCouponsFieldPolicy,
	},
	TenantCateringFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantCateringFiltersKeySpecifier | (() => undefined | TenantCateringFiltersKeySpecifier),
		fields?: TenantCateringFiltersFieldPolicy,
	},
	TenantCognitoConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantCognitoConfigurationKeySpecifier | (() => undefined | TenantCognitoConfigurationKeySpecifier),
		fields?: TenantCognitoConfigurationFieldPolicy,
	},
	TenantContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantContactKeySpecifier | (() => undefined | TenantContactKeySpecifier),
		fields?: TenantContactFieldPolicy,
	},
	TenantContactRegions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantContactRegionsKeySpecifier | (() => undefined | TenantContactRegionsKeySpecifier),
		fields?: TenantContactRegionsFieldPolicy,
	},
	TenantContactRegionsEmail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantContactRegionsEmailKeySpecifier | (() => undefined | TenantContactRegionsEmailKeySpecifier),
		fields?: TenantContactRegionsEmailFieldPolicy,
	},
	TenantContactRegionsPhone?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantContactRegionsPhoneKeySpecifier | (() => undefined | TenantContactRegionsPhoneKeySpecifier),
		fields?: TenantContactRegionsPhoneFieldPolicy,
	},
	TenantContentSecurityPolicy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantContentSecurityPolicyKeySpecifier | (() => undefined | TenantContentSecurityPolicyKeySpecifier),
		fields?: TenantContentSecurityPolicyFieldPolicy,
	},
	TenantEmailDisclaimerText?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantEmailDisclaimerTextKeySpecifier | (() => undefined | TenantEmailDisclaimerTextKeySpecifier),
		fields?: TenantEmailDisclaimerTextFieldPolicy,
	},
	TenantFeatures?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesKeySpecifier | (() => undefined | TenantFeaturesKeySpecifier),
		fields?: TenantFeaturesFieldPolicy,
	},
	TenantFeaturesCalendarTopPicks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesCalendarTopPicksKeySpecifier | (() => undefined | TenantFeaturesCalendarTopPicksKeySpecifier),
		fields?: TenantFeaturesCalendarTopPicksFieldPolicy,
	},
	TenantFeaturesCateringGroupOrdering?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesCateringGroupOrderingKeySpecifier | (() => undefined | TenantFeaturesCateringGroupOrderingKeySpecifier),
		fields?: TenantFeaturesCateringGroupOrderingFieldPolicy,
	},
	TenantFeaturesCateringGroupOrderingVisibility?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesCateringGroupOrderingVisibilityKeySpecifier | (() => undefined | TenantFeaturesCateringGroupOrderingVisibilityKeySpecifier),
		fields?: TenantFeaturesCateringGroupOrderingVisibilityFieldPolicy,
	},
	TenantFeaturesCateringTeamOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesCateringTeamOrderKeySpecifier | (() => undefined | TenantFeaturesCateringTeamOrderKeySpecifier),
		fields?: TenantFeaturesCateringTeamOrderFieldPolicy,
	},
	TenantFeaturesCateringTeamOrderVisibility?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesCateringTeamOrderVisibilityKeySpecifier | (() => undefined | TenantFeaturesCateringTeamOrderVisibilityKeySpecifier),
		fields?: TenantFeaturesCateringTeamOrderVisibilityFieldPolicy,
	},
	TenantFeaturesCcShowTimeslotWindow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesCcShowTimeslotWindowKeySpecifier | (() => undefined | TenantFeaturesCcShowTimeslotWindowKeySpecifier),
		fields?: TenantFeaturesCcShowTimeslotWindowFieldPolicy,
	},
	TenantFeaturesCcTopupAmounts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesCcTopupAmountsKeySpecifier | (() => undefined | TenantFeaturesCcTopupAmountsKeySpecifier),
		fields?: TenantFeaturesCcTopupAmountsFieldPolicy,
	},
	TenantFeaturesCharityMeals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesCharityMealsKeySpecifier | (() => undefined | TenantFeaturesCharityMealsKeySpecifier),
		fields?: TenantFeaturesCharityMealsFieldPolicy,
	},
	TenantFeaturesCharityMealsVisibility?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesCharityMealsVisibilityKeySpecifier | (() => undefined | TenantFeaturesCharityMealsVisibilityKeySpecifier),
		fields?: TenantFeaturesCharityMealsVisibilityFieldPolicy,
	},
	TenantFeaturesEmma?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesEmmaKeySpecifier | (() => undefined | TenantFeaturesEmmaKeySpecifier),
		fields?: TenantFeaturesEmmaFieldPolicy,
	},
	TenantFeaturesEmmaRegionSpecificRules?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesEmmaRegionSpecificRulesKeySpecifier | (() => undefined | TenantFeaturesEmmaRegionSpecificRulesKeySpecifier),
		fields?: TenantFeaturesEmmaRegionSpecificRulesFieldPolicy,
	},
	TenantFeaturesEmmaSupplierSpecificRules?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesEmmaSupplierSpecificRulesKeySpecifier | (() => undefined | TenantFeaturesEmmaSupplierSpecificRulesKeySpecifier),
		fields?: TenantFeaturesEmmaSupplierSpecificRulesFieldPolicy,
	},
	TenantFeaturesGmDeliveryTimeslots?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesGmDeliveryTimeslotsKeySpecifier | (() => undefined | TenantFeaturesGmDeliveryTimeslotsKeySpecifier),
		fields?: TenantFeaturesGmDeliveryTimeslotsFieldPolicy,
	},
	TenantFeaturesGmHideDeliveryWindow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesGmHideDeliveryWindowKeySpecifier | (() => undefined | TenantFeaturesGmHideDeliveryWindowKeySpecifier),
		fields?: TenantFeaturesGmHideDeliveryWindowFieldPolicy,
	},
	TenantFeaturesGmShowFullAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesGmShowFullAddressKeySpecifier | (() => undefined | TenantFeaturesGmShowFullAddressKeySpecifier),
		fields?: TenantFeaturesGmShowFullAddressFieldPolicy,
	},
	TenantFeaturesGmShowFullAddressVisibility?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesGmShowFullAddressVisibilityKeySpecifier | (() => undefined | TenantFeaturesGmShowFullAddressVisibilityKeySpecifier),
		fields?: TenantFeaturesGmShowFullAddressVisibilityFieldPolicy,
	},
	TenantFeaturesMenuItemAllergenAudit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesMenuItemAllergenAuditKeySpecifier | (() => undefined | TenantFeaturesMenuItemAllergenAuditKeySpecifier),
		fields?: TenantFeaturesMenuItemAllergenAuditFieldPolicy,
	},
	TenantFeaturesPreRenderMarketplaceMenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesPreRenderMarketplaceMenuKeySpecifier | (() => undefined | TenantFeaturesPreRenderMarketplaceMenuKeySpecifier),
		fields?: TenantFeaturesPreRenderMarketplaceMenuFieldPolicy,
	},
	TenantFeaturesVendorHelpCentre?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantFeaturesVendorHelpCentreKeySpecifier | (() => undefined | TenantFeaturesVendorHelpCentreKeySpecifier),
		fields?: TenantFeaturesVendorHelpCentreFieldPolicy,
	},
	TenantGmExpressCheckout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantGmExpressCheckoutKeySpecifier | (() => undefined | TenantGmExpressCheckoutKeySpecifier),
		fields?: TenantGmExpressCheckoutFieldPolicy,
	},
	TenantGuestAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantGuestAccountKeySpecifier | (() => undefined | TenantGuestAccountKeySpecifier),
		fields?: TenantGuestAccountFieldPolicy,
	},
	TenantImageUpload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantImageUploadKeySpecifier | (() => undefined | TenantImageUploadKeySpecifier),
		fields?: TenantImageUploadFieldPolicy,
	},
	TenantIntegrations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsKeySpecifier | (() => undefined | TenantIntegrationsKeySpecifier),
		fields?: TenantIntegrationsFieldPolicy,
	},
	TenantIntegrationsActeol?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsActeolKeySpecifier | (() => undefined | TenantIntegrationsActeolKeySpecifier),
		fields?: TenantIntegrationsActeolFieldPolicy,
	},
	TenantIntegrationsBingAds?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsBingAdsKeySpecifier | (() => undefined | TenantIntegrationsBingAdsKeySpecifier),
		fields?: TenantIntegrationsBingAdsFieldPolicy,
	},
	TenantIntegrationsGoogleTagManager?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsGoogleTagManagerKeySpecifier | (() => undefined | TenantIntegrationsGoogleTagManagerKeySpecifier),
		fields?: TenantIntegrationsGoogleTagManagerFieldPolicy,
	},
	TenantIntegrationsHotjar?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsHotjarKeySpecifier | (() => undefined | TenantIntegrationsHotjarKeySpecifier),
		fields?: TenantIntegrationsHotjarFieldPolicy,
	},
	TenantIntegrationsHotjarRegions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsHotjarRegionsKeySpecifier | (() => undefined | TenantIntegrationsHotjarRegionsKeySpecifier),
		fields?: TenantIntegrationsHotjarRegionsFieldPolicy,
	},
	TenantIntegrationsIntercom?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsIntercomKeySpecifier | (() => undefined | TenantIntegrationsIntercomKeySpecifier),
		fields?: TenantIntegrationsIntercomFieldPolicy,
	},
	TenantIntegrationsIntercomRegions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsIntercomRegionsKeySpecifier | (() => undefined | TenantIntegrationsIntercomRegionsKeySpecifier),
		fields?: TenantIntegrationsIntercomRegionsFieldPolicy,
	},
	TenantIntegrationsLinkedIn?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsLinkedInKeySpecifier | (() => undefined | TenantIntegrationsLinkedInKeySpecifier),
		fields?: TenantIntegrationsLinkedInFieldPolicy,
	},
	TenantIntegrationsOneTrust?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsOneTrustKeySpecifier | (() => undefined | TenantIntegrationsOneTrustKeySpecifier),
		fields?: TenantIntegrationsOneTrustFieldPolicy,
	},
	TenantIntegrationsOrkestro?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsOrkestroKeySpecifier | (() => undefined | TenantIntegrationsOrkestroKeySpecifier),
		fields?: TenantIntegrationsOrkestroFieldPolicy,
	},
	TenantIntegrationsOrkestroRegions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsOrkestroRegionsKeySpecifier | (() => undefined | TenantIntegrationsOrkestroRegionsKeySpecifier),
		fields?: TenantIntegrationsOrkestroRegionsFieldPolicy,
	},
	TenantIntegrationsPosthog?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsPosthogKeySpecifier | (() => undefined | TenantIntegrationsPosthogKeySpecifier),
		fields?: TenantIntegrationsPosthogFieldPolicy,
	},
	TenantIntegrationsSegment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsSegmentKeySpecifier | (() => undefined | TenantIntegrationsSegmentKeySpecifier),
		fields?: TenantIntegrationsSegmentFieldPolicy,
	},
	TenantIntegrationsSvix?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsSvixKeySpecifier | (() => undefined | TenantIntegrationsSvixKeySpecifier),
		fields?: TenantIntegrationsSvixFieldPolicy,
	},
	TenantIntegrationsVanillaBlue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsVanillaBlueKeySpecifier | (() => undefined | TenantIntegrationsVanillaBlueKeySpecifier),
		fields?: TenantIntegrationsVanillaBlueFieldPolicy,
	},
	TenantIntegrationsVanillaBlueRegions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsVanillaBlueRegionsKeySpecifier | (() => undefined | TenantIntegrationsVanillaBlueRegionsKeySpecifier),
		fields?: TenantIntegrationsVanillaBlueRegionsFieldPolicy,
	},
	TenantIntegrationsZendesk?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsZendeskKeySpecifier | (() => undefined | TenantIntegrationsZendeskKeySpecifier),
		fields?: TenantIntegrationsZendeskFieldPolicy,
	},
	TenantIntegrationsZendeskRegions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantIntegrationsZendeskRegionsKeySpecifier | (() => undefined | TenantIntegrationsZendeskRegionsKeySpecifier),
		fields?: TenantIntegrationsZendeskRegionsFieldPolicy,
	},
	TenantInternalAdminLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantInternalAdminLinkKeySpecifier | (() => undefined | TenantInternalAdminLinkKeySpecifier),
		fields?: TenantInternalAdminLinkFieldPolicy,
	},
	TenantMarketing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMarketingKeySpecifier | (() => undefined | TenantMarketingKeySpecifier),
		fields?: TenantMarketingFieldPolicy,
	},
	TenantMarketingAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMarketingAssetsKeySpecifier | (() => undefined | TenantMarketingAssetsKeySpecifier),
		fields?: TenantMarketingAssetsFieldPolicy,
	},
	TenantMarketingEmail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMarketingEmailKeySpecifier | (() => undefined | TenantMarketingEmailKeySpecifier),
		fields?: TenantMarketingEmailFieldPolicy,
	},
	TenantMarketingLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMarketingLinkKeySpecifier | (() => undefined | TenantMarketingLinkKeySpecifier),
		fields?: TenantMarketingLinkFieldPolicy,
	},
	TenantMarketingLogos?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMarketingLogosKeySpecifier | (() => undefined | TenantMarketingLogosKeySpecifier),
		fields?: TenantMarketingLogosFieldPolicy,
	},
	TenantMarketingPageRegions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMarketingPageRegionsKeySpecifier | (() => undefined | TenantMarketingPageRegionsKeySpecifier),
		fields?: TenantMarketingPageRegionsFieldPolicy,
	},
	TenantMarketingPages?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMarketingPagesKeySpecifier | (() => undefined | TenantMarketingPagesKeySpecifier),
		fields?: TenantMarketingPagesFieldPolicy,
	},
	TenantMarketingSitemaps?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMarketingSitemapsKeySpecifier | (() => undefined | TenantMarketingSitemapsKeySpecifier),
		fields?: TenantMarketingSitemapsFieldPolicy,
	},
	TenantMarketingTheme?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMarketingThemeKeySpecifier | (() => undefined | TenantMarketingThemeKeySpecifier),
		fields?: TenantMarketingThemeFieldPolicy,
	},
	TenantMarketingThemePalette?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMarketingThemePaletteKeySpecifier | (() => undefined | TenantMarketingThemePaletteKeySpecifier),
		fields?: TenantMarketingThemePaletteFieldPolicy,
	},
	TenantMobileApp?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMobileAppKeySpecifier | (() => undefined | TenantMobileAppKeySpecifier),
		fields?: TenantMobileAppFieldPolicy,
	},
	TenantMobileAppIntegrations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMobileAppIntegrationsKeySpecifier | (() => undefined | TenantMobileAppIntegrationsKeySpecifier),
		fields?: TenantMobileAppIntegrationsFieldPolicy,
	},
	TenantMobileAppIntegrationsZendesk?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMobileAppIntegrationsZendeskKeySpecifier | (() => undefined | TenantMobileAppIntegrationsZendeskKeySpecifier),
		fields?: TenantMobileAppIntegrationsZendeskFieldPolicy,
	},
	TenantMobileAppIntegrationsZendeskRegions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantMobileAppIntegrationsZendeskRegionsKeySpecifier | (() => undefined | TenantMobileAppIntegrationsZendeskRegionsKeySpecifier),
		fields?: TenantMobileAppIntegrationsZendeskRegionsFieldPolicy,
	},
	TenantNavigationLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantNavigationLinkKeySpecifier | (() => undefined | TenantNavigationLinkKeySpecifier),
		fields?: TenantNavigationLinkFieldPolicy,
	},
	TenantNavigationSubLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantNavigationSubLinkKeySpecifier | (() => undefined | TenantNavigationSubLinkKeySpecifier),
		fields?: TenantNavigationSubLinkFieldPolicy,
	},
	TenantPaletteColorBackground?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantPaletteColorBackgroundKeySpecifier | (() => undefined | TenantPaletteColorBackgroundKeySpecifier),
		fields?: TenantPaletteColorBackgroundFieldPolicy,
	},
	TenantPaletteColorCommon?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantPaletteColorCommonKeySpecifier | (() => undefined | TenantPaletteColorCommonKeySpecifier),
		fields?: TenantPaletteColorCommonFieldPolicy,
	},
	TenantPaletteColorOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantPaletteColorOptionsKeySpecifier | (() => undefined | TenantPaletteColorOptionsKeySpecifier),
		fields?: TenantPaletteColorOptionsFieldPolicy,
	},
	TenantPaletteColorText?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantPaletteColorTextKeySpecifier | (() => undefined | TenantPaletteColorTextKeySpecifier),
		fields?: TenantPaletteColorTextFieldPolicy,
	},
	TenantPayments?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantPaymentsKeySpecifier | (() => undefined | TenantPaymentsKeySpecifier),
		fields?: TenantPaymentsFieldPolicy,
	},
	TenantPermissions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantPermissionsKeySpecifier | (() => undefined | TenantPermissionsKeySpecifier),
		fields?: TenantPermissionsFieldPolicy,
	},
	TenantPrintLabels?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantPrintLabelsKeySpecifier | (() => undefined | TenantPrintLabelsKeySpecifier),
		fields?: TenantPrintLabelsFieldPolicy,
	},
	TenantPrintLabelsOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantPrintLabelsOptionsKeySpecifier | (() => undefined | TenantPrintLabelsOptionsKeySpecifier),
		fields?: TenantPrintLabelsOptionsFieldPolicy,
	},
	TenantServiceOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantServiceOptionsKeySpecifier | (() => undefined | TenantServiceOptionsKeySpecifier),
		fields?: TenantServiceOptionsFieldPolicy,
	},
	TenantServiceOptionsVisibility?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantServiceOptionsVisibilityKeySpecifier | (() => undefined | TenantServiceOptionsVisibilityKeySpecifier),
		fields?: TenantServiceOptionsVisibilityFieldPolicy,
	},
	TenantTransportType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantTransportTypeKeySpecifier | (() => undefined | TenantTransportTypeKeySpecifier),
		fields?: TenantTransportTypeFieldPolicy,
	},
	TenantTransportTypes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantTransportTypesKeySpecifier | (() => undefined | TenantTransportTypesKeySpecifier),
		fields?: TenantTransportTypesFieldPolicy,
	},
	TenantTransportTypesRegion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantTransportTypesRegionKeySpecifier | (() => undefined | TenantTransportTypesRegionKeySpecifier),
		fields?: TenantTransportTypesRegionFieldPolicy,
	},
	TenantsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantsPagedKeySpecifier | (() => undefined | TenantsPagedKeySpecifier),
		fields?: TenantsPagedFieldPolicy,
	},
	TimeRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TimeRangeKeySpecifier | (() => undefined | TimeRangeKeySpecifier),
		fields?: TimeRangeFieldPolicy,
	},
	Timezone?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TimezoneKeySpecifier | (() => undefined | TimezoneKeySpecifier),
		fields?: TimezoneFieldPolicy,
	},
	Translation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TranslationKeySpecifier | (() => undefined | TranslationKeySpecifier),
		fields?: TranslationFieldPolicy,
	},
	UriRestrictedAccessRules?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UriRestrictedAccessRulesKeySpecifier | (() => undefined | UriRestrictedAccessRulesKeySpecifier),
		fields?: UriRestrictedAccessRulesFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserAccountSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserAccountSettingsKeySpecifier | (() => undefined | UserAccountSettingsKeySpecifier),
		fields?: UserAccountSettingsFieldPolicy,
	},
	UserAllergens?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserAllergensKeySpecifier | (() => undefined | UserAllergensKeySpecifier),
		fields?: UserAllergensFieldPolicy,
	},
	UserAutopilotSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserAutopilotSettingsKeySpecifier | (() => undefined | UserAutopilotSettingsKeySpecifier),
		fields?: UserAutopilotSettingsFieldPolicy,
	},
	UserContactPreferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserContactPreferencesKeySpecifier | (() => undefined | UserContactPreferencesKeySpecifier),
		fields?: UserContactPreferencesFieldPolicy,
	},
	UserDietaryPreferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserDietaryPreferencesKeySpecifier | (() => undefined | UserDietaryPreferencesKeySpecifier),
		fields?: UserDietaryPreferencesFieldPolicy,
	},
	UserLanguageSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserLanguageSettingsKeySpecifier | (() => undefined | UserLanguageSettingsKeySpecifier),
		fields?: UserLanguageSettingsFieldPolicy,
	},
	UserNativeAppSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserNativeAppSettingsKeySpecifier | (() => undefined | UserNativeAppSettingsKeySpecifier),
		fields?: UserNativeAppSettingsFieldPolicy,
	},
	UserNotificationHistoryPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserNotificationHistoryPagedKeySpecifier | (() => undefined | UserNotificationHistoryPagedKeySpecifier),
		fields?: UserNotificationHistoryPagedFieldPolicy,
	},
	UserOnboardingSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserOnboardingSettingsKeySpecifier | (() => undefined | UserOnboardingSettingsKeySpecifier),
		fields?: UserOnboardingSettingsFieldPolicy,
	},
	UserSubsidySettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserSubsidySettingsKeySpecifier | (() => undefined | UserSubsidySettingsKeySpecifier),
		fields?: UserSubsidySettingsFieldPolicy,
	},
	UserWallet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserWalletKeySpecifier | (() => undefined | UserWalletKeySpecifier),
		fields?: UserWalletFieldPolicy,
	},
	UsersPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPagedKeySpecifier | (() => undefined | UsersPagedKeySpecifier),
		fields?: UsersPagedFieldPolicy,
	},
	UtmTrackingData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UtmTrackingDataKeySpecifier | (() => undefined | UtmTrackingDataKeySpecifier),
		fields?: UtmTrackingDataFieldPolicy,
	},
	VatBand?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VatBandKeySpecifier | (() => undefined | VatBandKeySpecifier),
		fields?: VatBandFieldPolicy,
	},
	VatCalculationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VatCalculationResultKeySpecifier | (() => undefined | VatCalculationResultKeySpecifier),
		fields?: VatCalculationResultFieldPolicy,
	},
	VatRegion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VatRegionKeySpecifier | (() => undefined | VatRegionKeySpecifier),
		fields?: VatRegionFieldPolicy,
	},
	VatSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VatSummaryKeySpecifier | (() => undefined | VatSummaryKeySpecifier),
		fields?: VatSummaryFieldPolicy,
	},
	Vendor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorKeySpecifier | (() => undefined | VendorKeySpecifier),
		fields?: VendorFieldPolicy,
	},
	VendorCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorCategoryKeySpecifier | (() => undefined | VendorCategoryKeySpecifier),
		fields?: VendorCategoryFieldPolicy,
	},
	VendorCategoryItemsPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorCategoryItemsPageKeySpecifier | (() => undefined | VendorCategoryItemsPageKeySpecifier),
		fields?: VendorCategoryItemsPageFieldPolicy,
	},
	VendorCharge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorChargeKeySpecifier | (() => undefined | VendorChargeKeySpecifier),
		fields?: VendorChargeFieldPolicy,
	},
	VendorContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorContactKeySpecifier | (() => undefined | VendorContactKeySpecifier),
		fields?: VendorContactFieldPolicy,
	},
	VendorContactsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorContactsPagedKeySpecifier | (() => undefined | VendorContactsPagedKeySpecifier),
		fields?: VendorContactsPagedFieldPolicy,
	},
	VendorEmmaSuitability?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorEmmaSuitabilityKeySpecifier | (() => undefined | VendorEmmaSuitabilityKeySpecifier),
		fields?: VendorEmmaSuitabilityFieldPolicy,
	},
	VendorExternalUrl?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorExternalUrlKeySpecifier | (() => undefined | VendorExternalUrlKeySpecifier),
		fields?: VendorExternalUrlFieldPolicy,
	},
	VendorExternalUrlData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorExternalUrlDataKeySpecifier | (() => undefined | VendorExternalUrlDataKeySpecifier),
		fields?: VendorExternalUrlDataFieldPolicy,
	},
	VendorExternalUrlTags?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorExternalUrlTagsKeySpecifier | (() => undefined | VendorExternalUrlTagsKeySpecifier),
		fields?: VendorExternalUrlTagsFieldPolicy,
	},
	VendorFinanceSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorFinanceSettingsKeySpecifier | (() => undefined | VendorFinanceSettingsKeySpecifier),
		fields?: VendorFinanceSettingsFieldPolicy,
	},
	VendorFlexFinanceSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorFlexFinanceSettingsKeySpecifier | (() => undefined | VendorFlexFinanceSettingsKeySpecifier),
		fields?: VendorFlexFinanceSettingsFieldPolicy,
	},
	VendorFlexInvoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorFlexInvoiceKeySpecifier | (() => undefined | VendorFlexInvoiceKeySpecifier),
		fields?: VendorFlexInvoiceFieldPolicy,
	},
	VendorFlexInvoiceAllTypes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorFlexInvoiceAllTypesKeySpecifier | (() => undefined | VendorFlexInvoiceAllTypesKeySpecifier),
		fields?: VendorFlexInvoiceAllTypesFieldPolicy,
	},
	VendorFlexInvoiceAllTypesPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorFlexInvoiceAllTypesPagedKeySpecifier | (() => undefined | VendorFlexInvoiceAllTypesPagedKeySpecifier),
		fields?: VendorFlexInvoiceAllTypesPagedFieldPolicy,
	},
	VendorFlexInvoicesPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorFlexInvoicesPagedKeySpecifier | (() => undefined | VendorFlexInvoicesPagedKeySpecifier),
		fields?: VendorFlexInvoicesPagedFieldPolicy,
	},
	VendorHighlightCategoriesForLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorHighlightCategoriesForLocationKeySpecifier | (() => undefined | VendorHighlightCategoriesForLocationKeySpecifier),
		fields?: VendorHighlightCategoriesForLocationFieldPolicy,
	},
	VendorHighlightCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorHighlightCategoryKeySpecifier | (() => undefined | VendorHighlightCategoryKeySpecifier),
		fields?: VendorHighlightCategoryFieldPolicy,
	},
	VendorHighlightCategoryVendorsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorHighlightCategoryVendorsPagedKeySpecifier | (() => undefined | VendorHighlightCategoryVendorsPagedKeySpecifier),
		fields?: VendorHighlightCategoryVendorsPagedFieldPolicy,
	},
	VendorImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorImageKeySpecifier | (() => undefined | VendorImageKeySpecifier),
		fields?: VendorImageFieldPolicy,
	},
	VendorInRangeLocations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorInRangeLocationsKeySpecifier | (() => undefined | VendorInRangeLocationsKeySpecifier),
		fields?: VendorInRangeLocationsFieldPolicy,
	},
	VendorIntegrationSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorIntegrationSettingsKeySpecifier | (() => undefined | VendorIntegrationSettingsKeySpecifier),
		fields?: VendorIntegrationSettingsFieldPolicy,
	},
	VendorInvoiceOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorInvoiceOrderKeySpecifier | (() => undefined | VendorInvoiceOrderKeySpecifier),
		fields?: VendorInvoiceOrderFieldPolicy,
	},
	VendorInvoiceOrdersPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorInvoiceOrdersPagedKeySpecifier | (() => undefined | VendorInvoiceOrdersPagedKeySpecifier),
		fields?: VendorInvoiceOrdersPagedFieldPolicy,
	},
	VendorLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorLocationKeySpecifier | (() => undefined | VendorLocationKeySpecifier),
		fields?: VendorLocationFieldPolicy,
	},
	VendorLocationClosingDate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorLocationClosingDateKeySpecifier | (() => undefined | VendorLocationClosingDateKeySpecifier),
		fields?: VendorLocationClosingDateFieldPolicy,
	},
	VendorLocationDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorLocationDetailsKeySpecifier | (() => undefined | VendorLocationDetailsKeySpecifier),
		fields?: VendorLocationDetailsFieldPolicy,
	},
	VendorLocationOpeningTime?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorLocationOpeningTimeKeySpecifier | (() => undefined | VendorLocationOpeningTimeKeySpecifier),
		fields?: VendorLocationOpeningTimeFieldPolicy,
	},
	VendorLocationServiceTime?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorLocationServiceTimeKeySpecifier | (() => undefined | VendorLocationServiceTimeKeySpecifier),
		fields?: VendorLocationServiceTimeFieldPolicy,
	},
	VendorMarkupSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorMarkupSettingsKeySpecifier | (() => undefined | VendorMarkupSettingsKeySpecifier),
		fields?: VendorMarkupSettingsFieldPolicy,
	},
	VendorMenuCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorMenuCategoryKeySpecifier | (() => undefined | VendorMenuCategoryKeySpecifier),
		fields?: VendorMenuCategoryFieldPolicy,
	},
	VendorMenuCategoryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorMenuCategoryConnectionKeySpecifier | (() => undefined | VendorMenuCategoryConnectionKeySpecifier),
		fields?: VendorMenuCategoryConnectionFieldPolicy,
	},
	VendorMenuCategoryHeroAsset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorMenuCategoryHeroAssetKeySpecifier | (() => undefined | VendorMenuCategoryHeroAssetKeySpecifier),
		fields?: VendorMenuCategoryHeroAssetFieldPolicy,
	},
	VendorMenuCategoryPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorMenuCategoryPageInfoKeySpecifier | (() => undefined | VendorMenuCategoryPageInfoKeySpecifier),
		fields?: VendorMenuCategoryPageInfoFieldPolicy,
	},
	VendorMenuItemStat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorMenuItemStatKeySpecifier | (() => undefined | VendorMenuItemStatKeySpecifier),
		fields?: VendorMenuItemStatFieldPolicy,
	},
	VendorMenuItemsPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorMenuItemsPageInfoKeySpecifier | (() => undefined | VendorMenuItemsPageInfoKeySpecifier),
		fields?: VendorMenuItemsPageInfoFieldPolicy,
	},
	VendorOccasionSuitabilityScore?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorOccasionSuitabilityScoreKeySpecifier | (() => undefined | VendorOccasionSuitabilityScoreKeySpecifier),
		fields?: VendorOccasionSuitabilityScoreFieldPolicy,
	},
	VendorPreference?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorPreferenceKeySpecifier | (() => undefined | VendorPreferenceKeySpecifier),
		fields?: VendorPreferenceFieldPolicy,
	},
	VendorRatingData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorRatingDataKeySpecifier | (() => undefined | VendorRatingDataKeySpecifier),
		fields?: VendorRatingDataFieldPolicy,
	},
	VendorSearchStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorSearchStatsKeySpecifier | (() => undefined | VendorSearchStatsKeySpecifier),
		fields?: VendorSearchStatsFieldPolicy,
	},
	VendorStatement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorStatementKeySpecifier | (() => undefined | VendorStatementKeySpecifier),
		fields?: VendorStatementFieldPolicy,
	},
	VendorStatementBillingContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorStatementBillingContactKeySpecifier | (() => undefined | VendorStatementBillingContactKeySpecifier),
		fields?: VendorStatementBillingContactFieldPolicy,
	},
	VendorStatementBillingDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorStatementBillingDetailsKeySpecifier | (() => undefined | VendorStatementBillingDetailsKeySpecifier),
		fields?: VendorStatementBillingDetailsFieldPolicy,
	},
	VendorStatementCommission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorStatementCommissionKeySpecifier | (() => undefined | VendorStatementCommissionKeySpecifier),
		fields?: VendorStatementCommissionFieldPolicy,
	},
	VendorStatementFeeSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorStatementFeeSummaryKeySpecifier | (() => undefined | VendorStatementFeeSummaryKeySpecifier),
		fields?: VendorStatementFeeSummaryFieldPolicy,
	},
	VendorStatementOrderBreakdownItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorStatementOrderBreakdownItemKeySpecifier | (() => undefined | VendorStatementOrderBreakdownItemKeySpecifier),
		fields?: VendorStatementOrderBreakdownItemFieldPolicy,
	},
	VendorStatementServiceOrderBreakdown?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorStatementServiceOrderBreakdownKeySpecifier | (() => undefined | VendorStatementServiceOrderBreakdownKeySpecifier),
		fields?: VendorStatementServiceOrderBreakdownFieldPolicy,
	},
	VendorStatementServiceTotals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorStatementServiceTotalsKeySpecifier | (() => undefined | VendorStatementServiceTotalsKeySpecifier),
		fields?: VendorStatementServiceTotalsFieldPolicy,
	},
	VendorStatementSummaryItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorStatementSummaryItemKeySpecifier | (() => undefined | VendorStatementSummaryItemKeySpecifier),
		fields?: VendorStatementSummaryItemFieldPolicy,
	},
	VendorStatementsCombinedPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorStatementsCombinedPagedKeySpecifier | (() => undefined | VendorStatementsCombinedPagedKeySpecifier),
		fields?: VendorStatementsCombinedPagedFieldPolicy,
	},
	VendorStatementsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorStatementsPagedKeySpecifier | (() => undefined | VendorStatementsPagedKeySpecifier),
		fields?: VendorStatementsPagedFieldPolicy,
	},
	VendorStatementsSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorStatementsSummaryKeySpecifier | (() => undefined | VendorStatementsSummaryKeySpecifier),
		fields?: VendorStatementsSummaryFieldPolicy,
	},
	VendorSuitabilityScore?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorSuitabilityScoreKeySpecifier | (() => undefined | VendorSuitabilityScoreKeySpecifier),
		fields?: VendorSuitabilityScoreFieldPolicy,
	},
	VendorTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorTagKeySpecifier | (() => undefined | VendorTagKeySpecifier),
		fields?: VendorTagFieldPolicy,
	},
	VendorTagCountryAssignment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorTagCountryAssignmentKeySpecifier | (() => undefined | VendorTagCountryAssignmentKeySpecifier),
		fields?: VendorTagCountryAssignmentFieldPolicy,
	},
	VendorsListPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorsListPagedKeySpecifier | (() => undefined | VendorsListPagedKeySpecifier),
		fields?: VendorsListPagedFieldPolicy,
	},
	VendorsPaged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorsPagedKeySpecifier | (() => undefined | VendorsPagedKeySpecifier),
		fields?: VendorsPagedFieldPolicy,
	},
	Viewport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ViewportKeySpecifier | (() => undefined | ViewportKeySpecifier),
		fields?: ViewportFieldPolicy,
	},
	occasionItemTimeRestraints?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | occasionItemTimeRestraintsKeySpecifier | (() => undefined | occasionItemTimeRestraintsKeySpecifier),
		fields?: occasionItemTimeRestraintsFieldPolicy,
	},
	orderItemsCsvResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | orderItemsCsvResultKeySpecifier | (() => undefined | orderItemsCsvResultKeySpecifier),
		fields?: orderItemsCsvResultFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;